import ar, { useContext as NO, useMemo as tp, useRef as bi, createElement as e3, createContext as t3, useEffect as Cl, useLayoutEffect as n3, useCallback as c0, useDebugValue as a3, useState as Rl } from "react";
import xO from "react-dom";
import { vitePreamble as e_ } from "./vitePreamble.js";
const l3 = {
  trigger: "cac-action-trigger",
  pageView: "cac-page-view"
}, u3 = "ad9123205592", HO = (r) => `https://assets.adobedtm.com/${u3}/${r}/`, i3 = "d8d060fcde08", pA = HO(i3), o3 = "779e6233ddb6", yA = HO(o3), Y1 = {
  NON_PRODUCTION: `${pA}launch-f70fe0a0d057-staging.min.js`,
  PRODUCTION: `${pA}launch-f50a00d402e8.min.js`,
  // Product-specific URLs
  DEALMAX: {
    NON_PRODUCTION: `${yA}launch-aeaa38b75488-staging.min.js`,
    PRODUCTION: `${yA}launch-77033f6e20e2.min.js`
  }
};
function c3(r, f) {
  return f === "dealmax" ? r ? Y1.DEALMAX.PRODUCTION : Y1.DEALMAX.NON_PRODUCTION : r ? Y1.PRODUCTION : Y1.NON_PRODUCTION;
}
const r3 = [
  "lab",
  "dev",
  "test",
  "qa",
  "production"
], LO = [
  "Test1",
  "Test2",
  "Test3",
  "Test4",
  "Test5"
], Yo = [
  ...r3,
  ...LO,
  "local",
  "unknown"
], BO = {
  unknown: {},
  local: {},
  lab: { pageHosting: "uilab" },
  dev: { pageHosting: "uidev" },
  production: {
    caps: "caps",
    login: "cacb2ccaps",
    customerPortal: "customer",
    dealmax: "dealmax",
    pageHosting: "ui"
  },
  qa: {
    caps: "capsqa",
    login: "cacnonprdb2ccapsqa",
    customerPortal: "customerqa",
    dealmax: "dealmaxqa",
    pageHosting: "uiqa"
  },
  Test5: {
    caps: "capstst005",
    customerPortal: "customertest5",
    pageHosting: "uitest"
  },
  Test4: {
    caps: "capstst004",
    customerPortal: "customertest4",
    pageHosting: "uitest"
  },
  Test3: {
    caps: "capstst3",
    customerPortal: "customertest3",
    pageHosting: "uitest"
  },
  Test2: {
    caps: "capstst002",
    customerPortal: "customertest2",
    pageHosting: "uitest"
  },
  Test1: {
    caps: "capstst001",
    customerPortal: "customertest1",
    pageHosting: "uitest"
  },
  test: {
    caps: "capstst002",
    customerPortal: "customertest2",
    dealmax: "dealmaxtst",
    pageHosting: "uitest"
  }
}, Bt = {
  LAB: Yo[0],
  DEV: Yo[1],
  TEST: Yo[2],
  QA: Yo[3],
  PRODUCTION: Yo[4],
  TEST1: Yo[5],
  TEST2: Yo[6],
  TEST3: Yo[7],
  TEST4: Yo[8],
  TEST5: Yo[9]
}, jO = "SALESPERSON (APPROVAL ENTRY)", s3 = "OWNER", f3 = "SALESPERSON", d3 = "MANAGER", h3 = [
  s3,
  d3,
  f3,
  jO
];
function gA(r, f = window.location.origin) {
  const { hostname: m } = new URL(r, f), h = m.split(".").shift();
  if (!h)
    return "unknown";
  for (const [v, g] of Object.entries(BO)) {
    const S = Object.values(g);
    if (S && S.includes(h))
      return v;
  }
  return "unknown";
}
const vA = "http://has.no.domain";
function m3(r) {
  return new URL(r, vA).origin === vA;
}
const CE = "capsTestEnv";
function s0(r, f) {
  if (!f && (r === void 0 || m3(r)) && window?.environment) {
    const { environment: m } = window;
    if (m === "test") {
      const h = sessionStorage.getItem(CE) ?? localStorage.getItem(CE);
      if (h && LO.includes(
        h
      ))
        return h;
      const v = gA(
        window.location.href,
        f
      );
      if (v.startsWith("Test"))
        return v;
    }
    return m;
  }
  return gA(
    r ?? window?.location.href ?? "",
    f ?? window?.location.origin ?? ""
  );
}
const p3 = /\/+/g;
function y3(...r) {
  return r.join("/").replaceAll(p3, "/");
}
function f0(r, f) {
  const m = s0();
  if (m === "unknown" && f === "dealmax")
    return new URL(r, "https://dealmaxtst.creditacceptance.com").toString();
  if (m === "local" && f === "caps")
    return new URL(r, "http://localhost:7001").toString();
  if (m === "unknown")
    return new URL(r, window.location.origin).toString();
  if (f === "login") {
    let g, S;
    switch (m) {
      case "local":
      // We can't run login locally, but if we're running another application locally, use the Test tenant for login
      case "lab":
      case "dev":
      case "test":
      case "Test1":
      case "Test2":
      case "Test3":
      case "Test4":
      case "Test5": {
        g = "https://cacnonprdb2ccaps.b2clogin.com", S = "/cacnonprdb2ccaps.onmicrosoft.com/";
        break;
      }
      case "qa": {
        g = "https://cacnonprdb2ccapsqa.b2clogin.com", S = "/cacnonprdb2ccapsqa.onmicrosoft.com/";
        break;
      }
      case "production": {
        g = "https://cacb2ccaps.b2clogin.com", S = "/cacb2ccaps.onmicrosoft.com/";
        break;
      }
    }
    return new URL(y3(S, r), g).toString();
  } else if (f === "dealmax") {
    let g;
    switch (m) {
      case "local":
      case "lab":
      case "dev":
      case "test":
      case "Test1":
      case "Test2":
      case "Test3":
      case "Test4":
      case "Test5": {
        g = "https://dealmaxtst.creditacceptance.com";
        break;
      }
      case "qa": {
        g = "https://dealmaxqa.creditacceptance.com";
        break;
      }
      case "production": {
        g = "https://dealmax.creditacceptance.com";
        break;
      }
    }
    return new URL(r, g).toString();
  }
  const h = (BO[m] ?? {})[f];
  if (!h)
    throw new Error(
      `${f === "caps" ? "CAPS" : "Dealer Portal"} does not exist in the ${m} environment.`
    );
  return new URL(r, `https://${h}.creditacceptance.com`).toString();
}
function ZE(r) {
  return f0(r, "caps");
}
function g3(r) {
  return f0(r, "login");
}
function v3(r) {
  return f0(r, "customerPortal");
}
function b3(r) {
  return f0(r, "dealmax");
}
function S3(r) {
  return f0(r, "pageHosting");
}
function Vz(r) {
  return s0(r) === "production";
}
function Yz(r) {
  return window.environment !== "test" ? !1 : s0() === r;
}
function Gz(r, f = 0) {
  let m;
  return function(...h) {
    m && clearTimeout(m), m = setTimeout(() => {
      r(...h);
    }, f);
  };
}
const Xz = (r, {
  displayCurrencySign: f = !1,
  locale: m = "en-US",
  currency: h = "USD",
  minimumFractionDigits: v,
  maximumFractionDigits: g
} = {}) => {
  const S = v ?? g ?? 2;
  let E = g ?? v ?? 2;
  E < S && (E = S);
  try {
    return new Intl.NumberFormat(m, {
      style: f ? "currency" : "decimal",
      currency: h,
      minimumFractionDigits: S,
      maximumFractionDigits: E
    }).format(r);
  } catch (O) {
    return console.error(`Error formatting number: ${O}`), r.toFixed(S);
  }
};
function Qz(r) {
  return new URLSearchParams(window.location.search).get(r);
}
const E3 = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};
function Zz(r) {
  return E3[r.toLocaleUpperCase()] ?? "";
}
function Jz(r, f = /* @__PURE__ */ new Date()) {
  return r.some(
    (m) => !m.cancellationDate || new Date(m.cancellationDate) > f
  );
}
const T3 = "inactive";
function Kz(r) {
  return typeof r == "string" ? r.toLowerCase().trim() !== T3 : r < 7;
}
function qO(r) {
  return r == null;
}
function kz(r) {
  return !qO(r);
}
function JE(r) {
  return qO(r) ? !0 : typeof r == "string" || Array.isArray(r) ? r.length === 0 : r instanceof Map || r instanceof Set ? r.size === 0 : typeof r == "object" ? Object.keys(r).length === 0 : !1;
}
function $z(r, f) {
  return r.toLocaleString(
    "en-US",
    f === void 0 ? {} : {
      minimumFractionDigits: f,
      maximumFractionDigits: f
    }
  );
}
function Fz(r) {
  let f = !1, m;
  return function(...h) {
    return f || (f = !0, m = r.apply(this, h)), m;
  };
}
function Wz({
  input: r,
  max: f = [3, 3, 4],
  delimiter: m = ""
}) {
  r = r.replaceAll(`${m}`, "");
  const h = new RegExp(
    `^(.{1,${f[0]}})(.{1,${f[1]}})(.{1,${f[2]}})`
  ), v = r.match(h);
  if (v)
    return {
      part1: v[1],
      part2: v[2],
      part3: v[3]
    };
}
function A3(r) {
  return r.map((f) => VO(f)).filter((f) => !JE(f));
}
function O3(r) {
  const f = {};
  for (const [m, h] of Object.entries(r)) {
    const v = VO(h);
    JE(v) || (f[m] = v);
  }
  return f;
}
function VO(r) {
  return Array.isArray(r) ? A3(r) : typeof r == "object" && r !== null ? O3(r) : r;
}
function Iz(r) {
  return r && r.replaceAll(/\s+/g, " ").trim().toUpperCase();
}
function Pz(r) {
  return r.toLowerCase().replaceAll("_", " ").trim().replaceAll(/\b\w/g, (f) => f.toUpperCase());
}
function e5(r) {
  const f = r.toUpperCase().trim();
  return !h3.includes(f);
}
function D3(r) {
  return r.toUpperCase().trim() === jO;
}
var yb = /* @__PURE__ */ ((r) => (r.CAPS = "CAPS", r.DVM = "DVM", r.DST = "DST", r.CAPS_BACKEND = "CAPS_BACKEND", r.PROOF_PORTAL = "PROOF_PORTAL", r))(yb || {});
const R3 = {
  CAPS: {
    [Bt.DEV]: "66607fdbb7dd8410c663ed5d",
    [Bt.PRODUCTION]: "66607f99d6a35910503bf8a2",
    [Bt.QA]: "66607fede3f9710fe60923ff",
    [Bt.TEST]: "66607f99d6a35910503bf8a1"
  },
  DVM: {
    [Bt.DEV]: "6660dccfec448d1091acdc26",
    [Bt.PRODUCTION]: "6660dcb4adc7361007bdff8d",
    [Bt.QA]: "6660dcdccb91220fd8860bee",
    [Bt.TEST]: "6660dcb4adc7361007bdff8c"
  },
  DST: {
    [Bt.DEV]: "684fcb35bc58e7094bc0bda0",
    [Bt.PRODUCTION]: "684fb737e6ea920938bc7aad",
    [Bt.QA]: "684fb7c7fb80e70934c11505",
    [Bt.TEST]: "684fb737e6ea920938bc7aac"
  },
  CAPS_BACKEND: {
    [Bt.PRODUCTION]: "68093cab2067c708f2787eba",
    [Bt.QA]: "6812697c1aae710df869ac86",
    [Bt.TEST]: "68093cab2067c708f2787eb9"
  },
  PROOF_PORTAL: {
    [Bt.DEV]: "689f47d7ef86ab099c4b1376",
    [Bt.TEST]: "689f47947145060990902229",
    [Bt.QA]: "689f47c8e061ab09983c7d84",
    [Bt.PRODUCTION]: "689f4794714506099090222a"
  }
}, ga = "release-dealer-experience-caps-dealer-portal-", C3 = "release-dealer-sales-tools-caps-dealer-portal-", r0 = {
  approvals: `${ga}approval-in-process`,
  contracts: `${ga}contracts-in-progress`,
  collectionsStatus: `${ga}collections-status`,
  collectionsPayments: `${ga}collections-payments`,
  collectionsAccount: `${ga}collections-account`,
  collectionsDispositions: `${ga}collections-dispositions`,
  vehiclesNew: `${ga}vehicles-new`,
  vehiclesAll: `${ga}vehicles-all`,
  inventoryIssues: `${ga}inventory-issues`,
  dealerProfile: `${ga}dealer-profile`,
  userSetup: `${ga}user-setup`,
  unproxy: `${ga}unproxy`,
  signOut: `${ga}signout`,
  updateVehicleFromStep3: `${ga}update-vehicle-from-step-3`,
  step4: `${ga}step-4`,
  step5: `${ga}step-5`,
  step6: `${ga}step-6`,
  notifications: `${ga}notifications-page`,
  salesTools: `${C3}auto-response-setup-page`,
  leads: "release-lead-management-system-caps-dealer-portal-leads-navigation-to-lms-leads",
  rehashAlternativeDeals: "release-dealer-experience-caps-rehash-header-alternative-deals",
  alternativeDealsNewExperience: "release-dealer-experience-caps-rehash-header-alternative-deals-new-experience",
  rehashDisplayProgramOptions: "release-dealer-experience-caps-rehash-display-program-options",
  inventoryRehash: "release-dealer-experience-caps-rehash-header-inventory-tab",
  adobeTagManager: "adobe-tag-manager-enabled"
}, t5 = {
  [r0.leads]: (r) => !JE(r),
  [r0.notifications]: Boolean,
  [r0.salesTools]: Boolean
}, n5 = {
  customerTools: "dealer-enabled",
  thirdPartyIntegration: "3rd-party-integration-enabled",
  websitePage: "admin-website-page-enabled",
  crmIntegration: "crm-integration-enabled",
  customDomain: "dealer-custom-domain-enabled",
  entriApexHandling: "dealer-custom-domain-entri-apex-handling-enabled"
}, a5 = {
  rehashNewStep4Page: "rehash-new-step-4-page",
  profitableAlternativeDealBanner: "caps-profitable-alternative-deal-banner",
  rehashHomeNotificationEnabled: "rehash-home-notification-enabled",
  maxDiscount: "Max_Discount",
  enableMarketplaceVisibility: "FT_ENABLE_MARKETPLACE_VISIBILITY"
}, z3 = [
  "actionType",
  "approvalId",
  "carLotPK",
  "count",
  "crmRegistryId",
  "dealMaxId",
  "errorId",
  "goTo",
  "isProgramCoordTrained",
  "isTpapGapEligible",
  "isTpapVscEligible",
  "pageHostingReturnPath",
  "vehicleId",
  "warningCode"
], Dn = Object.fromEntries(
  z3.map((r) => [r, `{{${r}}}`])
), fb = {
  login: {
    domain: "caps",
    pathname: `/steps/login.jsf?pageHostingPath=${Dn.pageHostingReturnPath}`
  },
  home: {
    domain: "pageHosting",
    pathname: "/pages/dealer/home"
  },
  leads: {
    domain: "caps",
    pathname: "/steps/pages/mydeals/aip/myDealsAIP.jsf?dealtype=NEW_LEAD"
  },
  newApproval: {
    domain: "pageHosting",
    pathname: "/pages/dealer/steps/step1"
  },
  approvals: {
    domain: "caps",
    pathname: "/steps/pages/mydeals/aip/myDealsAIP.jsf?origin=liferay"
  },
  contracts: {
    domain: "caps",
    pathname: "/steps/pages/mydeals/cip/myDealsCIP.jsf?origin=liferay"
  },
  collectionsStatus: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/accountstatus.jsf?origin=liferay"
  },
  collectionsPayments: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/accountpayment.jsf?origin=liferay"
  },
  collectionsAccount: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/provideaccountinfo.jsf?origin=liferay"
  },
  collectionsDispositions: {
    domain: "caps",
    pathname: "/steps/pages/collectionconnection/dispositionCodes.jsf?origin=liferay"
  },
  updateAllVehicles: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=updateallvehicle&origin=liferay"
  },
  vehiclesNew: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=addvehicle&origin=liferay"
  },
  vehiclesAll: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=updateallvehicle&origin=liferay"
  },
  inventoryIssues: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?modulename=dailyinvetoryexception"
  },
  loyaltyBenefits: {
    domain: "caps",
    pathname: "/steps/pages/benefits/loyalty.jsf?origin=liferay"
  },
  poolPurchaseOffers: {
    domain: "caps",
    pathname: "/steps/pages/benefits/portfolio.jsf?origin=liferay"
  },
  resources: {
    domain: "pageHosting",
    pathname: "/pages/dealer/resources"
  },
  dealerProfile: {
    domain: "caps",
    pathname: "/steps/pages/dealersetup/dealersetup_main.jsf?origin=liferay"
  },
  userSetup: {
    domain: "caps",
    pathname: "/steps/pages/dealersetup/dealersetup_usersetup_usersearch.jsf?origin=liferay"
  },
  changePassword: {
    domain: "login",
    pathname: "PLACEHOLDER"
  },
  createApplications: {
    domain: "caps",
    pathname: "/steps/pages/contractsetup/createApprovalsExt.jsf?origin=liferay"
  },
  contactUs: {
    domain: "pageHosting",
    pathname: "/pages/dealer/contact-us"
  },
  unproxy: {
    domain: "caps",
    pathname: "/steps/pages/admin/dealer_search.jsf"
  },
  changeDealership: {
    domain: "caps",
    pathname: "/steps/pages/lotselection.jsf"
  },
  unreadEmails: {
    domain: "caps",
    pathname: "steps/pages/utililty/liferayhandshake.jsp?modulename=plusprofit"
  },
  signOut: {
    domain: "caps",
    pathname: "/steps/logout.jsf"
  },
  dealmaxView: {
    domain: "dealmax",
    pathname: `/ords/camobile/r/dealmax/detail-view?value=${Dn.approvalId}`
  },
  dealmaxRestCall: {
    domain: "caps",
    pathname: `/steps/rest/dealMaxVerification?approvalId=${Dn.approvalId}&carLotPK=${Dn.carLotPK}&isTpapVscEligible=${Dn.isTpapVscEligible}&isTpapGapEligible=${Dn.isTpapGapEligible}&isProgramCoordTrained=${Dn.isProgramCoordTrained}&count=${Dn.count}`
  },
  checkAutoRunFlagValueDealmax: {
    domain: "caps",
    pathname: "/steps/rest/dealMaxVerification/autoRunDealmax"
  },
  dealerTerms: {
    domain: "caps",
    pathname: "/steps/pdfs/DealerUserAgreement.pdf"
  },
  dealerCaliforniaTerms: {
    domain: "customerPortal",
    pathname: "/consumer-privacy-act"
  },
  shoppingCart: {
    domain: "caps",
    pathname: "/steps/rest/navigation/shopping_cart_from_step3"
  },
  updateVehicleFromStep3: {
    domain: "caps",
    pathname: "/steps/rest/navigation/add_vehicle_from_step3"
  },
  step1: {
    domain: "pageHosting",
    pathname: `/pages/dealer/steps/step1/${Dn.approvalId}`
  },
  step2: {
    domain: "pageHosting",
    pathname: `/pages/dealer/steps/step2/${Dn.approvalId}`
  },
  step3: {
    domain: "pageHosting",
    pathname: `/pages/dealer/steps/step3/${Dn.approvalId}`
  },
  step4: {
    domain: "caps",
    pathname: "/steps/pages/step4/step4.jsf"
  },
  step4ExistingStock: {
    domain: "caps",
    pathname: "/steps/rest/navigation/step4_with_existing_stock"
  },
  step5: {
    domain: "caps",
    pathname: "/steps/pages/step5/step5.jsf"
  },
  step6: {
    domain: "caps",
    pathname: "/steps/pages/step6/step6.jsf"
  },
  inventoryDownloadServlet: {
    domain: "caps",
    pathname: "/steps/pages/utililty/liferayhandshake.jsp?origin=liferay&modulename=dwreport&goTo=inventory/pages/portal/downloadServlet_Dealer.dwrep?contentType=octet-stream&reportName=missing_titles_detail&reportType=Weekly"
  },
  dealerUserAgreement: {
    domain: "caps",
    pathname: "/inventory/pages/inventory/downloadServlet_Dealer.dprep?contentType=octet-stream&reportName=user_agreement&reportCateg=Adhoc"
  },
  goldPDF: {
    domain: "caps",
    pathname: "/inventory/pages/portal/downloadServlet_Dealer.trep?contentType=octet-stream&reportName=gold_program_info"
  },
  customerTools: {
    domain: "pageHosting",
    pathname: "/pages/dealer/customer-tools"
  },
  notifications: {
    domain: "pageHosting",
    pathname: "/pages/dealer/settings/notifications"
  },
  salesTools: {
    domain: "pageHosting",
    pathname: "/pages/dealer/settings/sales-tools"
  },
  capsDealMaxUrl: {
    domain: "caps",
    pathname: `/steps/login.jsf?dealMaxId=${Dn.dealMaxId}`
  },
  capsHandshakeUrl: {
    domain: "caps",
    // Unfortunately, the caps-steps handshake is inept to properly url-decode query params. So DON'T try to url-encode the goTo param.
    pathname: `/steps/pages/utililty/liferayhandshake.jsp?origin=liferay&modulename=dwreport&goTo=${Dn.goTo}`
  },
  pullAndViewBureau: {
    domain: "caps",
    pathname: "/steps/pages/bureau/view_credit_bureau.jsf"
  },
  enrollmentFactSheet: {
    domain: "caps",
    pathname: `/steps/pages/capscrm/applicationFactSheet.jsf?registryID=${Dn.crmRegistryId}`
  },
  inventoryWarningStockNumber: {
    domain: "caps",
    pathname: `/steps/pages/utililty/liferayhandshake.jsp?modulename=addvehicle&vehicleId=${Dn.vehicleId}&actionType=${Dn.actionType}&warningCode=${Dn.warningCode}&origin=pageHosting`
  },
  inventoryErrorStockNumber: {
    domain: "caps",
    pathname: `/steps/pages/utililty/liferayhandshake.jsp?modulename=addvehicle&vehicleId=${Dn.errorId}&actionType=${Dn.actionType}&origin=pageHosting`
  },
  dealStructureRehash: {
    domain: "caps",
    pathname: `steps/authenticate.jsf?appID=${Dn.approvalId}`
  },
  alternativeDealsRehash: {
    domain: "pageHosting",
    pathname: `/pages/dealer/alternative-deals/${Dn.approvalId}`
  },
  stipulationsRehash: {
    domain: "pageHosting",
    pathname: `pages/proof-portal/dealer/${Dn.approvalId}`
  },
  chargebacks: {
    domain: "pageHosting",
    pathname: "/pages/dealer/outstanding-chargebacks"
  },
  changeVehicleRehash: {
    domain: "pageHosting",
    pathname: `/pages/dealer/change-vehicle/${Dn.approvalId}`
  },
  unauthorizedPage: {
    domain: "caps",
    //caps will redirect inactive dealers to /web/guest/caps-auth-exception
    pathname: "/steps/pages/unauthorized_user.jsf"
  }
};
function _3() {
  let r, f, m;
  try {
    const g = s0();
    m = ZE(""), g === "qa" ? (r = "B2C_1A_QA_CHANGEPASSWORD", f = "58d48733-0983-4d6b-ad6c-54f826e0d88b") : g === "production" ? (r = "B2C_1A_CHANGEPASSWORD", f = "73144a60-68e9-4c88-8943-b78f5c6c3fa0") : (r = "UNKNOWN", f = "UNKNOWN");
  } catch {
    r = "UNKNOWN", f = "UNKNOWN", m = "UNKNOWN";
  }
  const h = encodeURIComponent(m), v = `/oauth2/v2.0/authorize?p=${r}&client_id=${f}&nonce=defaultNonce&redirect_uri=${h}&scope=openid&response_type=id_token`;
  return {
    ...fb,
    changePassword: {
      ...fb.changePassword,
      pathname: v
    }
  };
}
function YO(r) {
  return !!fb[r];
}
function GO(r, f) {
  if (!f)
    return r;
  let m = r;
  for (const [h, v] of Object.entries(f)) {
    const g = new RegExp(`{{${h}}}`, "g");
    m = m.replace(g, v);
  }
  return m;
}
function Pm(r, f, m) {
  if (!YO(r))
    throw new Error(`Unknown Location ${r}`);
  if (m) {
    const S = XO(r, f, m);
    if (S)
      return S;
  }
  const h = _3()[r];
  let { pathname: v } = h;
  f && (v = GO(
    v,
    f
  ));
  let g;
  switch (h.domain) {
    case "caps": {
      g = ZE("");
      break;
    }
    case "dealmax": {
      g = b3("");
      break;
    }
    case "customerPortal": {
      g = v3("");
      break;
    }
    case "pageHosting": {
      g = S3("");
      break;
    }
    default:
      return g3(h.pathname);
  }
  return new URL(v, g).toString();
}
function gb(r, f, m) {
  window.location.href = Pm(r, f, m);
}
function XO(r, f, m) {
  if (!YO(r))
    throw new Error(`Unknown Location ${r}`);
  const h = r0[r];
  if (!h)
    return Pm(r, f);
  try {
    if (!m)
      return Pm(r, f);
    const g = m.allFlags()[h];
    return typeof g != "string" || !g ? Pm(r, f) : GO(g, f);
  } catch (v) {
    return console.error("Launch darkly initialization failed", v), Pm(r, f);
  }
}
var G1 = { exports: {} }, FS = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bA;
function U3() {
  if (bA) return FS;
  bA = 1;
  var r = ar;
  function f(z, L) {
    return z === L && (z !== 0 || 1 / z === 1 / L) || z !== z && L !== L;
  }
  var m = typeof Object.is == "function" ? Object.is : f, h = r.useState, v = r.useEffect, g = r.useLayoutEffect, S = r.useDebugValue;
  function E(z, L) {
    var Q = L(), N = h({ inst: { value: Q, getSnapshot: L } }), G = N[0].inst, Y = N[1];
    return g(
      function() {
        G.value = Q, G.getSnapshot = L, O(G) && Y({ inst: G });
      },
      [z, Q, L]
    ), v(
      function() {
        return O(G) && Y({ inst: G }), z(function() {
          O(G) && Y({ inst: G });
        });
      },
      [z]
    ), S(Q), Q;
  }
  function O(z) {
    var L = z.getSnapshot;
    z = z.value;
    try {
      var Q = L();
      return !m(z, Q);
    } catch {
      return !0;
    }
  }
  function R(z, L) {
    return L();
  }
  var _ = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? R : E;
  return FS.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : _, FS;
}
var WS = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SA;
function w3() {
  return SA || (SA = 1, process.env.NODE_ENV !== "production" && (function() {
    function r(Q, N) {
      return Q === N && (Q !== 0 || 1 / Q === 1 / N) || Q !== Q && N !== N;
    }
    function f(Q, N) {
      _ || v.startTransition === void 0 || (_ = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var G = N();
      if (!z) {
        var Y = N();
        g(G, Y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), z = !0);
      }
      Y = S({
        inst: { value: G, getSnapshot: N }
      });
      var F = Y[0].inst, ne = Y[1];
      return O(
        function() {
          F.value = G, F.getSnapshot = N, m(F) && ne({ inst: F });
        },
        [Q, G, N]
      ), E(
        function() {
          return m(F) && ne({ inst: F }), Q(function() {
            m(F) && ne({ inst: F });
          });
        },
        [Q]
      ), R(G), G;
    }
    function m(Q) {
      var N = Q.getSnapshot;
      Q = Q.value;
      try {
        var G = N();
        return !g(Q, G);
      } catch {
        return !0;
      }
    }
    function h(Q, N) {
      return N();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var v = ar, g = typeof Object.is == "function" ? Object.is : r, S = v.useState, E = v.useEffect, O = v.useLayoutEffect, R = v.useDebugValue, _ = !1, z = !1, L = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? h : f;
    WS.useSyncExternalStore = v.useSyncExternalStore !== void 0 ? v.useSyncExternalStore : L, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), WS;
}
var EA;
function M3() {
  return EA || (EA = 1, process.env.NODE_ENV === "production" ? G1.exports = U3() : G1.exports = w3()), G1.exports;
}
var TA = M3();
const QO = 0, ZO = 1, JO = 2, AA = 3;
var OA = Object.prototype.hasOwnProperty;
function zE(r, f) {
  var m, h;
  if (r === f) return !0;
  if (r && f && (m = r.constructor) === f.constructor) {
    if (m === Date) return r.getTime() === f.getTime();
    if (m === RegExp) return r.toString() === f.toString();
    if (m === Array) {
      if ((h = r.length) === f.length)
        for (; h-- && zE(r[h], f[h]); ) ;
      return h === -1;
    }
    if (!m || typeof r == "object") {
      h = 0;
      for (m in r)
        if (OA.call(r, m) && ++h && !OA.call(f, m) || !(m in f) || !zE(r[m], f[m])) return !1;
      return Object.keys(f).length === h;
    }
  }
  return r !== r && f !== f;
}
const er = /* @__PURE__ */ new WeakMap(), tr = () => {
}, ja = (
  /*#__NOINLINE__*/
  tr()
), db = Object, Ut = (r) => r === ja, Wi = (r) => typeof r == "function", nr = (r, f) => ({
  ...r,
  ...f
}), KO = (r) => Wi(r.then), IS = {}, X1 = {}, KE = "undefined", d0 = typeof window != KE, _E = typeof document != KE, N3 = d0 && "Deno" in window, x3 = () => d0 && typeof window.requestAnimationFrame != KE, kO = (r, f) => {
  const m = er.get(r);
  return [
    // Getter
    () => !Ut(f) && r.get(f) || IS,
    // Setter
    (h) => {
      if (!Ut(f)) {
        const v = r.get(f);
        f in X1 || (X1[f] = v), m[5](f, nr(v, h), v || IS);
      }
    },
    // Subscriber
    m[6],
    // Get server cache snapshot
    () => !Ut(f) && f in X1 ? X1[f] : !Ut(f) && r.get(f) || IS
  ];
};
let UE = !0;
const H3 = () => UE, [wE, ME] = d0 && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  tr,
  tr
], L3 = () => {
  const r = _E && document.visibilityState;
  return Ut(r) || r !== "hidden";
}, B3 = (r) => (_E && document.addEventListener("visibilitychange", r), wE("focus", r), () => {
  _E && document.removeEventListener("visibilitychange", r), ME("focus", r);
}), j3 = (r) => {
  const f = () => {
    UE = !0, r();
  }, m = () => {
    UE = !1;
  };
  return wE("online", f), wE("offline", m), () => {
    ME("online", f), ME("offline", m);
  };
}, q3 = {
  isOnline: H3,
  isVisible: L3
}, V3 = {
  initFocus: B3,
  initReconnect: j3
}, DA = !ar.useId, ep = !d0 || N3, Y3 = (r) => x3() ? window.requestAnimationFrame(r) : setTimeout(r, 1), ib = ep ? Cl : n3, PS = typeof navigator < "u" && navigator.connection, RA = !ep && PS && ([
  "slow-2g",
  "2g"
].includes(PS.effectiveType) || PS.saveData), Q1 = /* @__PURE__ */ new WeakMap(), G3 = (r) => db.prototype.toString.call(r), eE = (r, f) => r === `[object ${f}]`;
let X3 = 0;
const NE = (r) => {
  const f = typeof r, m = G3(r), h = eE(m, "Date"), v = eE(m, "RegExp"), g = eE(m, "Object");
  let S, E;
  if (db(r) === r && !h && !v) {
    if (S = Q1.get(r), S) return S;
    if (S = ++X3 + "~", Q1.set(r, S), Array.isArray(r)) {
      for (S = "@", E = 0; E < r.length; E++)
        S += NE(r[E]) + ",";
      Q1.set(r, S);
    }
    if (g) {
      S = "#";
      const O = db.keys(r).sort();
      for (; !Ut(E = O.pop()); )
        Ut(r[E]) || (S += E + ":" + NE(r[E]) + ",");
      Q1.set(r, S);
    }
  } else
    S = h ? r.toJSON() : f == "symbol" ? r.toString() : f == "string" ? JSON.stringify(r) : "" + r;
  return S;
}, kE = (r) => {
  if (Wi(r))
    try {
      r = r();
    } catch {
      r = "";
    }
  const f = r;
  return r = typeof r == "string" ? r : (Array.isArray(r) ? r.length : r) ? NE(r) : "", [
    r,
    f
  ];
};
let Q3 = 0;
const xE = () => ++Q3;
async function $O(...r) {
  const [f, m, h, v] = r, g = nr({
    populateCache: !0,
    throwOnError: !0
  }, typeof v == "boolean" ? {
    revalidate: v
  } : v || {});
  let S = g.populateCache;
  const E = g.rollbackOnError;
  let O = g.optimisticData;
  const R = (L) => typeof E == "function" ? E(L) : E !== !1, _ = g.throwOnError;
  if (Wi(m)) {
    const L = m, Q = [], N = f.keys();
    for (const G of N)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(G) && L(f.get(G)._k) && Q.push(G);
    return Promise.all(Q.map(z));
  }
  return z(m);
  async function z(L) {
    const [Q] = kE(L);
    if (!Q) return;
    const [N, G] = kO(f, Q), [Y, F, ne, ye] = er.get(f), pe = () => {
      const We = Y[Q];
      return (Wi(g.revalidate) ? g.revalidate(N().data, L) : g.revalidate !== !1) && (delete ne[Q], delete ye[Q], We && We[0]) ? We[0](JO).then(() => N().data) : N().data;
    };
    if (r.length < 3)
      return pe();
    let he = h, Te, ge = !1;
    const Se = xE();
    F[Q] = [
      Se,
      0
    ];
    const xe = !Ut(O), ae = N(), Me = ae.data, Ce = ae._c, we = Ut(Ce) ? Me : Ce;
    if (xe && (O = Wi(O) ? O(we, Me) : O, G({
      data: O,
      _c: we
    })), Wi(he))
      try {
        he = he(we);
      } catch (We) {
        Te = We, ge = !0;
      }
    if (he && KO(he))
      if (he = await he.catch((We) => {
        Te = We, ge = !0;
      }), Se !== F[Q][0]) {
        if (ge) throw Te;
        return he;
      } else ge && xe && R(Te) && (S = !0, G({
        data: we,
        _c: ja
      }));
    if (S && !ge)
      if (Wi(S)) {
        const We = S(he, we);
        G({
          data: We,
          error: ja,
          _c: ja
        });
      } else
        G({
          data: he,
          error: ja,
          _c: ja
        });
    if (F[Q][1] = xE(), Promise.resolve(pe()).then(() => {
      G({
        _c: ja
      });
    }), ge) {
      if (_) throw Te;
      return;
    }
    return he;
  }
}
const CA = (r, f) => {
  for (const m in r)
    r[m][0] && r[m][0](f);
}, FO = (r, f) => {
  if (!er.has(r)) {
    const m = nr(V3, f), h = /* @__PURE__ */ Object.create(null), v = $O.bind(ja, r);
    let g = tr;
    const S = /* @__PURE__ */ Object.create(null), E = (_, z) => {
      const L = S[_] || [];
      return S[_] = L, L.push(z), () => L.splice(L.indexOf(z), 1);
    }, O = (_, z, L) => {
      r.set(_, z);
      const Q = S[_];
      if (Q)
        for (const N of Q)
          N(z, L);
    }, R = () => {
      if (!er.has(r) && (er.set(r, [
        h,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        v,
        O,
        E
      ]), !ep)) {
        const _ = m.initFocus(setTimeout.bind(ja, CA.bind(ja, h, QO))), z = m.initReconnect(setTimeout.bind(ja, CA.bind(ja, h, ZO)));
        g = () => {
          _ && _(), z && z(), er.delete(r);
        };
      }
    };
    return R(), [
      r,
      v,
      R,
      g
    ];
  }
  return [
    r,
    er.get(r)[4]
  ];
}, Z3 = (r, f, m, h, v) => {
  const g = m.errorRetryCount, S = v.retryCount, E = ~~((Math.random() + 0.5) * (1 << (S < 8 ? S : 8))) * m.errorRetryInterval;
  !Ut(g) && S > g || setTimeout(h, E, v);
}, J3 = zE, [$E, K3] = FO(/* @__PURE__ */ new Map()), WO = nr(
  {
    // events
    onLoadingSlow: tr,
    onSuccess: tr,
    onError: tr,
    onErrorRetry: Z3,
    onDiscarded: tr,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: RA ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: RA ? 5e3 : 3e3,
    // providers
    compare: J3,
    isPaused: () => !1,
    cache: $E,
    mutate: K3,
    fallback: {}
  },
  // use web preset by default
  q3
), IO = (r, f) => {
  const m = nr(r, f);
  if (f) {
    const { use: h, fallback: v } = r, { use: g, fallback: S } = f;
    h && g && (m.use = h.concat(g)), v && S && (m.fallback = nr(v, S));
  }
  return m;
}, HE = t3({}), k3 = (r) => {
  const { value: f } = r, m = NO(HE), h = Wi(f), v = tp(() => h ? f(m) : f, [
    h,
    m,
    f
  ]), g = tp(() => h ? v : IO(m, v), [
    h,
    m,
    v
  ]), S = v && v.provider, E = bi(ja);
  S && !E.current && (E.current = FO(S(g.cache || $E), v));
  const O = E.current;
  return O && (g.cache = O[0], g.mutate = O[1]), ib(() => {
    if (O)
      return O[2] && O[2](), O[3];
  }, []), e3(HE.Provider, nr(r, {
    value: g
  }));
}, $3 = "$inf$", PO = d0 && window.__SWR_DEVTOOLS_USE__, F3 = PO ? window.__SWR_DEVTOOLS_USE__ : [], W3 = () => {
  PO && (window.__SWR_DEVTOOLS_REACT__ = ar);
}, I3 = (r) => Wi(r[1]) ? [
  r[0],
  r[1],
  r[2] || {}
] : [
  r[0],
  null,
  (r[1] === null ? r[2] : r[1]) || {}
], P3 = () => {
  const r = NO(HE);
  return tp(() => nr(WO, r), [
    r
  ]);
}, e4 = (r) => (f, m, h) => r(f, m && ((...g) => {
  const [S] = kE(f), [, , , E] = er.get($E);
  if (S.startsWith($3))
    return m(...g);
  const O = E[S];
  return Ut(O) ? m(...g) : (delete E[S], O);
}), h), t4 = F3.concat(e4), n4 = (r) => function(...m) {
  const h = P3(), [v, g, S] = I3(m), E = IO(h, S);
  let O = r;
  const { use: R } = E, _ = (R || []).concat(t4);
  for (let z = _.length; z--; )
    O = _[z](O);
  return O(v, g || E.fetcher || null, E);
}, a4 = (r, f, m) => {
  const h = f[r] || (f[r] = []);
  return h.push(m), () => {
    const v = h.indexOf(m);
    v >= 0 && (h[v] = h[h.length - 1], h.pop());
  };
};
W3();
const tE = ar.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((r) => {
  switch (r.status) {
    case "pending":
      throw r;
    case "fulfilled":
      return r.value;
    case "rejected":
      throw r.reason;
    default:
      throw r.status = "pending", r.then((f) => {
        r.status = "fulfilled", r.value = f;
      }, (f) => {
        r.status = "rejected", r.reason = f;
      }), r;
  }
}), nE = {
  dedupe: !0
}, zA = Promise.resolve(ja), l4 = (r, f, m) => {
  const { cache: h, compare: v, suspense: g, fallbackData: S, revalidateOnMount: E, revalidateIfStale: O, refreshInterval: R, refreshWhenHidden: _, refreshWhenOffline: z, keepPreviousData: L, strictServerPrefetchWarning: Q } = m, [N, G, Y, F] = er.get(h), [ne, ye] = kE(r), pe = bi(!1), he = bi(!1), Te = bi(ne), ge = bi(f), Se = bi(m), xe = () => Se.current, ae = () => xe().isVisible() && xe().isOnline(), [Me, Ce, we, We] = kO(h, ne), Rt = bi({}).current, H = Ut(S) ? Ut(m.fallback) ? ja : m.fallback[ne] : S, ue = (He, wt) => {
    for (const jt in Rt) {
      const Zt = jt;
      if (Zt === "data") {
        if (!v(He[Zt], wt[Zt]) && (!Ut(He[Zt]) || !v(Rn, wt[Zt])))
          return !1;
      } else if (wt[Zt] !== He[Zt])
        return !1;
    }
    return !0;
  }, fe = tp(() => {
    const He = !ne || !f ? !1 : Ut(E) ? xe().isPaused() || g ? !1 : O !== !1 : E, wt = (me) => {
      const _e = nr(me);
      return delete _e._k, He ? {
        isValidating: !0,
        isLoading: !0,
        ..._e
      } : _e;
    }, jt = Me(), Zt = We(), Z = wt(jt), de = jt === Zt ? Z : wt(Zt);
    let oe = Z;
    return [
      () => {
        const me = wt(Me());
        return ue(me, oe) ? (oe.data = me.data, oe.isLoading = me.isLoading, oe.isValidating = me.isValidating, oe.error = me.error, oe) : (oe = me, me);
      },
      () => de
    ];
  }, [
    h,
    ne
  ]), be = TA.useSyncExternalStore(c0(
    (He) => we(ne, (wt, jt) => {
      ue(jt, wt) || He();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      h,
      ne
    ]
  ), fe[0], fe[1]), Be = !pe.current, ee = N[ne] && N[ne].length > 0, ve = be.data, De = Ut(ve) ? H && KO(H) ? tE(H) : H : ve, ze = be.error, At = bi(De), Rn = L ? Ut(ve) ? Ut(At.current) ? De : At.current : ve : De, ft = ne && Ut(De), en = !ep && // eslint-disable-next-line react-hooks/rules-of-hooks
  TA.useSyncExternalStore(() => tr, () => !1, () => !0);
  Q && en && !g && ft && console.warn(`Missing pre-initiated data for serialized key "${ne}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
  const Mn = ee && !Ut(ze) ? !1 : Be && !Ut(E) ? E : xe().isPaused() ? !1 : g ? Ut(De) ? !1 : O : Ut(De) || O, zl = !!(ne && f && Be && Mn), Ae = Ut(be.isValidating) ? zl : be.isValidating, qa = Ut(be.isLoading) ? zl : be.isLoading, va = c0(
    async (He) => {
      const wt = ge.current;
      if (!ne || !wt || he.current || xe().isPaused())
        return !1;
      let jt, Zt, Z = !0;
      const de = He || {}, oe = !Y[ne] || !de.dedupe, me = () => DA ? !he.current && ne === Te.current && pe.current : ne === Te.current, _e = {
        isValidating: !1,
        isLoading: !1
      }, vt = () => {
        Ce(_e);
      }, et = () => {
        const Wt = Y[ne];
        Wt && Wt[1] === Zt && delete Y[ne];
      }, St = {
        isValidating: !0
      };
      Ut(Me().data) && (St.isLoading = !0);
      try {
        if (oe && (Ce(St), m.loadingTimeout && Ut(Me().data) && setTimeout(() => {
          Z && me() && xe().onLoadingSlow(ne, m);
        }, m.loadingTimeout), Y[ne] = [
          wt(ye),
          xE()
        ]), [jt, Zt] = Y[ne], jt = await jt, oe && setTimeout(et, m.dedupingInterval), !Y[ne] || Y[ne][1] !== Zt)
          return oe && me() && xe().onDiscarded(ne), !1;
        _e.error = ja;
        const Wt = G[ne];
        if (!Ut(Wt) && // case 1
        (Zt <= Wt[0] || // case 2
        Zt <= Wt[1] || // case 3
        Wt[1] === 0))
          return vt(), oe && me() && xe().onDiscarded(ne), !1;
        const tl = Me().data;
        _e.data = v(tl, jt) ? tl : jt, oe && me() && xe().onSuccess(jt, ne, m);
      } catch (Wt) {
        et();
        const tl = xe(), { shouldRetryOnError: Xo } = tl;
        tl.isPaused() || (_e.error = Wt, oe && me() && (tl.onError(Wt, ne, tl), (Xo === !0 || Wi(Xo) && Xo(Wt)) && (!xe().revalidateOnFocus || !xe().revalidateOnReconnect || ae()) && tl.onErrorRetry(Wt, ne, tl, (Ud) => {
          const lr = N[ne];
          lr && lr[0] && lr[0](AA, Ud);
        }, {
          retryCount: (de.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return Z = !1, vt(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      ne,
      h
    ]
  ), na = c0(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...He) => $O(h, Te.current, ...He),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (ib(() => {
    ge.current = f, Se.current = m, Ut(ve) || (At.current = ve);
  }), ib(() => {
    if (!ne) return;
    const He = va.bind(ja, nE);
    let wt = 0;
    xe().revalidateOnFocus && (wt = Date.now() + xe().focusThrottleInterval);
    const Zt = a4(ne, N, (Z, de = {}) => {
      if (Z == QO) {
        const oe = Date.now();
        xe().revalidateOnFocus && oe > wt && ae() && (wt = oe + xe().focusThrottleInterval, He());
      } else if (Z == ZO)
        xe().revalidateOnReconnect && ae() && He();
      else {
        if (Z == JO)
          return va();
        if (Z == AA)
          return va(de);
      }
    });
    return he.current = !1, Te.current = ne, pe.current = !0, Ce({
      _k: ye
    }), Mn && (Y[ne] || (Ut(De) || ep ? He() : Y3(He))), () => {
      he.current = !0, Zt();
    };
  }, [
    ne
  ]), ib(() => {
    let He;
    function wt() {
      const Zt = Wi(R) ? R(Me().data) : R;
      Zt && He !== -1 && (He = setTimeout(jt, Zt));
    }
    function jt() {
      !Me().error && (_ || xe().isVisible()) && (z || xe().isOnline()) ? va(nE).then(wt) : wt();
    }
    return wt(), () => {
      He && (clearTimeout(He), He = -1);
    };
  }, [
    R,
    _,
    z,
    ne
  ]), a3(Rn), g) {
    if (!DA && ep && ft)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    ft && (ge.current = f, Se.current = m, he.current = !1);
    const He = F[ne], wt = !Ut(He) && ft ? na(He) : zA;
    if (tE(wt), !Ut(ze) && ft)
      throw ze;
    const jt = ft ? va(nE) : zA;
    !Ut(Rn) && ft && (jt.status = "fulfilled", jt.value = !0), tE(jt);
  }
  return {
    mutate: na,
    get data() {
      return Rt.data = !0, Rn;
    },
    get error() {
      return Rt.error = !0, ze;
    },
    get isValidating() {
      return Rt.isValidating = !0, Ae;
    },
    get isLoading() {
      return Rt.isLoading = !0, qa;
    }
  };
}, u4 = db.defineProperty(k3, "defaultValue", {
  value: WO
}), LE = n4(l4);
async function hb(r) {
  const [f, m] = Array.isArray(r) ? r : [r, void 0], h = typeof f == "string" ? f : f(), v = await fetch(h, {
    credentials: "include",
    mode: "cors"
  });
  if (!v.ok)
    throw new Error(`Failed to retrieve ${m}. Status: ${v.status}`);
  try {
    return await v.json();
  } catch (g) {
    throw console.error(
      `Failed to parse JSON from ${m}. Received Response:`,
      v
    ), new Error(`Failed to retrieve ${m}. Error: ${g}`);
  }
}
function eD(r, f) {
  return function() {
    return r.apply(f, arguments);
  };
}
const { toString: i4 } = Object.prototype, { getPrototypeOf: FE } = Object, { iterator: vb, toStringTag: tD } = Symbol, bb = /* @__PURE__ */ ((r) => (f) => {
  const m = i4.call(f);
  return r[m] || (r[m] = m.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ii = (r) => (r = r.toLowerCase(), (f) => bb(f) === r), Sb = (r) => (f) => typeof f === r, { isArray: ap } = Array, np = Sb("undefined");
function h0(r) {
  return r !== null && !np(r) && r.constructor !== null && !np(r.constructor) && Kl(r.constructor.isBuffer) && r.constructor.isBuffer(r);
}
const nD = Ii("ArrayBuffer");
function o4(r) {
  let f;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? f = ArrayBuffer.isView(r) : f = r && r.buffer && nD(r.buffer), f;
}
const c4 = Sb("string"), Kl = Sb("function"), aD = Sb("number"), m0 = (r) => r !== null && typeof r == "object", r4 = (r) => r === !0 || r === !1, ob = (r) => {
  if (bb(r) !== "object")
    return !1;
  const f = FE(r);
  return (f === null || f === Object.prototype || Object.getPrototypeOf(f) === null) && !(tD in r) && !(vb in r);
}, s4 = (r) => {
  if (!m0(r) || h0(r))
    return !1;
  try {
    return Object.keys(r).length === 0 && Object.getPrototypeOf(r) === Object.prototype;
  } catch {
    return !1;
  }
}, f4 = Ii("Date"), d4 = Ii("File"), h4 = Ii("Blob"), m4 = Ii("FileList"), p4 = (r) => m0(r) && Kl(r.pipe), y4 = (r) => {
  let f;
  return r && (typeof FormData == "function" && r instanceof FormData || Kl(r.append) && ((f = bb(r)) === "formdata" || // detect form-data instance
  f === "object" && Kl(r.toString) && r.toString() === "[object FormData]"));
}, g4 = Ii("URLSearchParams"), [v4, b4, S4, E4] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Ii), T4 = (r) => r.trim ? r.trim() : r.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function p0(r, f, { allOwnKeys: m = !1 } = {}) {
  if (r === null || typeof r > "u")
    return;
  let h, v;
  if (typeof r != "object" && (r = [r]), ap(r))
    for (h = 0, v = r.length; h < v; h++)
      f.call(null, r[h], h, r);
  else {
    if (h0(r))
      return;
    const g = m ? Object.getOwnPropertyNames(r) : Object.keys(r), S = g.length;
    let E;
    for (h = 0; h < S; h++)
      E = g[h], f.call(null, r[E], E, r);
  }
}
function lD(r, f) {
  if (h0(r))
    return null;
  f = f.toLowerCase();
  const m = Object.keys(r);
  let h = m.length, v;
  for (; h-- > 0; )
    if (v = m[h], f === v.toLowerCase())
      return v;
  return null;
}
const Cd = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, uD = (r) => !np(r) && r !== Cd;
function BE() {
  const { caseless: r, skipUndefined: f } = uD(this) && this || {}, m = {}, h = (v, g) => {
    if (g === "__proto__" || g === "constructor" || g === "prototype")
      return;
    const S = r && lD(m, g) || g;
    ob(m[S]) && ob(v) ? m[S] = BE(m[S], v) : ob(v) ? m[S] = BE({}, v) : ap(v) ? m[S] = v.slice() : (!f || !np(v)) && (m[S] = v);
  };
  for (let v = 0, g = arguments.length; v < g; v++)
    arguments[v] && p0(arguments[v], h);
  return m;
}
const A4 = (r, f, m, { allOwnKeys: h } = {}) => (p0(
  f,
  (v, g) => {
    m && Kl(v) ? Object.defineProperty(r, g, {
      value: eD(v, m),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(r, g, {
      value: v,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: h }
), r), O4 = (r) => (r.charCodeAt(0) === 65279 && (r = r.slice(1)), r), D4 = (r, f, m, h) => {
  r.prototype = Object.create(
    f.prototype,
    h
  ), Object.defineProperty(r.prototype, "constructor", {
    value: r,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(r, "super", {
    value: f.prototype
  }), m && Object.assign(r.prototype, m);
}, R4 = (r, f, m, h) => {
  let v, g, S;
  const E = {};
  if (f = f || {}, r == null) return f;
  do {
    for (v = Object.getOwnPropertyNames(r), g = v.length; g-- > 0; )
      S = v[g], (!h || h(S, r, f)) && !E[S] && (f[S] = r[S], E[S] = !0);
    r = m !== !1 && FE(r);
  } while (r && (!m || m(r, f)) && r !== Object.prototype);
  return f;
}, C4 = (r, f, m) => {
  r = String(r), (m === void 0 || m > r.length) && (m = r.length), m -= f.length;
  const h = r.indexOf(f, m);
  return h !== -1 && h === m;
}, z4 = (r) => {
  if (!r) return null;
  if (ap(r)) return r;
  let f = r.length;
  if (!aD(f)) return null;
  const m = new Array(f);
  for (; f-- > 0; )
    m[f] = r[f];
  return m;
}, _4 = /* @__PURE__ */ ((r) => (f) => r && f instanceof r)(typeof Uint8Array < "u" && FE(Uint8Array)), U4 = (r, f) => {
  const h = (r && r[vb]).call(r);
  let v;
  for (; (v = h.next()) && !v.done; ) {
    const g = v.value;
    f.call(r, g[0], g[1]);
  }
}, w4 = (r, f) => {
  let m;
  const h = [];
  for (; (m = r.exec(f)) !== null; )
    h.push(m);
  return h;
}, M4 = Ii("HTMLFormElement"), N4 = (r) => r.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(m, h, v) {
  return h.toUpperCase() + v;
}), _A = (({ hasOwnProperty: r }) => (f, m) => r.call(f, m))(Object.prototype), x4 = Ii("RegExp"), iD = (r, f) => {
  const m = Object.getOwnPropertyDescriptors(r), h = {};
  p0(m, (v, g) => {
    let S;
    (S = f(v, g, r)) !== !1 && (h[g] = S || v);
  }), Object.defineProperties(r, h);
}, H4 = (r) => {
  iD(r, (f, m) => {
    if (Kl(r) && ["arguments", "caller", "callee"].indexOf(m) !== -1)
      return !1;
    const h = r[m];
    if (Kl(h)) {
      if (f.enumerable = !1, "writable" in f) {
        f.writable = !1;
        return;
      }
      f.set || (f.set = () => {
        throw Error("Can not rewrite read-only method '" + m + "'");
      });
    }
  });
}, L4 = (r, f) => {
  const m = {}, h = (v) => {
    v.forEach((g) => {
      m[g] = !0;
    });
  };
  return ap(r) ? h(r) : h(String(r).split(f)), m;
}, B4 = () => {
}, j4 = (r, f) => r != null && Number.isFinite(r = +r) ? r : f;
function q4(r) {
  return !!(r && Kl(r.append) && r[tD] === "FormData" && r[vb]);
}
const V4 = (r) => {
  const f = new Array(10), m = (h, v) => {
    if (m0(h)) {
      if (f.indexOf(h) >= 0)
        return;
      if (h0(h))
        return h;
      if (!("toJSON" in h)) {
        f[v] = h;
        const g = ap(h) ? [] : {};
        return p0(h, (S, E) => {
          const O = m(S, v + 1);
          !np(O) && (g[E] = O);
        }), f[v] = void 0, g;
      }
    }
    return h;
  };
  return m(r, 0);
}, Y4 = Ii("AsyncFunction"), G4 = (r) => r && (m0(r) || Kl(r)) && Kl(r.then) && Kl(r.catch), oD = ((r, f) => r ? setImmediate : f ? ((m, h) => (Cd.addEventListener(
  "message",
  ({ source: v, data: g }) => {
    v === Cd && g === m && h.length && h.shift()();
  },
  !1
), (v) => {
  h.push(v), Cd.postMessage(m, "*");
}))(`axios@${Math.random()}`, []) : (m) => setTimeout(m))(typeof setImmediate == "function", Kl(Cd.postMessage)), X4 = typeof queueMicrotask < "u" ? queueMicrotask.bind(Cd) : typeof process < "u" && process.nextTick || oD, Q4 = (r) => r != null && Kl(r[vb]), te = {
  isArray: ap,
  isArrayBuffer: nD,
  isBuffer: h0,
  isFormData: y4,
  isArrayBufferView: o4,
  isString: c4,
  isNumber: aD,
  isBoolean: r4,
  isObject: m0,
  isPlainObject: ob,
  isEmptyObject: s4,
  isReadableStream: v4,
  isRequest: b4,
  isResponse: S4,
  isHeaders: E4,
  isUndefined: np,
  isDate: f4,
  isFile: d4,
  isBlob: h4,
  isRegExp: x4,
  isFunction: Kl,
  isStream: p4,
  isURLSearchParams: g4,
  isTypedArray: _4,
  isFileList: m4,
  forEach: p0,
  merge: BE,
  extend: A4,
  trim: T4,
  stripBOM: O4,
  inherits: D4,
  toFlatObject: R4,
  kindOf: bb,
  kindOfTest: Ii,
  endsWith: C4,
  toArray: z4,
  forEachEntry: U4,
  matchAll: w4,
  isHTMLForm: M4,
  hasOwnProperty: _A,
  hasOwnProp: _A,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: iD,
  freezeMethods: H4,
  toObjectSet: L4,
  toCamelCase: N4,
  noop: B4,
  toFiniteNumber: j4,
  findKey: lD,
  global: Cd,
  isContextDefined: uD,
  isSpecCompliantForm: q4,
  toJSONObject: V4,
  isAsyncFn: Y4,
  isThenable: G4,
  setImmediate: oD,
  asap: X4,
  isIterable: Q4
};
let $e = class cD extends Error {
  static from(f, m, h, v, g, S) {
    const E = new cD(f.message, m || f.code, h, v, g);
    return E.cause = f, E.name = f.name, S && Object.assign(E, S), E;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(f, m, h, v, g) {
    super(f), this.name = "AxiosError", this.isAxiosError = !0, m && (this.code = m), h && (this.config = h), v && (this.request = v), g && (this.response = g, this.status = g.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: te.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
$e.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
$e.ERR_BAD_OPTION = "ERR_BAD_OPTION";
$e.ECONNABORTED = "ECONNABORTED";
$e.ETIMEDOUT = "ETIMEDOUT";
$e.ERR_NETWORK = "ERR_NETWORK";
$e.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
$e.ERR_DEPRECATED = "ERR_DEPRECATED";
$e.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
$e.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
$e.ERR_CANCELED = "ERR_CANCELED";
$e.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
$e.ERR_INVALID_URL = "ERR_INVALID_URL";
const Z4 = null;
function jE(r) {
  return te.isPlainObject(r) || te.isArray(r);
}
function rD(r) {
  return te.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function UA(r, f, m) {
  return r ? r.concat(f).map(function(v, g) {
    return v = rD(v), !m && g ? "[" + v + "]" : v;
  }).join(m ? "." : "") : f;
}
function J4(r) {
  return te.isArray(r) && !r.some(jE);
}
const K4 = te.toFlatObject(te, {}, null, function(f) {
  return /^is[A-Z]/.test(f);
});
function Eb(r, f, m) {
  if (!te.isObject(r))
    throw new TypeError("target must be an object");
  f = f || new FormData(), m = te.toFlatObject(m, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(G, Y) {
    return !te.isUndefined(Y[G]);
  });
  const h = m.metaTokens, v = m.visitor || _, g = m.dots, S = m.indexes, O = (m.Blob || typeof Blob < "u" && Blob) && te.isSpecCompliantForm(f);
  if (!te.isFunction(v))
    throw new TypeError("visitor must be a function");
  function R(N) {
    if (N === null) return "";
    if (te.isDate(N))
      return N.toISOString();
    if (te.isBoolean(N))
      return N.toString();
    if (!O && te.isBlob(N))
      throw new $e("Blob is not supported. Use a Buffer instead.");
    return te.isArrayBuffer(N) || te.isTypedArray(N) ? O && typeof Blob == "function" ? new Blob([N]) : Buffer.from(N) : N;
  }
  function _(N, G, Y) {
    let F = N;
    if (N && !Y && typeof N == "object") {
      if (te.endsWith(G, "{}"))
        G = h ? G : G.slice(0, -2), N = JSON.stringify(N);
      else if (te.isArray(N) && J4(N) || (te.isFileList(N) || te.endsWith(G, "[]")) && (F = te.toArray(N)))
        return G = rD(G), F.forEach(function(ye, pe) {
          !(te.isUndefined(ye) || ye === null) && f.append(
            // eslint-disable-next-line no-nested-ternary
            S === !0 ? UA([G], pe, g) : S === null ? G : G + "[]",
            R(ye)
          );
        }), !1;
    }
    return jE(N) ? !0 : (f.append(UA(Y, G, g), R(N)), !1);
  }
  const z = [], L = Object.assign(K4, {
    defaultVisitor: _,
    convertValue: R,
    isVisitable: jE
  });
  function Q(N, G) {
    if (!te.isUndefined(N)) {
      if (z.indexOf(N) !== -1)
        throw Error("Circular reference detected in " + G.join("."));
      z.push(N), te.forEach(N, function(F, ne) {
        (!(te.isUndefined(F) || F === null) && v.call(
          f,
          F,
          te.isString(ne) ? ne.trim() : ne,
          G,
          L
        )) === !0 && Q(F, G ? G.concat(ne) : [ne]);
      }), z.pop();
    }
  }
  if (!te.isObject(r))
    throw new TypeError("data must be an object");
  return Q(r), f;
}
function wA(r) {
  const f = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(r).replace(/[!'()~]|%20|%00/g, function(h) {
    return f[h];
  });
}
function WE(r, f) {
  this._pairs = [], r && Eb(r, this, f);
}
const sD = WE.prototype;
sD.append = function(f, m) {
  this._pairs.push([f, m]);
};
sD.toString = function(f) {
  const m = f ? function(h) {
    return f.call(this, h, wA);
  } : wA;
  return this._pairs.map(function(v) {
    return m(v[0]) + "=" + m(v[1]);
  }, "").join("&");
};
function k4(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function fD(r, f, m) {
  if (!f)
    return r;
  const h = m && m.encode || k4, v = te.isFunction(m) ? {
    serialize: m
  } : m, g = v && v.serialize;
  let S;
  if (g ? S = g(f, v) : S = te.isURLSearchParams(f) ? f.toString() : new WE(f, v).toString(h), S) {
    const E = r.indexOf("#");
    E !== -1 && (r = r.slice(0, E)), r += (r.indexOf("?") === -1 ? "?" : "&") + S;
  }
  return r;
}
class MA {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(f, m, h) {
    return this.handlers.push({
      fulfilled: f,
      rejected: m,
      synchronous: h ? h.synchronous : !1,
      runWhen: h ? h.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(f) {
    this.handlers[f] && (this.handlers[f] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(f) {
    te.forEach(this.handlers, function(h) {
      h !== null && f(h);
    });
  }
}
const IE = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, $4 = typeof URLSearchParams < "u" ? URLSearchParams : WE, F4 = typeof FormData < "u" ? FormData : null, W4 = typeof Blob < "u" ? Blob : null, I4 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $4,
    FormData: F4,
    Blob: W4
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, PE = typeof window < "u" && typeof document < "u", qE = typeof navigator == "object" && navigator || void 0, P4 = PE && (!qE || ["ReactNative", "NativeScript", "NS"].indexOf(qE.product) < 0), e6 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", t6 = PE && window.location.href || "http://localhost", n6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: PE,
  hasStandardBrowserEnv: P4,
  hasStandardBrowserWebWorkerEnv: e6,
  navigator: qE,
  origin: t6
}, Symbol.toStringTag, { value: "Module" })), el = {
  ...n6,
  ...I4
};
function a6(r, f) {
  return Eb(r, new el.classes.URLSearchParams(), {
    visitor: function(m, h, v, g) {
      return el.isNode && te.isBuffer(m) ? (this.append(h, m.toString("base64")), !1) : g.defaultVisitor.apply(this, arguments);
    },
    ...f
  });
}
function l6(r) {
  return te.matchAll(/\w+|\[(\w*)]/g, r).map((f) => f[0] === "[]" ? "" : f[1] || f[0]);
}
function u6(r) {
  const f = {}, m = Object.keys(r);
  let h;
  const v = m.length;
  let g;
  for (h = 0; h < v; h++)
    g = m[h], f[g] = r[g];
  return f;
}
function dD(r) {
  function f(m, h, v, g) {
    let S = m[g++];
    if (S === "__proto__") return !0;
    const E = Number.isFinite(+S), O = g >= m.length;
    return S = !S && te.isArray(v) ? v.length : S, O ? (te.hasOwnProp(v, S) ? v[S] = [v[S], h] : v[S] = h, !E) : ((!v[S] || !te.isObject(v[S])) && (v[S] = []), f(m, h, v[S], g) && te.isArray(v[S]) && (v[S] = u6(v[S])), !E);
  }
  if (te.isFormData(r) && te.isFunction(r.entries)) {
    const m = {};
    return te.forEachEntry(r, (h, v) => {
      f(l6(h), v, m, 0);
    }), m;
  }
  return null;
}
function i6(r, f, m) {
  if (te.isString(r))
    try {
      return (f || JSON.parse)(r), te.trim(r);
    } catch (h) {
      if (h.name !== "SyntaxError")
        throw h;
    }
  return (m || JSON.stringify)(r);
}
const y0 = {
  transitional: IE,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(f, m) {
    const h = m.getContentType() || "", v = h.indexOf("application/json") > -1, g = te.isObject(f);
    if (g && te.isHTMLForm(f) && (f = new FormData(f)), te.isFormData(f))
      return v ? JSON.stringify(dD(f)) : f;
    if (te.isArrayBuffer(f) || te.isBuffer(f) || te.isStream(f) || te.isFile(f) || te.isBlob(f) || te.isReadableStream(f))
      return f;
    if (te.isArrayBufferView(f))
      return f.buffer;
    if (te.isURLSearchParams(f))
      return m.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), f.toString();
    let E;
    if (g) {
      if (h.indexOf("application/x-www-form-urlencoded") > -1)
        return a6(f, this.formSerializer).toString();
      if ((E = te.isFileList(f)) || h.indexOf("multipart/form-data") > -1) {
        const O = this.env && this.env.FormData;
        return Eb(
          E ? { "files[]": f } : f,
          O && new O(),
          this.formSerializer
        );
      }
    }
    return g || v ? (m.setContentType("application/json", !1), i6(f)) : f;
  }],
  transformResponse: [function(f) {
    const m = this.transitional || y0.transitional, h = m && m.forcedJSONParsing, v = this.responseType === "json";
    if (te.isResponse(f) || te.isReadableStream(f))
      return f;
    if (f && te.isString(f) && (h && !this.responseType || v)) {
      const S = !(m && m.silentJSONParsing) && v;
      try {
        return JSON.parse(f, this.parseReviver);
      } catch (E) {
        if (S)
          throw E.name === "SyntaxError" ? $e.from(E, $e.ERR_BAD_RESPONSE, this, null, this.response) : E;
      }
    }
    return f;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: el.classes.FormData,
    Blob: el.classes.Blob
  },
  validateStatus: function(f) {
    return f >= 200 && f < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
te.forEach(["delete", "get", "head", "post", "put", "patch"], (r) => {
  y0.headers[r] = {};
});
const o6 = te.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), c6 = (r) => {
  const f = {};
  let m, h, v;
  return r && r.split(`
`).forEach(function(S) {
    v = S.indexOf(":"), m = S.substring(0, v).trim().toLowerCase(), h = S.substring(v + 1).trim(), !(!m || f[m] && o6[m]) && (m === "set-cookie" ? f[m] ? f[m].push(h) : f[m] = [h] : f[m] = f[m] ? f[m] + ", " + h : h);
  }), f;
}, NA = Symbol("internals");
function e0(r) {
  return r && String(r).trim().toLowerCase();
}
function cb(r) {
  return r === !1 || r == null ? r : te.isArray(r) ? r.map(cb) : String(r);
}
function r6(r) {
  const f = /* @__PURE__ */ Object.create(null), m = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let h;
  for (; h = m.exec(r); )
    f[h[1]] = h[2];
  return f;
}
const s6 = (r) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(r.trim());
function aE(r, f, m, h, v) {
  if (te.isFunction(h))
    return h.call(this, f, m);
  if (v && (f = m), !!te.isString(f)) {
    if (te.isString(h))
      return f.indexOf(h) !== -1;
    if (te.isRegExp(h))
      return h.test(f);
  }
}
function f6(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (f, m, h) => m.toUpperCase() + h);
}
function d6(r, f) {
  const m = te.toCamelCase(" " + f);
  ["get", "set", "has"].forEach((h) => {
    Object.defineProperty(r, h + m, {
      value: function(v, g, S) {
        return this[h].call(this, f, v, g, S);
      },
      configurable: !0
    });
  });
}
let kl = class {
  constructor(f) {
    f && this.set(f);
  }
  set(f, m, h) {
    const v = this;
    function g(E, O, R) {
      const _ = e0(O);
      if (!_)
        throw new Error("header name must be a non-empty string");
      const z = te.findKey(v, _);
      (!z || v[z] === void 0 || R === !0 || R === void 0 && v[z] !== !1) && (v[z || O] = cb(E));
    }
    const S = (E, O) => te.forEach(E, (R, _) => g(R, _, O));
    if (te.isPlainObject(f) || f instanceof this.constructor)
      S(f, m);
    else if (te.isString(f) && (f = f.trim()) && !s6(f))
      S(c6(f), m);
    else if (te.isObject(f) && te.isIterable(f)) {
      let E = {}, O, R;
      for (const _ of f) {
        if (!te.isArray(_))
          throw TypeError("Object iterator must return a key-value pair");
        E[R = _[0]] = (O = E[R]) ? te.isArray(O) ? [...O, _[1]] : [O, _[1]] : _[1];
      }
      S(E, m);
    } else
      f != null && g(m, f, h);
    return this;
  }
  get(f, m) {
    if (f = e0(f), f) {
      const h = te.findKey(this, f);
      if (h) {
        const v = this[h];
        if (!m)
          return v;
        if (m === !0)
          return r6(v);
        if (te.isFunction(m))
          return m.call(this, v, h);
        if (te.isRegExp(m))
          return m.exec(v);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(f, m) {
    if (f = e0(f), f) {
      const h = te.findKey(this, f);
      return !!(h && this[h] !== void 0 && (!m || aE(this, this[h], h, m)));
    }
    return !1;
  }
  delete(f, m) {
    const h = this;
    let v = !1;
    function g(S) {
      if (S = e0(S), S) {
        const E = te.findKey(h, S);
        E && (!m || aE(h, h[E], E, m)) && (delete h[E], v = !0);
      }
    }
    return te.isArray(f) ? f.forEach(g) : g(f), v;
  }
  clear(f) {
    const m = Object.keys(this);
    let h = m.length, v = !1;
    for (; h--; ) {
      const g = m[h];
      (!f || aE(this, this[g], g, f, !0)) && (delete this[g], v = !0);
    }
    return v;
  }
  normalize(f) {
    const m = this, h = {};
    return te.forEach(this, (v, g) => {
      const S = te.findKey(h, g);
      if (S) {
        m[S] = cb(v), delete m[g];
        return;
      }
      const E = f ? f6(g) : String(g).trim();
      E !== g && delete m[g], m[E] = cb(v), h[E] = !0;
    }), this;
  }
  concat(...f) {
    return this.constructor.concat(this, ...f);
  }
  toJSON(f) {
    const m = /* @__PURE__ */ Object.create(null);
    return te.forEach(this, (h, v) => {
      h != null && h !== !1 && (m[v] = f && te.isArray(h) ? h.join(", ") : h);
    }), m;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([f, m]) => f + ": " + m).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(f) {
    return f instanceof this ? f : new this(f);
  }
  static concat(f, ...m) {
    const h = new this(f);
    return m.forEach((v) => h.set(v)), h;
  }
  static accessor(f) {
    const h = (this[NA] = this[NA] = {
      accessors: {}
    }).accessors, v = this.prototype;
    function g(S) {
      const E = e0(S);
      h[E] || (d6(v, S), h[E] = !0);
    }
    return te.isArray(f) ? f.forEach(g) : g(f), this;
  }
};
kl.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
te.reduceDescriptors(kl.prototype, ({ value: r }, f) => {
  let m = f[0].toUpperCase() + f.slice(1);
  return {
    get: () => r,
    set(h) {
      this[m] = h;
    }
  };
});
te.freezeMethods(kl);
function lE(r, f) {
  const m = this || y0, h = f || m, v = kl.from(h.headers);
  let g = h.data;
  return te.forEach(r, function(E) {
    g = E.call(m, g, v.normalize(), f ? f.status : void 0);
  }), v.normalize(), g;
}
function hD(r) {
  return !!(r && r.__CANCEL__);
}
let g0 = class extends $e {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(f, m, h) {
    super(f ?? "canceled", $e.ERR_CANCELED, m, h), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function mD(r, f, m) {
  const h = m.config.validateStatus;
  !m.status || !h || h(m.status) ? r(m) : f(new $e(
    "Request failed with status code " + m.status,
    [$e.ERR_BAD_REQUEST, $e.ERR_BAD_RESPONSE][Math.floor(m.status / 100) - 4],
    m.config,
    m.request,
    m
  ));
}
function h6(r) {
  const f = /^([-+\w]{1,25})(:?\/\/|:)/.exec(r);
  return f && f[1] || "";
}
function m6(r, f) {
  r = r || 10;
  const m = new Array(r), h = new Array(r);
  let v = 0, g = 0, S;
  return f = f !== void 0 ? f : 1e3, function(O) {
    const R = Date.now(), _ = h[g];
    S || (S = R), m[v] = O, h[v] = R;
    let z = g, L = 0;
    for (; z !== v; )
      L += m[z++], z = z % r;
    if (v = (v + 1) % r, v === g && (g = (g + 1) % r), R - S < f)
      return;
    const Q = _ && R - _;
    return Q ? Math.round(L * 1e3 / Q) : void 0;
  };
}
function p6(r, f) {
  let m = 0, h = 1e3 / f, v, g;
  const S = (R, _ = Date.now()) => {
    m = _, v = null, g && (clearTimeout(g), g = null), r(...R);
  };
  return [(...R) => {
    const _ = Date.now(), z = _ - m;
    z >= h ? S(R, _) : (v = R, g || (g = setTimeout(() => {
      g = null, S(v);
    }, h - z)));
  }, () => v && S(v)];
}
const mb = (r, f, m = 3) => {
  let h = 0;
  const v = m6(50, 250);
  return p6((g) => {
    const S = g.loaded, E = g.lengthComputable ? g.total : void 0, O = S - h, R = v(O), _ = S <= E;
    h = S;
    const z = {
      loaded: S,
      total: E,
      progress: E ? S / E : void 0,
      bytes: O,
      rate: R || void 0,
      estimated: R && E && _ ? (E - S) / R : void 0,
      event: g,
      lengthComputable: E != null,
      [f ? "download" : "upload"]: !0
    };
    r(z);
  }, m);
}, xA = (r, f) => {
  const m = r != null;
  return [(h) => f[0]({
    lengthComputable: m,
    total: r,
    loaded: h
  }), f[1]];
}, HA = (r) => (...f) => te.asap(() => r(...f)), y6 = el.hasStandardBrowserEnv ? /* @__PURE__ */ ((r, f) => (m) => (m = new URL(m, el.origin), r.protocol === m.protocol && r.host === m.host && (f || r.port === m.port)))(
  new URL(el.origin),
  el.navigator && /(msie|trident)/i.test(el.navigator.userAgent)
) : () => !0, g6 = el.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(r, f, m, h, v, g, S) {
      if (typeof document > "u") return;
      const E = [`${r}=${encodeURIComponent(f)}`];
      te.isNumber(m) && E.push(`expires=${new Date(m).toUTCString()}`), te.isString(h) && E.push(`path=${h}`), te.isString(v) && E.push(`domain=${v}`), g === !0 && E.push("secure"), te.isString(S) && E.push(`SameSite=${S}`), document.cookie = E.join("; ");
    },
    read(r) {
      if (typeof document > "u") return null;
      const f = document.cookie.match(new RegExp("(?:^|; )" + r + "=([^;]*)"));
      return f ? decodeURIComponent(f[1]) : null;
    },
    remove(r) {
      this.write(r, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function v6(r) {
  return typeof r != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
}
function b6(r, f) {
  return f ? r.replace(/\/?\/$/, "") + "/" + f.replace(/^\/+/, "") : r;
}
function pD(r, f, m) {
  let h = !v6(f);
  return r && (h || m == !1) ? b6(r, f) : f;
}
const LA = (r) => r instanceof kl ? { ...r } : r;
function _d(r, f) {
  f = f || {};
  const m = {};
  function h(R, _, z, L) {
    return te.isPlainObject(R) && te.isPlainObject(_) ? te.merge.call({ caseless: L }, R, _) : te.isPlainObject(_) ? te.merge({}, _) : te.isArray(_) ? _.slice() : _;
  }
  function v(R, _, z, L) {
    if (te.isUndefined(_)) {
      if (!te.isUndefined(R))
        return h(void 0, R, z, L);
    } else return h(R, _, z, L);
  }
  function g(R, _) {
    if (!te.isUndefined(_))
      return h(void 0, _);
  }
  function S(R, _) {
    if (te.isUndefined(_)) {
      if (!te.isUndefined(R))
        return h(void 0, R);
    } else return h(void 0, _);
  }
  function E(R, _, z) {
    if (z in f)
      return h(R, _);
    if (z in r)
      return h(void 0, R);
  }
  const O = {
    url: g,
    method: g,
    data: g,
    baseURL: S,
    transformRequest: S,
    transformResponse: S,
    paramsSerializer: S,
    timeout: S,
    timeoutMessage: S,
    withCredentials: S,
    withXSRFToken: S,
    adapter: S,
    responseType: S,
    xsrfCookieName: S,
    xsrfHeaderName: S,
    onUploadProgress: S,
    onDownloadProgress: S,
    decompress: S,
    maxContentLength: S,
    maxBodyLength: S,
    beforeRedirect: S,
    transport: S,
    httpAgent: S,
    httpsAgent: S,
    cancelToken: S,
    socketPath: S,
    responseEncoding: S,
    validateStatus: E,
    headers: (R, _, z) => v(LA(R), LA(_), z, !0)
  };
  return te.forEach(
    Object.keys({ ...r, ...f }),
    function(_) {
      if (_ === "__proto__" || _ === "constructor" || _ === "prototype")
        return;
      const z = te.hasOwnProp(O, _) ? O[_] : v, L = z(r[_], f[_], _);
      te.isUndefined(L) && z !== E || (m[_] = L);
    }
  ), m;
}
const yD = (r) => {
  const f = _d({}, r);
  let { data: m, withXSRFToken: h, xsrfHeaderName: v, xsrfCookieName: g, headers: S, auth: E } = f;
  if (f.headers = S = kl.from(S), f.url = fD(pD(f.baseURL, f.url, f.allowAbsoluteUrls), r.params, r.paramsSerializer), E && S.set(
    "Authorization",
    "Basic " + btoa((E.username || "") + ":" + (E.password ? unescape(encodeURIComponent(E.password)) : ""))
  ), te.isFormData(m)) {
    if (el.hasStandardBrowserEnv || el.hasStandardBrowserWebWorkerEnv)
      S.setContentType(void 0);
    else if (te.isFunction(m.getHeaders)) {
      const O = m.getHeaders(), R = ["content-type", "content-length"];
      Object.entries(O).forEach(([_, z]) => {
        R.includes(_.toLowerCase()) && S.set(_, z);
      });
    }
  }
  if (el.hasStandardBrowserEnv && (h && te.isFunction(h) && (h = h(f)), h || h !== !1 && y6(f.url))) {
    const O = v && g && g6.read(g);
    O && S.set(v, O);
  }
  return f;
}, S6 = typeof XMLHttpRequest < "u", E6 = S6 && function(r) {
  return new Promise(function(m, h) {
    const v = yD(r);
    let g = v.data;
    const S = kl.from(v.headers).normalize();
    let { responseType: E, onUploadProgress: O, onDownloadProgress: R } = v, _, z, L, Q, N;
    function G() {
      Q && Q(), N && N(), v.cancelToken && v.cancelToken.unsubscribe(_), v.signal && v.signal.removeEventListener("abort", _);
    }
    let Y = new XMLHttpRequest();
    Y.open(v.method.toUpperCase(), v.url, !0), Y.timeout = v.timeout;
    function F() {
      if (!Y)
        return;
      const ye = kl.from(
        "getAllResponseHeaders" in Y && Y.getAllResponseHeaders()
      ), he = {
        data: !E || E === "text" || E === "json" ? Y.responseText : Y.response,
        status: Y.status,
        statusText: Y.statusText,
        headers: ye,
        config: r,
        request: Y
      };
      mD(function(ge) {
        m(ge), G();
      }, function(ge) {
        h(ge), G();
      }, he), Y = null;
    }
    "onloadend" in Y ? Y.onloadend = F : Y.onreadystatechange = function() {
      !Y || Y.readyState !== 4 || Y.status === 0 && !(Y.responseURL && Y.responseURL.indexOf("file:") === 0) || setTimeout(F);
    }, Y.onabort = function() {
      Y && (h(new $e("Request aborted", $e.ECONNABORTED, r, Y)), Y = null);
    }, Y.onerror = function(pe) {
      const he = pe && pe.message ? pe.message : "Network Error", Te = new $e(he, $e.ERR_NETWORK, r, Y);
      Te.event = pe || null, h(Te), Y = null;
    }, Y.ontimeout = function() {
      let pe = v.timeout ? "timeout of " + v.timeout + "ms exceeded" : "timeout exceeded";
      const he = v.transitional || IE;
      v.timeoutErrorMessage && (pe = v.timeoutErrorMessage), h(new $e(
        pe,
        he.clarifyTimeoutError ? $e.ETIMEDOUT : $e.ECONNABORTED,
        r,
        Y
      )), Y = null;
    }, g === void 0 && S.setContentType(null), "setRequestHeader" in Y && te.forEach(S.toJSON(), function(pe, he) {
      Y.setRequestHeader(he, pe);
    }), te.isUndefined(v.withCredentials) || (Y.withCredentials = !!v.withCredentials), E && E !== "json" && (Y.responseType = v.responseType), R && ([L, N] = mb(R, !0), Y.addEventListener("progress", L)), O && Y.upload && ([z, Q] = mb(O), Y.upload.addEventListener("progress", z), Y.upload.addEventListener("loadend", Q)), (v.cancelToken || v.signal) && (_ = (ye) => {
      Y && (h(!ye || ye.type ? new g0(null, r, Y) : ye), Y.abort(), Y = null);
    }, v.cancelToken && v.cancelToken.subscribe(_), v.signal && (v.signal.aborted ? _() : v.signal.addEventListener("abort", _)));
    const ne = h6(v.url);
    if (ne && el.protocols.indexOf(ne) === -1) {
      h(new $e("Unsupported protocol " + ne + ":", $e.ERR_BAD_REQUEST, r));
      return;
    }
    Y.send(g || null);
  });
}, T6 = (r, f) => {
  const { length: m } = r = r ? r.filter(Boolean) : [];
  if (f || m) {
    let h = new AbortController(), v;
    const g = function(R) {
      if (!v) {
        v = !0, E();
        const _ = R instanceof Error ? R : this.reason;
        h.abort(_ instanceof $e ? _ : new g0(_ instanceof Error ? _.message : _));
      }
    };
    let S = f && setTimeout(() => {
      S = null, g(new $e(`timeout of ${f}ms exceeded`, $e.ETIMEDOUT));
    }, f);
    const E = () => {
      r && (S && clearTimeout(S), S = null, r.forEach((R) => {
        R.unsubscribe ? R.unsubscribe(g) : R.removeEventListener("abort", g);
      }), r = null);
    };
    r.forEach((R) => R.addEventListener("abort", g));
    const { signal: O } = h;
    return O.unsubscribe = () => te.asap(E), O;
  }
}, A6 = function* (r, f) {
  let m = r.byteLength;
  if (m < f) {
    yield r;
    return;
  }
  let h = 0, v;
  for (; h < m; )
    v = h + f, yield r.slice(h, v), h = v;
}, O6 = async function* (r, f) {
  for await (const m of D6(r))
    yield* A6(m, f);
}, D6 = async function* (r) {
  if (r[Symbol.asyncIterator]) {
    yield* r;
    return;
  }
  const f = r.getReader();
  try {
    for (; ; ) {
      const { done: m, value: h } = await f.read();
      if (m)
        break;
      yield h;
    }
  } finally {
    await f.cancel();
  }
}, BA = (r, f, m, h) => {
  const v = O6(r, f);
  let g = 0, S, E = (O) => {
    S || (S = !0, h && h(O));
  };
  return new ReadableStream({
    async pull(O) {
      try {
        const { done: R, value: _ } = await v.next();
        if (R) {
          E(), O.close();
          return;
        }
        let z = _.byteLength;
        if (m) {
          let L = g += z;
          m(L);
        }
        O.enqueue(new Uint8Array(_));
      } catch (R) {
        throw E(R), R;
      }
    },
    cancel(O) {
      return E(O), v.return();
    }
  }, {
    highWaterMark: 2
  });
}, jA = 64 * 1024, { isFunction: Z1 } = te, R6 = (({ Request: r, Response: f }) => ({
  Request: r,
  Response: f
}))(te.global), {
  ReadableStream: qA,
  TextEncoder: VA
} = te.global, YA = (r, ...f) => {
  try {
    return !!r(...f);
  } catch {
    return !1;
  }
}, C6 = (r) => {
  r = te.merge.call({
    skipUndefined: !0
  }, R6, r);
  const { fetch: f, Request: m, Response: h } = r, v = f ? Z1(f) : typeof fetch == "function", g = Z1(m), S = Z1(h);
  if (!v)
    return !1;
  const E = v && Z1(qA), O = v && (typeof VA == "function" ? /* @__PURE__ */ ((N) => (G) => N.encode(G))(new VA()) : async (N) => new Uint8Array(await new m(N).arrayBuffer())), R = g && E && YA(() => {
    let N = !1;
    const G = new m(el.origin, {
      body: new qA(),
      method: "POST",
      get duplex() {
        return N = !0, "half";
      }
    }).headers.has("Content-Type");
    return N && !G;
  }), _ = S && E && YA(() => te.isReadableStream(new h("").body)), z = {
    stream: _ && ((N) => N.body)
  };
  v && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((N) => {
    !z[N] && (z[N] = (G, Y) => {
      let F = G && G[N];
      if (F)
        return F.call(G);
      throw new $e(`Response type '${N}' is not supported`, $e.ERR_NOT_SUPPORT, Y);
    });
  });
  const L = async (N) => {
    if (N == null)
      return 0;
    if (te.isBlob(N))
      return N.size;
    if (te.isSpecCompliantForm(N))
      return (await new m(el.origin, {
        method: "POST",
        body: N
      }).arrayBuffer()).byteLength;
    if (te.isArrayBufferView(N) || te.isArrayBuffer(N))
      return N.byteLength;
    if (te.isURLSearchParams(N) && (N = N + ""), te.isString(N))
      return (await O(N)).byteLength;
  }, Q = async (N, G) => {
    const Y = te.toFiniteNumber(N.getContentLength());
    return Y ?? L(G);
  };
  return async (N) => {
    let {
      url: G,
      method: Y,
      data: F,
      signal: ne,
      cancelToken: ye,
      timeout: pe,
      onDownloadProgress: he,
      onUploadProgress: Te,
      responseType: ge,
      headers: Se,
      withCredentials: xe = "same-origin",
      fetchOptions: ae
    } = yD(N), Me = f || fetch;
    ge = ge ? (ge + "").toLowerCase() : "text";
    let Ce = T6([ne, ye && ye.toAbortSignal()], pe), we = null;
    const We = Ce && Ce.unsubscribe && (() => {
      Ce.unsubscribe();
    });
    let Rt;
    try {
      if (Te && R && Y !== "get" && Y !== "head" && (Rt = await Q(Se, F)) !== 0) {
        let ee = new m(G, {
          method: "POST",
          body: F,
          duplex: "half"
        }), ve;
        if (te.isFormData(F) && (ve = ee.headers.get("content-type")) && Se.setContentType(ve), ee.body) {
          const [De, ze] = xA(
            Rt,
            mb(HA(Te))
          );
          F = BA(ee.body, jA, De, ze);
        }
      }
      te.isString(xe) || (xe = xe ? "include" : "omit");
      const H = g && "credentials" in m.prototype, ue = {
        ...ae,
        signal: Ce,
        method: Y.toUpperCase(),
        headers: Se.normalize().toJSON(),
        body: F,
        duplex: "half",
        credentials: H ? xe : void 0
      };
      we = g && new m(G, ue);
      let fe = await (g ? Me(we, ae) : Me(G, ue));
      const be = _ && (ge === "stream" || ge === "response");
      if (_ && (he || be && We)) {
        const ee = {};
        ["status", "statusText", "headers"].forEach((At) => {
          ee[At] = fe[At];
        });
        const ve = te.toFiniteNumber(fe.headers.get("content-length")), [De, ze] = he && xA(
          ve,
          mb(HA(he), !0)
        ) || [];
        fe = new h(
          BA(fe.body, jA, De, () => {
            ze && ze(), We && We();
          }),
          ee
        );
      }
      ge = ge || "text";
      let Be = await z[te.findKey(z, ge) || "text"](fe, N);
      return !be && We && We(), await new Promise((ee, ve) => {
        mD(ee, ve, {
          data: Be,
          headers: kl.from(fe.headers),
          status: fe.status,
          statusText: fe.statusText,
          config: N,
          request: we
        });
      });
    } catch (H) {
      throw We && We(), H && H.name === "TypeError" && /Load failed|fetch/i.test(H.message) ? Object.assign(
        new $e("Network Error", $e.ERR_NETWORK, N, we, H && H.response),
        {
          cause: H.cause || H
        }
      ) : $e.from(H, H && H.code, N, we, H && H.response);
    }
  };
}, z6 = /* @__PURE__ */ new Map(), gD = (r) => {
  let f = r && r.env || {};
  const { fetch: m, Request: h, Response: v } = f, g = [
    h,
    v,
    m
  ];
  let S = g.length, E = S, O, R, _ = z6;
  for (; E--; )
    O = g[E], R = _.get(O), R === void 0 && _.set(O, R = E ? /* @__PURE__ */ new Map() : C6(f)), _ = R;
  return R;
};
gD();
const e2 = {
  http: Z4,
  xhr: E6,
  fetch: {
    get: gD
  }
};
te.forEach(e2, (r, f) => {
  if (r) {
    try {
      Object.defineProperty(r, "name", { value: f });
    } catch {
    }
    Object.defineProperty(r, "adapterName", { value: f });
  }
});
const GA = (r) => `- ${r}`, _6 = (r) => te.isFunction(r) || r === null || r === !1;
function U6(r, f) {
  r = te.isArray(r) ? r : [r];
  const { length: m } = r;
  let h, v;
  const g = {};
  for (let S = 0; S < m; S++) {
    h = r[S];
    let E;
    if (v = h, !_6(h) && (v = e2[(E = String(h)).toLowerCase()], v === void 0))
      throw new $e(`Unknown adapter '${E}'`);
    if (v && (te.isFunction(v) || (v = v.get(f))))
      break;
    g[E || "#" + S] = v;
  }
  if (!v) {
    const S = Object.entries(g).map(
      ([O, R]) => `adapter ${O} ` + (R === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let E = m ? S.length > 1 ? `since :
` + S.map(GA).join(`
`) : " " + GA(S[0]) : "as no adapter specified";
    throw new $e(
      "There is no suitable adapter to dispatch the request " + E,
      "ERR_NOT_SUPPORT"
    );
  }
  return v;
}
const vD = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: U6,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: e2
};
function uE(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new g0(null, r);
}
function XA(r) {
  return uE(r), r.headers = kl.from(r.headers), r.data = lE.call(
    r,
    r.transformRequest
  ), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), vD.getAdapter(r.adapter || y0.adapter, r)(r).then(function(h) {
    return uE(r), h.data = lE.call(
      r,
      r.transformResponse,
      h
    ), h.headers = kl.from(h.headers), h;
  }, function(h) {
    return hD(h) || (uE(r), h && h.response && (h.response.data = lE.call(
      r,
      r.transformResponse,
      h.response
    ), h.response.headers = kl.from(h.response.headers))), Promise.reject(h);
  });
}
const bD = "1.13.5", Tb = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((r, f) => {
  Tb[r] = function(h) {
    return typeof h === r || "a" + (f < 1 ? "n " : " ") + r;
  };
});
const QA = {};
Tb.transitional = function(f, m, h) {
  function v(g, S) {
    return "[Axios v" + bD + "] Transitional option '" + g + "'" + S + (h ? ". " + h : "");
  }
  return (g, S, E) => {
    if (f === !1)
      throw new $e(
        v(S, " has been removed" + (m ? " in " + m : "")),
        $e.ERR_DEPRECATED
      );
    return m && !QA[S] && (QA[S] = !0, console.warn(
      v(
        S,
        " has been deprecated since v" + m + " and will be removed in the near future"
      )
    )), f ? f(g, S, E) : !0;
  };
};
Tb.spelling = function(f) {
  return (m, h) => (console.warn(`${h} is likely a misspelling of ${f}`), !0);
};
function w6(r, f, m) {
  if (typeof r != "object")
    throw new $e("options must be an object", $e.ERR_BAD_OPTION_VALUE);
  const h = Object.keys(r);
  let v = h.length;
  for (; v-- > 0; ) {
    const g = h[v], S = f[g];
    if (S) {
      const E = r[g], O = E === void 0 || S(E, g, r);
      if (O !== !0)
        throw new $e("option " + g + " must be " + O, $e.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (m !== !0)
      throw new $e("Unknown option " + g, $e.ERR_BAD_OPTION);
  }
}
const rb = {
  assertOptions: w6,
  validators: Tb
}, gi = rb.validators;
let zd = class {
  constructor(f) {
    this.defaults = f || {}, this.interceptors = {
      request: new MA(),
      response: new MA()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(f, m) {
    try {
      return await this._request(f, m);
    } catch (h) {
      if (h instanceof Error) {
        let v = {};
        Error.captureStackTrace ? Error.captureStackTrace(v) : v = new Error();
        const g = v.stack ? v.stack.replace(/^.+\n/, "") : "";
        try {
          h.stack ? g && !String(h.stack).endsWith(g.replace(/^.+\n.+\n/, "")) && (h.stack += `
` + g) : h.stack = g;
        } catch {
        }
      }
      throw h;
    }
  }
  _request(f, m) {
    typeof f == "string" ? (m = m || {}, m.url = f) : m = f || {}, m = _d(this.defaults, m);
    const { transitional: h, paramsSerializer: v, headers: g } = m;
    h !== void 0 && rb.assertOptions(h, {
      silentJSONParsing: gi.transitional(gi.boolean),
      forcedJSONParsing: gi.transitional(gi.boolean),
      clarifyTimeoutError: gi.transitional(gi.boolean),
      legacyInterceptorReqResOrdering: gi.transitional(gi.boolean)
    }, !1), v != null && (te.isFunction(v) ? m.paramsSerializer = {
      serialize: v
    } : rb.assertOptions(v, {
      encode: gi.function,
      serialize: gi.function
    }, !0)), m.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? m.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : m.allowAbsoluteUrls = !0), rb.assertOptions(m, {
      baseUrl: gi.spelling("baseURL"),
      withXsrfToken: gi.spelling("withXSRFToken")
    }, !0), m.method = (m.method || this.defaults.method || "get").toLowerCase();
    let S = g && te.merge(
      g.common,
      g[m.method]
    );
    g && te.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (N) => {
        delete g[N];
      }
    ), m.headers = kl.concat(S, g);
    const E = [];
    let O = !0;
    this.interceptors.request.forEach(function(G) {
      if (typeof G.runWhen == "function" && G.runWhen(m) === !1)
        return;
      O = O && G.synchronous;
      const Y = m.transitional || IE;
      Y && Y.legacyInterceptorReqResOrdering ? E.unshift(G.fulfilled, G.rejected) : E.push(G.fulfilled, G.rejected);
    });
    const R = [];
    this.interceptors.response.forEach(function(G) {
      R.push(G.fulfilled, G.rejected);
    });
    let _, z = 0, L;
    if (!O) {
      const N = [XA.bind(this), void 0];
      for (N.unshift(...E), N.push(...R), L = N.length, _ = Promise.resolve(m); z < L; )
        _ = _.then(N[z++], N[z++]);
      return _;
    }
    L = E.length;
    let Q = m;
    for (; z < L; ) {
      const N = E[z++], G = E[z++];
      try {
        Q = N(Q);
      } catch (Y) {
        G.call(this, Y);
        break;
      }
    }
    try {
      _ = XA.call(this, Q);
    } catch (N) {
      return Promise.reject(N);
    }
    for (z = 0, L = R.length; z < L; )
      _ = _.then(R[z++], R[z++]);
    return _;
  }
  getUri(f) {
    f = _d(this.defaults, f);
    const m = pD(f.baseURL, f.url, f.allowAbsoluteUrls);
    return fD(m, f.params, f.paramsSerializer);
  }
};
te.forEach(["delete", "get", "head", "options"], function(f) {
  zd.prototype[f] = function(m, h) {
    return this.request(_d(h || {}, {
      method: f,
      url: m,
      data: (h || {}).data
    }));
  };
});
te.forEach(["post", "put", "patch"], function(f) {
  function m(h) {
    return function(g, S, E) {
      return this.request(_d(E || {}, {
        method: f,
        headers: h ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: g,
        data: S
      }));
    };
  }
  zd.prototype[f] = m(), zd.prototype[f + "Form"] = m(!0);
});
let M6 = class SD {
  constructor(f) {
    if (typeof f != "function")
      throw new TypeError("executor must be a function.");
    let m;
    this.promise = new Promise(function(g) {
      m = g;
    });
    const h = this;
    this.promise.then((v) => {
      if (!h._listeners) return;
      let g = h._listeners.length;
      for (; g-- > 0; )
        h._listeners[g](v);
      h._listeners = null;
    }), this.promise.then = (v) => {
      let g;
      const S = new Promise((E) => {
        h.subscribe(E), g = E;
      }).then(v);
      return S.cancel = function() {
        h.unsubscribe(g);
      }, S;
    }, f(function(g, S, E) {
      h.reason || (h.reason = new g0(g, S, E), m(h.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(f) {
    if (this.reason) {
      f(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(f) : this._listeners = [f];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(f) {
    if (!this._listeners)
      return;
    const m = this._listeners.indexOf(f);
    m !== -1 && this._listeners.splice(m, 1);
  }
  toAbortSignal() {
    const f = new AbortController(), m = (h) => {
      f.abort(h);
    };
    return this.subscribe(m), f.signal.unsubscribe = () => this.unsubscribe(m), f.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let f;
    return {
      token: new SD(function(v) {
        f = v;
      }),
      cancel: f
    };
  }
};
function N6(r) {
  return function(m) {
    return r.apply(null, m);
  };
}
function x6(r) {
  return te.isObject(r) && r.isAxiosError === !0;
}
const VE = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(VE).forEach(([r, f]) => {
  VE[f] = r;
});
function ED(r) {
  const f = new zd(r), m = eD(zd.prototype.request, f);
  return te.extend(m, zd.prototype, f, { allOwnKeys: !0 }), te.extend(m, f, null, { allOwnKeys: !0 }), m.create = function(v) {
    return ED(_d(r, v));
  }, m;
}
const Vn = ED(y0);
Vn.Axios = zd;
Vn.CanceledError = g0;
Vn.CancelToken = M6;
Vn.isCancel = hD;
Vn.VERSION = bD;
Vn.toFormData = Eb;
Vn.AxiosError = $e;
Vn.Cancel = Vn.CanceledError;
Vn.all = function(f) {
  return Promise.all(f);
};
Vn.spread = N6;
Vn.isAxiosError = x6;
Vn.mergeConfig = _d;
Vn.AxiosHeaders = kl;
Vn.formToJSON = (r) => dD(te.isHTMLForm(r) ? new FormData(r) : r);
Vn.getAdapter = vD.getAdapter;
Vn.HttpStatusCode = VE;
Vn.default = Vn;
const {
  Axios: o5,
  AxiosError: c5,
  CanceledError: r5,
  isCancel: s5,
  CancelToken: f5,
  VERSION: d5,
  all: h5,
  Cancel: m5,
  isAxiosError: p5,
  spread: y5,
  toFormData: g5,
  AxiosHeaders: v5,
  HttpStatusCode: b5,
  formToJSON: S5,
  getAdapter: E5,
  mergeConfig: T5
} = Vn;
function A5({
  baseURL: r,
  withCredentials: f = !0,
  headers: m = {},
  axiosConfig: h = {}
}) {
  return Vn.create({
    baseURL: r,
    withCredentials: f,
    headers: {
      "Content-Type": "application/json",
      ...m
    },
    ...h
  });
}
function O5(r, f = "local") {
  const m = window.environment || f;
  return r[m];
}
function H6(r) {
  return `dealers/D${r}`;
}
async function D5(r, f, m, h) {
  return m === "get" ? hb(f) : r[m](f, h);
}
var J1 = { exports: {} }, t0 = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZA;
function L6() {
  if (ZA) return t0;
  ZA = 1;
  var r = Symbol.for("react.transitional.element"), f = Symbol.for("react.fragment");
  function m(h, v, g) {
    var S = null;
    if (g !== void 0 && (S = "" + g), v.key !== void 0 && (S = "" + v.key), "key" in v) {
      g = {};
      for (var E in v)
        E !== "key" && (g[E] = v[E]);
    } else g = v;
    return v = g.ref, {
      $$typeof: r,
      type: h,
      key: S,
      ref: v !== void 0 ? v : null,
      props: g
    };
  }
  return t0.Fragment = f, t0.jsx = m, t0.jsxs = m, t0;
}
var n0 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JA;
function B6() {
  return JA || (JA = 1, process.env.NODE_ENV !== "production" && (function() {
    function r(ee) {
      if (ee == null) return null;
      if (typeof ee == "function")
        return ee.$$typeof === Me ? null : ee.displayName || ee.name || null;
      if (typeof ee == "string") return ee;
      switch (ee) {
        case Y:
          return "Fragment";
        case ne:
          return "Profiler";
        case F:
          return "StrictMode";
        case Te:
          return "Suspense";
        case ge:
          return "SuspenseList";
        case ae:
          return "Activity";
      }
      if (typeof ee == "object")
        switch (typeof ee.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), ee.$$typeof) {
          case G:
            return "Portal";
          case pe:
            return ee.displayName || "Context";
          case ye:
            return (ee._context.displayName || "Context") + ".Consumer";
          case he:
            var ve = ee.render;
            return ee = ee.displayName, ee || (ee = ve.displayName || ve.name || "", ee = ee !== "" ? "ForwardRef(" + ee + ")" : "ForwardRef"), ee;
          case Se:
            return ve = ee.displayName || null, ve !== null ? ve : r(ee.type) || "Memo";
          case xe:
            ve = ee._payload, ee = ee._init;
            try {
              return r(ee(ve));
            } catch {
            }
        }
      return null;
    }
    function f(ee) {
      return "" + ee;
    }
    function m(ee) {
      try {
        f(ee);
        var ve = !1;
      } catch {
        ve = !0;
      }
      if (ve) {
        ve = console;
        var De = ve.error, ze = typeof Symbol == "function" && Symbol.toStringTag && ee[Symbol.toStringTag] || ee.constructor.name || "Object";
        return De.call(
          ve,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          ze
        ), f(ee);
      }
    }
    function h(ee) {
      if (ee === Y) return "<>";
      if (typeof ee == "object" && ee !== null && ee.$$typeof === xe)
        return "<...>";
      try {
        var ve = r(ee);
        return ve ? "<" + ve + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function v() {
      var ee = Ce.A;
      return ee === null ? null : ee.getOwner();
    }
    function g() {
      return Error("react-stack-top-frame");
    }
    function S(ee) {
      if (we.call(ee, "key")) {
        var ve = Object.getOwnPropertyDescriptor(ee, "key").get;
        if (ve && ve.isReactWarning) return !1;
      }
      return ee.key !== void 0;
    }
    function E(ee, ve) {
      function De() {
        H || (H = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          ve
        ));
      }
      De.isReactWarning = !0, Object.defineProperty(ee, "key", {
        get: De,
        configurable: !0
      });
    }
    function O() {
      var ee = r(this.type);
      return ue[ee] || (ue[ee] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), ee = this.props.ref, ee !== void 0 ? ee : null;
    }
    function R(ee, ve, De, ze, At, Rn) {
      var ft = De.ref;
      return ee = {
        $$typeof: N,
        type: ee,
        key: ve,
        props: De,
        _owner: ze
      }, (ft !== void 0 ? ft : null) !== null ? Object.defineProperty(ee, "ref", {
        enumerable: !1,
        get: O
      }) : Object.defineProperty(ee, "ref", { enumerable: !1, value: null }), ee._store = {}, Object.defineProperty(ee._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(ee, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(ee, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: At
      }), Object.defineProperty(ee, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Rn
      }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
    }
    function _(ee, ve, De, ze, At, Rn) {
      var ft = ve.children;
      if (ft !== void 0)
        if (ze)
          if (We(ft)) {
            for (ze = 0; ze < ft.length; ze++)
              z(ft[ze]);
            Object.freeze && Object.freeze(ft);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else z(ft);
      if (we.call(ve, "key")) {
        ft = r(ee);
        var en = Object.keys(ve).filter(function(zl) {
          return zl !== "key";
        });
        ze = 0 < en.length ? "{key: someKey, " + en.join(": ..., ") + ": ...}" : "{key: someKey}", Be[ft + ze] || (en = 0 < en.length ? "{" + en.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          ze,
          ft,
          en,
          ft
        ), Be[ft + ze] = !0);
      }
      if (ft = null, De !== void 0 && (m(De), ft = "" + De), S(ve) && (m(ve.key), ft = "" + ve.key), "key" in ve) {
        De = {};
        for (var Mn in ve)
          Mn !== "key" && (De[Mn] = ve[Mn]);
      } else De = ve;
      return ft && E(
        De,
        typeof ee == "function" ? ee.displayName || ee.name || "Unknown" : ee
      ), R(
        ee,
        ft,
        De,
        v(),
        At,
        Rn
      );
    }
    function z(ee) {
      L(ee) ? ee._store && (ee._store.validated = 1) : typeof ee == "object" && ee !== null && ee.$$typeof === xe && (ee._payload.status === "fulfilled" ? L(ee._payload.value) && ee._payload.value._store && (ee._payload.value._store.validated = 1) : ee._store && (ee._store.validated = 1));
    }
    function L(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === N;
    }
    var Q = ar, N = Symbol.for("react.transitional.element"), G = Symbol.for("react.portal"), Y = Symbol.for("react.fragment"), F = Symbol.for("react.strict_mode"), ne = Symbol.for("react.profiler"), ye = Symbol.for("react.consumer"), pe = Symbol.for("react.context"), he = Symbol.for("react.forward_ref"), Te = Symbol.for("react.suspense"), ge = Symbol.for("react.suspense_list"), Se = Symbol.for("react.memo"), xe = Symbol.for("react.lazy"), ae = Symbol.for("react.activity"), Me = Symbol.for("react.client.reference"), Ce = Q.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, we = Object.prototype.hasOwnProperty, We = Array.isArray, Rt = console.createTask ? console.createTask : function() {
      return null;
    };
    Q = {
      react_stack_bottom_frame: function(ee) {
        return ee();
      }
    };
    var H, ue = {}, fe = Q.react_stack_bottom_frame.bind(
      Q,
      g
    )(), be = Rt(h(g)), Be = {};
    n0.Fragment = Y, n0.jsx = function(ee, ve, De) {
      var ze = 1e4 > Ce.recentlyCreatedOwnerStacks++;
      return _(
        ee,
        ve,
        De,
        !1,
        ze ? Error("react-stack-top-frame") : fe,
        ze ? Rt(h(ee)) : be
      );
    }, n0.jsxs = function(ee, ve, De) {
      var ze = 1e4 > Ce.recentlyCreatedOwnerStacks++;
      return _(
        ee,
        ve,
        De,
        !0,
        ze ? Error("react-stack-top-frame") : fe,
        ze ? Rt(h(ee)) : be
      );
    };
  })()), n0;
}
var KA;
function j6() {
  return KA || (KA = 1, process.env.NODE_ENV === "production" ? J1.exports = L6() : J1.exports = B6()), J1.exports;
}
var YE = j6();
function R5({
  children: r,
  axiosInstance: f,
  shouldRetryOnError: m = !1,
  errorRetryCount: h = 0,
  revalidateOnFocus: v = !1,
  ...g
}) {
  const S = async (E) => (await f.get(E)).data;
  return /* @__PURE__ */ YE.jsx(
    u4,
    {
      value: {
        fetcher: S,
        shouldRetryOnError: m,
        errorRetryCount: h,
        revalidateOnFocus: v,
        ...g
      },
      children: r
    }
  );
}
const q6 = (r) => `/api/dms/v1/${H6(r)}`, V6 = "Dealer details";
function C5(r) {
  return LE(
    !!r ? [q6(r), V6] : void 0,
    hb
  );
}
const Y6 = "/steps/rest/user?role=true", G6 = "/api/dms/v1/users/{userName}", X6 = "User details", Q6 = "Car lot information";
function TD({
  carLots: r = !1,
  dealerInfo: f = !1,
  enabled: m = !0
} = {}) {
  const h = f === !0 ? "&dealerInfo=true" : "";
  Z6();
  let v, g;
  try {
    v = ZE(Y6 + h);
  } catch (ye) {
    g = `${ye}`;
  }
  const {
    data: S,
    error: E,
    isLoading: O,
    mutate: R
  } = LE(
    m ? [v, X6] : void 0,
    hb,
    {
      revalidateOnFocus: !1
      // Do not revalidate on re-focus of the window tab
    }
  ), _ = r && S?.userName ? G6.replace("{userName}", S.userName) : void 0, {
    data: z,
    isLoading: L,
    error: Q,
    mutate: N
  } = LE(
    _ ? [_, Q6] : void 0,
    hb,
    {
      revalidateOnFocus: !1
    }
  ), G = tp(() => r ? S && (Q || z) ? z ? { ...S, ...z } : S : void 0 : S, [S, z, r, Q]), Y = g ?? E ?? Q ? `${g ?? E ?? Q}` : void 0;
  return {
    user: G,
    isLoading: Y ? !1 : O || r && L || !1,
    error: Y,
    mutate: async () => {
      const ye = await R();
      if (r && ye?.userName) {
        const pe = await N();
        return pe ? { ...ye, ...pe } : ye;
      }
      return ye;
    }
  };
}
function Z6() {
  if (window.environment !== "test")
    return;
  const r = document.referrer;
  if (!r)
    return;
  const m = new URL(r, window.location.origin).hostname.split(".")?.[0];
  if (m.startsWith("capstst")) {
    const h = m.at(-1);
    Number.isNaN(Number(h)) || sessionStorage.setItem(CE, `Test${h}`);
  }
}
function kA(r) {
  return "dealerId" in r;
}
function J6(r) {
  return "kind" in r;
}
function $A(r) {
  return {
    kind: "user",
    key: `D${r.dealerId}`
  };
}
function GE(...r) {
  if (r.length === 1) {
    const m = r[0];
    return kA(m) ? $A(m) : m;
  }
  const f = {
    kind: "multi"
  };
  for (const m of r)
    kA(m) ? f.user = $A(m) : J6(m) && (m.kind === "multi" ? Object.assign(f, m) : f[m.kind] = m);
  return f;
}
function qs(r) {
  function f(m, h) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = m, this.code = h;
  }
  return f.prototype = new Error(), f.prototype.name = r, f.prototype.constructor = f, f;
}
const K6 = qs("LaunchDarklyUnexpectedResponseError"), k6 = qs("LaunchDarklyInvalidEnvironmentIdError"), $6 = qs("LaunchDarklyInvalidUserError"), F6 = qs("LaunchDarklyInvalidEventKeyError"), W6 = qs("LaunchDarklyInvalidArgumentError"), I6 = qs("LaunchDarklyFlagFetchError");
for (var wn = { LDUnexpectedResponseError: K6, LDInvalidEnvironmentIdError: k6, LDInvalidUserError: $6, LDInvalidEventKeyError: F6, LDInvalidArgumentError: W6, LDInvalidDataError: qs("LaunchDarklyInvalidDataError"), LDFlagFetchError: I6, LDTimeoutError: qs("LaunchDarklyTimeoutError"), isHttpErrorRecoverable: function(r) {
  return !(r >= 400 && r < 500) || r === 400 || r === 408 || r === 429;
} }, P6 = function(r) {
  var f = WA(r), m = f[0], h = f[1];
  return 3 * (m + h) / 4 - h;
}, eC = function(r) {
  var f, m, h = WA(r), v = h[0], g = h[1], S = new nC((function(R, _, z) {
    return 3 * (_ + z) / 4 - z;
  })(0, v, g)), E = 0, O = g > 0 ? v - 4 : v;
  for (m = 0; m < O; m += 4) f = vi[r.charCodeAt(m)] << 18 | vi[r.charCodeAt(m + 1)] << 12 | vi[r.charCodeAt(m + 2)] << 6 | vi[r.charCodeAt(m + 3)], S[E++] = f >> 16 & 255, S[E++] = f >> 8 & 255, S[E++] = 255 & f;
  return g === 2 && (f = vi[r.charCodeAt(m)] << 2 | vi[r.charCodeAt(m + 1)] >> 4, S[E++] = 255 & f), g === 1 && (f = vi[r.charCodeAt(m)] << 10 | vi[r.charCodeAt(m + 1)] << 4 | vi[r.charCodeAt(m + 2)] >> 2, S[E++] = f >> 8 & 255, S[E++] = 255 & f), S;
}, tC = function(r) {
  for (var f, m = r.length, h = m % 3, v = [], g = 16383, S = 0, E = m - h; S < E; S += g) v.push(lC(r, S, S + g > E ? E : S + g));
  return h === 1 ? (f = r[m - 1], v.push(Go[f >> 2] + Go[f << 4 & 63] + "==")) : h === 2 && (f = (r[m - 2] << 8) + r[m - 1], v.push(Go[f >> 10] + Go[f >> 4 & 63] + Go[f << 2 & 63] + "=")), v.join("");
}, Go = [], vi = [], nC = typeof Uint8Array < "u" ? Uint8Array : Array, FA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Wm = 0; Wm < 64; ++Wm) Go[Wm] = FA[Wm], vi[FA.charCodeAt(Wm)] = Wm;
function WA(r) {
  var f = r.length;
  if (f % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var m = r.indexOf("=");
  return m === -1 && (m = f), [m, m === f ? 0 : 4 - m % 4];
}
function aC(r) {
  return Go[r >> 18 & 63] + Go[r >> 12 & 63] + Go[r >> 6 & 63] + Go[63 & r];
}
function lC(r, f, m) {
  for (var h, v = [], g = f; g < m; g += 3) h = (r[g] << 16 & 16711680) + (r[g + 1] << 8 & 65280) + (255 & r[g + 2]), v.push(aC(h));
  return v.join("");
}
vi[45] = 62, vi[95] = 63;
var uC = { byteLength: P6, toByteArray: eC, fromByteArray: tC }, IA = Array.isArray, PA = Object.keys, iC = Object.prototype.hasOwnProperty, oC = function r(f, m) {
  if (f === m) return !0;
  if (f && m && typeof f == "object" && typeof m == "object") {
    var h, v, g, S = IA(f), E = IA(m);
    if (S && E) {
      if ((v = f.length) != m.length) return !1;
      for (h = v; h-- !== 0; ) if (!r(f[h], m[h])) return !1;
      return !0;
    }
    if (S != E) return !1;
    var O = f instanceof Date, R = m instanceof Date;
    if (O != R) return !1;
    if (O && R) return f.getTime() == m.getTime();
    var _ = f instanceof RegExp, z = m instanceof RegExp;
    if (_ != z) return !1;
    if (_ && z) return f.toString() == m.toString();
    var L = PA(f);
    if ((v = L.length) !== PA(m).length) return !1;
    for (h = v; h-- !== 0; ) if (!iC.call(m, L[h])) return !1;
    for (h = v; h-- !== 0; ) if (!r(f[g = L[h]], m[g])) return !1;
    return !0;
  }
  return f != f && m != m;
};
const cC = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function eO(r) {
  const f = unescape(encodeURIComponent(r));
  return uC.fromByteArray((function(m) {
    const h = [];
    for (let v = 0; v < m.length; v++) h.push(m.charCodeAt(v));
    return h;
  })(f));
}
function iE(r, f) {
  return Object.prototype.hasOwnProperty.call(r, f);
}
var oE, tt = { appendUrlPath: function(r, f) {
  return (r.endsWith("/") ? r.substring(0, r.length - 1) : r) + (f.startsWith("/") ? "" : "/") + f;
}, base64URLEncode: function(r) {
  return eO(r).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, btoa: eO, clone: function(r) {
  return JSON.parse(JSON.stringify(r));
}, deepEquals: function(r, f) {
  return oC(r, f);
}, extend: function(...r) {
  return r.reduce((f, m) => ({ ...f, ...m }), {});
}, getLDUserAgentString: function(r) {
  const f = r.version || "?";
  return r.userAgent + "/" + f;
}, objectHasOwnProperty: iE, onNextTick: function(r) {
  setTimeout(r, 0);
}, sanitizeContext: function(r) {
  if (!r) return r;
  let f;
  return r.kind !== null && r.kind !== void 0 || cC.forEach((m) => {
    const h = r[m];
    h !== void 0 && typeof h != "string" && (f = f || { ...r }, f[m] = String(h));
  }), f || r;
}, transformValuesToVersionedValues: function(r) {
  const f = {};
  for (const m in r) iE(r, m) && (f[m] = { value: r[m], version: 0 });
  return f;
}, transformVersionedValuesToValues: function(r) {
  const f = {};
  for (const m in r) iE(r, m) && (f[m] = r[m].value);
  return f;
}, wrapPromiseCallback: function(r, f) {
  const m = r.then((h) => (f && setTimeout(() => {
    f(null, h);
  }, 0), h), (h) => {
    if (!f) return Promise.reject(h);
    setTimeout(() => {
      f(h, null);
    }, 0);
  });
  return f ? void 0 : m;
}, once: function(r) {
  let f, m = !1;
  return function(...h) {
    return m || (m = !0, f = r.apply(this, h)), f;
  };
} }, rC = new Uint8Array(16);
function tO() {
  if (!oE && !(oE = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return oE(rC);
}
var sC = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function pb(r) {
  return typeof r == "string" && sC.test(r);
}
for (var nO, cE, Ba = [], rE = 0; rE < 256; ++rE) Ba.push((rE + 256).toString(16).substr(1));
function sb(r) {
  var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, m = (Ba[r[f + 0]] + Ba[r[f + 1]] + Ba[r[f + 2]] + Ba[r[f + 3]] + "-" + Ba[r[f + 4]] + Ba[r[f + 5]] + "-" + Ba[r[f + 6]] + Ba[r[f + 7]] + "-" + Ba[r[f + 8]] + Ba[r[f + 9]] + "-" + Ba[r[f + 10]] + Ba[r[f + 11]] + Ba[r[f + 12]] + Ba[r[f + 13]] + Ba[r[f + 14]] + Ba[r[f + 15]]).toLowerCase();
  if (!pb(m)) throw TypeError("Stringified UUID is invalid");
  return m;
}
var sE = 0, fE = 0;
function AD(r) {
  if (!pb(r)) throw TypeError("Invalid UUID");
  var f, m = new Uint8Array(16);
  return m[0] = (f = parseInt(r.slice(0, 8), 16)) >>> 24, m[1] = f >>> 16 & 255, m[2] = f >>> 8 & 255, m[3] = 255 & f, m[4] = (f = parseInt(r.slice(9, 13), 16)) >>> 8, m[5] = 255 & f, m[6] = (f = parseInt(r.slice(14, 18), 16)) >>> 8, m[7] = 255 & f, m[8] = (f = parseInt(r.slice(19, 23), 16)) >>> 8, m[9] = 255 & f, m[10] = (f = parseInt(r.slice(24, 36), 16)) / 1099511627776 & 255, m[11] = f / 4294967296 & 255, m[12] = f >>> 24 & 255, m[13] = f >>> 16 & 255, m[14] = f >>> 8 & 255, m[15] = 255 & f, m;
}
function OD(r, f, m) {
  function h(v, g, S, E) {
    if (typeof v == "string" && (v = (function(_) {
      _ = unescape(encodeURIComponent(_));
      for (var z = [], L = 0; L < _.length; ++L) z.push(_.charCodeAt(L));
      return z;
    })(v)), typeof g == "string" && (g = AD(g)), g.length !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var O = new Uint8Array(16 + v.length);
    if (O.set(g), O.set(v, g.length), (O = m(O))[6] = 15 & O[6] | f, O[8] = 63 & O[8] | 128, S) {
      E = E || 0;
      for (var R = 0; R < 16; ++R) S[E + R] = O[R];
      return S;
    }
    return sb(O);
  }
  try {
    h.name = r;
  } catch {
  }
  return h.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", h.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", h;
}
function aO(r) {
  return 14 + (r + 64 >>> 9 << 4) + 1;
}
function js(r, f) {
  var m = (65535 & r) + (65535 & f);
  return (r >> 16) + (f >> 16) + (m >> 16) << 16 | 65535 & m;
}
function Ab(r, f, m, h, v, g) {
  return js((S = js(js(f, r), js(h, g))) << (E = v) | S >>> 32 - E, m);
  var S, E;
}
function Fa(r, f, m, h, v, g, S) {
  return Ab(f & m | ~f & h, r, f, v, g, S);
}
function Wa(r, f, m, h, v, g, S) {
  return Ab(f & h | m & ~h, r, f, v, g, S);
}
function Ia(r, f, m, h, v, g, S) {
  return Ab(f ^ m ^ h, r, f, v, g, S);
}
function Pa(r, f, m, h, v, g, S) {
  return Ab(m ^ (f | ~h), r, f, v, g, S);
}
var fC = OD("v3", 48, function(r) {
  if (typeof r == "string") {
    var f = unescape(encodeURIComponent(r));
    r = new Uint8Array(f.length);
    for (var m = 0; m < f.length; ++m) r[m] = f.charCodeAt(m);
  }
  return (function(h) {
    for (var v = [], g = 32 * h.length, S = "0123456789abcdef", E = 0; E < g; E += 8) {
      var O = h[E >> 5] >>> E % 32 & 255, R = parseInt(S.charAt(O >>> 4 & 15) + S.charAt(15 & O), 16);
      v.push(R);
    }
    return v;
  })((function(h, v) {
    h[v >> 5] |= 128 << v % 32, h[aO(v) - 1] = v;
    for (var g = 1732584193, S = -271733879, E = -1732584194, O = 271733878, R = 0; R < h.length; R += 16) {
      var _ = g, z = S, L = E, Q = O;
      g = Fa(g, S, E, O, h[R], 7, -680876936), O = Fa(O, g, S, E, h[R + 1], 12, -389564586), E = Fa(E, O, g, S, h[R + 2], 17, 606105819), S = Fa(S, E, O, g, h[R + 3], 22, -1044525330), g = Fa(g, S, E, O, h[R + 4], 7, -176418897), O = Fa(O, g, S, E, h[R + 5], 12, 1200080426), E = Fa(E, O, g, S, h[R + 6], 17, -1473231341), S = Fa(S, E, O, g, h[R + 7], 22, -45705983), g = Fa(g, S, E, O, h[R + 8], 7, 1770035416), O = Fa(O, g, S, E, h[R + 9], 12, -1958414417), E = Fa(E, O, g, S, h[R + 10], 17, -42063), S = Fa(S, E, O, g, h[R + 11], 22, -1990404162), g = Fa(g, S, E, O, h[R + 12], 7, 1804603682), O = Fa(O, g, S, E, h[R + 13], 12, -40341101), E = Fa(E, O, g, S, h[R + 14], 17, -1502002290), g = Wa(g, S = Fa(S, E, O, g, h[R + 15], 22, 1236535329), E, O, h[R + 1], 5, -165796510), O = Wa(O, g, S, E, h[R + 6], 9, -1069501632), E = Wa(E, O, g, S, h[R + 11], 14, 643717713), S = Wa(S, E, O, g, h[R], 20, -373897302), g = Wa(g, S, E, O, h[R + 5], 5, -701558691), O = Wa(O, g, S, E, h[R + 10], 9, 38016083), E = Wa(E, O, g, S, h[R + 15], 14, -660478335), S = Wa(S, E, O, g, h[R + 4], 20, -405537848), g = Wa(g, S, E, O, h[R + 9], 5, 568446438), O = Wa(O, g, S, E, h[R + 14], 9, -1019803690), E = Wa(E, O, g, S, h[R + 3], 14, -187363961), S = Wa(S, E, O, g, h[R + 8], 20, 1163531501), g = Wa(g, S, E, O, h[R + 13], 5, -1444681467), O = Wa(O, g, S, E, h[R + 2], 9, -51403784), E = Wa(E, O, g, S, h[R + 7], 14, 1735328473), g = Ia(g, S = Wa(S, E, O, g, h[R + 12], 20, -1926607734), E, O, h[R + 5], 4, -378558), O = Ia(O, g, S, E, h[R + 8], 11, -2022574463), E = Ia(E, O, g, S, h[R + 11], 16, 1839030562), S = Ia(S, E, O, g, h[R + 14], 23, -35309556), g = Ia(g, S, E, O, h[R + 1], 4, -1530992060), O = Ia(O, g, S, E, h[R + 4], 11, 1272893353), E = Ia(E, O, g, S, h[R + 7], 16, -155497632), S = Ia(S, E, O, g, h[R + 10], 23, -1094730640), g = Ia(g, S, E, O, h[R + 13], 4, 681279174), O = Ia(O, g, S, E, h[R], 11, -358537222), E = Ia(E, O, g, S, h[R + 3], 16, -722521979), S = Ia(S, E, O, g, h[R + 6], 23, 76029189), g = Ia(g, S, E, O, h[R + 9], 4, -640364487), O = Ia(O, g, S, E, h[R + 12], 11, -421815835), E = Ia(E, O, g, S, h[R + 15], 16, 530742520), g = Pa(g, S = Ia(S, E, O, g, h[R + 2], 23, -995338651), E, O, h[R], 6, -198630844), O = Pa(O, g, S, E, h[R + 7], 10, 1126891415), E = Pa(E, O, g, S, h[R + 14], 15, -1416354905), S = Pa(S, E, O, g, h[R + 5], 21, -57434055), g = Pa(g, S, E, O, h[R + 12], 6, 1700485571), O = Pa(O, g, S, E, h[R + 3], 10, -1894986606), E = Pa(E, O, g, S, h[R + 10], 15, -1051523), S = Pa(S, E, O, g, h[R + 1], 21, -2054922799), g = Pa(g, S, E, O, h[R + 8], 6, 1873313359), O = Pa(O, g, S, E, h[R + 15], 10, -30611744), E = Pa(E, O, g, S, h[R + 6], 15, -1560198380), S = Pa(S, E, O, g, h[R + 13], 21, 1309151649), g = Pa(g, S, E, O, h[R + 4], 6, -145523070), O = Pa(O, g, S, E, h[R + 11], 10, -1120210379), E = Pa(E, O, g, S, h[R + 2], 15, 718787259), S = Pa(S, E, O, g, h[R + 9], 21, -343485551), g = js(g, _), S = js(S, z), E = js(E, L), O = js(O, Q);
    }
    return [g, S, E, O];
  })((function(h) {
    if (h.length === 0) return [];
    for (var v = 8 * h.length, g = new Uint32Array(aO(v)), S = 0; S < v; S += 8) g[S >> 5] |= (255 & h[S / 8]) << S % 32;
    return g;
  })(r), 8 * r.length));
}), dC = fC;
function hC(r, f, m, h) {
  switch (r) {
    case 0:
      return f & m ^ ~f & h;
    case 1:
    case 3:
      return f ^ m ^ h;
    case 2:
      return f & m ^ f & h ^ m & h;
  }
}
function dE(r, f) {
  return r << f | r >>> 32 - f;
}
var mC = OD("v5", 80, function(r) {
  var f = [1518500249, 1859775393, 2400959708, 3395469782], m = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof r == "string") {
    var h = unescape(encodeURIComponent(r));
    r = [];
    for (var v = 0; v < h.length; ++v) r.push(h.charCodeAt(v));
  } else Array.isArray(r) || (r = Array.prototype.slice.call(r));
  r.push(128);
  for (var g = r.length / 4 + 2, S = Math.ceil(g / 16), E = new Array(S), O = 0; O < S; ++O) {
    for (var R = new Uint32Array(16), _ = 0; _ < 16; ++_) R[_] = r[64 * O + 4 * _] << 24 | r[64 * O + 4 * _ + 1] << 16 | r[64 * O + 4 * _ + 2] << 8 | r[64 * O + 4 * _ + 3];
    E[O] = R;
  }
  E[S - 1][14] = 8 * (r.length - 1) / Math.pow(2, 32), E[S - 1][14] = Math.floor(E[S - 1][14]), E[S - 1][15] = 8 * (r.length - 1) & 4294967295;
  for (var z = 0; z < S; ++z) {
    for (var L = new Uint32Array(80), Q = 0; Q < 16; ++Q) L[Q] = E[z][Q];
    for (var N = 16; N < 80; ++N) L[N] = dE(L[N - 3] ^ L[N - 8] ^ L[N - 14] ^ L[N - 16], 1);
    for (var G = m[0], Y = m[1], F = m[2], ne = m[3], ye = m[4], pe = 0; pe < 80; ++pe) {
      var he = Math.floor(pe / 20), Te = dE(G, 5) + hC(he, Y, F, ne) + ye + f[he] + L[pe] >>> 0;
      ye = ne, ne = F, F = dE(Y, 30) >>> 0, Y = G, G = Te;
    }
    m[0] = m[0] + G >>> 0, m[1] = m[1] + Y >>> 0, m[2] = m[2] + F >>> 0, m[3] = m[3] + ne >>> 0, m[4] = m[4] + ye >>> 0;
  }
  return [m[0] >> 24 & 255, m[0] >> 16 & 255, m[0] >> 8 & 255, 255 & m[0], m[1] >> 24 & 255, m[1] >> 16 & 255, m[1] >> 8 & 255, 255 & m[1], m[2] >> 24 & 255, m[2] >> 16 & 255, m[2] >> 8 & 255, 255 & m[2], m[3] >> 24 & 255, m[3] >> 16 & 255, m[3] >> 8 & 255, 255 & m[3], m[4] >> 24 & 255, m[4] >> 16 & 255, m[4] >> 8 & 255, 255 & m[4]];
}), pC = mC, t2 = Object.freeze({ __proto__: null, v1: function(r, f, m) {
  var h = f && m || 0, v = f || new Array(16), g = (r = r || {}).node || nO, S = r.clockseq !== void 0 ? r.clockseq : cE;
  if (g == null || S == null) {
    var E = r.random || (r.rng || tO)();
    g == null && (g = nO = [1 | E[0], E[1], E[2], E[3], E[4], E[5]]), S == null && (S = cE = 16383 & (E[6] << 8 | E[7]));
  }
  var O = r.msecs !== void 0 ? r.msecs : Date.now(), R = r.nsecs !== void 0 ? r.nsecs : fE + 1, _ = O - sE + (R - fE) / 1e4;
  if (_ < 0 && r.clockseq === void 0 && (S = S + 1 & 16383), (_ < 0 || O > sE) && r.nsecs === void 0 && (R = 0), R >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  sE = O, fE = R, cE = S;
  var z = (1e4 * (268435455 & (O += 122192928e5)) + R) % 4294967296;
  v[h++] = z >>> 24 & 255, v[h++] = z >>> 16 & 255, v[h++] = z >>> 8 & 255, v[h++] = 255 & z;
  var L = O / 4294967296 * 1e4 & 268435455;
  v[h++] = L >>> 8 & 255, v[h++] = 255 & L, v[h++] = L >>> 24 & 15 | 16, v[h++] = L >>> 16 & 255, v[h++] = S >>> 8 | 128, v[h++] = 255 & S;
  for (var Q = 0; Q < 6; ++Q) v[h + Q] = g[Q];
  return f || sb(v);
}, v3: dC, v4: function(r, f, m) {
  var h = (r = r || {}).random || (r.rng || tO)();
  if (h[6] = 15 & h[6] | 64, h[8] = 63 & h[8] | 128, f) {
    m = m || 0;
    for (var v = 0; v < 16; ++v) f[m + v] = h[v];
    return f;
  }
  return sb(h);
}, v5: pC, NIL: "00000000-0000-0000-0000-000000000000", version: function(r) {
  if (!pb(r)) throw TypeError("Invalid UUID");
  return parseInt(r.substr(14, 1), 16);
}, validate: pb, stringify: sb, parse: AD });
const a0 = ["debug", "info", "warn", "error", "none"];
var n2 = { commonBasicLogger: function(r, f) {
  if (r && r.destination && typeof r.destination != "function") throw new Error("destination for basicLogger was set to a non-function");
  function m(R) {
    return function(_) {
      console && console[R] && console[R].call(console, _);
    };
  }
  const h = r && r.destination ? [r.destination, r.destination, r.destination, r.destination] : [m("log"), m("info"), m("warn"), m("error")], v = !(!r || !r.destination), g = r && r.prefix !== void 0 && r.prefix !== null ? r.prefix : "[LaunchDarkly] ";
  let S = 1;
  if (r && r.level) for (let R = 0; R < a0.length; R++) a0[R] === r.level && (S = R);
  function E(R, _, z) {
    if (z.length < 1) return;
    let L;
    const Q = v ? _ + ": " + g : g;
    if (z.length !== 1 && f) {
      const N = [...z];
      N[0] = Q + N[0], L = f(...N);
    } else L = Q + z[0];
    try {
      h[R](L);
    } catch (N) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + _ + " method threw an exception: " + N);
    }
  }
  const O = {};
  for (let R = 0; R < a0.length; R++) {
    const _ = a0[R];
    if (_ !== "none") if (R < S) O[_] = () => {
    };
    else {
      const z = R;
      O[_] = function() {
        E(z, _, arguments);
      };
    }
  }
  return O;
}, validateLogger: function(r) {
  a0.forEach((f) => {
    if (f !== "none" && (!r[f] || typeof r[f] != "function")) throw new Error("Provided logger instance must support logger." + f + "(...) method");
  });
} };
function K1(r) {
  return r && r.message ? r.message : typeof r == "string" || r instanceof String ? r : JSON.stringify(r);
}
const Im = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var Fe = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + Im;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(r) {
  return 'enqueueing "' + r + '" event';
}, debugPostingDiagnosticEvent: function(r) {
  return "sending diagnostic event (" + r.kind + ")";
}, debugPostingEvents: function(r) {
  return "sending " + r + " events";
}, debugStreamDelete: function(r) {
  return 'received streaming deletion for flag "' + r + '"';
}, debugStreamDeleteIgnored: function(r) {
  return 'received streaming deletion for flag "' + r + '" but ignored due to version check';
}, debugStreamPatch: function(r) {
  return 'received streaming update for flag "' + r + '"';
}, debugStreamPatchIgnored: function(r) {
  return 'received streaming update for flag "' + r + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(r) {
  return "polling for feature flags at " + r;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(r, f) {
  return f ? '"' + r + '" is deprecated, please use "' + f + '"' : '"' + r + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + Im;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + Im;
}, errorFetchingFlags: function(r) {
  return "Error fetching flag settings: " + K1(r);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(r, f, m) {
  return "Received error " + r + (r === 401 ? " (invalid SDK key)" : "") + " for " + f + " - " + (wn.isHttpErrorRecoverable(r) ? m : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + Im;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (r, f) => `an inspector: "${f}" of type: "${r}" generated an exception`, invalidContentType: function(r) {
  return 'Expected application/json content type but got "' + r + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (r, f) => `an inspector: "${f}" of an invalid type (${r}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidMetricValue: (r) => `The track function was called with a non-numeric "metricValue" (${r}), only numeric metric values are supported.`, invalidContext: function() {
  return "Invalid context specified." + Im;
}, invalidTagValue: (r) => `Config option "${r}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(r) {
  return "local storage is unavailable: " + K1(r);
}, networkError: (r) => "network error" + (r ? " (" + r + ")" : ""), optionBelowMinimum: (r, f, m) => 'Config option "' + r + '" was set to ' + f + ", changing to minimum value of " + m, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(r) {
  return "Opening stream connection to " + r;
}, streamError: function(r, f) {
  return "Error on stream connection: " + K1(r) + ", will continue retrying after " + f + " milliseconds.";
}, tagValueTooLong: (r) => `Value of "${r}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(r) {
  return 'Custom event "' + r + '" does not exist';
}, unknownOption: (r) => 'Ignoring unknown config option "' + r + '"', contextNotSpecified: function() {
  return "No context specified." + Im;
}, unrecoverableStreamError: (r) => `Error on stream connection ${K1(r)}, giving up permanently`, wrongOptionType: (r, f, m) => 'Config option "' + r + '" should be of type ' + f + ", got " + m + ", using default value", wrongOptionTypeBoolean: (r, f) => 'Config option "' + r + '" should be a boolean, got ' + f + ", converting to boolean" };
const { validateLogger: yC } = n2, lO = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(r, f, m) {
  const h = {};
  return f.id && (h.id = uO(`${r}.id`, f.id, m)), f.version && (h.version = uO(`${r}.version`, f.version, m)), h;
} }, inspectors: { default: [] }, hooks: { default: [] }, plugins: { default: [] } }, gC = /^(\w|\.|-)+$/;
function hE(r) {
  return r && r.replace(/\/+$/, "");
}
function uO(r, f, m) {
  if (typeof f == "string" && f.match(gC)) {
    if (!(f.length > 64)) return f;
    m.warn(Fe.tagValueTooLong(r));
  } else m.warn(Fe.invalidTagValue(r));
}
var a2 = { baseOptionDefs: lO, validate: function(r, f, m, h) {
  const v = tt.extend({ logger: { default: h } }, lO, m), g = {};
  function S(O) {
    tt.onNextTick(() => {
      f && f.maybeReportError(new wn.LDInvalidArgumentError(O));
    });
  }
  let E = tt.extend({}, r || {});
  return (function(O) {
    const R = O;
    Object.keys(g).forEach((_) => {
      if (R[_] !== void 0) {
        const z = g[_];
        h && h.warn(Fe.deprecated(_, z)), z && (R[z] === void 0 && (R[z] = R[_]), delete R[_]);
      }
    });
  })(E), E = (function(O) {
    const R = tt.extend({}, O);
    return Object.keys(v).forEach((_) => {
      R[_] !== void 0 && R[_] !== null || (R[_] = v[_] && v[_].default);
    }), R;
  })(E), E = (function(O) {
    const R = tt.extend({}, O), _ = (z) => {
      if (z === null) return "any";
      if (z === void 0) return;
      if (Array.isArray(z)) return "array";
      const L = typeof z;
      return L === "boolean" || L === "string" || L === "number" || L === "function" ? L : "object";
    };
    return Object.keys(O).forEach((z) => {
      const L = O[z];
      if (L != null) {
        const Q = v[z];
        if (Q === void 0) S(Fe.unknownOption(z));
        else {
          const N = Q.type || _(Q.default), G = Q.validator;
          if (G) {
            const Y = G(z, O[z], h);
            Y !== void 0 ? R[z] = Y : delete R[z];
          } else if (N !== "any") {
            const Y = N.split("|"), F = _(L);
            Y.indexOf(F) < 0 ? N === "boolean" ? (R[z] = !!L, S(Fe.wrongOptionTypeBoolean(z, F))) : (S(Fe.wrongOptionType(z, N, F)), R[z] = Q.default) : F === "number" && Q.minimum !== void 0 && L < Q.minimum && (S(Fe.optionBelowMinimum(z, L, Q.minimum)), R[z] = Q.minimum);
          }
        }
      }
    }), R.baseUrl = hE(R.baseUrl), R.streamUrl = hE(R.streamUrl), R.eventsUrl = hE(R.eventsUrl), R;
  })(E), yC(E.logger), E;
}, getTags: function(r) {
  const f = {};
  return r && (r.application && r.application.id !== void 0 && r.application.id !== null && (f["application-id"] = [r.application.id]), r.application && r.application.version !== void 0 && r.application.id !== null && (f["application-version"] = [r.application.version])), f;
} };
const { getLDUserAgentString: vC } = tt;
var l2 = { getLDHeaders: function(r, f) {
  if (f && !f.sendLDHeaders) return {};
  const m = {};
  m[r.userAgentHeaderName || "User-Agent"] = vC(r), f && f.wrapperName && (m["X-LaunchDarkly-Wrapper"] = f.wrapperVersion ? f.wrapperName + "/" + f.wrapperVersion : f.wrapperName);
  const h = a2.getTags(f), v = Object.keys(h);
  return v.length && (m["x-launchdarkly-tags"] = v.sort().map((g) => Array.isArray(h[g]) ? h[g].sort().map((S) => `${g}/${S}`) : [`${g}/${h[g]}`]).reduce((g, S) => g.concat(S), []).join(" ")), m;
}, transformHeaders: function(r, f) {
  return f && f.requestHeaderTransform ? f.requestHeaderTransform({ ...r }) : r;
} };
const { v1: bC } = t2, { getLDHeaders: SC, transformHeaders: EC } = l2;
var DD = function(r, f, m) {
  const h = tt.extend({ "Content-Type": "application/json" }, SC(r, m)), v = {};
  return v.sendEvents = (g, S, E) => {
    if (!r.httpRequest) return Promise.resolve();
    const O = JSON.stringify(g), R = E ? null : bC();
    return (function _(z) {
      const L = E ? h : tt.extend({}, h, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": R });
      return r.httpRequest("POST", S, EC(L, m), O).promise.then((Q) => {
        if (Q) return Q.status >= 400 && wn.isHttpErrorRecoverable(Q.status) && z ? _(!1) : (function(N) {
          const G = { status: N.status }, Y = N.header("date");
          if (Y) {
            const F = Date.parse(Y);
            F && (G.serverTime = F);
          }
          return G;
        })(Q);
      }).catch(() => z ? _(!1) : Promise.reject());
    })(!0).catch(() => {
    });
  }, v;
}, TC = function r(f, m = []) {
  if (f === null || typeof f != "object") return JSON.stringify(f);
  if (m.includes(f)) throw new Error("Cycle detected");
  return Array.isArray(f) ? `[${f.map((h) => r(h, [...m, f])).map((h) => h === void 0 ? "null" : h).join(",")}]` : `{${Object.keys(f).sort().map((h) => {
    const v = r(f[h], [...m, f]);
    if (v !== void 0) return `${JSON.stringify(h)}:${v}`;
  }).filter((h) => h !== void 0).join(",")}}`;
};
const { commonBasicLogger: AC } = n2;
function iO(r) {
  return typeof r == "string" && r !== "kind" && r.match(/^(\w|\.|-)+$/);
}
var Ob = { checkContext: function(r, f) {
  if (r) {
    if (f && (r.kind === void 0 || r.kind === null)) return r.key !== void 0 && r.key !== null;
    const m = r.key, h = r.kind === void 0 ? "user" : r.kind, v = iO(h), g = h === "multi" || m != null && m !== "";
    if (h === "multi") {
      const S = Object.keys(r).filter((E) => E !== "kind");
      return g && S.every((E) => iO(E)) && S.every((E) => {
        const O = r[E].key;
        return O != null && O !== "";
      });
    }
    return g && v;
  }
  return !1;
}, getContextKeys: function(r, f = AC()) {
  if (!r) return;
  const m = {}, { kind: h, key: v } = r;
  switch (h) {
    case void 0:
      m.user = `${v}`;
      break;
    case "multi":
      Object.entries(r).filter(([g]) => g !== "kind").forEach(([g, S]) => {
        S && S.key && (m[g] = S.key);
      });
      break;
    case null:
      f.warn(`null is not a valid context kind: ${r}`);
      break;
    case "":
      f.warn(`'' is not a valid context kind: ${r}`);
      break;
    default:
      m[h] = `${v}`;
  }
  return m;
}, getContextKinds: function(r) {
  return r ? r.kind === null || r.kind === void 0 ? ["user"] : r.kind !== "multi" ? [r.kind] : Object.keys(r).filter((f) => f !== "kind") : [];
} };
const { getContextKinds: OC } = Ob;
var DC = function() {
  const r = {};
  let f = 0, m = 0, h = {}, v = {};
  return r.summarizeEvent = (g) => {
    if (g.kind === "feature") {
      const S = g.key + ":" + (g.variation !== null && g.variation !== void 0 ? g.variation : "") + ":" + (g.version !== null && g.version !== void 0 ? g.version : ""), E = h[S];
      let O = v[g.key];
      O || (O = /* @__PURE__ */ new Set(), v[g.key] = O), (function(R) {
        return R.context ? OC(R.context) : R.contextKeys ? Object.keys(R.contextKeys) : [];
      })(g).forEach((R) => O.add(R)), E ? E.count = E.count + 1 : h[S] = { count: 1, key: g.key, version: g.version, variation: g.variation, value: g.value, default: g.default }, (f === 0 || g.creationDate < f) && (f = g.creationDate), g.creationDate > m && (m = g.creationDate);
    }
  }, r.getSummary = () => {
    const g = {};
    let S = !0;
    for (const E of Object.values(h)) {
      let O = g[E.key];
      O || (O = { default: E.default, counters: [], contextKinds: [...v[E.key]] }, g[E.key] = O);
      const R = { value: E.value, count: E.count };
      E.variation !== void 0 && E.variation !== null && (R.variation = E.variation), E.version !== void 0 && E.version !== null ? R.version = E.version : R.unknown = !0, O.counters.push(R), S = !1;
    }
    return S ? null : { startDate: f, endDate: m, features: g, kind: "summary" };
  }, r.clearSummary = () => {
    f = 0, m = 0, h = {}, v = {};
  }, r;
}, RC = function(r) {
  let f = {}, m = {};
  return { summarizeEvent: function(h) {
    if (h.kind === "feature") {
      const v = TC(h.context);
      if (!v) return;
      let g = f[v];
      g || (f[v] = DC(), g = f[v], m[v] = h.context), g.summarizeEvent(h);
    }
  }, getSummaries: function() {
    const h = f, v = m;
    return f = {}, m = {}, Object.entries(h).map(([g, S]) => {
      const E = S.getSummary();
      return E.context = r.filter(v[g]), E;
    });
  } };
};
function RD(r) {
  return r.replace(/~/g, "~0").replace(/\//g, "~1");
}
function oO(r) {
  return (r.startsWith("/") ? r.substring(1) : r).split("/").map((f) => f.indexOf("~") >= 0 ? f.replace(/~1/g, "/").replace(/~0/g, "~") : f);
}
function cO(r) {
  return !r.startsWith("/");
}
function rO(r, f) {
  const m = cO(r), h = cO(f);
  if (m && h) return r === f;
  if (m) {
    const v = oO(f);
    return v.length === 1 && r === v[0];
  }
  if (h) {
    const v = oO(r);
    return v.length === 1 && f === v[0];
  }
  return r === f;
}
function sO(r) {
  return `/${RD(r)}`;
}
var mE = { cloneExcluding: function(r, f) {
  const m = [], h = {}, v = [];
  for (m.push(...Object.keys(r).map((g) => ({ key: g, ptr: sO(g), source: r, parent: h, visited: [r] }))); m.length; ) {
    const g = m.pop();
    if (f.some((S) => rO(S, g.ptr))) v.push(g.ptr);
    else {
      const S = g.source[g.key];
      if (S === null) g.parent[g.key] = S;
      else if (Array.isArray(S)) g.parent[g.key] = [...S];
      else if (typeof S == "object") {
        if (g.visited.includes(S)) continue;
        g.parent[g.key] = {}, m.push(...Object.keys(S).map((E) => {
          return { key: E, ptr: (O = g.ptr, R = RD(E), `${O}/${R}`), source: S, parent: g.parent[g.key], visited: [...g.visited, S] };
          var O, R;
        }));
      } else g.parent[g.key] = S;
    }
  }
  return { cloned: h, excluded: v.sort() };
}, compare: rO, literalToReference: sO }, CC = function(r) {
  const f = {}, m = r.allAttributesPrivate, h = r.privateAttributes || [], v = ["key", "kind", "_meta", "anonymous"], g = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], S = (E, O) => {
    if (typeof E != "object" || E === null || Array.isArray(E)) return;
    const { cloned: R, excluded: _ } = mE.cloneExcluding(E, ((z, L) => (m || L && z.anonymous ? Object.keys(z) : [...h, ...z._meta && z._meta.privateAttributes || []]).filter((Q) => !v.some((N) => mE.compare(Q, N))))(E, O));
    return R.key = String(R.key), _.length && (R._meta || (R._meta = {}), R._meta.redactedAttributes = _), R._meta && (delete R._meta.privateAttributes, Object.keys(R._meta).length === 0 && delete R._meta), R.anonymous !== void 0 && (R.anonymous = !!R.anonymous), R;
  };
  return f.filter = (E, O = !1) => E.kind === void 0 || E.kind === null ? S(((R) => {
    const _ = { ...R.custom || {}, kind: "user", key: R.key };
    R.anonymous !== void 0 && (_.anonymous = !!R.anonymous);
    for (const z of g) delete _[z], R[z] !== void 0 && R[z] !== null && (_[z] = String(R[z]));
    return R.privateAttributeNames !== void 0 && R.privateAttributeNames !== null && (_._meta = _._meta || {}, _._meta.privateAttributes = R.privateAttributeNames.map((z) => z.startsWith("/") ? mE.literalToReference(z) : z)), _;
  })(E), O) : E.kind === "multi" ? ((R, _) => {
    const z = { kind: R.kind }, L = Object.keys(R);
    for (const Q of L) if (Q !== "kind") {
      const N = S(R[Q], _);
      N && (z[Q] = N);
    }
    return z;
  })(E, O) : S(E, O), f;
};
const { getContextKeys: zC } = Ob;
var _C = function(r, f, m, h = null, v = null, g = null) {
  const S = {}, E = g || DD(r, m, f), O = tt.appendUrlPath(f.eventsUrl, "/events/bulk/" + m), R = CC(f), _ = RC(R), z = f.samplingInterval, L = f.eventCapacity, Q = f.flushInterval, N = f.logger;
  let G, Y = [], F = 0, ne = !1, ye = !1;
  function pe() {
    return z === 0 || Math.floor(Math.random() * z) === 0;
  }
  function he(ge) {
    const Se = tt.extend({}, ge);
    return ge.kind === "identify" || ge.kind === "feature" || ge.kind === "custom" ? Se.context = R.filter(ge.context) : (Se.contextKeys = zC(ge.context, N), delete Se.context), ge.kind === "feature" && (delete Se.trackEvents, delete Se.debugEventsUntilDate), Se;
  }
  function Te(ge) {
    Y.length < L ? (Y.push(ge), ye = !1) : (ye || (ye = !0, N.warn(Fe.eventCapacityExceeded())), h && h.incrementDroppedEvents());
  }
  return S.enqueue = function(ge) {
    if (ne) return;
    let Se = !1, xe = !1;
    var ae;
    if (_.summarizeEvent(ge), ge.kind === "feature" ? pe() && (Se = !!ge.trackEvents, xe = !!(ae = ge).debugEventsUntilDate && ae.debugEventsUntilDate > F && ae.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : Se = pe(), Se && Te(he(ge)), xe) {
      const Me = tt.extend({}, ge, { kind: "debug" });
      Me.context = R.filter(Me.context), delete Me.trackEvents, delete Me.debugEventsUntilDate, Te(Me);
    }
  }, S.flush = async function() {
    if (ne) return Promise.resolve();
    const ge = Y;
    return _.getSummaries().forEach((Se) => {
      Object.keys(Se.features).length && ge.push(Se);
    }), h && h.setEventsInLastBatch(ge.length), ge.length === 0 ? Promise.resolve() : (Y = [], N.debug(Fe.debugPostingEvents(ge.length)), E.sendEvents(ge, O).then((Se) => {
      Se && (Se.serverTime && (F = Se.serverTime), wn.isHttpErrorRecoverable(Se.status) || (ne = !0), Se.status >= 400 && tt.onNextTick(() => {
        v.maybeReportError(new wn.LDUnexpectedResponseError(Fe.httpErrorMessage(Se.status, "event posting", "some events were dropped")));
      }));
    }));
  }, S.start = function() {
    const ge = () => {
      S.flush(), G = setTimeout(ge, Q);
    };
    G = setTimeout(ge, Q);
  }, S.stop = function() {
    clearTimeout(G);
  }, S;
}, UC = function(r) {
  const f = {}, m = {};
  return f.on = function(h, v, g) {
    m[h] = m[h] || [], m[h] = m[h].concat({ handler: v, context: g });
  }, f.off = function(h, v, g) {
    if (m[h]) for (let S = 0; S < m[h].length; S++) m[h][S].handler === v && m[h][S].context === g && (m[h] = m[h].slice(0, S).concat(m[h].slice(S + 1)));
  }, f.emit = function(h) {
    if (!m[h]) return;
    const v = m[h].slice(0);
    for (let g = 0; g < v.length; g++) v[g].handler.apply(v[g].context, Array.prototype.slice.call(arguments, 1));
  }, f.getEvents = function() {
    return Object.keys(m);
  }, f.getEventListenerCount = function(h) {
    return m[h] ? m[h].length : 0;
  }, f.maybeReportError = function(h) {
    h && (m.error ? this.emit("error", h) : (r || console).error(h.message));
  }, f;
};
const k1 = "ready", pE = "initialized", yE = "failed";
var wC = function(r) {
  let f = !1, m = !1, h = null, v = null;
  const g = new Promise((S) => {
    const E = () => {
      r.off(k1, E), S();
    };
    r.on(k1, E);
  }).catch(() => {
  });
  return { getInitializationPromise: () => v || (f ? Promise.resolve() : m ? Promise.reject(h) : (v = new Promise((S, E) => {
    const O = () => {
      r.off(pE, O), S();
    }, R = (_) => {
      r.off(yE, R), E(_);
    };
    r.on(pE, O), r.on(yE, R);
  }), v)), getReadyPromise: () => g, signalSuccess: () => {
    f || m || (f = !0, r.emit(pE), r.emit(k1));
  }, signalFailure: (S) => {
    f || m || (m = !0, h = S, r.emit(yE, S), r.emit(k1)), r.maybeReportError(S);
  } };
}, MC = function(r, f, m, h) {
  const v = {};
  function g() {
    let S = "";
    const E = h.getContext();
    return E && (S = m || tt.btoa(JSON.stringify(E))), "ld:" + f + ":" + S;
  }
  return v.loadFlags = () => r.get(g()).then((S) => {
    if (S == null) return null;
    try {
      let E = JSON.parse(S);
      if (E) {
        const O = E.$schema;
        O === void 0 || O < 1 ? E = tt.transformValuesToVersionedValues(E) : delete E.$schema;
      }
      return E;
    } catch {
      return v.clearFlags().then(() => null);
    }
  }), v.saveFlags = (S) => {
    const E = tt.extend({}, S, { $schema: 1 });
    return r.set(g(), JSON.stringify(E));
  }, v.clearFlags = () => r.clear(g()), v;
}, NC = function(r, f) {
  const m = {};
  let h = !1;
  const v = (g) => {
    h || (h = !0, f.warn(Fe.localStorageUnavailable(g)));
  };
  return m.isEnabled = () => !!r, m.get = (g) => new Promise((S) => {
    r ? r.get(g).then(S).catch((E) => {
      v(E), S(void 0);
    }) : S(void 0);
  }), m.set = (g, S) => new Promise((E) => {
    r ? r.set(g, S).then(() => E(!0)).catch((O) => {
      v(O), E(!1);
    }) : E(!1);
  }), m.clear = (g) => new Promise((S) => {
    r ? r.clear(g).then(() => S(!0)).catch((E) => {
      v(E), S(!1);
    }) : S(!1);
  }), m;
};
const { appendUrlPath: fO, base64URLEncode: xC, objectHasOwnProperty: HC } = tt, { getLDHeaders: LC, transformHeaders: BC } = l2, { isHttpErrorRecoverable: jC } = wn;
var qC = function(r, f, m, h) {
  const v = f.streamUrl, g = f.logger, S = {}, E = fO(v, "/eval/" + m), O = f.useReport, R = f.evaluationReasons, _ = f.streamReconnectDelay, z = LC(r, f);
  let L, Q = !1, N = null, G = null, Y = null, F = null, ne = null, ye = 0;
  function pe() {
    const ae = (Me = (function() {
      const Ce = _ * Math.pow(2, ye);
      return Ce > 3e4 ? 3e4 : Ce;
    })(), Me - Math.trunc(0.5 * Math.random() * Me));
    var Me;
    return ye += 1, ae;
  }
  function he(ae) {
    if (ae.status && typeof ae.status == "number" && !jC(ae.status)) return Se(), g.error(Fe.unrecoverableStreamError(ae)), void (G && (clearTimeout(G), G = null));
    const Me = pe();
    Q || (g.warn(Fe.streamError(ae, Me)), Q = !0), xe(!1), Se(), Te(Me);
  }
  function Te(ae) {
    G || (ae ? G = setTimeout(ge, ae) : ge());
  }
  function ge() {
    let ae;
    G = null;
    let Me = "";
    const Ce = { headers: z, readTimeoutMillis: 3e5 };
    if (r.eventSourceFactory) {
      F != null && (Me = "h=" + F), O ? r.eventSourceAllowsReport ? (ae = E, Ce.method = "REPORT", Ce.headers["Content-Type"] = "application/json", Ce.body = JSON.stringify(Y)) : (ae = fO(v, "/ping/" + m), Me = "") : ae = E + "/" + xC(JSON.stringify(Y)), Ce.headers = BC(Ce.headers, f), R && (Me = Me + (Me ? "&" : "") + "withReasons=true"), ae = ae + (Me ? "?" : "") + Me, Se(), g.info(Fe.streamConnecting(ae)), L = (/* @__PURE__ */ new Date()).getTime(), N = r.eventSourceFactory(ae, Ce);
      for (const we in ne) HC(ne, we) && N.addEventListener(we, ne[we]);
      N.onerror = he, N.onopen = () => {
        ye = 0;
      };
    }
  }
  function Se() {
    N && (g.info(Fe.streamClosing()), N.close(), N = null);
  }
  function xe(ae) {
    L && h && h.recordStreamInit(L, !ae, (/* @__PURE__ */ new Date()).getTime() - L), L = null;
  }
  return S.connect = function(ae, Me, Ce) {
    Y = ae, F = Me, ne = {};
    for (const we in Ce || {}) ne[we] = function(We) {
      Q = !1, xe(!0), Ce[we] && Ce[we](We);
    };
    Te();
  }, S.disconnect = function() {
    clearTimeout(G), G = null, Se();
  }, S.isConnected = function() {
    return !!(N && r.eventSourceIsActive && r.eventSourceIsActive(N));
  }, S;
}, VC = function(r) {
  let f, m, h, v;
  const g = { addPromise: (S, E) => {
    f = S, m && m(), m = E, S.then((O) => {
      f === S && (h(O), r && r());
    }, (O) => {
      f === S && (v(O), r && r());
    });
  } };
  return g.resultPromise = new Promise((S, E) => {
    h = S, v = E;
  }), g;
};
const { transformHeaders: YC, getLDHeaders: GC } = l2, dO = "application/json";
var XC = function(r, f, m) {
  const h = f.baseUrl, v = f.useReport, g = f.evaluationReasons, S = f.logger, E = {}, O = {};
  function R(_, z) {
    if (!r.httpRequest) return new Promise((F, ne) => {
      ne(new wn.LDFlagFetchError(Fe.httpUnavailable()));
    });
    const L = z ? "REPORT" : "GET", Q = GC(r, f);
    z && (Q["Content-Type"] = dO);
    let N = O[_];
    N || (N = VC(() => {
      delete O[_];
    }), O[_] = N);
    const G = r.httpRequest(L, _, YC(Q, f), z), Y = G.promise.then((F) => {
      if (F.status === 200) {
        if (F.header("content-type") && F.header("content-type").substring(0, 16) === dO) return JSON.parse(F.body);
        {
          const ne = Fe.invalidContentType(F.header("content-type") || "");
          return Promise.reject(new wn.LDFlagFetchError(ne));
        }
      }
      return Promise.reject((function(ne) {
        return ne.status === 404 ? new wn.LDInvalidEnvironmentIdError(Fe.environmentNotFound()) : new wn.LDFlagFetchError(Fe.errorFetchingFlags(ne.statusText || String(ne.status)));
      })(F));
    }, (F) => Promise.reject(new wn.LDFlagFetchError(Fe.networkError(F))));
    return N.addPromise(Y, () => {
      G.cancel && G.cancel();
    }), N.resultPromise;
  }
  return E.fetchJSON = function(_) {
    return R(tt.appendUrlPath(h, _), null);
  }, E.fetchFlagSettings = function(_, z) {
    let L, Q, N, G = "";
    return v ? (Q = [h, "/sdk/evalx/", m, "/context"].join(""), N = JSON.stringify(_)) : (L = tt.base64URLEncode(JSON.stringify(_)), Q = [h, "/sdk/evalx/", m, "/contexts/", L].join("")), z && (G = "h=" + z), g && (G = G + (G ? "&" : "") + "withReasons=true"), Q = Q + (G ? "?" : "") + G, S.debug(Fe.debugPolling(Q)), R(Q, N);
  }, E;
}, QC = function(r, f) {
  const m = {};
  let h;
  return m.setContext = function(v) {
    h = tt.sanitizeContext(v), h && f && f(tt.clone(h));
  }, m.getContext = function() {
    return h ? tt.clone(h) : null;
  }, m;
};
const { v1: ZC } = t2, { getContextKinds: JC } = Ob;
var KC = function(r) {
  function f(h) {
    return h == null || h === "user" ? "ld:$anonUserId" : `ld:$contextKey:${h}`;
  }
  function m(h, v) {
    return v.key !== null && v.key !== void 0 ? (v.key = v.key.toString(), Promise.resolve(v)) : v.anonymous ? (function(g) {
      return r.get(f(g));
    })(h).then((g) => {
      if (g) return v.key = g, v;
      {
        const S = ZC();
        return v.key = S, (function(E, O) {
          return r.set(f(O), E);
        })(S, h).then(() => v);
      }
    }) : Promise.reject(new wn.LDInvalidUserError(Fe.invalidContext()));
  }
  this.processContext = (h) => {
    if (!h) return Promise.reject(new wn.LDInvalidUserError(Fe.contextNotSpecified()));
    const v = tt.clone(h);
    if (h.kind === "multi") {
      const g = JC(v);
      return Promise.all(g.map((S) => m(S, v[S]))).then(() => v);
    }
    return m(h.kind, v);
  };
};
const { v1: kC } = t2, { baseOptionDefs: gE } = a2, { appendUrlPath: $C } = tt;
var vE = { DiagnosticId: function(r) {
  const f = { diagnosticId: kC() };
  return r && (f.sdkKeySuffix = r.length > 6 ? r.substring(r.length - 6) : r), f;
}, DiagnosticsAccumulator: function(r) {
  let f, m, h, v;
  function g(S) {
    f = S, m = 0, h = 0, v = [];
  }
  return g(r), { getProps: () => ({ dataSinceDate: f, droppedEvents: m, eventsInLastBatch: h, streamInits: v }), setProps: (S) => {
    f = S.dataSinceDate, m = S.droppedEvents || 0, h = S.eventsInLastBatch || 0, v = S.streamInits || [];
  }, incrementDroppedEvents: () => {
    m++;
  }, setEventsInLastBatch: (S) => {
    h = S;
  }, recordStreamInit: (S, E, O) => {
    const R = { timestamp: S, failed: E, durationMillis: O };
    v.push(R);
  }, reset: g };
}, DiagnosticsManager: function(r, f, m, h, v, g, S) {
  const E = !!r.diagnosticUseCombinedEvent, O = "ld:" + v + ":$diagnostics", R = $C(g.eventsUrl, "/events/diagnostic/" + v), _ = g.diagnosticRecordingInterval, z = m;
  let L, Q, N = !!g.streaming;
  const G = {};
  function Y() {
    return { sdk: ye(), configuration: pe(), platform: r.diagnosticPlatformData };
  }
  function F(he) {
    g.logger && g.logger.debug(Fe.debugPostingDiagnosticEvent(he)), h.sendEvents(he, R, !0).then(() => {
    }).catch(() => {
    });
  }
  function ne() {
    F((function() {
      const he = (/* @__PURE__ */ new Date()).getTime();
      let Te = { kind: E ? "diagnostic-combined" : "diagnostic", id: S, creationDate: he, ...z.getProps() };
      return E && (Te = { ...Te, ...Y() }), z.reset(he), Te;
    })()), Q = setTimeout(ne, _), L = (/* @__PURE__ */ new Date()).getTime(), E && (function() {
      if (f.isEnabled()) {
        const he = { ...z.getProps() };
        f.set(O, JSON.stringify(he));
      }
    })();
  }
  function ye() {
    const he = { ...r.diagnosticSdkData };
    return g.wrapperName && (he.wrapperName = g.wrapperName), g.wrapperVersion && (he.wrapperVersion = g.wrapperVersion), he;
  }
  function pe() {
    return { customBaseURI: g.baseUrl !== gE.baseUrl.default, customStreamURI: g.streamUrl !== gE.streamUrl.default, customEventsURI: g.eventsUrl !== gE.eventsUrl.default, eventsCapacity: g.eventCapacity, eventsFlushIntervalMillis: g.flushInterval, reconnectTimeMillis: g.streamReconnectDelay, streamingDisabled: !N, allAttributesPrivate: !!g.allAttributesPrivate, diagnosticRecordingIntervalMillis: g.diagnosticRecordingInterval, usingSecureMode: !!g.hash, bootstrapMode: !!g.bootstrap, fetchGoalsDisabled: !g.fetchGoals, sendEventsOnlyForVariation: !!g.sendEventsOnlyForVariation };
  }
  return G.start = () => {
    E ? (function(he) {
      if (!f.isEnabled()) return he(!1);
      f.get(O).then((Te) => {
        if (Te) try {
          const ge = JSON.parse(Te);
          z.setProps(ge), L = ge.dataSinceDate;
        } catch {
        }
        he(!0);
      }).catch(() => {
        he(!1);
      });
    })((he) => {
      if (he) {
        const Te = (L || 0) + _, ge = (/* @__PURE__ */ new Date()).getTime();
        ge >= Te ? ne() : Q = setTimeout(ne, Te - ge);
      } else Math.floor(4 * Math.random()) === 0 ? ne() : Q = setTimeout(ne, _);
    }) : (F({ kind: "diagnostic-init", id: S, creationDate: z.getProps().dataSinceDate, ...Y() }), Q = setTimeout(ne, _));
  }, G.stop = () => {
    Q && clearTimeout(Q);
  }, G.setStreaming = (he) => {
    N = he;
  }, G;
} }, FC = function(r, f) {
  let m = !1;
  const h = { type: r.type, name: r.name, synchronous: r.synchronous, method: (...v) => {
    try {
      r.method(...v);
    } catch {
      m || (m = !0, f.warn(Fe.inspectorMethodError(h.type, h.name)));
    }
  } };
  return h;
};
const { onNextTick: $1 } = tt, Jl = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(Jl);
var WC = { InspectorTypes: Jl, InspectorManager: function(r, f) {
  const m = {}, h = { [Jl.flagUsed]: [], [Jl.flagDetailsChanged]: [], [Jl.flagDetailChanged]: [], [Jl.clientIdentityChanged]: [] }, v = { [Jl.flagUsed]: [], [Jl.flagDetailsChanged]: [], [Jl.flagDetailChanged]: [], [Jl.clientIdentityChanged]: [] }, g = r && r.map((S) => FC(S, f));
  return g && g.forEach((S) => {
    Object.prototype.hasOwnProperty.call(h, S.type) && !S.synchronous ? h[S.type].push(S) : Object.prototype.hasOwnProperty.call(v, S.type) && S.synchronous ? v[S.type].push(S) : f.warn(Fe.invalidInspector(S.type, S.name));
  }), m.hasListeners = (S) => h[S] && h[S].length || v[S] && v[S].length, m.onFlagUsed = (S, E, O) => {
    const R = Jl.flagUsed;
    v[R].length && v[R].forEach((_) => _.method(S, E, O)), h[R].length && $1(() => {
      h[R].forEach((_) => _.method(S, E, O));
    });
  }, m.onFlags = (S) => {
    const E = Jl.flagDetailsChanged;
    v[E].length && v[E].forEach((O) => O.method(S)), h[E].length && $1(() => {
      h[E].forEach((O) => O.method(S));
    });
  }, m.onFlagChanged = (S, E) => {
    const O = Jl.flagDetailChanged;
    v[O].length && v[O].forEach((R) => R.method(S, E)), h[O].length && $1(() => {
      h[O].forEach((R) => R.method(S, E));
    });
  }, m.onIdentityChanged = (S) => {
    const E = Jl.clientIdentityChanged;
    v[E].length && v[E].forEach((O) => O.method(S)), h[E].length && $1(() => {
      h[E].forEach((O) => O.method(S));
    });
  }, m;
} };
const { LDTimeoutError: IC } = wn;
var PC = function(r, f) {
  return new Promise((m, h) => {
    setTimeout(() => {
      h(new IC(`${f} timed out after ${r} seconds.`));
    }, 1e3 * r);
  });
};
const hO = "unknown hook";
function l0(r, f, m, h, v) {
  try {
    return h();
  } catch (g) {
    return r?.error(`An error was encountered in "${f}" of the "${m}" hook: ${g}`), v;
  }
}
function u0(r, f) {
  try {
    return f.getMetadata().name || hO;
  } catch {
    return r.error("Exception thrown getting metadata for hook. Unable to get hook name."), hO;
  }
}
var ez = function(r, f) {
  const m = f ? [...f] : [];
  return { withEvaluation: function(h, v, g, S) {
    if (m.length === 0) return S();
    const E = [...m], O = { flagKey: h, context: v, defaultValue: g }, R = (function(z, L, Q) {
      return L.map((N) => l0(z, "beforeEvaluation", u0(z, N), () => N?.beforeEvaluation?.(Q, {}) ?? {}, {}));
    })(r, E, O), _ = S();
    return (function(z, L, Q, N, G) {
      for (let Y = L.length - 1; Y >= 0; Y -= 1) {
        const F = L[Y], ne = N[Y];
        l0(z, "afterEvaluation", u0(z, F), () => F?.afterEvaluation?.(Q, ne, G) ?? {}, {});
      }
    })(r, E, O, R, _), _;
  }, identify: function(h, v) {
    const g = [...m], S = { context: h, timeout: v }, E = (function(O, R, _) {
      return R.map((z) => l0(O, "beforeIdentify", u0(O, z), () => z?.beforeIdentify?.(_, {}) ?? {}, {}));
    })(r, g, S);
    return (O) => {
      (function(R, _, z, L, Q) {
        for (let N = _.length - 1; N >= 0; N -= 1) {
          const G = _[N], Y = L[N];
          l0(R, "afterIdentify", u0(R, G), () => G?.afterIdentify?.(z, Y, Q) ?? {}, {});
        }
      })(r, g, S, E, O);
    };
  }, addHook: function(h) {
    m.push(h);
  }, afterTrack: function(h) {
    if (m.length === 0) return;
    const v = [...m];
    (function(g, S, E) {
      for (let O = S.length - 1; O >= 0; O -= 1) {
        const R = S[O];
        l0(g, "afterTrack", u0(g, R), () => R?.afterTrack?.(E), void 0);
      }
    })(r, v, h);
  } };
}, tz = function() {
  let r, f = {};
  function m(h) {
    return r && tt.objectHasOwnProperty(r, h) && r[h] ? r[h] : f && tt.objectHasOwnProperty(f, h) && f[h] && !f[h].deleted ? f[h] : null;
  }
  return { clearAllOverrides: function() {
    if (!r) return {};
    const h = { ...r };
    return r = void 0, h;
  }, get: m, getFlagOverrides: function() {
    return r || {};
  }, getFlags: function() {
    return f;
  }, getFlagsWithOverrides: function() {
    const h = {};
    for (const v in f) {
      const g = m(v);
      g && (h[v] = g);
    }
    if (r) for (const v in r) {
      const g = m(v);
      g && (h[v] = g);
    }
    return h;
  }, removeOverride: function(h) {
    r && r[h] && (delete r[h], Object.keys(r).length === 0 && (r = void 0));
  }, setFlags: function(h) {
    f = { ...h };
  }, setOverride: function(h, v) {
    r || (r = {}), r[h] = { value: v };
  } };
};
const mO = "unknown plugin";
function F1(r, f) {
  try {
    return f.getMetadata().name || mO;
  } catch {
    return r.error("Exception thrown getting metadata for plugin. Unable to get plugin name."), mO;
  }
}
var nz = { getPluginHooks: function(r, f, m) {
  const h = [];
  return m.forEach((v) => {
    try {
      const g = v.getHooks?.(f);
      g === void 0 ? r.error(`Plugin ${F1(r, v)} returned undefined from getHooks.`) : g && g.length > 0 && h.push(...g);
    } catch {
      r.error(`Exception thrown getting hooks for plugin ${F1(r, v)}. Unable to get hooks.`);
    }
  }), h;
}, registerPlugins: function(r, f, m, h) {
  h.forEach((v) => {
    try {
      v.register(m, f);
    } catch {
      r.error(`Exception thrown registering plugin ${F1(r, v)}.`);
    }
  });
}, registerPluginsForDebugOverride: function(r, f, m) {
  m.forEach((h) => {
    try {
      h.registerDebug?.(f);
    } catch {
      r.error(`Exception thrown registering debug override with plugin ${F1(r, h)}.`);
    }
  });
}, createPluginEnvironment: function(r, f, m) {
  const h = {};
  r.userAgent && (h.name = r.userAgent), r.version && (h.version = r.version), m.wrapperName && (h.wrapperName = m.wrapperName), m.wrapperVersion && (h.wrapperVersion = m.wrapperVersion);
  const v = {};
  m.application && (m.application.name && (v.name = m.application.name), m.application.version && (v.version = m.application.version));
  const g = { sdk: h, clientSideId: f };
  return Object.keys(v).length > 0 && (g.application = v), g;
} };
const { commonBasicLogger: az } = n2, { checkContext: lz } = Ob, { InspectorTypes: W1, InspectorManager: uz } = WC, { getPluginHooks: iz, registerPlugins: oz, registerPluginsForDebugOverride: cz, createPluginEnvironment: rz } = nz, I1 = "change", pO = "internal-change";
var CD = { initialize: function(r, f, m, h, v) {
  const g = (function() {
    return m && m.logger ? m.logger : v && v.logger && v.logger.default || az("warn");
  })(), S = UC(g), E = wC(S), O = a2.validate(m, S, v, g), R = uz(O.inspectors, g), _ = O.sendEvents;
  let z = r, L = O.hash;
  const Q = [...O.plugins], N = rz(h, r, O), G = iz(g, N, Q), Y = ez(g, [...O.hooks, ...G]), F = NC(h.localStorage, g), ne = DD(h, z, O), ye = O.sendEvents && !O.diagnosticOptOut, pe = ye ? vE.DiagnosticId(z) : null, he = ye ? vE.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, Te = ye ? vE.DiagnosticsManager(h, F, he, ne, z, O, pe) : null, ge = qC(h, O, z, he), Se = O.eventProcessor || _C(h, O, z, he, S, ne), xe = XC(h, O, z), ae = tz();
  let Me, Ce, we, We = O.streaming, Rt = !1, H = !1, ue = !0;
  const fe = O.stateProvider, be = QC(null, function(Z) {
    (function(de) {
      fe || de && ve({ kind: "identify", context: de, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(Z), R.hasListeners(W1.clientIdentityChanged) && R.onIdentityChanged(be.getContext());
  }), Be = new KC(F), ee = F.isEnabled() ? MC(F, z, L, be) : null;
  function ve(Z) {
    z && (fe && fe.enqueueEvent && fe.enqueueEvent(Z) || (Z.context ? (ue = !1, !_ || H || h.isDoNotTrack() || (g.debug(Fe.debugEnqueueingEvent(Z.kind)), Se.enqueue(Z))) : ue && (g.warn(Fe.eventWithoutContext()), ue = !1)));
  }
  function De(Z, de) {
    R.hasListeners(W1.flagDetailChanged) && R.onFlagChanged(Z.key, en(de));
  }
  function ze() {
    R.hasListeners(W1.flagDetailsChanged) && R.onFlags(Object.entries(ae.getFlagsWithOverrides()).map(([Z, de]) => ({ key: Z, detail: en(de) })).reduce((Z, de) => (Z[de.key] = de.detail, Z), {}));
  }
  function At(Z, de, oe, me) {
    const _e = be.getContext(), vt = /* @__PURE__ */ new Date(), et = { kind: "feature", key: Z, context: _e, value: de ? de.value : null, variation: de ? de.variationIndex : null, default: oe, creationDate: vt.getTime() }, St = ae.getFlags()[Z];
    St && (et.version = St.flagVersion ? St.flagVersion : St.version, et.trackEvents = St.trackEvents, et.debugEventsUntilDate = St.debugEventsUntilDate), (me || St && St.trackReason) && de && (et.reason = de.reason), ve(et);
  }
  function Rn(Z) {
    return lz(Z, !1) ? Promise.resolve(Z) : Promise.reject(new wn.LDInvalidUserError(Fe.invalidContext()));
  }
  function ft(Z, de, oe, me, _e, vt) {
    let et;
    const St = ae.get(Z);
    return St ? (et = en(St), St.value !== null && St.value !== void 0 || (et.value = de)) : et = { value: de, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } }, oe && (_e || St?.prerequisites?.forEach((Wt) => {
      ft(Wt, void 0, oe, !1, !1, !1);
    }), At(Z, et, de, me)), !_e && vt && (function(Wt, tl) {
      R.hasListeners(W1.flagUsed) && R.onFlagUsed(Wt, tl, be.getContext());
    })(Z, et), et;
  }
  function en(Z) {
    return { value: Z.value, variationIndex: Z.variation === void 0 ? null : Z.variation, reason: Z.reason || null };
  }
  function Mn() {
    if (Ce = !0, !be.getContext()) return;
    const Z = (de) => {
      try {
        return JSON.parse(de);
      } catch {
        return void S.maybeReportError(new wn.LDInvalidDataError(Fe.invalidData()));
      }
    };
    ge.connect(be.getContext(), L, { ping: function() {
      g.debug(Fe.debugStreamPing());
      const de = be.getContext();
      xe.fetchFlagSettings(de, L).then((oe) => {
        tt.deepEquals(de, be.getContext()) && Ae(oe || {});
      }).catch((oe) => {
        S.maybeReportError(new wn.LDFlagFetchError(Fe.errorFetchingFlags(oe)));
      });
    }, put: function(de) {
      const oe = Z(de.data);
      oe && (g.debug(Fe.debugStreamPut()), Ae(oe));
    }, patch: function(de) {
      const oe = Z(de.data);
      if (!oe) return;
      const me = ae.getFlags(), _e = me[oe.key];
      if (!_e || !_e.version || !oe.version || _e.version < oe.version) {
        g.debug(Fe.debugStreamPatch(oe.key));
        const vt = {}, et = tt.extend({}, oe);
        delete et.key, me[oe.key] = et, ae.setFlags(me);
        const St = en(et);
        vt[oe.key] = _e ? { previous: _e.value, current: St } : { current: St }, De(oe, et), qa(vt);
      } else g.debug(Fe.debugStreamPatchIgnored(oe.key));
    }, delete: function(de) {
      const oe = Z(de.data);
      if (!oe) return;
      const me = ae.getFlags();
      if (!me[oe.key] || me[oe.key].version < oe.version) {
        g.debug(Fe.debugStreamDelete(oe.key));
        const _e = {};
        me[oe.key] && !me[oe.key].deleted && (_e[oe.key] = { previous: me[oe.key].value }), me[oe.key] = { version: oe.version, deleted: !0 }, ae.setFlags(me), De(oe, me[oe.key]), qa(_e);
      } else g.debug(Fe.debugStreamDeleteIgnored(oe.key));
    } });
  }
  function zl() {
    Ce && (ge.disconnect(), Ce = !1);
  }
  function Ae(Z) {
    const de = {};
    if (!Z) return Promise.resolve();
    const oe = ae.getFlags();
    for (const me in oe) tt.objectHasOwnProperty(oe, me) && oe[me] && (Z[me] && !tt.deepEquals(Z[me].value, oe[me].value) ? de[me] = { previous: oe[me].value, current: en(Z[me]) } : Z[me] && !Z[me].deleted || (de[me] = { previous: oe[me].value }));
    for (const me in Z) tt.objectHasOwnProperty(Z, me) && Z[me] && (!oe[me] || oe[me].deleted) && (de[me] = { current: en(Z[me]) });
    return ae.setFlags({ ...Z }), ze(), qa(de).catch(() => {
    });
  }
  function qa(Z) {
    const de = Object.keys(Z);
    if (de.length > 0) {
      const oe = {};
      de.forEach((me) => {
        const _e = Z[me].current, vt = _e ? _e.value : void 0, et = Z[me].previous;
        S.emit(I1 + ":" + me, vt, et), oe[me] = _e ? { current: vt, previous: et } : { previous: et };
      }), S.emit(I1, oe), S.emit(pO, ae.getFlagsWithOverrides()), O.sendEventsOnlyForVariation || fe || de.forEach((me) => {
        At(me, Z[me].current);
      });
    }
    return Me && ee ? ee.saveFlags(ae.getFlags()) : Promise.resolve();
  }
  function va() {
    const Z = We || we && We === void 0;
    Z && !Ce ? Mn() : !Z && Ce && zl(), Te && Te.setStreaming(Z);
  }
  function na(Z) {
    return Z === I1 || Z.substr(0, 7) === I1 + ":";
  }
  if (typeof O.bootstrap == "string" && O.bootstrap.toUpperCase() === "LOCALSTORAGE" && (ee ? Me = !0 : g.warn(Fe.localStorageUnavailable())), typeof O.bootstrap == "object" && ae.setFlags((function(Z) {
    const de = Object.keys(Z), oe = "$flagsState", me = "$valid", _e = Z[oe];
    !_e && de.length && g.warn(Fe.bootstrapOldFormat()), Z[me] === !1 && g.warn(Fe.bootstrapInvalid());
    const vt = {};
    return de.forEach((et) => {
      if (et !== oe && et !== me) {
        let St = { value: Z[et] };
        _e && _e[et] ? St = tt.extend(St, _e[et]) : St.version = 0, vt[et] = St;
      }
    }), vt;
  })(O.bootstrap)), fe) {
    const Z = fe.getInitialState();
    Z ? $l(Z) : fe.on("init", $l), fe.on("update", function(de) {
      de.context && be.setContext(de.context), de.flags && Ae(de.flags);
    });
  } else (function() {
    if (!r) return Promise.reject(new wn.LDInvalidEnvironmentIdError(Fe.environmentNotSpecified()));
    let Z;
    return Be.processContext(f).then(Rn).then((de) => (Z = tt.once(Y.identify(de, void 0)), de)).then((de) => (Z?.({ status: "completed" }), be.setContext(de), typeof O.bootstrap == "object" ? He() : Me ? ee.loadFlags().then((oe) => oe == null ? (ae.setFlags({}), xe.fetchFlagSettings(be.getContext(), L).then((me) => Ae(me || {})).then(He).catch((me) => {
      wt(new wn.LDFlagFetchError(Fe.errorFetchingFlags(me)));
    })) : (ae.setFlags(oe), tt.onNextTick(He), xe.fetchFlagSettings(be.getContext(), L).then((me) => Ae(me)).catch((me) => S.maybeReportError(me)))) : xe.fetchFlagSettings(be.getContext(), L).then((oe) => {
      ae.setFlags(oe || {}), ze(), He();
    }).catch((oe) => {
      ae.setFlags({}), wt(oe);
    }))).catch((de) => {
      throw Z?.({ status: "error" }), de;
    });
  })().catch(wt);
  function $l(Z) {
    z = Z.environment, be.setContext(Z.context), ae.setFlags({ ...Z.flags }), tt.onNextTick(He);
  }
  function He() {
    g.info(Fe.clientInitialized()), Rt = !0, va(), E.signalSuccess();
  }
  function wt(Z) {
    E.signalFailure(Z);
  }
  const jt = { waitForInitialization: function(Z = void 0) {
    if (Z != null) {
      if (typeof Z == "number") return (function(de) {
        de > 5 && g.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
        const oe = E.getInitializationPromise(), me = PC(de, "waitForInitialization");
        return Promise.race([me, oe]).catch((_e) => {
          throw _e instanceof wn.LDTimeoutError && g.error(`waitForInitialization error: ${_e}`), _e;
        });
      })(Z);
      g.warn("The waitForInitialization method was provided with a non-numeric timeout.");
    }
    return g.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), E.getInitializationPromise();
  }, waitUntilReady: () => E.getReadyPromise(), identify: function(Z, de, oe) {
    if (H) return tt.wrapPromiseCallback(Promise.resolve({}), oe);
    if (fe) return g.warn(Fe.identifyDisabled()), tt.wrapPromiseCallback(Promise.resolve(tt.transformVersionedValuesToValues(ae.getFlagsWithOverrides())), oe);
    let me;
    const _e = Me && ee ? ee.clearFlags() : Promise.resolve();
    return tt.wrapPromiseCallback(_e.then(() => Be.processContext(Z)).then(Rn).then((vt) => (me = tt.once(Y.identify(vt, void 0)), vt)).then((vt) => xe.fetchFlagSettings(vt, de).then((et) => {
      const St = tt.transformVersionedValuesToValues(et);
      return be.setContext(vt), L = de, et ? Ae(et).then(() => St) : St;
    })).then((vt) => (me?.({ status: "completed" }), Ce && Mn(), vt)).catch((vt) => (me?.({ status: "error" }), S.maybeReportError(vt), Promise.reject(vt))), oe);
  }, getContext: function() {
    return be.getContext();
  }, variation: function(Z, de) {
    const { value: oe } = Y.withEvaluation(Z, be.getContext(), de, () => ft(Z, de, !0, !1, !1, !0));
    return oe;
  }, variationDetail: function(Z, de) {
    return Y.withEvaluation(Z, be.getContext(), de, () => ft(Z, de, !0, !0, !1, !0));
  }, track: function(Z, de, oe) {
    if (typeof Z != "string") return void S.maybeReportError(new wn.LDInvalidEventKeyError(Fe.unknownCustomEventKey(Z)));
    oe !== void 0 && typeof oe != "number" && g.warn(Fe.invalidMetricValue(typeof oe)), h.customEventFilter && !h.customEventFilter(Z) && g.warn(Fe.unknownCustomEventKey(Z));
    const me = be.getContext(), _e = { kind: "custom", key: Z, context: me, url: h.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    me && me.anonymous && (_e.contextKind = me.anonymous ? "anonymousUser" : "user"), de != null && (_e.data = de), oe != null && (_e.metricValue = oe), ve(_e), Y.afterTrack({ context: me, key: Z, data: de, metricValue: oe });
  }, on: function(Z, de, oe) {
    na(Z) ? (we = !0, Rt && va(), S.on(Z, de, oe)) : S.on(...arguments);
  }, off: function(Z) {
    if (S.off(...arguments), na(Z)) {
      let de = !1;
      S.getEvents().forEach((oe) => {
        na(oe) && S.getEventListenerCount(oe) > 0 && (de = !0);
      }), de || (we = !1, Ce && We === void 0 && zl());
    }
  }, setStreaming: function(Z) {
    const de = Z === null ? void 0 : Z;
    de !== We && (We = de, va());
  }, flush: function(Z) {
    return tt.wrapPromiseCallback(_ ? Se.flush() : Promise.resolve(), Z);
  }, allFlags: function() {
    const Z = {}, de = ae.getFlagsWithOverrides();
    if (!de) return Z;
    for (const oe in de) Z[oe] = ft(oe, null, !O.sendEventsOnlyForVariation, !1, !0, !1).value;
    return Z;
  }, close: function(Z) {
    if (H) return tt.wrapPromiseCallback(Promise.resolve(), Z);
    const de = () => {
      H = !0, ae.setFlags({});
    }, oe = Promise.resolve().then(() => {
      if (zl(), Te && Te.stop(), _) return Se.stop(), Se.flush();
    }).then(de).catch(de);
    return tt.wrapPromiseCallback(oe, Z);
  }, addHook: function(Z) {
    Y.addHook(Z);
  } };
  return oz(g, N, jt, Q), cz(g, { setOverride: function(Z, de) {
    const oe = {}, me = ae.get(Z), _e = me ? me.value : null;
    if (_e === de) return void g.debug(`setOverride: No change needed for ${Z}, value already ${de}`);
    ae.setOverride(Z, de);
    const vt = ae.get(Z), et = en(vt);
    oe[Z] = { previous: _e, current: et }, De({ key: Z }, vt), qa(oe);
  }, removeOverride: function(Z) {
    const de = ae.getFlagOverrides();
    if (!de[Z]) return;
    const oe = {}, me = de[Z], _e = ae.getFlags()[Z];
    oe[Z] = { previous: me.value, current: _e ? en(_e) : void 0 }, ae.removeOverride(Z), De({ key: Z }, _e), qa(oe);
  }, clearAllOverrides: function() {
    const Z = ae.getFlagOverrides();
    if (Object.keys(Z).length === 0) return;
    const de = {}, oe = ae.getFlags();
    Object.keys(Z).forEach((me) => {
      const _e = Z[me], vt = oe[me];
      de[me] = { previous: _e.value, current: vt ? en(vt) : void 0 };
    }), ae.clearAllOverrides(), Object.keys(de).length > 0 && qa(de);
  }, getAllOverrides: function() {
    const Z = ae.getFlagOverrides();
    if (!Z) return {};
    const de = {};
    return Object.keys(Z).forEach((oe) => {
      const me = Z[oe];
      me && (de[oe] = me.value);
    }), de;
  } }, Q), { client: jt, options: O, emitter: S, ident: be, logger: g, requestor: xe, start: function() {
    _ && (Te && Te.start(), Se.start());
  }, enqueueEvent: ve, getFlagsInternal: function() {
    return ae.getFlagsWithOverrides();
  }, getEnvironmentId: () => z, internalChangeEventName: pO };
}, errors: wn }, sz = CD.initialize, fz = CD.errors;
function dz(r, f, m) {
  return (f = (function(h) {
    var v = (function(g, S) {
      if (typeof g != "object" || !g) return g;
      var E = g[Symbol.toPrimitive];
      if (E !== void 0) {
        var O = E.call(g, S);
        if (typeof O != "object") return O;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (S === "string" ? String : Number)(g);
    })(h, "string");
    return typeof v == "symbol" ? v : v + "";
  })(f)) in r ? Object.defineProperty(r, f, { value: m, enumerable: !0, configurable: !0, writable: !0 }) : r[f] = m, r;
}
function yO(r, f) {
  var m = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(r);
    f && (h = h.filter(function(v) {
      return Object.getOwnPropertyDescriptor(r, v).enumerable;
    })), m.push.apply(m, h);
  }
  return m;
}
function gO(r) {
  for (var f = 1; f < arguments.length; f++) {
    var m = arguments[f] != null ? arguments[f] : {};
    f % 2 ? yO(Object(m), !0).forEach(function(h) {
      dz(r, h, m[h]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(m)) : yO(Object(m)).forEach(function(h) {
      Object.defineProperty(r, h, Object.getOwnPropertyDescriptor(m, h));
    });
  }
  return r;
}
var vO = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function hz(r, f, m, h, v) {
  if (v && !(function() {
    var R = window.navigator && window.navigator.userAgent;
    if (R) {
      var _ = R.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (_) return parseInt(_[2], 10) < 73;
    }
    return !0;
  })()) return vO;
  var g = new window.XMLHttpRequest();
  for (var S in g.open(r, f, !v), m || {}) Object.prototype.hasOwnProperty.call(m, S) && g.setRequestHeader(S, m[S]);
  if (v) {
    try {
      g.send(h);
    } catch {
    }
    return vO;
  }
  var E, O = new Promise(function(R, _) {
    g.addEventListener("load", function() {
      E || R({ status: g.status, header: function(z) {
        return g.getResponseHeader(z);
      }, body: g.responseText });
    }), g.addEventListener("error", function() {
      E || _(new Error());
    }), g.send(h);
  });
  return { promise: O, cancel: function() {
    E = !0, g.abort();
  } };
}
var bE = (r) => {
  if (typeof r != "string") throw new TypeError("Expected a string");
  return r.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function mz(r, f, m, h) {
  var v, g, S = ((r.kind === "substring" || r.kind === "regex") && h.includes("/") ? f : f.replace(h, "")).replace(m, "");
  switch (r.kind) {
    case "exact":
      g = f, v = new RegExp("^" + bE(r.url) + "/?$");
      break;
    case "canonical":
      g = S, v = new RegExp("^" + bE(r.url) + "/?$");
      break;
    case "substring":
      g = S, v = new RegExp(".*" + bE(r.substring) + ".*$");
      break;
    case "regex":
      g = S, v = new RegExp(r.pattern);
      break;
    default:
      return !1;
  }
  return v.test(g);
}
function bO(r, f) {
  for (var m = {}, h = null, v = [], g = 0; g < r.length; g++) for (var S = r[g], E = S.urls || [], O = 0; O < E.length; O++) if (mz(E[O], window.location.href, window.location.search, window.location.hash)) {
    S.kind === "pageview" ? f("pageview", S) : (v.push(S), f("click_pageview", S));
    break;
  }
  return v.length > 0 && (h = function(R) {
    for (var _ = (function(L, Q) {
      for (var N = [], G = 0; G < Q.length; G++) for (var Y = L.target, F = Q[G], ne = F.selector, ye = document.querySelectorAll(ne); Y && ye.length > 0; ) {
        for (var pe = 0; pe < ye.length; pe++) Y === ye[pe] && N.push(F);
        Y = Y.parentNode;
      }
      return N;
    })(R, v), z = 0; z < _.length; z++) f("click", _[z]);
  }, document.addEventListener("click", h)), m.dispose = function() {
    document.removeEventListener("click", h);
  }, m;
}
function pz(r, f) {
  var m, h;
  function v() {
    h && h.dispose(), m && m.length && (h = bO(m, g));
  }
  function g(S, E) {
    var O = r.ident.getContext(), R = { kind: S, key: E.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: O };
    return S === "click" && (R.selector = E.selector), r.enqueueEvent(R);
  }
  return r.requestor.fetchJSON("/sdk/goals/" + r.getEnvironmentId()).then(function(S) {
    S && S.length > 0 && (h = bO(m = S, g), (function(E, O) {
      var R, _ = window.location.href;
      function z() {
        (R = window.location.href) !== _ && (_ = R, O());
      }
      (function L(Q, N) {
        Q(), setTimeout(function() {
          L(Q, N);
        }, N);
      })(z, E), window.history && window.history.pushState ? window.addEventListener("popstate", z) : window.addEventListener("hashchange", z);
    })(300, v)), f();
  }).catch(function(S) {
    r.emitter.maybeReportError(new fz.LDUnexpectedResponseError((S && S.message, S.message))), f();
  }), {};
}
var P1 = "goalsReady", yz = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function gz(r, f) {
  var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = (function(_) {
    var z, L = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var Q = _ && _.disableSyncEventPost;
      L.httpRequest = function(F, ne, ye, pe) {
        var he = L.synchronousFlush & !Q;
        return L.synchronousFlush = !1, hz(F, ne, ye, pe, he);
      };
    }
    L.httpAllowsPost = function() {
      return z === void 0 && (z = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), z;
    }, L.httpFallbackPing = function(F) {
      new window.Image().src = F;
    };
    var N, G = _ && _.eventUrlTransformer;
    L.getCurrentUrl = function() {
      return G ? G(window.location.href) : window.location.href;
    }, L.isDoNotTrack = function() {
      var F;
      return (F = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || F === !0 || F === "1" || F === "yes";
    };
    try {
      window.localStorage && (L.localStorage = { get: function(F) {
        return new Promise(function(ne) {
          ne(window.localStorage.getItem(F));
        });
      }, set: function(F, ne) {
        return new Promise(function(ye) {
          window.localStorage.setItem(F, ne), ye();
        });
      }, clear: function(F) {
        return new Promise(function(ne) {
          window.localStorage.removeItem(F), ne();
        });
      } });
    } catch {
      L.localStorage = null;
    }
    if (_ && _.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (L.eventSourceAllowsReport = !0, N = window.EventSourcePolyfill) : (L.eventSourceAllowsReport = !1, N = window.EventSource), window.EventSource) {
      var Y = 3e5;
      L.eventSourceFactory = function(F, ne) {
        var ye = gO(gO({}, { heartbeatTimeout: Y, silentTimeout: Y, skipDefaultHeaders: !0 }), ne);
        return new N(F, ye);
      }, L.eventSourceIsActive = function(F) {
        return F.readyState === window.EventSource.OPEN || F.readyState === window.EventSource.CONNECTING;
      };
    }
    return L.userAgent = "JSClient", L.version = "3.9.0", L.diagnosticSdkData = { name: "js-client-sdk", version: "3.9.0" }, L.diagnosticPlatformData = { name: "JS" }, L.diagnosticUseCombinedEvent = !0, L;
  })(m), v = sz(r, f, m, h, yz), g = v.client, S = v.options, E = v.emitter, O = new Promise(function(_) {
    var z = E.on(P1, function() {
      E.off(P1, z), _();
    });
  });
  g.waitUntilGoalsReady = function() {
    return O;
  }, S.fetchGoals ? pz(v, function() {
    return E.emit(P1);
  }) : E.emit(P1), document.readyState !== "complete" ? window.addEventListener("load", v.start) : v.start();
  var R = function() {
    h.synchronousFlush = !0, g.flush().catch(function() {
    }), h.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && R();
  }), window.addEventListener("pagehide", R), g;
}
function vz(r = yb.CAPS) {
  const f = R3[r];
  switch (s0()) {
    case Bt.DEV:
    case Bt.LAB:
      return f[Bt.DEV];
    case Bt.QA:
      return f[Bt.QA];
    case Bt.TEST:
    case Bt.TEST1:
    case Bt.TEST2:
    case Bt.TEST3:
    case Bt.TEST4:
    case Bt.TEST5:
      return f[Bt.TEST];
    default:
      return f[Bt.PRODUCTION];
  }
}
function bz(r, f) {
  const m = r.getContext();
  return JSON.stringify(m) !== JSON.stringify(f);
}
let Bs;
const eb = {};
function SE(r, f) {
  console.error(`Failed to ${r} LaunchDarkly client context`, f);
}
function SO() {
  Bs = void 0;
}
async function Sz(r) {
  const { context: f, project: m = yb.CAPS } = r || {};
  if (eb[m] && Bs) {
    Bs = eb[m];
    const v = f && GE(f);
    if (v && bz(Bs, v))
      try {
        await Bs.identify(v);
      } catch (g) {
        SE("update", g);
      }
    return Bs;
  }
  if (!f)
    throw new Error(
      "Cannot initialize LaunchDarkly client without a Context or User"
    );
  let h;
  try {
    h = gz(
      vz(m),
      GE(f)
    );
  } catch (v) {
    SE("initialize", v), SO();
    return;
  }
  try {
    await h.waitForInitialization(5), eb[m] = h, Bs = eb[m];
  } catch (v) {
    SE("finish initializing", v), SO();
    return;
  }
  return Bs;
}
function zD(r) {
  const { user: f, isLoading: m, error: h } = TD(), [v, g] = Rl(!0), [S, E] = Rl(h), [O, R] = Rl(), { context: _, project: z, shouldDeferInitialization: L } = r ?? {};
  return Cl(() => {
    E(h);
  }, [h]), Cl(() => {
    (async () => {
      if (!(!!f && !m && !h)) {
        g(!1);
        return;
      }
      if (g(!0), R(void 0), L)
        return;
      const G = [f, ..._ ? [_] : []];
      try {
        R(
          await Sz({
            context: GE(...G),
            project: z
          })
        );
      } catch (Y) {
        E(`${Y}`);
      } finally {
        g(!1);
      }
    })();
  }, [
    _,
    z,
    f,
    h,
    m,
    L
  ]), {
    launchDarklyClient: O,
    isLoading: !O && !S && !h && (v || m),
    error: S
  };
}
function z5(r) {
  const [f, m] = Rl(), [h, v] = Rl({
    goTo: EE.bind(void 0, void 0, m),
    toURL: TE.bind(void 0, void 0)
  });
  return Cl(() => {
    if (!r) {
      v({
        goTo: EE.bind(
          void 0,
          void 0,
          m
        ),
        toURL: TE.bind(void 0, void 0)
      });
      return;
    }
    v({
      goTo: EE.bind(
        void 0,
        r,
        m
      ),
      toURL: TE.bind(void 0, r)
    });
  }, [r]), Cl(() => {
    f && r && (gb(f[0], f[1], r), m(void 0));
  }, [f, r]), h;
}
function EE(r, f, m, h) {
  if (!r) {
    f([m, h]);
    return;
  }
  try {
    gb(m, h, r);
  } catch (v) {
    console.error("Error in goTo:", v);
  }
}
function TE(r, f, m) {
  let h = "";
  try {
    h = Pm(f, m, r);
  } catch (v) {
    console.error("Error in toURL:", v);
  }
  return h;
}
function _5(r) {
  const { dealerId: f, aggregatorPartner: m, isMultiContextValueReady: h } = r, v = tp(() => {
    if (!(h === !1 || !f))
      return {
        kind: "multi",
        dealer: { kind: "dealer", key: f },
        "aggregator-partner": {
          kind: "aggregator-partner",
          key: m || "NONE"
          // Use "NONE" as default key if aggregatorPartner is not provided to induce a false flag variation if there is not lead source data
        }
      };
  }, [f, m, h]);
  return zD({
    project: yb.CAPS_BACKEND,
    context: v,
    shouldDeferInitialization: h === !1
    // Defer initialization until context values are ready to avoid incorrect flag evaluations
  });
}
function U5(r, f) {
  return fb[r].domain === "pageHosting" ? !1 : f ? !XO(
    r,
    void 0,
    f
  ).startsWith("https://ui") : !0;
}
function _D(r, { cleanup: f = !1, appendTo: m = "body", enabled: h = !0 } = {}) {
  const [v, g] = Rl(!1), [S, E] = Rl(!1);
  return Cl(() => {
    if (!r || !h)
      return;
    let O = document.querySelector(
      `script[src="${r}"]`
    );
    O || (O = document.createElement("script"), O.src = r, O.async = !0, document[m].append(O));
    const R = () => {
      E(!0), g(!1), O.dataset.loaded = "true";
    }, _ = () => {
      g(!0), E(!1), O.dataset.error = "true";
    };
    return O.dataset.loaded === "true" || O.dataset.error === "true" ? (E(O.dataset.loaded === "true"), g(O.dataset.error === "true")) : (O.addEventListener("load", R), O.addEventListener("error", _)), () => {
      O.removeEventListener("load", R), O.removeEventListener("error", _), f && (O.dataset.loaded === "true" || O.dataset.error === "true") && O.remove();
    };
  }, [r, f, m, h]), { error: v, loaded: S };
}
let AE = [], tb = !1;
const OE = /* @__PURE__ */ new Set();
function w5(r) {
  const f = window.location.hostname.includes("local") ?? !1, m = c3(
    window.environment === "production",
    r
  ), { launchDarklyClient: h, isLoading: v } = zD(), g = !v && (h?.variation(
    r0.adobeTagManager,
    !0
  ) ?? !0), { loaded: S, error: E } = _D(m, {
    appendTo: "head",
    enabled: g
  }), [O, R] = Rl(
    tb
  );
  Cl(() => (OE.add(R), () => {
    OE.delete(R);
  }), []), Cl(() => {
    if (S && !tb) {
      window.adobeDataLayer = window.adobeDataLayer || [];
      const z = [...AE];
      if (f && z.length > 0)
        console.log(
          "Adobe Analytics events skipped in local environment, queuedEvent that would have been pushed to data layer:",
          z
        );
      else
        for (const L of z)
          window.adobeDataLayer.push(L);
      AE = [], tb = !0;
      for (const L of OE)
        L(!0);
    }
  }, [S, f]);
  const _ = c0(
    (z) => {
      if (!tb) {
        AE.push(z);
        return;
      }
      if (f) {
        console.log(
          "Adobe Analytics event skipped in local environment, event data that would have been pushed to data layer:",
          z
        );
        return;
      }
      window.adobeDataLayer.push(z);
    },
    [f]
  );
  return {
    loaded: O,
    error: E,
    queueAdobeAnalyticsEvent: _
  };
}
function M5({
  dealerId: r,
  dealerName: f,
  userName: m,
  isProxied: h,
  userRole: v,
  crmContactId: g
}, S) {
  return {
    event: l3.pageView,
    is_spa: "true",
    signed_in_status: "logged in",
    page_url: window.location.href,
    crm_contact_id: g ?? "",
    account_type: "dealer",
    environment: window.environment,
    dealer_name: f?.toLowerCase() ?? "",
    dealer_id: r?.toLowerCase() ?? "",
    br_language: navigator.language?.toLowerCase(),
    web_lang: navigator.language?.toLowerCase(),
    caps_user_id: m?.toLowerCase() ?? "",
    isProxied: h.toString() ?? "false",
    user_role_name: v,
    ...S
    //user_id:???? User endpoint need user_id
  };
}
const EO = 100;
function N5({
  key: r,
  value: f,
  additionalData: m,
  parentActionId: h = !1
}) {
  if (window.dtrum)
    try {
      window.dtrum?.reportCustomError(
        r,
        f?.slice(0, EO),
        m?.slice(0, EO),
        h
      );
    } catch {
    }
}
const TO = {
  TEST_ENV: "JCFPX",
  PRODUCTION: "JPV5D"
}, x5 = "fs-exclude";
var Ez = function() {
  var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, m = f.wnd, h = m === void 0 ? window : m;
  (function(v, g, S, E, O, R, _, z) {
    var L = (function(G) {
      return G in v ? (v.console && v.console.log && v.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'), !1) : !0;
    })(S);
    if (!L) return;
    function Q(N) {
      var G = [], Y;
      function F() {
        Y && (G.forEach(function(pe) {
          var he;
          try {
            he = pe[Y[0]] && pe[Y[0]](Y[1]);
          } catch (Te) {
            pe[3] && pe[3](Te);
            return;
          }
          he && he.then ? he.then(pe[2], pe[3]) : pe[2] && pe[2](he);
        }), G.length = 0);
      }
      function ne(pe) {
        return function(he) {
          Y || (Y = [pe, he], F());
        };
      }
      N(ne(0), ne(1));
      function ye(pe, he) {
        return Q(function(Te, ge) {
          G.push([pe, he, Te, ge]), F();
        });
      }
      return {
        then: ye
      };
    }
    _ = v[S] = (function() {
      var G = function(ne, ye, pe, he) {
        he = he || 2;
        function Te(xe, ae) {
          Y(ne, ye, pe, xe, ae, he);
        }
        var ge = /Async$/;
        if (ge.test(ne))
          return ne = ne.replace(ge, ""), typeof Promise == "function" ? new Promise(Te) : Q(Te);
        var Se;
        return Y(ne, ye, pe, Se, Se, he);
      };
      function Y(F, ne, ye, pe, he, Te) {
        return G._api ? G._api(F, ne, ye, pe, he, Te) : (G.q && G.q.push([F, ne, ye, pe, he, Te]), null);
      }
      return G.q = [], G;
    })(), z = /* @__PURE__ */ (function() {
      return function(G) {
        function Y(ye) {
          typeof ye[4] == "function" && ye[4](new Error(G));
        }
        var F = _.q;
        if (F) {
          for (var ne = 0; ne < F.length; ne++)
            Y(F[ne]);
          F.length = 0, F.push = Y;
        }
      };
    })(), (function() {
      R = g.createElement(E), R.async = !0, R.crossOrigin = "anonymous", R.src = "https://" + O, R.onerror = function() {
        z("Error loading " + O);
      };
      var G = g.getElementsByTagName(E)[0];
      G && G.parentNode ? G.parentNode.insertBefore(R, G) : g.head.appendChild(R);
    })(), (function() {
      function G() {
      }
      function Y(pe, he, Te) {
        _(pe, he, Te, 1);
      }
      function F(pe, he, Te) {
        Y("setProperties", {
          type: pe,
          properties: he
        }, Te);
      }
      function ne(pe, he) {
        F("user", pe, he);
      }
      function ye(pe, he, Te) {
        ne({
          uid: pe
        }, Te), he && ne(he, Te);
      }
      _.identify = ye, _.setUserVars = ne, _.identifyAccount = G, _.clearUserCookie = G, _.setVars = F, _.event = function(pe, he, Te) {
        Y("trackEvent", {
          name: pe,
          properties: he
        }, Te);
      }, _.anonymize = function() {
        ye(!1);
      }, _.shutdown = function() {
        Y("shutdown");
      }, _.restart = function() {
        Y("restart");
      }, _.log = function(pe, he) {
        Y("log", {
          level: pe,
          msg: he
        });
      }, _.consent = function(pe) {
        Y("setIdentity", {
          consent: !arguments.length || pe
        });
      };
    })(), (function() {
      var G = "fetch", Y = "XMLHttpRequest";
      _._w = {}, _._w[Y] = v[Y], _._w[G] = v[G], v[G] && (v[G] = function() {
        return _._w[G].apply(this, arguments);
      });
    })(), _._v = "2.0.0";
  })(h, h.document, h._fs_namespace, "script", h._fs_script);
}, Tz = function(f) {
  return f === "window" ? "document" : "".concat(f, ".document");
}, Az = function() {
  var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, m = f.shouldInsertScript, h = m === void 0 ? !0 : m, v = f.globalVar, g = v === void 0 ? "window" : v, S = f.apiVersion, E = S === void 0 ? "1.3.0" : S;
  return `(function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];`.concat(h ? `
    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);` : "", `
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.anonymize=function(){g.identify(!!0)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.log = function(a,b){g("log",[a,b])};
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
    g.setVars=function(n, p){g('setVars',[n,p]);};
    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
    g._v="`).concat(E, `";
})(`).concat(g, ",").concat(Tz(g), ",").concat(g, "['_fs_namespace'],'script','user');");
}, Oz = function(f) {
  var m = f.orgId, h = f.namespace, v = h === void 0 ? "FS" : h, g = f.host, S = g === void 0 ? "fullstory.com" : g, E = f.script, O = E === void 0 ? "edge.fullstory.com/s/fs.js" : E;
  if (!m)
    throw new Error("FullStory orgId is a required parameter");
  window._fs_host = S, window._fs_script = O, window._fs_org = m, window._fs_namespace = v, Ez();
};
Az();
var XE = function() {
  return XE = Object.assign || function(f) {
    for (var m, h = 1, v = arguments.length; h < v; h++) {
      m = arguments[h];
      for (var g in m) Object.prototype.hasOwnProperty.call(m, g) && (f[g] = m[g]);
    }
    return f;
  }, XE.apply(this, arguments);
}, AO = function() {
  if (window._fs_namespace)
    return window[window._fs_namespace];
}, Dz = function(r, f) {
  var m = XE({}, r);
  if (AO()) {
    console.warn("The FullStory snippet has already been defined elsewhere (likely in the <head> element)");
    return;
  }
  m.recordCrossDomainIFrames && (window._fs_run_in_iframe = !0), m.appHost && (window._fs_app_host = m.appHost), m.assetMapId && (window._fs_asset_map_id = m.assetMapId), m.startCaptureManually && (window._fs_capture_on_startup = !1), m.recordOnlyThisIFrame && (window._fs_is_outer_script = !0), m.cookieDomain && (window._fs_cookie_domain = m.cookieDomain), m.debug === !0 && (m.script ? console.warn("Ignoring `debug = true` because `script` is set") : m.script = "edge.fullstory.com/s/fs-debug.js"), Oz(m);
  var h = AO();
  if (!h) {
    console.warn("Failed to initialize FS snippet");
    return;
  }
  if (f && h("observe", { type: "start", callback: f }), m.devMode === !0) {
    var v = "FullStory was initialized in devMode and will stop recording";
    h("trackEvent", {
      name: "FullStory Dev Mode",
      properties: {
        message: v
      }
    }), h("shutdown"), window._fs_dev_mode = !0, console.warn(v);
  }
}, Rz = function(r) {
  return function(f, m) {
    if (window._fs_initialized) {
      r && console.warn(r);
      return;
    }
    Dz(f, m), window._fs_initialized = !0;
  };
}, Cz = Rz("FullStory init has already been called once, additional invocations are ignored");
function H5() {
  Cl(() => {
    const r = window.environment === "production" ? TO.PRODUCTION : TO.TEST_ENV;
    Cz({ orgId: r });
  }, []);
}
const zz = /ui(\w+)?\.creditacceptance\.com/;
async function _z() {
  if (!zz.test(window.location.host))
    return {
      isAuthenticated: !1,
      isRedirectingToLogin: !1
    };
  let f = !1;
  try {
    f = (await fetch("/oauth2/auth", {
      method: "GET",
      credentials: "include"
    })).ok;
  } catch {
    f = !1;
  }
  if (!f) {
    const m = encodeURIComponent(
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    ), h = `${window.location.origin}/oauth2/start?rd=${m}`;
    return window.location.assign(h), {
      isAuthenticated: !1,
      isRedirectingToLogin: !0
    };
  }
  return {
    isAuthenticated: f,
    isRedirectingToLogin: !1
  };
}
function L5({
  checkCAPS: r = !0
} = {}) {
  const [f, m] = Rl(!0), [h, v] = Rl(!1), [g, S] = Rl(!1), E = bi(!1), O = bi(!1), R = bi(!1), { user: _, error: z } = TD({ enabled: r }), L = c0(async () => {
    try {
      const Q = await _z();
      O.current = Q.isRedirectingToLogin, v(Q.isAuthenticated), S(!0), !Q.isRedirectingToLogin && !r && m(!1);
    } catch (Q) {
      if (console.error("Error checking OAuth authentication", Q), window.isLocalDealerUI && !r) {
        m(!1);
        return;
      }
    }
  }, [r]);
  return Cl(() => {
    E.current || (m(!0), E.current = !0, L());
  }, [L]), Cl(() => {
    if (r && !(!g || O.current))
      if (z) {
        if (R.current)
          return;
        if (window.isLocalDealerUI) {
          m(!1);
          return;
        }
        R.current = !0;
        const Q = encodeURIComponent(
          `${window.location.pathname}${window.location.search}${window.location.hash}`
        );
        gb("login", { pageHostingReturnPath: Q });
      } else _ && m(!1);
  }, [r, h, g, _, z]), {
    isLoading: f,
    isAuthenticated: h && (!r || !!_)
  };
}
const B5 = "[^\\/]+";
function j5(r) {
  return window.isLocalDealerUI ? "/assets" : `/pages/${r}`;
}
const q5 = {
  SUCCESS: 200,
  FORBIDDEN: 403
};
var nb = { exports: {} }, i0 = {}, ab = { exports: {} }, DE = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OO;
function Uz() {
  return OO || (OO = 1, (function(r) {
    function f(H, ue) {
      var fe = H.length;
      H.push(ue);
      e: for (; 0 < fe; ) {
        var be = fe - 1 >>> 1, Be = H[be];
        if (0 < v(Be, ue))
          H[be] = ue, H[fe] = Be, fe = be;
        else break e;
      }
    }
    function m(H) {
      return H.length === 0 ? null : H[0];
    }
    function h(H) {
      if (H.length === 0) return null;
      var ue = H[0], fe = H.pop();
      if (fe !== ue) {
        H[0] = fe;
        e: for (var be = 0, Be = H.length, ee = Be >>> 1; be < ee; ) {
          var ve = 2 * (be + 1) - 1, De = H[ve], ze = ve + 1, At = H[ze];
          if (0 > v(De, fe))
            ze < Be && 0 > v(At, De) ? (H[be] = At, H[ze] = fe, be = ze) : (H[be] = De, H[ve] = fe, be = ve);
          else if (ze < Be && 0 > v(At, fe))
            H[be] = At, H[ze] = fe, be = ze;
          else break e;
        }
      }
      return ue;
    }
    function v(H, ue) {
      var fe = H.sortIndex - ue.sortIndex;
      return fe !== 0 ? fe : H.id - ue.id;
    }
    if (r.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var g = performance;
      r.unstable_now = function() {
        return g.now();
      };
    } else {
      var S = Date, E = S.now();
      r.unstable_now = function() {
        return S.now() - E;
      };
    }
    var O = [], R = [], _ = 1, z = null, L = 3, Q = !1, N = !1, G = !1, Y = !1, F = typeof setTimeout == "function" ? setTimeout : null, ne = typeof clearTimeout == "function" ? clearTimeout : null, ye = typeof setImmediate < "u" ? setImmediate : null;
    function pe(H) {
      for (var ue = m(R); ue !== null; ) {
        if (ue.callback === null) h(R);
        else if (ue.startTime <= H)
          h(R), ue.sortIndex = ue.expirationTime, f(O, ue);
        else break;
        ue = m(R);
      }
    }
    function he(H) {
      if (G = !1, pe(H), !N)
        if (m(O) !== null)
          N = !0, Te || (Te = !0, Ce());
        else {
          var ue = m(R);
          ue !== null && Rt(he, ue.startTime - H);
        }
    }
    var Te = !1, ge = -1, Se = 5, xe = -1;
    function ae() {
      return Y ? !0 : !(r.unstable_now() - xe < Se);
    }
    function Me() {
      if (Y = !1, Te) {
        var H = r.unstable_now();
        xe = H;
        var ue = !0;
        try {
          e: {
            N = !1, G && (G = !1, ne(ge), ge = -1), Q = !0;
            var fe = L;
            try {
              t: {
                for (pe(H), z = m(O); z !== null && !(z.expirationTime > H && ae()); ) {
                  var be = z.callback;
                  if (typeof be == "function") {
                    z.callback = null, L = z.priorityLevel;
                    var Be = be(
                      z.expirationTime <= H
                    );
                    if (H = r.unstable_now(), typeof Be == "function") {
                      z.callback = Be, pe(H), ue = !0;
                      break t;
                    }
                    z === m(O) && h(O), pe(H);
                  } else h(O);
                  z = m(O);
                }
                if (z !== null) ue = !0;
                else {
                  var ee = m(R);
                  ee !== null && Rt(
                    he,
                    ee.startTime - H
                  ), ue = !1;
                }
              }
              break e;
            } finally {
              z = null, L = fe, Q = !1;
            }
            ue = void 0;
          }
        } finally {
          ue ? Ce() : Te = !1;
        }
      }
    }
    var Ce;
    if (typeof ye == "function")
      Ce = function() {
        ye(Me);
      };
    else if (typeof MessageChannel < "u") {
      var we = new MessageChannel(), We = we.port2;
      we.port1.onmessage = Me, Ce = function() {
        We.postMessage(null);
      };
    } else
      Ce = function() {
        F(Me, 0);
      };
    function Rt(H, ue) {
      ge = F(function() {
        H(r.unstable_now());
      }, ue);
    }
    r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(H) {
      H.callback = null;
    }, r.unstable_forceFrameRate = function(H) {
      0 > H || 125 < H ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Se = 0 < H ? Math.floor(1e3 / H) : 5;
    }, r.unstable_getCurrentPriorityLevel = function() {
      return L;
    }, r.unstable_next = function(H) {
      switch (L) {
        case 1:
        case 2:
        case 3:
          var ue = 3;
          break;
        default:
          ue = L;
      }
      var fe = L;
      L = ue;
      try {
        return H();
      } finally {
        L = fe;
      }
    }, r.unstable_requestPaint = function() {
      Y = !0;
    }, r.unstable_runWithPriority = function(H, ue) {
      switch (H) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          H = 3;
      }
      var fe = L;
      L = H;
      try {
        return ue();
      } finally {
        L = fe;
      }
    }, r.unstable_scheduleCallback = function(H, ue, fe) {
      var be = r.unstable_now();
      switch (typeof fe == "object" && fe !== null ? (fe = fe.delay, fe = typeof fe == "number" && 0 < fe ? be + fe : be) : fe = be, H) {
        case 1:
          var Be = -1;
          break;
        case 2:
          Be = 250;
          break;
        case 5:
          Be = 1073741823;
          break;
        case 4:
          Be = 1e4;
          break;
        default:
          Be = 5e3;
      }
      return Be = fe + Be, H = {
        id: _++,
        callback: ue,
        priorityLevel: H,
        startTime: fe,
        expirationTime: Be,
        sortIndex: -1
      }, fe > be ? (H.sortIndex = fe, f(R, H), m(O) === null && H === m(R) && (G ? (ne(ge), ge = -1) : G = !0, Rt(he, fe - be))) : (H.sortIndex = Be, f(O, H), N || Q || (N = !0, Te || (Te = !0, Ce()))), H;
    }, r.unstable_shouldYield = ae, r.unstable_wrapCallback = function(H) {
      var ue = L;
      return function() {
        var fe = L;
        L = ue;
        try {
          return H.apply(this, arguments);
        } finally {
          L = fe;
        }
      };
    };
  })(DE)), DE;
}
var RE = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var DO;
function wz() {
  return DO || (DO = 1, (function(r) {
    process.env.NODE_ENV !== "production" && (function() {
      function f() {
        if (he = !1, xe) {
          var H = r.unstable_now();
          Ce = H;
          var ue = !0;
          try {
            e: {
              ye = !1, pe && (pe = !1, ge(ae), ae = -1), ne = !0;
              var fe = F;
              try {
                t: {
                  for (S(H), Y = h(Q); Y !== null && !(Y.expirationTime > H && O()); ) {
                    var be = Y.callback;
                    if (typeof be == "function") {
                      Y.callback = null, F = Y.priorityLevel;
                      var Be = be(
                        Y.expirationTime <= H
                      );
                      if (H = r.unstable_now(), typeof Be == "function") {
                        Y.callback = Be, S(H), ue = !0;
                        break t;
                      }
                      Y === h(Q) && v(Q), S(H);
                    } else v(Q);
                    Y = h(Q);
                  }
                  if (Y !== null) ue = !0;
                  else {
                    var ee = h(N);
                    ee !== null && R(
                      E,
                      ee.startTime - H
                    ), ue = !1;
                  }
                }
                break e;
              } finally {
                Y = null, F = fe, ne = !1;
              }
              ue = void 0;
            }
          } finally {
            ue ? we() : xe = !1;
          }
        }
      }
      function m(H, ue) {
        var fe = H.length;
        H.push(ue);
        e: for (; 0 < fe; ) {
          var be = fe - 1 >>> 1, Be = H[be];
          if (0 < g(Be, ue))
            H[be] = ue, H[fe] = Be, fe = be;
          else break e;
        }
      }
      function h(H) {
        return H.length === 0 ? null : H[0];
      }
      function v(H) {
        if (H.length === 0) return null;
        var ue = H[0], fe = H.pop();
        if (fe !== ue) {
          H[0] = fe;
          e: for (var be = 0, Be = H.length, ee = Be >>> 1; be < ee; ) {
            var ve = 2 * (be + 1) - 1, De = H[ve], ze = ve + 1, At = H[ze];
            if (0 > g(De, fe))
              ze < Be && 0 > g(At, De) ? (H[be] = At, H[ze] = fe, be = ze) : (H[be] = De, H[ve] = fe, be = ve);
            else if (ze < Be && 0 > g(At, fe))
              H[be] = At, H[ze] = fe, be = ze;
            else break e;
          }
        }
        return ue;
      }
      function g(H, ue) {
        var fe = H.sortIndex - ue.sortIndex;
        return fe !== 0 ? fe : H.id - ue.id;
      }
      function S(H) {
        for (var ue = h(N); ue !== null; ) {
          if (ue.callback === null) v(N);
          else if (ue.startTime <= H)
            v(N), ue.sortIndex = ue.expirationTime, m(Q, ue);
          else break;
          ue = h(N);
        }
      }
      function E(H) {
        if (pe = !1, S(H), !ye)
          if (h(Q) !== null)
            ye = !0, xe || (xe = !0, we());
          else {
            var ue = h(N);
            ue !== null && R(
              E,
              ue.startTime - H
            );
          }
      }
      function O() {
        return he ? !0 : !(r.unstable_now() - Ce < Me);
      }
      function R(H, ue) {
        ae = Te(function() {
          H(r.unstable_now());
        }, ue);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), r.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var _ = performance;
        r.unstable_now = function() {
          return _.now();
        };
      } else {
        var z = Date, L = z.now();
        r.unstable_now = function() {
          return z.now() - L;
        };
      }
      var Q = [], N = [], G = 1, Y = null, F = 3, ne = !1, ye = !1, pe = !1, he = !1, Te = typeof setTimeout == "function" ? setTimeout : null, ge = typeof clearTimeout == "function" ? clearTimeout : null, Se = typeof setImmediate < "u" ? setImmediate : null, xe = !1, ae = -1, Me = 5, Ce = -1;
      if (typeof Se == "function")
        var we = function() {
          Se(f);
        };
      else if (typeof MessageChannel < "u") {
        var We = new MessageChannel(), Rt = We.port2;
        We.port1.onmessage = f, we = function() {
          Rt.postMessage(null);
        };
      } else
        we = function() {
          Te(f, 0);
        };
      r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function(H) {
        H.callback = null;
      }, r.unstable_forceFrameRate = function(H) {
        0 > H || 125 < H ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : Me = 0 < H ? Math.floor(1e3 / H) : 5;
      }, r.unstable_getCurrentPriorityLevel = function() {
        return F;
      }, r.unstable_next = function(H) {
        switch (F) {
          case 1:
          case 2:
          case 3:
            var ue = 3;
            break;
          default:
            ue = F;
        }
        var fe = F;
        F = ue;
        try {
          return H();
        } finally {
          F = fe;
        }
      }, r.unstable_requestPaint = function() {
        he = !0;
      }, r.unstable_runWithPriority = function(H, ue) {
        switch (H) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            H = 3;
        }
        var fe = F;
        F = H;
        try {
          return ue();
        } finally {
          F = fe;
        }
      }, r.unstable_scheduleCallback = function(H, ue, fe) {
        var be = r.unstable_now();
        switch (typeof fe == "object" && fe !== null ? (fe = fe.delay, fe = typeof fe == "number" && 0 < fe ? be + fe : be) : fe = be, H) {
          case 1:
            var Be = -1;
            break;
          case 2:
            Be = 250;
            break;
          case 5:
            Be = 1073741823;
            break;
          case 4:
            Be = 1e4;
            break;
          default:
            Be = 5e3;
        }
        return Be = fe + Be, H = {
          id: G++,
          callback: ue,
          priorityLevel: H,
          startTime: fe,
          expirationTime: Be,
          sortIndex: -1
        }, fe > be ? (H.sortIndex = fe, m(N, H), h(Q) === null && H === h(N) && (pe ? (ge(ae), ae = -1) : pe = !0, R(E, fe - be))) : (H.sortIndex = Be, m(Q, H), ye || ne || (ye = !0, xe || (xe = !0, we()))), H;
      }, r.unstable_shouldYield = O, r.unstable_wrapCallback = function(H) {
        var ue = F;
        return function() {
          var fe = F;
          F = ue;
          try {
            return H.apply(this, arguments);
          } finally {
            F = fe;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(RE)), RE;
}
var RO;
function UD() {
  return RO || (RO = 1, process.env.NODE_ENV === "production" ? ab.exports = Uz() : ab.exports = wz()), ab.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CO;
function Mz() {
  if (CO) return i0;
  CO = 1;
  var r = UD(), f = ar, m = xO;
  function h(n) {
    var l = "https://react.dev/errors/" + n;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var u = 2; u < arguments.length; u++)
        l += "&args[]=" + encodeURIComponent(arguments[u]);
    }
    return "Minified React error #" + n + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function v(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function g(n) {
    var l = n, u = n;
    if (n.alternate) for (; l.return; ) l = l.return;
    else {
      n = l;
      do
        l = n, (l.flags & 4098) !== 0 && (u = l.return), n = l.return;
      while (n);
    }
    return l.tag === 3 ? u : null;
  }
  function S(n) {
    if (n.tag === 13) {
      var l = n.memoizedState;
      if (l === null && (n = n.alternate, n !== null && (l = n.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function E(n) {
    if (n.tag === 31) {
      var l = n.memoizedState;
      if (l === null && (n = n.alternate, n !== null && (l = n.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function O(n) {
    if (g(n) !== n)
      throw Error(h(188));
  }
  function R(n) {
    var l = n.alternate;
    if (!l) {
      if (l = g(n), l === null) throw Error(h(188));
      return l !== n ? null : n;
    }
    for (var u = n, o = l; ; ) {
      var d = u.return;
      if (d === null) break;
      var p = d.alternate;
      if (p === null) {
        if (o = d.return, o !== null) {
          u = o;
          continue;
        }
        break;
      }
      if (d.child === p.child) {
        for (p = d.child; p; ) {
          if (p === u) return O(d), n;
          if (p === o) return O(d), l;
          p = p.sibling;
        }
        throw Error(h(188));
      }
      if (u.return !== o.return) u = d, o = p;
      else {
        for (var T = !1, C = d.child; C; ) {
          if (C === u) {
            T = !0, u = d, o = p;
            break;
          }
          if (C === o) {
            T = !0, o = d, u = p;
            break;
          }
          C = C.sibling;
        }
        if (!T) {
          for (C = p.child; C; ) {
            if (C === u) {
              T = !0, u = p, o = d;
              break;
            }
            if (C === o) {
              T = !0, o = p, u = d;
              break;
            }
            C = C.sibling;
          }
          if (!T) throw Error(h(189));
        }
      }
      if (u.alternate !== o) throw Error(h(190));
    }
    if (u.tag !== 3) throw Error(h(188));
    return u.stateNode.current === u ? n : l;
  }
  function _(n) {
    var l = n.tag;
    if (l === 5 || l === 26 || l === 27 || l === 6) return n;
    for (n = n.child; n !== null; ) {
      if (l = _(n), l !== null) return l;
      n = n.sibling;
    }
    return null;
  }
  var z = Object.assign, L = Symbol.for("react.element"), Q = Symbol.for("react.transitional.element"), N = Symbol.for("react.portal"), G = Symbol.for("react.fragment"), Y = Symbol.for("react.strict_mode"), F = Symbol.for("react.profiler"), ne = Symbol.for("react.consumer"), ye = Symbol.for("react.context"), pe = Symbol.for("react.forward_ref"), he = Symbol.for("react.suspense"), Te = Symbol.for("react.suspense_list"), ge = Symbol.for("react.memo"), Se = Symbol.for("react.lazy"), xe = Symbol.for("react.activity"), ae = Symbol.for("react.memo_cache_sentinel"), Me = Symbol.iterator;
  function Ce(n) {
    return n === null || typeof n != "object" ? null : (n = Me && n[Me] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var we = Symbol.for("react.client.reference");
  function We(n) {
    if (n == null) return null;
    if (typeof n == "function")
      return n.$$typeof === we ? null : n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case G:
        return "Fragment";
      case F:
        return "Profiler";
      case Y:
        return "StrictMode";
      case he:
        return "Suspense";
      case Te:
        return "SuspenseList";
      case xe:
        return "Activity";
    }
    if (typeof n == "object")
      switch (n.$$typeof) {
        case N:
          return "Portal";
        case ye:
          return n.displayName || "Context";
        case ne:
          return (n._context.displayName || "Context") + ".Consumer";
        case pe:
          var l = n.render;
          return n = n.displayName, n || (n = l.displayName || l.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
        case ge:
          return l = n.displayName || null, l !== null ? l : We(n.type) || "Memo";
        case Se:
          l = n._payload, n = n._init;
          try {
            return We(n(l));
          } catch {
          }
      }
    return null;
  }
  var Rt = Array.isArray, H = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ue = m.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fe = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, be = [], Be = -1;
  function ee(n) {
    return { current: n };
  }
  function ve(n) {
    0 > Be || (n.current = be[Be], be[Be] = null, Be--);
  }
  function De(n, l) {
    Be++, be[Be] = n.current, n.current = l;
  }
  var ze = ee(null), At = ee(null), Rn = ee(null), ft = ee(null);
  function en(n, l) {
    switch (De(Rn, l), De(At, n), De(ze, null), l.nodeType) {
      case 9:
      case 11:
        n = (n = l.documentElement) && (n = n.namespaceURI) ? Mv(n) : 0;
        break;
      default:
        if (n = l.tagName, l = l.namespaceURI)
          l = Mv(l), n = $y(l, n);
        else
          switch (n) {
            case "svg":
              n = 1;
              break;
            case "math":
              n = 2;
              break;
            default:
              n = 0;
          }
    }
    ve(ze), De(ze, n);
  }
  function Mn() {
    ve(ze), ve(At), ve(Rn);
  }
  function zl(n) {
    n.memoizedState !== null && De(ft, n);
    var l = ze.current, u = $y(l, n.type);
    l !== u && (De(At, n), De(ze, u));
  }
  function Ae(n) {
    At.current === n && (ve(ze), ve(At)), ft.current === n && (ve(ft), ed._currentValue = fe);
  }
  var qa, va;
  function na(n) {
    if (qa === void 0)
      try {
        throw Error();
      } catch (u) {
        var l = u.stack.trim().match(/\n( *(at )?)/);
        qa = l && l[1] || "", va = -1 < u.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < u.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + qa + n + va;
  }
  var $l = !1;
  function He(n, l) {
    if (!n || $l) return "";
    $l = !0;
    var u = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var o = {
        DetermineComponentFrameRoot: function() {
          try {
            if (l) {
              var re = function() {
                throw Error();
              };
              if (Object.defineProperty(re.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(re, []);
                } catch (P) {
                  var k = P;
                }
                Reflect.construct(n, [], re);
              } else {
                try {
                  re.call();
                } catch (P) {
                  k = P;
                }
                n.call(re.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (P) {
                k = P;
              }
              (re = n()) && typeof re.catch == "function" && re.catch(function() {
              });
            }
          } catch (P) {
            if (P && k && typeof P.stack == "string")
              return [P.stack, k.stack];
          }
          return [null, null];
        }
      };
      o.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var d = Object.getOwnPropertyDescriptor(
        o.DetermineComponentFrameRoot,
        "name"
      );
      d && d.configurable && Object.defineProperty(
        o.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var p = o.DetermineComponentFrameRoot(), T = p[0], C = p[1];
      if (T && C) {
        var x = T.split(`
`), K = C.split(`
`);
        for (d = o = 0; o < x.length && !x[o].includes("DetermineComponentFrameRoot"); )
          o++;
        for (; d < K.length && !K[d].includes(
          "DetermineComponentFrameRoot"
        ); )
          d++;
        if (o === x.length || d === K.length)
          for (o = x.length - 1, d = K.length - 1; 1 <= o && 0 <= d && x[o] !== K[d]; )
            d--;
        for (; 1 <= o && 0 <= d; o--, d--)
          if (x[o] !== K[d]) {
            if (o !== 1 || d !== 1)
              do
                if (o--, d--, 0 > d || x[o] !== K[d]) {
                  var le = `
` + x[o].replace(" at new ", " at ");
                  return n.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", n.displayName)), le;
                }
              while (1 <= o && 0 <= d);
            break;
          }
      }
    } finally {
      $l = !1, Error.prepareStackTrace = u;
    }
    return (u = n ? n.displayName || n.name : "") ? na(u) : "";
  }
  function wt(n, l) {
    switch (n.tag) {
      case 26:
      case 27:
      case 5:
        return na(n.type);
      case 16:
        return na("Lazy");
      case 13:
        return n.child !== l && l !== null ? na("Suspense Fallback") : na("Suspense");
      case 19:
        return na("SuspenseList");
      case 0:
      case 15:
        return He(n.type, !1);
      case 11:
        return He(n.type.render, !1);
      case 1:
        return He(n.type, !0);
      case 31:
        return na("Activity");
      default:
        return "";
    }
  }
  function jt(n) {
    try {
      var l = "", u = null;
      do
        l += wt(n, u), u = n, n = n.return;
      while (n);
      return l;
    } catch (o) {
      return `
Error generating stack: ` + o.message + `
` + o.stack;
    }
  }
  var Zt = Object.prototype.hasOwnProperty, Z = r.unstable_scheduleCallback, de = r.unstable_cancelCallback, oe = r.unstable_shouldYield, me = r.unstable_requestPaint, _e = r.unstable_now, vt = r.unstable_getCurrentPriorityLevel, et = r.unstable_ImmediatePriority, St = r.unstable_UserBlockingPriority, Wt = r.unstable_NormalPriority, tl = r.unstable_LowPriority, Xo = r.unstable_IdlePriority, Ud = r.log, lr = r.unstable_setDisableYieldValue, Qo = null, Va = null;
  function Si(n) {
    if (typeof Ud == "function" && lr(n), Va && typeof Va.setStrictMode == "function")
      try {
        Va.setStrictMode(Qo, n);
      } catch {
      }
  }
  var ba = Math.clz32 ? Math.clz32 : lp, v0 = Math.log, b0 = Math.LN2;
  function lp(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (v0(n) / b0 | 0) | 0;
  }
  var Ei = 256, Fl = 262144, Pi = 4194304;
  function _l(n) {
    var l = n & 42;
    if (l !== 0) return l;
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return n & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return n & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return n;
    }
  }
  function vn(n, l, u) {
    var o = n.pendingLanes;
    if (o === 0) return 0;
    var d = 0, p = n.suspendedLanes, T = n.pingedLanes;
    n = n.warmLanes;
    var C = o & 134217727;
    return C !== 0 ? (o = C & ~p, o !== 0 ? d = _l(o) : (T &= C, T !== 0 ? d = _l(T) : u || (u = C & ~n, u !== 0 && (d = _l(u))))) : (C = o & ~p, C !== 0 ? d = _l(C) : T !== 0 ? d = _l(T) : u || (u = o & ~n, u !== 0 && (d = _l(u)))), d === 0 ? 0 : l !== 0 && l !== d && (l & p) === 0 && (p = d & -d, u = l & -l, p >= u || p === 32 && (u & 4194048) !== 0) ? l : d;
  }
  function Wl(n, l) {
    return (n.pendingLanes & ~(n.suspendedLanes & ~n.pingedLanes) & l) === 0;
  }
  function ur(n, l) {
    switch (n) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return l + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Zo() {
    var n = Pi;
    return Pi <<= 1, (Pi & 62914560) === 0 && (Pi = 4194304), n;
  }
  function Vs(n) {
    for (var l = [], u = 0; 31 > u; u++) l.push(n);
    return l;
  }
  function ir(n, l) {
    n.pendingLanes |= l, l !== 268435456 && (n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0);
  }
  function wd(n, l, u, o, d, p) {
    var T = n.pendingLanes;
    n.pendingLanes = u, n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0, n.expiredLanes &= u, n.entangledLanes &= u, n.errorRecoveryDisabledLanes &= u, n.shellSuspendCounter = 0;
    var C = n.entanglements, x = n.expirationTimes, K = n.hiddenUpdates;
    for (u = T & ~u; 0 < u; ) {
      var le = 31 - ba(u), re = 1 << le;
      C[le] = 0, x[le] = -1;
      var k = K[le];
      if (k !== null)
        for (K[le] = null, le = 0; le < k.length; le++) {
          var P = k[le];
          P !== null && (P.lane &= -536870913);
        }
      u &= ~re;
    }
    o !== 0 && Ys(n, o, 0), p !== 0 && d === 0 && n.tag !== 0 && (n.suspendedLanes |= p & ~(T & ~l));
  }
  function Ys(n, l, u) {
    n.pendingLanes |= l, n.suspendedLanes &= ~l;
    var o = 31 - ba(l);
    n.entangledLanes |= l, n.entanglements[o] = n.entanglements[o] | 1073741824 | u & 261930;
  }
  function Cu(n, l) {
    var u = n.entangledLanes |= l;
    for (n = n.entanglements; u; ) {
      var o = 31 - ba(u), d = 1 << o;
      d & l | n[o] & l && (n[o] |= l), u &= ~d;
    }
  }
  function nl(n, l) {
    var u = l & -l;
    return u = (u & 42) !== 0 ? 1 : Md(u), (u & (n.suspendedLanes | l)) !== 0 ? 0 : u;
  }
  function Md(n) {
    switch (n) {
      case 2:
        n = 1;
        break;
      case 8:
        n = 4;
        break;
      case 32:
        n = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        n = 128;
        break;
      case 268435456:
        n = 134217728;
        break;
      default:
        n = 0;
    }
    return n;
  }
  function up(n) {
    return n &= -n, 2 < n ? 8 < n ? (n & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Nd() {
    var n = ue.p;
    return n !== 0 ? n : (n = window.event, n === void 0 ? 32 : td(n.type));
  }
  function ip(n, l) {
    var u = ue.p;
    try {
      return ue.p = n, l();
    } finally {
      ue.p = u;
    }
  }
  var Il = Math.random().toString(36).slice(2), qt = "__reactFiber$" + Il, Sa = "__reactProps$" + Il, eo = "__reactContainer$" + Il, xd = "__reactEvents$" + Il, op = "__reactListeners$" + Il, S0 = "__reactHandles$" + Il, cp = "__reactResources$" + Il, zu = "__reactMarker$" + Il;
  function Hd(n) {
    delete n[qt], delete n[Sa], delete n[xd], delete n[op], delete n[S0];
  }
  function Jo(n) {
    var l = n[qt];
    if (l) return l;
    for (var u = n.parentNode; u; ) {
      if (l = u[eo] || u[qt]) {
        if (u = l.alternate, l.child !== null || u !== null && u.child !== null)
          for (n = bu(n); n !== null; ) {
            if (u = n[qt]) return u;
            n = bu(n);
          }
        return l;
      }
      n = u, u = n.parentNode;
    }
    return null;
  }
  function Ko(n) {
    if (n = n[qt] || n[eo]) {
      var l = n.tag;
      if (l === 5 || l === 6 || l === 13 || l === 31 || l === 26 || l === 27 || l === 3)
        return n;
    }
    return null;
  }
  function or(n) {
    var l = n.tag;
    if (l === 5 || l === 26 || l === 27 || l === 6) return n.stateNode;
    throw Error(h(33));
  }
  function ko(n) {
    var l = n[cp];
    return l || (l = n[cp] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), l;
  }
  function Mt(n) {
    n[zu] = !0;
  }
  var $o = /* @__PURE__ */ new Set(), to = {};
  function no(n, l) {
    _u(n, l), _u(n + "Capture", l);
  }
  function _u(n, l) {
    for (to[n] = l, n = 0; n < l.length; n++)
      $o.add(l[n]);
  }
  var Ld = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Bd = {}, cr = {};
  function rr(n) {
    return Zt.call(cr, n) ? !0 : Zt.call(Bd, n) ? !1 : Ld.test(n) ? cr[n] = !0 : (Bd[n] = !0, !1);
  }
  function sr(n, l, u) {
    if (rr(l))
      if (u === null) n.removeAttribute(l);
      else {
        switch (typeof u) {
          case "undefined":
          case "function":
          case "symbol":
            n.removeAttribute(l);
            return;
          case "boolean":
            var o = l.toLowerCase().slice(0, 5);
            if (o !== "data-" && o !== "aria-") {
              n.removeAttribute(l);
              return;
            }
        }
        n.setAttribute(l, "" + u);
      }
  }
  function jd(n, l, u) {
    if (u === null) n.removeAttribute(l);
    else {
      switch (typeof u) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          n.removeAttribute(l);
          return;
      }
      n.setAttribute(l, "" + u);
    }
  }
  function Ti(n, l, u, o) {
    if (o === null) n.removeAttribute(u);
    else {
      switch (typeof o) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          n.removeAttribute(u);
          return;
      }
      n.setAttributeNS(l, u, "" + o);
    }
  }
  function al(n) {
    switch (typeof n) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function qd(n) {
    var l = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
  }
  function rp(n, l, u) {
    var o = Object.getOwnPropertyDescriptor(
      n.constructor.prototype,
      l
    );
    if (!n.hasOwnProperty(l) && typeof o < "u" && typeof o.get == "function" && typeof o.set == "function") {
      var d = o.get, p = o.set;
      return Object.defineProperty(n, l, {
        configurable: !0,
        get: function() {
          return d.call(this);
        },
        set: function(T) {
          u = "" + T, p.call(this, T);
        }
      }), Object.defineProperty(n, l, {
        enumerable: o.enumerable
      }), {
        getValue: function() {
          return u;
        },
        setValue: function(T) {
          u = "" + T;
        },
        stopTracking: function() {
          n._valueTracker = null, delete n[l];
        }
      };
    }
  }
  function Vd(n) {
    if (!n._valueTracker) {
      var l = qd(n) ? "checked" : "value";
      n._valueTracker = rp(
        n,
        l,
        "" + n[l]
      );
    }
  }
  function sp(n) {
    if (!n) return !1;
    var l = n._valueTracker;
    if (!l) return !0;
    var u = l.getValue(), o = "";
    return n && (o = qd(n) ? n.checked ? "true" : "false" : n.value), n = o, n !== u ? (l.setValue(n), !0) : !1;
  }
  function Gs(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  var Db = /[\n"\\]/g;
  function ll(n) {
    return n.replace(
      Db,
      function(l) {
        return "\\" + l.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Xs(n, l, u, o, d, p, T, C) {
    n.name = "", T != null && typeof T != "function" && typeof T != "symbol" && typeof T != "boolean" ? n.type = T : n.removeAttribute("type"), l != null ? T === "number" ? (l === 0 && n.value === "" || n.value != l) && (n.value = "" + al(l)) : n.value !== "" + al(l) && (n.value = "" + al(l)) : T !== "submit" && T !== "reset" || n.removeAttribute("value"), l != null ? Fo(n, T, al(l)) : u != null ? Fo(n, T, al(u)) : o != null && n.removeAttribute("value"), d == null && p != null && (n.defaultChecked = !!p), d != null && (n.checked = d && typeof d != "function" && typeof d != "symbol"), C != null && typeof C != "function" && typeof C != "symbol" && typeof C != "boolean" ? n.name = "" + al(C) : n.removeAttribute("name");
  }
  function Qs(n, l, u, o, d, p, T, C) {
    if (p != null && typeof p != "function" && typeof p != "symbol" && typeof p != "boolean" && (n.type = p), l != null || u != null) {
      if (!(p !== "submit" && p !== "reset" || l != null)) {
        Vd(n);
        return;
      }
      u = u != null ? "" + al(u) : "", l = l != null ? "" + al(l) : u, C || l === n.value || (n.value = l), n.defaultValue = l;
    }
    o = o ?? d, o = typeof o != "function" && typeof o != "symbol" && !!o, n.checked = C ? n.checked : !!o, n.defaultChecked = !!o, T != null && typeof T != "function" && typeof T != "symbol" && typeof T != "boolean" && (n.name = T), Vd(n);
  }
  function Fo(n, l, u) {
    l === "number" && Gs(n.ownerDocument) === n || n.defaultValue === "" + u || (n.defaultValue = "" + u);
  }
  function fr(n, l, u, o) {
    if (n = n.options, l) {
      l = {};
      for (var d = 0; d < u.length; d++)
        l["$" + u[d]] = !0;
      for (u = 0; u < n.length; u++)
        d = l.hasOwnProperty("$" + n[u].value), n[u].selected !== d && (n[u].selected = d), d && o && (n[u].defaultSelected = !0);
    } else {
      for (u = "" + al(u), l = null, d = 0; d < n.length; d++) {
        if (n[d].value === u) {
          n[d].selected = !0, o && (n[d].defaultSelected = !0);
          return;
        }
        l !== null || n[d].disabled || (l = n[d]);
      }
      l !== null && (l.selected = !0);
    }
  }
  function fp(n, l, u) {
    if (l != null && (l = "" + al(l), l !== n.value && (n.value = l), u == null)) {
      n.defaultValue !== l && (n.defaultValue = l);
      return;
    }
    n.defaultValue = u != null ? "" + al(u) : "";
  }
  function dp(n, l, u, o) {
    if (l == null) {
      if (o != null) {
        if (u != null) throw Error(h(92));
        if (Rt(o)) {
          if (1 < o.length) throw Error(h(93));
          o = o[0];
        }
        u = o;
      }
      u == null && (u = ""), l = u;
    }
    u = al(l), n.defaultValue = u, o = n.textContent, o === u && o !== "" && o !== null && (n.value = o), Vd(n);
  }
  function Uu(n, l) {
    if (l) {
      var u = n.firstChild;
      if (u && u === n.lastChild && u.nodeType === 3) {
        u.nodeValue = l;
        return;
      }
    }
    n.textContent = l;
  }
  var E0 = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function T0(n, l, u) {
    var o = l.indexOf("--") === 0;
    u == null || typeof u == "boolean" || u === "" ? o ? n.setProperty(l, "") : l === "float" ? n.cssFloat = "" : n[l] = "" : o ? n.setProperty(l, u) : typeof u != "number" || u === 0 || E0.has(l) ? l === "float" ? n.cssFloat = u : n[l] = ("" + u).trim() : n[l] = u + "px";
  }
  function A0(n, l, u) {
    if (l != null && typeof l != "object")
      throw Error(h(62));
    if (n = n.style, u != null) {
      for (var o in u)
        !u.hasOwnProperty(o) || l != null && l.hasOwnProperty(o) || (o.indexOf("--") === 0 ? n.setProperty(o, "") : o === "float" ? n.cssFloat = "" : n[o] = "");
      for (var d in l)
        o = l[d], l.hasOwnProperty(d) && u[d] !== o && T0(n, d, o);
    } else
      for (var p in l)
        l.hasOwnProperty(p) && T0(n, p, l[p]);
  }
  function hp(n) {
    if (n.indexOf("-") === -1) return !1;
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Rb = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Zs = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ul(n) {
    return Zs.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
  }
  function Pl() {
  }
  var Yd = null;
  function Gd(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var wu = null, Wo = null;
  function Js(n) {
    var l = Ko(n);
    if (l && (n = l.stateNode)) {
      var u = n[Sa] || null;
      e: switch (n = l.stateNode, l.type) {
        case "input":
          if (Xs(
            n,
            u.value,
            u.defaultValue,
            u.defaultValue,
            u.checked,
            u.defaultChecked,
            u.type,
            u.name
          ), l = u.name, u.type === "radio" && l != null) {
            for (u = n; u.parentNode; ) u = u.parentNode;
            for (u = u.querySelectorAll(
              'input[name="' + ll(
                "" + l
              ) + '"][type="radio"]'
            ), l = 0; l < u.length; l++) {
              var o = u[l];
              if (o !== n && o.form === n.form) {
                var d = o[Sa] || null;
                if (!d) throw Error(h(90));
                Xs(
                  o,
                  d.value,
                  d.defaultValue,
                  d.defaultValue,
                  d.checked,
                  d.defaultChecked,
                  d.type,
                  d.name
                );
              }
            }
            for (l = 0; l < u.length; l++)
              o = u[l], o.form === n.form && sp(o);
          }
          break e;
        case "textarea":
          fp(n, u.value, u.defaultValue);
          break e;
        case "select":
          l = u.value, l != null && fr(n, !!u.multiple, l, !1);
      }
    }
  }
  var dr = !1;
  function mp(n, l, u) {
    if (dr) return n(l, u);
    dr = !0;
    try {
      var o = n(l);
      return o;
    } finally {
      if (dr = !1, (wu !== null || Wo !== null) && (kr(), wu && (l = wu, n = Wo, Wo = wu = null, Js(l), n)))
        for (l = 0; l < n.length; l++) Js(n[l]);
    }
  }
  function Yn(n, l) {
    var u = n.stateNode;
    if (u === null) return null;
    var o = u[Sa] || null;
    if (o === null) return null;
    u = o[l];
    e: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (o = !o.disabled) || (n = n.type, o = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !o;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (u && typeof u != "function")
      throw Error(
        h(231, l, typeof u)
      );
    return u;
  }
  var Ai = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Ks = !1;
  if (Ai)
    try {
      var hr = {};
      Object.defineProperty(hr, "passive", {
        get: function() {
          Ks = !0;
        }
      }), window.addEventListener("test", hr, hr), window.removeEventListener("test", hr, hr);
    } catch {
      Ks = !1;
    }
  var Oi = null, pp = null, Xd = null;
  function yp() {
    if (Xd) return Xd;
    var n, l = pp, u = l.length, o, d = "value" in Oi ? Oi.value : Oi.textContent, p = d.length;
    for (n = 0; n < u && l[n] === d[n]; n++) ;
    var T = u - n;
    for (o = 1; o <= T && l[u - o] === d[p - o]; o++) ;
    return Xd = d.slice(n, 1 < o ? 1 - o : void 0);
  }
  function Qd(n) {
    var l = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && l === 13 && (n = 13)) : n = l, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function ks() {
    return !0;
  }
  function O0() {
    return !1;
  }
  function aa(n) {
    function l(u, o, d, p, T) {
      this._reactName = u, this._targetInst = d, this.type = o, this.nativeEvent = p, this.target = T, this.currentTarget = null;
      for (var C in n)
        n.hasOwnProperty(C) && (u = n[C], this[C] = u ? u(p) : p[C]);
      return this.isDefaultPrevented = (p.defaultPrevented != null ? p.defaultPrevented : p.returnValue === !1) ? ks : O0, this.isPropagationStopped = O0, this;
    }
    return z(l.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var u = this.nativeEvent;
        u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = ks);
      },
      stopPropagation: function() {
        var u = this.nativeEvent;
        u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = ks);
      },
      persist: function() {
      },
      isPersistent: ks
    }), l;
  }
  var ao = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(n) {
      return n.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, $s = aa(ao), mr = z({}, ao, { view: 0, detail: 0 }), Cb = aa(mr), gp, vp, Fs, Zd = z({}, mr, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: wl,
    button: 0,
    buttons: 0,
    relatedTarget: function(n) {
      return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
    },
    movementX: function(n) {
      return "movementX" in n ? n.movementX : (n !== Fs && (Fs && n.type === "mousemove" ? (gp = n.screenX - Fs.screenX, vp = n.screenY - Fs.screenY) : vp = gp = 0, Fs = n), gp);
    },
    movementY: function(n) {
      return "movementY" in n ? n.movementY : vp;
    }
  }), pr = aa(Zd), D0 = z({}, Zd, { dataTransfer: 0 }), R0 = aa(D0), C0 = z({}, mr, { relatedTarget: 0 }), Jd = aa(C0), bp = z({}, ao, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), z0 = aa(bp), Io = z({}, ao, {
    clipboardData: function(n) {
      return "clipboardData" in n ? n.clipboardData : window.clipboardData;
    }
  }), Po = aa(Io), eu = z({}, ao, { data: 0 }), _0 = aa(eu), Sp = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Mu = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, U0 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function tu(n) {
    var l = this.nativeEvent;
    return l.getModifierState ? l.getModifierState(n) : (n = U0[n]) ? !!l[n] : !1;
  }
  function wl() {
    return tu;
  }
  var Kd = z({}, mr, {
    key: function(n) {
      if (n.key) {
        var l = Sp[n.key] || n.key;
        if (l !== "Unidentified") return l;
      }
      return n.type === "keypress" ? (n = Qd(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? Mu[n.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: wl,
    charCode: function(n) {
      return n.type === "keypress" ? Qd(n) : 0;
    },
    keyCode: function(n) {
      return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
    },
    which: function(n) {
      return n.type === "keypress" ? Qd(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
    }
  }), kd = aa(Kd), Ep = z({}, Zd, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), nu = aa(Ep), zb = z({}, mr, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: wl
  }), w0 = aa(zb), M0 = z({}, ao, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), _b = aa(M0), Tp = z({}, Zd, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Ub = aa(Tp), N0 = z({}, ao, {
    newState: 0,
    oldState: 0
  }), Ap = aa(N0), $d = [9, 13, 27, 32], yr = Ai && "CompositionEvent" in window, ec = null;
  Ai && "documentMode" in document && (ec = document.documentMode);
  var ra = Ai && "TextEvent" in window && !ec, Op = Ai && (!yr || ec && 8 < ec && 11 >= ec), Ws = " ", lo = !1;
  function Fd(n, l) {
    switch (n) {
      case "keyup":
        return $d.indexOf(l.keyCode) !== -1;
      case "keydown":
        return l.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Dp(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var tc = !1;
  function x0(n, l) {
    switch (n) {
      case "compositionend":
        return Dp(l);
      case "keypress":
        return l.which !== 32 ? null : (lo = !0, Ws);
      case "textInput":
        return n = l.data, n === Ws && lo ? null : n;
      default:
        return null;
    }
  }
  function wb(n, l) {
    if (tc)
      return n === "compositionend" || !yr && Fd(n, l) ? (n = yp(), Xd = pp = Oi = null, tc = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
          if (l.char && 1 < l.char.length)
            return l.char;
          if (l.which) return String.fromCharCode(l.which);
        }
        return null;
      case "compositionend":
        return Op && l.locale !== "ko" ? null : l.data;
      default:
        return null;
    }
  }
  var Rp = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Nu(n) {
    var l = n && n.nodeName && n.nodeName.toLowerCase();
    return l === "input" ? !!Rp[n.type] : l === "textarea";
  }
  function Cp(n, l, u, o) {
    wu ? Wo ? Wo.push(o) : Wo = [o] : wu = o, l = kf(l, "onChange"), 0 < l.length && (u = new $s(
      "onChange",
      "change",
      null,
      u,
      o
    ), n.push({ event: u, listeners: l }));
  }
  var nc = null, uo = null;
  function ac(n) {
    _v(n, 0);
  }
  function gr(n) {
    var l = or(n);
    if (sp(l)) return n;
  }
  function zp(n, l) {
    if (n === "change") return l;
  }
  var Wd = !1;
  if (Ai) {
    var Ea;
    if (Ai) {
      var au = "oninput" in document;
      if (!au) {
        var _p = document.createElement("div");
        _p.setAttribute("oninput", "return;"), au = typeof _p.oninput == "function";
      }
      Ea = au;
    } else Ea = !1;
    Wd = Ea && (!document.documentMode || 9 < document.documentMode);
  }
  function Id() {
    nc && (nc.detachEvent("onpropertychange", Pd), uo = nc = null);
  }
  function Pd(n) {
    if (n.propertyName === "value" && gr(uo)) {
      var l = [];
      Cp(
        l,
        uo,
        n,
        Gd(n)
      ), mp(ac, l);
    }
  }
  function H0(n, l, u) {
    n === "focusin" ? (Id(), nc = l, uo = u, nc.attachEvent("onpropertychange", Pd)) : n === "focusout" && Id();
  }
  function L0(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown")
      return gr(uo);
  }
  function io(n, l) {
    if (n === "click") return gr(l);
  }
  function lc(n, l) {
    if (n === "input" || n === "change")
      return gr(l);
  }
  function B0(n, l) {
    return n === l && (n !== 0 || 1 / n === 1 / l) || n !== n && l !== l;
  }
  var sa = typeof Object.is == "function" ? Object.is : B0;
  function Ml(n, l) {
    if (sa(n, l)) return !0;
    if (typeof n != "object" || n === null || typeof l != "object" || l === null)
      return !1;
    var u = Object.keys(n), o = Object.keys(l);
    if (u.length !== o.length) return !1;
    for (o = 0; o < u.length; o++) {
      var d = u[o];
      if (!Zt.call(l, d) || !sa(n[d], l[d]))
        return !1;
    }
    return !0;
  }
  function Up(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function wp(n, l) {
    var u = Up(n);
    n = 0;
    for (var o; u; ) {
      if (u.nodeType === 3) {
        if (o = n + u.textContent.length, n <= l && o >= l)
          return { node: u, offset: l - n };
        n = o;
      }
      e: {
        for (; u; ) {
          if (u.nextSibling) {
            u = u.nextSibling;
            break e;
          }
          u = u.parentNode;
        }
        u = void 0;
      }
      u = Up(u);
    }
  }
  function uc(n, l) {
    return n && l ? n === l ? !0 : n && n.nodeType === 3 ? !1 : l && l.nodeType === 3 ? uc(n, l.parentNode) : "contains" in n ? n.contains(l) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(l) & 16) : !1 : !1;
  }
  function oo(n) {
    n = n != null && n.ownerDocument != null && n.ownerDocument.defaultView != null ? n.ownerDocument.defaultView : window;
    for (var l = Gs(n.document); l instanceof n.HTMLIFrameElement; ) {
      try {
        var u = typeof l.contentWindow.location.href == "string";
      } catch {
        u = !1;
      }
      if (u) n = l.contentWindow;
      else break;
      l = Gs(n.document);
    }
    return l;
  }
  function Is(n) {
    var l = n && n.nodeName && n.nodeName.toLowerCase();
    return l && (l === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || l === "textarea" || n.contentEditable === "true");
  }
  var Ps = Ai && "documentMode" in document && 11 >= document.documentMode, co = null, vr = null, Nl = null, lu = !1;
  function eh(n, l, u) {
    var o = u.window === u ? u.document : u.nodeType === 9 ? u : u.ownerDocument;
    lu || co == null || co !== Gs(o) || (o = co, "selectionStart" in o && Is(o) ? o = { start: o.selectionStart, end: o.selectionEnd } : (o = (o.ownerDocument && o.ownerDocument.defaultView || window).getSelection(), o = {
      anchorNode: o.anchorNode,
      anchorOffset: o.anchorOffset,
      focusNode: o.focusNode,
      focusOffset: o.focusOffset
    }), Nl && Ml(Nl, o) || (Nl = o, o = kf(vr, "onSelect"), 0 < o.length && (l = new $s(
      "onSelect",
      "select",
      null,
      l,
      u
    ), n.push({ event: l, listeners: o }), l.target = co)));
  }
  function Di(n, l) {
    var u = {};
    return u[n.toLowerCase()] = l.toLowerCase(), u["Webkit" + n] = "webkit" + l, u["Moz" + n] = "moz" + l, u;
  }
  var uu = {
    animationend: Di("Animation", "AnimationEnd"),
    animationiteration: Di("Animation", "AnimationIteration"),
    animationstart: Di("Animation", "AnimationStart"),
    transitionrun: Di("Transition", "TransitionRun"),
    transitionstart: Di("Transition", "TransitionStart"),
    transitioncancel: Di("Transition", "TransitionCancel"),
    transitionend: Di("Transition", "TransitionEnd")
  }, br = {}, ro = {};
  Ai && (ro = document.createElement("div").style, "AnimationEvent" in window || (delete uu.animationend.animation, delete uu.animationiteration.animation, delete uu.animationstart.animation), "TransitionEvent" in window || delete uu.transitionend.transition);
  function Ct(n) {
    if (br[n]) return br[n];
    if (!uu[n]) return n;
    var l = uu[n], u;
    for (u in l)
      if (l.hasOwnProperty(u) && u in ro)
        return br[n] = l[u];
    return n;
  }
  var ef = Ct("animationend"), Mp = Ct("animationiteration"), th = Ct("animationstart"), ic = Ct("transitionrun"), tf = Ct("transitionstart"), xu = Ct("transitioncancel"), j0 = Ct("transitionend"), Hu = /* @__PURE__ */ new Map(), Sr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Sr.push("scrollEnd");
  function Ta(n, l) {
    Hu.set(n, l), no(l, [n]);
  }
  var oc = typeof reportError == "function" ? reportError : function(n) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var l = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof n == "object" && n !== null && typeof n.message == "string" ? String(n.message) : String(n),
        error: n
      });
      if (!window.dispatchEvent(l)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", n);
      return;
    }
    console.error(n);
  }, tn = [], Gn = 0, xl = 0;
  function ul() {
    for (var n = Gn, l = xl = Gn = 0; l < n; ) {
      var u = tn[l];
      tn[l++] = null;
      var o = tn[l];
      tn[l++] = null;
      var d = tn[l];
      tn[l++] = null;
      var p = tn[l];
      if (tn[l++] = null, o !== null && d !== null) {
        var T = o.pending;
        T === null ? d.next = d : (d.next = T.next, T.next = d), o.pending = d;
      }
      p !== 0 && nh(u, d, p);
    }
  }
  function il(n, l, u, o) {
    tn[Gn++] = n, tn[Gn++] = l, tn[Gn++] = u, tn[Gn++] = o, xl |= o, n.lanes |= o, n = n.alternate, n !== null && (n.lanes |= o);
  }
  function Hl(n, l, u, o) {
    return il(n, l, u, o), nf(n);
  }
  function Ri(n, l) {
    return il(n, null, null, l), nf(n);
  }
  function nh(n, l, u) {
    n.lanes |= u;
    var o = n.alternate;
    o !== null && (o.lanes |= u);
    for (var d = !1, p = n.return; p !== null; )
      p.childLanes |= u, o = p.alternate, o !== null && (o.childLanes |= u), p.tag === 22 && (n = p.stateNode, n === null || n._visibility & 1 || (d = !0)), n = p, p = p.return;
    return n.tag === 3 ? (p = n.stateNode, d && l !== null && (d = 31 - ba(u), n = p.hiddenUpdates, o = n[d], o === null ? n[d] = [l] : o.push(l), l.lane = u | 536870912), p) : null;
  }
  function nf(n) {
    if (50 < Kr)
      throw Kr = 0, qf = null, Error(h(185));
    for (var l = n.return; l !== null; )
      n = l, l = n.return;
    return n.tag === 3 ? n.stateNode : null;
  }
  var Aa = {};
  function q0(n, l, u, o) {
    this.tag = n, this.key = u, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = o, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function hn(n, l, u, o) {
    return new q0(n, l, u, o);
  }
  function cc(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function Ci(n, l) {
    var u = n.alternate;
    return u === null ? (u = hn(
      n.tag,
      l,
      n.key,
      n.mode
    ), u.elementType = n.elementType, u.type = n.type, u.stateNode = n.stateNode, u.alternate = n, n.alternate = u) : (u.pendingProps = l, u.type = n.type, u.flags = 0, u.subtreeFlags = 0, u.deletions = null), u.flags = n.flags & 65011712, u.childLanes = n.childLanes, u.lanes = n.lanes, u.child = n.child, u.memoizedProps = n.memoizedProps, u.memoizedState = n.memoizedState, u.updateQueue = n.updateQueue, l = n.dependencies, u.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }, u.sibling = n.sibling, u.index = n.index, u.ref = n.ref, u.refCleanup = n.refCleanup, u;
  }
  function Np(n, l) {
    n.flags &= 65011714;
    var u = n.alternate;
    return u === null ? (n.childLanes = 0, n.lanes = l, n.child = null, n.subtreeFlags = 0, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null) : (n.childLanes = u.childLanes, n.lanes = u.lanes, n.child = u.child, n.subtreeFlags = 0, n.deletions = null, n.memoizedProps = u.memoizedProps, n.memoizedState = u.memoizedState, n.updateQueue = u.updateQueue, n.type = u.type, l = u.dependencies, n.dependencies = l === null ? null : {
      lanes: l.lanes,
      firstContext: l.firstContext
    }), n;
  }
  function ah(n, l, u, o, d, p) {
    var T = 0;
    if (o = n, typeof n == "function") cc(n) && (T = 1);
    else if (typeof n == "string")
      T = ng(
        n,
        u,
        ze.current
      ) ? 26 : n === "html" || n === "head" || n === "body" ? 27 : 5;
    else
      e: switch (n) {
        case xe:
          return n = hn(31, u, l, d), n.elementType = xe, n.lanes = p, n;
        case G:
          return zi(u.children, d, p, l);
        case Y:
          T = 8, d |= 24;
          break;
        case F:
          return n = hn(12, u, l, d | 2), n.elementType = F, n.lanes = p, n;
        case he:
          return n = hn(13, u, l, d), n.elementType = he, n.lanes = p, n;
        case Te:
          return n = hn(19, u, l, d), n.elementType = Te, n.lanes = p, n;
        default:
          if (typeof n == "object" && n !== null)
            switch (n.$$typeof) {
              case ye:
                T = 10;
                break e;
              case ne:
                T = 9;
                break e;
              case pe:
                T = 11;
                break e;
              case ge:
                T = 14;
                break e;
              case Se:
                T = 16, o = null;
                break e;
            }
          T = 29, u = Error(
            h(130, n === null ? "null" : typeof n, "")
          ), o = null;
      }
    return l = hn(T, u, l, d), l.elementType = n, l.type = o, l.lanes = p, l;
  }
  function zi(n, l, u, o) {
    return n = hn(7, n, o, l), n.lanes = u, n;
  }
  function Er(n, l, u) {
    return n = hn(6, n, null, l), n.lanes = u, n;
  }
  function xp(n) {
    var l = hn(18, null, null, 0);
    return l.stateNode = n, l;
  }
  function lh(n, l, u) {
    return l = hn(
      4,
      n.children !== null ? n.children : [],
      n.key,
      l
    ), l.lanes = u, l.stateNode = {
      containerInfo: n.containerInfo,
      pendingChildren: null,
      implementation: n.implementation
    }, l;
  }
  var Hp = /* @__PURE__ */ new WeakMap();
  function ol(n, l) {
    if (typeof n == "object" && n !== null) {
      var u = Hp.get(n);
      return u !== void 0 ? u : (l = {
        value: n,
        source: l,
        stack: jt(l)
      }, Hp.set(n, l), l);
    }
    return {
      value: n,
      source: l,
      stack: jt(l)
    };
  }
  var cl = [], rc = 0, af = null, bn = 0, Ya = [], Oa = 0, iu = null, Ga = 1, ou = "";
  function Ll(n, l) {
    cl[rc++] = bn, cl[rc++] = af, af = n, bn = l;
  }
  function Lp(n, l, u) {
    Ya[Oa++] = Ga, Ya[Oa++] = ou, Ya[Oa++] = iu, iu = n;
    var o = Ga;
    n = ou;
    var d = 32 - ba(o) - 1;
    o &= ~(1 << d), u += 1;
    var p = 32 - ba(l) + d;
    if (30 < p) {
      var T = d - d % 5;
      p = (o & (1 << T) - 1).toString(32), o >>= T, d -= T, Ga = 1 << 32 - ba(l) + d | u << d | o, ou = p + n;
    } else
      Ga = 1 << p | u << d | o, ou = n;
  }
  function Tr(n) {
    n.return !== null && (Ll(n, 1), Lp(n, 1, 0));
  }
  function uh(n) {
    for (; n === af; )
      af = cl[--rc], cl[rc] = null, bn = cl[--rc], cl[rc] = null;
    for (; n === iu; )
      iu = Ya[--Oa], Ya[Oa] = null, ou = Ya[--Oa], Ya[Oa] = null, Ga = Ya[--Oa], Ya[Oa] = null;
  }
  function lf(n, l) {
    Ya[Oa++] = Ga, Ya[Oa++] = ou, Ya[Oa++] = iu, Ga = l.id, ou = l.overflow, iu = n;
  }
  var Xn = null, Jt = null, ht = !1, Lu = null, Nn = !1, Bu = Error(h(519));
  function Bl(n) {
    var l = Error(
      h(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw Or(ol(l, n)), Bu;
  }
  function uf(n) {
    var l = n.stateNode, u = n.type, o = n.memoizedProps;
    switch (l[qt] = n, l[Sa] = o, u) {
      case "dialog":
        dt("cancel", l), dt("close", l);
        break;
      case "iframe":
      case "object":
      case "embed":
        dt("load", l);
        break;
      case "video":
      case "audio":
        for (u = 0; u < Pr.length; u++)
          dt(Pr[u], l);
        break;
      case "source":
        dt("error", l);
        break;
      case "img":
      case "image":
      case "link":
        dt("error", l), dt("load", l);
        break;
      case "details":
        dt("toggle", l);
        break;
      case "input":
        dt("invalid", l), Qs(
          l,
          o.value,
          o.defaultValue,
          o.checked,
          o.defaultChecked,
          o.type,
          o.name,
          !0
        );
        break;
      case "select":
        dt("invalid", l);
        break;
      case "textarea":
        dt("invalid", l), dp(l, o.value, o.defaultValue, o.children);
    }
    u = o.children, typeof u != "string" && typeof u != "number" && typeof u != "bigint" || l.textContent === "" + u || o.suppressHydrationWarning === !0 || Zy(l.textContent, u) ? (o.popover != null && (dt("beforetoggle", l), dt("toggle", l)), o.onScroll != null && dt("scroll", l), o.onScrollEnd != null && dt("scrollend", l), o.onClick != null && (l.onclick = Pl), l = !0) : l = !1, l || Bl(n, !0);
  }
  function Ar(n) {
    for (Xn = n.return; Xn; )
      switch (Xn.tag) {
        case 5:
        case 31:
        case 13:
          Nn = !1;
          return;
        case 27:
        case 3:
          Nn = !0;
          return;
        default:
          Xn = Xn.return;
      }
  }
  function ju(n) {
    if (n !== Xn) return !1;
    if (!ht) return Ar(n), ht = !0, !1;
    var l = n.tag, u;
    if ((u = l !== 3 && l !== 27) && ((u = l === 5) && (u = n.type, u = !(u !== "form" && u !== "button") || ts(n.type, n.memoizedProps)), u = !u), u && Jt && Bl(n), Ar(n), l === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(h(317));
      Jt = cm(n);
    } else if (l === 31) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(h(317));
      Jt = cm(n);
    } else
      l === 27 ? (l = Jt, vu(n.type) ? (n = Wf, Wf = null, Jt = n) : Jt = l) : Jt = Xn ? xa(n.stateNode.nextSibling) : null;
    return !0;
  }
  function so() {
    Jt = Xn = null, ht = !1;
  }
  function Bp() {
    var n = Lu;
    return n !== null && (fn === null ? fn = n : fn.push.apply(
      fn,
      n
    ), Lu = null), n;
  }
  function Or(n) {
    Lu === null ? Lu = [n] : Lu.push(n);
  }
  var ih = ee(null), _i = null, cu = null;
  function Da(n, l, u) {
    De(ih, l._currentValue), l._currentValue = u;
  }
  function ru(n) {
    n._currentValue = ih.current, ve(ih);
  }
  function oh(n, l, u) {
    for (; n !== null; ) {
      var o = n.alternate;
      if ((n.childLanes & l) !== l ? (n.childLanes |= l, o !== null && (o.childLanes |= l)) : o !== null && (o.childLanes & l) !== l && (o.childLanes |= l), n === u) break;
      n = n.return;
    }
  }
  function qu(n, l, u, o) {
    var d = n.child;
    for (d !== null && (d.return = n); d !== null; ) {
      var p = d.dependencies;
      if (p !== null) {
        var T = d.child;
        p = p.firstContext;
        e: for (; p !== null; ) {
          var C = p;
          p = d;
          for (var x = 0; x < l.length; x++)
            if (C.context === l[x]) {
              p.lanes |= u, C = p.alternate, C !== null && (C.lanes |= u), oh(
                p.return,
                u,
                n
              ), o || (T = null);
              break e;
            }
          p = C.next;
        }
      } else if (d.tag === 18) {
        if (T = d.return, T === null) throw Error(h(341));
        T.lanes |= u, p = T.alternate, p !== null && (p.lanes |= u), oh(T, u, n), T = null;
      } else T = d.child;
      if (T !== null) T.return = d;
      else
        for (T = d; T !== null; ) {
          if (T === n) {
            T = null;
            break;
          }
          if (d = T.sibling, d !== null) {
            d.return = T.return, T = d;
            break;
          }
          T = T.return;
        }
      d = T;
    }
  }
  function Qn(n, l, u, o) {
    n = null;
    for (var d = l, p = !1; d !== null; ) {
      if (!p) {
        if ((d.flags & 524288) !== 0) p = !0;
        else if ((d.flags & 262144) !== 0) break;
      }
      if (d.tag === 10) {
        var T = d.alternate;
        if (T === null) throw Error(h(387));
        if (T = T.memoizedProps, T !== null) {
          var C = d.type;
          sa(d.pendingProps.value, T.value) || (n !== null ? n.push(C) : n = [C]);
        }
      } else if (d === ft.current) {
        if (T = d.alternate, T === null) throw Error(h(387));
        T.memoizedState.memoizedState !== d.memoizedState.memoizedState && (n !== null ? n.push(ed) : n = [ed]);
      }
      d = d.return;
    }
    n !== null && qu(
      l,
      n,
      u,
      o
    ), l.flags |= 262144;
  }
  function sc(n) {
    for (n = n.firstContext; n !== null; ) {
      if (!sa(
        n.context._currentValue,
        n.memoizedValue
      ))
        return !0;
      n = n.next;
    }
    return !1;
  }
  function Je(n) {
    _i = n, cu = null, n = n.dependencies, n !== null && (n.firstContext = null);
  }
  function se(n) {
    return of(_i, n);
  }
  function Ui(n, l) {
    return _i === null && Je(n), of(n, l);
  }
  function of(n, l) {
    var u = l._currentValue;
    if (l = { context: l, memoizedValue: u, next: null }, cu === null) {
      if (n === null) throw Error(h(308));
      cu = l, n.dependencies = { lanes: 0, firstContext: l }, n.flags |= 524288;
    } else cu = cu.next = l;
    return u;
  }
  var mn = typeof AbortController < "u" ? AbortController : function() {
    var n = [], l = this.signal = {
      aborted: !1,
      addEventListener: function(u, o) {
        n.push(o);
      }
    };
    this.abort = function() {
      l.aborted = !0, n.forEach(function(u) {
        return u();
      });
    };
  }, jp = r.unstable_scheduleCallback, qp = r.unstable_NormalPriority, Sn = {
    $$typeof: ye,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function cf() {
    return {
      controller: new mn(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function rf(n) {
    n.refCount--, n.refCount === 0 && jp(qp, function() {
      n.controller.abort();
    });
  }
  var fc = null, sf = 0, fo = 0, Cn = null;
  function Nt(n, l) {
    if (fc === null) {
      var u = fc = [];
      sf = 0, fo = em(), Cn = {
        status: "pending",
        value: void 0,
        then: function(o) {
          u.push(o);
        }
      };
    }
    return sf++, l.then(ff, ff), l;
  }
  function ff() {
    if (--sf === 0 && fc !== null) {
      Cn !== null && (Cn.status = "fulfilled");
      var n = fc;
      fc = null, fo = 0, Cn = null;
      for (var l = 0; l < n.length; l++) (0, n[l])();
    }
  }
  function df(n, l) {
    var u = [], o = {
      status: "pending",
      value: null,
      reason: null,
      then: function(d) {
        u.push(d);
      }
    };
    return n.then(
      function() {
        o.status = "fulfilled", o.value = l;
        for (var d = 0; d < u.length; d++) (0, u[d])(l);
      },
      function(d) {
        for (o.status = "rejected", o.reason = d, d = 0; d < u.length; d++)
          (0, u[d])(void 0);
      }
    ), o;
  }
  var wi = H.S;
  H.S = function(n, l) {
    My = _e(), typeof l == "object" && l !== null && typeof l.then == "function" && Nt(n, l), wi !== null && wi(n, l);
  };
  var rl = ee(null);
  function sl() {
    var n = rl.current;
    return n !== null ? n : Yt.pooledCache;
  }
  function Dr(n, l) {
    l === null ? De(rl, rl.current) : De(rl, l.pool);
  }
  function dc() {
    var n = sl();
    return n === null ? null : { parent: Sn._currentValue, pool: n };
  }
  var ho = Error(h(460)), hc = Error(h(474)), Rr = Error(h(542)), mc = { then: function() {
  } };
  function Vp(n) {
    return n = n.status, n === "fulfilled" || n === "rejected";
  }
  function Yp(n, l, u) {
    switch (u = n[u], u === void 0 ? n.push(l) : u !== l && (l.then(Pl, Pl), l = u), l.status) {
      case "fulfilled":
        return l.value;
      case "rejected":
        throw n = l.reason, ch(n), n;
      default:
        if (typeof l.status == "string") l.then(Pl, Pl);
        else {
          if (n = Yt, n !== null && 100 < n.shellSuspendCounter)
            throw Error(h(482));
          n = l, n.status = "pending", n.then(
            function(o) {
              if (l.status === "pending") {
                var d = l;
                d.status = "fulfilled", d.value = o;
              }
            },
            function(o) {
              if (l.status === "pending") {
                var d = l;
                d.status = "rejected", d.reason = o;
              }
            }
          );
        }
        switch (l.status) {
          case "fulfilled":
            return l.value;
          case "rejected":
            throw n = l.reason, ch(n), n;
        }
        throw po = l, ho;
    }
  }
  function mo(n) {
    try {
      var l = n._init;
      return l(n._payload);
    } catch (u) {
      throw u !== null && typeof u == "object" && typeof u.then == "function" ? (po = u, ho) : u;
    }
  }
  var po = null;
  function Gp() {
    if (po === null) throw Error(h(459));
    var n = po;
    return po = null, n;
  }
  function ch(n) {
    if (n === ho || n === Rr)
      throw Error(h(483));
  }
  var yo = null, pc = 0;
  function hf(n) {
    var l = pc;
    return pc += 1, yo === null && (yo = []), Yp(yo, n, l);
  }
  function Cr(n, l) {
    l = l.props.ref, n.ref = l !== void 0 ? l : null;
  }
  function mf(n, l) {
    throw l.$$typeof === L ? Error(h(525)) : (n = Object.prototype.toString.call(l), Error(
      h(
        31,
        n === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : n
      )
    ));
  }
  function V0(n) {
    function l(X, q) {
      if (n) {
        var J = X.deletions;
        J === null ? (X.deletions = [q], X.flags |= 16) : J.push(q);
      }
    }
    function u(X, q) {
      if (!n) return null;
      for (; q !== null; )
        l(X, q), q = q.sibling;
      return null;
    }
    function o(X) {
      for (var q = /* @__PURE__ */ new Map(); X !== null; )
        X.key !== null ? q.set(X.key, X) : q.set(X.index, X), X = X.sibling;
      return q;
    }
    function d(X, q) {
      return X = Ci(X, q), X.index = 0, X.sibling = null, X;
    }
    function p(X, q, J) {
      return X.index = J, n ? (J = X.alternate, J !== null ? (J = J.index, J < q ? (X.flags |= 67108866, q) : J) : (X.flags |= 67108866, q)) : (X.flags |= 1048576, q);
    }
    function T(X) {
      return n && X.alternate === null && (X.flags |= 67108866), X;
    }
    function C(X, q, J, ce) {
      return q === null || q.tag !== 6 ? (q = Er(J, X.mode, ce), q.return = X, q) : (q = d(q, J), q.return = X, q);
    }
    function x(X, q, J, ce) {
      var je = J.type;
      return je === G ? le(
        X,
        q,
        J.props.children,
        ce,
        J.key
      ) : q !== null && (q.elementType === je || typeof je == "object" && je !== null && je.$$typeof === Se && mo(je) === q.type) ? (q = d(q, J.props), Cr(q, J), q.return = X, q) : (q = ah(
        J.type,
        J.key,
        J.props,
        null,
        X.mode,
        ce
      ), Cr(q, J), q.return = X, q);
    }
    function K(X, q, J, ce) {
      return q === null || q.tag !== 4 || q.stateNode.containerInfo !== J.containerInfo || q.stateNode.implementation !== J.implementation ? (q = lh(J, X.mode, ce), q.return = X, q) : (q = d(q, J.children || []), q.return = X, q);
    }
    function le(X, q, J, ce, je) {
      return q === null || q.tag !== 7 ? (q = zi(
        J,
        X.mode,
        ce,
        je
      ), q.return = X, q) : (q = d(q, J), q.return = X, q);
    }
    function re(X, q, J) {
      if (typeof q == "string" && q !== "" || typeof q == "number" || typeof q == "bigint")
        return q = Er(
          "" + q,
          X.mode,
          J
        ), q.return = X, q;
      if (typeof q == "object" && q !== null) {
        switch (q.$$typeof) {
          case Q:
            return J = ah(
              q.type,
              q.key,
              q.props,
              null,
              X.mode,
              J
            ), Cr(J, q), J.return = X, J;
          case N:
            return q = lh(
              q,
              X.mode,
              J
            ), q.return = X, q;
          case Se:
            return q = mo(q), re(X, q, J);
        }
        if (Rt(q) || Ce(q))
          return q = zi(
            q,
            X.mode,
            J,
            null
          ), q.return = X, q;
        if (typeof q.then == "function")
          return re(X, hf(q), J);
        if (q.$$typeof === ye)
          return re(
            X,
            Ui(X, q),
            J
          );
        mf(X, q);
      }
      return null;
    }
    function k(X, q, J, ce) {
      var je = q !== null ? q.key : null;
      if (typeof J == "string" && J !== "" || typeof J == "number" || typeof J == "bigint")
        return je !== null ? null : C(X, q, "" + J, ce);
      if (typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case Q:
            return J.key === je ? x(X, q, J, ce) : null;
          case N:
            return J.key === je ? K(X, q, J, ce) : null;
          case Se:
            return J = mo(J), k(X, q, J, ce);
        }
        if (Rt(J) || Ce(J))
          return je !== null ? null : le(X, q, J, ce, null);
        if (typeof J.then == "function")
          return k(
            X,
            q,
            hf(J),
            ce
          );
        if (J.$$typeof === ye)
          return k(
            X,
            q,
            Ui(X, J),
            ce
          );
        mf(X, J);
      }
      return null;
    }
    function P(X, q, J, ce, je) {
      if (typeof ce == "string" && ce !== "" || typeof ce == "number" || typeof ce == "bigint")
        return X = X.get(J) || null, C(q, X, "" + ce, je);
      if (typeof ce == "object" && ce !== null) {
        switch (ce.$$typeof) {
          case Q:
            return X = X.get(
              ce.key === null ? J : ce.key
            ) || null, x(q, X, ce, je);
          case N:
            return X = X.get(
              ce.key === null ? J : ce.key
            ) || null, K(q, X, ce, je);
          case Se:
            return ce = mo(ce), P(
              X,
              q,
              J,
              ce,
              je
            );
        }
        if (Rt(ce) || Ce(ce))
          return X = X.get(J) || null, le(q, X, ce, je, null);
        if (typeof ce.then == "function")
          return P(
            X,
            q,
            J,
            hf(ce),
            je
          );
        if (ce.$$typeof === ye)
          return P(
            X,
            q,
            J,
            Ui(q, ce),
            je
          );
        mf(q, ce);
      }
      return null;
    }
    function Ue(X, q, J, ce) {
      for (var je = null, Et = null, Ne = q, Ie = q = 0, at = null; Ne !== null && Ie < J.length; Ie++) {
        Ne.index > Ie ? (at = Ne, Ne = null) : at = Ne.sibling;
        var Dt = k(
          X,
          Ne,
          J[Ie],
          ce
        );
        if (Dt === null) {
          Ne === null && (Ne = at);
          break;
        }
        n && Ne && Dt.alternate === null && l(X, Ne), q = p(Dt, q, Ie), Et === null ? je = Dt : Et.sibling = Dt, Et = Dt, Ne = at;
      }
      if (Ie === J.length)
        return u(X, Ne), ht && Ll(X, Ie), je;
      if (Ne === null) {
        for (; Ie < J.length; Ie++)
          Ne = re(X, J[Ie], ce), Ne !== null && (q = p(
            Ne,
            q,
            Ie
          ), Et === null ? je = Ne : Et.sibling = Ne, Et = Ne);
        return ht && Ll(X, Ie), je;
      }
      for (Ne = o(Ne); Ie < J.length; Ie++)
        at = P(
          Ne,
          X,
          Ie,
          J[Ie],
          ce
        ), at !== null && (n && at.alternate !== null && Ne.delete(
          at.key === null ? Ie : at.key
        ), q = p(
          at,
          q,
          Ie
        ), Et === null ? je = at : Et.sibling = at, Et = at);
      return n && Ne.forEach(function(Eu) {
        return l(X, Eu);
      }), ht && Ll(X, Ie), je;
    }
    function Ye(X, q, J, ce) {
      if (J == null) throw Error(h(151));
      for (var je = null, Et = null, Ne = q, Ie = q = 0, at = null, Dt = J.next(); Ne !== null && !Dt.done; Ie++, Dt = J.next()) {
        Ne.index > Ie ? (at = Ne, Ne = null) : at = Ne.sibling;
        var Eu = k(X, Ne, Dt.value, ce);
        if (Eu === null) {
          Ne === null && (Ne = at);
          break;
        }
        n && Ne && Eu.alternate === null && l(X, Ne), q = p(Eu, q, Ie), Et === null ? je = Eu : Et.sibling = Eu, Et = Eu, Ne = at;
      }
      if (Dt.done)
        return u(X, Ne), ht && Ll(X, Ie), je;
      if (Ne === null) {
        for (; !Dt.done; Ie++, Dt = J.next())
          Dt = re(X, Dt.value, ce), Dt !== null && (q = p(Dt, q, Ie), Et === null ? je = Dt : Et.sibling = Dt, Et = Dt);
        return ht && Ll(X, Ie), je;
      }
      for (Ne = o(Ne); !Dt.done; Ie++, Dt = J.next())
        Dt = P(Ne, X, Ie, Dt.value, ce), Dt !== null && (n && Dt.alternate !== null && Ne.delete(Dt.key === null ? Ie : Dt.key), q = p(Dt, q, Ie), Et === null ? je = Dt : Et.sibling = Dt, Et = Dt);
      return n && Ne.forEach(function(Qv) {
        return l(X, Qv);
      }), ht && Ll(X, Ie), je;
    }
    function Xt(X, q, J, ce) {
      if (typeof J == "object" && J !== null && J.type === G && J.key === null && (J = J.props.children), typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case Q:
            e: {
              for (var je = J.key; q !== null; ) {
                if (q.key === je) {
                  if (je = J.type, je === G) {
                    if (q.tag === 7) {
                      u(
                        X,
                        q.sibling
                      ), ce = d(
                        q,
                        J.props.children
                      ), ce.return = X, X = ce;
                      break e;
                    }
                  } else if (q.elementType === je || typeof je == "object" && je !== null && je.$$typeof === Se && mo(je) === q.type) {
                    u(
                      X,
                      q.sibling
                    ), ce = d(q, J.props), Cr(ce, J), ce.return = X, X = ce;
                    break e;
                  }
                  u(X, q);
                  break;
                } else l(X, q);
                q = q.sibling;
              }
              J.type === G ? (ce = zi(
                J.props.children,
                X.mode,
                ce,
                J.key
              ), ce.return = X, X = ce) : (ce = ah(
                J.type,
                J.key,
                J.props,
                null,
                X.mode,
                ce
              ), Cr(ce, J), ce.return = X, X = ce);
            }
            return T(X);
          case N:
            e: {
              for (je = J.key; q !== null; ) {
                if (q.key === je)
                  if (q.tag === 4 && q.stateNode.containerInfo === J.containerInfo && q.stateNode.implementation === J.implementation) {
                    u(
                      X,
                      q.sibling
                    ), ce = d(q, J.children || []), ce.return = X, X = ce;
                    break e;
                  } else {
                    u(X, q);
                    break;
                  }
                else l(X, q);
                q = q.sibling;
              }
              ce = lh(J, X.mode, ce), ce.return = X, X = ce;
            }
            return T(X);
          case Se:
            return J = mo(J), Xt(
              X,
              q,
              J,
              ce
            );
        }
        if (Rt(J))
          return Ue(
            X,
            q,
            J,
            ce
          );
        if (Ce(J)) {
          if (je = Ce(J), typeof je != "function") throw Error(h(150));
          return J = je.call(J), Ye(
            X,
            q,
            J,
            ce
          );
        }
        if (typeof J.then == "function")
          return Xt(
            X,
            q,
            hf(J),
            ce
          );
        if (J.$$typeof === ye)
          return Xt(
            X,
            q,
            Ui(X, J),
            ce
          );
        mf(X, J);
      }
      return typeof J == "string" && J !== "" || typeof J == "number" || typeof J == "bigint" ? (J = "" + J, q !== null && q.tag === 6 ? (u(X, q.sibling), ce = d(q, J), ce.return = X, X = ce) : (u(X, q), ce = Er(J, X.mode, ce), ce.return = X, X = ce), T(X)) : u(X, q);
    }
    return function(X, q, J, ce) {
      try {
        pc = 0;
        var je = Xt(
          X,
          q,
          J,
          ce
        );
        return yo = null, je;
      } catch (Ne) {
        if (Ne === ho || Ne === Rr) throw Ne;
        var Et = hn(29, Ne, null, X.mode);
        return Et.lanes = ce, Et.return = X, Et;
      } finally {
      }
    };
  }
  var go = V0(!0), Xp = V0(!1), Mi = !1;
  function pf(n) {
    n.updateQueue = {
      baseState: n.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function rh(n, l) {
    n = n.updateQueue, l.updateQueue === n && (l.updateQueue = {
      baseState: n.baseState,
      firstBaseUpdate: n.firstBaseUpdate,
      lastBaseUpdate: n.lastBaseUpdate,
      shared: n.shared,
      callbacks: null
    });
  }
  function Ni(n) {
    return { lane: n, tag: 0, payload: null, callback: null, next: null };
  }
  function fl(n, l, u) {
    var o = n.updateQueue;
    if (o === null) return null;
    if (o = o.shared, (Ot & 2) !== 0) {
      var d = o.pending;
      return d === null ? l.next = l : (l.next = d.next, d.next = l), o.pending = l, l = nf(n), nh(n, null, u), l;
    }
    return il(n, o, l, u), nf(n);
  }
  function vo(n, l, u) {
    if (l = l.updateQueue, l !== null && (l = l.shared, (u & 4194048) !== 0)) {
      var o = l.lanes;
      o &= n.pendingLanes, u |= o, l.lanes = u, Cu(n, u);
    }
  }
  function sh(n, l) {
    var u = n.updateQueue, o = n.alternate;
    if (o !== null && (o = o.updateQueue, u === o)) {
      var d = null, p = null;
      if (u = u.firstBaseUpdate, u !== null) {
        do {
          var T = {
            lane: u.lane,
            tag: u.tag,
            payload: u.payload,
            callback: null,
            next: null
          };
          p === null ? d = p = T : p = p.next = T, u = u.next;
        } while (u !== null);
        p === null ? d = p = l : p = p.next = l;
      } else d = p = l;
      u = {
        baseState: o.baseState,
        firstBaseUpdate: d,
        lastBaseUpdate: p,
        shared: o.shared,
        callbacks: o.callbacks
      }, n.updateQueue = u;
      return;
    }
    n = u.lastBaseUpdate, n === null ? u.firstBaseUpdate = l : n.next = l, u.lastBaseUpdate = l;
  }
  var Qp = !1;
  function bo() {
    if (Qp) {
      var n = Cn;
      if (n !== null) throw n;
    }
  }
  function Vu(n, l, u, o) {
    Qp = !1;
    var d = n.updateQueue;
    Mi = !1;
    var p = d.firstBaseUpdate, T = d.lastBaseUpdate, C = d.shared.pending;
    if (C !== null) {
      d.shared.pending = null;
      var x = C, K = x.next;
      x.next = null, T === null ? p = K : T.next = K, T = x;
      var le = n.alternate;
      le !== null && (le = le.updateQueue, C = le.lastBaseUpdate, C !== T && (C === null ? le.firstBaseUpdate = K : C.next = K, le.lastBaseUpdate = x));
    }
    if (p !== null) {
      var re = d.baseState;
      T = 0, le = K = x = null, C = p;
      do {
        var k = C.lane & -536870913, P = k !== C.lane;
        if (P ? (rt & k) === k : (o & k) === k) {
          k !== 0 && k === fo && (Qp = !0), le !== null && (le = le.next = {
            lane: 0,
            tag: C.tag,
            payload: C.payload,
            callback: null,
            next: null
          });
          e: {
            var Ue = n, Ye = C;
            k = l;
            var Xt = u;
            switch (Ye.tag) {
              case 1:
                if (Ue = Ye.payload, typeof Ue == "function") {
                  re = Ue.call(Xt, re, k);
                  break e;
                }
                re = Ue;
                break e;
              case 3:
                Ue.flags = Ue.flags & -65537 | 128;
              case 0:
                if (Ue = Ye.payload, k = typeof Ue == "function" ? Ue.call(Xt, re, k) : Ue, k == null) break e;
                re = z({}, re, k);
                break e;
              case 2:
                Mi = !0;
            }
          }
          k = C.callback, k !== null && (n.flags |= 64, P && (n.flags |= 8192), P = d.callbacks, P === null ? d.callbacks = [k] : P.push(k));
        } else
          P = {
            lane: k,
            tag: C.tag,
            payload: C.payload,
            callback: C.callback,
            next: null
          }, le === null ? (K = le = P, x = re) : le = le.next = P, T |= k;
        if (C = C.next, C === null) {
          if (C = d.shared.pending, C === null)
            break;
          P = C, C = P.next, P.next = null, d.lastBaseUpdate = P, d.shared.pending = null;
        }
      } while (!0);
      le === null && (x = re), d.baseState = x, d.firstBaseUpdate = K, d.lastBaseUpdate = le, p === null && (d.shared.lanes = 0), yu |= T, n.lanes = T, n.memoizedState = re;
    }
  }
  function fh(n, l) {
    if (typeof n != "function")
      throw Error(h(191, n));
    n.call(l);
  }
  function So(n, l) {
    var u = n.callbacks;
    if (u !== null)
      for (n.callbacks = null, n = 0; n < u.length; n++)
        fh(u[n], l);
  }
  var xn = ee(null), yc = ee(0);
  function Y0(n, l) {
    n = pu, De(yc, n), De(xn, l), pu = n | l.baseLanes;
  }
  function yf() {
    De(yc, pu), De(xn, xn.current);
  }
  function zr() {
    pu = yc.current, ve(xn), ve(yc);
  }
  var Ra = ee(null), dl = null;
  function Yu(n) {
    var l = n.alternate;
    De(nn, nn.current & 1), De(Ra, n), dl === null && (l === null || xn.current !== null || l.memoizedState !== null) && (dl = n);
  }
  function _r(n) {
    De(nn, nn.current), De(Ra, n), dl === null && (dl = n);
  }
  function dh(n) {
    n.tag === 22 ? (De(nn, nn.current), De(Ra, n), dl === null && (dl = n)) : su();
  }
  function su() {
    De(nn, nn.current), De(Ra, Ra.current);
  }
  function Ca(n) {
    ve(Ra), dl === n && (dl = null), ve(nn);
  }
  var nn = ee(0);
  function Ur(n) {
    for (var l = n; l !== null; ) {
      if (l.tag === 13) {
        var u = l.memoizedState;
        if (u !== null && (u = u.dehydrated, u === null || Yl(u) || Mo(u)))
          return l;
      } else if (l.tag === 19 && (l.memoizedProps.revealOrder === "forwards" || l.memoizedProps.revealOrder === "backwards" || l.memoizedProps.revealOrder === "unstable_legacy-backwards" || l.memoizedProps.revealOrder === "together")) {
        if ((l.flags & 128) !== 0) return l;
      } else if (l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === n) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === n) return null;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
    return null;
  }
  var Gu = 0, Pe = null, xt = null, En = null, gc = !1, vc = !1, xi = !1, gf = 0, wr = 0, Eo = null, G0 = 0;
  function rn() {
    throw Error(h(321));
  }
  function Hi(n, l) {
    if (l === null) return !1;
    for (var u = 0; u < l.length && u < n.length; u++)
      if (!sa(n[u], l[u])) return !1;
    return !0;
  }
  function vf(n, l, u, o, d, p) {
    return Gu = p, Pe = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, H.H = n === null || n.memoizedState === null ? F0 : _h, xi = !1, p = u(o, d), xi = !1, vc && (p = X0(
      l,
      u,
      o,
      d
    )), hh(n), p;
  }
  function hh(n) {
    H.H = Cf;
    var l = xt !== null && xt.next !== null;
    if (Gu = 0, En = xt = Pe = null, gc = !1, wr = 0, Eo = null, l) throw Error(h(300));
    n === null || Tn || (n = n.dependencies, n !== null && sc(n) && (Tn = !0));
  }
  function X0(n, l, u, o) {
    Pe = n;
    var d = 0;
    do {
      if (vc && (Eo = null), wr = 0, vc = !1, 25 <= d) throw Error(h(301));
      if (d += 1, En = xt = null, n.updateQueue != null) {
        var p = n.updateQueue;
        p.lastEffect = null, p.events = null, p.stores = null, p.memoCache != null && (p.memoCache.index = 0);
      }
      H.H = W0, p = l(u, o);
    } while (vc);
    return p;
  }
  function Mb() {
    var n = H.H, l = n.useState()[0];
    return l = typeof l.then == "function" ? Sc(l) : l, n = n.useState()[0], (xt !== null ? xt.memoizedState : null) !== n && (Pe.flags |= 1024), l;
  }
  function mh() {
    var n = gf !== 0;
    return gf = 0, n;
  }
  function bc(n, l, u) {
    l.updateQueue = n.updateQueue, l.flags &= -2053, n.lanes &= ~u;
  }
  function bf(n) {
    if (gc) {
      for (n = n.memoizedState; n !== null; ) {
        var l = n.queue;
        l !== null && (l.pending = null), n = n.next;
      }
      gc = !1;
    }
    Gu = 0, En = xt = Pe = null, vc = !1, wr = gf = 0, Eo = null;
  }
  function Zn() {
    var n = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return En === null ? Pe.memoizedState = En = n : En = En.next = n, En;
  }
  function pn() {
    if (xt === null) {
      var n = Pe.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = xt.next;
    var l = En === null ? Pe.memoizedState : En.next;
    if (l !== null)
      En = l, xt = n;
    else {
      if (n === null)
        throw Pe.alternate === null ? Error(h(467)) : Error(h(310));
      xt = n, n = {
        memoizedState: xt.memoizedState,
        baseState: xt.baseState,
        baseQueue: xt.baseQueue,
        queue: xt.queue,
        next: null
      }, En === null ? Pe.memoizedState = En = n : En = En.next = n;
    }
    return En;
  }
  function Sf() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Sc(n) {
    var l = wr;
    return wr += 1, Eo === null && (Eo = []), n = Yp(Eo, n, l), l = Pe, (En === null ? l.memoizedState : En.next) === null && (l = l.alternate, H.H = l === null || l.memoizedState === null ? F0 : _h), n;
  }
  function Mr(n) {
    if (n !== null && typeof n == "object") {
      if (typeof n.then == "function") return Sc(n);
      if (n.$$typeof === ye) return se(n);
    }
    throw Error(h(438, String(n)));
  }
  function ph(n) {
    var l = null, u = Pe.updateQueue;
    if (u !== null && (l = u.memoCache), l == null) {
      var o = Pe.alternate;
      o !== null && (o = o.updateQueue, o !== null && (o = o.memoCache, o != null && (l = {
        data: o.data.map(function(d) {
          return d.slice();
        }),
        index: 0
      })));
    }
    if (l == null && (l = { data: [], index: 0 }), u === null && (u = Sf(), Pe.updateQueue = u), u.memoCache = l, u = l.data[l.index], u === void 0)
      for (u = l.data[l.index] = Array(n), o = 0; o < n; o++)
        u[o] = ae;
    return l.index++, u;
  }
  function Xu(n, l) {
    return typeof l == "function" ? l(n) : l;
  }
  function Qu(n) {
    var l = pn();
    return yh(l, xt, n);
  }
  function yh(n, l, u) {
    var o = n.queue;
    if (o === null) throw Error(h(311));
    o.lastRenderedReducer = u;
    var d = n.baseQueue, p = o.pending;
    if (p !== null) {
      if (d !== null) {
        var T = d.next;
        d.next = p.next, p.next = T;
      }
      l.baseQueue = d = p, o.pending = null;
    }
    if (p = n.baseState, d === null) n.memoizedState = p;
    else {
      l = d.next;
      var C = T = null, x = null, K = l, le = !1;
      do {
        var re = K.lane & -536870913;
        if (re !== K.lane ? (rt & re) === re : (Gu & re) === re) {
          var k = K.revertLane;
          if (k === 0)
            x !== null && (x = x.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: K.action,
              hasEagerState: K.hasEagerState,
              eagerState: K.eagerState,
              next: null
            }), re === fo && (le = !0);
          else if ((Gu & k) === k) {
            K = K.next, k === fo && (le = !0);
            continue;
          } else
            re = {
              lane: 0,
              revertLane: K.revertLane,
              gesture: null,
              action: K.action,
              hasEagerState: K.hasEagerState,
              eagerState: K.eagerState,
              next: null
            }, x === null ? (C = x = re, T = p) : x = x.next = re, Pe.lanes |= k, yu |= k;
          re = K.action, xi && u(p, re), p = K.hasEagerState ? K.eagerState : u(p, re);
        } else
          k = {
            lane: re,
            revertLane: K.revertLane,
            gesture: K.gesture,
            action: K.action,
            hasEagerState: K.hasEagerState,
            eagerState: K.eagerState,
            next: null
          }, x === null ? (C = x = k, T = p) : x = x.next = k, Pe.lanes |= re, yu |= re;
        K = K.next;
      } while (K !== null && K !== l);
      if (x === null ? T = p : x.next = C, !sa(p, n.memoizedState) && (Tn = !0, le && (u = Cn, u !== null)))
        throw u;
      n.memoizedState = p, n.baseState = T, n.baseQueue = x, o.lastRenderedState = p;
    }
    return d === null && (o.lanes = 0), [n.memoizedState, o.dispatch];
  }
  function gh(n) {
    var l = pn(), u = l.queue;
    if (u === null) throw Error(h(311));
    u.lastRenderedReducer = n;
    var o = u.dispatch, d = u.pending, p = l.memoizedState;
    if (d !== null) {
      u.pending = null;
      var T = d = d.next;
      do
        p = n(p, T.action), T = T.next;
      while (T !== d);
      sa(p, l.memoizedState) || (Tn = !0), l.memoizedState = p, l.baseQueue === null && (l.baseState = p), u.lastRenderedState = p;
    }
    return [p, o];
  }
  function Zp(n, l, u) {
    var o = Pe, d = pn(), p = ht;
    if (p) {
      if (u === void 0) throw Error(h(407));
      u = u();
    } else u = l();
    var T = !sa(
      (xt || d).memoizedState,
      u
    );
    if (T && (d.memoizedState = u, Tn = !0), d = d.queue, Th(vh.bind(null, o, d, n), [
      n
    ]), d.getSnapshot !== l || T || En !== null && En.memoizedState.tag & 1) {
      if (o.flags |= 2048, Tc(
        9,
        { destroy: void 0 },
        Jp.bind(
          null,
          o,
          d,
          u,
          l
        ),
        null
      ), Yt === null) throw Error(h(349));
      p || (Gu & 127) !== 0 || Ef(o, l, u);
    }
    return u;
  }
  function Ef(n, l, u) {
    n.flags |= 16384, n = { getSnapshot: l, value: u }, l = Pe.updateQueue, l === null ? (l = Sf(), Pe.updateQueue = l, l.stores = [n]) : (u = l.stores, u === null ? l.stores = [n] : u.push(n));
  }
  function Jp(n, l, u, o) {
    l.value = u, l.getSnapshot = o, bh(l) && Sh(n);
  }
  function vh(n, l, u) {
    return u(function() {
      bh(l) && Sh(n);
    });
  }
  function bh(n) {
    var l = n.getSnapshot;
    n = n.value;
    try {
      var u = l();
      return !sa(n, u);
    } catch {
      return !0;
    }
  }
  function Sh(n) {
    var l = Ri(n, 2);
    l !== null && Na(l, n, 2);
  }
  function Kp(n) {
    var l = Zn();
    if (typeof n == "function") {
      var u = n;
      if (n = u(), xi) {
        Si(!0);
        try {
          u();
        } finally {
          Si(!1);
        }
      }
    }
    return l.memoizedState = l.baseState = n, l.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Xu,
      lastRenderedState: n
    }, l;
  }
  function Jn(n, l, u, o) {
    return n.baseState = u, yh(
      n,
      xt,
      typeof o == "function" ? o : Xu
    );
  }
  function Q0(n, l, u, o, d) {
    if (Rf(n)) throw Error(h(485));
    if (n = l.action, n !== null) {
      var p = {
        payload: d,
        action: n,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(T) {
          p.listeners.push(T);
        }
      };
      H.T !== null ? u(!0) : p.isTransition = !1, o(p), u = l.pending, u === null ? (p.next = l.pending = p, kp(l, p)) : (p.next = u.next, l.pending = u.next = p);
    }
  }
  function kp(n, l) {
    var u = l.action, o = l.payload, d = n.state;
    if (l.isTransition) {
      var p = H.T, T = {};
      H.T = T;
      try {
        var C = u(d, o), x = H.S;
        x !== null && x(T, C), $p(n, l, C);
      } catch (K) {
        Ec(n, l, K);
      } finally {
        p !== null && T.types !== null && (p.types = T.types), H.T = p;
      }
    } else
      try {
        p = u(d, o), $p(n, l, p);
      } catch (K) {
        Ec(n, l, K);
      }
  }
  function $p(n, l, u) {
    u !== null && typeof u == "object" && typeof u.then == "function" ? u.then(
      function(o) {
        Fp(n, l, o);
      },
      function(o) {
        return Ec(n, l, o);
      }
    ) : Fp(n, l, u);
  }
  function Fp(n, l, u) {
    l.status = "fulfilled", l.value = u, Wp(l), n.state = u, l = n.pending, l !== null && (u = l.next, u === l ? n.pending = null : (u = u.next, l.next = u, kp(n, u)));
  }
  function Ec(n, l, u) {
    var o = n.pending;
    if (n.pending = null, o !== null) {
      o = o.next;
      do
        l.status = "rejected", l.reason = u, Wp(l), l = l.next;
      while (l !== o);
    }
    n.action = null;
  }
  function Wp(n) {
    n = n.listeners;
    for (var l = 0; l < n.length; l++) (0, n[l])();
  }
  function Tf(n, l) {
    return l;
  }
  function Ip(n, l) {
    if (ht) {
      var u = Yt.formState;
      if (u !== null) {
        e: {
          var o = Pe;
          if (ht) {
            if (Jt) {
              t: {
                for (var d = Jt, p = Nn; d.nodeType !== 8; ) {
                  if (!p) {
                    d = null;
                    break t;
                  }
                  if (d = xa(
                    d.nextSibling
                  ), d === null) {
                    d = null;
                    break t;
                  }
                }
                p = d.data, d = p === "F!" || p === "F" ? d : null;
              }
              if (d) {
                Jt = xa(
                  d.nextSibling
                ), o = d.data === "F!";
                break e;
              }
            }
            Bl(o);
          }
          o = !1;
        }
        o && (l = u[0]);
      }
    }
    return u = Zn(), u.memoizedState = u.baseState = l, o = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Tf,
      lastRenderedState: l
    }, u.queue = o, u = Ch.bind(
      null,
      Pe,
      o
    ), o.dispatch = u, o = Kp(!1), p = To.bind(
      null,
      Pe,
      !1,
      o.queue
    ), o = Zn(), d = {
      state: l,
      dispatch: null,
      action: n,
      pending: null
    }, o.queue = d, u = Q0.bind(
      null,
      Pe,
      d,
      p,
      u
    ), d.dispatch = u, o.memoizedState = n, [l, u, !1];
  }
  function Z0(n) {
    var l = pn();
    return Af(l, xt, n);
  }
  function Af(n, l, u) {
    if (l = yh(
      n,
      l,
      Tf
    )[0], n = Qu(Xu)[0], typeof l == "object" && l !== null && typeof l.then == "function")
      try {
        var o = Sc(l);
      } catch (T) {
        throw T === ho ? Rr : T;
      }
    else o = l;
    l = pn();
    var d = l.queue, p = d.dispatch;
    return u !== l.memoizedState && (Pe.flags |= 2048, Tc(
      9,
      { destroy: void 0 },
      Pp.bind(null, d, u),
      null
    )), [o, p, n];
  }
  function Pp(n, l) {
    n.action = l;
  }
  function ey(n) {
    var l = pn(), u = xt;
    if (u !== null)
      return Af(l, u, n);
    pn(), l = l.memoizedState, u = pn();
    var o = u.queue.dispatch;
    return u.memoizedState = n, [l, o, !1];
  }
  function Tc(n, l, u, o) {
    return n = { tag: n, create: u, deps: o, inst: l, next: null }, l = Pe.updateQueue, l === null && (l = Sf(), Pe.updateQueue = l), u = l.lastEffect, u === null ? l.lastEffect = n.next = n : (o = u.next, u.next = n, n.next = o, l.lastEffect = n), n;
  }
  function ty() {
    return pn().memoizedState;
  }
  function Nr(n, l, u, o) {
    var d = Zn();
    Pe.flags |= n, d.memoizedState = Tc(
      1 | l,
      { destroy: void 0 },
      u,
      o === void 0 ? null : o
    );
  }
  function xr(n, l, u, o) {
    var d = pn();
    o = o === void 0 ? null : o;
    var p = d.memoizedState.inst;
    xt !== null && o !== null && Hi(o, xt.memoizedState.deps) ? d.memoizedState = Tc(l, p, u, o) : (Pe.flags |= n, d.memoizedState = Tc(
      1 | l,
      p,
      u,
      o
    ));
  }
  function Eh(n, l) {
    Nr(8390656, 8, n, l);
  }
  function Th(n, l) {
    xr(2048, 8, n, l);
  }
  function ny(n) {
    Pe.flags |= 4;
    var l = Pe.updateQueue;
    if (l === null)
      l = Sf(), Pe.updateQueue = l, l.events = [n];
    else {
      var u = l.events;
      u === null ? l.events = [n] : u.push(n);
    }
  }
  function Of(n) {
    var l = pn().memoizedState;
    return ny({ ref: l, nextImpl: n }), function() {
      if ((Ot & 2) !== 0) throw Error(h(440));
      return l.impl.apply(void 0, arguments);
    };
  }
  function Ah(n, l) {
    return xr(4, 2, n, l);
  }
  function ay(n, l) {
    return xr(4, 4, n, l);
  }
  function Oh(n, l) {
    if (typeof l == "function") {
      n = n();
      var u = l(n);
      return function() {
        typeof u == "function" ? u() : l(null);
      };
    }
    if (l != null)
      return n = n(), l.current = n, function() {
        l.current = null;
      };
  }
  function ly(n, l, u) {
    u = u != null ? u.concat([n]) : null, xr(4, 4, Oh.bind(null, l, n), u);
  }
  function fu() {
  }
  function Dh(n, l) {
    var u = pn();
    l = l === void 0 ? null : l;
    var o = u.memoizedState;
    return l !== null && Hi(l, o[1]) ? o[0] : (u.memoizedState = [n, l], n);
  }
  function J0(n, l) {
    var u = pn();
    l = l === void 0 ? null : l;
    var o = u.memoizedState;
    if (l !== null && Hi(l, o[1]))
      return o[0];
    if (o = n(), xi) {
      Si(!0);
      try {
        n();
      } finally {
        Si(!1);
      }
    }
    return u.memoizedState = [o, l], o;
  }
  function Df(n, l, u) {
    return u === void 0 || (Gu & 1073741824) !== 0 && (rt & 261930) === 0 ? n.memoizedState = l : (n.memoizedState = u, n = ov(), Pe.lanes |= n, yu |= n, u);
  }
  function Zu(n, l, u, o) {
    return sa(u, l) ? u : xn.current !== null ? (n = Df(n, u, o), sa(n, l) || (Tn = !0), n) : (Gu & 42) === 0 || (Gu & 1073741824) !== 0 && (rt & 261930) === 0 ? (Tn = !0, n.memoizedState = u) : (n = ov(), Pe.lanes |= n, yu |= n, l);
  }
  function Rh(n, l, u, o, d) {
    var p = ue.p;
    ue.p = p !== 0 && 8 > p ? p : 8;
    var T = H.T, C = {};
    H.T = C, To(n, !1, l, u);
    try {
      var x = d(), K = H.S;
      if (K !== null && K(C, x), x !== null && typeof x == "object" && typeof x.then == "function") {
        var le = df(
          x,
          o
        );
        Li(
          n,
          l,
          le,
          Ja(n)
        );
      } else
        Li(
          n,
          l,
          o,
          Ja(n)
        );
    } catch (re) {
      Li(
        n,
        l,
        { then: function() {
        }, status: "rejected", reason: re },
        Ja()
      );
    } finally {
      ue.p = p, T !== null && C.types !== null && (T.types = C.types), H.T = T;
    }
  }
  function K0() {
  }
  function Hr(n, l, u, o) {
    if (n.tag !== 5) throw Error(h(476));
    var d = Lr(n).queue;
    Rh(
      n,
      d,
      l,
      fe,
      u === null ? K0 : function() {
        return Vt(n), u(o);
      }
    );
  }
  function Lr(n) {
    var l = n.memoizedState;
    if (l !== null) return l;
    l = {
      memoizedState: fe,
      baseState: fe,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Xu,
        lastRenderedState: fe
      },
      next: null
    };
    var u = {};
    return l.next = {
      memoizedState: u,
      baseState: u,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Xu,
        lastRenderedState: u
      },
      next: null
    }, n.memoizedState = l, n = n.alternate, n !== null && (n.memoizedState = l), l;
  }
  function Vt(n) {
    var l = Lr(n);
    l.next === null && (l = n.alternate.memoizedState), Li(
      n,
      l.next.queue,
      {},
      Ja()
    );
  }
  function uy() {
    return se(ed);
  }
  function k0() {
    return pn().memoizedState;
  }
  function iy() {
    return pn().memoizedState;
  }
  function Ju(n) {
    for (var l = n.return; l !== null; ) {
      switch (l.tag) {
        case 24:
        case 3:
          var u = Ja();
          n = Ni(u);
          var o = fl(l, n, u);
          o !== null && (Na(o, l, u), vo(o, l, u)), l = { cache: cf() }, n.payload = l;
          return;
      }
      l = l.return;
    }
  }
  function $0(n, l, u) {
    var o = Ja();
    u = {
      lane: o,
      revertLane: 0,
      gesture: null,
      action: u,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Rf(n) ? zh(l, u) : (u = Hl(n, l, u, o), u !== null && (Na(u, n, o), oy(u, l, o)));
  }
  function Ch(n, l, u) {
    var o = Ja();
    Li(n, l, u, o);
  }
  function Li(n, l, u, o) {
    var d = {
      lane: o,
      revertLane: 0,
      gesture: null,
      action: u,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Rf(n)) zh(l, d);
    else {
      var p = n.alternate;
      if (n.lanes === 0 && (p === null || p.lanes === 0) && (p = l.lastRenderedReducer, p !== null))
        try {
          var T = l.lastRenderedState, C = p(T, u);
          if (d.hasEagerState = !0, d.eagerState = C, sa(C, T))
            return il(n, l, d, 0), Yt === null && ul(), !1;
        } catch {
        } finally {
        }
      if (u = Hl(n, l, d, o), u !== null)
        return Na(u, n, o), oy(u, l, o), !0;
    }
    return !1;
  }
  function To(n, l, u, o) {
    if (o = {
      lane: 2,
      revertLane: em(),
      gesture: null,
      action: o,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Rf(n)) {
      if (l) throw Error(h(479));
    } else
      l = Hl(
        n,
        u,
        o,
        2
      ), l !== null && Na(l, n, 2);
  }
  function Rf(n) {
    var l = n.alternate;
    return n === Pe || l !== null && l === Pe;
  }
  function zh(n, l) {
    vc = gc = !0;
    var u = n.pending;
    u === null ? l.next = l : (l.next = u.next, u.next = l), n.pending = l;
  }
  function oy(n, l, u) {
    if ((u & 4194048) !== 0) {
      var o = l.lanes;
      o &= n.pendingLanes, u |= o, l.lanes = u, Cu(n, u);
    }
  }
  var Cf = {
    readContext: se,
    use: Mr,
    useCallback: rn,
    useContext: rn,
    useEffect: rn,
    useImperativeHandle: rn,
    useLayoutEffect: rn,
    useInsertionEffect: rn,
    useMemo: rn,
    useReducer: rn,
    useRef: rn,
    useState: rn,
    useDebugValue: rn,
    useDeferredValue: rn,
    useTransition: rn,
    useSyncExternalStore: rn,
    useId: rn,
    useHostTransitionStatus: rn,
    useFormState: rn,
    useActionState: rn,
    useOptimistic: rn,
    useMemoCache: rn,
    useCacheRefresh: rn
  };
  Cf.useEffectEvent = rn;
  var F0 = {
    readContext: se,
    use: Mr,
    useCallback: function(n, l) {
      return Zn().memoizedState = [
        n,
        l === void 0 ? null : l
      ], n;
    },
    useContext: se,
    useEffect: Eh,
    useImperativeHandle: function(n, l, u) {
      u = u != null ? u.concat([n]) : null, Nr(
        4194308,
        4,
        Oh.bind(null, l, n),
        u
      );
    },
    useLayoutEffect: function(n, l) {
      return Nr(4194308, 4, n, l);
    },
    useInsertionEffect: function(n, l) {
      Nr(4, 2, n, l);
    },
    useMemo: function(n, l) {
      var u = Zn();
      l = l === void 0 ? null : l;
      var o = n();
      if (xi) {
        Si(!0);
        try {
          n();
        } finally {
          Si(!1);
        }
      }
      return u.memoizedState = [o, l], o;
    },
    useReducer: function(n, l, u) {
      var o = Zn();
      if (u !== void 0) {
        var d = u(l);
        if (xi) {
          Si(!0);
          try {
            u(l);
          } finally {
            Si(!1);
          }
        }
      } else d = l;
      return o.memoizedState = o.baseState = d, n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: d
      }, o.queue = n, n = n.dispatch = $0.bind(
        null,
        Pe,
        n
      ), [o.memoizedState, n];
    },
    useRef: function(n) {
      var l = Zn();
      return n = { current: n }, l.memoizedState = n;
    },
    useState: function(n) {
      n = Kp(n);
      var l = n.queue, u = Ch.bind(null, Pe, l);
      return l.dispatch = u, [n.memoizedState, u];
    },
    useDebugValue: fu,
    useDeferredValue: function(n, l) {
      var u = Zn();
      return Df(u, n, l);
    },
    useTransition: function() {
      var n = Kp(!1);
      return n = Rh.bind(
        null,
        Pe,
        n.queue,
        !0,
        !1
      ), Zn().memoizedState = n, [!1, n];
    },
    useSyncExternalStore: function(n, l, u) {
      var o = Pe, d = Zn();
      if (ht) {
        if (u === void 0)
          throw Error(h(407));
        u = u();
      } else {
        if (u = l(), Yt === null)
          throw Error(h(349));
        (rt & 127) !== 0 || Ef(o, l, u);
      }
      d.memoizedState = u;
      var p = { value: u, getSnapshot: l };
      return d.queue = p, Eh(vh.bind(null, o, p, n), [
        n
      ]), o.flags |= 2048, Tc(
        9,
        { destroy: void 0 },
        Jp.bind(
          null,
          o,
          p,
          u,
          l
        ),
        null
      ), u;
    },
    useId: function() {
      var n = Zn(), l = Yt.identifierPrefix;
      if (ht) {
        var u = ou, o = Ga;
        u = (o & ~(1 << 32 - ba(o) - 1)).toString(32) + u, l = "_" + l + "R_" + u, u = gf++, 0 < u && (l += "H" + u.toString(32)), l += "_";
      } else
        u = G0++, l = "_" + l + "r_" + u.toString(32) + "_";
      return n.memoizedState = l;
    },
    useHostTransitionStatus: uy,
    useFormState: Ip,
    useActionState: Ip,
    useOptimistic: function(n) {
      var l = Zn();
      l.memoizedState = l.baseState = n;
      var u = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return l.queue = u, l = To.bind(
        null,
        Pe,
        !0,
        u
      ), u.dispatch = l, [n, l];
    },
    useMemoCache: ph,
    useCacheRefresh: function() {
      return Zn().memoizedState = Ju.bind(
        null,
        Pe
      );
    },
    useEffectEvent: function(n) {
      var l = Zn(), u = { impl: n };
      return l.memoizedState = u, function() {
        if ((Ot & 2) !== 0)
          throw Error(h(440));
        return u.impl.apply(void 0, arguments);
      };
    }
  }, _h = {
    readContext: se,
    use: Mr,
    useCallback: Dh,
    useContext: se,
    useEffect: Th,
    useImperativeHandle: ly,
    useInsertionEffect: Ah,
    useLayoutEffect: ay,
    useMemo: J0,
    useReducer: Qu,
    useRef: ty,
    useState: function() {
      return Qu(Xu);
    },
    useDebugValue: fu,
    useDeferredValue: function(n, l) {
      var u = pn();
      return Zu(
        u,
        xt.memoizedState,
        n,
        l
      );
    },
    useTransition: function() {
      var n = Qu(Xu)[0], l = pn().memoizedState;
      return [
        typeof n == "boolean" ? n : Sc(n),
        l
      ];
    },
    useSyncExternalStore: Zp,
    useId: k0,
    useHostTransitionStatus: uy,
    useFormState: Z0,
    useActionState: Z0,
    useOptimistic: function(n, l) {
      var u = pn();
      return Jn(u, xt, n, l);
    },
    useMemoCache: ph,
    useCacheRefresh: iy
  };
  _h.useEffectEvent = Of;
  var W0 = {
    readContext: se,
    use: Mr,
    useCallback: Dh,
    useContext: se,
    useEffect: Th,
    useImperativeHandle: ly,
    useInsertionEffect: Ah,
    useLayoutEffect: ay,
    useMemo: J0,
    useReducer: gh,
    useRef: ty,
    useState: function() {
      return gh(Xu);
    },
    useDebugValue: fu,
    useDeferredValue: function(n, l) {
      var u = pn();
      return xt === null ? Df(u, n, l) : Zu(
        u,
        xt.memoizedState,
        n,
        l
      );
    },
    useTransition: function() {
      var n = gh(Xu)[0], l = pn().memoizedState;
      return [
        typeof n == "boolean" ? n : Sc(n),
        l
      ];
    },
    useSyncExternalStore: Zp,
    useId: k0,
    useHostTransitionStatus: uy,
    useFormState: ey,
    useActionState: ey,
    useOptimistic: function(n, l) {
      var u = pn();
      return xt !== null ? Jn(u, xt, n, l) : (u.baseState = n, [n, u.queue.dispatch]);
    },
    useMemoCache: ph,
    useCacheRefresh: iy
  };
  W0.useEffectEvent = Of;
  function Ac(n, l, u, o) {
    l = n.memoizedState, u = u(o, l), u = u == null ? l : z({}, l, u), n.memoizedState = u, n.lanes === 0 && (n.updateQueue.baseState = u);
  }
  var jl = {
    enqueueSetState: function(n, l, u) {
      n = n._reactInternals;
      var o = Ja(), d = Ni(o);
      d.payload = l, u != null && (d.callback = u), l = fl(n, d, o), l !== null && (Na(l, n, o), vo(l, n, o));
    },
    enqueueReplaceState: function(n, l, u) {
      n = n._reactInternals;
      var o = Ja(), d = Ni(o);
      d.tag = 1, d.payload = l, u != null && (d.callback = u), l = fl(n, d, o), l !== null && (Na(l, n, o), vo(l, n, o));
    },
    enqueueForceUpdate: function(n, l) {
      n = n._reactInternals;
      var u = Ja(), o = Ni(u);
      o.tag = 2, l != null && (o.callback = l), l = fl(n, o, u), l !== null && (Na(l, n, u), vo(l, n, u));
    }
  };
  function cy(n, l, u, o, d, p, T) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(o, p, T) : l.prototype && l.prototype.isPureReactComponent ? !Ml(u, o) || !Ml(d, p) : !0;
  }
  function I0(n, l, u, o) {
    n = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(u, o), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(u, o), l.state !== n && jl.enqueueReplaceState(l, l.state, null);
  }
  function Ao(n, l) {
    var u = l;
    if ("ref" in l) {
      u = {};
      for (var o in l)
        o !== "ref" && (u[o] = l[o]);
    }
    if (n = n.defaultProps) {
      u === l && (u = z({}, u));
      for (var d in n)
        u[d] === void 0 && (u[d] = n[d]);
    }
    return u;
  }
  function Uh(n) {
    oc(n);
  }
  function ry(n) {
    console.error(n);
  }
  function wh(n) {
    oc(n);
  }
  function Br(n, l) {
    try {
      var u = n.onUncaughtError;
      u(l.value, { componentStack: l.stack });
    } catch (o) {
      setTimeout(function() {
        throw o;
      });
    }
  }
  function zf(n, l, u) {
    try {
      var o = n.onCaughtError;
      o(u.value, {
        componentStack: u.stack,
        errorBoundary: l.tag === 1 ? l.stateNode : null
      });
    } catch (d) {
      setTimeout(function() {
        throw d;
      });
    }
  }
  function sy(n, l, u) {
    return u = Ni(u), u.tag = 3, u.payload = { element: null }, u.callback = function() {
      Br(n, l);
    }, u;
  }
  function fy(n) {
    return n = Ni(n), n.tag = 3, n;
  }
  function dy(n, l, u, o) {
    var d = u.type.getDerivedStateFromError;
    if (typeof d == "function") {
      var p = o.value;
      n.payload = function() {
        return d(p);
      }, n.callback = function() {
        zf(l, u, o);
      };
    }
    var T = u.stateNode;
    T !== null && typeof T.componentDidCatch == "function" && (n.callback = function() {
      zf(l, u, o), typeof d != "function" && (an === null ? an = /* @__PURE__ */ new Set([this]) : an.add(this));
      var C = o.stack;
      this.componentDidCatch(o.value, {
        componentStack: C !== null ? C : ""
      });
    });
  }
  function Nb(n, l, u, o, d) {
    if (u.flags |= 32768, o !== null && typeof o == "object" && typeof o.then == "function") {
      if (l = u.alternate, l !== null && Qn(
        l,
        u,
        d,
        !0
      ), u = Ra.current, u !== null) {
        switch (u.tag) {
          case 31:
          case 13:
            return dl === null ? Fh() : u.alternate === null && kt === 0 && (kt = 3), u.flags &= -257, u.flags |= 65536, u.lanes = d, o === mc ? u.flags |= 16384 : (l = u.updateQueue, l === null ? u.updateQueue = /* @__PURE__ */ new Set([o]) : l.add(o), Gf(n, o, d)), !1;
          case 22:
            return u.flags |= 65536, o === mc ? u.flags |= 16384 : (l = u.updateQueue, l === null ? (l = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([o])
            }, u.updateQueue = l) : (u = l.retryQueue, u === null ? l.retryQueue = /* @__PURE__ */ new Set([o]) : u.add(o)), Gf(n, o, d)), !1;
        }
        throw Error(h(435, u.tag));
      }
      return Gf(n, o, d), Fh(), !1;
    }
    if (ht)
      return l = Ra.current, l !== null ? ((l.flags & 65536) === 0 && (l.flags |= 256), l.flags |= 65536, l.lanes = d, o !== Bu && (n = Error(h(422), { cause: o }), Or(ol(n, u)))) : (o !== Bu && (l = Error(h(423), {
        cause: o
      }), Or(
        ol(l, u)
      )), n = n.current.alternate, n.flags |= 65536, d &= -d, n.lanes |= d, o = ol(o, u), d = sy(
        n.stateNode,
        o,
        d
      ), sh(n, d), kt !== 4 && (kt = 2)), !1;
    var p = Error(h(520), { cause: o });
    if (p = ol(p, u), jf === null ? jf = [p] : jf.push(p), kt !== 4 && (kt = 2), l === null) return !0;
    o = ol(o, u), u = l;
    do {
      switch (u.tag) {
        case 3:
          return u.flags |= 65536, n = d & -d, u.lanes |= n, n = sy(u.stateNode, o, n), sh(u, n), !1;
        case 1:
          if (l = u.type, p = u.stateNode, (u.flags & 128) === 0 && (typeof l.getDerivedStateFromError == "function" || p !== null && typeof p.componentDidCatch == "function" && (an === null || !an.has(p))))
            return u.flags |= 65536, d &= -d, u.lanes |= d, d = fy(d), dy(
              d,
              n,
              u,
              o
            ), sh(u, d), !1;
      }
      u = u.return;
    } while (u !== null);
    return !1;
  }
  var Mh = Error(h(461)), Tn = !1;
  function It(n, l, u, o) {
    l.child = n === null ? Xp(l, null, u, o) : go(
      l,
      n.child,
      u,
      o
    );
  }
  function hy(n, l, u, o, d) {
    u = u.render;
    var p = l.ref;
    if ("ref" in o) {
      var T = {};
      for (var C in o)
        C !== "ref" && (T[C] = o[C]);
    } else T = o;
    return Je(l), o = vf(
      n,
      l,
      u,
      T,
      p,
      d
    ), C = mh(), n !== null && !Tn ? (bc(n, l, d), pl(n, l, d)) : (ht && C && Tr(l), l.flags |= 1, It(n, l, o, d), l.child);
  }
  function my(n, l, u, o, d) {
    if (n === null) {
      var p = u.type;
      return typeof p == "function" && !cc(p) && p.defaultProps === void 0 && u.compare === null ? (l.tag = 15, l.type = p, py(
        n,
        l,
        p,
        o,
        d
      )) : (n = ah(
        u.type,
        null,
        o,
        l,
        l.mode,
        d
      ), n.ref = l.ref, n.return = l, l.child = n);
    }
    if (p = n.child, !Hh(n, d)) {
      var T = p.memoizedProps;
      if (u = u.compare, u = u !== null ? u : Ml, u(T, o) && n.ref === l.ref)
        return pl(n, l, d);
    }
    return l.flags |= 1, n = Ci(p, o), n.ref = l.ref, n.return = l, l.child = n;
  }
  function py(n, l, u, o, d) {
    if (n !== null) {
      var p = n.memoizedProps;
      if (Ml(p, o) && n.ref === l.ref)
        if (Tn = !1, l.pendingProps = o = p, Hh(n, d))
          (n.flags & 131072) !== 0 && (Tn = !0);
        else
          return l.lanes = n.lanes, pl(n, l, d);
    }
    return Nh(
      n,
      l,
      u,
      o,
      d
    );
  }
  function P0(n, l, u, o) {
    var d = o.children, p = n !== null ? n.memoizedState : null;
    if (n === null && l.stateNode === null && (l.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), o.mode === "hidden") {
      if ((l.flags & 128) !== 0) {
        if (p = p !== null ? p.baseLanes | u : u, n !== null) {
          for (o = l.child = n.child, d = 0; o !== null; )
            d = d | o.lanes | o.childLanes, o = o.sibling;
          o = d & ~p;
        } else o = 0, l.child = null;
        return za(
          n,
          l,
          p,
          u,
          o
        );
      }
      if ((u & 536870912) !== 0)
        l.memoizedState = { baseLanes: 0, cachePool: null }, n !== null && Dr(
          l,
          p !== null ? p.cachePool : null
        ), p !== null ? Y0(l, p) : yf(), dh(l);
      else
        return o = l.lanes = 536870912, za(
          n,
          l,
          p !== null ? p.baseLanes | u : u,
          u,
          o
        );
    } else
      p !== null ? (Dr(l, p.cachePool), Y0(l, p), su(), l.memoizedState = null) : (n !== null && Dr(l, null), yf(), su());
    return It(n, l, d, u), l.child;
  }
  function Oo(n, l) {
    return n !== null && n.tag === 22 || l.stateNode !== null || (l.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), l.sibling;
  }
  function za(n, l, u, o, d) {
    var p = sl();
    return p = p === null ? null : { parent: Sn._currentValue, pool: p }, l.memoizedState = {
      baseLanes: u,
      cachePool: p
    }, n !== null && Dr(l, null), yf(), dh(l), n !== null && Qn(n, l, o, !0), l.childLanes = d, null;
  }
  function _f(n, l) {
    return l = Mf(
      { mode: l.mode, children: l.children },
      n.mode
    ), l.ref = n.ref, n.child = l, l.return = n, l;
  }
  function _a(n, l, u) {
    return go(l, n.child, null, u), n = _f(l, l.pendingProps), n.flags |= 2, Ca(l), l.memoizedState = null, n;
  }
  function ev(n, l, u) {
    var o = l.pendingProps, d = (l.flags & 128) !== 0;
    if (l.flags &= -129, n === null) {
      if (ht) {
        if (o.mode === "hidden")
          return n = _f(l, o), l.lanes = 536870912, Oo(null, n);
        if (_r(l), (n = Jt) ? (n = Hv(
          n,
          Nn
        ), n = n !== null && n.data === "&" ? n : null, n !== null && (l.memoizedState = {
          dehydrated: n,
          treeContext: iu !== null ? { id: Ga, overflow: ou } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, u = xp(n), u.return = l, l.child = u, Xn = l, Jt = null)) : n = null, n === null) throw Bl(l);
        return l.lanes = 536870912, null;
      }
      return _f(l, o);
    }
    var p = n.memoizedState;
    if (p !== null) {
      var T = p.dehydrated;
      if (_r(l), d)
        if (l.flags & 256)
          l.flags &= -257, l = _a(
            n,
            l,
            u
          );
        else if (l.memoizedState !== null)
          l.child = n.child, l.flags |= 128, l = null;
        else throw Error(h(558));
      else if (Tn || Qn(n, l, u, !1), d = (u & n.childLanes) !== 0, Tn || d) {
        if (o = Yt, o !== null && (T = nl(o, u), T !== 0 && T !== p.retryLane))
          throw p.retryLane = T, Ri(n, T), Na(o, n, T), Mh;
        Fh(), l = _a(
          n,
          l,
          u
        );
      } else
        n = p.treeContext, Jt = xa(T.nextSibling), Xn = l, ht = !0, Lu = null, Nn = !1, n !== null && lf(l, n), l = _f(l, o), l.flags |= 4096;
      return l;
    }
    return n = Ci(n.child, {
      mode: o.mode,
      children: o.children
    }), n.ref = l.ref, l.child = n, n.return = l, n;
  }
  function hl(n, l) {
    var u = l.ref;
    if (u === null)
      n !== null && n.ref !== null && (l.flags |= 4194816);
    else {
      if (typeof u != "function" && typeof u != "object")
        throw Error(h(284));
      (n === null || n.ref !== u) && (l.flags |= 4194816);
    }
  }
  function Nh(n, l, u, o, d) {
    return Je(l), u = vf(
      n,
      l,
      u,
      o,
      void 0,
      d
    ), o = mh(), n !== null && !Tn ? (bc(n, l, d), pl(n, l, d)) : (ht && o && Tr(l), l.flags |= 1, It(n, l, u, d), l.child);
  }
  function Do(n, l, u, o, d, p) {
    return Je(l), l.updateQueue = null, u = X0(
      l,
      o,
      u,
      d
    ), hh(n), o = mh(), n !== null && !Tn ? (bc(n, l, p), pl(n, l, p)) : (ht && o && Tr(l), l.flags |= 1, It(n, l, u, p), l.child);
  }
  function yy(n, l, u, o, d) {
    if (Je(l), l.stateNode === null) {
      var p = Aa, T = u.contextType;
      typeof T == "object" && T !== null && (p = se(T)), p = new u(o, p), l.memoizedState = p.state !== null && p.state !== void 0 ? p.state : null, p.updater = jl, l.stateNode = p, p._reactInternals = l, p = l.stateNode, p.props = o, p.state = l.memoizedState, p.refs = {}, pf(l), T = u.contextType, p.context = typeof T == "object" && T !== null ? se(T) : Aa, p.state = l.memoizedState, T = u.getDerivedStateFromProps, typeof T == "function" && (Ac(
        l,
        u,
        T,
        o
      ), p.state = l.memoizedState), typeof u.getDerivedStateFromProps == "function" || typeof p.getSnapshotBeforeUpdate == "function" || typeof p.UNSAFE_componentWillMount != "function" && typeof p.componentWillMount != "function" || (T = p.state, typeof p.componentWillMount == "function" && p.componentWillMount(), typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount(), T !== p.state && jl.enqueueReplaceState(p, p.state, null), Vu(l, o, p, d), bo(), p.state = l.memoizedState), typeof p.componentDidMount == "function" && (l.flags |= 4194308), o = !0;
    } else if (n === null) {
      p = l.stateNode;
      var C = l.memoizedProps, x = Ao(u, C);
      p.props = x;
      var K = p.context, le = u.contextType;
      T = Aa, typeof le == "object" && le !== null && (T = se(le));
      var re = u.getDerivedStateFromProps;
      le = typeof re == "function" || typeof p.getSnapshotBeforeUpdate == "function", C = l.pendingProps !== C, le || typeof p.UNSAFE_componentWillReceiveProps != "function" && typeof p.componentWillReceiveProps != "function" || (C || K !== T) && I0(
        l,
        p,
        o,
        T
      ), Mi = !1;
      var k = l.memoizedState;
      p.state = k, Vu(l, o, p, d), bo(), K = l.memoizedState, C || k !== K || Mi ? (typeof re == "function" && (Ac(
        l,
        u,
        re,
        o
      ), K = l.memoizedState), (x = Mi || cy(
        l,
        u,
        x,
        o,
        k,
        K,
        T
      )) ? (le || typeof p.UNSAFE_componentWillMount != "function" && typeof p.componentWillMount != "function" || (typeof p.componentWillMount == "function" && p.componentWillMount(), typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount()), typeof p.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof p.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = o, l.memoizedState = K), p.props = o, p.state = K, p.context = T, o = x) : (typeof p.componentDidMount == "function" && (l.flags |= 4194308), o = !1);
    } else {
      p = l.stateNode, rh(n, l), T = l.memoizedProps, le = Ao(u, T), p.props = le, re = l.pendingProps, k = p.context, K = u.contextType, x = Aa, typeof K == "object" && K !== null && (x = se(K)), C = u.getDerivedStateFromProps, (K = typeof C == "function" || typeof p.getSnapshotBeforeUpdate == "function") || typeof p.UNSAFE_componentWillReceiveProps != "function" && typeof p.componentWillReceiveProps != "function" || (T !== re || k !== x) && I0(
        l,
        p,
        o,
        x
      ), Mi = !1, k = l.memoizedState, p.state = k, Vu(l, o, p, d), bo();
      var P = l.memoizedState;
      T !== re || k !== P || Mi || n !== null && n.dependencies !== null && sc(n.dependencies) ? (typeof C == "function" && (Ac(
        l,
        u,
        C,
        o
      ), P = l.memoizedState), (le = Mi || cy(
        l,
        u,
        le,
        o,
        k,
        P,
        x
      ) || n !== null && n.dependencies !== null && sc(n.dependencies)) ? (K || typeof p.UNSAFE_componentWillUpdate != "function" && typeof p.componentWillUpdate != "function" || (typeof p.componentWillUpdate == "function" && p.componentWillUpdate(o, P, x), typeof p.UNSAFE_componentWillUpdate == "function" && p.UNSAFE_componentWillUpdate(
        o,
        P,
        x
      )), typeof p.componentDidUpdate == "function" && (l.flags |= 4), typeof p.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof p.componentDidUpdate != "function" || T === n.memoizedProps && k === n.memoizedState || (l.flags |= 4), typeof p.getSnapshotBeforeUpdate != "function" || T === n.memoizedProps && k === n.memoizedState || (l.flags |= 1024), l.memoizedProps = o, l.memoizedState = P), p.props = o, p.state = P, p.context = x, o = le) : (typeof p.componentDidUpdate != "function" || T === n.memoizedProps && k === n.memoizedState || (l.flags |= 4), typeof p.getSnapshotBeforeUpdate != "function" || T === n.memoizedProps && k === n.memoizedState || (l.flags |= 1024), o = !1);
    }
    return p = o, hl(n, l), o = (l.flags & 128) !== 0, p || o ? (p = l.stateNode, u = o && typeof u.getDerivedStateFromError != "function" ? null : p.render(), l.flags |= 1, n !== null && o ? (l.child = go(
      l,
      n.child,
      null,
      d
    ), l.child = go(
      l,
      null,
      u,
      d
    )) : It(n, l, u, d), l.memoizedState = p.state, n = l.child) : n = pl(
      n,
      l,
      d
    ), n;
  }
  function du(n, l, u, o) {
    return so(), l.flags |= 256, It(n, l, u, o), l.child;
  }
  var Uf = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function wf(n) {
    return { baseLanes: n, cachePool: dc() };
  }
  function ml(n, l, u) {
    return n = n !== null ? n.childLanes & ~u : 0, l && (n |= Ma), n;
  }
  function gy(n, l, u) {
    var o = l.pendingProps, d = !1, p = (l.flags & 128) !== 0, T;
    if ((T = p) || (T = n !== null && n.memoizedState === null ? !1 : (nn.current & 2) !== 0), T && (d = !0, l.flags &= -129), T = (l.flags & 32) !== 0, l.flags &= -33, n === null) {
      if (ht) {
        if (d ? Yu(l) : su(), (n = Jt) ? (n = Hv(
          n,
          Nn
        ), n = n !== null && n.data !== "&" ? n : null, n !== null && (l.memoizedState = {
          dehydrated: n,
          treeContext: iu !== null ? { id: Ga, overflow: ou } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, u = xp(n), u.return = l, l.child = u, Xn = l, Jt = null)) : n = null, n === null) throw Bl(l);
        return Mo(n) ? l.lanes = 32 : l.lanes = 536870912, null;
      }
      var C = o.children;
      return o = o.fallback, d ? (su(), d = l.mode, C = Mf(
        { mode: "hidden", children: C },
        d
      ), o = zi(
        o,
        d,
        u,
        null
      ), C.return = l, o.return = l, C.sibling = o, l.child = C, o = l.child, o.memoizedState = wf(u), o.childLanes = ml(
        n,
        T,
        u
      ), l.memoizedState = Uf, Oo(null, o)) : (Yu(l), Ro(l, C));
    }
    var x = n.memoizedState;
    if (x !== null && (C = x.dehydrated, C !== null)) {
      if (p)
        l.flags & 256 ? (Yu(l), l.flags &= -257, l = Oc(
          n,
          l,
          u
        )) : l.memoizedState !== null ? (su(), l.child = n.child, l.flags |= 128, l = null) : (su(), C = o.fallback, d = l.mode, o = Mf(
          { mode: "visible", children: o.children },
          d
        ), C = zi(
          C,
          d,
          u,
          null
        ), C.flags |= 2, o.return = l, C.return = l, o.sibling = C, l.child = o, go(
          l,
          n.child,
          null,
          u
        ), o = l.child, o.memoizedState = wf(u), o.childLanes = ml(
          n,
          T,
          u
        ), l.memoizedState = Uf, l = Oo(null, o));
      else if (Yu(l), Mo(C)) {
        if (T = C.nextSibling && C.nextSibling.dataset, T) var K = T.dgst;
        T = K, o = Error(h(419)), o.stack = "", o.digest = T, Or({ value: o, source: null, stack: null }), l = Oc(
          n,
          l,
          u
        );
      } else if (Tn || Qn(n, l, u, !1), T = (u & n.childLanes) !== 0, Tn || T) {
        if (T = Yt, T !== null && (o = nl(T, u), o !== 0 && o !== x.retryLane))
          throw x.retryLane = o, Ri(n, o), Na(T, n, o), Mh;
        Yl(C) || Fh(), l = Oc(
          n,
          l,
          u
        );
      } else
        Yl(C) ? (l.flags |= 192, l.child = n.child, l = null) : (n = x.treeContext, Jt = xa(
          C.nextSibling
        ), Xn = l, ht = !0, Lu = null, Nn = !1, n !== null && lf(l, n), l = Ro(
          l,
          o.children
        ), l.flags |= 4096);
      return l;
    }
    return d ? (su(), C = o.fallback, d = l.mode, x = n.child, K = x.sibling, o = Ci(x, {
      mode: "hidden",
      children: o.children
    }), o.subtreeFlags = x.subtreeFlags & 65011712, K !== null ? C = Ci(
      K,
      C
    ) : (C = zi(
      C,
      d,
      u,
      null
    ), C.flags |= 2), C.return = l, o.return = l, o.sibling = C, l.child = o, Oo(null, o), o = l.child, C = n.child.memoizedState, C === null ? C = wf(u) : (d = C.cachePool, d !== null ? (x = Sn._currentValue, d = d.parent !== x ? { parent: x, pool: x } : d) : d = dc(), C = {
      baseLanes: C.baseLanes | u,
      cachePool: d
    }), o.memoizedState = C, o.childLanes = ml(
      n,
      T,
      u
    ), l.memoizedState = Uf, Oo(n.child, o)) : (Yu(l), u = n.child, n = u.sibling, u = Ci(u, {
      mode: "visible",
      children: o.children
    }), u.return = l, u.sibling = null, n !== null && (T = l.deletions, T === null ? (l.deletions = [n], l.flags |= 16) : T.push(n)), l.child = u, l.memoizedState = null, u);
  }
  function Ro(n, l) {
    return l = Mf(
      { mode: "visible", children: l },
      n.mode
    ), l.return = n, n.child = l;
  }
  function Mf(n, l) {
    return n = hn(22, n, null, l), n.lanes = 0, n;
  }
  function Oc(n, l, u) {
    return go(l, n.child, null, u), n = Ro(
      l,
      l.pendingProps.children
    ), n.flags |= 2, l.memoizedState = null, n;
  }
  function Dc(n, l, u) {
    n.lanes |= l;
    var o = n.alternate;
    o !== null && (o.lanes |= l), oh(n.return, l, u);
  }
  function xh(n, l, u, o, d, p) {
    var T = n.memoizedState;
    T === null ? n.memoizedState = {
      isBackwards: l,
      rendering: null,
      renderingStartTime: 0,
      last: o,
      tail: u,
      tailMode: d,
      treeForkCount: p
    } : (T.isBackwards = l, T.rendering = null, T.renderingStartTime = 0, T.last = o, T.tail = u, T.tailMode = d, T.treeForkCount = p);
  }
  function vy(n, l, u) {
    var o = l.pendingProps, d = o.revealOrder, p = o.tail;
    o = o.children;
    var T = nn.current, C = (T & 2) !== 0;
    if (C ? (T = T & 1 | 2, l.flags |= 128) : T &= 1, De(nn, T), It(n, l, o, u), o = ht ? bn : 0, !C && n !== null && (n.flags & 128) !== 0)
      e: for (n = l.child; n !== null; ) {
        if (n.tag === 13)
          n.memoizedState !== null && Dc(n, u, l);
        else if (n.tag === 19)
          Dc(n, u, l);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === l) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === l)
            break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
    switch (d) {
      case "forwards":
        for (u = l.child, d = null; u !== null; )
          n = u.alternate, n !== null && Ur(n) === null && (d = u), u = u.sibling;
        u = d, u === null ? (d = l.child, l.child = null) : (d = u.sibling, u.sibling = null), xh(
          l,
          !1,
          d,
          u,
          p,
          o
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (u = null, d = l.child, l.child = null; d !== null; ) {
          if (n = d.alternate, n !== null && Ur(n) === null) {
            l.child = d;
            break;
          }
          n = d.sibling, d.sibling = u, u = d, d = n;
        }
        xh(
          l,
          !0,
          u,
          null,
          p,
          o
        );
        break;
      case "together":
        xh(
          l,
          !1,
          null,
          null,
          void 0,
          o
        );
        break;
      default:
        l.memoizedState = null;
    }
    return l.child;
  }
  function pl(n, l, u) {
    if (n !== null && (l.dependencies = n.dependencies), yu |= l.lanes, (u & l.childLanes) === 0)
      if (n !== null) {
        if (Qn(
          n,
          l,
          u,
          !1
        ), (u & l.childLanes) === 0)
          return null;
      } else return null;
    if (n !== null && l.child !== n.child)
      throw Error(h(153));
    if (l.child !== null) {
      for (n = l.child, u = Ci(n, n.pendingProps), l.child = u, u.return = l; n.sibling !== null; )
        n = n.sibling, u = u.sibling = Ci(n, n.pendingProps), u.return = l;
      u.sibling = null;
    }
    return l.child;
  }
  function Hh(n, l) {
    return (n.lanes & l) !== 0 ? !0 : (n = n.dependencies, !!(n !== null && sc(n)));
  }
  function Lh(n, l, u) {
    switch (l.tag) {
      case 3:
        en(l, l.stateNode.containerInfo), Da(l, Sn, n.memoizedState.cache), so();
        break;
      case 27:
      case 5:
        zl(l);
        break;
      case 4:
        en(l, l.stateNode.containerInfo);
        break;
      case 10:
        Da(
          l,
          l.type,
          l.memoizedProps.value
        );
        break;
      case 31:
        if (l.memoizedState !== null)
          return l.flags |= 128, _r(l), null;
        break;
      case 13:
        var o = l.memoizedState;
        if (o !== null)
          return o.dehydrated !== null ? (Yu(l), l.flags |= 128, null) : (u & l.child.childLanes) !== 0 ? gy(n, l, u) : (Yu(l), n = pl(
            n,
            l,
            u
          ), n !== null ? n.sibling : null);
        Yu(l);
        break;
      case 19:
        var d = (n.flags & 128) !== 0;
        if (o = (u & l.childLanes) !== 0, o || (Qn(
          n,
          l,
          u,
          !1
        ), o = (u & l.childLanes) !== 0), d) {
          if (o)
            return vy(
              n,
              l,
              u
            );
          l.flags |= 128;
        }
        if (d = l.memoizedState, d !== null && (d.rendering = null, d.tail = null, d.lastEffect = null), De(nn, nn.current), o) break;
        return null;
      case 22:
        return l.lanes = 0, P0(
          n,
          l,
          u,
          l.pendingProps
        );
      case 24:
        Da(l, Sn, n.memoizedState.cache);
    }
    return pl(n, l, u);
  }
  function by(n, l, u) {
    if (n !== null)
      if (n.memoizedProps !== l.pendingProps)
        Tn = !0;
      else {
        if (!Hh(n, u) && (l.flags & 128) === 0)
          return Tn = !1, Lh(
            n,
            l,
            u
          );
        Tn = (n.flags & 131072) !== 0;
      }
    else
      Tn = !1, ht && (l.flags & 1048576) !== 0 && Lp(l, bn, l.index);
    switch (l.lanes = 0, l.tag) {
      case 16:
        e: {
          var o = l.pendingProps;
          if (n = mo(l.elementType), l.type = n, typeof n == "function")
            cc(n) ? (o = Ao(n, o), l.tag = 1, l = yy(
              null,
              l,
              n,
              o,
              u
            )) : (l.tag = 0, l = Nh(
              null,
              l,
              n,
              o,
              u
            ));
          else {
            if (n != null) {
              var d = n.$$typeof;
              if (d === pe) {
                l.tag = 11, l = hy(
                  null,
                  l,
                  n,
                  o,
                  u
                );
                break e;
              } else if (d === ge) {
                l.tag = 14, l = my(
                  null,
                  l,
                  n,
                  o,
                  u
                );
                break e;
              }
            }
            throw l = We(n) || n, Error(h(306, l, ""));
          }
        }
        return l;
      case 0:
        return Nh(
          n,
          l,
          l.type,
          l.pendingProps,
          u
        );
      case 1:
        return o = l.type, d = Ao(
          o,
          l.pendingProps
        ), yy(
          n,
          l,
          o,
          d,
          u
        );
      case 3:
        e: {
          if (en(
            l,
            l.stateNode.containerInfo
          ), n === null) throw Error(h(387));
          o = l.pendingProps;
          var p = l.memoizedState;
          d = p.element, rh(n, l), Vu(l, o, null, u);
          var T = l.memoizedState;
          if (o = T.cache, Da(l, Sn, o), o !== p.cache && qu(
            l,
            [Sn],
            u,
            !0
          ), bo(), o = T.element, p.isDehydrated)
            if (p = {
              element: o,
              isDehydrated: !1,
              cache: T.cache
            }, l.updateQueue.baseState = p, l.memoizedState = p, l.flags & 256) {
              l = du(
                n,
                l,
                o,
                u
              );
              break e;
            } else if (o !== d) {
              d = ol(
                Error(h(424)),
                l
              ), Or(d), l = du(
                n,
                l,
                o,
                u
              );
              break e;
            } else {
              switch (n = l.stateNode.containerInfo, n.nodeType) {
                case 9:
                  n = n.body;
                  break;
                default:
                  n = n.nodeName === "HTML" ? n.ownerDocument.body : n;
              }
              for (Jt = xa(n.firstChild), Xn = l, ht = !0, Lu = null, Nn = !0, u = Xp(
                l,
                null,
                o,
                u
              ), l.child = u; u; )
                u.flags = u.flags & -3 | 4096, u = u.sibling;
            }
          else {
            if (so(), o === d) {
              l = pl(
                n,
                l,
                u
              );
              break e;
            }
            It(n, l, o, u);
          }
          l = l.child;
        }
        return l;
      case 26:
        return hl(n, l), n === null ? (u = us(
          l.type,
          null,
          l.pendingProps,
          null
        )) ? l.memoizedState = u : ht || (u = l.type, n = l.pendingProps, o = wo(
          Rn.current
        ).createElement(u), o[qt] = l, o[Sa] = n, la(o, u, n), Mt(o), l.stateNode = o) : l.memoizedState = us(
          l.type,
          n.memoizedProps,
          l.pendingProps,
          n.memoizedState
        ), null;
      case 27:
        return zl(l), n === null && ht && (o = l.stateNode = as(
          l.type,
          l.pendingProps,
          Rn.current
        ), Xn = l, Nn = !0, d = Jt, vu(l.type) ? (Wf = d, Jt = xa(o.firstChild)) : Jt = d), It(
          n,
          l,
          l.pendingProps.children,
          u
        ), hl(n, l), n === null && (l.flags |= 4194304), l.child;
      case 5:
        return n === null && ht && ((d = o = Jt) && (o = Lb(
          o,
          l.type,
          l.pendingProps,
          Nn
        ), o !== null ? (l.stateNode = o, Xn = l, Jt = xa(o.firstChild), Nn = !1, d = !0) : d = !1), d || Bl(l)), zl(l), d = l.type, p = l.pendingProps, T = n !== null ? n.memoizedProps : null, o = p.children, ts(d, p) ? o = null : T !== null && ts(d, T) && (l.flags |= 32), l.memoizedState !== null && (d = vf(
          n,
          l,
          Mb,
          null,
          null,
          u
        ), ed._currentValue = d), hl(n, l), It(n, l, o, u), l.child;
      case 6:
        return n === null && ht && ((n = u = Jt) && (u = ut(
          u,
          l.pendingProps,
          Nn
        ), u !== null ? (l.stateNode = u, Xn = l, Jt = null, n = !0) : n = !1), n || Bl(l)), null;
      case 13:
        return gy(n, l, u);
      case 4:
        return en(
          l,
          l.stateNode.containerInfo
        ), o = l.pendingProps, n === null ? l.child = go(
          l,
          null,
          o,
          u
        ) : It(n, l, o, u), l.child;
      case 11:
        return hy(
          n,
          l,
          l.type,
          l.pendingProps,
          u
        );
      case 7:
        return It(
          n,
          l,
          l.pendingProps,
          u
        ), l.child;
      case 8:
        return It(
          n,
          l,
          l.pendingProps.children,
          u
        ), l.child;
      case 12:
        return It(
          n,
          l,
          l.pendingProps.children,
          u
        ), l.child;
      case 10:
        return o = l.pendingProps, Da(l, l.type, o.value), It(n, l, o.children, u), l.child;
      case 9:
        return d = l.type._context, o = l.pendingProps.children, Je(l), d = se(d), o = o(d), l.flags |= 1, It(n, l, o, u), l.child;
      case 14:
        return my(
          n,
          l,
          l.type,
          l.pendingProps,
          u
        );
      case 15:
        return py(
          n,
          l,
          l.type,
          l.pendingProps,
          u
        );
      case 19:
        return vy(n, l, u);
      case 31:
        return ev(n, l, u);
      case 22:
        return P0(
          n,
          l,
          u,
          l.pendingProps
        );
      case 24:
        return Je(l), o = se(Sn), n === null ? (d = sl(), d === null && (d = Yt, p = cf(), d.pooledCache = p, p.refCount++, p !== null && (d.pooledCacheLanes |= u), d = p), l.memoizedState = { parent: o, cache: d }, pf(l), Da(l, Sn, d)) : ((n.lanes & u) !== 0 && (rh(n, l), Vu(l, null, null, u), bo()), d = n.memoizedState, p = l.memoizedState, d.parent !== o ? (d = { parent: o, cache: o }, l.memoizedState = d, l.lanes === 0 && (l.memoizedState = l.updateQueue.baseState = d), Da(l, Sn, o)) : (o = p.cache, Da(l, Sn, o), o !== d.cache && qu(
          l,
          [Sn],
          u,
          !0
        ))), It(
          n,
          l,
          l.pendingProps.children,
          u
        ), l.child;
      case 29:
        throw l.pendingProps;
    }
    throw Error(h(156, l.tag));
  }
  function Ku(n) {
    n.flags |= 4;
  }
  function Sy(n, l, u, o, d) {
    if ((l = (n.mode & 32) !== 0) && (l = !1), l) {
      if (n.flags |= 16777216, (d & 335544128) === d)
        if (n.stateNode.complete) n.flags |= 8192;
        else if (sv()) n.flags |= 8192;
        else
          throw po = mc, hc;
    } else n.flags &= -16777217;
  }
  function Ey(n, l) {
    if (l.type !== "stylesheet" || (l.state.loading & 4) !== 0)
      n.flags &= -16777217;
    else if (n.flags |= 16777216, !ka(l))
      if (sv()) n.flags |= 8192;
      else
        throw po = mc, hc;
  }
  function fa(n, l) {
    l !== null && (n.flags |= 4), n.flags & 16384 && (l = n.tag !== 22 ? Zo() : 536870912, n.lanes |= l, sn |= l);
  }
  function jr(n, l) {
    if (!ht)
      switch (n.tailMode) {
        case "hidden":
          l = n.tail;
          for (var u = null; l !== null; )
            l.alternate !== null && (u = l), l = l.sibling;
          u === null ? n.tail = null : u.sibling = null;
          break;
        case "collapsed":
          u = n.tail;
          for (var o = null; u !== null; )
            u.alternate !== null && (o = u), u = u.sibling;
          o === null ? l || n.tail === null ? n.tail = null : n.tail.sibling = null : o.sibling = null;
      }
  }
  function Ze(n) {
    var l = n.alternate !== null && n.alternate.child === n.child, u = 0, o = 0;
    if (l)
      for (var d = n.child; d !== null; )
        u |= d.lanes | d.childLanes, o |= d.subtreeFlags & 65011712, o |= d.flags & 65011712, d.return = n, d = d.sibling;
    else
      for (d = n.child; d !== null; )
        u |= d.lanes | d.childLanes, o |= d.subtreeFlags, o |= d.flags, d.return = n, d = d.sibling;
    return n.subtreeFlags |= o, n.childLanes = u, l;
  }
  function tv(n, l, u) {
    var o = l.pendingProps;
    switch (uh(l), l.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ze(l), null;
      case 1:
        return Ze(l), null;
      case 3:
        return u = l.stateNode, o = null, n !== null && (o = n.memoizedState.cache), l.memoizedState.cache !== o && (l.flags |= 2048), ru(Sn), Mn(), u.pendingContext && (u.context = u.pendingContext, u.pendingContext = null), (n === null || n.child === null) && (ju(l) ? Ku(l) : n === null || n.memoizedState.isDehydrated && (l.flags & 256) === 0 || (l.flags |= 1024, Bp())), Ze(l), null;
      case 26:
        var d = l.type, p = l.memoizedState;
        return n === null ? (Ku(l), p !== null ? (Ze(l), Ey(l, p)) : (Ze(l), Sy(
          l,
          d,
          null,
          o,
          u
        ))) : p ? p !== n.memoizedState ? (Ku(l), Ze(l), Ey(l, p)) : (Ze(l), l.flags &= -16777217) : (n = n.memoizedProps, n !== o && Ku(l), Ze(l), Sy(
          l,
          d,
          n,
          o,
          u
        )), null;
      case 27:
        if (Ae(l), u = Rn.current, d = l.type, n !== null && l.stateNode != null)
          n.memoizedProps !== o && Ku(l);
        else {
          if (!o) {
            if (l.stateNode === null)
              throw Error(h(166));
            return Ze(l), null;
          }
          n = ze.current, ju(l) ? uf(l) : (n = as(d, o, u), l.stateNode = n, Ku(l));
        }
        return Ze(l), null;
      case 5:
        if (Ae(l), d = l.type, n !== null && l.stateNode != null)
          n.memoizedProps !== o && Ku(l);
        else {
          if (!o) {
            if (l.stateNode === null)
              throw Error(h(166));
            return Ze(l), null;
          }
          if (p = ze.current, ju(l))
            uf(l);
          else {
            var T = wo(
              Rn.current
            );
            switch (p) {
              case 1:
                p = T.createElementNS(
                  "http://www.w3.org/2000/svg",
                  d
                );
                break;
              case 2:
                p = T.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  d
                );
                break;
              default:
                switch (d) {
                  case "svg":
                    p = T.createElementNS(
                      "http://www.w3.org/2000/svg",
                      d
                    );
                    break;
                  case "math":
                    p = T.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      d
                    );
                    break;
                  case "script":
                    p = T.createElement("div"), p.innerHTML = "<script><\/script>", p = p.removeChild(
                      p.firstChild
                    );
                    break;
                  case "select":
                    p = typeof o.is == "string" ? T.createElement("select", {
                      is: o.is
                    }) : T.createElement("select"), o.multiple ? p.multiple = !0 : o.size && (p.size = o.size);
                    break;
                  default:
                    p = typeof o.is == "string" ? T.createElement(d, { is: o.is }) : T.createElement(d);
                }
            }
            p[qt] = l, p[Sa] = o;
            e: for (T = l.child; T !== null; ) {
              if (T.tag === 5 || T.tag === 6)
                p.appendChild(T.stateNode);
              else if (T.tag !== 4 && T.tag !== 27 && T.child !== null) {
                T.child.return = T, T = T.child;
                continue;
              }
              if (T === l) break e;
              for (; T.sibling === null; ) {
                if (T.return === null || T.return === l)
                  break e;
                T = T.return;
              }
              T.sibling.return = T.return, T = T.sibling;
            }
            l.stateNode = p;
            e: switch (la(p, d, o), d) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                o = !!o.autoFocus;
                break e;
              case "img":
                o = !0;
                break e;
              default:
                o = !1;
            }
            o && Ku(l);
          }
        }
        return Ze(l), Sy(
          l,
          l.type,
          n === null ? null : n.memoizedProps,
          l.pendingProps,
          u
        ), null;
      case 6:
        if (n && l.stateNode != null)
          n.memoizedProps !== o && Ku(l);
        else {
          if (typeof o != "string" && l.stateNode === null)
            throw Error(h(166));
          if (n = Rn.current, ju(l)) {
            if (n = l.stateNode, u = l.memoizedProps, o = null, d = Xn, d !== null)
              switch (d.tag) {
                case 27:
                case 5:
                  o = d.memoizedProps;
              }
            n[qt] = l, n = !!(n.nodeValue === u || o !== null && o.suppressHydrationWarning === !0 || Zy(n.nodeValue, u)), n || Bl(l, !0);
          } else
            n = wo(n).createTextNode(
              o
            ), n[qt] = l, l.stateNode = n;
        }
        return Ze(l), null;
      case 31:
        if (u = l.memoizedState, n === null || n.memoizedState !== null) {
          if (o = ju(l), u !== null) {
            if (n === null) {
              if (!o) throw Error(h(318));
              if (n = l.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(h(557));
              n[qt] = l;
            } else
              so(), (l.flags & 128) === 0 && (l.memoizedState = null), l.flags |= 4;
            Ze(l), n = !1;
          } else
            u = Bp(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = u), n = !0;
          if (!n)
            return l.flags & 256 ? (Ca(l), l) : (Ca(l), null);
          if ((l.flags & 128) !== 0)
            throw Error(h(558));
        }
        return Ze(l), null;
      case 13:
        if (o = l.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (d = ju(l), o !== null && o.dehydrated !== null) {
            if (n === null) {
              if (!d) throw Error(h(318));
              if (d = l.memoizedState, d = d !== null ? d.dehydrated : null, !d) throw Error(h(317));
              d[qt] = l;
            } else
              so(), (l.flags & 128) === 0 && (l.memoizedState = null), l.flags |= 4;
            Ze(l), d = !1;
          } else
            d = Bp(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = d), d = !0;
          if (!d)
            return l.flags & 256 ? (Ca(l), l) : (Ca(l), null);
        }
        return Ca(l), (l.flags & 128) !== 0 ? (l.lanes = u, l) : (u = o !== null, n = n !== null && n.memoizedState !== null, u && (o = l.child, d = null, o.alternate !== null && o.alternate.memoizedState !== null && o.alternate.memoizedState.cachePool !== null && (d = o.alternate.memoizedState.cachePool.pool), p = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (p = o.memoizedState.cachePool.pool), p !== d && (o.flags |= 2048)), u !== n && u && (l.child.flags |= 8192), fa(l, l.updateQueue), Ze(l), null);
      case 4:
        return Mn(), n === null && es(l.stateNode.containerInfo), Ze(l), null;
      case 10:
        return ru(l.type), Ze(l), null;
      case 19:
        if (ve(nn), o = l.memoizedState, o === null) return Ze(l), null;
        if (d = (l.flags & 128) !== 0, p = o.rendering, p === null)
          if (d) jr(o, !1);
          else {
            if (kt !== 0 || n !== null && (n.flags & 128) !== 0)
              for (n = l.child; n !== null; ) {
                if (p = Ur(n), p !== null) {
                  for (l.flags |= 128, jr(o, !1), n = p.updateQueue, l.updateQueue = n, fa(l, n), l.subtreeFlags = 0, n = u, u = l.child; u !== null; )
                    Np(u, n), u = u.sibling;
                  return De(
                    nn,
                    nn.current & 1 | 2
                  ), ht && Ll(l, o.treeForkCount), l.child;
                }
                n = n.sibling;
              }
            o.tail !== null && _e() > zt && (l.flags |= 128, d = !0, jr(o, !1), l.lanes = 4194304);
          }
        else {
          if (!d)
            if (n = Ur(p), n !== null) {
              if (l.flags |= 128, d = !0, n = n.updateQueue, l.updateQueue = n, fa(l, n), jr(o, !0), o.tail === null && o.tailMode === "hidden" && !p.alternate && !ht)
                return Ze(l), null;
            } else
              2 * _e() - o.renderingStartTime > zt && u !== 536870912 && (l.flags |= 128, d = !0, jr(o, !1), l.lanes = 4194304);
          o.isBackwards ? (p.sibling = l.child, l.child = p) : (n = o.last, n !== null ? n.sibling = p : l.child = p, o.last = p);
        }
        return o.tail !== null ? (n = o.tail, o.rendering = n, o.tail = n.sibling, o.renderingStartTime = _e(), n.sibling = null, u = nn.current, De(
          nn,
          d ? u & 1 | 2 : u & 1
        ), ht && Ll(l, o.treeForkCount), n) : (Ze(l), null);
      case 22:
      case 23:
        return Ca(l), zr(), o = l.memoizedState !== null, n !== null ? n.memoizedState !== null !== o && (l.flags |= 8192) : o && (l.flags |= 8192), o ? (u & 536870912) !== 0 && (l.flags & 128) === 0 && (Ze(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : Ze(l), u = l.updateQueue, u !== null && fa(l, u.retryQueue), u = null, n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (u = n.memoizedState.cachePool.pool), o = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (o = l.memoizedState.cachePool.pool), o !== u && (l.flags |= 2048), n !== null && ve(rl), null;
      case 24:
        return u = null, n !== null && (u = n.memoizedState.cache), l.memoizedState.cache !== u && (l.flags |= 2048), ru(Sn), Ze(l), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(h(156, l.tag));
  }
  function nv(n, l) {
    switch (uh(l), l.tag) {
      case 1:
        return n = l.flags, n & 65536 ? (l.flags = n & -65537 | 128, l) : null;
      case 3:
        return ru(Sn), Mn(), n = l.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (l.flags = n & -65537 | 128, l) : null;
      case 26:
      case 27:
      case 5:
        return Ae(l), null;
      case 31:
        if (l.memoizedState !== null) {
          if (Ca(l), l.alternate === null)
            throw Error(h(340));
          so();
        }
        return n = l.flags, n & 65536 ? (l.flags = n & -65537 | 128, l) : null;
      case 13:
        if (Ca(l), n = l.memoizedState, n !== null && n.dehydrated !== null) {
          if (l.alternate === null)
            throw Error(h(340));
          so();
        }
        return n = l.flags, n & 65536 ? (l.flags = n & -65537 | 128, l) : null;
      case 19:
        return ve(nn), null;
      case 4:
        return Mn(), null;
      case 10:
        return ru(l.type), null;
      case 22:
      case 23:
        return Ca(l), zr(), n !== null && ve(rl), n = l.flags, n & 65536 ? (l.flags = n & -65537 | 128, l) : null;
      case 24:
        return ru(Sn), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function av(n, l) {
    switch (uh(l), l.tag) {
      case 3:
        ru(Sn), Mn();
        break;
      case 26:
      case 27:
      case 5:
        Ae(l);
        break;
      case 4:
        Mn();
        break;
      case 31:
        l.memoizedState !== null && Ca(l);
        break;
      case 13:
        Ca(l);
        break;
      case 19:
        ve(nn);
        break;
      case 10:
        ru(l.type);
        break;
      case 22:
      case 23:
        Ca(l), zr(), n !== null && ve(rl);
        break;
      case 24:
        ru(Sn);
    }
  }
  function ql(n, l) {
    try {
      var u = l.updateQueue, o = u !== null ? u.lastEffect : null;
      if (o !== null) {
        var d = o.next;
        u = d;
        do {
          if ((u.tag & n) === n) {
            o = void 0;
            var p = u.create, T = u.inst;
            o = p(), T.destroy = o;
          }
          u = u.next;
        } while (u !== d);
      }
    } catch (C) {
      Lt(l, l.return, C);
    }
  }
  function yl(n, l, u) {
    try {
      var o = l.updateQueue, d = o !== null ? o.lastEffect : null;
      if (d !== null) {
        var p = d.next;
        o = p;
        do {
          if ((o.tag & n) === n) {
            var T = o.inst, C = T.destroy;
            if (C !== void 0) {
              T.destroy = void 0, d = l;
              var x = u, K = C;
              try {
                K();
              } catch (le) {
                Lt(
                  d,
                  x,
                  le
                );
              }
            }
          }
          o = o.next;
        } while (o !== p);
      }
    } catch (le) {
      Lt(l, l.return, le);
    }
  }
  function Bh(n) {
    var l = n.updateQueue;
    if (l !== null) {
      var u = n.stateNode;
      try {
        So(l, u);
      } catch (o) {
        Lt(n, n.return, o);
      }
    }
  }
  function Co(n, l, u) {
    u.props = Ao(
      n.type,
      n.memoizedProps
    ), u.state = n.memoizedState;
    try {
      u.componentWillUnmount();
    } catch (o) {
      Lt(n, l, o);
    }
  }
  function ku(n, l) {
    try {
      var u = n.ref;
      if (u !== null) {
        switch (n.tag) {
          case 26:
          case 27:
          case 5:
            var o = n.stateNode;
            break;
          case 30:
            o = n.stateNode;
            break;
          default:
            o = n.stateNode;
        }
        typeof u == "function" ? n.refCleanup = u(o) : u.current = o;
      }
    } catch (d) {
      Lt(n, l, d);
    }
  }
  function hu(n, l) {
    var u = n.ref, o = n.refCleanup;
    if (u !== null)
      if (typeof o == "function")
        try {
          o();
        } catch (d) {
          Lt(n, l, d);
        } finally {
          n.refCleanup = null, n = n.alternate, n != null && (n.refCleanup = null);
        }
      else if (typeof u == "function")
        try {
          u(null);
        } catch (d) {
          Lt(n, l, d);
        }
      else u.current = null;
  }
  function Ty(n) {
    var l = n.type, u = n.memoizedProps, o = n.stateNode;
    try {
      e: switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && o.focus();
          break e;
        case "img":
          u.src ? o.src = u.src : u.srcSet && (o.srcset = u.srcSet);
      }
    } catch (d) {
      Lt(n, n.return, d);
    }
  }
  function jh(n, l, u) {
    try {
      var o = n.stateNode;
      Ky(o, n.type, u, l), o[Sa] = l;
    } catch (d) {
      Lt(n, n.return, d);
    }
  }
  function Ay(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 26 || n.tag === 27 && vu(n.type) || n.tag === 4;
  }
  function qr(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || Ay(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.tag === 27 && vu(n.type) || n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function Vr(n, l, u) {
    var o = n.tag;
    if (o === 5 || o === 6)
      n = n.stateNode, l ? (u.nodeType === 9 ? u.body : u.nodeName === "HTML" ? u.ownerDocument.body : u).insertBefore(n, l) : (l = u.nodeType === 9 ? u.body : u.nodeName === "HTML" ? u.ownerDocument.body : u, l.appendChild(n), u = u._reactRootContainer, u != null || l.onclick !== null || (l.onclick = Pl));
    else if (o !== 4 && (o === 27 && vu(n.type) && (u = n.stateNode, l = null), n = n.child, n !== null))
      for (Vr(n, l, u), n = n.sibling; n !== null; )
        Vr(n, l, u), n = n.sibling;
  }
  function Yr(n, l, u) {
    var o = n.tag;
    if (o === 5 || o === 6)
      n = n.stateNode, l ? u.insertBefore(n, l) : u.appendChild(n);
    else if (o !== 4 && (o === 27 && vu(n.type) && (u = n.stateNode), n = n.child, n !== null))
      for (Yr(n, l, u), n = n.sibling; n !== null; )
        Yr(n, l, u), n = n.sibling;
  }
  function Oy(n) {
    var l = n.stateNode, u = n.memoizedProps;
    try {
      for (var o = n.type, d = l.attributes; d.length; )
        l.removeAttributeNode(d[0]);
      la(l, o, u), l[qt] = n, l[Sa] = u;
    } catch (p) {
      Lt(n, n.return, p);
    }
  }
  var Bi = !1, zn = !1, qh = !1, Dy = typeof WeakSet == "function" ? WeakSet : Set, Kn = null;
  function Gr(n, l) {
    if (n = n.containerInfo, um = Ln, n = oo(n), Is(n)) {
      if ("selectionStart" in n)
        var u = {
          start: n.selectionStart,
          end: n.selectionEnd
        };
      else
        e: {
          u = (u = n.ownerDocument) && u.defaultView || window;
          var o = u.getSelection && u.getSelection();
          if (o && o.rangeCount !== 0) {
            u = o.anchorNode;
            var d = o.anchorOffset, p = o.focusNode;
            o = o.focusOffset;
            try {
              u.nodeType, p.nodeType;
            } catch {
              u = null;
              break e;
            }
            var T = 0, C = -1, x = -1, K = 0, le = 0, re = n, k = null;
            t: for (; ; ) {
              for (var P; re !== u || d !== 0 && re.nodeType !== 3 || (C = T + d), re !== p || o !== 0 && re.nodeType !== 3 || (x = T + o), re.nodeType === 3 && (T += re.nodeValue.length), (P = re.firstChild) !== null; )
                k = re, re = P;
              for (; ; ) {
                if (re === n) break t;
                if (k === u && ++K === d && (C = T), k === p && ++le === o && (x = T), (P = re.nextSibling) !== null) break;
                re = k, k = re.parentNode;
              }
              re = P;
            }
            u = C === -1 || x === -1 ? null : { start: C, end: x };
          } else u = null;
        }
      u = u || { start: 0, end: 0 };
    } else u = null;
    for (im = { focusedElem: n, selectionRange: u }, Ln = !1, Kn = l; Kn !== null; )
      if (l = Kn, n = l.child, (l.subtreeFlags & 1028) !== 0 && n !== null)
        n.return = l, Kn = n;
      else
        for (; Kn !== null; ) {
          switch (l = Kn, p = l.alternate, n = l.flags, l.tag) {
            case 0:
              if ((n & 4) !== 0 && (n = l.updateQueue, n = n !== null ? n.events : null, n !== null))
                for (u = 0; u < n.length; u++)
                  d = n[u], d.ref.impl = d.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((n & 1024) !== 0 && p !== null) {
                n = void 0, u = l, d = p.memoizedProps, p = p.memoizedState, o = u.stateNode;
                try {
                  var Ue = Ao(
                    u.type,
                    d
                  );
                  n = o.getSnapshotBeforeUpdate(
                    Ue,
                    p
                  ), o.__reactInternalSnapshotBeforeUpdate = n;
                } catch (Ye) {
                  Lt(
                    u,
                    u.return,
                    Ye
                  );
                }
              }
              break;
            case 3:
              if ((n & 1024) !== 0) {
                if (n = l.stateNode.containerInfo, u = n.nodeType, u === 9)
                  Ff(n);
                else if (u === 1)
                  switch (n.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Ff(n);
                      break;
                    default:
                      n.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((n & 1024) !== 0) throw Error(h(163));
          }
          if (n = l.sibling, n !== null) {
            n.return = l.return, Kn = n;
            break;
          }
          Kn = l.return;
        }
  }
  function Nf(n, l, u) {
    var o = u.flags;
    switch (u.tag) {
      case 0:
      case 11:
      case 15:
        ji(n, u), o & 4 && ql(5, u);
        break;
      case 1:
        if (ji(n, u), o & 4)
          if (n = u.stateNode, l === null)
            try {
              n.componentDidMount();
            } catch (T) {
              Lt(u, u.return, T);
            }
          else {
            var d = Ao(
              u.type,
              l.memoizedProps
            );
            l = l.memoizedState;
            try {
              n.componentDidUpdate(
                d,
                l,
                n.__reactInternalSnapshotBeforeUpdate
              );
            } catch (T) {
              Lt(
                u,
                u.return,
                T
              );
            }
          }
        o & 64 && Bh(u), o & 512 && ku(u, u.return);
        break;
      case 3:
        if (ji(n, u), o & 64 && (n = u.updateQueue, n !== null)) {
          if (l = null, u.child !== null)
            switch (u.child.tag) {
              case 27:
              case 5:
                l = u.child.stateNode;
                break;
              case 1:
                l = u.child.stateNode;
            }
          try {
            So(n, l);
          } catch (T) {
            Lt(u, u.return, T);
          }
        }
        break;
      case 27:
        l === null && o & 4 && Oy(u);
      case 26:
      case 5:
        ji(n, u), l === null && o & 4 && Ty(u), o & 512 && ku(u, u.return);
        break;
      case 12:
        ji(n, u);
        break;
      case 31:
        ji(n, u), o & 4 && lv(n, u);
        break;
      case 13:
        ji(n, u), o & 4 && zy(n, u), o & 64 && (n = u.memoizedState, n !== null && (n = n.dehydrated, n !== null && (u = gl.bind(
          null,
          u
        ), ns(n, u))));
        break;
      case 22:
        if (o = u.memoizedState !== null || Bi, !o) {
          l = l !== null && l.memoizedState !== null || zn, d = Bi;
          var p = zn;
          Bi = o, (zn = l) && !p ? mu(
            n,
            u,
            (u.subtreeFlags & 8772) !== 0
          ) : ji(n, u), Bi = d, zn = p;
        }
        break;
      case 30:
        break;
      default:
        ji(n, u);
    }
  }
  function Ry(n) {
    var l = n.alternate;
    l !== null && (n.alternate = null, Ry(l)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (l = n.stateNode, l !== null && Hd(l)), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  var Kt = null, Ua = !1;
  function $u(n, l, u) {
    for (u = u.child; u !== null; )
      Cy(n, l, u), u = u.sibling;
  }
  function Cy(n, l, u) {
    if (Va && typeof Va.onCommitFiberUnmount == "function")
      try {
        Va.onCommitFiberUnmount(Qo, u);
      } catch {
      }
    switch (u.tag) {
      case 26:
        zn || hu(u, l), $u(
          n,
          l,
          u
        ), u.memoizedState ? u.memoizedState.count-- : u.stateNode && (u = u.stateNode, u.parentNode.removeChild(u));
        break;
      case 27:
        zn || hu(u, l);
        var o = Kt, d = Ua;
        vu(u.type) && (Kt = u.stateNode, Ua = !1), $u(
          n,
          l,
          u
        ), Nc(u.stateNode), Kt = o, Ua = d;
        break;
      case 5:
        zn || hu(u, l);
      case 6:
        if (o = Kt, d = Ua, Kt = null, $u(
          n,
          l,
          u
        ), Kt = o, Ua = d, Kt !== null)
          if (Ua)
            try {
              (Kt.nodeType === 9 ? Kt.body : Kt.nodeName === "HTML" ? Kt.ownerDocument.body : Kt).removeChild(u.stateNode);
            } catch (p) {
              Lt(
                u,
                l,
                p
              );
            }
          else
            try {
              Kt.removeChild(u.stateNode);
            } catch (p) {
              Lt(
                u,
                l,
                p
              );
            }
        break;
      case 18:
        Kt !== null && (Ua ? (n = Kt, Wy(
          n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n,
          u.stateNode
        ), hs(n)) : Wy(Kt, u.stateNode));
        break;
      case 4:
        o = Kt, d = Ua, Kt = u.stateNode.containerInfo, Ua = !0, $u(
          n,
          l,
          u
        ), Kt = o, Ua = d;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        yl(2, u, l), zn || yl(4, u, l), $u(
          n,
          l,
          u
        );
        break;
      case 1:
        zn || (hu(u, l), o = u.stateNode, typeof o.componentWillUnmount == "function" && Co(
          u,
          l,
          o
        )), $u(
          n,
          l,
          u
        );
        break;
      case 21:
        $u(
          n,
          l,
          u
        );
        break;
      case 22:
        zn = (o = zn) || u.memoizedState !== null, $u(
          n,
          l,
          u
        ), zn = o;
        break;
      default:
        $u(
          n,
          l,
          u
        );
    }
  }
  function lv(n, l) {
    if (l.memoizedState === null && (n = l.alternate, n !== null && (n = n.memoizedState, n !== null))) {
      n = n.dehydrated;
      try {
        hs(n);
      } catch (u) {
        Lt(l, l.return, u);
      }
    }
  }
  function zy(n, l) {
    if (l.memoizedState === null && (n = l.alternate, n !== null && (n = n.memoizedState, n !== null && (n = n.dehydrated, n !== null))))
      try {
        hs(n);
      } catch (u) {
        Lt(l, l.return, u);
      }
  }
  function xf(n) {
    switch (n.tag) {
      case 31:
      case 13:
      case 19:
        var l = n.stateNode;
        return l === null && (l = n.stateNode = new Dy()), l;
      case 22:
        return n = n.stateNode, l = n._retryCache, l === null && (l = n._retryCache = new Dy()), l;
      default:
        throw Error(h(435, n.tag));
    }
  }
  function Hf(n, l) {
    var u = xf(n);
    l.forEach(function(o) {
      if (!u.has(o)) {
        u.add(o);
        var d = Dv.bind(null, n, o);
        o.then(d, d);
      }
    });
  }
  function wa(n, l) {
    var u = l.deletions;
    if (u !== null)
      for (var o = 0; o < u.length; o++) {
        var d = u[o], p = n, T = l, C = T;
        e: for (; C !== null; ) {
          switch (C.tag) {
            case 27:
              if (vu(C.type)) {
                Kt = C.stateNode, Ua = !1;
                break e;
              }
              break;
            case 5:
              Kt = C.stateNode, Ua = !1;
              break e;
            case 3:
            case 4:
              Kt = C.stateNode.containerInfo, Ua = !0;
              break e;
          }
          C = C.return;
        }
        if (Kt === null) throw Error(h(160));
        Cy(p, T, d), Kt = null, Ua = !1, p = d.alternate, p !== null && (p.return = null), d.return = null;
      }
    if (l.subtreeFlags & 13886)
      for (l = l.child; l !== null; )
        Vh(l, n), l = l.sibling;
  }
  var nt = null;
  function Vh(n, l) {
    var u = n.alternate, o = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        wa(l, n), Xa(n), o & 4 && (yl(3, n, n.return), ql(3, n), yl(5, n, n.return));
        break;
      case 1:
        wa(l, n), Xa(n), o & 512 && (zn || u === null || hu(u, u.return)), o & 64 && Bi && (n = n.updateQueue, n !== null && (o = n.callbacks, o !== null && (u = n.shared.hiddenCallbacks, n.shared.hiddenCallbacks = u === null ? o : u.concat(o))));
        break;
      case 26:
        var d = nt;
        if (wa(l, n), Xa(n), o & 512 && (zn || u === null || hu(u, u.return)), o & 4) {
          var p = u !== null ? u.memoizedState : null;
          if (o = n.memoizedState, u === null)
            if (o === null)
              if (n.stateNode === null) {
                e: {
                  o = n.type, u = n.memoizedProps, d = d.ownerDocument || d;
                  t: switch (o) {
                    case "title":
                      p = d.getElementsByTagName("title")[0], (!p || p[zu] || p[qt] || p.namespaceURI === "http://www.w3.org/2000/svg" || p.hasAttribute("itemprop")) && (p = d.createElement(o), d.head.insertBefore(
                        p,
                        d.querySelector("head > title")
                      )), la(p, o, u), p[qt] = n, Mt(p), o = p;
                      break e;
                    case "link":
                      var T = tg(
                        "link",
                        "href",
                        d
                      ).get(o + (u.href || ""));
                      if (T) {
                        for (var C = 0; C < T.length; C++)
                          if (p = T[C], p.getAttribute("href") === (u.href == null || u.href === "" ? null : u.href) && p.getAttribute("rel") === (u.rel == null ? null : u.rel) && p.getAttribute("title") === (u.title == null ? null : u.title) && p.getAttribute("crossorigin") === (u.crossOrigin == null ? null : u.crossOrigin)) {
                            T.splice(C, 1);
                            break t;
                          }
                      }
                      p = d.createElement(o), la(p, o, u), d.head.appendChild(p);
                      break;
                    case "meta":
                      if (T = tg(
                        "meta",
                        "content",
                        d
                      ).get(o + (u.content || ""))) {
                        for (C = 0; C < T.length; C++)
                          if (p = T[C], p.getAttribute("content") === (u.content == null ? null : "" + u.content) && p.getAttribute("name") === (u.name == null ? null : u.name) && p.getAttribute("property") === (u.property == null ? null : u.property) && p.getAttribute("http-equiv") === (u.httpEquiv == null ? null : u.httpEquiv) && p.getAttribute("charset") === (u.charSet == null ? null : u.charSet)) {
                            T.splice(C, 1);
                            break t;
                          }
                      }
                      p = d.createElement(o), la(p, o, u), d.head.appendChild(p);
                      break;
                    default:
                      throw Error(h(468, o));
                  }
                  p[qt] = n, Mt(p), o = p;
                }
                n.stateNode = o;
              } else
                fm(
                  d,
                  n.type,
                  n.stateNode
                );
            else
              n.stateNode = eg(
                d,
                o,
                n.memoizedProps
              );
          else
            p !== o ? (p === null ? u.stateNode !== null && (u = u.stateNode, u.parentNode.removeChild(u)) : p.count--, o === null ? fm(
              d,
              n.type,
              n.stateNode
            ) : eg(
              d,
              o,
              n.memoizedProps
            )) : o === null && n.stateNode !== null && jh(
              n,
              n.memoizedProps,
              u.memoizedProps
            );
        }
        break;
      case 27:
        wa(l, n), Xa(n), o & 512 && (zn || u === null || hu(u, u.return)), u !== null && o & 4 && jh(
          n,
          n.memoizedProps,
          u.memoizedProps
        );
        break;
      case 5:
        if (wa(l, n), Xa(n), o & 512 && (zn || u === null || hu(u, u.return)), n.flags & 32) {
          d = n.stateNode;
          try {
            Uu(d, "");
          } catch (Ue) {
            Lt(n, n.return, Ue);
          }
        }
        o & 4 && n.stateNode != null && (d = n.memoizedProps, jh(
          n,
          d,
          u !== null ? u.memoizedProps : d
        )), o & 1024 && (qh = !0);
        break;
      case 6:
        if (wa(l, n), Xa(n), o & 4) {
          if (n.stateNode === null)
            throw Error(h(162));
          o = n.memoizedProps, u = n.stateNode;
          try {
            u.nodeValue = o;
          } catch (Ue) {
            Lt(n, n.return, Ue);
          }
        }
        break;
      case 3:
        if (cs = null, d = nt, nt = da(l.containerInfo), wa(l, n), nt = d, Xa(n), o & 4 && u !== null && u.memoizedState.isDehydrated)
          try {
            hs(l.containerInfo);
          } catch (Ue) {
            Lt(n, n.return, Ue);
          }
        qh && (qh = !1, _y(n));
        break;
      case 4:
        o = nt, nt = da(
          n.stateNode.containerInfo
        ), wa(l, n), Xa(n), nt = o;
        break;
      case 12:
        wa(l, n), Xa(n);
        break;
      case 31:
        wa(l, n), Xa(n), o & 4 && (o = n.updateQueue, o !== null && (n.updateQueue = null, Hf(n, o)));
        break;
      case 13:
        wa(l, n), Xa(n), n.child.flags & 8192 && n.memoizedState !== null != (u !== null && u.memoizedState !== null) && (gu = _e()), o & 4 && (o = n.updateQueue, o !== null && (n.updateQueue = null, Hf(n, o)));
        break;
      case 22:
        d = n.memoizedState !== null;
        var x = u !== null && u.memoizedState !== null, K = Bi, le = zn;
        if (Bi = K || d, zn = le || x, wa(l, n), zn = le, Bi = K, Xa(n), o & 8192)
          e: for (l = n.stateNode, l._visibility = d ? l._visibility & -2 : l._visibility | 1, d && (u === null || x || Bi || zn || Rc(n)), u = null, l = n; ; ) {
            if (l.tag === 5 || l.tag === 26) {
              if (u === null) {
                x = u = l;
                try {
                  if (p = x.stateNode, d)
                    T = p.style, typeof T.setProperty == "function" ? T.setProperty("display", "none", "important") : T.display = "none";
                  else {
                    C = x.stateNode;
                    var re = x.memoizedProps.style, k = re != null && re.hasOwnProperty("display") ? re.display : null;
                    C.style.display = k == null || typeof k == "boolean" ? "" : ("" + k).trim();
                  }
                } catch (Ue) {
                  Lt(x, x.return, Ue);
                }
              }
            } else if (l.tag === 6) {
              if (u === null) {
                x = l;
                try {
                  x.stateNode.nodeValue = d ? "" : x.memoizedProps;
                } catch (Ue) {
                  Lt(x, x.return, Ue);
                }
              }
            } else if (l.tag === 18) {
              if (u === null) {
                x = l;
                try {
                  var P = x.stateNode;
                  d ? An(P, !0) : An(x.stateNode, !1);
                } catch (Ue) {
                  Lt(x, x.return, Ue);
                }
              }
            } else if ((l.tag !== 22 && l.tag !== 23 || l.memoizedState === null || l === n) && l.child !== null) {
              l.child.return = l, l = l.child;
              continue;
            }
            if (l === n) break e;
            for (; l.sibling === null; ) {
              if (l.return === null || l.return === n) break e;
              u === l && (u = null), l = l.return;
            }
            u === l && (u = null), l.sibling.return = l.return, l = l.sibling;
          }
        o & 4 && (o = n.updateQueue, o !== null && (u = o.retryQueue, u !== null && (o.retryQueue = null, Hf(n, u))));
        break;
      case 19:
        wa(l, n), Xa(n), o & 4 && (o = n.updateQueue, o !== null && (n.updateQueue = null, Hf(n, o)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        wa(l, n), Xa(n);
    }
  }
  function Xa(n) {
    var l = n.flags;
    if (l & 2) {
      try {
        for (var u, o = n.return; o !== null; ) {
          if (Ay(o)) {
            u = o;
            break;
          }
          o = o.return;
        }
        if (u == null) throw Error(h(160));
        switch (u.tag) {
          case 27:
            var d = u.stateNode, p = qr(n);
            Yr(n, p, d);
            break;
          case 5:
            var T = u.stateNode;
            u.flags & 32 && (Uu(T, ""), u.flags &= -33);
            var C = qr(n);
            Yr(n, C, T);
            break;
          case 3:
          case 4:
            var x = u.stateNode.containerInfo, K = qr(n);
            Vr(
              n,
              K,
              x
            );
            break;
          default:
            throw Error(h(161));
        }
      } catch (le) {
        Lt(n, n.return, le);
      }
      n.flags &= -3;
    }
    l & 4096 && (n.flags &= -4097);
  }
  function _y(n) {
    if (n.subtreeFlags & 1024)
      for (n = n.child; n !== null; ) {
        var l = n;
        _y(l), l.tag === 5 && l.flags & 1024 && l.stateNode.reset(), n = n.sibling;
      }
  }
  function ji(n, l) {
    if (l.subtreeFlags & 8772)
      for (l = l.child; l !== null; )
        Nf(n, l.alternate, l), l = l.sibling;
  }
  function Rc(n) {
    for (n = n.child; n !== null; ) {
      var l = n;
      switch (l.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          yl(4, l, l.return), Rc(l);
          break;
        case 1:
          hu(l, l.return);
          var u = l.stateNode;
          typeof u.componentWillUnmount == "function" && Co(
            l,
            l.return,
            u
          ), Rc(l);
          break;
        case 27:
          Nc(l.stateNode);
        case 26:
        case 5:
          hu(l, l.return), Rc(l);
          break;
        case 22:
          l.memoizedState === null && Rc(l);
          break;
        case 30:
          Rc(l);
          break;
        default:
          Rc(l);
      }
      n = n.sibling;
    }
  }
  function mu(n, l, u) {
    for (u = u && (l.subtreeFlags & 8772) !== 0, l = l.child; l !== null; ) {
      var o = l.alternate, d = n, p = l, T = p.flags;
      switch (p.tag) {
        case 0:
        case 11:
        case 15:
          mu(
            d,
            p,
            u
          ), ql(4, p);
          break;
        case 1:
          if (mu(
            d,
            p,
            u
          ), o = p, d = o.stateNode, typeof d.componentDidMount == "function")
            try {
              d.componentDidMount();
            } catch (K) {
              Lt(o, o.return, K);
            }
          if (o = p, d = o.updateQueue, d !== null) {
            var C = o.stateNode;
            try {
              var x = d.shared.hiddenCallbacks;
              if (x !== null)
                for (d.shared.hiddenCallbacks = null, d = 0; d < x.length; d++)
                  fh(x[d], C);
            } catch (K) {
              Lt(o, o.return, K);
            }
          }
          u && T & 64 && Bh(p), ku(p, p.return);
          break;
        case 27:
          Oy(p);
        case 26:
        case 5:
          mu(
            d,
            p,
            u
          ), u && o === null && T & 4 && Ty(p), ku(p, p.return);
          break;
        case 12:
          mu(
            d,
            p,
            u
          );
          break;
        case 31:
          mu(
            d,
            p,
            u
          ), u && T & 4 && lv(d, p);
          break;
        case 13:
          mu(
            d,
            p,
            u
          ), u && T & 4 && zy(d, p);
          break;
        case 22:
          p.memoizedState === null && mu(
            d,
            p,
            u
          ), ku(p, p.return);
          break;
        case 30:
          break;
        default:
          mu(
            d,
            p,
            u
          );
      }
      l = l.sibling;
    }
  }
  function Yh(n, l) {
    var u = null;
    n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (u = n.memoizedState.cachePool.pool), n = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (n = l.memoizedState.cachePool.pool), n !== u && (n != null && n.refCount++, u != null && rf(u));
  }
  function Gh(n, l) {
    n = null, l.alternate !== null && (n = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== n && (l.refCount++, n != null && rf(n));
  }
  function Vl(n, l, u, o) {
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        Xr(
          n,
          l,
          u,
          o
        ), l = l.sibling;
  }
  function Xr(n, l, u, o) {
    var d = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        Vl(
          n,
          l,
          u,
          o
        ), d & 2048 && ql(9, l);
        break;
      case 1:
        Vl(
          n,
          l,
          u,
          o
        );
        break;
      case 3:
        Vl(
          n,
          l,
          u,
          o
        ), d & 2048 && (n = null, l.alternate !== null && (n = l.alternate.memoizedState.cache), l = l.memoizedState.cache, l !== n && (l.refCount++, n != null && rf(n)));
        break;
      case 12:
        if (d & 2048) {
          Vl(
            n,
            l,
            u,
            o
          ), n = l.stateNode;
          try {
            var p = l.memoizedProps, T = p.id, C = p.onPostCommit;
            typeof C == "function" && C(
              T,
              l.alternate === null ? "mount" : "update",
              n.passiveEffectDuration,
              -0
            );
          } catch (x) {
            Lt(l, l.return, x);
          }
        } else
          Vl(
            n,
            l,
            u,
            o
          );
        break;
      case 31:
        Vl(
          n,
          l,
          u,
          o
        );
        break;
      case 13:
        Vl(
          n,
          l,
          u,
          o
        );
        break;
      case 23:
        break;
      case 22:
        p = l.stateNode, T = l.alternate, l.memoizedState !== null ? p._visibility & 2 ? Vl(
          n,
          l,
          u,
          o
        ) : Lf(n, l) : p._visibility & 2 ? Vl(
          n,
          l,
          u,
          o
        ) : (p._visibility |= 2, Qr(
          n,
          l,
          u,
          o,
          (l.subtreeFlags & 10256) !== 0 || !1
        )), d & 2048 && Yh(T, l);
        break;
      case 24:
        Vl(
          n,
          l,
          u,
          o
        ), d & 2048 && Gh(l.alternate, l);
        break;
      default:
        Vl(
          n,
          l,
          u,
          o
        );
    }
  }
  function Qr(n, l, u, o, d) {
    for (d = d && ((l.subtreeFlags & 10256) !== 0 || !1), l = l.child; l !== null; ) {
      var p = n, T = l, C = u, x = o, K = T.flags;
      switch (T.tag) {
        case 0:
        case 11:
        case 15:
          Qr(
            p,
            T,
            C,
            x,
            d
          ), ql(8, T);
          break;
        case 23:
          break;
        case 22:
          var le = T.stateNode;
          T.memoizedState !== null ? le._visibility & 2 ? Qr(
            p,
            T,
            C,
            x,
            d
          ) : Lf(
            p,
            T
          ) : (le._visibility |= 2, Qr(
            p,
            T,
            C,
            x,
            d
          )), d && K & 2048 && Yh(
            T.alternate,
            T
          );
          break;
        case 24:
          Qr(
            p,
            T,
            C,
            x,
            d
          ), d && K & 2048 && Gh(T.alternate, T);
          break;
        default:
          Qr(
            p,
            T,
            C,
            x,
            d
          );
      }
      l = l.sibling;
    }
  }
  function Lf(n, l) {
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; ) {
        var u = n, o = l, d = o.flags;
        switch (o.tag) {
          case 22:
            Lf(u, o), d & 2048 && Yh(
              o.alternate,
              o
            );
            break;
          case 24:
            Lf(u, o), d & 2048 && Gh(o.alternate, o);
            break;
          default:
            Lf(u, o);
        }
        l = l.sibling;
      }
  }
  var Qa = 8192;
  function Fu(n, l, u) {
    if (n.subtreeFlags & Qa)
      for (n = n.child; n !== null; )
        uv(
          n,
          l,
          u
        ), n = n.sibling;
  }
  function uv(n, l, u) {
    switch (n.tag) {
      case 26:
        Fu(
          n,
          l,
          u
        ), n.flags & Qa && n.memoizedState !== null && ti(
          u,
          nt,
          n.memoizedState,
          n.memoizedProps
        );
        break;
      case 5:
        Fu(
          n,
          l,
          u
        );
        break;
      case 3:
      case 4:
        var o = nt;
        nt = da(n.stateNode.containerInfo), Fu(
          n,
          l,
          u
        ), nt = o;
        break;
      case 22:
        n.memoizedState === null && (o = n.alternate, o !== null && o.memoizedState !== null ? (o = Qa, Qa = 16777216, Fu(
          n,
          l,
          u
        ), Qa = o) : Fu(
          n,
          l,
          u
        ));
        break;
      default:
        Fu(
          n,
          l,
          u
        );
    }
  }
  function Xh(n) {
    var l = n.alternate;
    if (l !== null && (n = l.child, n !== null)) {
      l.child = null;
      do
        l = n.sibling, n.sibling = null, n = l;
      while (n !== null);
    }
  }
  function Zr(n) {
    var l = n.deletions;
    if ((n.flags & 16) !== 0) {
      if (l !== null)
        for (var u = 0; u < l.length; u++) {
          var o = l[u];
          Kn = o, Qh(
            o,
            n
          );
        }
      Xh(n);
    }
    if (n.subtreeFlags & 10256)
      for (n = n.child; n !== null; )
        Uy(n), n = n.sibling;
  }
  function Uy(n) {
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        Zr(n), n.flags & 2048 && yl(9, n, n.return);
        break;
      case 3:
        Zr(n);
        break;
      case 12:
        Zr(n);
        break;
      case 22:
        var l = n.stateNode;
        n.memoizedState !== null && l._visibility & 2 && (n.return === null || n.return.tag !== 13) ? (l._visibility &= -3, Bf(n)) : Zr(n);
        break;
      default:
        Zr(n);
    }
  }
  function Bf(n) {
    var l = n.deletions;
    if ((n.flags & 16) !== 0) {
      if (l !== null)
        for (var u = 0; u < l.length; u++) {
          var o = l[u];
          Kn = o, Qh(
            o,
            n
          );
        }
      Xh(n);
    }
    for (n = n.child; n !== null; ) {
      switch (l = n, l.tag) {
        case 0:
        case 11:
        case 15:
          yl(8, l, l.return), Bf(l);
          break;
        case 22:
          u = l.stateNode, u._visibility & 2 && (u._visibility &= -3, Bf(l));
          break;
        default:
          Bf(l);
      }
      n = n.sibling;
    }
  }
  function Qh(n, l) {
    for (; Kn !== null; ) {
      var u = Kn;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          yl(8, u, l);
          break;
        case 23:
        case 22:
          if (u.memoizedState !== null && u.memoizedState.cachePool !== null) {
            var o = u.memoizedState.cachePool.pool;
            o != null && o.refCount++;
          }
          break;
        case 24:
          rf(u.memoizedState.cache);
      }
      if (o = u.child, o !== null) o.return = u, Kn = o;
      else
        e: for (u = n; Kn !== null; ) {
          o = Kn;
          var d = o.sibling, p = o.return;
          if (Ry(o), o === u) {
            Kn = null;
            break e;
          }
          if (d !== null) {
            d.return = p, Kn = d;
            break e;
          }
          Kn = p;
        }
    }
  }
  var iv = {
    getCacheForType: function(n) {
      var l = se(Sn), u = l.data.get(n);
      return u === void 0 && (u = n(), l.data.set(n, u)), u;
    },
    cacheSignal: function() {
      return se(Sn).controller.signal;
    }
  }, wy = typeof WeakMap == "function" ? WeakMap : Map, Ot = 0, Yt = null, mt = null, rt = 0, Ht = 0, Xe = null, Wu = !1, zo = !1, Zh = !1, pu = 0, kt = 0, yu = 0, Cc = 0, Jh = 0, Ma = 0, sn = 0, jf = null, fn = null, Kh = !1, gu = 0, My = 0, zt = 1 / 0, Jr = null, an = null, Hn = 0, qi = null, _o = null, Iu = 0, Za = 0, kh = null, $h = null, Kr = 0, qf = null;
  function Ja() {
    return (Ot & 2) !== 0 && rt !== 0 ? rt & -rt : H.T !== null ? em() : Nd();
  }
  function ov() {
    if (Ma === 0)
      if ((rt & 536870912) === 0 || ht) {
        var n = Fl;
        Fl <<= 1, (Fl & 3932160) === 0 && (Fl = 262144), Ma = n;
      } else Ma = 536870912;
    return n = Ra.current, n !== null && (n.flags |= 32), Ma;
  }
  function Na(n, l, u) {
    (n === Yt && (Ht === 2 || Ht === 9) || n.cancelPendingCommit !== null) && (Pu(n, 0), Vi(
      n,
      rt,
      Ma,
      !1
    )), ir(n, u), ((Ot & 2) === 0 || n !== Yt) && (n === Yt && ((Ot & 2) === 0 && (Cc |= u), kt === 4 && Vi(
      n,
      rt,
      Ma,
      !1
    )), ei(n));
  }
  function cv(n, l, u) {
    if ((Ot & 6) !== 0) throw Error(h(327));
    var o = !u && (l & 127) === 0 && (l & n.expiredLanes) === 0 || Wl(n, l), d = o ? hv(n, l) : Wh(n, l, !0), p = o;
    do {
      if (d === 0) {
        zo && !o && Vi(n, l, 0, !1);
        break;
      } else {
        if (u = n.current.alternate, p && !rv(u)) {
          d = Wh(n, l, !1), p = !1;
          continue;
        }
        if (d === 2) {
          if (p = l, n.errorRecoveryDisabledLanes & p)
            var T = 0;
          else
            T = n.pendingLanes & -536870913, T = T !== 0 ? T : T & 536870912 ? 536870912 : 0;
          if (T !== 0) {
            l = T;
            e: {
              var C = n;
              d = jf;
              var x = C.current.memoizedState.isDehydrated;
              if (x && (Pu(C, T).flags |= 256), T = Wh(
                C,
                T,
                !1
              ), T !== 2) {
                if (Zh && !x) {
                  C.errorRecoveryDisabledLanes |= p, Cc |= p, d = 4;
                  break e;
                }
                p = fn, fn = d, p !== null && (fn === null ? fn = p : fn.push.apply(
                  fn,
                  p
                ));
              }
              d = T;
            }
            if (p = !1, d !== 2) continue;
          }
        }
        if (d === 1) {
          Pu(n, 0), Vi(n, l, 0, !0);
          break;
        }
        e: {
          switch (o = n, p = d, p) {
            case 0:
            case 1:
              throw Error(h(345));
            case 4:
              if ((l & 4194048) !== l) break;
            case 6:
              Vi(
                o,
                l,
                Ma,
                !Wu
              );
              break e;
            case 2:
              fn = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(h(329));
          }
          if ((l & 62914560) === l && (d = gu + 300 - _e(), 10 < d)) {
            if (Vi(
              o,
              l,
              Ma,
              !Wu
            ), vn(o, 0, !0) !== 0) break e;
            Iu = l, o.timeoutHandle = $f(
              Vf.bind(
                null,
                o,
                u,
                fn,
                Jr,
                Kh,
                l,
                Ma,
                Cc,
                sn,
                Wu,
                p,
                "Throttled",
                -0,
                0
              ),
              d
            );
            break e;
          }
          Vf(
            o,
            u,
            fn,
            Jr,
            Kh,
            l,
            Ma,
            Cc,
            sn,
            Wu,
            p,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    ei(n);
  }
  function Vf(n, l, u, o, d, p, T, C, x, K, le, re, k, P) {
    if (n.timeoutHandle = -1, re = l.subtreeFlags, re & 8192 || (re & 16785408) === 16785408) {
      re = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Pl
      }, uv(
        l,
        p,
        re
      );
      var Ue = (p & 62914560) === p ? gu - _e() : (p & 4194048) === p ? My - _e() : 0;
      if (Ue = ag(
        re,
        Ue
      ), Ue !== null) {
        Iu = p, n.cancelPendingCommit = Ue(
          gv.bind(
            null,
            n,
            l,
            p,
            u,
            o,
            d,
            T,
            C,
            x,
            le,
            re,
            null,
            k,
            P
          )
        ), Vi(n, p, T, !K);
        return;
      }
    }
    gv(
      n,
      l,
      p,
      u,
      o,
      d,
      T,
      C,
      x
    );
  }
  function rv(n) {
    for (var l = n; ; ) {
      var u = l.tag;
      if ((u === 0 || u === 11 || u === 15) && l.flags & 16384 && (u = l.updateQueue, u !== null && (u = u.stores, u !== null)))
        for (var o = 0; o < u.length; o++) {
          var d = u[o], p = d.getSnapshot;
          d = d.value;
          try {
            if (!sa(p(), d)) return !1;
          } catch {
            return !1;
          }
        }
      if (u = l.child, l.subtreeFlags & 16384 && u !== null)
        u.return = l, l = u;
      else {
        if (l === n) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === n) return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    return !0;
  }
  function Vi(n, l, u, o) {
    l &= ~Jh, l &= ~Cc, n.suspendedLanes |= l, n.pingedLanes &= ~l, o && (n.warmLanes |= l), o = n.expirationTimes;
    for (var d = l; 0 < d; ) {
      var p = 31 - ba(d), T = 1 << p;
      o[p] = -1, d &= ~T;
    }
    u !== 0 && Ys(n, u, l);
  }
  function kr() {
    return (Ot & 6) === 0 ? (Gi(0), !1) : !0;
  }
  function Ny() {
    if (mt !== null) {
      if (Ht === 0)
        var n = mt.return;
      else
        n = mt, cu = _i = null, bf(n), yo = null, pc = 0, n = mt;
      for (; n !== null; )
        av(n.alternate, n), n = n.return;
      mt = null;
    }
  }
  function Pu(n, l) {
    var u = n.timeoutHandle;
    u !== -1 && (n.timeoutHandle = -1, Nv(u)), u = n.cancelPendingCommit, u !== null && (n.cancelPendingCommit = null, u()), Iu = 0, Ny(), Yt = n, mt = u = Ci(n.current, null), rt = l, Ht = 0, Xe = null, Wu = !1, zo = Wl(n, l), Zh = !1, sn = Ma = Jh = Cc = yu = kt = 0, fn = jf = null, Kh = !1, (l & 8) !== 0 && (l |= l & 32);
    var o = n.entangledLanes;
    if (o !== 0)
      for (n = n.entanglements, o &= l; 0 < o; ) {
        var d = 31 - ba(o), p = 1 << d;
        l |= n[d], o &= ~p;
      }
    return pu = l, ul(), u;
  }
  function $r(n, l) {
    Pe = null, H.H = Cf, l === ho || l === Rr ? (l = Gp(), Ht = 3) : l === hc ? (l = Gp(), Ht = 4) : Ht = l === Mh ? 8 : l !== null && typeof l == "object" && typeof l.then == "function" ? 6 : 1, Xe = l, mt === null && (kt = 1, Br(
      n,
      ol(l, n.current)
    ));
  }
  function sv() {
    var n = Ra.current;
    return n === null ? !0 : (rt & 4194048) === rt ? dl === null : (rt & 62914560) === rt || (rt & 536870912) !== 0 ? n === dl : !1;
  }
  function fv() {
    var n = H.H;
    return H.H = Cf, n === null ? Cf : n;
  }
  function dv() {
    var n = H.A;
    return H.A = iv, n;
  }
  function Fh() {
    kt = 4, Wu || (rt & 4194048) !== rt && Ra.current !== null || (zo = !0), (yu & 134217727) === 0 && (Cc & 134217727) === 0 || Yt === null || Vi(
      Yt,
      rt,
      Ma,
      !1
    );
  }
  function Wh(n, l, u) {
    var o = Ot;
    Ot |= 2;
    var d = fv(), p = dv();
    (Yt !== n || rt !== l) && (Jr = null, Pu(n, l)), l = !1;
    var T = kt;
    e: do
      try {
        if (Ht !== 0 && mt !== null) {
          var C = mt, x = Xe;
          switch (Ht) {
            case 8:
              Ny(), T = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              Ra.current === null && (l = !0);
              var K = Ht;
              if (Ht = 0, Xe = null, zc(n, C, x, K), u && zo) {
                T = 0;
                break e;
              }
              break;
            default:
              K = Ht, Ht = 0, Xe = null, zc(n, C, x, K);
          }
        }
        xb(), T = kt;
        break;
      } catch (le) {
        $r(n, le);
      }
    while (!0);
    return l && n.shellSuspendCounter++, cu = _i = null, Ot = o, H.H = d, H.A = p, mt === null && (Yt = null, rt = 0, ul()), T;
  }
  function xb() {
    for (; mt !== null; ) mv(mt);
  }
  function hv(n, l) {
    var u = Ot;
    Ot |= 2;
    var o = fv(), d = dv();
    Yt !== n || rt !== l ? (Jr = null, zt = _e() + 500, Pu(n, l)) : zo = Wl(
      n,
      l
    );
    e: do
      try {
        if (Ht !== 0 && mt !== null) {
          l = mt;
          var p = Xe;
          t: switch (Ht) {
            case 1:
              Ht = 0, Xe = null, zc(n, l, p, 1);
              break;
            case 2:
            case 9:
              if (Vp(p)) {
                Ht = 0, Xe = null, pv(l);
                break;
              }
              l = function() {
                Ht !== 2 && Ht !== 9 || Yt !== n || (Ht = 7), ei(n);
              }, p.then(l, l);
              break e;
            case 3:
              Ht = 7;
              break e;
            case 4:
              Ht = 5;
              break e;
            case 7:
              Vp(p) ? (Ht = 0, Xe = null, pv(l)) : (Ht = 0, Xe = null, zc(n, l, p, 7));
              break;
            case 5:
              var T = null;
              switch (mt.tag) {
                case 26:
                  T = mt.memoizedState;
                case 5:
                case 27:
                  var C = mt;
                  if (T ? ka(T) : C.stateNode.complete) {
                    Ht = 0, Xe = null;
                    var x = C.sibling;
                    if (x !== null) mt = x;
                    else {
                      var K = C.return;
                      K !== null ? (mt = K, Yf(K)) : mt = null;
                    }
                    break t;
                  }
              }
              Ht = 0, Xe = null, zc(n, l, p, 5);
              break;
            case 6:
              Ht = 0, Xe = null, zc(n, l, p, 6);
              break;
            case 8:
              Ny(), kt = 6;
              break e;
            default:
              throw Error(h(462));
          }
        }
        Uo();
        break;
      } catch (le) {
        $r(n, le);
      }
    while (!0);
    return cu = _i = null, H.H = o, H.A = d, Ot = u, mt !== null ? 0 : (Yt = null, rt = 0, ul(), kt);
  }
  function Uo() {
    for (; mt !== null && !oe(); )
      mv(mt);
  }
  function mv(n) {
    var l = by(n.alternate, n, pu);
    n.memoizedProps = n.pendingProps, l === null ? Yf(n) : mt = l;
  }
  function pv(n) {
    var l = n, u = l.alternate;
    switch (l.tag) {
      case 15:
      case 0:
        l = Do(
          u,
          l,
          l.pendingProps,
          l.type,
          void 0,
          rt
        );
        break;
      case 11:
        l = Do(
          u,
          l,
          l.pendingProps,
          l.type.render,
          l.ref,
          rt
        );
        break;
      case 5:
        bf(l);
      default:
        av(u, l), l = mt = Np(l, pu), l = by(u, l, pu);
    }
    n.memoizedProps = n.pendingProps, l === null ? Yf(n) : mt = l;
  }
  function zc(n, l, u, o) {
    cu = _i = null, bf(l), yo = null, pc = 0;
    var d = l.return;
    try {
      if (Nb(
        n,
        d,
        l,
        u,
        rt
      )) {
        kt = 1, Br(
          n,
          ol(u, n.current)
        ), mt = null;
        return;
      }
    } catch (p) {
      if (d !== null) throw mt = d, p;
      kt = 1, Br(
        n,
        ol(u, n.current)
      ), mt = null;
      return;
    }
    l.flags & 32768 ? (ht || o === 1 ? n = !0 : zo || (rt & 536870912) !== 0 ? n = !1 : (Wu = n = !0, (o === 2 || o === 9 || o === 3 || o === 6) && (o = Ra.current, o !== null && o.tag === 13 && (o.flags |= 16384))), yv(l, n)) : Yf(l);
  }
  function Yf(n) {
    var l = n;
    do {
      if ((l.flags & 32768) !== 0) {
        yv(
          l,
          Wu
        );
        return;
      }
      n = l.return;
      var u = tv(
        l.alternate,
        l,
        pu
      );
      if (u !== null) {
        mt = u;
        return;
      }
      if (l = l.sibling, l !== null) {
        mt = l;
        return;
      }
      mt = l = n;
    } while (l !== null);
    kt === 0 && (kt = 5);
  }
  function yv(n, l) {
    do {
      var u = nv(n.alternate, n);
      if (u !== null) {
        u.flags &= 32767, mt = u;
        return;
      }
      if (u = n.return, u !== null && (u.flags |= 32768, u.subtreeFlags = 0, u.deletions = null), !l && (n = n.sibling, n !== null)) {
        mt = n;
        return;
      }
      mt = n = u;
    } while (n !== null);
    kt = 6, mt = null;
  }
  function gv(n, l, u, o, d, p, T, C, x) {
    n.cancelPendingCommit = null;
    do
      Fr();
    while (Hn !== 0);
    if ((Ot & 6) !== 0) throw Error(h(327));
    if (l !== null) {
      if (l === n.current) throw Error(h(177));
      if (p = l.lanes | l.childLanes, p |= xl, wd(
        n,
        u,
        p,
        T,
        C,
        x
      ), n === Yt && (mt = Yt = null, rt = 0), _o = l, qi = n, Iu = u, Za = p, kh = d, $h = o, (l.subtreeFlags & 10256) !== 0 || (l.flags & 10256) !== 0 ? (n.callbackNode = null, n.callbackPriority = 0, Rv(Wt, function() {
        return Tv(), null;
      })) : (n.callbackNode = null, n.callbackPriority = 0), o = (l.flags & 13878) !== 0, (l.subtreeFlags & 13878) !== 0 || o) {
        o = H.T, H.T = null, d = ue.p, ue.p = 2, T = Ot, Ot |= 4;
        try {
          Gr(n, l, u);
        } finally {
          Ot = T, ue.p = d, H.T = o;
        }
      }
      Hn = 1, vv(), bv(), Sv();
    }
  }
  function vv() {
    if (Hn === 1) {
      Hn = 0;
      var n = qi, l = _o, u = (l.flags & 13878) !== 0;
      if ((l.subtreeFlags & 13878) !== 0 || u) {
        u = H.T, H.T = null;
        var o = ue.p;
        ue.p = 2;
        var d = Ot;
        Ot |= 4;
        try {
          Vh(l, n);
          var p = im, T = oo(n.containerInfo), C = p.focusedElem, x = p.selectionRange;
          if (T !== C && C && C.ownerDocument && uc(
            C.ownerDocument.documentElement,
            C
          )) {
            if (x !== null && Is(C)) {
              var K = x.start, le = x.end;
              if (le === void 0 && (le = K), "selectionStart" in C)
                C.selectionStart = K, C.selectionEnd = Math.min(
                  le,
                  C.value.length
                );
              else {
                var re = C.ownerDocument || document, k = re && re.defaultView || window;
                if (k.getSelection) {
                  var P = k.getSelection(), Ue = C.textContent.length, Ye = Math.min(x.start, Ue), Xt = x.end === void 0 ? Ye : Math.min(x.end, Ue);
                  !P.extend && Ye > Xt && (T = Xt, Xt = Ye, Ye = T);
                  var X = wp(
                    C,
                    Ye
                  ), q = wp(
                    C,
                    Xt
                  );
                  if (X && q && (P.rangeCount !== 1 || P.anchorNode !== X.node || P.anchorOffset !== X.offset || P.focusNode !== q.node || P.focusOffset !== q.offset)) {
                    var J = re.createRange();
                    J.setStart(X.node, X.offset), P.removeAllRanges(), Ye > Xt ? (P.addRange(J), P.extend(q.node, q.offset)) : (J.setEnd(q.node, q.offset), P.addRange(J));
                  }
                }
              }
            }
            for (re = [], P = C; P = P.parentNode; )
              P.nodeType === 1 && re.push({
                element: P,
                left: P.scrollLeft,
                top: P.scrollTop
              });
            for (typeof C.focus == "function" && C.focus(), C = 0; C < re.length; C++) {
              var ce = re[C];
              ce.element.scrollLeft = ce.left, ce.element.scrollTop = ce.top;
            }
          }
          Ln = !!um, im = um = null;
        } finally {
          Ot = d, ue.p = o, H.T = u;
        }
      }
      n.current = l, Hn = 2;
    }
  }
  function bv() {
    if (Hn === 2) {
      Hn = 0;
      var n = qi, l = _o, u = (l.flags & 8772) !== 0;
      if ((l.subtreeFlags & 8772) !== 0 || u) {
        u = H.T, H.T = null;
        var o = ue.p;
        ue.p = 2;
        var d = Ot;
        Ot |= 4;
        try {
          Nf(n, l.alternate, l);
        } finally {
          Ot = d, ue.p = o, H.T = u;
        }
      }
      Hn = 3;
    }
  }
  function Sv() {
    if (Hn === 4 || Hn === 3) {
      Hn = 0, me();
      var n = qi, l = _o, u = Iu, o = $h;
      (l.subtreeFlags & 10256) !== 0 || (l.flags & 10256) !== 0 ? Hn = 5 : (Hn = 0, _o = qi = null, Ev(n, n.pendingLanes));
      var d = n.pendingLanes;
      if (d === 0 && (an = null), up(u), l = l.stateNode, Va && typeof Va.onCommitFiberRoot == "function")
        try {
          Va.onCommitFiberRoot(
            Qo,
            l,
            void 0,
            (l.current.flags & 128) === 128
          );
        } catch {
        }
      if (o !== null) {
        l = H.T, d = ue.p, ue.p = 2, H.T = null;
        try {
          for (var p = n.onRecoverableError, T = 0; T < o.length; T++) {
            var C = o[T];
            p(C.value, {
              componentStack: C.stack
            });
          }
        } finally {
          H.T = l, ue.p = d;
        }
      }
      (Iu & 3) !== 0 && Fr(), ei(n), d = n.pendingLanes, (u & 261930) !== 0 && (d & 42) !== 0 ? n === qf ? Kr++ : (Kr = 0, qf = n) : Kr = 0, Gi(0);
    }
  }
  function Ev(n, l) {
    (n.pooledCacheLanes &= l) === 0 && (l = n.pooledCache, l != null && (n.pooledCache = null, rf(l)));
  }
  function Fr() {
    return vv(), bv(), Sv(), Tv();
  }
  function Tv() {
    if (Hn !== 5) return !1;
    var n = qi, l = Za;
    Za = 0;
    var u = up(Iu), o = H.T, d = ue.p;
    try {
      ue.p = 32 > u ? 32 : u, H.T = null, u = kh, kh = null;
      var p = qi, T = Iu;
      if (Hn = 0, _o = qi = null, Iu = 0, (Ot & 6) !== 0) throw Error(h(331));
      var C = Ot;
      if (Ot |= 4, Uy(p.current), Xr(
        p,
        p.current,
        T,
        u
      ), Ot = C, Gi(0, !1), Va && typeof Va.onPostCommitFiberRoot == "function")
        try {
          Va.onPostCommitFiberRoot(Qo, p);
        } catch {
        }
      return !0;
    } finally {
      ue.p = d, H.T = o, Ev(n, l);
    }
  }
  function Av(n, l, u) {
    l = ol(u, l), l = sy(n.stateNode, l, 2), n = fl(n, l, 2), n !== null && (ir(n, 2), ei(n));
  }
  function Lt(n, l, u) {
    if (n.tag === 3)
      Av(n, n, u);
    else
      for (; l !== null; ) {
        if (l.tag === 3) {
          Av(
            l,
            n,
            u
          );
          break;
        } else if (l.tag === 1) {
          var o = l.stateNode;
          if (typeof l.type.getDerivedStateFromError == "function" || typeof o.componentDidCatch == "function" && (an === null || !an.has(o))) {
            n = ol(u, n), u = fy(2), o = fl(l, u, 2), o !== null && (dy(
              u,
              o,
              l,
              n
            ), ir(o, 2), ei(o));
            break;
          }
        }
        l = l.return;
      }
  }
  function Gf(n, l, u) {
    var o = n.pingCache;
    if (o === null) {
      o = n.pingCache = new wy();
      var d = /* @__PURE__ */ new Set();
      o.set(l, d);
    } else
      d = o.get(l), d === void 0 && (d = /* @__PURE__ */ new Set(), o.set(l, d));
    d.has(u) || (Zh = !0, d.add(u), n = xy.bind(null, n, l, u), l.then(n, n));
  }
  function xy(n, l, u) {
    var o = n.pingCache;
    o !== null && o.delete(l), n.pingedLanes |= n.suspendedLanes & u, n.warmLanes &= ~u, Yt === n && (rt & u) === u && (kt === 4 || kt === 3 && (rt & 62914560) === rt && 300 > _e() - gu ? (Ot & 2) === 0 && Pu(n, 0) : Jh |= u, sn === rt && (sn = 0)), ei(n);
  }
  function Ov(n, l) {
    l === 0 && (l = Zo()), n = Ri(n, l), n !== null && (ir(n, l), ei(n));
  }
  function gl(n) {
    var l = n.memoizedState, u = 0;
    l !== null && (u = l.retryLane), Ov(n, u);
  }
  function Dv(n, l) {
    var u = 0;
    switch (n.tag) {
      case 31:
      case 13:
        var o = n.stateNode, d = n.memoizedState;
        d !== null && (u = d.retryLane);
        break;
      case 19:
        o = n.stateNode;
        break;
      case 22:
        o = n.stateNode._retryCache;
        break;
      default:
        throw Error(h(314));
    }
    o !== null && o.delete(l), Ov(n, u);
  }
  function Rv(n, l) {
    return Z(n, l);
  }
  var Wr = null, _c = null, Hy = !1, Ih = !1, Ly = !1, Yi = 0;
  function ei(n) {
    n !== _c && n.next === null && (_c === null ? Wr = _c = n : _c = _c.next = n), Ih = !0, Hy || (Hy = !0, Qf());
  }
  function Gi(n, l) {
    if (!Ly && Ih) {
      Ly = !0;
      do
        for (var u = !1, o = Wr; o !== null; ) {
          if (n !== 0) {
            var d = o.pendingLanes;
            if (d === 0) var p = 0;
            else {
              var T = o.suspendedLanes, C = o.pingedLanes;
              p = (1 << 31 - ba(42 | n) + 1) - 1, p &= d & ~(T & ~C), p = p & 201326741 ? p & 201326741 | 1 : p ? p | 2 : 0;
            }
            p !== 0 && (u = !0, Uc(o, p));
          } else
            p = rt, p = vn(
              o,
              o === Yt ? p : 0,
              o.cancelPendingCommit !== null || o.timeoutHandle !== -1
            ), (p & 3) === 0 || Wl(o, p) || (u = !0, Uc(o, p));
          o = o.next;
        }
      while (u);
      Ly = !1;
    }
  }
  function Ph() {
    By();
  }
  function By() {
    Ih = Hy = !1;
    var n = 0;
    Yi !== 0 && Hb() && (n = Yi);
    for (var l = _e(), u = null, o = Wr; o !== null; ) {
      var d = o.next, p = jy(o, l);
      p === 0 ? (o.next = null, u === null ? Wr = d : u.next = d, d === null && (_c = u)) : (u = o, (n !== 0 || (p & 3) !== 0) && (Ih = !0)), o = d;
    }
    Hn !== 0 && Hn !== 5 || Gi(n), Yi !== 0 && (Yi = 0);
  }
  function jy(n, l) {
    for (var u = n.suspendedLanes, o = n.pingedLanes, d = n.expirationTimes, p = n.pendingLanes & -62914561; 0 < p; ) {
      var T = 31 - ba(p), C = 1 << T, x = d[T];
      x === -1 ? ((C & u) === 0 || (C & o) !== 0) && (d[T] = ur(C, l)) : x <= l && (n.expiredLanes |= C), p &= ~C;
    }
    if (l = Yt, u = rt, u = vn(
      n,
      n === l ? u : 0,
      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
    ), o = n.callbackNode, u === 0 || n === l && (Ht === 2 || Ht === 9) || n.cancelPendingCommit !== null)
      return o !== null && o !== null && de(o), n.callbackNode = null, n.callbackPriority = 0;
    if ((u & 3) === 0 || Wl(n, u)) {
      if (l = u & -u, l === n.callbackPriority) return l;
      switch (o !== null && de(o), up(u)) {
        case 2:
        case 8:
          u = St;
          break;
        case 32:
          u = Wt;
          break;
        case 268435456:
          u = Xo;
          break;
        default:
          u = Wt;
      }
      return o = Xf.bind(null, n), u = Z(u, o), n.callbackPriority = l, n.callbackNode = u, l;
    }
    return o !== null && o !== null && de(o), n.callbackPriority = 2, n.callbackNode = null, 2;
  }
  function Xf(n, l) {
    if (Hn !== 0 && Hn !== 5)
      return n.callbackNode = null, n.callbackPriority = 0, null;
    var u = n.callbackNode;
    if (Fr() && n.callbackNode !== u)
      return null;
    var o = rt;
    return o = vn(
      n,
      n === Yt ? o : 0,
      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
    ), o === 0 ? null : (cv(n, o, l), jy(n, _e()), n.callbackNode != null && n.callbackNode === u ? Xf.bind(null, n) : null);
  }
  function Uc(n, l) {
    if (Fr()) return null;
    cv(n, l, !0);
  }
  function Qf() {
    xv(function() {
      (Ot & 6) !== 0 ? Z(
        et,
        Ph
      ) : By();
    });
  }
  function em() {
    if (Yi === 0) {
      var n = fo;
      n === 0 && (n = Ei, Ei <<= 1, (Ei & 261888) === 0 && (Ei = 256)), Yi = n;
    }
    return Yi;
  }
  function Cv(n) {
    return n == null || typeof n == "symbol" || typeof n == "boolean" ? null : typeof n == "function" ? n : Ul("" + n);
  }
  function wc(n, l) {
    var u = l.ownerDocument.createElement("input");
    return u.name = l.name, u.value = l.value, n.id && u.setAttribute("form", n.id), l.parentNode.insertBefore(u, l), n = new FormData(n), u.parentNode.removeChild(u), n;
  }
  function Zf(n, l, u, o, d) {
    if (l === "submit" && u && u.stateNode === d) {
      var p = Cv(
        (d[Sa] || null).action
      ), T = o.submitter;
      T && (l = (l = T[Sa] || null) ? Cv(l.formAction) : T.getAttribute("formAction"), l !== null && (p = l, T = null));
      var C = new $s(
        "action",
        "action",
        null,
        o,
        d
      );
      n.push({
        event: C,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (o.defaultPrevented) {
                if (Yi !== 0) {
                  var x = T ? wc(d, T) : new FormData(d);
                  Hr(
                    u,
                    {
                      pending: !0,
                      data: x,
                      method: d.method,
                      action: p
                    },
                    null,
                    x
                  );
                }
              } else
                typeof p == "function" && (C.preventDefault(), x = T ? wc(d, T) : new FormData(d), Hr(
                  u,
                  {
                    pending: !0,
                    data: x,
                    method: d.method,
                    action: p
                  },
                  p,
                  x
                ));
            },
            currentTarget: d
          }
        ]
      });
    }
  }
  for (var tm = 0; tm < Sr.length; tm++) {
    var Ir = Sr[tm], qy = Ir.toLowerCase(), Vy = Ir[0].toUpperCase() + Ir.slice(1);
    Ta(
      qy,
      "on" + Vy
    );
  }
  Ta(ef, "onAnimationEnd"), Ta(Mp, "onAnimationIteration"), Ta(th, "onAnimationStart"), Ta("dblclick", "onDoubleClick"), Ta("focusin", "onFocus"), Ta("focusout", "onBlur"), Ta(ic, "onTransitionRun"), Ta(tf, "onTransitionStart"), Ta(xu, "onTransitionCancel"), Ta(j0, "onTransitionEnd"), _u("onMouseEnter", ["mouseout", "mouseover"]), _u("onMouseLeave", ["mouseout", "mouseover"]), _u("onPointerEnter", ["pointerout", "pointerover"]), _u("onPointerLeave", ["pointerout", "pointerover"]), no(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), no(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), no("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), no(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), no(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), no(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Pr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), zv = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Pr)
  );
  function _v(n, l) {
    l = (l & 4) !== 0;
    for (var u = 0; u < n.length; u++) {
      var o = n[u], d = o.event;
      o = o.listeners;
      e: {
        var p = void 0;
        if (l)
          for (var T = o.length - 1; 0 <= T; T--) {
            var C = o[T], x = C.instance, K = C.currentTarget;
            if (C = C.listener, x !== p && d.isPropagationStopped())
              break e;
            p = C, d.currentTarget = K;
            try {
              p(d);
            } catch (le) {
              oc(le);
            }
            d.currentTarget = null, p = x;
          }
        else
          for (T = 0; T < o.length; T++) {
            if (C = o[T], x = C.instance, K = C.currentTarget, C = C.listener, x !== p && d.isPropagationStopped())
              break e;
            p = C, d.currentTarget = K;
            try {
              p(d);
            } catch (le) {
              oc(le);
            }
            d.currentTarget = null, p = x;
          }
      }
    }
  }
  function dt(n, l) {
    var u = l[xd];
    u === void 0 && (u = l[xd] = /* @__PURE__ */ new Set());
    var o = n + "__bubble";
    u.has(o) || (Jf(l, n, 2, !1), u.add(o));
  }
  function Yy(n, l, u) {
    var o = 0;
    l && (o |= 4), Jf(
      u,
      n,
      o,
      l
    );
  }
  var nm = "_reactListening" + Math.random().toString(36).slice(2);
  function es(n) {
    if (!n[nm]) {
      n[nm] = !0, $o.forEach(function(u) {
        u !== "selectionchange" && (zv.has(u) || Yy(u, !1, n), Yy(u, !0, n));
      });
      var l = n.nodeType === 9 ? n : n.ownerDocument;
      l === null || l[nm] || (l[nm] = !0, Yy("selectionchange", !1, l));
    }
  }
  function Jf(n, l, u, o) {
    switch (td(l)) {
      case 2:
        var d = ni;
        break;
      case 8:
        d = ai;
        break;
      default:
        d = ua;
    }
    u = d.bind(
      null,
      l,
      u,
      n
    ), d = void 0, !Ks || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (d = !0), o ? d !== void 0 ? n.addEventListener(l, u, {
      capture: !0,
      passive: d
    }) : n.addEventListener(l, u, !0) : d !== void 0 ? n.addEventListener(l, u, {
      passive: d
    }) : n.addEventListener(l, u, !1);
  }
  function Gy(n, l, u, o, d) {
    var p = o;
    if ((l & 1) === 0 && (l & 2) === 0 && o !== null)
      e: for (; ; ) {
        if (o === null) return;
        var T = o.tag;
        if (T === 3 || T === 4) {
          var C = o.stateNode.containerInfo;
          if (C === d) break;
          if (T === 4)
            for (T = o.return; T !== null; ) {
              var x = T.tag;
              if ((x === 3 || x === 4) && T.stateNode.containerInfo === d)
                return;
              T = T.return;
            }
          for (; C !== null; ) {
            if (T = Jo(C), T === null) return;
            if (x = T.tag, x === 5 || x === 6 || x === 26 || x === 27) {
              o = p = T;
              continue e;
            }
            C = C.parentNode;
          }
        }
        o = o.return;
      }
    mp(function() {
      var K = p, le = Gd(u), re = [];
      e: {
        var k = Hu.get(n);
        if (k !== void 0) {
          var P = $s, Ue = n;
          switch (n) {
            case "keypress":
              if (Qd(u) === 0) break e;
            case "keydown":
            case "keyup":
              P = kd;
              break;
            case "focusin":
              Ue = "focus", P = Jd;
              break;
            case "focusout":
              Ue = "blur", P = Jd;
              break;
            case "beforeblur":
            case "afterblur":
              P = Jd;
              break;
            case "click":
              if (u.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              P = pr;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              P = R0;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              P = w0;
              break;
            case ef:
            case Mp:
            case th:
              P = z0;
              break;
            case j0:
              P = _b;
              break;
            case "scroll":
            case "scrollend":
              P = Cb;
              break;
            case "wheel":
              P = Ub;
              break;
            case "copy":
            case "cut":
            case "paste":
              P = Po;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              P = nu;
              break;
            case "toggle":
            case "beforetoggle":
              P = Ap;
          }
          var Ye = (l & 4) !== 0, Xt = !Ye && (n === "scroll" || n === "scrollend"), X = Ye ? k !== null ? k + "Capture" : null : k;
          Ye = [];
          for (var q = K, J; q !== null; ) {
            var ce = q;
            if (J = ce.stateNode, ce = ce.tag, ce !== 5 && ce !== 26 && ce !== 27 || J === null || X === null || (ce = Yn(q, X), ce != null && Ye.push(
              Kf(q, ce, J)
            )), Xt) break;
            q = q.return;
          }
          0 < Ye.length && (k = new P(
            k,
            Ue,
            null,
            u,
            le
          ), re.push({ event: k, listeners: Ye }));
        }
      }
      if ((l & 7) === 0) {
        e: {
          if (k = n === "mouseover" || n === "pointerover", P = n === "mouseout" || n === "pointerout", k && u !== Yd && (Ue = u.relatedTarget || u.fromElement) && (Jo(Ue) || Ue[eo]))
            break e;
          if ((P || k) && (k = le.window === le ? le : (k = le.ownerDocument) ? k.defaultView || k.parentWindow : window, P ? (Ue = u.relatedTarget || u.toElement, P = K, Ue = Ue ? Jo(Ue) : null, Ue !== null && (Xt = g(Ue), Ye = Ue.tag, Ue !== Xt || Ye !== 5 && Ye !== 27 && Ye !== 6) && (Ue = null)) : (P = null, Ue = K), P !== Ue)) {
            if (Ye = pr, ce = "onMouseLeave", X = "onMouseEnter", q = "mouse", (n === "pointerout" || n === "pointerover") && (Ye = nu, ce = "onPointerLeave", X = "onPointerEnter", q = "pointer"), Xt = P == null ? k : or(P), J = Ue == null ? k : or(Ue), k = new Ye(
              ce,
              q + "leave",
              P,
              u,
              le
            ), k.target = Xt, k.relatedTarget = J, ce = null, Jo(le) === K && (Ye = new Ye(
              X,
              q + "enter",
              Ue,
              u,
              le
            ), Ye.target = J, Ye.relatedTarget = Xt, ce = Ye), Xt = ce, P && Ue)
              t: {
                for (Ye = Uv, X = P, q = Ue, J = 0, ce = X; ce; ce = Ye(ce))
                  J++;
                ce = 0;
                for (var je = q; je; je = Ye(je))
                  ce++;
                for (; 0 < J - ce; )
                  X = Ye(X), J--;
                for (; 0 < ce - J; )
                  q = Ye(q), ce--;
                for (; J--; ) {
                  if (X === q || q !== null && X === q.alternate) {
                    Ye = X;
                    break t;
                  }
                  X = Ye(X), q = Ye(q);
                }
                Ye = null;
              }
            else Ye = null;
            P !== null && am(
              re,
              k,
              P,
              Ye,
              !1
            ), Ue !== null && Xt !== null && am(
              re,
              Xt,
              Ue,
              Ye,
              !0
            );
          }
        }
        e: {
          if (k = K ? or(K) : window, P = k.nodeName && k.nodeName.toLowerCase(), P === "select" || P === "input" && k.type === "file")
            var Et = zp;
          else if (Nu(k))
            if (Wd)
              Et = lc;
            else {
              Et = L0;
              var Ne = H0;
            }
          else
            P = k.nodeName, !P || P.toLowerCase() !== "input" || k.type !== "checkbox" && k.type !== "radio" ? K && hp(K.elementType) && (Et = zp) : Et = io;
          if (Et && (Et = Et(n, K))) {
            Cp(
              re,
              Et,
              u,
              le
            );
            break e;
          }
          Ne && Ne(n, k, K), n === "focusout" && K && k.type === "number" && K.memoizedProps.value != null && Fo(k, "number", k.value);
        }
        switch (Ne = K ? or(K) : window, n) {
          case "focusin":
            (Nu(Ne) || Ne.contentEditable === "true") && (co = Ne, vr = K, Nl = null);
            break;
          case "focusout":
            Nl = vr = co = null;
            break;
          case "mousedown":
            lu = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            lu = !1, eh(re, u, le);
            break;
          case "selectionchange":
            if (Ps) break;
          case "keydown":
          case "keyup":
            eh(re, u, le);
        }
        var Ie;
        if (yr)
          e: {
            switch (n) {
              case "compositionstart":
                var at = "onCompositionStart";
                break e;
              case "compositionend":
                at = "onCompositionEnd";
                break e;
              case "compositionupdate":
                at = "onCompositionUpdate";
                break e;
            }
            at = void 0;
          }
        else
          tc ? Fd(n, u) && (at = "onCompositionEnd") : n === "keydown" && u.keyCode === 229 && (at = "onCompositionStart");
        at && (Op && u.locale !== "ko" && (tc || at !== "onCompositionStart" ? at === "onCompositionEnd" && tc && (Ie = yp()) : (Oi = le, pp = "value" in Oi ? Oi.value : Oi.textContent, tc = !0)), Ne = kf(K, at), 0 < Ne.length && (at = new _0(
          at,
          n,
          null,
          u,
          le
        ), re.push({ event: at, listeners: Ne }), Ie ? at.data = Ie : (Ie = Dp(u), Ie !== null && (at.data = Ie)))), (Ie = ra ? x0(n, u) : wb(n, u)) && (at = kf(K, "onBeforeInput"), 0 < at.length && (Ne = new _0(
          "onBeforeInput",
          "beforeinput",
          null,
          u,
          le
        ), re.push({
          event: Ne,
          listeners: at
        }), Ne.data = Ie)), Zf(
          re,
          n,
          K,
          u,
          le
        );
      }
      _v(re, l);
    });
  }
  function Kf(n, l, u) {
    return {
      instance: n,
      listener: l,
      currentTarget: u
    };
  }
  function kf(n, l) {
    for (var u = l + "Capture", o = []; n !== null; ) {
      var d = n, p = d.stateNode;
      if (d = d.tag, d !== 5 && d !== 26 && d !== 27 || p === null || (d = Yn(n, u), d != null && o.unshift(
        Kf(n, d, p)
      ), d = Yn(n, l), d != null && o.push(
        Kf(n, d, p)
      )), n.tag === 3) return o;
      n = n.return;
    }
    return [];
  }
  function Uv(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5 && n.tag !== 27);
    return n || null;
  }
  function am(n, l, u, o, d) {
    for (var p = l._reactName, T = []; u !== null && u !== o; ) {
      var C = u, x = C.alternate, K = C.stateNode;
      if (C = C.tag, x !== null && x === o) break;
      C !== 5 && C !== 26 && C !== 27 || K === null || (x = K, d ? (K = Yn(u, p), K != null && T.unshift(
        Kf(u, K, x)
      )) : d || (K = Yn(u, p), K != null && T.push(
        Kf(u, K, x)
      ))), u = u.return;
    }
    T.length !== 0 && n.push({ event: l, listeners: T });
  }
  var wv = /\r\n?/g, Xy = /\u0000|\uFFFD/g;
  function Qy(n) {
    return (typeof n == "string" ? n : "" + n).replace(wv, `
`).replace(Xy, "");
  }
  function Zy(n, l) {
    return l = Qy(l), Qy(n) === l;
  }
  function Gt(n, l, u, o, d, p) {
    switch (u) {
      case "children":
        typeof o == "string" ? l === "body" || l === "textarea" && o === "" || Uu(n, o) : (typeof o == "number" || typeof o == "bigint") && l !== "body" && Uu(n, "" + o);
        break;
      case "className":
        jd(n, "class", o);
        break;
      case "tabIndex":
        jd(n, "tabindex", o);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        jd(n, u, o);
        break;
      case "style":
        A0(n, o, p);
        break;
      case "data":
        if (l !== "object") {
          jd(n, "data", o);
          break;
        }
      case "src":
      case "href":
        if (o === "" && (l !== "a" || u !== "href")) {
          n.removeAttribute(u);
          break;
        }
        if (o == null || typeof o == "function" || typeof o == "symbol" || typeof o == "boolean") {
          n.removeAttribute(u);
          break;
        }
        o = Ul("" + o), n.setAttribute(u, o);
        break;
      case "action":
      case "formAction":
        if (typeof o == "function") {
          n.setAttribute(
            u,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof p == "function" && (u === "formAction" ? (l !== "input" && Gt(n, l, "name", d.name, d, null), Gt(
            n,
            l,
            "formEncType",
            d.formEncType,
            d,
            null
          ), Gt(
            n,
            l,
            "formMethod",
            d.formMethod,
            d,
            null
          ), Gt(
            n,
            l,
            "formTarget",
            d.formTarget,
            d,
            null
          )) : (Gt(n, l, "encType", d.encType, d, null), Gt(n, l, "method", d.method, d, null), Gt(n, l, "target", d.target, d, null)));
        if (o == null || typeof o == "symbol" || typeof o == "boolean") {
          n.removeAttribute(u);
          break;
        }
        o = Ul("" + o), n.setAttribute(u, o);
        break;
      case "onClick":
        o != null && (n.onclick = Pl);
        break;
      case "onScroll":
        o != null && dt("scroll", n);
        break;
      case "onScrollEnd":
        o != null && dt("scrollend", n);
        break;
      case "dangerouslySetInnerHTML":
        if (o != null) {
          if (typeof o != "object" || !("__html" in o))
            throw Error(h(61));
          if (u = o.__html, u != null) {
            if (d.children != null) throw Error(h(60));
            n.innerHTML = u;
          }
        }
        break;
      case "multiple":
        n.multiple = o && typeof o != "function" && typeof o != "symbol";
        break;
      case "muted":
        n.muted = o && typeof o != "function" && typeof o != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (o == null || typeof o == "function" || typeof o == "boolean" || typeof o == "symbol") {
          n.removeAttribute("xlink:href");
          break;
        }
        u = Ul("" + o), n.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          u
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        o != null && typeof o != "function" && typeof o != "symbol" ? n.setAttribute(u, "" + o) : n.removeAttribute(u);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        o && typeof o != "function" && typeof o != "symbol" ? n.setAttribute(u, "") : n.removeAttribute(u);
        break;
      case "capture":
      case "download":
        o === !0 ? n.setAttribute(u, "") : o !== !1 && o != null && typeof o != "function" && typeof o != "symbol" ? n.setAttribute(u, o) : n.removeAttribute(u);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        o != null && typeof o != "function" && typeof o != "symbol" && !isNaN(o) && 1 <= o ? n.setAttribute(u, o) : n.removeAttribute(u);
        break;
      case "rowSpan":
      case "start":
        o == null || typeof o == "function" || typeof o == "symbol" || isNaN(o) ? n.removeAttribute(u) : n.setAttribute(u, o);
        break;
      case "popover":
        dt("beforetoggle", n), dt("toggle", n), sr(n, "popover", o);
        break;
      case "xlinkActuate":
        Ti(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          o
        );
        break;
      case "xlinkArcrole":
        Ti(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          o
        );
        break;
      case "xlinkRole":
        Ti(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          o
        );
        break;
      case "xlinkShow":
        Ti(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          o
        );
        break;
      case "xlinkTitle":
        Ti(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          o
        );
        break;
      case "xlinkType":
        Ti(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          o
        );
        break;
      case "xmlBase":
        Ti(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          o
        );
        break;
      case "xmlLang":
        Ti(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          o
        );
        break;
      case "xmlSpace":
        Ti(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          o
        );
        break;
      case "is":
        sr(n, "is", o);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < u.length) || u[0] !== "o" && u[0] !== "O" || u[1] !== "n" && u[1] !== "N") && (u = Rb.get(u) || u, sr(n, u, o));
    }
  }
  function Jy(n, l, u, o, d, p) {
    switch (u) {
      case "style":
        A0(n, o, p);
        break;
      case "dangerouslySetInnerHTML":
        if (o != null) {
          if (typeof o != "object" || !("__html" in o))
            throw Error(h(61));
          if (u = o.__html, u != null) {
            if (d.children != null) throw Error(h(60));
            n.innerHTML = u;
          }
        }
        break;
      case "children":
        typeof o == "string" ? Uu(n, o) : (typeof o == "number" || typeof o == "bigint") && Uu(n, "" + o);
        break;
      case "onScroll":
        o != null && dt("scroll", n);
        break;
      case "onScrollEnd":
        o != null && dt("scrollend", n);
        break;
      case "onClick":
        o != null && (n.onclick = Pl);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!to.hasOwnProperty(u))
          e: {
            if (u[0] === "o" && u[1] === "n" && (d = u.endsWith("Capture"), l = u.slice(2, d ? u.length - 7 : void 0), p = n[Sa] || null, p = p != null ? p[u] : null, typeof p == "function" && n.removeEventListener(l, p, d), typeof o == "function")) {
              typeof p != "function" && p !== null && (u in n ? n[u] = null : n.hasAttribute(u) && n.removeAttribute(u)), n.addEventListener(l, o, d);
              break e;
            }
            u in n ? n[u] = o : o === !0 ? n.setAttribute(u, "") : sr(n, u, o);
          }
    }
  }
  function la(n, l, u) {
    switch (l) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        dt("error", n), dt("load", n);
        var o = !1, d = !1, p;
        for (p in u)
          if (u.hasOwnProperty(p)) {
            var T = u[p];
            if (T != null)
              switch (p) {
                case "src":
                  o = !0;
                  break;
                case "srcSet":
                  d = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(h(137, l));
                default:
                  Gt(n, l, p, T, u, null);
              }
          }
        d && Gt(n, l, "srcSet", u.srcSet, u, null), o && Gt(n, l, "src", u.src, u, null);
        return;
      case "input":
        dt("invalid", n);
        var C = p = T = d = null, x = null, K = null;
        for (o in u)
          if (u.hasOwnProperty(o)) {
            var le = u[o];
            if (le != null)
              switch (o) {
                case "name":
                  d = le;
                  break;
                case "type":
                  T = le;
                  break;
                case "checked":
                  x = le;
                  break;
                case "defaultChecked":
                  K = le;
                  break;
                case "value":
                  p = le;
                  break;
                case "defaultValue":
                  C = le;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (le != null)
                    throw Error(h(137, l));
                  break;
                default:
                  Gt(n, l, o, le, u, null);
              }
          }
        Qs(
          n,
          p,
          C,
          x,
          K,
          T,
          d,
          !1
        );
        return;
      case "select":
        dt("invalid", n), o = T = p = null;
        for (d in u)
          if (u.hasOwnProperty(d) && (C = u[d], C != null))
            switch (d) {
              case "value":
                p = C;
                break;
              case "defaultValue":
                T = C;
                break;
              case "multiple":
                o = C;
              default:
                Gt(n, l, d, C, u, null);
            }
        l = p, u = T, n.multiple = !!o, l != null ? fr(n, !!o, l, !1) : u != null && fr(n, !!o, u, !0);
        return;
      case "textarea":
        dt("invalid", n), p = d = o = null;
        for (T in u)
          if (u.hasOwnProperty(T) && (C = u[T], C != null))
            switch (T) {
              case "value":
                o = C;
                break;
              case "defaultValue":
                d = C;
                break;
              case "children":
                p = C;
                break;
              case "dangerouslySetInnerHTML":
                if (C != null) throw Error(h(91));
                break;
              default:
                Gt(n, l, T, C, u, null);
            }
        dp(n, o, d, p);
        return;
      case "option":
        for (x in u)
          if (u.hasOwnProperty(x) && (o = u[x], o != null))
            switch (x) {
              case "selected":
                n.selected = o && typeof o != "function" && typeof o != "symbol";
                break;
              default:
                Gt(n, l, x, o, u, null);
            }
        return;
      case "dialog":
        dt("beforetoggle", n), dt("toggle", n), dt("cancel", n), dt("close", n);
        break;
      case "iframe":
      case "object":
        dt("load", n);
        break;
      case "video":
      case "audio":
        for (o = 0; o < Pr.length; o++)
          dt(Pr[o], n);
        break;
      case "image":
        dt("error", n), dt("load", n);
        break;
      case "details":
        dt("toggle", n);
        break;
      case "embed":
      case "source":
      case "link":
        dt("error", n), dt("load", n);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (K in u)
          if (u.hasOwnProperty(K) && (o = u[K], o != null))
            switch (K) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(h(137, l));
              default:
                Gt(n, l, K, o, u, null);
            }
        return;
      default:
        if (hp(l)) {
          for (le in u)
            u.hasOwnProperty(le) && (o = u[le], o !== void 0 && Jy(
              n,
              l,
              le,
              o,
              u,
              void 0
            ));
          return;
        }
    }
    for (C in u)
      u.hasOwnProperty(C) && (o = u[C], o != null && Gt(n, l, C, o, u, null));
  }
  function Ky(n, l, u, o) {
    switch (l) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var d = null, p = null, T = null, C = null, x = null, K = null, le = null;
        for (P in u) {
          var re = u[P];
          if (u.hasOwnProperty(P) && re != null)
            switch (P) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                x = re;
              default:
                o.hasOwnProperty(P) || Gt(n, l, P, null, o, re);
            }
        }
        for (var k in o) {
          var P = o[k];
          if (re = u[k], o.hasOwnProperty(k) && (P != null || re != null))
            switch (k) {
              case "type":
                p = P;
                break;
              case "name":
                d = P;
                break;
              case "checked":
                K = P;
                break;
              case "defaultChecked":
                le = P;
                break;
              case "value":
                T = P;
                break;
              case "defaultValue":
                C = P;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (P != null)
                  throw Error(h(137, l));
                break;
              default:
                P !== re && Gt(
                  n,
                  l,
                  k,
                  P,
                  o,
                  re
                );
            }
        }
        Xs(
          n,
          T,
          C,
          x,
          K,
          le,
          p,
          d
        );
        return;
      case "select":
        P = T = C = k = null;
        for (p in u)
          if (x = u[p], u.hasOwnProperty(p) && x != null)
            switch (p) {
              case "value":
                break;
              case "multiple":
                P = x;
              default:
                o.hasOwnProperty(p) || Gt(
                  n,
                  l,
                  p,
                  null,
                  o,
                  x
                );
            }
        for (d in o)
          if (p = o[d], x = u[d], o.hasOwnProperty(d) && (p != null || x != null))
            switch (d) {
              case "value":
                k = p;
                break;
              case "defaultValue":
                C = p;
                break;
              case "multiple":
                T = p;
              default:
                p !== x && Gt(
                  n,
                  l,
                  d,
                  p,
                  o,
                  x
                );
            }
        l = C, u = T, o = P, k != null ? fr(n, !!u, k, !1) : !!o != !!u && (l != null ? fr(n, !!u, l, !0) : fr(n, !!u, u ? [] : "", !1));
        return;
      case "textarea":
        P = k = null;
        for (C in u)
          if (d = u[C], u.hasOwnProperty(C) && d != null && !o.hasOwnProperty(C))
            switch (C) {
              case "value":
                break;
              case "children":
                break;
              default:
                Gt(n, l, C, null, o, d);
            }
        for (T in o)
          if (d = o[T], p = u[T], o.hasOwnProperty(T) && (d != null || p != null))
            switch (T) {
              case "value":
                k = d;
                break;
              case "defaultValue":
                P = d;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (d != null) throw Error(h(91));
                break;
              default:
                d !== p && Gt(n, l, T, d, o, p);
            }
        fp(n, k, P);
        return;
      case "option":
        for (var Ue in u)
          if (k = u[Ue], u.hasOwnProperty(Ue) && k != null && !o.hasOwnProperty(Ue))
            switch (Ue) {
              case "selected":
                n.selected = !1;
                break;
              default:
                Gt(
                  n,
                  l,
                  Ue,
                  null,
                  o,
                  k
                );
            }
        for (x in o)
          if (k = o[x], P = u[x], o.hasOwnProperty(x) && k !== P && (k != null || P != null))
            switch (x) {
              case "selected":
                n.selected = k && typeof k != "function" && typeof k != "symbol";
                break;
              default:
                Gt(
                  n,
                  l,
                  x,
                  k,
                  o,
                  P
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Ye in u)
          k = u[Ye], u.hasOwnProperty(Ye) && k != null && !o.hasOwnProperty(Ye) && Gt(n, l, Ye, null, o, k);
        for (K in o)
          if (k = o[K], P = u[K], o.hasOwnProperty(K) && k !== P && (k != null || P != null))
            switch (K) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (k != null)
                  throw Error(h(137, l));
                break;
              default:
                Gt(
                  n,
                  l,
                  K,
                  k,
                  o,
                  P
                );
            }
        return;
      default:
        if (hp(l)) {
          for (var Xt in u)
            k = u[Xt], u.hasOwnProperty(Xt) && k !== void 0 && !o.hasOwnProperty(Xt) && Jy(
              n,
              l,
              Xt,
              void 0,
              o,
              k
            );
          for (le in o)
            k = o[le], P = u[le], !o.hasOwnProperty(le) || k === P || k === void 0 && P === void 0 || Jy(
              n,
              l,
              le,
              k,
              o,
              P
            );
          return;
        }
    }
    for (var X in u)
      k = u[X], u.hasOwnProperty(X) && k != null && !o.hasOwnProperty(X) && Gt(n, l, X, null, o, k);
    for (re in o)
      k = o[re], P = u[re], !o.hasOwnProperty(re) || k === P || k == null && P == null || Gt(n, l, re, k, o, P);
  }
  function lm(n) {
    switch (n) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function ky() {
    if (typeof performance.getEntriesByType == "function") {
      for (var n = 0, l = 0, u = performance.getEntriesByType("resource"), o = 0; o < u.length; o++) {
        var d = u[o], p = d.transferSize, T = d.initiatorType, C = d.duration;
        if (p && C && lm(T)) {
          for (T = 0, C = d.responseEnd, o += 1; o < u.length; o++) {
            var x = u[o], K = x.startTime;
            if (K > C) break;
            var le = x.transferSize, re = x.initiatorType;
            le && lm(re) && (x = x.responseEnd, T += le * (x < C ? 1 : (C - K) / (x - K)));
          }
          if (--o, l += 8 * (p + T) / (d.duration / 1e3), n++, 10 < n) break;
        }
      }
      if (0 < n) return l / n / 1e6;
    }
    return navigator.connection && (n = navigator.connection.downlink, typeof n == "number") ? n : 5;
  }
  var um = null, im = null;
  function wo(n) {
    return n.nodeType === 9 ? n : n.ownerDocument;
  }
  function Mv(n) {
    switch (n) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function $y(n, l) {
    if (n === 0)
      switch (l) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return n === 1 && l === "foreignObject" ? 0 : n;
  }
  function ts(n, l) {
    return n === "textarea" || n === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.children == "bigint" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
  }
  var om = null;
  function Hb() {
    var n = window.event;
    return n && n.type === "popstate" ? n === om ? !1 : (om = n, !0) : (om = null, !1);
  }
  var $f = typeof setTimeout == "function" ? setTimeout : void 0, Nv = typeof clearTimeout == "function" ? clearTimeout : void 0, Mc = typeof Promise == "function" ? Promise : void 0, xv = typeof queueMicrotask == "function" ? queueMicrotask : typeof Mc < "u" ? function(n) {
    return Mc.resolve(null).then(n).catch(Fy);
  } : $f;
  function Fy(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function vu(n) {
    return n === "head";
  }
  function Wy(n, l) {
    var u = l, o = 0;
    do {
      var d = u.nextSibling;
      if (n.removeChild(u), d && d.nodeType === 8)
        if (u = d.data, u === "/$" || u === "/&") {
          if (o === 0) {
            n.removeChild(d), hs(l);
            return;
          }
          o--;
        } else if (u === "$" || u === "$?" || u === "$~" || u === "$!" || u === "&")
          o++;
        else if (u === "html")
          Nc(n.ownerDocument.documentElement);
        else if (u === "head") {
          u = n.ownerDocument.head, Nc(u);
          for (var p = u.firstChild; p; ) {
            var T = p.nextSibling, C = p.nodeName;
            p[zu] || C === "SCRIPT" || C === "STYLE" || C === "LINK" && p.rel.toLowerCase() === "stylesheet" || u.removeChild(p), p = T;
          }
        } else
          u === "body" && Nc(n.ownerDocument.body);
      u = d;
    } while (u);
    hs(l);
  }
  function An(n, l) {
    var u = n;
    n = 0;
    do {
      var o = u.nextSibling;
      if (u.nodeType === 1 ? l ? (u._stashedDisplay = u.style.display, u.style.display = "none") : (u.style.display = u._stashedDisplay || "", u.getAttribute("style") === "" && u.removeAttribute("style")) : u.nodeType === 3 && (l ? (u._stashedText = u.nodeValue, u.nodeValue = "") : u.nodeValue = u._stashedText || ""), o && o.nodeType === 8)
        if (u = o.data, u === "/$") {
          if (n === 0) break;
          n--;
        } else
          u !== "$" && u !== "$?" && u !== "$~" && u !== "$!" || n++;
      u = o;
    } while (u);
  }
  function Ff(n) {
    var l = n.firstChild;
    for (l && l.nodeType === 10 && (l = l.nextSibling); l; ) {
      var u = l;
      switch (l = l.nextSibling, u.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Ff(u), Hd(u);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (u.rel.toLowerCase() === "stylesheet") continue;
      }
      n.removeChild(u);
    }
  }
  function Lb(n, l, u, o) {
    for (; n.nodeType === 1; ) {
      var d = u;
      if (n.nodeName.toLowerCase() !== l.toLowerCase()) {
        if (!o && (n.nodeName !== "INPUT" || n.type !== "hidden"))
          break;
      } else if (o) {
        if (!n[zu])
          switch (l) {
            case "meta":
              if (!n.hasAttribute("itemprop")) break;
              return n;
            case "link":
              if (p = n.getAttribute("rel"), p === "stylesheet" && n.hasAttribute("data-precedence"))
                break;
              if (p !== d.rel || n.getAttribute("href") !== (d.href == null || d.href === "" ? null : d.href) || n.getAttribute("crossorigin") !== (d.crossOrigin == null ? null : d.crossOrigin) || n.getAttribute("title") !== (d.title == null ? null : d.title))
                break;
              return n;
            case "style":
              if (n.hasAttribute("data-precedence")) break;
              return n;
            case "script":
              if (p = n.getAttribute("src"), (p !== (d.src == null ? null : d.src) || n.getAttribute("type") !== (d.type == null ? null : d.type) || n.getAttribute("crossorigin") !== (d.crossOrigin == null ? null : d.crossOrigin)) && p && n.hasAttribute("async") && !n.hasAttribute("itemprop"))
                break;
              return n;
            default:
              return n;
          }
      } else if (l === "input" && n.type === "hidden") {
        var p = d.name == null ? null : "" + d.name;
        if (d.type === "hidden" && n.getAttribute("name") === p)
          return n;
      } else return n;
      if (n = xa(n.nextSibling), n === null) break;
    }
    return null;
  }
  function ut(n, l, u) {
    if (l === "") return null;
    for (; n.nodeType !== 3; )
      if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !u || (n = xa(n.nextSibling), n === null)) return null;
    return n;
  }
  function Hv(n, l) {
    for (; n.nodeType !== 8; )
      if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !l || (n = xa(n.nextSibling), n === null)) return null;
    return n;
  }
  function Yl(n) {
    return n.data === "$?" || n.data === "$~";
  }
  function Mo(n) {
    return n.data === "$!" || n.data === "$?" && n.ownerDocument.readyState !== "loading";
  }
  function ns(n, l) {
    var u = n.ownerDocument;
    if (n.data === "$~") n._reactRetry = l;
    else if (n.data !== "$?" || u.readyState !== "loading")
      l();
    else {
      var o = function() {
        l(), u.removeEventListener("DOMContentLoaded", o);
      };
      u.addEventListener("DOMContentLoaded", o), n._reactRetry = o;
    }
  }
  function xa(n) {
    for (; n != null; n = n.nextSibling) {
      var l = n.nodeType;
      if (l === 1 || l === 3) break;
      if (l === 8) {
        if (l = n.data, l === "$" || l === "$!" || l === "$?" || l === "$~" || l === "&" || l === "F!" || l === "F")
          break;
        if (l === "/$" || l === "/&") return null;
      }
    }
    return n;
  }
  var Wf = null;
  function cm(n) {
    n = n.nextSibling;
    for (var l = 0; n; ) {
      if (n.nodeType === 8) {
        var u = n.data;
        if (u === "/$" || u === "/&") {
          if (l === 0)
            return xa(n.nextSibling);
          l--;
        } else
          u !== "$" && u !== "$!" && u !== "$?" && u !== "$~" && u !== "&" || l++;
      }
      n = n.nextSibling;
    }
    return null;
  }
  function bu(n) {
    n = n.previousSibling;
    for (var l = 0; n; ) {
      if (n.nodeType === 8) {
        var u = n.data;
        if (u === "$" || u === "$!" || u === "$?" || u === "$~" || u === "&") {
          if (l === 0) return n;
          l--;
        } else u !== "/$" && u !== "/&" || l++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  function as(n, l, u) {
    switch (l = wo(u), n) {
      case "html":
        if (n = l.documentElement, !n) throw Error(h(452));
        return n;
      case "head":
        if (n = l.head, !n) throw Error(h(453));
        return n;
      case "body":
        if (n = l.body, !n) throw Error(h(454));
        return n;
      default:
        throw Error(h(451));
    }
  }
  function Nc(n) {
    for (var l = n.attributes; l.length; )
      n.removeAttributeNode(l[0]);
    Hd(n);
  }
  var Ka = /* @__PURE__ */ new Map(), If = /* @__PURE__ */ new Set();
  function da(n) {
    return typeof n.getRootNode == "function" ? n.getRootNode() : n.nodeType === 9 ? n : n.ownerDocument;
  }
  var Su = ue.d;
  ue.d = {
    f: Bb,
    r: Lv,
    D: I,
    C: _t,
    L: jb,
    m: Iy,
    X: Xi,
    S: Py,
    M: No
  };
  function Bb() {
    var n = Su.f(), l = kr();
    return n || l;
  }
  function Lv(n) {
    var l = Ko(n);
    l !== null && l.tag === 5 && l.type === "form" ? Vt(l) : Su.r(n);
  }
  var ls = typeof document > "u" ? null : document;
  function _n(n, l, u) {
    var o = ls;
    if (o && typeof l == "string" && l) {
      var d = ll(l);
      d = 'link[rel="' + n + '"][href="' + d + '"]', typeof u == "string" && (d += '[crossorigin="' + u + '"]'), If.has(d) || (If.add(d), n = { rel: n, crossOrigin: u, href: l }, o.querySelector(d) === null && (l = o.createElement("link"), la(l, "link", n), Mt(l), o.head.appendChild(l)));
    }
  }
  function I(n) {
    Su.D(n), _n("dns-prefetch", n, null);
  }
  function _t(n, l) {
    Su.C(n, l), _n("preconnect", n, l);
  }
  function jb(n, l, u) {
    Su.L(n, l, u);
    var o = ls;
    if (o && n && l) {
      var d = 'link[rel="preload"][as="' + ll(l) + '"]';
      l === "image" && u && u.imageSrcSet ? (d += '[imagesrcset="' + ll(
        u.imageSrcSet
      ) + '"]', typeof u.imageSizes == "string" && (d += '[imagesizes="' + ll(
        u.imageSizes
      ) + '"]')) : d += '[href="' + ll(n) + '"]';
      var p = d;
      switch (l) {
        case "style":
          p = vl(n);
          break;
        case "script":
          p = xc(n);
      }
      Ka.has(p) || (n = z(
        {
          rel: "preload",
          href: l === "image" && u && u.imageSrcSet ? void 0 : n,
          as: l
        },
        u
      ), Ka.set(p, n), o.querySelector(d) !== null || l === "style" && o.querySelector(xo(p)) || l === "script" && o.querySelector(os(p)) || (l = o.createElement("link"), la(l, "link", n), Mt(l), o.head.appendChild(l)));
    }
  }
  function Iy(n, l) {
    Su.m(n, l);
    var u = ls;
    if (u && n) {
      var o = l && typeof l.as == "string" ? l.as : "script", d = 'link[rel="modulepreload"][as="' + ll(o) + '"][href="' + ll(n) + '"]', p = d;
      switch (o) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          p = xc(n);
      }
      if (!Ka.has(p) && (n = z({ rel: "modulepreload", href: n }, l), Ka.set(p, n), u.querySelector(d) === null)) {
        switch (o) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (u.querySelector(os(p)))
              return;
        }
        o = u.createElement("link"), la(o, "link", n), Mt(o), u.head.appendChild(o);
      }
    }
  }
  function Py(n, l, u) {
    Su.S(n, l, u);
    var o = ls;
    if (o && n) {
      var d = ko(o).hoistableStyles, p = vl(n);
      l = l || "default";
      var T = d.get(p);
      if (!T) {
        var C = { loading: 0, preload: null };
        if (T = o.querySelector(
          xo(p)
        ))
          C.loading = 5;
        else {
          n = z(
            { rel: "stylesheet", href: n, "data-precedence": l },
            u
          ), (u = Ka.get(p)) && rm(n, u);
          var x = T = o.createElement("link");
          Mt(x), la(x, "link", n), x._p = new Promise(function(K, le) {
            x.onload = K, x.onerror = le;
          }), x.addEventListener("load", function() {
            C.loading |= 1;
          }), x.addEventListener("error", function() {
            C.loading |= 2;
          }), C.loading |= 4, Pf(T, l, o);
        }
        T = {
          type: "stylesheet",
          instance: T,
          count: 1,
          state: C
        }, d.set(p, T);
      }
    }
  }
  function Xi(n, l) {
    Su.X(n, l);
    var u = ls;
    if (u && n) {
      var o = ko(u).hoistableScripts, d = xc(n), p = o.get(d);
      p || (p = u.querySelector(os(d)), p || (n = z({ src: n, async: !0 }, l), (l = Ka.get(d)) && sm(n, l), p = u.createElement("script"), Mt(p), la(p, "link", n), u.head.appendChild(p)), p = {
        type: "script",
        instance: p,
        count: 1,
        state: null
      }, o.set(d, p));
    }
  }
  function No(n, l) {
    Su.M(n, l);
    var u = ls;
    if (u && n) {
      var o = ko(u).hoistableScripts, d = xc(n), p = o.get(d);
      p || (p = u.querySelector(os(d)), p || (n = z({ src: n, async: !0, type: "module" }, l), (l = Ka.get(d)) && sm(n, l), p = u.createElement("script"), Mt(p), la(p, "link", n), u.head.appendChild(p)), p = {
        type: "script",
        instance: p,
        count: 1,
        state: null
      }, o.set(d, p));
    }
  }
  function us(n, l, u, o) {
    var d = (d = Rn.current) ? da(d) : null;
    if (!d) throw Error(h(446));
    switch (n) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof u.precedence == "string" && typeof u.href == "string" ? (l = vl(u.href), u = ko(
          d
        ).hoistableStyles, o = u.get(l), o || (o = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, u.set(l, o)), o) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (u.rel === "stylesheet" && typeof u.href == "string" && typeof u.precedence == "string") {
          n = vl(u.href);
          var p = ko(
            d
          ).hoistableStyles, T = p.get(n);
          if (T || (d = d.ownerDocument || d, T = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, p.set(n, T), (p = d.querySelector(
            xo(n)
          )) && !p._p && (T.instance = p, T.state.loading = 5), Ka.has(n) || (u = {
            rel: "preload",
            as: "style",
            href: u.href,
            crossOrigin: u.crossOrigin,
            integrity: u.integrity,
            media: u.media,
            hrefLang: u.hrefLang,
            referrerPolicy: u.referrerPolicy
          }, Ka.set(n, u), p || Bv(
            d,
            n,
            u,
            T.state
          ))), l && o === null)
            throw Error(h(528, ""));
          return T;
        }
        if (l && o !== null)
          throw Error(h(529, ""));
        return null;
      case "script":
        return l = u.async, u = u.src, typeof u == "string" && l && typeof l != "function" && typeof l != "symbol" ? (l = xc(u), u = ko(
          d
        ).hoistableScripts, o = u.get(l), o || (o = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, u.set(l, o)), o) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(h(444, n));
    }
  }
  function vl(n) {
    return 'href="' + ll(n) + '"';
  }
  function xo(n) {
    return 'link[rel="stylesheet"][' + n + "]";
  }
  function is(n) {
    return z({}, n, {
      "data-precedence": n.precedence,
      precedence: null
    });
  }
  function Bv(n, l, u, o) {
    n.querySelector('link[rel="preload"][as="style"][' + l + "]") ? o.loading = 1 : (l = n.createElement("link"), o.preload = l, l.addEventListener("load", function() {
      return o.loading |= 1;
    }), l.addEventListener("error", function() {
      return o.loading |= 2;
    }), la(l, "link", u), Mt(l), n.head.appendChild(l));
  }
  function xc(n) {
    return '[src="' + ll(n) + '"]';
  }
  function os(n) {
    return "script[async]" + n;
  }
  function eg(n, l, u) {
    if (l.count++, l.instance === null)
      switch (l.type) {
        case "style":
          var o = n.querySelector(
            'style[data-href~="' + ll(u.href) + '"]'
          );
          if (o)
            return l.instance = o, Mt(o), o;
          var d = z({}, u, {
            "data-href": u.href,
            "data-precedence": u.precedence,
            href: null,
            precedence: null
          });
          return o = (n.ownerDocument || n).createElement(
            "style"
          ), Mt(o), la(o, "style", d), Pf(o, u.precedence, n), l.instance = o;
        case "stylesheet":
          d = vl(u.href);
          var p = n.querySelector(
            xo(d)
          );
          if (p)
            return l.state.loading |= 4, l.instance = p, Mt(p), p;
          o = is(u), (d = Ka.get(d)) && rm(o, d), p = (n.ownerDocument || n).createElement("link"), Mt(p);
          var T = p;
          return T._p = new Promise(function(C, x) {
            T.onload = C, T.onerror = x;
          }), la(p, "link", o), l.state.loading |= 4, Pf(p, u.precedence, n), l.instance = p;
        case "script":
          return p = xc(u.src), (d = n.querySelector(
            os(p)
          )) ? (l.instance = d, Mt(d), d) : (o = u, (d = Ka.get(p)) && (o = z({}, u), sm(o, d)), n = n.ownerDocument || n, d = n.createElement("script"), Mt(d), la(d, "link", o), n.head.appendChild(d), l.instance = d);
        case "void":
          return null;
        default:
          throw Error(h(443, l.type));
      }
    else
      l.type === "stylesheet" && (l.state.loading & 4) === 0 && (o = l.instance, l.state.loading |= 4, Pf(o, u.precedence, n));
    return l.instance;
  }
  function Pf(n, l, u) {
    for (var o = u.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), d = o.length ? o[o.length - 1] : null, p = d, T = 0; T < o.length; T++) {
      var C = o[T];
      if (C.dataset.precedence === l) p = C;
      else if (p !== d) break;
    }
    p ? p.parentNode.insertBefore(n, p.nextSibling) : (l = u.nodeType === 9 ? u.head : u, l.insertBefore(n, l.firstChild));
  }
  function rm(n, l) {
    n.crossOrigin == null && (n.crossOrigin = l.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = l.referrerPolicy), n.title == null && (n.title = l.title);
  }
  function sm(n, l) {
    n.crossOrigin == null && (n.crossOrigin = l.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = l.referrerPolicy), n.integrity == null && (n.integrity = l.integrity);
  }
  var cs = null;
  function tg(n, l, u) {
    if (cs === null) {
      var o = /* @__PURE__ */ new Map(), d = cs = /* @__PURE__ */ new Map();
      d.set(u, o);
    } else
      d = cs, o = d.get(u), o || (o = /* @__PURE__ */ new Map(), d.set(u, o));
    if (o.has(n)) return o;
    for (o.set(n, null), u = u.getElementsByTagName(n), d = 0; d < u.length; d++) {
      var p = u[d];
      if (!(p[zu] || p[qt] || n === "link" && p.getAttribute("rel") === "stylesheet") && p.namespaceURI !== "http://www.w3.org/2000/svg") {
        var T = p.getAttribute(l) || "";
        T = n + T;
        var C = o.get(T);
        C ? C.push(p) : o.set(T, [p]);
      }
    }
    return o;
  }
  function fm(n, l, u) {
    n = n.ownerDocument || n, n.head.insertBefore(
      u,
      l === "title" ? n.querySelector("head > title") : null
    );
  }
  function ng(n, l, u) {
    if (u === 1 || l.itemProp != null) return !1;
    switch (n) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof l.precedence != "string" || typeof l.href != "string" || l.href === "")
          break;
        return !0;
      case "link":
        if (typeof l.rel != "string" || typeof l.href != "string" || l.href === "" || l.onLoad || l.onError)
          break;
        switch (l.rel) {
          case "stylesheet":
            return n = l.disabled, typeof l.precedence == "string" && n == null;
          default:
            return !0;
        }
      case "script":
        if (l.async && typeof l.async != "function" && typeof l.async != "symbol" && !l.onLoad && !l.onError && l.src && typeof l.src == "string")
          return !0;
    }
    return !1;
  }
  function ka(n) {
    return !(n.type === "stylesheet" && (n.state.loading & 3) === 0);
  }
  function ti(n, l, u, o) {
    if (u.type === "stylesheet" && (typeof o.media != "string" || matchMedia(o.media).matches !== !1) && (u.state.loading & 4) === 0) {
      if (u.instance === null) {
        var d = vl(o.href), p = l.querySelector(
          xo(d)
        );
        if (p) {
          l = p._p, l !== null && typeof l == "object" && typeof l.then == "function" && (n.count++, n = dm.bind(n), l.then(n, n)), u.state.loading |= 4, u.instance = p, Mt(p);
          return;
        }
        p = l.ownerDocument || l, o = is(o), (d = Ka.get(d)) && rm(o, d), p = p.createElement("link"), Mt(p);
        var T = p;
        T._p = new Promise(function(C, x) {
          T.onload = C, T.onerror = x;
        }), la(p, "link", o), u.instance = p;
      }
      n.stylesheets === null && (n.stylesheets = /* @__PURE__ */ new Map()), n.stylesheets.set(u, l), (l = u.state.preload) && (u.state.loading & 3) === 0 && (n.count++, u = dm.bind(n), l.addEventListener("load", u), l.addEventListener("error", u));
    }
  }
  var bl = 0;
  function ag(n, l) {
    return n.stylesheets && n.count === 0 && mm(n, n.stylesheets), 0 < n.count || 0 < n.imgCount ? function(u) {
      var o = setTimeout(function() {
        if (n.stylesheets && mm(n, n.stylesheets), n.unsuspend) {
          var p = n.unsuspend;
          n.unsuspend = null, p();
        }
      }, 6e4 + l);
      0 < n.imgBytes && bl === 0 && (bl = 62500 * ky());
      var d = setTimeout(
        function() {
          if (n.waitingForImages = !1, n.count === 0 && (n.stylesheets && mm(n, n.stylesheets), n.unsuspend)) {
            var p = n.unsuspend;
            n.unsuspend = null, p();
          }
        },
        (n.imgBytes > bl ? 50 : 800) + l
      );
      return n.unsuspend = u, function() {
        n.unsuspend = null, clearTimeout(o), clearTimeout(d);
      };
    } : null;
  }
  function dm() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) mm(this, this.stylesheets);
      else if (this.unsuspend) {
        var n = this.unsuspend;
        this.unsuspend = null, n();
      }
    }
  }
  var hm = null;
  function mm(n, l) {
    n.stylesheets = null, n.unsuspend !== null && (n.count++, hm = /* @__PURE__ */ new Map(), l.forEach(kn, n), hm = null, dm.call(n));
  }
  function kn(n, l) {
    if (!(l.state.loading & 4)) {
      var u = hm.get(n);
      if (u) var o = u.get(null);
      else {
        u = /* @__PURE__ */ new Map(), hm.set(n, u);
        for (var d = n.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), p = 0; p < d.length; p++) {
          var T = d[p];
          (T.nodeName === "LINK" || T.getAttribute("media") !== "not all") && (u.set(T.dataset.precedence, T), o = T);
        }
        o && u.set(null, o);
      }
      d = l.instance, T = d.getAttribute("data-precedence"), p = u.get(T) || o, p === o && u.set(null, d), u.set(T, d), this.count++, o = dm.bind(this), d.addEventListener("load", o), d.addEventListener("error", o), p ? p.parentNode.insertBefore(d, p.nextSibling) : (n = n.nodeType === 9 ? n.head : n, n.insertBefore(d, n.firstChild)), l.state.loading |= 4;
    }
  }
  var ed = {
    $$typeof: ye,
    Provider: null,
    Consumer: null,
    _currentValue: fe,
    _currentValue2: fe,
    _threadCount: 0
  };
  function lg(n, l, u, o, d, p, T, C, x) {
    this.tag = 1, this.containerInfo = n, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Vs(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Vs(0), this.hiddenUpdates = Vs(null), this.identifierPrefix = o, this.onUncaughtError = d, this.onCaughtError = p, this.onRecoverableError = T, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = x, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function pm(n, l, u, o, d, p, T, C, x, K, le, re) {
    return n = new lg(
      n,
      l,
      u,
      T,
      x,
      K,
      le,
      re,
      C
    ), l = 1, p === !0 && (l |= 24), p = hn(3, null, null, l), n.current = p, p.stateNode = n, l = cf(), l.refCount++, n.pooledCache = l, l.refCount++, p.memoizedState = {
      element: o,
      isDehydrated: u,
      cache: l
    }, pf(p), n;
  }
  function Hc(n) {
    return n ? (n = Aa, n) : Aa;
  }
  function jv(n, l, u, o, d, p) {
    d = Hc(d), o.context === null ? o.context = d : o.pendingContext = d, o = Ni(l), o.payload = { element: u }, p = p === void 0 ? null : p, p !== null && (o.callback = p), u = fl(n, o, l), u !== null && (Na(u, n, l), vo(u, n, l));
  }
  function ym(n, l) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var u = n.retryLane;
      n.retryLane = u !== 0 && u < l ? u : l;
    }
  }
  function ug(n, l) {
    ym(n, l), (n = n.alternate) && ym(n, l);
  }
  function qv(n) {
    if (n.tag === 13 || n.tag === 31) {
      var l = Ri(n, 67108864);
      l !== null && Na(l, n, 67108864), ug(n, 67108864);
    }
  }
  function Lc(n) {
    if (n.tag === 13 || n.tag === 31) {
      var l = Ja();
      l = Md(l);
      var u = Ri(n, l);
      u !== null && Na(u, n, l), ug(n, l);
    }
  }
  var Ln = !0;
  function ni(n, l, u, o) {
    var d = H.T;
    H.T = null;
    var p = ue.p;
    try {
      ue.p = 2, ua(n, l, u, o);
    } finally {
      ue.p = p, H.T = d;
    }
  }
  function ai(n, l, u, o) {
    var d = H.T;
    H.T = null;
    var p = ue.p;
    try {
      ue.p = 8, ua(n, l, u, o);
    } finally {
      ue.p = p, H.T = d;
    }
  }
  function ua(n, l, u, o) {
    if (Ln) {
      var d = ig(o);
      if (d === null)
        Gy(
          n,
          l,
          o,
          gm,
          u
        ), Qi(n, o);
      else if (qb(
        d,
        n,
        l,
        u,
        o
      ))
        o.stopPropagation();
      else if (Qi(n, o), l & 4 && -1 < Ha.indexOf(n)) {
        for (; d !== null; ) {
          var p = Ko(d);
          if (p !== null)
            switch (p.tag) {
              case 3:
                if (p = p.stateNode, p.current.memoizedState.isDehydrated) {
                  var T = _l(p.pendingLanes);
                  if (T !== 0) {
                    var C = p;
                    for (C.pendingLanes |= 2, C.entangledLanes |= 2; T; ) {
                      var x = 1 << 31 - ba(T);
                      C.entanglements[1] |= x, T &= ~x;
                    }
                    ei(p), (Ot & 6) === 0 && (zt = _e() + 500, Gi(0));
                  }
                }
                break;
              case 31:
              case 13:
                C = Ri(p, 2), C !== null && Na(C, p, 2), kr(), ug(p, 2);
            }
          if (p = ig(o), p === null && Gy(
            n,
            l,
            o,
            gm,
            u
          ), p === d) break;
          d = p;
        }
        d !== null && o.stopPropagation();
      } else
        Gy(
          n,
          l,
          o,
          null,
          u
        );
    }
  }
  function ig(n) {
    return n = Gd(n), rs(n);
  }
  var gm = null;
  function rs(n) {
    if (gm = null, n = Jo(n), n !== null) {
      var l = g(n);
      if (l === null) n = null;
      else {
        var u = l.tag;
        if (u === 13) {
          if (n = S(l), n !== null) return n;
          n = null;
        } else if (u === 31) {
          if (n = E(l), n !== null) return n;
          n = null;
        } else if (u === 3) {
          if (l.stateNode.current.memoizedState.isDehydrated)
            return l.tag === 3 ? l.stateNode.containerInfo : null;
          n = null;
        } else l !== n && (n = null);
      }
    }
    return gm = n, null;
  }
  function td(n) {
    switch (n) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (vt()) {
          case et:
            return 2;
          case St:
            return 8;
          case Wt:
          case tl:
            return 32;
          case Xo:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var ss = !1, Bn = null, ia = null, ha = null, Ho = /* @__PURE__ */ new Map(), Gl = /* @__PURE__ */ new Map(), ln = [], Ha = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Qi(n, l) {
    switch (n) {
      case "focusin":
      case "focusout":
        Bn = null;
        break;
      case "dragenter":
      case "dragleave":
        ia = null;
        break;
      case "mouseover":
      case "mouseout":
        ha = null;
        break;
      case "pointerover":
      case "pointerout":
        Ho.delete(l.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Gl.delete(l.pointerId);
    }
  }
  function Bc(n, l, u, o, d, p) {
    return n === null || n.nativeEvent !== p ? (n = {
      blockedOn: l,
      domEventName: u,
      eventSystemFlags: o,
      nativeEvent: p,
      targetContainers: [d]
    }, l !== null && (l = Ko(l), l !== null && qv(l)), n) : (n.eventSystemFlags |= o, l = n.targetContainers, d !== null && l.indexOf(d) === -1 && l.push(d), n);
  }
  function qb(n, l, u, o, d) {
    switch (l) {
      case "focusin":
        return Bn = Bc(
          Bn,
          n,
          l,
          u,
          o,
          d
        ), !0;
      case "dragenter":
        return ia = Bc(
          ia,
          n,
          l,
          u,
          o,
          d
        ), !0;
      case "mouseover":
        return ha = Bc(
          ha,
          n,
          l,
          u,
          o,
          d
        ), !0;
      case "pointerover":
        var p = d.pointerId;
        return Ho.set(
          p,
          Bc(
            Ho.get(p) || null,
            n,
            l,
            u,
            o,
            d
          )
        ), !0;
      case "gotpointercapture":
        return p = d.pointerId, Gl.set(
          p,
          Bc(
            Gl.get(p) || null,
            n,
            l,
            u,
            o,
            d
          )
        ), !0;
    }
    return !1;
  }
  function Vv(n) {
    var l = Jo(n.target);
    if (l !== null) {
      var u = g(l);
      if (u !== null) {
        if (l = u.tag, l === 13) {
          if (l = S(u), l !== null) {
            n.blockedOn = l, ip(n.priority, function() {
              Lc(u);
            });
            return;
          }
        } else if (l === 31) {
          if (l = E(u), l !== null) {
            n.blockedOn = l, ip(n.priority, function() {
              Lc(u);
            });
            return;
          }
        } else if (l === 3 && u.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = u.tag === 3 ? u.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function nd(n) {
    if (n.blockedOn !== null) return !1;
    for (var l = n.targetContainers; 0 < l.length; ) {
      var u = ig(n.nativeEvent);
      if (u === null) {
        u = n.nativeEvent;
        var o = new u.constructor(
          u.type,
          u
        );
        Yd = o, u.target.dispatchEvent(o), Yd = null;
      } else
        return l = Ko(u), l !== null && qv(l), n.blockedOn = u, !1;
      l.shift();
    }
    return !0;
  }
  function fs(n, l, u) {
    nd(n) && u.delete(l);
  }
  function Yv() {
    ss = !1, Bn !== null && nd(Bn) && (Bn = null), ia !== null && nd(ia) && (ia = null), ha !== null && nd(ha) && (ha = null), Ho.forEach(fs), Gl.forEach(fs);
  }
  function li(n, l) {
    n.blockedOn === l && (n.blockedOn = null, ss || (ss = !0, r.unstable_scheduleCallback(
      r.unstable_NormalPriority,
      Yv
    )));
  }
  var ds = null;
  function Gv(n) {
    ds !== n && (ds = n, r.unstable_scheduleCallback(
      r.unstable_NormalPriority,
      function() {
        ds === n && (ds = null);
        for (var l = 0; l < n.length; l += 3) {
          var u = n[l], o = n[l + 1], d = n[l + 2];
          if (typeof o != "function") {
            if (rs(o || u) === null)
              continue;
            break;
          }
          var p = Ko(u);
          p !== null && (n.splice(l, 3), l -= 3, Hr(
            p,
            {
              pending: !0,
              data: d,
              method: u.method,
              action: o
            },
            o,
            d
          ));
        }
      }
    ));
  }
  function hs(n) {
    function l(x) {
      return li(x, n);
    }
    Bn !== null && li(Bn, n), ia !== null && li(ia, n), ha !== null && li(ha, n), Ho.forEach(l), Gl.forEach(l);
    for (var u = 0; u < ln.length; u++) {
      var o = ln[u];
      o.blockedOn === n && (o.blockedOn = null);
    }
    for (; 0 < ln.length && (u = ln[0], u.blockedOn === null); )
      Vv(u), u.blockedOn === null && ln.shift();
    if (u = (n.ownerDocument || n).$$reactFormReplay, u != null)
      for (o = 0; o < u.length; o += 3) {
        var d = u[o], p = u[o + 1], T = d[Sa] || null;
        if (typeof p == "function")
          T || Gv(u);
        else if (T) {
          var C = null;
          if (p && p.hasAttribute("formAction")) {
            if (d = p, T = p[Sa] || null)
              C = T.formAction;
            else if (rs(d) !== null) continue;
          } else C = T.action;
          typeof C == "function" ? u[o + 1] = C : (u.splice(o, 3), o -= 3), Gv(u);
        }
      }
  }
  function og() {
    function n(p) {
      p.canIntercept && p.info === "react-transition" && p.intercept({
        handler: function() {
          return new Promise(function(T) {
            return d = T;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function l() {
      d !== null && (d(), d = null), o || setTimeout(u, 20);
    }
    function u() {
      if (!o && !navigation.transition) {
        var p = navigation.currentEntry;
        p && p.url != null && navigation.navigate(p.url, {
          state: p.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var o = !1, d = null;
      return navigation.addEventListener("navigate", n), navigation.addEventListener("navigatesuccess", l), navigation.addEventListener("navigateerror", l), setTimeout(u, 100), function() {
        o = !0, navigation.removeEventListener("navigate", n), navigation.removeEventListener("navigatesuccess", l), navigation.removeEventListener("navigateerror", l), d !== null && (d(), d = null);
      };
    }
  }
  function vm(n) {
    this._internalRoot = n;
  }
  bm.prototype.render = vm.prototype.render = function(n) {
    var l = this._internalRoot;
    if (l === null) throw Error(h(409));
    var u = l.current, o = Ja();
    jv(u, o, n, l, null, null);
  }, bm.prototype.unmount = vm.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var l = n.containerInfo;
      jv(n.current, 2, null, n, null, null), kr(), l[eo] = null;
    }
  };
  function bm(n) {
    this._internalRoot = n;
  }
  bm.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var l = Nd();
      n = { blockedOn: null, target: n, priority: l };
      for (var u = 0; u < ln.length && l !== 0 && l < ln[u].priority; u++) ;
      ln.splice(u, 0, n), u === 0 && Vv(n);
    }
  };
  var cg = f.version;
  if (cg !== "19.2.4")
    throw Error(
      h(
        527,
        cg,
        "19.2.4"
      )
    );
  ue.findDOMNode = function(n) {
    var l = n._reactInternals;
    if (l === void 0)
      throw typeof n.render == "function" ? Error(h(188)) : (n = Object.keys(n).join(","), Error(h(268, n)));
    return n = R(l), n = n !== null ? _(n) : null, n = n === null ? null : n.stateNode, n;
  };
  var Xv = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: H,
    reconcilerVersion: "19.2.4"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ad = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ad.isDisabled && ad.supportsFiber)
      try {
        Qo = ad.inject(
          Xv
        ), Va = ad;
      } catch {
      }
  }
  return i0.createRoot = function(n, l) {
    if (!v(n)) throw Error(h(299));
    var u = !1, o = "", d = Uh, p = ry, T = wh;
    return l != null && (l.unstable_strictMode === !0 && (u = !0), l.identifierPrefix !== void 0 && (o = l.identifierPrefix), l.onUncaughtError !== void 0 && (d = l.onUncaughtError), l.onCaughtError !== void 0 && (p = l.onCaughtError), l.onRecoverableError !== void 0 && (T = l.onRecoverableError)), l = pm(
      n,
      1,
      !1,
      null,
      null,
      u,
      o,
      null,
      d,
      p,
      T,
      og
    ), n[eo] = l.current, es(n), new vm(l);
  }, i0.hydrateRoot = function(n, l, u) {
    if (!v(n)) throw Error(h(299));
    var o = !1, d = "", p = Uh, T = ry, C = wh, x = null;
    return u != null && (u.unstable_strictMode === !0 && (o = !0), u.identifierPrefix !== void 0 && (d = u.identifierPrefix), u.onUncaughtError !== void 0 && (p = u.onUncaughtError), u.onCaughtError !== void 0 && (T = u.onCaughtError), u.onRecoverableError !== void 0 && (C = u.onRecoverableError), u.formState !== void 0 && (x = u.formState)), l = pm(
      n,
      1,
      !0,
      l,
      u ?? null,
      o,
      d,
      x,
      p,
      T,
      C,
      og
    ), l.context = Hc(null), u = l.current, o = Ja(), o = Md(o), d = Ni(o), d.callback = null, fl(u, d, o), u = o, l.current.lanes = u, ir(l, u), ei(l), n[eo] = l.current, es(n), new bm(l);
  }, i0.version = "19.2.4", i0;
}
var o0 = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zO;
function Nz() {
  return zO || (zO = 1, process.env.NODE_ENV !== "production" && (function() {
    function r(e, t) {
      for (e = e.memoizedState; e !== null && 0 < t; )
        e = e.next, t--;
      return e;
    }
    function f(e, t, a, i) {
      if (a >= t.length) return i;
      var c = t[a], s = _n(e) ? e.slice() : ut({}, e);
      return s[c] = f(e[c], t, a + 1, i), s;
    }
    function m(e, t, a) {
      if (t.length !== a.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var i = 0; i < a.length - 1; i++)
          if (t[i] !== a[i]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return h(e, t, a, 0);
      }
    }
    function h(e, t, a, i) {
      var c = t[i], s = _n(e) ? e.slice() : ut({}, e);
      return i + 1 === t.length ? (s[a[i]] = s[c], _n(s) ? s.splice(c, 1) : delete s[c]) : s[c] = h(
        e[c],
        t,
        a,
        i + 1
      ), s;
    }
    function v(e, t, a) {
      var i = t[a], c = _n(e) ? e.slice() : ut({}, e);
      return a + 1 === t.length ? (_n(c) ? c.splice(i, 1) : delete c[i], c) : (c[i] = v(e[i], t, a + 1), c);
    }
    function g() {
      return !1;
    }
    function S() {
      return null;
    }
    function E() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function O() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function R() {
    }
    function _() {
    }
    function z(e) {
      var t = [];
      return e.forEach(function(a) {
        t.push(a);
      }), t.sort().join(", ");
    }
    function L(e, t, a, i) {
      return new wb(e, t, a, i);
    }
    function Q(e, t) {
      e.context === gs && (am(e.current, 2, t, e, null, null), yl());
    }
    function N(e, t) {
      if (oi !== null) {
        var a = t.staleFamilies;
        t = t.updatedFamilies, xf(), x0(
          e.current,
          t,
          a
        ), yl();
      }
    }
    function G(e) {
      oi = e;
    }
    function Y(e) {
      return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
    }
    function F(e) {
      var t = e, a = e;
      if (e.alternate) for (; t.return; ) t = t.return;
      else {
        e = t;
        do
          t = e, (t.flags & 4098) !== 0 && (a = t.return), e = t.return;
        while (e);
      }
      return t.tag === 3 ? a : null;
    }
    function ne(e) {
      if (e.tag === 13) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
      }
      return null;
    }
    function ye(e) {
      if (e.tag === 31) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
      }
      return null;
    }
    function pe(e) {
      if (F(e) !== e)
        throw Error("Unable to find node on an unmounted component.");
    }
    function he(e) {
      var t = e.alternate;
      if (!t) {
        if (t = F(e), t === null)
          throw Error("Unable to find node on an unmounted component.");
        return t !== e ? null : e;
      }
      for (var a = e, i = t; ; ) {
        var c = a.return;
        if (c === null) break;
        var s = c.alternate;
        if (s === null) {
          if (i = c.return, i !== null) {
            a = i;
            continue;
          }
          break;
        }
        if (c.child === s.child) {
          for (s = c.child; s; ) {
            if (s === a) return pe(c), e;
            if (s === i) return pe(c), t;
            s = s.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (a.return !== i.return) a = c, i = s;
        else {
          for (var y = !1, b = c.child; b; ) {
            if (b === a) {
              y = !0, a = c, i = s;
              break;
            }
            if (b === i) {
              y = !0, i = c, a = s;
              break;
            }
            b = b.sibling;
          }
          if (!y) {
            for (b = s.child; b; ) {
              if (b === a) {
                y = !0, a = s, i = c;
                break;
              }
              if (b === i) {
                y = !0, i = s, a = c;
                break;
              }
              b = b.sibling;
            }
            if (!y)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (a.alternate !== i)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (a.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return a.stateNode.current === a ? e : t;
    }
    function Te(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6) return e;
      for (e = e.child; e !== null; ) {
        if (t = Te(e), t !== null) return t;
        e = e.sibling;
      }
      return null;
    }
    function ge(e) {
      return e === null || typeof e != "object" ? null : (e = Lv && e[Lv] || e["@@iterator"], typeof e == "function" ? e : null);
    }
    function Se(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === ls ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case ns:
          return "Fragment";
        case Wf:
          return "Profiler";
        case xa:
          return "StrictMode";
        case Nc:
          return "Suspense";
        case Ka:
          return "SuspenseList";
        case Su:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case Mo:
            return "Portal";
          case bu:
            return e.displayName || "Context";
          case cm:
            return (e._context.displayName || "Context") + ".Consumer";
          case as:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case If:
            return t = e.displayName || null, t !== null ? t : Se(e.type) || "Memo";
          case da:
            t = e._payload, e = e._init;
            try {
              return Se(e(t));
            } catch {
            }
        }
      return null;
    }
    function xe(e) {
      return typeof e.tag == "number" ? ae(e) : typeof e.name == "string" ? e.name : null;
    }
    function ae(e) {
      var t = e.type;
      switch (e.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (t._context.displayName || "Context") + ".Consumer";
        case 10:
          return t.displayName || "Context";
        case 18:
          return "DehydratedFragment";
        case 11:
          return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return t;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return Se(t);
        case 8:
          return t === xa ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof t == "function")
            return t.displayName || t.name || null;
          if (typeof t == "string") return t;
          break;
        case 29:
          if (t = e._debugInfo, t != null) {
            for (var a = t.length - 1; 0 <= a; a--)
              if (typeof t[a].name == "string") return t[a].name;
          }
          if (e.return !== null)
            return ae(e.return);
      }
      return null;
    }
    function Me(e) {
      return { current: e };
    }
    function Ce(e, t) {
      0 > Xi ? console.error("Unexpected pop.") : (t !== Py[Xi] && console.error("Unexpected Fiber popped."), e.current = Iy[Xi], Iy[Xi] = null, Py[Xi] = null, Xi--);
    }
    function we(e, t, a) {
      Xi++, Iy[Xi] = e.current, Py[Xi] = a, e.current = t;
    }
    function We(e) {
      return e === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), e;
    }
    function Rt(e, t) {
      we(vl, t, e), we(us, e, e), we(No, null, e);
      var a = t.nodeType;
      switch (a) {
        case 9:
        case 11:
          a = a === 9 ? "#document" : "#fragment", t = (t = t.documentElement) && (t = t.namespaceURI) ? rv(t) : Wc;
          break;
        default:
          if (a = t.tagName, t = t.namespaceURI)
            t = rv(t), t = Vi(
              t,
              a
            );
          else
            switch (a) {
              case "svg":
                t = $m;
                break;
              case "math":
                t = x1;
                break;
              default:
                t = Wc;
            }
      }
      a = a.toLowerCase(), a = sp(null, a), a = {
        context: t,
        ancestorInfo: a
      }, Ce(No, e), we(No, a, e);
    }
    function H(e) {
      Ce(No, e), Ce(us, e), Ce(vl, e);
    }
    function ue() {
      return We(No.current);
    }
    function fe(e) {
      e.memoizedState !== null && we(xo, e, e);
      var t = We(No.current), a = e.type, i = Vi(t.context, a);
      a = sp(t.ancestorInfo, a), i = { context: i, ancestorInfo: a }, t !== i && (we(us, e, e), we(No, i, e));
    }
    function be(e) {
      us.current === e && (Ce(No, e), Ce(us, e)), xo.current === e && (Ce(xo, e), Wg._currentValue = Rd);
    }
    function Be() {
    }
    function ee() {
      if (is === 0) {
        Bv = console.log, xc = console.info, os = console.warn, eg = console.error, Pf = console.group, rm = console.groupCollapsed, sm = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: Be,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      is++;
    }
    function ve() {
      if (is--, is === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: ut({}, e, { value: Bv }),
          info: ut({}, e, { value: xc }),
          warn: ut({}, e, { value: os }),
          error: ut({}, e, { value: eg }),
          group: ut({}, e, { value: Pf }),
          groupCollapsed: ut({}, e, { value: rm }),
          groupEnd: ut({}, e, { value: sm })
        });
      }
      0 > is && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function De(e) {
      var t = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = t, e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)), t = e.indexOf(`
`), t !== -1 && (e = e.slice(t + 1)), t = e.indexOf("react_stack_bottom_frame"), t !== -1 && (t = e.lastIndexOf(
        `
`,
        t
      )), t !== -1)
        e = e.slice(0, t);
      else return "";
      return e;
    }
    function ze(e) {
      if (cs === void 0)
        try {
          throw Error();
        } catch (a) {
          var t = a.stack.trim().match(/\n( *(at )?)/);
          cs = t && t[1] || "", tg = -1 < a.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < a.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + cs + e + tg;
    }
    function At(e, t) {
      if (!e || fm) return "";
      var a = ng.get(e);
      if (a !== void 0) return a;
      fm = !0, a = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var i = null;
      i = I.H, I.H = null, ee();
      try {
        var c = {
          DetermineComponentFrameRoot: function() {
            try {
              if (t) {
                var w = function() {
                  throw Error();
                };
                if (Object.defineProperty(w.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(w, []);
                  } catch (Ee) {
                    var $ = Ee;
                  }
                  Reflect.construct(e, [], w);
                } else {
                  try {
                    w.call();
                  } catch (Ee) {
                    $ = Ee;
                  }
                  e.call(w.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Ee) {
                  $ = Ee;
                }
                (w = e()) && typeof w.catch == "function" && w.catch(function() {
                });
              }
            } catch (Ee) {
              if (Ee && $ && typeof Ee.stack == "string")
                return [Ee.stack, $.stack];
            }
            return [null, null];
          }
        };
        c.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var s = Object.getOwnPropertyDescriptor(
          c.DetermineComponentFrameRoot,
          "name"
        );
        s && s.configurable && Object.defineProperty(
          c.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var y = c.DetermineComponentFrameRoot(), b = y[0], A = y[1];
        if (b && A) {
          var D = b.split(`
`), j = A.split(`
`);
          for (y = s = 0; s < D.length && !D[s].includes(
            "DetermineComponentFrameRoot"
          ); )
            s++;
          for (; y < j.length && !j[y].includes(
            "DetermineComponentFrameRoot"
          ); )
            y++;
          if (s === D.length || y === j.length)
            for (s = D.length - 1, y = j.length - 1; 1 <= s && 0 <= y && D[s] !== j[y]; )
              y--;
          for (; 1 <= s && 0 <= y; s--, y--)
            if (D[s] !== j[y]) {
              if (s !== 1 || y !== 1)
                do
                  if (s--, y--, 0 > y || D[s] !== j[y]) {
                    var V = `
` + D[s].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && V.includes("<anonymous>") && (V = V.replace("<anonymous>", e.displayName)), typeof e == "function" && ng.set(e, V), V;
                  }
                while (1 <= s && 0 <= y);
              break;
            }
        }
      } finally {
        fm = !1, I.H = i, ve(), Error.prepareStackTrace = a;
      }
      return D = (D = e ? e.displayName || e.name : "") ? ze(D) : "", typeof e == "function" && ng.set(e, D), D;
    }
    function Rn(e, t) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return ze(e.type);
        case 16:
          return ze("Lazy");
        case 13:
          return e.child !== t && t !== null ? ze("Suspense Fallback") : ze("Suspense");
        case 19:
          return ze("SuspenseList");
        case 0:
        case 15:
          return At(e.type, !1);
        case 11:
          return At(e.type.render, !1);
        case 1:
          return At(e.type, !0);
        case 31:
          return ze("Activity");
        default:
          return "";
      }
    }
    function ft(e) {
      try {
        var t = "", a = null;
        do {
          t += Rn(e, a);
          var i = e._debugInfo;
          if (i)
            for (var c = i.length - 1; 0 <= c; c--) {
              var s = i[c];
              if (typeof s.name == "string") {
                var y = t;
                e: {
                  var b = s.name, A = s.env, D = s.debugLocation;
                  if (D != null) {
                    var j = De(D), V = j.lastIndexOf(`
`), w = V === -1 ? j : j.slice(V + 1);
                    if (w.indexOf(b) !== -1) {
                      var $ = `
` + w;
                      break e;
                    }
                  }
                  $ = ze(
                    b + (A ? " [" + A + "]" : "")
                  );
                }
                t = y + $;
              }
            }
          a = e, e = e.return;
        } while (e);
        return t;
      } catch (Ee) {
        return `
Error generating stack: ` + Ee.message + `
` + Ee.stack;
      }
    }
    function en(e) {
      return (e = e ? e.displayName || e.name : "") ? ze(e) : "";
    }
    function Mn() {
      if (ka === null) return null;
      var e = ka._debugOwner;
      return e != null ? xe(e) : null;
    }
    function zl() {
      if (ka === null) return "";
      var e = ka;
      try {
        var t = "";
        switch (e.tag === 6 && (e = e.return), e.tag) {
          case 26:
          case 27:
          case 5:
            t += ze(e.type);
            break;
          case 13:
            t += ze("Suspense");
            break;
          case 19:
            t += ze("SuspenseList");
            break;
          case 31:
            t += ze("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            e._debugOwner || t !== "" || (t += en(
              e.type
            ));
            break;
          case 11:
            e._debugOwner || t !== "" || (t += en(
              e.type.render
            ));
        }
        for (; e; )
          if (typeof e.tag == "number") {
            var a = e;
            e = a._debugOwner;
            var i = a._debugStack;
            if (e && i) {
              var c = De(i);
              c !== "" && (t += `
` + c);
            }
          } else if (e.debugStack != null) {
            var s = e.debugStack;
            (e = e.owner) && s && (t += `
` + De(s));
          } else break;
        var y = t;
      } catch (b) {
        y = `
Error generating stack: ` + b.message + `
` + b.stack;
      }
      return y;
    }
    function Ae(e, t, a, i, c, s, y) {
      var b = ka;
      qa(e);
      try {
        return e !== null && e._debugTask ? e._debugTask.run(
          t.bind(null, a, i, c, s, y)
        ) : t(a, i, c, s, y);
      } finally {
        qa(b);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function qa(e) {
      I.getCurrentStack = e === null ? null : zl, ti = !1, ka = e;
    }
    function va(e) {
      return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
    }
    function na(e) {
      try {
        return $l(e), !1;
      } catch {
        return !0;
      }
    }
    function $l(e) {
      return "" + e;
    }
    function He(e, t) {
      if (na(e))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          va(e)
        ), $l(e);
    }
    function wt(e, t) {
      if (na(e))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          va(e)
        ), $l(e);
    }
    function jt(e) {
      if (na(e))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          va(e)
        ), $l(e);
    }
    function Zt(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled) return !0;
      if (!t.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        Lc = t.inject(e), Ln = t;
      } catch (a) {
        console.error("React instrumentation encountered an error: %o.", a);
      }
      return !!t.checkDCE;
    }
    function Z(e) {
      if (typeof ug == "function" && qv(e), Ln && typeof Ln.setStrictMode == "function")
        try {
          Ln.setStrictMode(Lc, e);
        } catch (t) {
          ni || (ni = !0, console.error(
            "React instrumentation encountered an error: %o",
            t
          ));
        }
    }
    function de(e) {
      return e >>>= 0, e === 0 ? 32 : 31 - (ig(e) / gm | 0) | 0;
    }
    function oe(e) {
      var t = e & 42;
      if (t !== 0) return t;
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return e & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return e & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return e & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), e;
      }
    }
    function me(e, t, a) {
      var i = e.pendingLanes;
      if (i === 0) return 0;
      var c = 0, s = e.suspendedLanes, y = e.pingedLanes;
      e = e.warmLanes;
      var b = i & 134217727;
      return b !== 0 ? (i = b & ~s, i !== 0 ? c = oe(i) : (y &= b, y !== 0 ? c = oe(y) : a || (a = b & ~e, a !== 0 && (c = oe(a))))) : (b = i & ~s, b !== 0 ? c = oe(b) : y !== 0 ? c = oe(y) : a || (a = i & ~e, a !== 0 && (c = oe(a)))), c === 0 ? 0 : t !== 0 && t !== c && (t & s) === 0 && (s = c & -c, a = t & -t, s >= a || s === 32 && (a & 4194048) !== 0) ? t : c;
    }
    function _e(e, t) {
      return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
    }
    function vt(e, t) {
      switch (e) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return t + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return t + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function et() {
      var e = ss;
      return ss <<= 1, (ss & 62914560) === 0 && (ss = 4194304), e;
    }
    function St(e) {
      for (var t = [], a = 0; 31 > a; a++) t.push(e);
      return t;
    }
    function Wt(e, t) {
      e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function tl(e, t, a, i, c, s) {
      var y = e.pendingLanes;
      e.pendingLanes = a, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= a, e.entangledLanes &= a, e.errorRecoveryDisabledLanes &= a, e.shellSuspendCounter = 0;
      var b = e.entanglements, A = e.expirationTimes, D = e.hiddenUpdates;
      for (a = y & ~a; 0 < a; ) {
        var j = 31 - ua(a), V = 1 << j;
        b[j] = 0, A[j] = -1;
        var w = D[j];
        if (w !== null)
          for (D[j] = null, j = 0; j < w.length; j++) {
            var $ = w[j];
            $ !== null && ($.lane &= -536870913);
          }
        a &= ~V;
      }
      i !== 0 && Xo(e, i, 0), s !== 0 && c === 0 && e.tag !== 0 && (e.suspendedLanes |= s & ~(y & ~t));
    }
    function Xo(e, t, a) {
      e.pendingLanes |= t, e.suspendedLanes &= ~t;
      var i = 31 - ua(t);
      e.entangledLanes |= t, e.entanglements[i] = e.entanglements[i] | 1073741824 | a & 261930;
    }
    function Ud(e, t) {
      var a = e.entangledLanes |= t;
      for (e = e.entanglements; a; ) {
        var i = 31 - ua(a), c = 1 << i;
        c & t | e[i] & t && (e[i] |= t), a &= ~c;
      }
    }
    function lr(e, t) {
      var a = t & -t;
      return a = (a & 42) !== 0 ? 1 : Qo(a), (a & (e.suspendedLanes | t)) !== 0 ? 0 : a;
    }
    function Qo(e) {
      switch (e) {
        case 2:
          e = 1;
          break;
        case 8:
          e = 4;
          break;
        case 32:
          e = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          e = 128;
          break;
        case 268435456:
          e = 134217728;
          break;
        default:
          e = 0;
      }
      return e;
    }
    function Va(e, t, a) {
      if (ai)
        for (e = e.pendingUpdatersLaneMap; 0 < a; ) {
          var i = 31 - ua(a), c = 1 << i;
          e[i].add(t), a &= ~c;
        }
    }
    function Si(e, t) {
      if (ai)
        for (var a = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; 0 < t; ) {
          var c = 31 - ua(t);
          e = 1 << c, c = a[c], 0 < c.size && (c.forEach(function(s) {
            var y = s.alternate;
            y !== null && i.has(y) || i.add(s);
          }), c.clear()), t &= ~e;
        }
    }
    function ba(e) {
      return e &= -e, Bn < e ? ia < e ? (e & 134217727) !== 0 ? ha : Ho : ia : Bn;
    }
    function v0() {
      var e = _t.p;
      return e !== 0 ? e : (e = window.event, e === void 0 ? ha : um(e.type));
    }
    function b0(e, t) {
      var a = _t.p;
      try {
        return _t.p = e, t();
      } finally {
        _t.p = a;
      }
    }
    function lp(e) {
      delete e[ln], delete e[Ha], delete e[Bc], delete e[qb], delete e[Vv];
    }
    function Ei(e) {
      var t = e[ln];
      if (t) return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[Qi] || a[ln]) {
          if (a = t.alternate, t.child !== null || a !== null && a.child !== null)
            for (e = _c(e); e !== null; ) {
              if (a = e[ln])
                return a;
              e = _c(e);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function Fl(e) {
      if (e = e[ln] || e[Qi]) {
        var t = e.tag;
        if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
          return e;
      }
      return null;
    }
    function Pi(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6)
        return e.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function _l(e) {
      var t = e[nd];
      return t || (t = e[nd] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
    }
    function vn(e) {
      e[fs] = !0;
    }
    function Wl(e, t) {
      ur(e, t), ur(e + "Capture", t);
    }
    function ur(e, t) {
      li[e] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        e
      ), li[e] = t;
      var a = e.toLowerCase();
      for (ds[a] = e, e === "onDoubleClick" && (ds.ondblclick = e), e = 0; e < t.length; e++)
        Yv.add(t[e]);
    }
    function Zo(e, t) {
      Gv[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || console.error(
        e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), t.onChange || t.readOnly || t.disabled || t.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function Vs(e) {
      return bl.call(vm, e) ? !0 : bl.call(og, e) ? !1 : hs.test(e) ? vm[e] = !0 : (og[e] = !0, console.error("Invalid attribute name: `%s`", e), !1);
    }
    function ir(e, t, a) {
      if (Vs(t)) {
        if (!e.hasAttribute(t)) {
          switch (typeof a) {
            case "symbol":
            case "object":
              return a;
            case "function":
              return a;
            case "boolean":
              if (a === !1) return a;
          }
          return a === void 0 ? void 0 : null;
        }
        return e = e.getAttribute(t), e === "" && a === !0 ? !0 : (He(a, t), e === "" + a ? a : e);
      }
    }
    function wd(e, t, a) {
      if (Vs(t))
        if (a === null) e.removeAttribute(t);
        else {
          switch (typeof a) {
            case "undefined":
            case "function":
            case "symbol":
              e.removeAttribute(t);
              return;
            case "boolean":
              var i = t.toLowerCase().slice(0, 5);
              if (i !== "data-" && i !== "aria-") {
                e.removeAttribute(t);
                return;
              }
          }
          He(a, t), e.setAttribute(t, "" + a);
        }
    }
    function Ys(e, t, a) {
      if (a === null) e.removeAttribute(t);
      else {
        switch (typeof a) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(t);
            return;
        }
        He(a, t), e.setAttribute(t, "" + a);
      }
    }
    function Cu(e, t, a, i) {
      if (i === null) e.removeAttribute(a);
      else {
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(a);
            return;
        }
        He(i, a), e.setAttributeNS(t, a, "" + i);
      }
    }
    function nl(e) {
      switch (typeof e) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return jt(e), e;
        default:
          return "";
      }
    }
    function Md(e) {
      var t = e.type;
      return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function up(e, t, a) {
      var i = Object.getOwnPropertyDescriptor(
        e.constructor.prototype,
        t
      );
      if (!e.hasOwnProperty(t) && typeof i < "u" && typeof i.get == "function" && typeof i.set == "function") {
        var c = i.get, s = i.set;
        return Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return c.call(this);
          },
          set: function(y) {
            jt(y), a = "" + y, s.call(this, y);
          }
        }), Object.defineProperty(e, t, {
          enumerable: i.enumerable
        }), {
          getValue: function() {
            return a;
          },
          setValue: function(y) {
            jt(y), a = "" + y;
          },
          stopTracking: function() {
            e._valueTracker = null, delete e[t];
          }
        };
      }
    }
    function Nd(e) {
      if (!e._valueTracker) {
        var t = Md(e) ? "checked" : "value";
        e._valueTracker = up(
          e,
          t,
          "" + e[t]
        );
      }
    }
    function ip(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var a = t.getValue(), i = "";
      return e && (i = Md(e) ? e.checked ? "true" : "false" : e.value), e = i, e !== a ? (t.setValue(e), !0) : !1;
    }
    function Il(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    function qt(e) {
      return e.replace(
        bm,
        function(t) {
          return "\\" + t.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function Sa(e, t) {
      t.checked === void 0 || t.defaultChecked === void 0 || Xv || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Mn() || "A component",
        t.type
      ), Xv = !0), t.value === void 0 || t.defaultValue === void 0 || cg || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Mn() || "A component",
        t.type
      ), cg = !0);
    }
    function eo(e, t, a, i, c, s, y, b) {
      e.name = "", y != null && typeof y != "function" && typeof y != "symbol" && typeof y != "boolean" ? (He(y, "type"), e.type = y) : e.removeAttribute("type"), t != null ? y === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + nl(t)) : e.value !== "" + nl(t) && (e.value = "" + nl(t)) : y !== "submit" && y !== "reset" || e.removeAttribute("value"), t != null ? op(e, y, nl(t)) : a != null ? op(e, y, nl(a)) : i != null && e.removeAttribute("value"), c == null && s != null && (e.defaultChecked = !!s), c != null && (e.checked = c && typeof c != "function" && typeof c != "symbol"), b != null && typeof b != "function" && typeof b != "symbol" && typeof b != "boolean" ? (He(b, "name"), e.name = "" + nl(b)) : e.removeAttribute("name");
    }
    function xd(e, t, a, i, c, s, y, b) {
      if (s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" && (He(s, "type"), e.type = s), t != null || a != null) {
        if (!(s !== "submit" && s !== "reset" || t != null)) {
          Nd(e);
          return;
        }
        a = a != null ? "" + nl(a) : "", t = t != null ? "" + nl(t) : a, b || t === e.value || (e.value = t), e.defaultValue = t;
      }
      i = i ?? c, i = typeof i != "function" && typeof i != "symbol" && !!i, e.checked = b ? e.checked : !!i, e.defaultChecked = !!i, y != null && typeof y != "function" && typeof y != "symbol" && typeof y != "boolean" && (He(y, "name"), e.name = y), Nd(e);
    }
    function op(e, t, a) {
      t === "number" && Il(e.ownerDocument) === e || e.defaultValue === "" + a || (e.defaultValue = "" + a);
    }
    function S0(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? Ff.Children.forEach(t.children, function(a) {
        a == null || typeof a == "string" || typeof a == "number" || typeof a == "bigint" || n || (n = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : t.dangerouslySetInnerHTML == null || l || (l = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), t.selected == null || ad || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), ad = !0);
    }
    function cp() {
      var e = Mn();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    function zu(e, t, a, i) {
      if (e = e.options, t) {
        t = {};
        for (var c = 0; c < a.length; c++)
          t["$" + a[c]] = !0;
        for (a = 0; a < e.length; a++)
          c = t.hasOwnProperty("$" + e[a].value), e[a].selected !== c && (e[a].selected = c), c && i && (e[a].defaultSelected = !0);
      } else {
        for (a = "" + nl(a), t = null, c = 0; c < e.length; c++) {
          if (e[c].value === a) {
            e[c].selected = !0, i && (e[c].defaultSelected = !0);
            return;
          }
          t !== null || e[c].disabled || (t = e[c]);
        }
        t !== null && (t.selected = !0);
      }
    }
    function Hd(e, t) {
      for (e = 0; e < o.length; e++) {
        var a = o[e];
        if (t[a] != null) {
          var i = _n(t[a]);
          t.multiple && !i ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            a,
            cp()
          ) : !t.multiple && i && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            a,
            cp()
          );
        }
      }
      t.value === void 0 || t.defaultValue === void 0 || u || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), u = !0);
    }
    function Jo(e, t) {
      t.value === void 0 || t.defaultValue === void 0 || d || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        Mn() || "A component"
      ), d = !0), t.children != null && t.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function Ko(e, t, a) {
      if (t != null && (t = "" + nl(t), t !== e.value && (e.value = t), a == null)) {
        e.defaultValue !== t && (e.defaultValue = t);
        return;
      }
      e.defaultValue = a != null ? "" + nl(a) : "";
    }
    function or(e, t, a, i) {
      if (t == null) {
        if (i != null) {
          if (a != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (_n(i)) {
            if (1 < i.length)
              throw Error("<textarea> can only have at most one child.");
            i = i[0];
          }
          a = i;
        }
        a == null && (a = ""), t = a;
      }
      a = nl(t), e.defaultValue = a, i = e.textContent, i === a && i !== "" && i !== null && (e.value = i), Nd(e);
    }
    function ko(e, t) {
      return e.serverProps === void 0 && e.serverTail.length === 0 && e.children.length === 1 && 3 < e.distanceFromLeaf && e.distanceFromLeaf > 15 - t ? ko(e.children[0], t) : e;
    }
    function Mt(e) {
      return "  " + "  ".repeat(e);
    }
    function $o(e) {
      return "+ " + "  ".repeat(e);
    }
    function to(e) {
      return "- " + "  ".repeat(e);
    }
    function no(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return e.type;
        case 16:
          return "Lazy";
        case 31:
          return "Activity";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return e = e.type, e.displayName || e.name || null;
        case 11:
          return e = e.type.render, e.displayName || e.name || null;
        case 1:
          return e = e.type, e.displayName || e.name || null;
        default:
          return null;
      }
    }
    function _u(e, t) {
      return p.test(e) ? (e = JSON.stringify(e), e.length > t - 2 ? 8 > t ? '{"..."}' : "{" + e.slice(0, t - 7) + '..."}' : "{" + e + "}") : e.length > t ? 5 > t ? '{"..."}' : e.slice(0, t - 3) + "..." : e;
    }
    function Ld(e, t, a) {
      var i = 120 - 2 * a;
      if (t === null)
        return $o(a) + _u(e, i) + `
`;
      if (typeof t == "string") {
        for (var c = 0; c < t.length && c < e.length && t.charCodeAt(c) === e.charCodeAt(c); c++) ;
        return c > i - 8 && 10 < c && (e = "..." + e.slice(c - 8), t = "..." + t.slice(c - 8)), $o(a) + _u(e, i) + `
` + to(a) + _u(t, i) + `
`;
      }
      return Mt(a) + _u(e, i) + `
`;
    }
    function Bd(e) {
      return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(t, a) {
        return a;
      });
    }
    function cr(e, t) {
      switch (typeof e) {
        case "string":
          return e = JSON.stringify(e), e.length > t ? 5 > t ? '"..."' : e.slice(0, t - 4) + '..."' : e;
        case "object":
          if (e === null) return "null";
          if (_n(e)) return "[...]";
          if (e.$$typeof === Yl)
            return (t = Se(e.type)) ? "<" + t + ">" : "<...>";
          var a = Bd(e);
          if (a === "Object") {
            a = "", t -= 2;
            for (var i in e)
              if (e.hasOwnProperty(i)) {
                var c = JSON.stringify(i);
                if (c !== '"' + i + '"' && (i = c), t -= i.length - 2, c = cr(
                  e[i],
                  15 > t ? t : 15
                ), t -= c.length, 0 > t) {
                  a += a === "" ? "..." : ", ...";
                  break;
                }
                a += (a === "" ? "" : ",") + i + ":" + c;
              }
            return "{" + a + "}";
          }
          return a;
        case "function":
          return (t = e.displayName || e.name) ? "function " + t : "function";
        default:
          return String(e);
      }
    }
    function rr(e, t) {
      return typeof e != "string" || p.test(e) ? "{" + cr(e, t - 2) + "}" : e.length > t - 2 ? 5 > t ? '"..."' : '"' + e.slice(0, t - 5) + '..."' : '"' + e + '"';
    }
    function sr(e, t, a) {
      var i = 120 - a.length - e.length, c = [], s;
      for (s in t)
        if (t.hasOwnProperty(s) && s !== "children") {
          var y = rr(
            t[s],
            120 - a.length - s.length - 1
          );
          i -= s.length + y.length + 2, c.push(s + "=" + y);
        }
      return c.length === 0 ? a + "<" + e + `>
` : 0 < i ? a + "<" + e + " " + c.join(" ") + `>
` : a + "<" + e + `
` + a + "  " + c.join(`
` + a + "  ") + `
` + a + `>
`;
    }
    function jd(e, t, a) {
      var i = "", c = ut({}, t), s;
      for (s in e)
        if (e.hasOwnProperty(s)) {
          delete c[s];
          var y = 120 - 2 * a - s.length - 2, b = cr(e[s], y);
          t.hasOwnProperty(s) ? (y = cr(t[s], y), i += $o(a) + s + ": " + b + `
`, i += to(a) + s + ": " + y + `
`) : i += $o(a) + s + ": " + b + `
`;
        }
      for (var A in c)
        c.hasOwnProperty(A) && (e = cr(
          c[A],
          120 - 2 * a - A.length - 2
        ), i += to(a) + A + ": " + e + `
`);
      return i;
    }
    function Ti(e, t, a, i) {
      var c = "", s = /* @__PURE__ */ new Map();
      for (D in a)
        a.hasOwnProperty(D) && s.set(
          D.toLowerCase(),
          D
        );
      if (s.size === 1 && s.has("children"))
        c += sr(
          e,
          t,
          Mt(i)
        );
      else {
        for (var y in t)
          if (t.hasOwnProperty(y) && y !== "children") {
            var b = 120 - 2 * (i + 1) - y.length - 1, A = s.get(y.toLowerCase());
            if (A !== void 0) {
              s.delete(y.toLowerCase());
              var D = t[y];
              A = a[A];
              var j = rr(
                D,
                b
              );
              b = rr(
                A,
                b
              ), typeof D == "object" && D !== null && typeof A == "object" && A !== null && Bd(D) === "Object" && Bd(A) === "Object" && (2 < Object.keys(D).length || 2 < Object.keys(A).length || -1 < j.indexOf("...") || -1 < b.indexOf("...")) ? c += Mt(i + 1) + y + `={{
` + jd(
                D,
                A,
                i + 2
              ) + Mt(i + 1) + `}}
` : (c += $o(i + 1) + y + "=" + j + `
`, c += to(i + 1) + y + "=" + b + `
`);
            } else
              c += Mt(i + 1) + y + "=" + rr(t[y], b) + `
`;
          }
        s.forEach(function(V) {
          if (V !== "children") {
            var w = 120 - 2 * (i + 1) - V.length - 1;
            c += to(i + 1) + V + "=" + rr(a[V], w) + `
`;
          }
        }), c = c === "" ? Mt(i) + "<" + e + `>
` : Mt(i) + "<" + e + `
` + c + Mt(i) + `>
`;
      }
      return e = a.children, t = t.children, typeof e == "string" || typeof e == "number" || typeof e == "bigint" ? (s = "", (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (s = "" + t), c += Ld(s, "" + e, i + 1)) : (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (c = e == null ? c + Ld("" + t, null, i + 1) : c + Ld("" + t, void 0, i + 1)), c;
    }
    function al(e, t) {
      var a = no(e);
      if (a === null) {
        for (a = "", e = e.child; e; )
          a += al(e, t), e = e.sibling;
        return a;
      }
      return Mt(t) + "<" + a + `>
`;
    }
    function qd(e, t) {
      var a = ko(e, t);
      if (a !== e && (e.children.length !== 1 || e.children[0] !== a))
        return Mt(t) + `...
` + qd(a, t + 1);
      a = "";
      var i = e.fiber._debugInfo;
      if (i)
        for (var c = 0; c < i.length; c++) {
          var s = i[c].name;
          typeof s == "string" && (a += Mt(t) + "<" + s + `>
`, t++);
        }
      if (i = "", c = e.fiber.pendingProps, e.fiber.tag === 6)
        i = Ld(c, e.serverProps, t), t++;
      else if (s = no(e.fiber), s !== null)
        if (e.serverProps === void 0) {
          i = t;
          var y = 120 - 2 * i - s.length - 2, b = "";
          for (D in c)
            if (c.hasOwnProperty(D) && D !== "children") {
              var A = rr(c[D], 15);
              if (y -= D.length + A.length + 2, 0 > y) {
                b += " ...";
                break;
              }
              b += " " + D + "=" + A;
            }
          i = Mt(i) + "<" + s + b + `>
`, t++;
        } else
          e.serverProps === null ? (i = sr(
            s,
            c,
            $o(t)
          ), t++) : typeof e.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (i = Ti(
            s,
            c,
            e.serverProps,
            t
          ), t++);
      var D = "";
      for (c = e.fiber.child, s = 0; c && s < e.children.length; )
        y = e.children[s], y.fiber === c ? (D += qd(y, t), s++) : D += al(c, t), c = c.sibling;
      for (c && 0 < e.children.length && (D += Mt(t) + `...
`), c = e.serverTail, e.serverProps === null && t--, e = 0; e < c.length; e++)
        s = c[e], D = typeof s == "string" ? D + (to(t) + _u(s, 120 - 2 * t) + `
`) : D + sr(
          s.type,
          s.props,
          to(t)
        );
      return a + i + D;
    }
    function rp(e) {
      try {
        return `

` + qd(e, 0);
      } catch {
        return "";
      }
    }
    function Vd(e, t, a) {
      for (var i = t, c = null, s = 0; i; )
        i === e && (s = 0), c = {
          fiber: i,
          children: c !== null ? [c] : [],
          serverProps: i === t ? a : i === e ? null : void 0,
          serverTail: [],
          distanceFromLeaf: s
        }, s++, i = i.return;
      return c !== null ? rp(c).replaceAll(/^[+-]/gm, ">") : "";
    }
    function sp(e, t) {
      var a = ut({}, e || le), i = { tag: t };
      return C.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), x.indexOf(t) !== -1 && (a.pTagInButtonScope = null), T.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = i, t === "form" && (a.formTag = i), t === "a" && (a.aTagInScope = i), t === "button" && (a.buttonTagInScope = i), t === "nobr" && (a.nobrTagInScope = i), t === "p" && (a.pTagInButtonScope = i), t === "li" && (a.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = i), t === "#document" || t === "html" ? a.containerTagInScope = null : a.containerTagInScope || (a.containerTagInScope = i), e !== null || t !== "#document" && t !== "html" && t !== "body" ? a.implicitRootScope === !0 && (a.implicitRootScope = !1) : a.implicitRootScope = !0, a;
    }
    function Gs(e, t, a) {
      switch (t) {
        case "select":
          return e === "hr" || e === "option" || e === "optgroup" || e === "script" || e === "template" || e === "#text";
        case "optgroup":
          return e === "option" || e === "#text";
        case "option":
          return e === "#text";
        case "tr":
          return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return e === "tr" || e === "style" || e === "script" || e === "template";
        case "colgroup":
          return e === "col" || e === "template";
        case "table":
          return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
        case "head":
          return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
        case "html":
          if (a) break;
          return e === "head" || e === "body" || e === "frameset";
        case "frameset":
          return e === "frame";
        case "#document":
          if (!a) return e === "html";
      }
      switch (e) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
        case "rp":
        case "rt":
          return K.indexOf(t) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return t == null;
        case "head":
          return a || t === null;
        case "html":
          return a && t === "#document" || t === null;
        case "body":
          return a && (t === "#document" || t === "html") || t === null;
      }
      return !0;
    }
    function Db(e, t) {
      switch (e) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t.pTagInButtonScope;
        case "form":
          return t.formTag || t.pTagInButtonScope;
        case "li":
          return t.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return t.dlItemTagAutoclosing;
        case "button":
          return t.buttonTagInScope;
        case "a":
          return t.aTagInScope;
        case "nobr":
          return t.nobrTagInScope;
      }
      return null;
    }
    function ll(e, t) {
      for (; e; ) {
        switch (e.tag) {
          case 5:
          case 26:
          case 27:
            if (e.type === t) return e;
        }
        e = e.return;
      }
      return null;
    }
    function Xs(e, t) {
      t = t || le;
      var a = t.current;
      if (t = (a = Gs(
        e,
        a && a.tag,
        t.implicitRootScope
      ) ? null : a) ? null : Db(e, t), t = a || t, !t) return !0;
      var i = t.tag;
      if (t = String(!!a) + "|" + e + "|" + i, re[t]) return !1;
      re[t] = !0;
      var c = (t = ka) ? ll(t.return, i) : null, s = t !== null && c !== null ? Vd(c, t, null) : "", y = "<" + e + ">";
      return a ? (a = "", i === "table" && e === "tr" && (a += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        y,
        i,
        a,
        s
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        y,
        i,
        s
      ), t && (e = t.return, c === null || e === null || c === e && e._debugOwner === t._debugOwner || Ae(c, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          i,
          y
        );
      })), !1;
    }
    function Qs(e, t, a) {
      if (a || Gs("#text", t, !1))
        return !0;
      if (a = "#text|" + t, re[a]) return !1;
      re[a] = !0;
      var i = (a = ka) ? ll(a, t) : null;
      return a = a !== null && i !== null ? Vd(
        i,
        a,
        a.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(e) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        t,
        a
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        t,
        a
      ), !1;
    }
    function Fo(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === 3) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }
    function fr(e) {
      return e.replace(X, function(t, a) {
        return a.toUpperCase();
      });
    }
    function fp(e, t, a) {
      var i = t.indexOf("--") === 0;
      i || (-1 < t.indexOf("-") ? J.hasOwnProperty(t) && J[t] || (J[t] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        t,
        fr(t.replace(Xt, "ms-"))
      )) : Ye.test(t) ? J.hasOwnProperty(t) && J[t] || (J[t] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        t,
        t.charAt(0).toUpperCase() + t.slice(1)
      )) : !q.test(a) || ce.hasOwnProperty(a) && ce[a] || (ce[a] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        t,
        a.replace(q, "")
      )), typeof a == "number" && (isNaN(a) ? je || (je = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        t
      )) : isFinite(a) || Et || (Et = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        t
      )))), a == null || typeof a == "boolean" || a === "" ? i ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : i ? e.setProperty(t, a) : typeof a != "number" || a === 0 || Ne.has(t) ? t === "float" ? e.cssFloat = a : (wt(a, t), e[t] = ("" + a).trim()) : e[t] = a + "px";
    }
    function dp(e, t, a) {
      if (t != null && typeof t != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (t && Object.freeze(t), e = e.style, a != null) {
        if (t) {
          var i = {};
          if (a) {
            for (var c in a)
              if (a.hasOwnProperty(c) && !t.hasOwnProperty(c))
                for (var s = k[c] || [c], y = 0; y < s.length; y++)
                  i[s[y]] = c;
          }
          for (var b in t)
            if (t.hasOwnProperty(b) && (!a || a[b] !== t[b]))
              for (c = k[b] || [b], s = 0; s < c.length; s++)
                i[c[s]] = b;
          b = {};
          for (var A in t)
            for (c = k[A] || [A], s = 0; s < c.length; s++)
              b[c[s]] = A;
          A = {};
          for (var D in i)
            if (c = i[D], (s = b[D]) && c !== s && (y = c + "," + s, !A[y])) {
              A[y] = !0, y = console;
              var j = t[c];
              y.error.call(
                y,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                j == null || typeof j == "boolean" || j === "" ? "Removing" : "Updating",
                c,
                s
              );
            }
        }
        for (var V in a)
          !a.hasOwnProperty(V) || t != null && t.hasOwnProperty(V) || (V.indexOf("--") === 0 ? e.setProperty(V, "") : V === "float" ? e.cssFloat = "" : e[V] = "");
        for (var w in t)
          D = t[w], t.hasOwnProperty(w) && a[w] !== D && fp(e, w, D);
      } else
        for (i in t)
          t.hasOwnProperty(i) && fp(e, i, t[i]);
    }
    function Uu(e) {
      if (e.indexOf("-") === -1) return !1;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function E0(e) {
      return Dt.get(e) || e;
    }
    function T0(e, t) {
      if (bl.call(Sm, t) && Sm[t])
        return !0;
      if (ND.test(t)) {
        if (e = "aria-" + t.slice(4).toLowerCase(), e = Qv.hasOwnProperty(e) ? e : null, e == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            t
          ), Sm[t] = !0;
        if (t !== e)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            t,
            e
          ), Sm[t] = !0;
      }
      if (MD.test(t)) {
        if (e = t.toLowerCase(), e = Qv.hasOwnProperty(e) ? e : null, e == null) return Sm[t] = !0, !1;
        t !== e && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          t,
          e
        ), Sm[t] = !0);
      }
      return !0;
    }
    function A0(e, t) {
      var a = [], i;
      for (i in t)
        T0(e, i) || a.push(i);
      t = a.map(function(c) {
        return "`" + c + "`";
      }).join(", "), a.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      ) : 1 < a.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      );
    }
    function hp(e, t, a, i) {
      if (bl.call(Sl, t) && Sl[t])
        return !0;
      var c = t.toLowerCase();
      if (c === "onfocusin" || c === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), Sl[t] = !0;
      if (typeof a == "function" && (e === "form" && t === "action" || e === "input" && t === "formAction" || e === "button" && t === "formAction"))
        return !0;
      if (i != null) {
        if (e = i.possibleRegistrationNames, i.registrationNameDependencies.hasOwnProperty(t))
          return !0;
        if (i = e.hasOwnProperty(c) ? e[c] : null, i != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            t,
            i
          ), Sl[t] = !0;
        if (i2.test(t))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            t
          ), Sl[t] = !0;
      } else if (i2.test(t))
        return xD.test(t) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          t
        ), Sl[t] = !0;
      if (HD.test(t) || LD.test(t)) return !0;
      if (c === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), Sl[t] = !0;
      if (c === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), Sl[t] = !0;
      if (c === "is" && a !== null && a !== void 0 && typeof a != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof a
        ), Sl[t] = !0;
      if (typeof a == "number" && isNaN(a))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          t
        ), Sl[t] = !0;
      if (Eu.hasOwnProperty(c)) {
        if (c = Eu[c], c !== t)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            t,
            c
          ), Sl[t] = !0;
      } else if (t !== c)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          t,
          c
        ), Sl[t] = !0;
      switch (t) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof a) {
        case "boolean":
          switch (t) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return c = t.toLowerCase().slice(0, 5), c === "data-" || c === "aria-" ? !0 : (a ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                a,
                t,
                t,
                a,
                t
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                a,
                t,
                t,
                a,
                t,
                t,
                t
              ), Sl[t] = !0);
          }
        case "function":
        case "symbol":
          return Sl[t] = !0, !1;
        case "string":
          if (a === "false" || a === "true") {
            switch (t) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              a,
              t,
              a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              t,
              a
            ), Sl[t] = !0;
          }
      }
      return !0;
    }
    function Rb(e, t, a) {
      var i = [], c;
      for (c in t)
        hp(e, c, t[c], a) || i.push(c);
      t = i.map(function(s) {
        return "`" + s + "`";
      }).join(", "), i.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      ) : 1 < i.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      );
    }
    function Zs(e) {
      return BD.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    function Ul() {
    }
    function Pl(e) {
      return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
    }
    function Yd(e) {
      var t = Fl(e);
      if (t && (e = t.stateNode)) {
        var a = e[Ha] || null;
        e: switch (e = t.stateNode, t.type) {
          case "input":
            if (eo(
              e,
              a.value,
              a.defaultValue,
              a.defaultValue,
              a.checked,
              a.defaultChecked,
              a.type,
              a.name
            ), t = a.name, a.type === "radio" && t != null) {
              for (a = e; a.parentNode; ) a = a.parentNode;
              for (He(t, "name"), a = a.querySelectorAll(
                'input[name="' + qt(
                  "" + t
                ) + '"][type="radio"]'
              ), t = 0; t < a.length; t++) {
                var i = a[t];
                if (i !== e && i.form === e.form) {
                  var c = i[Ha] || null;
                  if (!c)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  eo(
                    i,
                    c.value,
                    c.defaultValue,
                    c.defaultValue,
                    c.checked,
                    c.defaultChecked,
                    c.type,
                    c.name
                  );
                }
              }
              for (t = 0; t < a.length; t++)
                i = a[t], i.form === e.form && ip(i);
            }
            break e;
          case "textarea":
            Ko(e, a.value, a.defaultValue);
            break e;
          case "select":
            t = a.value, t != null && zu(e, !!a.multiple, t, !1);
        }
      }
    }
    function Gd(e, t, a) {
      if (Vb) return e(t, a);
      Vb = !0;
      try {
        var i = e(t);
        return i;
      } finally {
        if (Vb = !1, (Em !== null || Tm !== null) && (yl(), Em && (t = Em, e = Tm, Tm = Em = null, Yd(t), e)))
          for (t = 0; t < e.length; t++) Yd(e[t]);
      }
    }
    function wu(e, t) {
      var a = e.stateNode;
      if (a === null) return null;
      var i = a[Ha] || null;
      if (i === null) return null;
      a = i[t];
      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (i = !i.disabled) || (e = e.type, i = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !i;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (a && typeof a != "function")
        throw Error(
          "Expected `" + t + "` listener to be a function, instead got a value of `" + typeof a + "` type."
        );
      return a;
    }
    function Wo() {
      if (Zv) return Zv;
      var e, t = Gb, a = t.length, i, c = "value" in ms ? ms.value : ms.textContent, s = c.length;
      for (e = 0; e < a && t[e] === c[e]; e++) ;
      var y = a - e;
      for (i = 1; i <= y && t[a - i] === c[s - i]; i++) ;
      return Zv = c.slice(e, 1 < i ? 1 - i : void 0);
    }
    function Js(e) {
      var t = e.keyCode;
      return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
    }
    function dr() {
      return !0;
    }
    function mp() {
      return !1;
    }
    function Yn(e) {
      function t(a, i, c, s, y) {
        this._reactName = a, this._targetInst = c, this.type = i, this.nativeEvent = s, this.target = y, this.currentTarget = null;
        for (var b in e)
          e.hasOwnProperty(b) && (a = e[b], this[b] = a ? a(s) : s[b]);
        return this.isDefaultPrevented = (s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1) ? dr : mp, this.isPropagationStopped = mp, this;
      }
      return ut(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = dr);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = dr);
        },
        persist: function() {
        },
        isPersistent: dr
      }), t;
    }
    function Ai(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : (e = FD[e]) ? !!t[e] : !1;
    }
    function Ks() {
      return Ai;
    }
    function hr(e, t) {
      switch (e) {
        case "keyup":
          return cR.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== s2;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Oi(e) {
      return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
    }
    function pp(e, t) {
      switch (e) {
        case "compositionend":
          return Oi(t);
        case "keypress":
          return t.which !== d2 ? null : (m2 = !0, h2);
        case "textInput":
          return e = t.data, e === h2 && m2 ? null : e;
        default:
          return null;
      }
    }
    function Xd(e, t) {
      if (Am)
        return e === "compositionend" || !Jb && hr(e, t) ? (e = Wo(), Zv = Gb = ms = null, Am = !1, e) : null;
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
            if (t.char && 1 < t.char.length)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return f2 && t.locale !== "ko" ? null : t.data;
        default:
          return null;
      }
    }
    function yp(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!sR[e.type] : t === "textarea";
    }
    function Qd(e) {
      if (!Lo) return !1;
      e = "on" + e;
      var t = e in document;
      return t || (t = document.createElement("div"), t.setAttribute(e, "return;"), t = typeof t[e] == "function"), t;
    }
    function ks(e, t, a, i) {
      Em ? Tm ? Tm.push(i) : Tm = [i] : Em = i, t = yu(t, "onChange"), 0 < t.length && (a = new Jv(
        "onChange",
        "change",
        null,
        a,
        i
      ), e.push({ event: a, listeners: t }));
    }
    function O0(e) {
      Ht(e, 0);
    }
    function aa(e) {
      var t = Pi(e);
      if (ip(t)) return e;
    }
    function ao(e, t) {
      if (e === "change") return t;
    }
    function $s() {
      mg && (mg.detachEvent("onpropertychange", mr), pg = mg = null);
    }
    function mr(e) {
      if (e.propertyName === "value" && aa(pg)) {
        var t = [];
        ks(
          t,
          pg,
          e,
          Pl(e)
        ), Gd(O0, t);
      }
    }
    function Cb(e, t, a) {
      e === "focusin" ? ($s(), mg = t, pg = a, mg.attachEvent("onpropertychange", mr)) : e === "focusout" && $s();
    }
    function gp(e) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return aa(pg);
    }
    function vp(e, t) {
      if (e === "click") return aa(t);
    }
    function Fs(e, t) {
      if (e === "input" || e === "change")
        return aa(t);
    }
    function Zd(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    function pr(e, t) {
      if (El(e, t)) return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), i = Object.keys(t);
      if (a.length !== i.length) return !1;
      for (i = 0; i < a.length; i++) {
        var c = a[i];
        if (!bl.call(t, c) || !El(e[c], t[c]))
          return !1;
      }
      return !0;
    }
    function D0(e) {
      for (; e && e.firstChild; ) e = e.firstChild;
      return e;
    }
    function R0(e, t) {
      var a = D0(e);
      e = 0;
      for (var i; a; ) {
        if (a.nodeType === 3) {
          if (i = e + a.textContent.length, e <= t && i >= t)
            return { node: a, offset: t - e };
          e = i;
        }
        e: {
          for (; a; ) {
            if (a.nextSibling) {
              a = a.nextSibling;
              break e;
            }
            a = a.parentNode;
          }
          a = void 0;
        }
        a = D0(a);
      }
    }
    function C0(e, t) {
      return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? C0(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
    }
    function Jd(e) {
      e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
      for (var t = Il(e.document); t instanceof e.HTMLIFrameElement; ) {
        try {
          var a = typeof t.contentWindow.location.href == "string";
        } catch {
          a = !1;
        }
        if (a) e = t.contentWindow;
        else break;
        t = Il(e.document);
      }
      return t;
    }
    function bp(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function z0(e, t, a) {
      var i = a.window === a ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
      kb || Om == null || Om !== Il(i) || (i = Om, "selectionStart" in i && bp(i) ? i = { start: i.selectionStart, end: i.selectionEnd } : (i = (i.ownerDocument && i.ownerDocument.defaultView || window).getSelection(), i = {
        anchorNode: i.anchorNode,
        anchorOffset: i.anchorOffset,
        focusNode: i.focusNode,
        focusOffset: i.focusOffset
      }), yg && pr(yg, i) || (yg = i, i = yu(Kb, "onSelect"), 0 < i.length && (t = new Jv(
        "onSelect",
        "select",
        null,
        t,
        a
      ), e.push({ event: t, listeners: i }), t.target = Om)));
    }
    function Io(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    function Po(e) {
      if ($b[e]) return $b[e];
      if (!Dm[e]) return e;
      var t = Dm[e], a;
      for (a in t)
        if (t.hasOwnProperty(a) && a in y2)
          return $b[e] = t[a];
      return e;
    }
    function eu(e, t) {
      E2.set(e, t), Wl(t, [e]);
    }
    function _0(e) {
      for (var t = kv, a = 0; a < e.length; a++) {
        var i = e[a];
        if (typeof i == "object" && i !== null)
          if (_n(i) && i.length === 2 && typeof i[0] == "string") {
            if (t !== kv && t !== eS)
              return Ib;
            t = eS;
          } else return Ib;
        else {
          if (typeof i == "function" || typeof i == "string" && 50 < i.length || t !== kv && t !== Pb)
            return Ib;
          t = Pb;
        }
      }
      return t;
    }
    function Sp(e, t, a, i) {
      for (var c in e)
        bl.call(e, c) && c[0] !== "_" && Mu(c, e[c], t, a, i);
    }
    function Mu(e, t, a, i, c) {
      switch (typeof t) {
        case "object":
          if (t === null) {
            t = "null";
            break;
          } else {
            if (t.$$typeof === Yl) {
              var s = Se(t.type) || "…", y = t.key;
              t = t.props;
              var b = Object.keys(t), A = b.length;
              if (y == null && A === 0) {
                t = "<" + s + " />";
                break;
              }
              if (3 > i || A === 1 && b[0] === "children" && y == null) {
                t = "<" + s + " … />";
                break;
              }
              a.push([
                c + "  ".repeat(i) + e,
                "<" + s
              ]), y !== null && Mu(
                "key",
                y,
                a,
                i + 1,
                c
              ), e = !1;
              for (var D in t)
                D === "children" ? t.children != null && (!_n(t.children) || 0 < t.children.length) && (e = !0) : bl.call(t, D) && D[0] !== "_" && Mu(
                  D,
                  t[D],
                  a,
                  i + 1,
                  c
                );
              a.push([
                "",
                e ? ">…</" + s + ">" : "/>"
              ]);
              return;
            }
            if (s = Object.prototype.toString.call(t), s = s.slice(8, s.length - 1), s === "Array") {
              if (D = _0(t), D === Pb || D === kv) {
                t = JSON.stringify(t);
                break;
              } else if (D === eS) {
                for (a.push([
                  c + "  ".repeat(i) + e,
                  ""
                ]), e = 0; e < t.length; e++)
                  s = t[e], Mu(
                    s[0],
                    s[1],
                    a,
                    i + 1,
                    c
                  );
                return;
              }
            }
            if (s === "Promise") {
              if (t.status === "fulfilled") {
                if (s = a.length, Mu(
                  e,
                  t.value,
                  a,
                  i,
                  c
                ), a.length > s) {
                  a = a[s], a[1] = "Promise<" + (a[1] || "Object") + ">";
                  return;
                }
              } else if (t.status === "rejected" && (s = a.length, Mu(
                e,
                t.reason,
                a,
                i,
                c
              ), a.length > s)) {
                a = a[s], a[1] = "Rejected Promise<" + a[1] + ">";
                return;
              }
              a.push([
                "  ".repeat(i) + e,
                "Promise"
              ]);
              return;
            }
            s === "Object" && (D = Object.getPrototypeOf(t)) && typeof D.constructor == "function" && (s = D.constructor.name), a.push([
              c + "  ".repeat(i) + e,
              s === "Object" ? 3 > i ? "" : "…" : s
            ]), 3 > i && Sp(t, a, i + 1, c);
            return;
          }
        case "function":
          t = t.name === "" ? "() => {}" : t.name + "() {}";
          break;
        case "string":
          t = t === gR ? "…" : JSON.stringify(t);
          break;
        case "undefined":
          t = "undefined";
          break;
        case "boolean":
          t = t ? "true" : "false";
          break;
        default:
          t = String(t);
      }
      a.push([
        c + "  ".repeat(i) + e,
        t
      ]);
    }
    function U0(e, t, a, i) {
      var c = !0;
      for (y in e)
        y in t || (a.push([
          $v + "  ".repeat(i) + y,
          "…"
        ]), c = !1);
      for (var s in t)
        if (s in e) {
          var y = e[s], b = t[s];
          if (y !== b) {
            if (i === 0 && s === "children")
              c = "  ".repeat(i) + s, a.push(
                [$v + c, "…"],
                [Fv + c, "…"]
              );
            else {
              if (!(3 <= i)) {
                if (typeof y == "object" && typeof b == "object" && y !== null && b !== null && y.$$typeof === b.$$typeof)
                  if (b.$$typeof === Yl) {
                    if (y.type === b.type && y.key === b.key) {
                      y = Se(b.type) || "…", c = "  ".repeat(i) + s, y = "<" + y + " … />", a.push(
                        [$v + c, y],
                        [Fv + c, y]
                      ), c = !1;
                      continue;
                    }
                  } else {
                    var A = Object.prototype.toString.call(y), D = Object.prototype.toString.call(b);
                    if (A === D && (D === "[object Object]" || D === "[object Array]")) {
                      A = [
                        O2 + "  ".repeat(i) + s,
                        D === "[object Array]" ? "Array" : ""
                      ], a.push(A), D = a.length, U0(
                        y,
                        b,
                        a,
                        i + 1
                      ) ? D === a.length && (A[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : c = !1;
                      continue;
                    }
                  }
                else if (typeof y == "function" && typeof b == "function" && y.name === b.name && y.length === b.length && (A = Function.prototype.toString.call(y), D = Function.prototype.toString.call(b), A === D)) {
                  y = b.name === "" ? "() => {}" : b.name + "() {}", a.push([
                    O2 + "  ".repeat(i) + s,
                    y + " Referentially unequal function closure. Consider memoization."
                  ]);
                  continue;
                }
              }
              Mu(s, y, a, i, $v), Mu(s, b, a, i, Fv);
            }
            c = !1;
          }
        } else
          a.push([
            Fv + "  ".repeat(i) + s,
            "…"
          ]), c = !1;
      return c;
    }
    function tu(e) {
      bt = e & 63 ? "Blocking" : e & 64 ? "Gesture" : e & 4194176 ? "Transition" : e & 62914560 ? "Suspense" : e & 2080374784 ? "Idle" : "Other";
    }
    function wl(e, t, a, i) {
      un && (ys.start = t, ys.end = a, jc.color = "warning", jc.tooltipText = i, jc.properties = null, (e = e._debugTask) ? e.run(
        performance.measure.bind(
          performance,
          i,
          ys
        )
      ) : performance.measure(i, ys));
    }
    function Kd(e, t, a) {
      wl(e, t, a, "Reconnect");
    }
    function kd(e, t, a, i, c) {
      var s = ae(e);
      if (s !== null && un) {
        var y = e.alternate, b = e.actualDuration;
        if (y === null || y.child !== e.child)
          for (var A = e.child; A !== null; A = A.sibling)
            b -= A.actualDuration;
        i = 0.5 > b ? i ? "tertiary-light" : "primary-light" : 10 > b ? i ? "tertiary" : "primary" : 100 > b ? i ? "tertiary-dark" : "primary-dark" : "error";
        var D = e.memoizedProps;
        b = e._debugTask, D !== null && y !== null && y.memoizedProps !== D ? (A = [vR], D = U0(
          y.memoizedProps,
          D,
          A,
          0
        ), 1 < A.length && (D && !ps && (y.lanes & c) === 0 && 100 < e.actualDuration ? (ps = !0, A[0] = bR, jc.color = "warning", jc.tooltipText = D2) : (jc.color = i, jc.tooltipText = s), jc.properties = A, ys.start = t, ys.end = a, b != null ? b.run(
          performance.measure.bind(
            performance,
            "​" + s,
            ys
          )
        ) : performance.measure(
          "​" + s,
          ys
        ))) : b != null ? b.run(
          console.timeStamp.bind(
            console,
            s,
            t,
            a,
            ui,
            void 0,
            i
          )
        ) : console.timeStamp(
          s,
          t,
          a,
          ui,
          void 0,
          i
        );
      }
    }
    function Ep(e, t, a, i) {
      if (un) {
        var c = ae(e);
        if (c !== null) {
          for (var s = null, y = [], b = 0; b < i.length; b++) {
            var A = i[b];
            s == null && A.source !== null && (s = A.source._debugTask), A = A.value, y.push([
              "Error",
              typeof A == "object" && A !== null && typeof A.message == "string" ? String(A.message) : String(A)
            ]);
          }
          e.key !== null && Mu("key", e.key, y, 0, ""), e.memoizedProps !== null && Sp(e.memoizedProps, y, 0, ""), s == null && (s = e._debugTask), e = {
            start: t,
            end: a,
            detail: {
              devtools: {
                color: "error",
                track: ui,
                tooltipText: e.tag === 13 ? "Hydration failed" : "Error boundary caught an error",
                properties: y
              }
            }
          }, s ? s.run(
            performance.measure.bind(performance, "​" + c, e)
          ) : performance.measure("​" + c, e);
        }
      }
    }
    function nu(e, t, a, i, c) {
      if (c !== null) {
        if (un) {
          var s = ae(e);
          if (s !== null) {
            i = [];
            for (var y = 0; y < c.length; y++) {
              var b = c[y].value;
              i.push([
                "Error",
                typeof b == "object" && b !== null && typeof b.message == "string" ? String(b.message) : String(b)
              ]);
            }
            e.key !== null && Mu("key", e.key, i, 0, ""), e.memoizedProps !== null && Sp(e.memoizedProps, i, 0, ""), t = {
              start: t,
              end: a,
              detail: {
                devtools: {
                  color: "error",
                  track: ui,
                  tooltipText: "A lifecycle or effect errored",
                  properties: i
                }
              }
            }, (e = e._debugTask) ? e.run(
              performance.measure.bind(
                performance,
                "​" + s,
                t
              )
            ) : performance.measure("​" + s, t);
          }
        }
      } else
        s = ae(e), s !== null && un && (c = 1 > i ? "secondary-light" : 100 > i ? "secondary" : 500 > i ? "secondary-dark" : "error", (e = e._debugTask) ? e.run(
          console.timeStamp.bind(
            console,
            s,
            t,
            a,
            ui,
            void 0,
            c
          )
        ) : console.timeStamp(
          s,
          t,
          a,
          ui,
          void 0,
          c
        ));
    }
    function zb(e, t, a, i) {
      if (un && !(t <= e)) {
        var c = (a & 738197653) === a ? "tertiary-dark" : "primary-dark";
        a = (a & 536870912) === a ? "Prepared" : (a & 201326741) === a ? "Hydrated" : "Render", i ? i.run(
          console.timeStamp.bind(
            console,
            a,
            e,
            t,
            bt,
            yt,
            c
          )
        ) : console.timeStamp(
          a,
          e,
          t,
          bt,
          yt,
          c
        );
      }
    }
    function w0(e, t, a, i) {
      !un || t <= e || (a = (a & 738197653) === a ? "tertiary-dark" : "primary-dark", i ? i.run(
        console.timeStamp.bind(
          console,
          "Prewarm",
          e,
          t,
          bt,
          yt,
          a
        )
      ) : console.timeStamp(
        "Prewarm",
        e,
        t,
        bt,
        yt,
        a
      ));
    }
    function M0(e, t, a, i) {
      !un || t <= e || (a = (a & 738197653) === a ? "tertiary-dark" : "primary-dark", i ? i.run(
        console.timeStamp.bind(
          console,
          "Suspended",
          e,
          t,
          bt,
          yt,
          a
        )
      ) : console.timeStamp(
        "Suspended",
        e,
        t,
        bt,
        yt,
        a
      ));
    }
    function _b(e, t, a, i, c, s) {
      if (un && !(t <= e)) {
        a = [];
        for (var y = 0; y < i.length; y++) {
          var b = i[y].value;
          a.push([
            "Recoverable Error",
            typeof b == "object" && b !== null && typeof b.message == "string" ? String(b.message) : String(b)
          ]);
        }
        e = {
          start: e,
          end: t,
          detail: {
            devtools: {
              color: "primary-dark",
              track: bt,
              trackGroup: yt,
              tooltipText: c ? "Hydration Failed" : "Recovered after Error",
              properties: a
            }
          }
        }, s ? s.run(
          performance.measure.bind(performance, "Recovered", e)
        ) : performance.measure("Recovered", e);
      }
    }
    function Tp(e, t, a, i) {
      !un || t <= e || (i ? i.run(
        console.timeStamp.bind(
          console,
          "Errored",
          e,
          t,
          bt,
          yt,
          "error"
        )
      ) : console.timeStamp(
        "Errored",
        e,
        t,
        bt,
        yt,
        "error"
      ));
    }
    function Ub(e, t, a, i) {
      !un || t <= e || (i ? i.run(
        console.timeStamp.bind(
          console,
          a,
          e,
          t,
          bt,
          yt,
          "secondary-light"
        )
      ) : console.timeStamp(
        a,
        e,
        t,
        bt,
        yt,
        "secondary-light"
      ));
    }
    function N0(e, t, a, i, c) {
      if (un && !(t <= e)) {
        for (var s = [], y = 0; y < a.length; y++) {
          var b = a[y].value;
          s.push([
            "Error",
            typeof b == "object" && b !== null && typeof b.message == "string" ? String(b.message) : String(b)
          ]);
        }
        e = {
          start: e,
          end: t,
          detail: {
            devtools: {
              color: "error",
              track: bt,
              trackGroup: yt,
              tooltipText: i ? "Remaining Effects Errored" : "Commit Errored",
              properties: s
            }
          }
        }, c ? c.run(
          performance.measure.bind(performance, "Errored", e)
        ) : performance.measure("Errored", e);
      }
    }
    function Ap(e, t, a) {
      !un || t <= e || console.timeStamp(
        "Animating",
        e,
        t,
        bt,
        yt,
        "secondary-dark"
      );
    }
    function $d() {
      for (var e = Rm, t = tS = Rm = 0; t < e; ) {
        var a = ii[t];
        ii[t++] = null;
        var i = ii[t];
        ii[t++] = null;
        var c = ii[t];
        ii[t++] = null;
        var s = ii[t];
        if (ii[t++] = null, i !== null && c !== null) {
          var y = i.pending;
          y === null ? c.next = c : (c.next = y.next, y.next = c), i.pending = c;
        }
        s !== 0 && Op(a, c, s);
      }
    }
    function yr(e, t, a, i) {
      ii[Rm++] = e, ii[Rm++] = t, ii[Rm++] = a, ii[Rm++] = i, tS |= i, e.lanes |= i, e = e.alternate, e !== null && (e.lanes |= i);
    }
    function ec(e, t, a, i) {
      return yr(e, t, a, i), Ws(e);
    }
    function ra(e, t) {
      return yr(e, null, null, t), Ws(e);
    }
    function Op(e, t, a) {
      e.lanes |= a;
      var i = e.alternate;
      i !== null && (i.lanes |= a);
      for (var c = !1, s = e.return; s !== null; )
        s.childLanes |= a, i = s.alternate, i !== null && (i.childLanes |= a), s.tag === 22 && (e = s.stateNode, e === null || e._visibility & gg || (c = !0)), e = s, s = s.return;
      return e.tag === 3 ? (s = e.stateNode, c && t !== null && (c = 31 - ua(a), e = s.hiddenUpdates, i = e[c], i === null ? e[c] = [t] : i.push(t), t.lane = a | 536870912), s) : null;
    }
    function Ws(e) {
      if (Qg > HR)
        throw Sd = Qg = 0, Zg = xS = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      Sd > LR && (Sd = 0, Zg = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), e.alternate === null && (e.flags & 4098) !== 0 && Vl(e);
      for (var t = e, a = t.return; a !== null; )
        t.alternate === null && (t.flags & 4098) !== 0 && Vl(e), t = a, a = t.return;
      return t.tag === 3 ? t.stateNode : null;
    }
    function lo(e) {
      if (oi === null) return e;
      var t = oi(e);
      return t === void 0 ? e : t.current;
    }
    function Fd(e) {
      if (oi === null) return e;
      var t = oi(e);
      return t === void 0 ? e != null && typeof e.render == "function" && (t = lo(e.render), e.render !== t) ? (t = { $$typeof: as, render: t }, e.displayName !== void 0 && (t.displayName = e.displayName), t) : e : t.current;
    }
    function Dp(e, t) {
      if (oi === null) return !1;
      var a = e.elementType;
      t = t.type;
      var i = !1, c = typeof t == "object" && t !== null ? t.$$typeof : null;
      switch (e.tag) {
        case 1:
          typeof t == "function" && (i = !0);
          break;
        case 0:
          (typeof t == "function" || c === da) && (i = !0);
          break;
        case 11:
          (c === as || c === da) && (i = !0);
          break;
        case 14:
        case 15:
          (c === If || c === da) && (i = !0);
          break;
        default:
          return !1;
      }
      return !!(i && (e = oi(a), e !== void 0 && e === oi(t)));
    }
    function tc(e) {
      oi !== null && typeof WeakSet == "function" && (Cm === null && (Cm = /* @__PURE__ */ new WeakSet()), Cm.add(e));
    }
    function x0(e, t, a) {
      do {
        var i = e, c = i.alternate, s = i.child, y = i.sibling, b = i.tag;
        i = i.type;
        var A = null;
        switch (b) {
          case 0:
          case 15:
          case 1:
            A = i;
            break;
          case 11:
            A = i.render;
        }
        if (oi === null)
          throw Error("Expected resolveFamily to be set during hot reload.");
        var D = !1;
        if (i = !1, A !== null && (A = oi(A), A !== void 0 && (a.has(A) ? i = !0 : t.has(A) && (b === 1 ? i = !0 : D = !0))), Cm !== null && (Cm.has(e) || c !== null && Cm.has(c)) && (i = !0), i && (e._debugNeedsRemount = !0), (i || D) && (c = ra(e, 2), c !== null && Ze(c, e, 2)), s === null || i || x0(
          s,
          t,
          a
        ), y === null) break;
        e = y;
      } while (!0);
    }
    function wb(e, t, a, i) {
      this.tag = e, this.key = a, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, R2 || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function Rp(e) {
      return e = e.prototype, !(!e || !e.isReactComponent);
    }
    function Nu(e, t) {
      var a = e.alternate;
      switch (a === null ? (a = L(
        e.tag,
        t,
        e.key,
        e.mode
      ), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugOwner = e._debugOwner, a._debugStack = e._debugStack, a._debugTask = e._debugTask, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = 0, a.subtreeFlags = 0, a.deletions = null, a.actualDuration = -0, a.actualStartTime = -1.1), a.flags = e.flags & 65011712, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue, t = e.dependencies, a.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext,
        _debugThenableState: t._debugThenableState
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.refCleanup = e.refCleanup, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugInfo = e._debugInfo, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case 0:
        case 15:
          a.type = lo(e.type);
          break;
        case 1:
          a.type = lo(e.type);
          break;
        case 11:
          a.type = Fd(e.type);
      }
      return a;
    }
    function Cp(e, t) {
      e.flags &= 65011714;
      var a = e.alternate;
      return a === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type, t = a.dependencies, e.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext,
        _debugThenableState: t._debugThenableState
      }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration), e;
    }
    function nc(e, t, a, i, c, s) {
      var y = 0, b = e;
      if (typeof e == "function")
        Rp(e) && (y = 1), b = lo(b);
      else if (typeof e == "string")
        y = ue(), y = _v(e, a, y) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
      else
        e: switch (e) {
          case Su:
            return t = L(31, a, t, c), t.elementType = Su, t.lanes = s, t;
          case ns:
            return ac(
              a.children,
              c,
              s,
              t
            );
          case xa:
            y = 8, c |= $a, c |= Zi;
            break;
          case Wf:
            return e = a, i = c, typeof e.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof e.id
            ), t = L(12, e, t, i | it), t.elementType = Wf, t.lanes = s, t.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, t;
          case Nc:
            return t = L(13, a, t, c), t.elementType = Nc, t.lanes = s, t;
          case Ka:
            return t = L(19, a, t, c), t.elementType = Ka, t.lanes = s, t;
          default:
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case bu:
                  y = 10;
                  break e;
                case cm:
                  y = 9;
                  break e;
                case as:
                  y = 11, b = Fd(b);
                  break e;
                case If:
                  y = 14;
                  break e;
                case da:
                  y = 16, b = null;
                  break e;
              }
            b = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? a = "null" : _n(e) ? a = "array" : e !== void 0 && e.$$typeof === Yl ? (a = "<" + (Se(e.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : a = typeof e, (y = i ? xe(i) : null) && (b += `

Check the render method of \`` + y + "`."), y = 29, a = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (a + "." + b)
            ), b = null;
        }
      return t = L(y, a, t, c), t.elementType = e, t.type = b, t.lanes = s, t._debugOwner = i, t;
    }
    function uo(e, t, a) {
      return t = nc(
        e.type,
        e.key,
        e.props,
        e._owner,
        t,
        a
      ), t._debugOwner = e._owner, t._debugStack = e._debugStack, t._debugTask = e._debugTask, t;
    }
    function ac(e, t, a, i) {
      return e = L(7, e, i, t), e.lanes = a, e;
    }
    function gr(e, t, a) {
      return e = L(6, e, null, t), e.lanes = a, e;
    }
    function zp(e) {
      var t = L(18, null, null, Qe);
      return t.stateNode = e, t;
    }
    function Wd(e, t, a) {
      return t = L(
        4,
        e.children !== null ? e.children : [],
        e.key,
        t
      ), t.lanes = a, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }
    function Ea(e, t) {
      if (typeof e == "object" && e !== null) {
        var a = nS.get(e);
        return a !== void 0 ? a : (t = {
          value: e,
          source: t,
          stack: ft(t)
        }, nS.set(e, t), t);
      }
      return {
        value: e,
        source: t,
        stack: ft(t)
      };
    }
    function au(e, t) {
      io(), zm[_m++] = vg, zm[_m++] = Wv, Wv = e, vg = t;
    }
    function _p(e, t, a) {
      io(), ci[ri++] = Vc, ci[ri++] = Yc, ci[ri++] = ud, ud = e;
      var i = Vc;
      e = Yc;
      var c = 32 - ua(i) - 1;
      i &= ~(1 << c), a += 1;
      var s = 32 - ua(t) + c;
      if (30 < s) {
        var y = c - c % 5;
        s = (i & (1 << y) - 1).toString(32), i >>= y, c -= y, Vc = 1 << 32 - ua(t) + c | a << c | i, Yc = s + e;
      } else
        Vc = 1 << s | a << c | i, Yc = e;
    }
    function Id(e) {
      io(), e.return !== null && (au(e, 1), _p(e, 1, 0));
    }
    function Pd(e) {
      for (; e === Wv; )
        Wv = zm[--_m], zm[_m] = null, vg = zm[--_m], zm[_m] = null;
      for (; e === ud; )
        ud = ci[--ri], ci[ri] = null, Yc = ci[--ri], ci[ri] = null, Vc = ci[--ri], ci[ri] = null;
    }
    function H0() {
      return io(), ud !== null ? { id: Vc, overflow: Yc } : null;
    }
    function L0(e, t) {
      io(), ci[ri++] = Vc, ci[ri++] = Yc, ci[ri++] = ud, Vc = t.id, Yc = t.overflow, ud = e;
    }
    function io() {
      pt || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function lc(e, t) {
      if (e.return === null) {
        if (Tu === null)
          Tu = {
            fiber: e,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: t
          };
        else {
          if (Tu.fiber !== e)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          Tu.distanceFromLeaf > t && (Tu.distanceFromLeaf = t);
        }
        return Tu;
      }
      var a = lc(
        e.return,
        t + 1
      ).children;
      return 0 < a.length && a[a.length - 1].fiber === e ? (a = a[a.length - 1], a.distanceFromLeaf > t && (a.distanceFromLeaf = t), a) : (t = {
        fiber: e,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: t
      }, a.push(t), t);
    }
    function B0() {
      pt && console.error(
        "We should not be hydrating here. This is a bug in React. Please file a bug."
      );
    }
    function sa(e, t) {
      Bo || (e = lc(e, 0), e.serverProps = null, t !== null && (t = Dv(t), e.serverTail.push(t)));
    }
    function Ml(e) {
      var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : !1, a = "", i = Tu;
      throw i !== null && (Tu = null, a = rp(i)), Ps(
        Ea(
          Error(
            "Hydration failed because the server rendered " + (t ? "text" : "HTML") + ` didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + a
          ),
          e
        )
      ), aS;
    }
    function Up(e) {
      var t = e.stateNode, a = e.type, i = e.memoizedProps;
      switch (t[ln] = e, t[Ha] = i, Ma(a, i), a) {
        case "dialog":
          Xe("cancel", t), Xe("close", t);
          break;
        case "iframe":
        case "object":
        case "embed":
          Xe("load", t);
          break;
        case "video":
        case "audio":
          for (a = 0; a < Jg.length; a++)
            Xe(Jg[a], t);
          break;
        case "source":
          Xe("error", t);
          break;
        case "img":
        case "image":
        case "link":
          Xe("error", t), Xe("load", t);
          break;
        case "details":
          Xe("toggle", t);
          break;
        case "input":
          Zo("input", i), Xe("invalid", t), Sa(t, i), xd(
            t,
            i.value,
            i.defaultValue,
            i.checked,
            i.defaultChecked,
            i.type,
            i.name,
            !0
          );
          break;
        case "option":
          S0(t, i);
          break;
        case "select":
          Zo("select", i), Xe("invalid", t), Hd(t, i);
          break;
        case "textarea":
          Zo("textarea", i), Xe("invalid", t), Jo(t, i), or(
            t,
            i.value,
            i.defaultValue,
            i.children
          );
      }
      a = i.children, typeof a != "string" && typeof a != "number" && typeof a != "bigint" || t.textContent === "" + a || i.suppressHydrationWarning === !0 || My(t.textContent, a) ? (i.popover != null && (Xe("beforetoggle", t), Xe("toggle", t)), i.onScroll != null && Xe("scroll", t), i.onScrollEnd != null && Xe("scrollend", t), i.onClick != null && (t.onclick = Ul), t = !0) : t = !1, t || Ml(e, !0);
    }
    function wp(e) {
      for (La = e.return; La; )
        switch (La.tag) {
          case 5:
          case 31:
          case 13:
            si = !1;
            return;
          case 27:
          case 3:
            si = !0;
            return;
          default:
            La = La.return;
        }
    }
    function uc(e) {
      if (e !== La) return !1;
      if (!pt)
        return wp(e), pt = !0, !1;
      var t = e.tag, a;
      if ((a = t !== 3 && t !== 27) && ((a = t === 5) && (a = e.type, a = !(a !== "form" && a !== "button") || kr(e.type, e.memoizedProps)), a = !a), a && on) {
        for (a = on; a; ) {
          var i = lc(e, 0), c = Dv(a);
          i.serverTail.push(c), a = c.type === "Suspense" ? Wr(a) : gl(a.nextSibling);
        }
        Ml(e);
      }
      if (wp(e), t === 13) {
        if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        on = Wr(e);
      } else if (t === 31) {
        if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        on = Wr(e);
      } else
        t === 27 ? (t = on, Uo(e.type) ? (e = JS, JS = null, on = e) : on = t) : on = La ? gl(e.stateNode.nextSibling) : null;
      return !0;
    }
    function oo() {
      on = La = null, Bo = pt = !1;
    }
    function Is() {
      var e = vs;
      return e !== null && (Dl === null ? Dl = e : Dl.push.apply(
        Dl,
        e
      ), vs = null), e;
    }
    function Ps(e) {
      vs === null ? vs = [e] : vs.push(e);
    }
    function co() {
      var e = Tu;
      if (e !== null) {
        Tu = null;
        for (var t = rp(e); 0 < e.children.length; )
          e = e.children[0];
        Ae(e.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            t
          );
        });
      }
    }
    function vr() {
      Um = Iv = null, wm = !1;
    }
    function Nl(e, t, a) {
      we(lS, t._currentValue, e), t._currentValue = a, we(uS, t._currentRenderer, e), t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== z2 && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), t._currentRenderer = z2;
    }
    function lu(e, t) {
      e._currentValue = lS.current;
      var a = uS.current;
      Ce(uS, t), e._currentRenderer = a, Ce(lS, t);
    }
    function eh(e, t, a) {
      for (; e !== null; ) {
        var i = e.alternate;
        if ((e.childLanes & t) !== t ? (e.childLanes |= t, i !== null && (i.childLanes |= t)) : i !== null && (i.childLanes & t) !== t && (i.childLanes |= t), e === a) break;
        e = e.return;
      }
      e !== a && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Di(e, t, a, i) {
      var c = e.child;
      for (c !== null && (c.return = e); c !== null; ) {
        var s = c.dependencies;
        if (s !== null) {
          var y = c.child;
          s = s.firstContext;
          e: for (; s !== null; ) {
            var b = s;
            s = c;
            for (var A = 0; A < t.length; A++)
              if (b.context === t[A]) {
                s.lanes |= a, b = s.alternate, b !== null && (b.lanes |= a), eh(
                  s.return,
                  a,
                  e
                ), i || (y = null);
                break e;
              }
            s = b.next;
          }
        } else if (c.tag === 18) {
          if (y = c.return, y === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          y.lanes |= a, s = y.alternate, s !== null && (s.lanes |= a), eh(
            y,
            a,
            e
          ), y = null;
        } else y = c.child;
        if (y !== null) y.return = c;
        else
          for (y = c; y !== null; ) {
            if (y === e) {
              y = null;
              break;
            }
            if (c = y.sibling, c !== null) {
              c.return = y.return, y = c;
              break;
            }
            y = y.return;
          }
        c = y;
      }
    }
    function uu(e, t, a, i) {
      e = null;
      for (var c = t, s = !1; c !== null; ) {
        if (!s) {
          if ((c.flags & 524288) !== 0) s = !0;
          else if ((c.flags & 262144) !== 0) break;
        }
        if (c.tag === 10) {
          var y = c.alternate;
          if (y === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (y = y.memoizedProps, y !== null) {
            var b = c.type;
            El(c.pendingProps.value, y.value) || (e !== null ? e.push(b) : e = [b]);
          }
        } else if (c === xo.current) {
          if (y = c.alternate, y === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          y.memoizedState.memoizedState !== c.memoizedState.memoizedState && (e !== null ? e.push(Wg) : e = [Wg]);
        }
        c = c.return;
      }
      e !== null && Di(
        t,
        e,
        a,
        i
      ), t.flags |= 262144;
    }
    function br(e) {
      for (e = e.firstContext; e !== null; ) {
        if (!El(
          e.context._currentValue,
          e.memoizedValue
        ))
          return !0;
        e = e.next;
      }
      return !1;
    }
    function ro(e) {
      Iv = e, Um = null, e = e.dependencies, e !== null && (e.firstContext = null);
    }
    function Ct(e) {
      return wm && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), Mp(Iv, e);
    }
    function ef(e, t) {
      return Iv === null && ro(e), Mp(e, t);
    }
    function Mp(e, t) {
      var a = t._currentValue;
      if (t = { context: t, memoizedValue: a, next: null }, Um === null) {
        if (e === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        Um = t, e.dependencies = {
          lanes: 0,
          firstContext: t,
          _debugThenableState: null
        }, e.flags |= 524288;
      } else Um = Um.next = t;
      return a;
    }
    function th() {
      return {
        controller: new TR(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function ic(e) {
      e.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      ), e.refCount++;
    }
    function tf(e) {
      e.refCount--, 0 > e.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      ), e.refCount === 0 && AR(OR, function() {
        e.controller.abort();
      });
    }
    function xu(e, t, a) {
      (e & 127) !== 0 ? 0 > jo && (jo = Fn(), Sg = Pv(t), iS = t, a != null && (oS = ae(a)), (Tt & (ca | Du)) !== ya && (On = !0, Ss = bg), e = $r(), t = Pu(), e !== Mm || t !== Eg ? Mm = -1.1 : t !== null && (Ss = bg), cd = e, Eg = t) : (e & 4194048) !== 0 && 0 > fi && (fi = Fn(), Tg = Pv(t), _2 = t, a != null && (U2 = ae(a)), 0 > Zc) && (e = $r(), t = Pu(), (e !== Ts || t !== rd) && (Ts = -1.1), Es = e, rd = t);
    }
    function j0(e) {
      if (0 > jo) {
        jo = Fn(), Sg = e._debugTask != null ? e._debugTask : null, (Tt & (ca | Du)) !== ya && (Ss = bg);
        var t = $r(), a = Pu();
        t !== Mm || a !== Eg ? Mm = -1.1 : a !== null && (Ss = bg), cd = t, Eg = a;
      }
      0 > fi && (fi = Fn(), Tg = e._debugTask != null ? e._debugTask : null, 0 > Zc) && (e = $r(), t = Pu(), (e !== Ts || t !== rd) && (Ts = -1.1), Es = e, rd = t);
    }
    function Hu() {
      var e = id;
      return id = 0, e;
    }
    function Sr(e) {
      var t = id;
      return id = e, t;
    }
    function Ta(e) {
      var t = id;
      return id += e, t;
    }
    function oc() {
      Ge = Ve = -1.1;
    }
    function tn() {
      var e = Ve;
      return Ve = -1.1, e;
    }
    function Gn(e) {
      0 <= e && (Ve = e);
    }
    function xl() {
      var e = yn;
      return yn = -0, e;
    }
    function ul(e) {
      0 <= e && (yn = e);
    }
    function il() {
      var e = dn;
      return dn = null, e;
    }
    function Hl() {
      var e = On;
      return On = !1, e;
    }
    function Ri(e) {
      Tl = Fn(), 0 > e.actualStartTime && (e.actualStartTime = Tl);
    }
    function nh(e) {
      if (0 <= Tl) {
        var t = Fn() - Tl;
        e.actualDuration += t, e.selfBaseDuration = t, Tl = -1;
      }
    }
    function nf(e) {
      if (0 <= Tl) {
        var t = Fn() - Tl;
        e.actualDuration += t, Tl = -1;
      }
    }
    function Aa() {
      if (0 <= Tl) {
        var e = Fn(), t = e - Tl;
        Tl = -1, id += t, yn += t, Ge = e;
      }
    }
    function q0(e) {
      dn === null && (dn = []), dn.push(e), Xc === null && (Xc = []), Xc.push(e);
    }
    function hn() {
      Tl = Fn(), 0 > Ve && (Ve = Tl);
    }
    function cc(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function Ci(e, t) {
      if (Og === null) {
        var a = Og = [];
        rS = 0, sd = wy(), Nm = {
          status: "pending",
          value: void 0,
          then: function(i) {
            a.push(i);
          }
        };
      }
      return rS++, t.then(Np, Np), t;
    }
    function Np() {
      if (--rS === 0 && (-1 < fi || (Zc = -1.1), Og !== null)) {
        Nm !== null && (Nm.status = "fulfilled");
        var e = Og;
        Og = null, sd = 0, Nm = null;
        for (var t = 0; t < e.length; t++) (0, e[t])();
      }
    }
    function ah(e, t) {
      var a = [], i = {
        status: "pending",
        value: null,
        reason: null,
        then: function(c) {
          a.push(c);
        }
      };
      return e.then(
        function() {
          i.status = "fulfilled", i.value = t;
          for (var c = 0; c < a.length; c++) (0, a[c])(t);
        },
        function(c) {
          for (i.status = "rejected", i.reason = c, c = 0; c < a.length; c++)
            (0, a[c])(void 0);
        }
      ), i;
    }
    function zi() {
      var e = fd.current;
      return e !== null ? e : Ft.pooledCache;
    }
    function Er(e, t) {
      t === null ? we(fd, fd.current, e) : we(fd, t.pool, e);
    }
    function xp() {
      var e = zi();
      return e === null ? null : { parent: $n._currentValue, pool: e };
    }
    function lh() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function Hp(e) {
      return e = e.status, e === "fulfilled" || e === "rejected";
    }
    function ol(e, t, a) {
      I.actQueue !== null && (I.didUsePromise = !0);
      var i = e.thenables;
      if (a = i[a], a === void 0 ? i.push(t) : a !== t && (e.didWarnAboutUncachedPromise || (e.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), t.then(Ul, Ul), t = a), t._debugInfo === void 0) {
        e = performance.now(), i = t.displayName;
        var c = {
          name: typeof i == "string" ? i : "Promise",
          start: e,
          end: e,
          value: t
        };
        t._debugInfo = [{ awaited: c }], t.status !== "fulfilled" && t.status !== "rejected" && (e = function() {
          c.end = performance.now();
        }, t.then(e, e));
      }
      switch (t.status) {
        case "fulfilled":
          return t.value;
        case "rejected":
          throw e = t.reason, af(e), e;
        default:
          if (typeof t.status == "string")
            t.then(Ul, Ul);
          else {
            if (e = Ft, e !== null && 100 < e.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            e = t, e.status = "pending", e.then(
              function(s) {
                if (t.status === "pending") {
                  var y = t;
                  y.status = "fulfilled", y.value = s;
                }
              },
              function(s) {
                if (t.status === "pending") {
                  var y = t;
                  y.status = "rejected", y.reason = s;
                }
              }
            );
          }
          switch (t.status) {
            case "fulfilled":
              return t.value;
            case "rejected":
              throw e = t.reason, af(e), e;
          }
          throw hd = t, wg = !0, xm;
      }
    }
    function cl(e) {
      try {
        return _R(e);
      } catch (t) {
        throw t !== null && typeof t == "object" && typeof t.then == "function" ? (hd = t, wg = !0, xm) : t;
      }
    }
    function rc() {
      if (hd === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var e = hd;
      return hd = null, wg = !1, e;
    }
    function af(e) {
      if (e === xm || e === o1)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function bn(e) {
      var t = ot;
      return e != null && (ot = t === null ? e : t.concat(e)), t;
    }
    function Ya() {
      var e = ot;
      if (e != null) {
        for (var t = e.length - 1; 0 <= t; t--)
          if (e[t].name != null) {
            var a = e[t].debugTask;
            if (a != null) return a;
          }
      }
      return null;
    }
    function Oa(e, t, a) {
      for (var i = Object.keys(e.props), c = 0; c < i.length; c++) {
        var s = i[c];
        if (s !== "children" && s !== "key") {
          t === null && (t = uo(e, a.mode, 0), t._debugInfo = ot, t.return = a), Ae(
            t,
            function(y) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                y
              );
            },
            s
          );
          break;
        }
      }
    }
    function iu(e) {
      var t = Mg;
      return Mg += 1, Hm === null && (Hm = lh()), ol(Hm, e, t);
    }
    function Ga(e, t) {
      t = t.props.ref, e.ref = t !== void 0 ? t : null;
    }
    function ou(e, t) {
      throw t.$$typeof === Hv ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (e = Object.prototype.toString.call(t), Error(
        "Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function Ll(e, t) {
      var a = Ya();
      a !== null ? a.run(
        ou.bind(null, e, t)
      ) : ou(e, t);
    }
    function Lp(e, t) {
      var a = ae(e) || "Component";
      F2[a] || (F2[a] = !0, t = t.displayName || t.name || "Component", e.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        t,
        t,
        t
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        t,
        t,
        a,
        t,
        a
      ));
    }
    function Tr(e, t) {
      var a = Ya();
      a !== null ? a.run(
        Lp.bind(null, e, t)
      ) : Lp(e, t);
    }
    function uh(e, t) {
      var a = ae(e) || "Component";
      W2[a] || (W2[a] = !0, t = String(t), e.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        t
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        a,
        t,
        a
      ));
    }
    function lf(e, t) {
      var a = Ya();
      a !== null ? a.run(
        uh.bind(null, e, t)
      ) : uh(e, t);
    }
    function Xn(e) {
      function t(U, M) {
        if (e) {
          var B = U.deletions;
          B === null ? (U.deletions = [M], U.flags |= 16) : B.push(M);
        }
      }
      function a(U, M) {
        if (!e) return null;
        for (; M !== null; )
          t(U, M), M = M.sibling;
        return null;
      }
      function i(U) {
        for (var M = /* @__PURE__ */ new Map(); U !== null; )
          U.key !== null ? M.set(U.key, U) : M.set(U.index, U), U = U.sibling;
        return M;
      }
      function c(U, M) {
        return U = Nu(U, M), U.index = 0, U.sibling = null, U;
      }
      function s(U, M, B) {
        return U.index = B, e ? (B = U.alternate, B !== null ? (B = B.index, B < M ? (U.flags |= 67108866, M) : B) : (U.flags |= 67108866, M)) : (U.flags |= 1048576, M);
      }
      function y(U) {
        return e && U.alternate === null && (U.flags |= 67108866), U;
      }
      function b(U, M, B, ie) {
        return M === null || M.tag !== 6 ? (M = gr(
          B,
          U.mode,
          ie
        ), M.return = U, M._debugOwner = U, M._debugTask = U._debugTask, M._debugInfo = ot, M) : (M = c(M, B), M.return = U, M._debugInfo = ot, M);
      }
      function A(U, M, B, ie) {
        var Oe = B.type;
        return Oe === ns ? (M = j(
          U,
          M,
          B.props.children,
          ie,
          B.key
        ), Oa(B, M, U), M) : M !== null && (M.elementType === Oe || Dp(M, B) || typeof Oe == "object" && Oe !== null && Oe.$$typeof === da && cl(Oe) === M.type) ? (M = c(M, B.props), Ga(M, B), M.return = U, M._debugOwner = B._owner, M._debugInfo = ot, M) : (M = uo(B, U.mode, ie), Ga(M, B), M.return = U, M._debugInfo = ot, M);
      }
      function D(U, M, B, ie) {
        return M === null || M.tag !== 4 || M.stateNode.containerInfo !== B.containerInfo || M.stateNode.implementation !== B.implementation ? (M = Wd(B, U.mode, ie), M.return = U, M._debugInfo = ot, M) : (M = c(M, B.children || []), M.return = U, M._debugInfo = ot, M);
      }
      function j(U, M, B, ie, Oe) {
        return M === null || M.tag !== 7 ? (M = ac(
          B,
          U.mode,
          ie,
          Oe
        ), M.return = U, M._debugOwner = U, M._debugTask = U._debugTask, M._debugInfo = ot, M) : (M = c(M, B), M.return = U, M._debugInfo = ot, M);
      }
      function V(U, M, B) {
        if (typeof M == "string" && M !== "" || typeof M == "number" || typeof M == "bigint")
          return M = gr(
            "" + M,
            U.mode,
            B
          ), M.return = U, M._debugOwner = U, M._debugTask = U._debugTask, M._debugInfo = ot, M;
        if (typeof M == "object" && M !== null) {
          switch (M.$$typeof) {
            case Yl:
              return B = uo(
                M,
                U.mode,
                B
              ), Ga(B, M), B.return = U, U = bn(M._debugInfo), B._debugInfo = ot, ot = U, B;
            case Mo:
              return M = Wd(
                M,
                U.mode,
                B
              ), M.return = U, M._debugInfo = ot, M;
            case da:
              var ie = bn(M._debugInfo);
              return M = cl(M), U = V(U, M, B), ot = ie, U;
          }
          if (_n(M) || ge(M))
            return B = ac(
              M,
              U.mode,
              B,
              null
            ), B.return = U, B._debugOwner = U, B._debugTask = U._debugTask, U = bn(M._debugInfo), B._debugInfo = ot, ot = U, B;
          if (typeof M.then == "function")
            return ie = bn(M._debugInfo), U = V(
              U,
              iu(M),
              B
            ), ot = ie, U;
          if (M.$$typeof === bu)
            return V(
              U,
              ef(U, M),
              B
            );
          Ll(U, M);
        }
        return typeof M == "function" && Tr(U, M), typeof M == "symbol" && lf(U, M), null;
      }
      function w(U, M, B, ie) {
        var Oe = M !== null ? M.key : null;
        if (typeof B == "string" && B !== "" || typeof B == "number" || typeof B == "bigint")
          return Oe !== null ? null : b(U, M, "" + B, ie);
        if (typeof B == "object" && B !== null) {
          switch (B.$$typeof) {
            case Yl:
              return B.key === Oe ? (Oe = bn(B._debugInfo), U = A(
                U,
                M,
                B,
                ie
              ), ot = Oe, U) : null;
            case Mo:
              return B.key === Oe ? D(U, M, B, ie) : null;
            case da:
              return Oe = bn(B._debugInfo), B = cl(B), U = w(
                U,
                M,
                B,
                ie
              ), ot = Oe, U;
          }
          if (_n(B) || ge(B))
            return Oe !== null ? null : (Oe = bn(B._debugInfo), U = j(
              U,
              M,
              B,
              ie,
              null
            ), ot = Oe, U);
          if (typeof B.then == "function")
            return Oe = bn(B._debugInfo), U = w(
              U,
              M,
              iu(B),
              ie
            ), ot = Oe, U;
          if (B.$$typeof === bu)
            return w(
              U,
              M,
              ef(U, B),
              ie
            );
          Ll(U, B);
        }
        return typeof B == "function" && Tr(U, B), typeof B == "symbol" && lf(U, B), null;
      }
      function $(U, M, B, ie, Oe) {
        if (typeof ie == "string" && ie !== "" || typeof ie == "number" || typeof ie == "bigint")
          return U = U.get(B) || null, b(M, U, "" + ie, Oe);
        if (typeof ie == "object" && ie !== null) {
          switch (ie.$$typeof) {
            case Yl:
              return B = U.get(
                ie.key === null ? B : ie.key
              ) || null, U = bn(ie._debugInfo), M = A(
                M,
                B,
                ie,
                Oe
              ), ot = U, M;
            case Mo:
              return U = U.get(
                ie.key === null ? B : ie.key
              ) || null, D(M, U, ie, Oe);
            case da:
              var ke = bn(ie._debugInfo);
              return ie = cl(ie), M = $(
                U,
                M,
                B,
                ie,
                Oe
              ), ot = ke, M;
          }
          if (_n(ie) || ge(ie))
            return B = U.get(B) || null, U = bn(ie._debugInfo), M = j(
              M,
              B,
              ie,
              Oe,
              null
            ), ot = U, M;
          if (typeof ie.then == "function")
            return ke = bn(ie._debugInfo), M = $(
              U,
              M,
              B,
              iu(ie),
              Oe
            ), ot = ke, M;
          if (ie.$$typeof === bu)
            return $(
              U,
              M,
              B,
              ef(M, ie),
              Oe
            );
          Ll(M, ie);
        }
        return typeof ie == "function" && Tr(M, ie), typeof ie == "symbol" && lf(M, ie), null;
      }
      function Ee(U, M, B, ie) {
        if (typeof B != "object" || B === null) return ie;
        switch (B.$$typeof) {
          case Yl:
          case Mo:
            _(U, M, B);
            var Oe = B.key;
            if (typeof Oe != "string") break;
            if (ie === null) {
              ie = /* @__PURE__ */ new Set(), ie.add(Oe);
              break;
            }
            if (!ie.has(Oe)) {
              ie.add(Oe);
              break;
            }
            Ae(M, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                Oe
              );
            });
            break;
          case da:
            B = cl(B), Ee(U, M, B, ie);
        }
        return ie;
      }
      function Re(U, M, B, ie) {
        for (var Oe = null, ke = null, qe = null, Le = M, lt = M = 0, cn = null; Le !== null && lt < B.length; lt++) {
          Le.index > lt ? (cn = Le, Le = null) : cn = Le.sibling;
          var qn = w(
            U,
            Le,
            B[lt],
            ie
          );
          if (qn === null) {
            Le === null && (Le = cn);
            break;
          }
          Oe = Ee(
            U,
            qn,
            B[lt],
            Oe
          ), e && Le && qn.alternate === null && t(U, Le), M = s(qn, M, lt), qe === null ? ke = qn : qe.sibling = qn, qe = qn, Le = cn;
        }
        if (lt === B.length)
          return a(U, Le), pt && au(U, lt), ke;
        if (Le === null) {
          for (; lt < B.length; lt++)
            Le = V(U, B[lt], ie), Le !== null && (Oe = Ee(
              U,
              Le,
              B[lt],
              Oe
            ), M = s(
              Le,
              M,
              lt
            ), qe === null ? ke = Le : qe.sibling = Le, qe = Le);
          return pt && au(U, lt), ke;
        }
        for (Le = i(Le); lt < B.length; lt++)
          cn = $(
            Le,
            U,
            lt,
            B[lt],
            ie
          ), cn !== null && (Oe = Ee(
            U,
            cn,
            B[lt],
            Oe
          ), e && cn.alternate !== null && Le.delete(
            cn.key === null ? lt : cn.key
          ), M = s(
            cn,
            M,
            lt
          ), qe === null ? ke = cn : qe.sibling = cn, qe = cn);
        return e && Le.forEach(function(Pc) {
          return t(U, Pc);
        }), pt && au(U, lt), ke;
      }
      function Pt(U, M, B, ie) {
        if (B == null)
          throw Error("An iterable object provided no iterator.");
        for (var Oe = null, ke = null, qe = M, Le = M = 0, lt = null, cn = null, qn = B.next(); qe !== null && !qn.done; Le++, qn = B.next()) {
          qe.index > Le ? (lt = qe, qe = null) : lt = qe.sibling;
          var Pc = w(U, qe, qn.value, ie);
          if (Pc === null) {
            qe === null && (qe = lt);
            break;
          }
          cn = Ee(
            U,
            Pc,
            qn.value,
            cn
          ), e && qe && Pc.alternate === null && t(U, qe), M = s(Pc, M, Le), ke === null ? Oe = Pc : ke.sibling = Pc, ke = Pc, qe = lt;
        }
        if (qn.done)
          return a(U, qe), pt && au(U, Le), Oe;
        if (qe === null) {
          for (; !qn.done; Le++, qn = B.next())
            qe = V(U, qn.value, ie), qe !== null && (cn = Ee(
              U,
              qe,
              qn.value,
              cn
            ), M = s(
              qe,
              M,
              Le
            ), ke === null ? Oe = qe : ke.sibling = qe, ke = qe);
          return pt && au(U, Le), Oe;
        }
        for (qe = i(qe); !qn.done; Le++, qn = B.next())
          lt = $(
            qe,
            U,
            Le,
            qn.value,
            ie
          ), lt !== null && (cn = Ee(
            U,
            lt,
            qn.value,
            cn
          ), e && lt.alternate !== null && qe.delete(
            lt.key === null ? Le : lt.key
          ), M = s(
            lt,
            M,
            Le
          ), ke === null ? Oe = lt : ke.sibling = lt, ke = lt);
        return e && qe.forEach(function(PR) {
          return t(U, PR);
        }), pt && au(U, Le), Oe;
      }
      function gt(U, M, B, ie) {
        if (typeof B == "object" && B !== null && B.type === ns && B.key === null && (Oa(B, null, U), B = B.props.children), typeof B == "object" && B !== null) {
          switch (B.$$typeof) {
            case Yl:
              var Oe = bn(B._debugInfo);
              e: {
                for (var ke = B.key; M !== null; ) {
                  if (M.key === ke) {
                    if (ke = B.type, ke === ns) {
                      if (M.tag === 7) {
                        a(
                          U,
                          M.sibling
                        ), ie = c(
                          M,
                          B.props.children
                        ), ie.return = U, ie._debugOwner = B._owner, ie._debugInfo = ot, Oa(B, ie, U), U = ie;
                        break e;
                      }
                    } else if (M.elementType === ke || Dp(
                      M,
                      B
                    ) || typeof ke == "object" && ke !== null && ke.$$typeof === da && cl(ke) === M.type) {
                      a(
                        U,
                        M.sibling
                      ), ie = c(M, B.props), Ga(ie, B), ie.return = U, ie._debugOwner = B._owner, ie._debugInfo = ot, U = ie;
                      break e;
                    }
                    a(U, M);
                    break;
                  } else t(U, M);
                  M = M.sibling;
                }
                B.type === ns ? (ie = ac(
                  B.props.children,
                  U.mode,
                  ie,
                  B.key
                ), ie.return = U, ie._debugOwner = U, ie._debugTask = U._debugTask, ie._debugInfo = ot, Oa(B, ie, U), U = ie) : (ie = uo(
                  B,
                  U.mode,
                  ie
                ), Ga(ie, B), ie.return = U, ie._debugInfo = ot, U = ie);
              }
              return U = y(U), ot = Oe, U;
            case Mo:
              e: {
                for (Oe = B, B = Oe.key; M !== null; ) {
                  if (M.key === B)
                    if (M.tag === 4 && M.stateNode.containerInfo === Oe.containerInfo && M.stateNode.implementation === Oe.implementation) {
                      a(
                        U,
                        M.sibling
                      ), ie = c(
                        M,
                        Oe.children || []
                      ), ie.return = U, U = ie;
                      break e;
                    } else {
                      a(U, M);
                      break;
                    }
                  else t(U, M);
                  M = M.sibling;
                }
                ie = Wd(
                  Oe,
                  U.mode,
                  ie
                ), ie.return = U, U = ie;
              }
              return y(U);
            case da:
              return Oe = bn(B._debugInfo), B = cl(B), U = gt(
                U,
                M,
                B,
                ie
              ), ot = Oe, U;
          }
          if (_n(B))
            return Oe = bn(B._debugInfo), U = Re(
              U,
              M,
              B,
              ie
            ), ot = Oe, U;
          if (ge(B)) {
            if (Oe = bn(B._debugInfo), ke = ge(B), typeof ke != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var qe = ke.call(B);
            return qe === B ? (U.tag !== 0 || Object.prototype.toString.call(U.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(qe) !== "[object Generator]") && (k2 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), k2 = !0) : B.entries !== ke || hS || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), hS = !0), U = Pt(
              U,
              M,
              qe,
              ie
            ), ot = Oe, U;
          }
          if (typeof B.then == "function")
            return Oe = bn(B._debugInfo), U = gt(
              U,
              M,
              iu(B),
              ie
            ), ot = Oe, U;
          if (B.$$typeof === bu)
            return gt(
              U,
              M,
              ef(U, B),
              ie
            );
          Ll(U, B);
        }
        return typeof B == "string" && B !== "" || typeof B == "number" || typeof B == "bigint" ? (Oe = "" + B, M !== null && M.tag === 6 ? (a(
          U,
          M.sibling
        ), ie = c(M, Oe), ie.return = U, U = ie) : (a(U, M), ie = gr(
          Oe,
          U.mode,
          ie
        ), ie.return = U, ie._debugOwner = U, ie._debugTask = U._debugTask, ie._debugInfo = ot, U = ie), y(U)) : (typeof B == "function" && Tr(U, B), typeof B == "symbol" && lf(U, B), a(U, M));
      }
      return function(U, M, B, ie) {
        var Oe = ot;
        ot = null;
        try {
          Mg = 0;
          var ke = gt(
            U,
            M,
            B,
            ie
          );
          return Hm = null, ke;
        } catch (cn) {
          if (cn === xm || cn === o1) throw cn;
          var qe = L(29, cn, null, U.mode);
          qe.lanes = ie, qe.return = U;
          var Le = qe._debugInfo = ot;
          if (qe._debugOwner = U._debugOwner, qe._debugTask = U._debugTask, Le != null) {
            for (var lt = Le.length - 1; 0 <= lt; lt--)
              if (typeof Le[lt].stack == "string") {
                qe._debugOwner = Le[lt], qe._debugTask = Le[lt].debugTask;
                break;
              }
          }
          return qe;
        } finally {
          ot = Oe;
        }
      };
    }
    function Jt(e, t) {
      var a = _n(e);
      return e = !a && typeof ge(e) == "function", a || e ? (a = a ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        a,
        t,
        a
      ), !1) : !0;
    }
    function ht(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function Lu(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        callbacks: null
      });
    }
    function Nn(e) {
      return {
        lane: e,
        tag: P2,
        payload: null,
        callback: null,
        next: null
      };
    }
    function Bu(e, t, a) {
      var i = e.updateQueue;
      if (i === null) return null;
      if (i = i.shared, pS === i && !nT) {
        var c = ae(e);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          c
        ), nT = !0;
      }
      return (Tt & ca) !== ya ? (c = i.pending, c === null ? t.next = t : (t.next = c.next, c.next = t), i.pending = t, t = Ws(e), Op(e, null, a), t) : (yr(e, i, t, a), Ws(e));
    }
    function Bl(e, t, a) {
      if (t = t.updateQueue, t !== null && (t = t.shared, (a & 4194048) !== 0)) {
        var i = t.lanes;
        i &= e.pendingLanes, a |= i, t.lanes = a, Ud(e, a);
      }
    }
    function uf(e, t) {
      var a = e.updateQueue, i = e.alternate;
      if (i !== null && (i = i.updateQueue, a === i)) {
        var c = null, s = null;
        if (a = a.firstBaseUpdate, a !== null) {
          do {
            var y = {
              lane: a.lane,
              tag: a.tag,
              payload: a.payload,
              callback: null,
              next: null
            };
            s === null ? c = s = y : s = s.next = y, a = a.next;
          } while (a !== null);
          s === null ? c = s = t : s = s.next = t;
        } else c = s = t;
        a = {
          baseState: i.baseState,
          firstBaseUpdate: c,
          lastBaseUpdate: s,
          shared: i.shared,
          callbacks: i.callbacks
        }, e.updateQueue = a;
        return;
      }
      e = a.lastBaseUpdate, e === null ? a.firstBaseUpdate = t : e.next = t, a.lastBaseUpdate = t;
    }
    function Ar() {
      if (yS) {
        var e = Nm;
        if (e !== null) throw e;
      }
    }
    function ju(e, t, a, i) {
      yS = !1;
      var c = e.updateQueue;
      As = !1, pS = c.shared;
      var s = c.firstBaseUpdate, y = c.lastBaseUpdate, b = c.shared.pending;
      if (b !== null) {
        c.shared.pending = null;
        var A = b, D = A.next;
        A.next = null, y === null ? s = D : y.next = D, y = A;
        var j = e.alternate;
        j !== null && (j = j.updateQueue, b = j.lastBaseUpdate, b !== y && (b === null ? j.firstBaseUpdate = D : b.next = D, j.lastBaseUpdate = A));
      }
      if (s !== null) {
        var V = c.baseState;
        y = 0, j = D = A = null, b = s;
        do {
          var w = b.lane & -536870913, $ = w !== b.lane;
          if ($ ? (ct & w) === w : (i & w) === w) {
            w !== 0 && w === sd && (yS = !0), j !== null && (j = j.next = {
              lane: 0,
              tag: b.tag,
              payload: b.payload,
              callback: null,
              next: null
            });
            e: {
              w = e;
              var Ee = b, Re = t, Pt = a;
              switch (Ee.tag) {
                case eT:
                  if (Ee = Ee.payload, typeof Ee == "function") {
                    wm = !0;
                    var gt = Ee.call(
                      Pt,
                      V,
                      Re
                    );
                    if (w.mode & $a) {
                      Z(!0);
                      try {
                        Ee.call(Pt, V, Re);
                      } finally {
                        Z(!1);
                      }
                    }
                    wm = !1, V = gt;
                    break e;
                  }
                  V = Ee;
                  break e;
                case mS:
                  w.flags = w.flags & -65537 | 128;
                case P2:
                  if (gt = Ee.payload, typeof gt == "function") {
                    if (wm = !0, Ee = gt.call(
                      Pt,
                      V,
                      Re
                    ), w.mode & $a) {
                      Z(!0);
                      try {
                        gt.call(Pt, V, Re);
                      } finally {
                        Z(!1);
                      }
                    }
                    wm = !1;
                  } else Ee = gt;
                  if (Ee == null) break e;
                  V = ut({}, V, Ee);
                  break e;
                case tT:
                  As = !0;
              }
            }
            w = b.callback, w !== null && (e.flags |= 64, $ && (e.flags |= 8192), $ = c.callbacks, $ === null ? c.callbacks = [w] : $.push(w));
          } else
            $ = {
              lane: w,
              tag: b.tag,
              payload: b.payload,
              callback: b.callback,
              next: null
            }, j === null ? (D = j = $, A = V) : j = j.next = $, y |= w;
          if (b = b.next, b === null) {
            if (b = c.shared.pending, b === null)
              break;
            $ = b, b = $.next, $.next = null, c.lastBaseUpdate = $, c.shared.pending = null;
          }
        } while (!0);
        j === null && (A = V), c.baseState = A, c.firstBaseUpdate = D, c.lastBaseUpdate = j, s === null && (c.shared.lanes = 0), Rs |= y, e.lanes = y, e.memoizedState = V;
      }
      pS = null;
    }
    function so(e, t) {
      if (typeof e != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + e
        );
      e.call(t);
    }
    function Bp(e, t) {
      var a = e.shared.hiddenCallbacks;
      if (a !== null)
        for (e.shared.hiddenCallbacks = null, e = 0; e < a.length; e++)
          so(a[e], t);
    }
    function Or(e, t) {
      var a = e.callbacks;
      if (a !== null)
        for (e.callbacks = null, e = 0; e < a.length; e++)
          so(a[e], t);
    }
    function ih(e, t) {
      var a = Vo;
      we(r1, a, e), we(Lm, t, e), Vo = a | t.baseLanes;
    }
    function _i(e) {
      we(r1, Vo, e), we(
        Lm,
        Lm.current,
        e
      );
    }
    function cu(e) {
      Vo = r1.current, Ce(Lm, e), Ce(r1, e);
    }
    function Da(e) {
      var t = e.alternate;
      we(
        jn,
        jn.current & Bm,
        e
      ), we(Au, e, e), di === null && (t === null || Lm.current !== null || t.memoizedState !== null) && (di = e);
    }
    function ru(e) {
      we(jn, jn.current, e), we(Au, e, e), di === null && (di = e);
    }
    function oh(e) {
      e.tag === 22 ? (we(jn, jn.current, e), we(Au, e, e), di === null && (di = e)) : qu(e);
    }
    function qu(e) {
      we(jn, jn.current, e), we(
        Au,
        Au.current,
        e
      );
    }
    function Qn(e) {
      Ce(Au, e), di === e && (di = null), Ce(jn, e);
    }
    function sc(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === 13) {
          var a = t.memoizedState;
          if (a !== null && (a = a.dehydrated, a === null || Gf(a) || xy(a)))
            return t;
        } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
          if ((t.flags & 128) !== 0) return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    function Je() {
      var e = W;
      mi === null ? mi = [e] : mi.push(e);
    }
    function se() {
      var e = W;
      if (mi !== null && (kc++, mi[kc] !== e)) {
        var t = ae(Ke);
        if (!aT.has(t) && (aT.add(t), mi !== null)) {
          for (var a = "", i = 0; i <= kc; i++) {
            var c = mi[i], s = i === kc ? e : c;
            for (c = i + 1 + ". " + c; 30 > c.length; )
              c += " ";
            c += s + `
`, a += c;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            t,
            a
          );
        }
      }
    }
    function Ui(e) {
      e == null || _n(e) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        W,
        typeof e
      );
    }
    function of() {
      var e = ae(Ke);
      uT.has(e) || (uT.add(e), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        e
      ));
    }
    function mn() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function jp(e, t) {
      if (Hg) return !1;
      if (t === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          W
        ), !1;
      e.length !== t.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        W,
        "[" + t.join(", ") + "]",
        "[" + e.join(", ") + "]"
      );
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!El(e[a], t[a])) return !1;
      return !0;
    }
    function qp(e, t, a, i, c, s) {
      Jc = s, Ke = t, mi = e !== null ? e._debugHookTypes : null, kc = -1, Hg = e !== null && e.type !== t.type, (Object.prototype.toString.call(a) === "[object AsyncFunction]" || Object.prototype.toString.call(a) === "[object AsyncGeneratorFunction]") && (s = ae(Ke), gS.has(s) || (gS.add(s), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        s === null ? "An unknown Component" : "<" + s + ">"
      ))), t.memoizedState = null, t.updateQueue = null, t.lanes = 0, I.H = e !== null && e.memoizedState !== null ? bS : mi !== null ? iT : vS, pd = s = (t.mode & $a) !== Qe;
      var y = sS(a, i, c);
      if (pd = !1, qm && (y = cf(
        t,
        a,
        i,
        c
      )), s) {
        Z(!0);
        try {
          y = cf(
            t,
            a,
            i,
            c
          );
        } finally {
          Z(!1);
        }
      }
      return Sn(e, t), y;
    }
    function Sn(e, t) {
      t._debugHookTypes = mi, t.dependencies === null ? Kc !== null && (t.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: Kc
      }) : t.dependencies._debugThenableState = Kc, I.H = Lg;
      var a = $t !== null && $t.next !== null;
      if (Jc = 0, mi = W = Wn = $t = Ke = null, kc = -1, e !== null && (e.flags & 65011712) !== (t.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), f1 = !1, xg = 0, Kc = null, a)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      e === null || In || (e = e.dependencies, e !== null && br(e) && (In = !0)), wg ? (wg = !1, e = !0) : e = !1, e && (t = ae(t) || "Unknown", lT.has(t) || gS.has(t) || (lT.add(t), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function cf(e, t, a, i) {
      Ke = e;
      var c = 0;
      do {
        if (qm && (Kc = null), xg = 0, qm = !1, c >= wR)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (c += 1, Hg = !1, Wn = $t = null, e.updateQueue != null) {
          var s = e.updateQueue;
          s.lastEffect = null, s.events = null, s.stores = null, s.memoCache != null && (s.memoCache.index = 0);
        }
        kc = -1, I.H = oT, s = sS(t, a, i);
      } while (qm);
      return s;
    }
    function rf() {
      var e = I.H, t = e.useState()[0];
      return t = typeof t.then == "function" ? df(t) : t, e = e.useState()[0], ($t !== null ? $t.memoizedState : null) !== e && (Ke.flags |= 1024), t;
    }
    function fc() {
      var e = d1 !== 0;
      return d1 = 0, e;
    }
    function sf(e, t, a) {
      t.updateQueue = e.updateQueue, t.flags = (t.mode & Zi) !== Qe ? t.flags & -402655237 : t.flags & -2053, e.lanes &= ~a;
    }
    function fo(e) {
      if (f1) {
        for (e = e.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        f1 = !1;
      }
      Jc = 0, mi = Wn = $t = Ke = null, kc = -1, W = null, qm = !1, xg = d1 = 0, Kc = null;
    }
    function Cn() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Wn === null ? Ke.memoizedState = Wn = e : Wn = Wn.next = e, Wn;
    }
    function Nt() {
      if ($t === null) {
        var e = Ke.alternate;
        e = e !== null ? e.memoizedState : null;
      } else e = $t.next;
      var t = Wn === null ? Ke.memoizedState : Wn.next;
      if (t !== null)
        Wn = t, $t = e;
      else {
        if (e === null)
          throw Ke.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        $t = e, e = {
          memoizedState: $t.memoizedState,
          baseState: $t.baseState,
          baseQueue: $t.baseQueue,
          queue: $t.queue,
          next: null
        }, Wn === null ? Ke.memoizedState = Wn = e : Wn = Wn.next = e;
      }
      return Wn;
    }
    function ff() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function df(e) {
      var t = xg;
      return xg += 1, Kc === null && (Kc = lh()), e = ol(Kc, e, t), t = Ke, (Wn === null ? t.memoizedState : Wn.next) === null && (t = t.alternate, I.H = t !== null && t.memoizedState !== null ? bS : vS), e;
    }
    function wi(e) {
      if (e !== null && typeof e == "object") {
        if (typeof e.then == "function") return df(e);
        if (e.$$typeof === bu) return Ct(e);
      }
      throw Error("An unsupported type was passed to use(): " + String(e));
    }
    function rl(e) {
      var t = null, a = Ke.updateQueue;
      if (a !== null && (t = a.memoCache), t == null) {
        var i = Ke.alternate;
        i !== null && (i = i.updateQueue, i !== null && (i = i.memoCache, i != null && (t = {
          data: i.data.map(function(c) {
            return c.slice();
          }),
          index: 0
        })));
      }
      if (t == null && (t = { data: [], index: 0 }), a === null && (a = ff(), Ke.updateQueue = a), a.memoCache = t, a = t.data[t.index], a === void 0 || Hg)
        for (a = t.data[t.index] = Array(e), i = 0; i < e; i++)
          a[i] = Bb;
      else
        a.length !== e && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          a.length,
          e
        );
      return t.index++, a;
    }
    function sl(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function Dr(e, t, a) {
      var i = Cn();
      if (a !== void 0) {
        var c = a(t);
        if (pd) {
          Z(!0);
          try {
            a(t);
          } finally {
            Z(!1);
          }
        }
      } else c = t;
      return i.memoizedState = i.baseState = c, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      }, i.queue = e, e = e.dispatch = Mb.bind(
        null,
        Ke,
        e
      ), [i.memoizedState, e];
    }
    function dc(e) {
      var t = Nt();
      return ho(t, $t, e);
    }
    function ho(e, t, a) {
      var i = e.queue;
      if (i === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      i.lastRenderedReducer = a;
      var c = e.baseQueue, s = i.pending;
      if (s !== null) {
        if (c !== null) {
          var y = c.next;
          c.next = s.next, s.next = y;
        }
        t.baseQueue !== c && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), t.baseQueue = c = s, i.pending = null;
      }
      if (s = e.baseState, c === null) e.memoizedState = s;
      else {
        t = c.next;
        var b = y = null, A = null, D = t, j = !1;
        do {
          var V = D.lane & -536870913;
          if (V !== D.lane ? (ct & V) === V : (Jc & V) === V) {
            var w = D.revertLane;
            if (w === 0)
              A !== null && (A = A.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: D.action,
                hasEagerState: D.hasEagerState,
                eagerState: D.eagerState,
                next: null
              }), V === sd && (j = !0);
            else if ((Jc & w) === w) {
              D = D.next, w === sd && (j = !0);
              continue;
            } else
              V = {
                lane: 0,
                revertLane: D.revertLane,
                gesture: null,
                action: D.action,
                hasEagerState: D.hasEagerState,
                eagerState: D.eagerState,
                next: null
              }, A === null ? (b = A = V, y = s) : A = A.next = V, Ke.lanes |= w, Rs |= w;
            V = D.action, pd && a(s, V), s = D.hasEagerState ? D.eagerState : a(s, V);
          } else
            w = {
              lane: V,
              revertLane: D.revertLane,
              gesture: D.gesture,
              action: D.action,
              hasEagerState: D.hasEagerState,
              eagerState: D.eagerState,
              next: null
            }, A === null ? (b = A = w, y = s) : A = A.next = w, Ke.lanes |= V, Rs |= V;
          D = D.next;
        } while (D !== null && D !== t);
        if (A === null ? y = s : A.next = b, !El(s, e.memoizedState) && (In = !0, j && (a = Nm, a !== null)))
          throw a;
        e.memoizedState = s, e.baseState = y, e.baseQueue = A, i.lastRenderedState = s;
      }
      return c === null && (i.lanes = 0), [e.memoizedState, i.dispatch];
    }
    function hc(e) {
      var t = Nt(), a = t.queue;
      if (a === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      a.lastRenderedReducer = e;
      var i = a.dispatch, c = a.pending, s = t.memoizedState;
      if (c !== null) {
        a.pending = null;
        var y = c = c.next;
        do
          s = e(s, y.action), y = y.next;
        while (y !== c);
        El(s, t.memoizedState) || (In = !0), t.memoizedState = s, t.baseQueue === null && (t.baseState = s), a.lastRenderedState = s;
      }
      return [s, i];
    }
    function Rr(e, t, a) {
      var i = Ke, c = Cn();
      if (pt) {
        if (a === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var s = a();
        jm || s === a() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), jm = !0);
      } else {
        if (s = t(), jm || (a = t(), El(s, a) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), jm = !0)), Ft === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        (ct & 127) !== 0 || Vp(i, t, s);
      }
      return c.memoizedState = s, a = { value: s, getSnapshot: t }, c.queue = a, yc(
        mo.bind(null, i, a, e),
        [e]
      ), i.flags |= 2048, Vu(
        hi | Ol,
        { destroy: void 0 },
        Yp.bind(
          null,
          i,
          a,
          s,
          t
        ),
        null
      ), s;
    }
    function mc(e, t, a) {
      var i = Ke, c = Nt(), s = pt;
      if (s) {
        if (a === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        a = a();
      } else if (a = t(), !jm) {
        var y = t();
        El(a, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), jm = !0);
      }
      (y = !El(
        ($t || c).memoizedState,
        a
      )) && (c.memoizedState = a, In = !0), c = c.queue;
      var b = mo.bind(null, i, c, e);
      if (xn(2048, Ol, b, [e]), c.getSnapshot !== t || y || Wn !== null && Wn.memoizedState.tag & hi) {
        if (i.flags |= 2048, Vu(
          hi | Ol,
          { destroy: void 0 },
          Yp.bind(
            null,
            i,
            c,
            a,
            t
          ),
          null
        ), Ft === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        s || (Jc & 127) !== 0 || Vp(i, t, a);
      }
      return a;
    }
    function Vp(e, t, a) {
      e.flags |= 16384, e = { getSnapshot: t, value: a }, t = Ke.updateQueue, t === null ? (t = ff(), Ke.updateQueue = t, t.stores = [e]) : (a = t.stores, a === null ? t.stores = [e] : a.push(e));
    }
    function Yp(e, t, a, i) {
      t.value = a, t.getSnapshot = i, po(t) && Gp(e);
    }
    function mo(e, t, a) {
      return a(function() {
        po(t) && (xu(2, "updateSyncExternalStore()", e), Gp(e));
      });
    }
    function po(e) {
      var t = e.getSnapshot;
      e = e.value;
      try {
        var a = t();
        return !El(e, a);
      } catch {
        return !0;
      }
    }
    function Gp(e) {
      var t = ra(e, 2);
      t !== null && Ze(t, e, 2);
    }
    function ch(e) {
      var t = Cn();
      if (typeof e == "function") {
        var a = e;
        if (e = a(), pd) {
          Z(!0);
          try {
            a();
          } finally {
            Z(!1);
          }
        }
      }
      return t.memoizedState = t.baseState = e, t.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: sl,
        lastRenderedState: e
      }, t;
    }
    function yo(e) {
      e = ch(e);
      var t = e.queue, a = mh.bind(null, Ke, t);
      return t.dispatch = a, [e.memoizedState, a];
    }
    function pc(e) {
      var t = Cn();
      t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = a, t = bf.bind(
        null,
        Ke,
        !0,
        a
      ), a.dispatch = t, [e, t];
    }
    function hf(e, t) {
      var a = Nt();
      return Cr(a, $t, e, t);
    }
    function Cr(e, t, a, i) {
      return e.baseState = a, ho(
        e,
        $t,
        typeof i == "function" ? i : sl
      );
    }
    function mf(e, t) {
      var a = Nt();
      return $t !== null ? Cr(a, $t, e, t) : (a.baseState = e, [e, a.queue.dispatch]);
    }
    function V0(e, t, a, i, c) {
      if (Zn(e))
        throw Error("Cannot update form state while rendering.");
      if (e = t.action, e !== null) {
        var s = {
          payload: c,
          action: e,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(y) {
            s.listeners.push(y);
          }
        };
        I.T !== null ? a(!0) : s.isTransition = !1, i(s), a = t.pending, a === null ? (s.next = t.pending = s, go(t, s)) : (s.next = a.next, t.pending = a.next = s);
      }
    }
    function go(e, t) {
      var a = t.action, i = t.payload, c = e.state;
      if (t.isTransition) {
        var s = I.T, y = {};
        y._updatedFibers = /* @__PURE__ */ new Set(), I.T = y;
        try {
          var b = a(c, i), A = I.S;
          A !== null && A(y, b), Xp(e, t, b);
        } catch (D) {
          pf(e, t, D);
        } finally {
          s !== null && y.types !== null && (s.types !== null && s.types !== y.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), s.types = y.types), I.T = s, s === null && y._updatedFibers && (e = y._updatedFibers.size, y._updatedFibers.clear(), 10 < e && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          y = a(c, i), Xp(e, t, y);
        } catch (D) {
          pf(e, t, D);
        }
    }
    function Xp(e, t, a) {
      a !== null && typeof a == "object" && typeof a.then == "function" ? (I.asyncTransitions++, a.then(gc, gc), a.then(
        function(i) {
          Mi(e, t, i);
        },
        function(i) {
          return pf(e, t, i);
        }
      ), t.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : Mi(e, t, a);
    }
    function Mi(e, t, a) {
      t.status = "fulfilled", t.value = a, rh(t), e.state = a, t = e.pending, t !== null && (a = t.next, a === t ? e.pending = null : (a = a.next, t.next = a, go(e, a)));
    }
    function pf(e, t, a) {
      var i = e.pending;
      if (e.pending = null, i !== null) {
        i = i.next;
        do
          t.status = "rejected", t.reason = a, rh(t), t = t.next;
        while (t !== i);
      }
      e.action = null;
    }
    function rh(e) {
      e = e.listeners;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
    function Ni(e, t) {
      return t;
    }
    function fl(e, t) {
      if (pt) {
        var a = Ft.formState;
        if (a !== null) {
          e: {
            var i = Ke;
            if (pt) {
              if (on) {
                t: {
                  for (var c = on, s = si; c.nodeType !== 8; ) {
                    if (!s) {
                      c = null;
                      break t;
                    }
                    if (c = gl(
                      c.nextSibling
                    ), c === null) {
                      c = null;
                      break t;
                    }
                  }
                  s = c.data, c = s === GS || s === JT ? c : null;
                }
                if (c) {
                  on = gl(
                    c.nextSibling
                  ), i = c.data === GS;
                  break e;
                }
              }
              Ml(i);
            }
            i = !1;
          }
          i && (t = a[0]);
        }
      }
      return a = Cn(), a.memoizedState = a.baseState = t, i = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Ni,
        lastRenderedState: t
      }, a.queue = i, a = mh.bind(
        null,
        Ke,
        i
      ), i.dispatch = a, i = ch(!1), s = bf.bind(
        null,
        Ke,
        !1,
        i.queue
      ), i = Cn(), c = {
        state: t,
        dispatch: null,
        action: e,
        pending: null
      }, i.queue = c, a = V0.bind(
        null,
        Ke,
        c,
        s,
        a
      ), c.dispatch = a, i.memoizedState = e, [t, a, !1];
    }
    function vo(e) {
      var t = Nt();
      return sh(t, $t, e);
    }
    function sh(e, t, a) {
      if (t = ho(
        e,
        t,
        Ni
      )[0], e = dc(sl)[0], typeof t == "object" && t !== null && typeof t.then == "function")
        try {
          var i = df(t);
        } catch (y) {
          throw y === xm ? o1 : y;
        }
      else i = t;
      t = Nt();
      var c = t.queue, s = c.dispatch;
      return a !== t.memoizedState && (Ke.flags |= 2048, Vu(
        hi | Ol,
        { destroy: void 0 },
        Qp.bind(null, c, a),
        null
      )), [i, s, e];
    }
    function Qp(e, t) {
      e.action = t;
    }
    function bo(e) {
      var t = Nt(), a = $t;
      if (a !== null)
        return sh(t, a, e);
      Nt(), t = t.memoizedState, a = Nt();
      var i = a.queue.dispatch;
      return a.memoizedState = e, [t, i, !1];
    }
    function Vu(e, t, a, i) {
      return e = { tag: e, create: a, deps: i, inst: t, next: null }, t = Ke.updateQueue, t === null && (t = ff(), Ke.updateQueue = t), a = t.lastEffect, a === null ? t.lastEffect = e.next = e : (i = a.next, a.next = e, e.next = i, t.lastEffect = e), e;
    }
    function fh(e) {
      var t = Cn();
      return e = { current: e }, t.memoizedState = e;
    }
    function So(e, t, a, i) {
      var c = Cn();
      Ke.flags |= e, c.memoizedState = Vu(
        hi | t,
        { destroy: void 0 },
        a,
        i === void 0 ? null : i
      );
    }
    function xn(e, t, a, i) {
      var c = Nt();
      i = i === void 0 ? null : i;
      var s = c.memoizedState.inst;
      $t !== null && i !== null && jp(i, $t.memoizedState.deps) ? c.memoizedState = Vu(t, s, a, i) : (Ke.flags |= e, c.memoizedState = Vu(
        hi | t,
        s,
        a,
        i
      ));
    }
    function yc(e, t) {
      (Ke.mode & Zi) !== Qe ? So(276826112, Ol, e, t) : So(8390656, Ol, e, t);
    }
    function Y0(e) {
      Ke.flags |= 4;
      var t = Ke.updateQueue;
      if (t === null)
        t = ff(), Ke.updateQueue = t, t.events = [e];
      else {
        var a = t.events;
        a === null ? t.events = [e] : a.push(e);
      }
    }
    function yf(e) {
      var t = Cn(), a = { impl: e };
      return t.memoizedState = a, function() {
        if ((Tt & ca) !== ya)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return a.impl.apply(void 0, arguments);
      };
    }
    function zr(e) {
      var t = Nt().memoizedState;
      return Y0({ ref: t, nextImpl: e }), function() {
        if ((Tt & ca) !== ya)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return t.impl.apply(void 0, arguments);
      };
    }
    function Ra(e, t) {
      var a = 4194308;
      return (Ke.mode & Zi) !== Qe && (a |= 134217728), So(a, Ou, e, t);
    }
    function dl(e, t) {
      if (typeof t == "function") {
        e = e();
        var a = t(e);
        return function() {
          typeof a == "function" ? a() : t(null);
        };
      }
      if (t != null)
        return t.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(t).join(", ") + "}"
        ), e = e(), t.current = e, function() {
          t.current = null;
        };
    }
    function Yu(e, t, a) {
      typeof t != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        t !== null ? typeof t : "null"
      ), a = a != null ? a.concat([e]) : null;
      var i = 4194308;
      (Ke.mode & Zi) !== Qe && (i |= 134217728), So(
        i,
        Ou,
        dl.bind(null, t, e),
        a
      );
    }
    function _r(e, t, a) {
      typeof t != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        t !== null ? typeof t : "null"
      ), a = a != null ? a.concat([e]) : null, xn(
        4,
        Ou,
        dl.bind(null, t, e),
        a
      );
    }
    function dh(e, t) {
      return Cn().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    }
    function su(e, t) {
      var a = Nt();
      t = t === void 0 ? null : t;
      var i = a.memoizedState;
      return t !== null && jp(t, i[1]) ? i[0] : (a.memoizedState = [e, t], e);
    }
    function Ca(e, t) {
      var a = Cn();
      t = t === void 0 ? null : t;
      var i = e();
      if (pd) {
        Z(!0);
        try {
          e();
        } finally {
          Z(!1);
        }
      }
      return a.memoizedState = [i, t], i;
    }
    function nn(e, t) {
      var a = Nt();
      t = t === void 0 ? null : t;
      var i = a.memoizedState;
      if (t !== null && jp(t, i[1]))
        return i[0];
      if (i = e(), pd) {
        Z(!0);
        try {
          e();
        } finally {
          Z(!1);
        }
      }
      return a.memoizedState = [i, t], i;
    }
    function Ur(e, t) {
      var a = Cn();
      return xt(a, e, t);
    }
    function Gu(e, t) {
      var a = Nt();
      return En(
        a,
        $t.memoizedState,
        e,
        t
      );
    }
    function Pe(e, t) {
      var a = Nt();
      return $t === null ? xt(a, e, t) : En(
        a,
        $t.memoizedState,
        e,
        t
      );
    }
    function xt(e, t, a) {
      return a === void 0 || (Jc & 1073741824) !== 0 && (ct & 261930) === 0 ? e.memoizedState = t : (e.memoizedState = a, e = jr(), Ke.lanes |= e, Rs |= e, a);
    }
    function En(e, t, a, i) {
      return El(a, t) ? a : Lm.current !== null ? (e = xt(e, a, i), El(e, t) || (In = !0), e) : (Jc & 42) === 0 || (Jc & 1073741824) !== 0 && (ct & 261930) === 0 ? (In = !0, e.memoizedState = a) : (e = jr(), Ke.lanes |= e, Rs |= e, t);
    }
    function gc() {
      I.asyncTransitions--;
    }
    function vc(e, t, a, i, c) {
      var s = _t.p;
      _t.p = s !== 0 && s < ia ? s : ia;
      var y = I.T, b = {};
      b._updatedFibers = /* @__PURE__ */ new Set(), I.T = b, bf(e, !1, t, a);
      try {
        var A = c(), D = I.S;
        if (D !== null && D(b, A), A !== null && typeof A == "object" && typeof A.then == "function") {
          I.asyncTransitions++, A.then(gc, gc);
          var j = ah(
            A,
            i
          );
          bc(
            e,
            t,
            j,
            fa(e)
          );
        } else
          bc(
            e,
            t,
            i,
            fa(e)
          );
      } catch (V) {
        bc(
          e,
          t,
          { then: function() {
          }, status: "rejected", reason: V },
          fa(e)
        );
      } finally {
        _t.p = s, y !== null && b.types !== null && (y.types !== null && y.types !== b.types && console.error(
          "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
        ), y.types = b.types), I.T = y, y === null && b._updatedFibers && (e = b._updatedFibers.size, b._updatedFibers.clear(), 10 < e && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function xi(e, t, a, i) {
      if (e.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var c = gf(e).queue;
      j0(e), vc(
        e,
        c,
        t,
        Rd,
        a === null ? R : function() {
          return wr(e), a(i);
        }
      );
    }
    function gf(e) {
      var t = e.memoizedState;
      if (t !== null) return t;
      t = {
        memoizedState: Rd,
        baseState: Rd,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: sl,
          lastRenderedState: Rd
        },
        next: null
      };
      var a = {};
      return t.next = {
        memoizedState: a,
        baseState: a,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: sl,
          lastRenderedState: a
        },
        next: null
      }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
    }
    function wr(e) {
      I.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var t = gf(e);
      t.next === null && (t = e.alternate.memoizedState), bc(
        e,
        t.next.queue,
        {},
        fa(e)
      );
    }
    function Eo() {
      var e = ch(!1);
      return e = vc.bind(
        null,
        Ke,
        e.queue,
        !0,
        !1
      ), Cn().memoizedState = e, [!1, e];
    }
    function G0() {
      var e = dc(sl)[0], t = Nt().memoizedState;
      return [
        typeof e == "boolean" ? e : df(e),
        t
      ];
    }
    function rn() {
      var e = hc(sl)[0], t = Nt().memoizedState;
      return [
        typeof e == "boolean" ? e : df(e),
        t
      ];
    }
    function Hi() {
      return Ct(Wg);
    }
    function vf() {
      var e = Cn(), t = Ft.identifierPrefix;
      if (pt) {
        var a = Yc, i = Vc;
        a = (i & ~(1 << 32 - ua(i) - 1)).toString(32) + a, t = "_" + t + "R_" + a, a = d1++, 0 < a && (t += "H" + a.toString(32)), t += "_";
      } else
        a = UR++, t = "_" + t + "r_" + a.toString(32) + "_";
      return e.memoizedState = t;
    }
    function hh() {
      return Cn().memoizedState = X0.bind(
        null,
        Ke
      );
    }
    function X0(e, t) {
      for (var a = e.return; a !== null; ) {
        switch (a.tag) {
          case 24:
          case 3:
            var i = fa(a), c = Nn(i), s = Bu(a, c, i);
            s !== null && (xu(i, "refresh()", e), Ze(s, a, i), Bl(s, a, i)), e = th(), t != null && s !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), c.payload = { cache: e };
            return;
        }
        a = a.return;
      }
    }
    function Mb(e, t, a) {
      var i = arguments;
      typeof i[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), i = fa(e);
      var c = {
        lane: i,
        revertLane: 0,
        gesture: null,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      Zn(e) ? pn(t, c) : (c = ec(e, t, c, i), c !== null && (xu(i, "dispatch()", e), Ze(c, e, i), Sf(c, t, i)));
    }
    function mh(e, t, a) {
      var i = arguments;
      typeof i[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), i = fa(e), bc(e, t, a, i) && xu(i, "setState()", e);
    }
    function bc(e, t, a, i) {
      var c = {
        lane: i,
        revertLane: 0,
        gesture: null,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Zn(e)) pn(t, c);
      else {
        var s = e.alternate;
        if (e.lanes === 0 && (s === null || s.lanes === 0) && (s = t.lastRenderedReducer, s !== null)) {
          var y = I.H;
          I.H = Ki;
          try {
            var b = t.lastRenderedState, A = s(b, a);
            if (c.hasEagerState = !0, c.eagerState = A, El(A, b))
              return yr(e, t, c, 0), Ft === null && $d(), !1;
          } catch {
          } finally {
            I.H = y;
          }
        }
        if (a = ec(e, t, c, i), a !== null)
          return Ze(a, e, i), Sf(a, t, i), !0;
      }
      return !1;
    }
    function bf(e, t, a, i) {
      if (I.T === null && sd === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), i = {
        lane: 2,
        revertLane: wy(),
        gesture: null,
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Zn(e)) {
        if (t)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        t = ec(
          e,
          a,
          i,
          2
        ), t !== null && (xu(2, "setOptimistic()", e), Ze(t, e, 2));
    }
    function Zn(e) {
      var t = e.alternate;
      return e === Ke || t !== null && t === Ke;
    }
    function pn(e, t) {
      qm = f1 = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function Sf(e, t, a) {
      if ((a & 4194048) !== 0) {
        var i = t.lanes;
        i &= e.pendingLanes, a |= i, t.lanes = a, Ud(e, a);
      }
    }
    function Sc(e) {
      if (e !== null && typeof e != "function") {
        var t = String(e);
        vT.has(t) || (vT.add(t), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          e
        ));
      }
    }
    function Mr(e, t, a, i) {
      var c = e.memoizedState, s = a(i, c);
      if (e.mode & $a) {
        Z(!0);
        try {
          s = a(i, c);
        } finally {
          Z(!1);
        }
      }
      s === void 0 && (t = Se(t) || "Component", mT.has(t) || (mT.add(t), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        t
      ))), c = s == null ? c : ut({}, c, s), e.memoizedState = c, e.lanes === 0 && (e.updateQueue.baseState = c);
    }
    function ph(e, t, a, i, c, s, y) {
      var b = e.stateNode;
      if (typeof b.shouldComponentUpdate == "function") {
        if (a = b.shouldComponentUpdate(
          i,
          s,
          y
        ), e.mode & $a) {
          Z(!0);
          try {
            a = b.shouldComponentUpdate(
              i,
              s,
              y
            );
          } finally {
            Z(!1);
          }
        }
        return a === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          Se(t) || "Component"
        ), a;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !pr(a, i) || !pr(c, s) : !0;
    }
    function Xu(e, t, a, i) {
      var c = t.state;
      typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, i), t.state !== c && (e = ae(e) || "Component", rT.has(e) || (rT.add(e), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        e
      )), SS.enqueueReplaceState(
        t,
        t.state,
        null
      ));
    }
    function Qu(e, t) {
      var a = t;
      if ("ref" in t) {
        a = {};
        for (var i in t)
          i !== "ref" && (a[i] = t[i]);
      }
      if (e = e.defaultProps) {
        a === t && (a = ut({}, a));
        for (var c in e)
          a[c] === void 0 && (a[c] = e[c]);
      }
      return a;
    }
    function yh(e) {
      Wb(e), console.warn(
        `%s

%s
`,
        Vm ? "An error occurred in the <" + Vm + "> component." : "An error occurred in one of your React components.",
        `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
      );
    }
    function gh(e) {
      var t = Vm ? "The above error occurred in the <" + Vm + "> component." : "The above error occurred in one of your React components.", a = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((ES || "Anonymous") + ".");
      if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
        var i = e.environmentName;
        e = [
          `%o

%s

%s
`,
          e,
          t,
          a
        ].slice(0), typeof e[0] == "string" ? e.splice(
          0,
          1,
          eA + " " + e[0],
          tA,
          B1 + i + B1,
          nA
        ) : e.splice(
          0,
          0,
          eA,
          tA,
          B1 + i + B1,
          nA
        ), e.unshift(console), i = WR.apply(console.error, e), i();
      } else
        console.error(
          `%o

%s

%s
`,
          e,
          t,
          a
        );
    }
    function Zp(e) {
      Wb(e);
    }
    function Ef(e, t) {
      try {
        Vm = t.source ? ae(t.source) : null, ES = null;
        var a = t.value;
        if (I.actQueue !== null)
          I.thrownErrors.push(a);
        else {
          var i = e.onUncaughtError;
          i(a, { componentStack: t.stack });
        }
      } catch (c) {
        setTimeout(function() {
          throw c;
        });
      }
    }
    function Jp(e, t, a) {
      try {
        Vm = a.source ? ae(a.source) : null, ES = ae(t);
        var i = e.onCaughtError;
        i(a.value, {
          componentStack: a.stack,
          errorBoundary: t.tag === 1 ? t.stateNode : null
        });
      } catch (c) {
        setTimeout(function() {
          throw c;
        });
      }
    }
    function vh(e, t, a) {
      return a = Nn(a), a.tag = mS, a.payload = { element: null }, a.callback = function() {
        Ae(t.source, Ef, e, t);
      }, a;
    }
    function bh(e) {
      return e = Nn(e), e.tag = mS, e;
    }
    function Sh(e, t, a, i) {
      var c = a.type.getDerivedStateFromError;
      if (typeof c == "function") {
        var s = i.value;
        e.payload = function() {
          return c(s);
        }, e.callback = function() {
          tc(a), Ae(
            i.source,
            Jp,
            t,
            a,
            i
          );
        };
      }
      var y = a.stateNode;
      y !== null && typeof y.componentDidCatch == "function" && (e.callback = function() {
        tc(a), Ae(
          i.source,
          Jp,
          t,
          a,
          i
        ), typeof c != "function" && (zs === null ? zs = /* @__PURE__ */ new Set([this]) : zs.add(this)), RR(this, i), typeof c == "function" || (a.lanes & 2) === 0 && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          ae(a) || "Unknown"
        );
      });
    }
    function Kp(e, t, a, i, c) {
      if (a.flags |= 32768, ai && Xr(e, c), i !== null && typeof i == "object" && typeof i.then == "function") {
        if (t = a.alternate, t !== null && uu(
          t,
          a,
          c,
          !0
        ), pt && (Bo = !0), a = Au.current, a !== null) {
          switch (a.tag) {
            case 31:
            case 13:
              return di === null ? Vr() : a.alternate === null && gn === Fc && (gn = p1), a.flags &= -257, a.flags |= 65536, a.lanes = c, i === c1 ? a.flags |= 16384 : (t = a.updateQueue, t === null ? a.updateQueue = /* @__PURE__ */ new Set([i]) : t.add(i), Vh(e, i, c)), !1;
            case 22:
              return a.flags |= 65536, i === c1 ? a.flags |= 16384 : (t = a.updateQueue, t === null ? (t = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([i])
              }, a.updateQueue = t) : (a = t.retryQueue, a === null ? t.retryQueue = /* @__PURE__ */ new Set([i]) : a.add(i)), Vh(e, i, c)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + a.tag + "). This is a bug in React."
          );
        }
        return Vh(e, i, c), Vr(), !1;
      }
      if (pt)
        return Bo = !0, t = Au.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = c, i !== aS && Ps(
          Ea(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: i }
            ),
            a
          )
        )) : (i !== aS && Ps(
          Ea(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: i }
            ),
            a
          )
        ), e = e.current.alternate, e.flags |= 65536, c &= -c, e.lanes |= c, i = Ea(i, a), c = vh(
          e.stateNode,
          i,
          c
        ), uf(e, c), gn !== Os && (gn = yd)), !1;
      var s = Ea(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: i }
        ),
        a
      );
      if (Gg === null ? Gg = [s] : Gg.push(s), gn !== Os && (gn = yd), t === null) return !0;
      i = Ea(i, a), a = t;
      do {
        switch (a.tag) {
          case 3:
            return a.flags |= 65536, e = c & -c, a.lanes |= e, e = vh(
              a.stateNode,
              i,
              e
            ), uf(a, e), !1;
          case 1:
            if (t = a.type, s = a.stateNode, (a.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || s !== null && typeof s.componentDidCatch == "function" && (zs === null || !zs.has(s))))
              return a.flags |= 65536, c &= -c, a.lanes |= c, c = bh(c), Sh(
                c,
                e,
                a,
                i
              ), uf(a, c), !1;
        }
        a = a.return;
      } while (a !== null);
      return !1;
    }
    function Jn(e, t, a, i) {
      t.child = e === null ? I2(t, null, a, i) : md(
        t,
        e.child,
        a,
        i
      );
    }
    function Q0(e, t, a, i, c) {
      a = a.render;
      var s = t.ref;
      if ("ref" in i) {
        var y = {};
        for (var b in i)
          b !== "ref" && (y[b] = i[b]);
      } else y = i;
      return ro(t), i = qp(
        e,
        t,
        a,
        y,
        s,
        c
      ), b = fc(), e !== null && !In ? (sf(e, t, c), fu(e, t, c)) : (pt && b && Id(t), t.flags |= 1, Jn(e, t, i, c), t.child);
    }
    function kp(e, t, a, i, c) {
      if (e === null) {
        var s = a.type;
        return typeof s == "function" && !Rp(s) && s.defaultProps === void 0 && a.compare === null ? (a = lo(s), t.tag = 15, t.type = a, Nr(t, s), $p(
          e,
          t,
          a,
          i,
          c
        )) : (e = nc(
          a.type,
          null,
          i,
          t,
          t.mode,
          c
        ), e.ref = t.ref, e.return = t, t.child = e);
      }
      if (s = e.child, !Dh(e, c)) {
        var y = s.memoizedProps;
        if (a = a.compare, a = a !== null ? a : pr, a(y, i) && e.ref === t.ref)
          return fu(
            e,
            t,
            c
          );
      }
      return t.flags |= 1, e = Nu(s, i), e.ref = t.ref, e.return = t, t.child = e;
    }
    function $p(e, t, a, i, c) {
      if (e !== null) {
        var s = e.memoizedProps;
        if (pr(s, i) && e.ref === t.ref && t.type === e.type)
          if (In = !1, t.pendingProps = i = s, Dh(e, c))
            (e.flags & 131072) !== 0 && (In = !0);
          else
            return t.lanes = e.lanes, fu(e, t, c);
      }
      return Pp(
        e,
        t,
        a,
        i,
        c
      );
    }
    function Fp(e, t, a, i) {
      var c = i.children, s = e !== null ? e.memoizedState : null;
      if (e === null && t.stateNode === null && (t.stateNode = {
        _visibility: gg,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), i.mode === "hidden") {
        if ((t.flags & 128) !== 0) {
          if (s = s !== null ? s.baseLanes | a : a, e !== null) {
            for (i = t.child = e.child, c = 0; i !== null; )
              c = c | i.lanes | i.childLanes, i = i.sibling;
            i = c & ~s;
          } else i = 0, t.child = null;
          return Wp(
            e,
            t,
            s,
            a,
            i
          );
        }
        if ((a & 536870912) !== 0)
          t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && Er(
            t,
            s !== null ? s.cachePool : null
          ), s !== null ? ih(t, s) : _i(t), oh(t);
        else
          return i = t.lanes = 536870912, Wp(
            e,
            t,
            s !== null ? s.baseLanes | a : a,
            a,
            i
          );
      } else
        s !== null ? (Er(t, s.cachePool), ih(t, s), qu(t), t.memoizedState = null) : (e !== null && Er(t, null), _i(t), qu(t));
      return Jn(e, t, c, a), t.child;
    }
    function Ec(e, t) {
      return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
        _visibility: gg,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }), t.sibling;
    }
    function Wp(e, t, a, i, c) {
      var s = zi();
      return s = s === null ? null : {
        parent: $n._currentValue,
        pool: s
      }, t.memoizedState = {
        baseLanes: a,
        cachePool: s
      }, e !== null && Er(t, null), _i(t), oh(t), e !== null && uu(e, t, i, !0), t.childLanes = c, null;
    }
    function Tf(e, t) {
      var a = t.hidden;
      return a !== void 0 && console.error(
        `<Activity> doesn't accept a hidden prop. Use mode="hidden" instead.
- <Activity %s>
+ <Activity %s>`,
        a === !0 ? "hidden" : a === !1 ? "hidden={false}" : "hidden={...}",
        a ? 'mode="hidden"' : 'mode="visible"'
      ), t = Of(
        { mode: t.mode, children: t.children },
        e.mode
      ), t.ref = e.ref, e.child = t, t.return = e, t;
    }
    function Ip(e, t, a) {
      return md(t, e.child, null, a), e = Tf(
        t,
        t.pendingProps
      ), e.flags |= 2, Qn(t), t.memoizedState = null, e;
    }
    function Z0(e, t, a) {
      var i = t.pendingProps, c = (t.flags & 128) !== 0;
      if (t.flags &= -129, e === null) {
        if (pt) {
          if (i.mode === "hidden")
            return e = Tf(t, i), t.lanes = 536870912, Ec(null, e);
          if (ru(t), (e = on) ? (a = Lt(
            e,
            si
          ), a = a !== null && a.data === Td ? a : null, a !== null && (i = {
            dehydrated: a,
            treeContext: H0(),
            retryLane: 536870912,
            hydrationErrors: null
          }, t.memoizedState = i, i = zp(a), i.return = t, t.child = i, La = t, on = null)) : a = null, a === null)
            throw sa(t, e), Ml(t);
          return t.lanes = 536870912, null;
        }
        return Tf(t, i);
      }
      var s = e.memoizedState;
      if (s !== null) {
        var y = s.dehydrated;
        if (ru(t), c)
          if (t.flags & 256)
            t.flags &= -257, t = Ip(
              e,
              t,
              a
            );
          else if (t.memoizedState !== null)
            t.child = e.child, t.flags |= 128, t = null;
          else
            throw Error(
              "Client rendering an Activity suspended it again. This is a bug in React."
            );
        else if (B0(), (a & 536870912) !== 0 && qr(t), In || uu(
          e,
          t,
          a,
          !1
        ), c = (a & e.childLanes) !== 0, In || c) {
          if (i = Ft, i !== null && (y = lr(
            i,
            a
          ), y !== 0 && y !== s.retryLane))
            throw s.retryLane = y, ra(e, y), Ze(i, e, y), TS;
          Vr(), t = Ip(
            e,
            t,
            a
          );
        } else
          e = s.treeContext, on = gl(
            y.nextSibling
          ), La = t, pt = !0, vs = null, Bo = !1, Tu = null, si = !1, e !== null && L0(t, e), t = Tf(t, i), t.flags |= 4096;
        return t;
      }
      return s = e.child, i = { mode: i.mode, children: i.children }, (a & 536870912) !== 0 && (a & e.lanes) !== 0 && qr(t), e = Nu(s, i), e.ref = t.ref, t.child = e, e.return = t, e;
    }
    function Af(e, t) {
      var a = t.ref;
      if (a === null)
        e !== null && e.ref !== null && (t.flags |= 4194816);
      else {
        if (typeof a != "function" && typeof a != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (e === null || e.ref !== a) && (t.flags |= 4194816);
      }
    }
    function Pp(e, t, a, i, c) {
      if (a.prototype && typeof a.prototype.render == "function") {
        var s = Se(a) || "Unknown";
        bT[s] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          s,
          s
        ), bT[s] = !0);
      }
      return t.mode & $a && Ji.recordLegacyContextWarning(
        t,
        null
      ), e === null && (Nr(t, t.type), a.contextTypes && (s = Se(a) || "Unknown", ET[s] || (ET[s] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        s
      )))), ro(t), a = qp(
        e,
        t,
        a,
        i,
        void 0,
        c
      ), i = fc(), e !== null && !In ? (sf(e, t, c), fu(e, t, c)) : (pt && i && Id(t), t.flags |= 1, Jn(e, t, a, c), t.child);
    }
    function ey(e, t, a, i, c, s) {
      return ro(t), kc = -1, Hg = e !== null && e.type !== t.type, t.updateQueue = null, a = cf(
        t,
        i,
        a,
        c
      ), Sn(e, t), i = fc(), e !== null && !In ? (sf(e, t, s), fu(e, t, s)) : (pt && i && Id(t), t.flags |= 1, Jn(e, t, a, s), t.child);
    }
    function Tc(e, t, a, i, c) {
      switch (S(t)) {
        case !1:
          var s = t.stateNode, y = new t.type(
            t.memoizedProps,
            s.context
          ).state;
          s.updater.enqueueSetState(s, y, null);
          break;
        case !0:
          t.flags |= 128, t.flags |= 65536, s = Error("Simulated error coming from DevTools");
          var b = c & -c;
          if (t.lanes |= b, y = Ft, y === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          b = bh(b), Sh(
            b,
            y,
            t,
            Ea(s, t)
          ), uf(t, b);
      }
      if (ro(t), t.stateNode === null) {
        if (y = gs, s = a.contextType, "contextType" in a && s !== null && (s === void 0 || s.$$typeof !== bu) && !gT.has(a) && (gT.add(a), b = s === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof s != "object" ? " However, it is set to a " + typeof s + "." : s.$$typeof === cm ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(s).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          Se(a) || "Component",
          b
        )), typeof s == "object" && s !== null && (y = Ct(s)), s = new a(i, y), t.mode & $a) {
          Z(!0);
          try {
            s = new a(i, y);
          } finally {
            Z(!1);
          }
        }
        if (y = t.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, s.updater = SS, t.stateNode = s, s._reactInternals = t, s._reactInternalInstance = cT, typeof a.getDerivedStateFromProps == "function" && y === null && (y = Se(a) || "Component", sT.has(y) || (sT.add(y), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          y,
          s.state === null ? "null" : "undefined",
          y
        ))), typeof a.getDerivedStateFromProps == "function" || typeof s.getSnapshotBeforeUpdate == "function") {
          var A = b = y = null;
          if (typeof s.componentWillMount == "function" && s.componentWillMount.__suppressDeprecationWarning !== !0 ? y = "componentWillMount" : typeof s.UNSAFE_componentWillMount == "function" && (y = "UNSAFE_componentWillMount"), typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? b = "componentWillReceiveProps" : typeof s.UNSAFE_componentWillReceiveProps == "function" && (b = "UNSAFE_componentWillReceiveProps"), typeof s.componentWillUpdate == "function" && s.componentWillUpdate.__suppressDeprecationWarning !== !0 ? A = "componentWillUpdate" : typeof s.UNSAFE_componentWillUpdate == "function" && (A = "UNSAFE_componentWillUpdate"), y !== null || b !== null || A !== null) {
            s = Se(a) || "Component";
            var D = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            dT.has(s) || (dT.add(s), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              s,
              D,
              y !== null ? `
  ` + y : "",
              b !== null ? `
  ` + b : "",
              A !== null ? `
  ` + A : ""
            ));
          }
        }
        s = t.stateNode, y = Se(a) || "Component", s.render || (a.prototype && typeof a.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          y
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          y
        )), !s.getInitialState || s.getInitialState.isReactClassApproved || s.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          y
        ), s.getDefaultProps && !s.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          y
        ), s.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          y
        ), a.childContextTypes && !yT.has(a) && (yT.add(a), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          y
        )), a.contextTypes && !pT.has(a) && (pT.add(a), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          y
        )), typeof s.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          y
        ), a.prototype && a.prototype.isPureReactComponent && typeof s.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          Se(a) || "A pure component"
        ), typeof s.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          y
        ), typeof s.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          y
        ), typeof s.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          y
        ), typeof s.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          y
        ), b = s.props !== i, s.props !== void 0 && b && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          y
        ), s.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          y,
          y
        ), typeof s.getSnapshotBeforeUpdate != "function" || typeof s.componentDidUpdate == "function" || fT.has(a) || (fT.add(a), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          Se(a)
        )), typeof s.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          y
        ), typeof s.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          y
        ), typeof a.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          y
        ), (b = s.state) && (typeof b != "object" || _n(b)) && console.error("%s.state: must be set to an object or null", y), typeof s.getChildContext == "function" && typeof a.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          y
        ), s = t.stateNode, s.props = i, s.state = t.memoizedState, s.refs = {}, ht(t), y = a.contextType, s.context = typeof y == "object" && y !== null ? Ct(y) : gs, s.state === i && (y = Se(a) || "Component", hT.has(y) || (hT.add(y), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          y
        ))), t.mode & $a && Ji.recordLegacyContextWarning(
          t,
          s
        ), Ji.recordUnsafeLifecycleWarnings(
          t,
          s
        ), s.state = t.memoizedState, y = a.getDerivedStateFromProps, typeof y == "function" && (Mr(
          t,
          a,
          y,
          i
        ), s.state = t.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof s.getSnapshotBeforeUpdate == "function" || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (y = s.state, typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), y !== s.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          ae(t) || "Component"
        ), SS.enqueueReplaceState(
          s,
          s.state,
          null
        )), ju(t, i, s, c), Ar(), s.state = t.memoizedState), typeof s.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Zi) !== Qe && (t.flags |= 134217728), s = !0;
      } else if (e === null) {
        s = t.stateNode;
        var j = t.memoizedProps;
        b = Qu(a, j), s.props = b;
        var V = s.context;
        A = a.contextType, y = gs, typeof A == "object" && A !== null && (y = Ct(A)), D = a.getDerivedStateFromProps, A = typeof D == "function" || typeof s.getSnapshotBeforeUpdate == "function", j = t.pendingProps !== j, A || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (j || V !== y) && Xu(
          t,
          s,
          i,
          y
        ), As = !1;
        var w = t.memoizedState;
        s.state = w, ju(t, i, s, c), Ar(), V = t.memoizedState, j || w !== V || As ? (typeof D == "function" && (Mr(
          t,
          a,
          D,
          i
        ), V = t.memoizedState), (b = As || ph(
          t,
          a,
          b,
          i,
          w,
          V,
          y
        )) ? (A || typeof s.UNSAFE_componentWillMount != "function" && typeof s.componentWillMount != "function" || (typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount()), typeof s.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Zi) !== Qe && (t.flags |= 134217728)) : (typeof s.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Zi) !== Qe && (t.flags |= 134217728), t.memoizedProps = i, t.memoizedState = V), s.props = i, s.state = V, s.context = y, s = b) : (typeof s.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & Zi) !== Qe && (t.flags |= 134217728), s = !1);
      } else {
        s = t.stateNode, Lu(e, t), y = t.memoizedProps, A = Qu(a, y), s.props = A, D = t.pendingProps, w = s.context, V = a.contextType, b = gs, typeof V == "object" && V !== null && (b = Ct(V)), j = a.getDerivedStateFromProps, (V = typeof j == "function" || typeof s.getSnapshotBeforeUpdate == "function") || typeof s.UNSAFE_componentWillReceiveProps != "function" && typeof s.componentWillReceiveProps != "function" || (y !== D || w !== b) && Xu(
          t,
          s,
          i,
          b
        ), As = !1, w = t.memoizedState, s.state = w, ju(t, i, s, c), Ar();
        var $ = t.memoizedState;
        y !== D || w !== $ || As || e !== null && e.dependencies !== null && br(e.dependencies) ? (typeof j == "function" && (Mr(
          t,
          a,
          j,
          i
        ), $ = t.memoizedState), (A = As || ph(
          t,
          a,
          A,
          i,
          w,
          $,
          b
        ) || e !== null && e.dependencies !== null && br(e.dependencies)) ? (V || typeof s.UNSAFE_componentWillUpdate != "function" && typeof s.componentWillUpdate != "function" || (typeof s.componentWillUpdate == "function" && s.componentWillUpdate(i, $, b), typeof s.UNSAFE_componentWillUpdate == "function" && s.UNSAFE_componentWillUpdate(
          i,
          $,
          b
        )), typeof s.componentDidUpdate == "function" && (t.flags |= 4), typeof s.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof s.componentDidUpdate != "function" || y === e.memoizedProps && w === e.memoizedState || (t.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || y === e.memoizedProps && w === e.memoizedState || (t.flags |= 1024), t.memoizedProps = i, t.memoizedState = $), s.props = i, s.state = $, s.context = b, s = A) : (typeof s.componentDidUpdate != "function" || y === e.memoizedProps && w === e.memoizedState || (t.flags |= 4), typeof s.getSnapshotBeforeUpdate != "function" || y === e.memoizedProps && w === e.memoizedState || (t.flags |= 1024), s = !1);
      }
      if (b = s, Af(e, t), y = (t.flags & 128) !== 0, b || y) {
        if (b = t.stateNode, qa(t), y && typeof a.getDerivedStateFromError != "function")
          a = null, Tl = -1;
        else if (a = j2(b), t.mode & $a) {
          Z(!0);
          try {
            j2(b);
          } finally {
            Z(!1);
          }
        }
        t.flags |= 1, e !== null && y ? (t.child = md(
          t,
          e.child,
          null,
          c
        ), t.child = md(
          t,
          null,
          a,
          c
        )) : Jn(e, t, a, c), t.memoizedState = b.state, e = t.child;
      } else
        e = fu(
          e,
          t,
          c
        );
      return c = t.stateNode, s && c.props !== i && (Ym || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        ae(t) || "a component"
      ), Ym = !0), e;
    }
    function ty(e, t, a, i) {
      return oo(), t.flags |= 256, Jn(e, t, a, i), t.child;
    }
    function Nr(e, t) {
      t && t.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        t.displayName || t.name || "Component"
      ), typeof t.getDerivedStateFromProps == "function" && (e = Se(t) || "Unknown", TT[e] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        e
      ), TT[e] = !0)), typeof t.contextType == "object" && t.contextType !== null && (t = Se(t) || "Unknown", ST[t] || (console.error(
        "%s: Function components do not support contextType.",
        t
      ), ST[t] = !0));
    }
    function xr(e) {
      return { baseLanes: e, cachePool: xp() };
    }
    function Eh(e, t, a) {
      return e = e !== null ? e.childLanes & ~a : 0, t && (e |= Zl), e;
    }
    function Th(e, t, a) {
      var i, c = t.pendingProps;
      g(t) && (t.flags |= 128);
      var s = !1, y = (t.flags & 128) !== 0;
      if ((i = y) || (i = e !== null && e.memoizedState === null ? !1 : (jn.current & Ng) !== 0), i && (s = !0, t.flags &= -129), i = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
        if (pt) {
          if (s ? Da(t) : qu(t), (e = on) ? (a = Lt(
            e,
            si
          ), a = a !== null && a.data !== Td ? a : null, a !== null && (i = {
            dehydrated: a,
            treeContext: H0(),
            retryLane: 536870912,
            hydrationErrors: null
          }, t.memoizedState = i, i = zp(a), i.return = t, t.child = i, La = t, on = null)) : a = null, a === null)
            throw sa(t, e), Ml(t);
          return xy(a) ? t.lanes = 32 : t.lanes = 536870912, null;
        }
        var b = c.children;
        if (c = c.fallback, s) {
          qu(t);
          var A = t.mode;
          return b = Of(
            { mode: "hidden", children: b },
            A
          ), c = ac(
            c,
            A,
            a,
            null
          ), b.return = t, c.return = t, b.sibling = c, t.child = b, c = t.child, c.memoizedState = xr(a), c.childLanes = Eh(
            e,
            i,
            a
          ), t.memoizedState = AS, Ec(
            null,
            c
          );
        }
        return Da(t), ny(
          t,
          b
        );
      }
      var D = e.memoizedState;
      if (D !== null) {
        var j = D.dehydrated;
        if (j !== null) {
          if (y)
            t.flags & 256 ? (Da(t), t.flags &= -257, t = Ah(
              e,
              t,
              a
            )) : t.memoizedState !== null ? (qu(t), t.child = e.child, t.flags |= 128, t = null) : (qu(t), b = c.fallback, A = t.mode, c = Of(
              {
                mode: "visible",
                children: c.children
              },
              A
            ), b = ac(
              b,
              A,
              a,
              null
            ), b.flags |= 2, c.return = t, b.return = t, c.sibling = b, t.child = c, md(
              t,
              e.child,
              null,
              a
            ), c = t.child, c.memoizedState = xr(a), c.childLanes = Eh(
              e,
              i,
              a
            ), t.memoizedState = AS, t = Ec(
              null,
              c
            ));
          else if (Da(t), B0(), (a & 536870912) !== 0 && qr(t), xy(
            j
          )) {
            if (i = j.nextSibling && j.nextSibling.dataset, i) {
              b = i.dgst;
              var V = i.msg;
              A = i.stck;
              var w = i.cstck;
            }
            s = V, i = b, c = A, j = w, b = s, A = j, b = Error(b || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), b.stack = c || "", b.digest = i, i = A === void 0 ? null : A, c = {
              value: b,
              source: null,
              stack: i
            }, typeof i == "string" && nS.set(
              b,
              c
            ), Ps(c), t = Ah(
              e,
              t,
              a
            );
          } else if (In || uu(
            e,
            t,
            a,
            !1
          ), i = (a & e.childLanes) !== 0, In || i) {
            if (i = Ft, i !== null && (c = lr(
              i,
              a
            ), c !== 0 && c !== D.retryLane))
              throw D.retryLane = c, ra(
                e,
                c
              ), Ze(
                i,
                e,
                c
              ), TS;
            Gf(
              j
            ) || Vr(), t = Ah(
              e,
              t,
              a
            );
          } else
            Gf(
              j
            ) ? (t.flags |= 192, t.child = e.child, t = null) : (e = D.treeContext, on = gl(
              j.nextSibling
            ), La = t, pt = !0, vs = null, Bo = !1, Tu = null, si = !1, e !== null && L0(t, e), t = ny(
              t,
              c.children
            ), t.flags |= 4096);
          return t;
        }
      }
      return s ? (qu(t), b = c.fallback, A = t.mode, w = e.child, j = w.sibling, c = Nu(
        w,
        {
          mode: "hidden",
          children: c.children
        }
      ), c.subtreeFlags = w.subtreeFlags & 65011712, j !== null ? b = Nu(
        j,
        b
      ) : (b = ac(
        b,
        A,
        a,
        null
      ), b.flags |= 2), b.return = t, c.return = t, c.sibling = b, t.child = c, Ec(null, c), c = t.child, b = e.child.memoizedState, b === null ? b = xr(a) : (A = b.cachePool, A !== null ? (w = $n._currentValue, A = A.parent !== w ? { parent: w, pool: w } : A) : A = xp(), b = {
        baseLanes: b.baseLanes | a,
        cachePool: A
      }), c.memoizedState = b, c.childLanes = Eh(
        e,
        i,
        a
      ), t.memoizedState = AS, Ec(
        e.child,
        c
      )) : (D !== null && (a & 62914560) === a && (a & e.lanes) !== 0 && qr(t), Da(t), a = e.child, e = a.sibling, a = Nu(a, {
        mode: "visible",
        children: c.children
      }), a.return = t, a.sibling = null, e !== null && (i = t.deletions, i === null ? (t.deletions = [e], t.flags |= 16) : i.push(e)), t.child = a, t.memoizedState = null, a);
    }
    function ny(e, t) {
      return t = Of(
        { mode: "visible", children: t },
        e.mode
      ), t.return = e, e.child = t;
    }
    function Of(e, t) {
      return e = L(22, e, null, t), e.lanes = 0, e;
    }
    function Ah(e, t, a) {
      return md(t, e.child, null, a), e = ny(
        t,
        t.pendingProps.children
      ), e.flags |= 2, t.memoizedState = null, e;
    }
    function ay(e, t, a) {
      e.lanes |= t;
      var i = e.alternate;
      i !== null && (i.lanes |= t), eh(
        e.return,
        t,
        a
      );
    }
    function Oh(e, t, a, i, c, s) {
      var y = e.memoizedState;
      y === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: a,
        tailMode: c,
        treeForkCount: s
      } : (y.isBackwards = t, y.rendering = null, y.renderingStartTime = 0, y.last = i, y.tail = a, y.tailMode = c, y.treeForkCount = s);
    }
    function ly(e, t, a) {
      var i = t.pendingProps, c = i.revealOrder, s = i.tail, y = i.children, b = jn.current;
      if ((i = (b & Ng) !== 0) ? (b = b & Bm | Ng, t.flags |= 128) : b &= Bm, we(jn, b, t), b = c ?? "null", c !== "forwards" && c !== "unstable_legacy-backwards" && c !== "together" && c !== "independent" && !AT[b])
        if (AT[b] = !0, c == null)
          console.error(
            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
          );
        else if (c === "backwards")
          console.error(
            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
          );
        else if (typeof c == "string")
          switch (c.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
            case "independent":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                c,
                c.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                c,
                c.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
                c
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
            c
          );
      b = s ?? "null", m1[b] || (s == null ? (c === "forwards" || c === "backwards" || c === "unstable_legacy-backwards") && (m1[b] = !0, console.error(
        'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
      )) : s !== "visible" && s !== "collapsed" && s !== "hidden" ? (m1[b] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
        s
      )) : c !== "forwards" && c !== "backwards" && c !== "unstable_legacy-backwards" && (m1[b] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        s
      )));
      e: if ((c === "forwards" || c === "backwards" || c === "unstable_legacy-backwards") && y !== void 0 && y !== null && y !== !1)
        if (_n(y)) {
          for (b = 0; b < y.length; b++)
            if (!Jt(
              y[b],
              b
            ))
              break e;
        } else if (b = ge(y), typeof b == "function") {
          if (b = b.call(y))
            for (var A = b.next(), D = 0; !A.done; A = b.next()) {
              if (!Jt(A.value, D)) break e;
              D++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            c
          );
      if (Jn(e, t, y, a), pt ? (io(), y = vg) : y = 0, !i && e !== null && (e.flags & 128) !== 0)
        e: for (e = t.child; e !== null; ) {
          if (e.tag === 13)
            e.memoizedState !== null && ay(e, a, t);
          else if (e.tag === 19)
            ay(e, a, t);
          else if (e.child !== null) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === t) break e;
          for (; e.sibling === null; ) {
            if (e.return === null || e.return === t)
              break e;
            e = e.return;
          }
          e.sibling.return = e.return, e = e.sibling;
        }
      switch (c) {
        case "forwards":
          for (a = t.child, c = null; a !== null; )
            e = a.alternate, e !== null && sc(e) === null && (c = a), a = a.sibling;
          a = c, a === null ? (c = t.child, t.child = null) : (c = a.sibling, a.sibling = null), Oh(
            t,
            !1,
            c,
            a,
            s,
            y
          );
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          for (a = null, c = t.child, t.child = null; c !== null; ) {
            if (e = c.alternate, e !== null && sc(e) === null) {
              t.child = c;
              break;
            }
            e = c.sibling, c.sibling = a, a = c, c = e;
          }
          Oh(
            t,
            !0,
            a,
            null,
            s,
            y
          );
          break;
        case "together":
          Oh(
            t,
            !1,
            null,
            null,
            void 0,
            y
          );
          break;
        default:
          t.memoizedState = null;
      }
      return t.child;
    }
    function fu(e, t, a) {
      if (e !== null && (t.dependencies = e.dependencies), Tl = -1, Rs |= t.lanes, (a & t.childLanes) === 0)
        if (e !== null) {
          if (uu(
            e,
            t,
            a,
            !1
          ), (a & t.childLanes) === 0)
            return null;
        } else return null;
      if (e !== null && t.child !== e.child)
        throw Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        for (e = t.child, a = Nu(e, e.pendingProps), t.child = a, a.return = t; e.sibling !== null; )
          e = e.sibling, a = a.sibling = Nu(e, e.pendingProps), a.return = t;
        a.sibling = null;
      }
      return t.child;
    }
    function Dh(e, t) {
      return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && br(e)));
    }
    function J0(e, t, a) {
      switch (t.tag) {
        case 3:
          Rt(
            t,
            t.stateNode.containerInfo
          ), Nl(
            t,
            $n,
            e.memoizedState.cache
          ), oo();
          break;
        case 27:
        case 5:
          fe(t);
          break;
        case 4:
          Rt(
            t,
            t.stateNode.containerInfo
          );
          break;
        case 10:
          Nl(
            t,
            t.type,
            t.memoizedProps.value
          );
          break;
        case 12:
          (a & t.childLanes) !== 0 && (t.flags |= 4), t.flags |= 2048;
          var i = t.stateNode;
          i.effectDuration = -0, i.passiveEffectDuration = -0;
          break;
        case 31:
          if (t.memoizedState !== null)
            return t.flags |= 128, ru(t), null;
          break;
        case 13:
          if (i = t.memoizedState, i !== null)
            return i.dehydrated !== null ? (Da(t), t.flags |= 128, null) : (a & t.child.childLanes) !== 0 ? Th(
              e,
              t,
              a
            ) : (Da(t), e = fu(
              e,
              t,
              a
            ), e !== null ? e.sibling : null);
          Da(t);
          break;
        case 19:
          var c = (e.flags & 128) !== 0;
          if (i = (a & t.childLanes) !== 0, i || (uu(
            e,
            t,
            a,
            !1
          ), i = (a & t.childLanes) !== 0), c) {
            if (i)
              return ly(
                e,
                t,
                a
              );
            t.flags |= 128;
          }
          if (c = t.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), we(
            jn,
            jn.current,
            t
          ), i) break;
          return null;
        case 22:
          return t.lanes = 0, Fp(
            e,
            t,
            a,
            t.pendingProps
          );
        case 24:
          Nl(
            t,
            $n,
            e.memoizedState.cache
          );
      }
      return fu(e, t, a);
    }
    function Df(e, t, a) {
      if (t._debugNeedsRemount && e !== null) {
        a = nc(
          t.type,
          t.key,
          t.pendingProps,
          t._debugOwner || null,
          t.mode,
          t.lanes
        ), a._debugStack = t._debugStack, a._debugTask = t._debugTask;
        var i = t.return;
        if (i === null) throw Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, a._debugInfo = t._debugInfo, t === i.child)
          i.child = a;
        else {
          var c = i.child;
          if (c === null)
            throw Error("Expected parent to have a child.");
          for (; c.sibling !== t; )
            if (c = c.sibling, c === null)
              throw Error("Expected to find the previous sibling.");
          c.sibling = a;
        }
        return t = i.deletions, t === null ? (i.deletions = [e], i.flags |= 16) : t.push(e), a.flags |= 2, a;
      }
      if (e !== null)
        if (e.memoizedProps !== t.pendingProps || t.type !== e.type)
          In = !0;
        else {
          if (!Dh(e, a) && (t.flags & 128) === 0)
            return In = !1, J0(
              e,
              t,
              a
            );
          In = (e.flags & 131072) !== 0;
        }
      else
        In = !1, (i = pt) && (io(), i = (t.flags & 1048576) !== 0), i && (i = t.index, io(), _p(t, vg, i));
      switch (t.lanes = 0, t.tag) {
        case 16:
          e: if (i = t.pendingProps, e = cl(t.elementType), t.type = e, typeof e == "function")
            Rp(e) ? (i = Qu(
              e,
              i
            ), t.tag = 1, t.type = e = lo(e), t = Tc(
              null,
              t,
              e,
              i,
              a
            )) : (t.tag = 0, Nr(t, e), t.type = e = lo(e), t = Pp(
              null,
              t,
              e,
              i,
              a
            ));
          else {
            if (e != null) {
              if (c = e.$$typeof, c === as) {
                t.tag = 11, t.type = e = Fd(e), t = Q0(
                  null,
                  t,
                  e,
                  i,
                  a
                );
                break e;
              } else if (c === If) {
                t.tag = 14, t = kp(
                  null,
                  t,
                  e,
                  i,
                  a
                );
                break e;
              }
            }
            throw t = "", e !== null && typeof e == "object" && e.$$typeof === da && (t = " Did you wrap a component in React.lazy() more than once?"), a = Se(e) || e, Error(
              "Element type is invalid. Received a promise that resolves to: " + a + ". Lazy element type must resolve to a class or function." + t
            );
          }
          return t;
        case 0:
          return Pp(
            e,
            t,
            t.type,
            t.pendingProps,
            a
          );
        case 1:
          return i = t.type, c = Qu(
            i,
            t.pendingProps
          ), Tc(
            e,
            t,
            i,
            c,
            a
          );
        case 3:
          e: {
            if (Rt(
              t,
              t.stateNode.containerInfo
            ), e === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            i = t.pendingProps;
            var s = t.memoizedState;
            c = s.element, Lu(e, t), ju(t, i, null, a);
            var y = t.memoizedState;
            if (i = y.cache, Nl(t, $n, i), i !== s.cache && Di(
              t,
              [$n],
              a,
              !0
            ), Ar(), i = y.element, s.isDehydrated)
              if (s = {
                element: i,
                isDehydrated: !1,
                cache: y.cache
              }, t.updateQueue.baseState = s, t.memoizedState = s, t.flags & 256) {
                t = ty(
                  e,
                  t,
                  i,
                  a
                );
                break e;
              } else if (i !== c) {
                c = Ea(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  t
                ), Ps(c), t = ty(
                  e,
                  t,
                  i,
                  a
                );
                break e;
              } else {
                switch (e = t.stateNode.containerInfo, e.nodeType) {
                  case 9:
                    e = e.body;
                    break;
                  default:
                    e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
                }
                for (on = gl(e.firstChild), La = t, pt = !0, vs = null, Bo = !1, Tu = null, si = !0, a = I2(
                  t,
                  null,
                  i,
                  a
                ), t.child = a; a; )
                  a.flags = a.flags & -3 | 4096, a = a.sibling;
              }
            else {
              if (oo(), i === c) {
                t = fu(
                  e,
                  t,
                  a
                );
                break e;
              }
              Jn(
                e,
                t,
                i,
                a
              );
            }
            t = t.child;
          }
          return t;
        case 26:
          return Af(e, t), e === null ? (a = jy(
            t.type,
            null,
            t.pendingProps,
            null
          )) ? t.memoizedState = a : pt || (a = t.type, e = t.pendingProps, i = We(
            vl.current
          ), i = Vf(
            i
          ).createElement(a), i[ln] = t, i[Ha] = e, an(i, a, e), vn(i), t.stateNode = i) : t.memoizedState = jy(
            t.type,
            e.memoizedProps,
            t.pendingProps,
            e.memoizedState
          ), null;
        case 27:
          return fe(t), e === null && pt && (i = We(vl.current), c = ue(), i = t.stateNode = Yi(
            t.type,
            t.pendingProps,
            i,
            c,
            !1
          ), Bo || (c = Ja(
            i,
            t.type,
            t.pendingProps,
            c
          ), c !== null && (lc(t, 0).serverProps = c)), La = t, si = !0, c = on, Uo(t.type) ? (JS = c, on = gl(
            i.firstChild
          )) : on = c), Jn(
            e,
            t,
            t.pendingProps.children,
            a
          ), Af(e, t), e === null && (t.flags |= 4194304), t.child;
        case 5:
          return e === null && pt && (s = ue(), i = Xs(
            t.type,
            s.ancestorInfo
          ), c = on, (y = !c) || (y = Tv(
            c,
            t.type,
            t.pendingProps,
            si
          ), y !== null ? (t.stateNode = y, Bo || (s = Ja(
            y,
            t.type,
            t.pendingProps,
            s
          ), s !== null && (lc(t, 0).serverProps = s)), La = t, on = gl(
            y.firstChild
          ), si = !1, s = !0) : s = !1, y = !s), y && (i && sa(t, c), Ml(t))), fe(t), c = t.type, s = t.pendingProps, y = e !== null ? e.memoizedProps : null, i = s.children, kr(c, s) ? i = null : y !== null && kr(c, y) && (t.flags |= 32), t.memoizedState !== null && (c = qp(
            e,
            t,
            rf,
            null,
            null,
            a
          ), Wg._currentValue = c), Af(e, t), Jn(
            e,
            t,
            i,
            a
          ), t.child;
        case 6:
          return e === null && pt && (a = t.pendingProps, e = ue(), i = e.ancestorInfo.current, a = i != null ? Qs(
            a,
            i.tag,
            e.ancestorInfo.implicitRootScope
          ) : !0, e = on, (i = !e) || (i = Av(
            e,
            t.pendingProps,
            si
          ), i !== null ? (t.stateNode = i, La = t, on = null, i = !0) : i = !1, i = !i), i && (a && sa(t, e), Ml(t))), null;
        case 13:
          return Th(e, t, a);
        case 4:
          return Rt(
            t,
            t.stateNode.containerInfo
          ), i = t.pendingProps, e === null ? t.child = md(
            t,
            null,
            i,
            a
          ) : Jn(
            e,
            t,
            i,
            a
          ), t.child;
        case 11:
          return Q0(
            e,
            t,
            t.type,
            t.pendingProps,
            a
          );
        case 7:
          return Jn(
            e,
            t,
            t.pendingProps,
            a
          ), t.child;
        case 8:
          return Jn(
            e,
            t,
            t.pendingProps.children,
            a
          ), t.child;
        case 12:
          return t.flags |= 4, t.flags |= 2048, i = t.stateNode, i.effectDuration = -0, i.passiveEffectDuration = -0, Jn(
            e,
            t,
            t.pendingProps.children,
            a
          ), t.child;
        case 10:
          return i = t.type, c = t.pendingProps, s = c.value, "value" in c || OT || (OT = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), Nl(t, i, s), Jn(
            e,
            t,
            c.children,
            a
          ), t.child;
        case 9:
          return c = t.type._context, i = t.pendingProps.children, typeof i != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), ro(t), c = Ct(c), i = sS(
            i,
            c,
            void 0
          ), t.flags |= 1, Jn(
            e,
            t,
            i,
            a
          ), t.child;
        case 14:
          return kp(
            e,
            t,
            t.type,
            t.pendingProps,
            a
          );
        case 15:
          return $p(
            e,
            t,
            t.type,
            t.pendingProps,
            a
          );
        case 19:
          return ly(
            e,
            t,
            a
          );
        case 31:
          return Z0(e, t, a);
        case 22:
          return Fp(
            e,
            t,
            a,
            t.pendingProps
          );
        case 24:
          return ro(t), i = Ct($n), e === null ? (c = zi(), c === null && (c = Ft, s = th(), c.pooledCache = s, ic(s), s !== null && (c.pooledCacheLanes |= a), c = s), t.memoizedState = {
            parent: i,
            cache: c
          }, ht(t), Nl(t, $n, c)) : ((e.lanes & a) !== 0 && (Lu(e, t), ju(t, null, null, a), Ar()), c = e.memoizedState, s = t.memoizedState, c.parent !== i ? (c = {
            parent: i,
            cache: i
          }, t.memoizedState = c, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = c), Nl(t, $n, i)) : (i = s.cache, Nl(t, $n, i), i !== c.cache && Di(
            t,
            [$n],
            a,
            !0
          ))), Jn(
            e,
            t,
            t.pendingProps.children,
            a
          ), t.child;
        case 29:
          throw t.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function Zu(e) {
      e.flags |= 4;
    }
    function Rh(e, t, a, i, c) {
      if ((t = (e.mode & ER) !== Qe) && (t = !1), t) {
        if (e.flags |= 16777216, (c & 335544128) === c)
          if (e.stateNode.complete) e.flags |= 8192;
          else if (Ty()) e.flags |= 8192;
          else
            throw hd = c1, dS;
      } else e.flags &= -16777217;
    }
    function K0(e, t) {
      if (t.type !== "stylesheet" || (t.state.loading & pi) !== Dd)
        e.flags &= -16777217;
      else if (e.flags |= 16777216, !dt(t))
        if (Ty()) e.flags |= 8192;
        else
          throw hd = c1, dS;
    }
    function Hr(e, t) {
      t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? et() : 536870912, e.lanes |= t, bd |= t);
    }
    function Lr(e, t) {
      if (!pt)
        switch (e.tailMode) {
          case "hidden":
            t = e.tail;
            for (var a = null; t !== null; )
              t.alternate !== null && (a = t), t = t.sibling;
            a === null ? e.tail = null : a.sibling = null;
            break;
          case "collapsed":
            a = e.tail;
            for (var i = null; a !== null; )
              a.alternate !== null && (i = a), a = a.sibling;
            i === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : i.sibling = null;
        }
    }
    function Vt(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = 0, i = 0;
      if (t)
        if ((e.mode & it) !== Qe) {
          for (var c = e.selfBaseDuration, s = e.child; s !== null; )
            a |= s.lanes | s.childLanes, i |= s.subtreeFlags & 65011712, i |= s.flags & 65011712, c += s.treeBaseDuration, s = s.sibling;
          e.treeBaseDuration = c;
        } else
          for (c = e.child; c !== null; )
            a |= c.lanes | c.childLanes, i |= c.subtreeFlags & 65011712, i |= c.flags & 65011712, c.return = e, c = c.sibling;
      else if ((e.mode & it) !== Qe) {
        c = e.actualDuration, s = e.selfBaseDuration;
        for (var y = e.child; y !== null; )
          a |= y.lanes | y.childLanes, i |= y.subtreeFlags, i |= y.flags, c += y.actualDuration, s += y.treeBaseDuration, y = y.sibling;
        e.actualDuration = c, e.treeBaseDuration = s;
      } else
        for (c = e.child; c !== null; )
          a |= c.lanes | c.childLanes, i |= c.subtreeFlags, i |= c.flags, c.return = e, c = c.sibling;
      return e.subtreeFlags |= i, e.childLanes = a, t;
    }
    function uy(e, t, a) {
      var i = t.pendingProps;
      switch (Pd(t), t.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Vt(t), null;
        case 1:
          return Vt(t), null;
        case 3:
          return a = t.stateNode, i = null, e !== null && (i = e.memoizedState.cache), t.memoizedState.cache !== i && (t.flags |= 2048), lu($n, t), H(t), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), (e === null || e.child === null) && (uc(t) ? (co(), Zu(t)) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, Is())), Vt(t), null;
        case 26:
          var c = t.type, s = t.memoizedState;
          return e === null ? (Zu(t), s !== null ? (Vt(t), K0(
            t,
            s
          )) : (Vt(t), Rh(
            t,
            c,
            null,
            i,
            a
          ))) : s ? s !== e.memoizedState ? (Zu(t), Vt(t), K0(
            t,
            s
          )) : (Vt(t), t.flags &= -16777217) : (e = e.memoizedProps, e !== i && Zu(t), Vt(t), Rh(
            t,
            c,
            e,
            i,
            a
          )), null;
        case 27:
          if (be(t), a = We(vl.current), c = t.type, e !== null && t.stateNode != null)
            e.memoizedProps !== i && Zu(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Vt(t), null;
            }
            e = ue(), uc(t) ? Up(t) : (e = Yi(
              c,
              i,
              a,
              e,
              !0
            ), t.stateNode = e, Zu(t));
          }
          return Vt(t), null;
        case 5:
          if (be(t), c = t.type, e !== null && t.stateNode != null)
            e.memoizedProps !== i && Zu(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return Vt(t), null;
            }
            var y = ue();
            if (uc(t))
              Up(t);
            else {
              switch (s = We(vl.current), Xs(c, y.ancestorInfo), y = y.context, s = Vf(s), y) {
                case $m:
                  s = s.createElementNS(
                    at,
                    c
                  );
                  break;
                case x1:
                  s = s.createElementNS(
                    Ie,
                    c
                  );
                  break;
                default:
                  switch (c) {
                    case "svg":
                      s = s.createElementNS(
                        at,
                        c
                      );
                      break;
                    case "math":
                      s = s.createElementNS(
                        Ie,
                        c
                      );
                      break;
                    case "script":
                      s = s.createElement("div"), s.innerHTML = "<script><\/script>", s = s.removeChild(
                        s.firstChild
                      );
                      break;
                    case "select":
                      s = typeof i.is == "string" ? s.createElement("select", {
                        is: i.is
                      }) : s.createElement("select"), i.multiple ? s.multiple = !0 : i.size && (s.size = i.size);
                      break;
                    default:
                      s = typeof i.is == "string" ? s.createElement(c, {
                        is: i.is
                      }) : s.createElement(c), c.indexOf("-") === -1 && (c !== c.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        c
                      ), Object.prototype.toString.call(s) !== "[object HTMLUnknownElement]" || bl.call(kT, c) || (kT[c] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        c
                      )));
                  }
              }
              s[ln] = t, s[Ha] = i;
              e: for (y = t.child; y !== null; ) {
                if (y.tag === 5 || y.tag === 6)
                  s.appendChild(y.stateNode);
                else if (y.tag !== 4 && y.tag !== 27 && y.child !== null) {
                  y.child.return = y, y = y.child;
                  continue;
                }
                if (y === t) break e;
                for (; y.sibling === null; ) {
                  if (y.return === null || y.return === t)
                    break e;
                  y = y.return;
                }
                y.sibling.return = y.return, y = y.sibling;
              }
              t.stateNode = s;
              e: switch (an(s, c, i), c) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  i = !!i.autoFocus;
                  break e;
                case "img":
                  i = !0;
                  break e;
                default:
                  i = !1;
              }
              i && Zu(t);
            }
          }
          return Vt(t), Rh(
            t,
            t.type,
            e === null ? null : e.memoizedProps,
            t.pendingProps,
            a
          ), null;
        case 6:
          if (e && t.stateNode != null)
            e.memoizedProps !== i && Zu(t);
          else {
            if (typeof i != "string" && t.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (e = We(vl.current), a = ue(), uc(t)) {
              if (e = t.stateNode, a = t.memoizedProps, c = !Bo, i = null, s = La, s !== null)
                switch (s.tag) {
                  case 3:
                    c && (c = Rv(
                      e,
                      a,
                      i
                    ), c !== null && (lc(t, 0).serverProps = c));
                    break;
                  case 27:
                  case 5:
                    i = s.memoizedProps, c && (c = Rv(
                      e,
                      a,
                      i
                    ), c !== null && (lc(
                      t,
                      0
                    ).serverProps = c));
                }
              e[ln] = t, e = !!(e.nodeValue === a || i !== null && i.suppressHydrationWarning === !0 || My(e.nodeValue, a)), e || Ml(t, !0);
            } else
              c = a.ancestorInfo.current, c != null && Qs(
                i,
                c.tag,
                a.ancestorInfo.implicitRootScope
              ), e = Vf(e).createTextNode(
                i
              ), e[ln] = t, t.stateNode = e;
          }
          return Vt(t), null;
        case 31:
          if (a = t.memoizedState, e === null || e.memoizedState !== null) {
            if (i = uc(t), a !== null) {
              if (e === null) {
                if (!i)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (e = t.memoizedState, e = e !== null ? e.dehydrated : null, !e)
                  throw Error(
                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                e[ln] = t, Vt(t), (t.mode & it) !== Qe && a !== null && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration));
              } else
                co(), oo(), (t.flags & 128) === 0 && (a = t.memoizedState = null), t.flags |= 4, Vt(t), (t.mode & it) !== Qe && a !== null && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration));
              e = !1;
            } else
              a = Is(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), e = !0;
            if (!e)
              return t.flags & 256 ? (Qn(t), t) : (Qn(t), null);
            if ((t.flags & 128) !== 0)
              throw Error(
                "Client rendering an Activity suspended it again. This is a bug in React."
              );
          }
          return Vt(t), null;
        case 13:
          if (i = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            if (c = i, s = uc(t), c !== null && c.dehydrated !== null) {
              if (e === null) {
                if (!s)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (s = t.memoizedState, s = s !== null ? s.dehydrated : null, !s)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                s[ln] = t, Vt(t), (t.mode & it) !== Qe && c !== null && (c = t.child, c !== null && (t.treeBaseDuration -= c.treeBaseDuration));
              } else
                co(), oo(), (t.flags & 128) === 0 && (c = t.memoizedState = null), t.flags |= 4, Vt(t), (t.mode & it) !== Qe && c !== null && (c = t.child, c !== null && (t.treeBaseDuration -= c.treeBaseDuration));
              c = !1;
            } else
              c = Is(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = c), c = !0;
            if (!c)
              return t.flags & 256 ? (Qn(t), t) : (Qn(t), null);
          }
          return Qn(t), (t.flags & 128) !== 0 ? (t.lanes = a, (t.mode & it) !== Qe && cc(t), t) : (a = i !== null, e = e !== null && e.memoizedState !== null, a && (i = t.child, c = null, i.alternate !== null && i.alternate.memoizedState !== null && i.alternate.memoizedState.cachePool !== null && (c = i.alternate.memoizedState.cachePool.pool), s = null, i.memoizedState !== null && i.memoizedState.cachePool !== null && (s = i.memoizedState.cachePool.pool), s !== c && (i.flags |= 2048)), a !== e && a && (t.child.flags |= 8192), Hr(t, t.updateQueue), Vt(t), (t.mode & it) !== Qe && a && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration)), null);
        case 4:
          return H(t), e === null && zo(
            t.stateNode.containerInfo
          ), Vt(t), null;
        case 10:
          return lu(t.type, t), Vt(t), null;
        case 19:
          if (Ce(jn, t), i = t.memoizedState, i === null) return Vt(t), null;
          if (c = (t.flags & 128) !== 0, s = i.rendering, s === null)
            if (c) Lr(i, !1);
            else {
              if (gn !== Fc || e !== null && (e.flags & 128) !== 0)
                for (e = t.child; e !== null; ) {
                  if (s = sc(e), s !== null) {
                    for (t.flags |= 128, Lr(i, !1), e = s.updateQueue, t.updateQueue = e, Hr(t, e), t.subtreeFlags = 0, e = a, a = t.child; a !== null; )
                      Cp(a, e), a = a.sibling;
                    return we(
                      jn,
                      jn.current & Bm | Ng,
                      t
                    ), pt && au(t, i.treeForkCount), t.child;
                  }
                  e = e.sibling;
                }
              i.tail !== null && kn() > E1 && (t.flags |= 128, c = !0, Lr(i, !1), t.lanes = 4194304);
            }
          else {
            if (!c)
              if (e = sc(s), e !== null) {
                if (t.flags |= 128, c = !0, e = e.updateQueue, t.updateQueue = e, Hr(t, e), Lr(i, !0), i.tail === null && i.tailMode === "hidden" && !s.alternate && !pt)
                  return Vt(t), null;
              } else
                2 * kn() - i.renderingStartTime > E1 && a !== 536870912 && (t.flags |= 128, c = !0, Lr(i, !1), t.lanes = 4194304);
            i.isBackwards ? (s.sibling = t.child, t.child = s) : (e = i.last, e !== null ? e.sibling = s : t.child = s, i.last = s);
          }
          return i.tail !== null ? (e = i.tail, i.rendering = e, i.tail = e.sibling, i.renderingStartTime = kn(), e.sibling = null, a = jn.current, a = c ? a & Bm | Ng : a & Bm, we(jn, a, t), pt && au(t, i.treeForkCount), e) : (Vt(t), null);
        case 22:
        case 23:
          return Qn(t), cu(t), i = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== i && (t.flags |= 8192) : i && (t.flags |= 8192), i ? (a & 536870912) !== 0 && (t.flags & 128) === 0 && (Vt(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Vt(t), a = t.updateQueue, a !== null && Hr(t, a.retryQueue), a = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), i = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (i = t.memoizedState.cachePool.pool), i !== a && (t.flags |= 2048), e !== null && Ce(fd, t), null;
        case 24:
          return a = null, e !== null && (a = e.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), lu($n, t), Vt(t), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function k0(e, t) {
      switch (Pd(t), t.tag) {
        case 1:
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & it) !== Qe && cc(t), t) : null;
        case 3:
          return lu($n, t), H(t), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
        case 26:
        case 27:
        case 5:
          return be(t), null;
        case 31:
          if (t.memoizedState !== null) {
            if (Qn(t), t.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            oo();
          }
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & it) !== Qe && cc(t), t) : null;
        case 13:
          if (Qn(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
            if (t.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            oo();
          }
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & it) !== Qe && cc(t), t) : null;
        case 19:
          return Ce(jn, t), null;
        case 4:
          return H(t), null;
        case 10:
          return lu(t.type, t), null;
        case 22:
        case 23:
          return Qn(t), cu(t), e !== null && Ce(fd, t), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & it) !== Qe && cc(t), t) : null;
        case 24:
          return lu($n, t), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function iy(e, t) {
      switch (Pd(t), t.tag) {
        case 3:
          lu($n, t), H(t);
          break;
        case 26:
        case 27:
        case 5:
          be(t);
          break;
        case 4:
          H(t);
          break;
        case 31:
          t.memoizedState !== null && Qn(t);
          break;
        case 13:
          Qn(t);
          break;
        case 19:
          Ce(jn, t);
          break;
        case 10:
          lu(t.type, t);
          break;
        case 22:
        case 23:
          Qn(t), cu(t), e !== null && Ce(fd, t);
          break;
        case 24:
          lu($n, t);
      }
    }
    function Ju(e) {
      return (e.mode & it) !== Qe;
    }
    function $0(e, t) {
      Ju(e) ? (hn(), Li(t, e), Aa()) : Li(t, e);
    }
    function Ch(e, t, a) {
      Ju(e) ? (hn(), To(
        a,
        e,
        t
      ), Aa()) : To(
        a,
        e,
        t
      );
    }
    function Li(e, t) {
      try {
        var a = t.updateQueue, i = a !== null ? a.lastEffect : null;
        if (i !== null) {
          var c = i.next;
          a = c;
          do {
            if ((a.tag & e) === e && (i = void 0, (e & Al) !== s1 && (Jm = !0), i = Ae(
              t,
              CR,
              a
            ), (e & Al) !== s1 && (Jm = !1), i !== void 0 && typeof i != "function")) {
              var s = void 0;
              s = (a.tag & Ou) !== 0 ? "useLayoutEffect" : (a.tag & Al) !== 0 ? "useInsertionEffect" : "useEffect";
              var y = void 0;
              y = i === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof i.then == "function" ? `

It looks like you wrote ` + s + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + s + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + i, Ae(
                t,
                function(b, A) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    b,
                    A
                  );
                },
                s,
                y
              );
            }
            a = a.next;
          } while (a !== c);
        }
      } catch (b) {
        nt(t, t.return, b);
      }
    }
    function To(e, t, a) {
      try {
        var i = t.updateQueue, c = i !== null ? i.lastEffect : null;
        if (c !== null) {
          var s = c.next;
          i = s;
          do {
            if ((i.tag & e) === e) {
              var y = i.inst, b = y.destroy;
              b !== void 0 && (y.destroy = void 0, (e & Al) !== s1 && (Jm = !0), c = t, Ae(
                c,
                zR,
                c,
                a,
                b
              ), (e & Al) !== s1 && (Jm = !1));
            }
            i = i.next;
          } while (i !== s);
        }
      } catch (A) {
        nt(t, t.return, A);
      }
    }
    function Rf(e, t) {
      Ju(e) ? (hn(), Li(t, e), Aa()) : Li(t, e);
    }
    function zh(e, t, a) {
      Ju(e) ? (hn(), To(
        a,
        e,
        t
      ), Aa()) : To(
        a,
        e,
        t
      );
    }
    function oy(e) {
      var t = e.updateQueue;
      if (t !== null) {
        var a = e.stateNode;
        e.type.defaultProps || "ref" in e.memoizedProps || Ym || (a.props !== e.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          ae(e) || "instance"
        ), a.state !== e.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          ae(e) || "instance"
        ));
        try {
          Ae(
            e,
            Or,
            t,
            a
          );
        } catch (i) {
          nt(e, e.return, i);
        }
      }
    }
    function Cf(e, t, a) {
      return e.getSnapshotBeforeUpdate(t, a);
    }
    function F0(e, t) {
      var a = t.memoizedProps, i = t.memoizedState;
      t = e.stateNode, e.type.defaultProps || "ref" in e.memoizedProps || Ym || (t.props !== e.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        ae(e) || "instance"
      ), t.state !== e.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        ae(e) || "instance"
      ));
      try {
        var c = Qu(
          e.type,
          a
        ), s = Ae(
          e,
          Cf,
          t,
          c,
          i
        );
        a = DT, s !== void 0 || a.has(e.type) || (a.add(e.type), Ae(e, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            ae(e)
          );
        })), t.__reactInternalSnapshotBeforeUpdate = s;
      } catch (y) {
        nt(e, e.return, y);
      }
    }
    function _h(e, t, a) {
      a.props = Qu(
        e.type,
        e.memoizedProps
      ), a.state = e.memoizedState, Ju(e) ? (hn(), Ae(
        e,
        Q2,
        e,
        t,
        a
      ), Aa()) : Ae(
        e,
        Q2,
        e,
        t,
        a
      );
    }
    function W0(e) {
      var t = e.ref;
      if (t !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var a = e.stateNode;
            break;
          case 30:
            a = e.stateNode;
            break;
          default:
            a = e.stateNode;
        }
        if (typeof t == "function")
          if (Ju(e))
            try {
              hn(), e.refCleanup = t(a);
            } finally {
              Aa();
            }
          else e.refCleanup = t(a);
        else
          typeof t == "string" ? console.error("String refs are no longer supported.") : t.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            ae(e)
          ), t.current = a;
      }
    }
    function Ac(e, t) {
      try {
        Ae(e, W0, e);
      } catch (a) {
        nt(e, t, a);
      }
    }
    function jl(e, t) {
      var a = e.ref, i = e.refCleanup;
      if (a !== null)
        if (typeof i == "function")
          try {
            if (Ju(e))
              try {
                hn(), Ae(e, i);
              } finally {
                Aa(e);
              }
            else Ae(e, i);
          } catch (c) {
            nt(e, t, c);
          } finally {
            e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
          }
        else if (typeof a == "function")
          try {
            if (Ju(e))
              try {
                hn(), Ae(e, a, null);
              } finally {
                Aa(e);
              }
            else Ae(e, a, null);
          } catch (c) {
            nt(e, t, c);
          }
        else a.current = null;
    }
    function cy(e, t, a, i) {
      var c = e.memoizedProps, s = c.id, y = c.onCommit;
      c = c.onRender, t = t === null ? "mount" : "update", l1 && (t = "nested-update"), typeof c == "function" && c(
        s,
        t,
        e.actualDuration,
        e.treeBaseDuration,
        e.actualStartTime,
        a
      ), typeof y == "function" && y(s, t, i, a);
    }
    function I0(e, t, a, i) {
      var c = e.memoizedProps;
      e = c.id, c = c.onPostCommit, t = t === null ? "mount" : "update", l1 && (t = "nested-update"), typeof c == "function" && c(
        e,
        t,
        i,
        a
      );
    }
    function Ao(e) {
      var t = e.type, a = e.memoizedProps, i = e.stateNode;
      try {
        Ae(
          e,
          fv,
          i,
          t,
          a,
          e
        );
      } catch (c) {
        nt(e, e.return, c);
      }
    }
    function Uh(e, t, a) {
      try {
        Ae(
          e,
          Fh,
          e.stateNode,
          e.type,
          a,
          t,
          e
        );
      } catch (i) {
        nt(e, e.return, i);
      }
    }
    function ry(e) {
      return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Uo(e.type) || e.tag === 4;
    }
    function wh(e) {
      e: for (; ; ) {
        for (; e.sibling === null; ) {
          if (e.return === null || ry(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
          if (e.tag === 27 && Uo(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
          e.child.return = e, e = e.child;
        }
        if (!(e.flags & 2)) return e.stateNode;
      }
    }
    function Br(e, t, a) {
      var i = e.tag;
      if (i === 5 || i === 6)
        e = e.stateNode, t ? (hv(a), (a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a).insertBefore(e, t)) : (hv(a), t = a.nodeType === 9 ? a.body : a.nodeName === "HTML" ? a.ownerDocument.body : a, t.appendChild(e), a = a._reactRootContainer, a != null || t.onclick !== null || (t.onclick = Ul));
      else if (i !== 4 && (i === 27 && Uo(e.type) && (a = e.stateNode, t = null), e = e.child, e !== null))
        for (Br(e, t, a), e = e.sibling; e !== null; )
          Br(e, t, a), e = e.sibling;
    }
    function zf(e, t, a) {
      var i = e.tag;
      if (i === 5 || i === 6)
        e = e.stateNode, t ? a.insertBefore(e, t) : a.appendChild(e);
      else if (i !== 4 && (i === 27 && Uo(e.type) && (a = e.stateNode), e = e.child, e !== null))
        for (zf(e, t, a), e = e.sibling; e !== null; )
          zf(e, t, a), e = e.sibling;
    }
    function sy(e) {
      for (var t, a = e.return; a !== null; ) {
        if (ry(a)) {
          t = a;
          break;
        }
        a = a.return;
      }
      if (t == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (t.tag) {
        case 27:
          t = t.stateNode, a = wh(e), zf(
            e,
            a,
            t
          );
          break;
        case 5:
          a = t.stateNode, t.flags & 32 && (Wh(a), t.flags &= -33), t = wh(e), zf(
            e,
            t,
            a
          );
          break;
        case 3:
        case 4:
          t = t.stateNode.containerInfo, a = wh(e), Br(
            e,
            a,
            t
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function fy(e) {
      var t = e.stateNode, a = e.memoizedProps;
      try {
        Ae(
          e,
          ei,
          e.type,
          a,
          t,
          e
        );
      } catch (i) {
        nt(e, e.return, i);
      }
    }
    function dy(e, t) {
      return t.tag === 31 ? (t = t.memoizedState, e.memoizedState !== null && t === null) : t.tag === 13 ? (e = e.memoizedState, t = t.memoizedState, e !== null && e.dehydrated !== null && (t === null || t.dehydrated === null)) : t.tag === 3 ? e.memoizedState.isDehydrated && (t.flags & 256) === 0 : !1;
    }
    function Nb(e, t) {
      if (e = e.containerInfo, XS = j1, e = Jd(e), bp(e)) {
        if ("selectionStart" in e)
          var a = {
            start: e.selectionStart,
            end: e.selectionEnd
          };
        else
          e: {
            a = (a = e.ownerDocument) && a.defaultView || window;
            var i = a.getSelection && a.getSelection();
            if (i && i.rangeCount !== 0) {
              a = i.anchorNode;
              var c = i.anchorOffset, s = i.focusNode;
              i = i.focusOffset;
              try {
                a.nodeType, s.nodeType;
              } catch {
                a = null;
                break e;
              }
              var y = 0, b = -1, A = -1, D = 0, j = 0, V = e, w = null;
              t: for (; ; ) {
                for (var $; V !== a || c !== 0 && V.nodeType !== 3 || (b = y + c), V !== s || i !== 0 && V.nodeType !== 3 || (A = y + i), V.nodeType === 3 && (y += V.nodeValue.length), ($ = V.firstChild) !== null; )
                  w = V, V = $;
                for (; ; ) {
                  if (V === e) break t;
                  if (w === a && ++D === c && (b = y), w === s && ++j === i && (A = y), ($ = V.nextSibling) !== null) break;
                  V = w, w = V.parentNode;
                }
                V = $;
              }
              a = b === -1 || A === -1 ? null : { start: b, end: A };
            } else a = null;
          }
        a = a || { start: 0, end: 0 };
      } else a = null;
      for (QS = {
        focusedElem: e,
        selectionRange: a
      }, j1 = !1, pa = t; pa !== null; )
        if (t = pa, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null)
          e.return = t, pa = e;
        else
          for (; pa !== null; ) {
            switch (e = t = pa, a = e.alternate, c = e.flags, e.tag) {
              case 0:
                if ((c & 4) !== 0 && (e = e.updateQueue, e = e !== null ? e.events : null, e !== null))
                  for (a = 0; a < e.length; a++)
                    c = e[a], c.ref.impl = c.nextImpl;
                break;
              case 11:
              case 15:
                break;
              case 1:
                (c & 1024) !== 0 && a !== null && F0(e, a);
                break;
              case 3:
                if ((c & 1024) !== 0) {
                  if (e = e.stateNode.containerInfo, a = e.nodeType, a === 9)
                    Fr(e);
                  else if (a === 1)
                    switch (e.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Fr(e);
                        break;
                      default:
                        e.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((c & 1024) !== 0)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (e = t.sibling, e !== null) {
              e.return = t.return, pa = e;
              break;
            }
            pa = t.return;
          }
    }
    function Mh(e, t, a) {
      var i = tn(), c = xl(), s = il(), y = Hl(), b = a.flags;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          hl(e, a), b & 4 && $0(a, Ou | hi);
          break;
        case 1:
          if (hl(e, a), b & 4)
            if (e = a.stateNode, t === null)
              a.type.defaultProps || "ref" in a.memoizedProps || Ym || (e.props !== a.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                ae(a) || "instance"
              ), e.state !== a.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                ae(a) || "instance"
              )), Ju(a) ? (hn(), Ae(
                a,
                fS,
                a,
                e
              ), Aa()) : Ae(
                a,
                fS,
                a,
                e
              );
            else {
              var A = Qu(
                a.type,
                t.memoizedProps
              );
              t = t.memoizedState, a.type.defaultProps || "ref" in a.memoizedProps || Ym || (e.props !== a.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                ae(a) || "instance"
              ), e.state !== a.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                ae(a) || "instance"
              )), Ju(a) ? (hn(), Ae(
                a,
                Y2,
                a,
                e,
                A,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              ), Aa()) : Ae(
                a,
                Y2,
                a,
                e,
                A,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            }
          b & 64 && oy(a), b & 512 && Ac(a, a.return);
          break;
        case 3:
          if (t = Hu(), hl(e, a), b & 64 && (b = a.updateQueue, b !== null)) {
            if (A = null, a.child !== null)
              switch (a.child.tag) {
                case 27:
                case 5:
                  A = a.child.stateNode;
                  break;
                case 1:
                  A = a.child.stateNode;
              }
            try {
              Ae(
                a,
                Or,
                b,
                A
              );
            } catch (j) {
              nt(a, a.return, j);
            }
          }
          e.effectDuration += Sr(t);
          break;
        case 27:
          t === null && b & 4 && fy(a);
        case 26:
        case 5:
          if (hl(e, a), t === null) {
            if (b & 4) Ao(a);
            else if (b & 64) {
              e = a.type, t = a.memoizedProps, A = a.stateNode;
              try {
                Ae(
                  a,
                  dv,
                  A,
                  e,
                  t,
                  a
                );
              } catch (j) {
                nt(
                  a,
                  a.return,
                  j
                );
              }
            }
          }
          b & 512 && Ac(a, a.return);
          break;
        case 12:
          if (b & 4) {
            b = Hu(), hl(e, a), e = a.stateNode, e.effectDuration += Ta(b);
            try {
              Ae(
                a,
                cy,
                a,
                t,
                bs,
                e.effectDuration
              );
            } catch (j) {
              nt(a, a.return, j);
            }
          } else hl(e, a);
          break;
        case 31:
          hl(e, a), b & 4 && my(e, a);
          break;
        case 13:
          hl(e, a), b & 4 && py(e, a), b & 64 && (e = a.memoizedState, e !== null && (e = e.dehydrated, e !== null && (b = ji.bind(
            null,
            a
          ), Ov(e, b))));
          break;
        case 22:
          if (b = a.memoizedState !== null || $c, !b) {
            t = t !== null && t.memoizedState !== null || Pn, A = $c;
            var D = Pn;
            $c = b, (Pn = t) && !D ? (du(
              e,
              a,
              (a.subtreeFlags & 8772) !== 0
            ), (a.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && Kd(
              a,
              Ve,
              Ge
            )) : hl(e, a), $c = A, Pn = D;
          }
          break;
        case 30:
          break;
        default:
          hl(e, a);
      }
      (a.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && ((On || 0.05 < yn) && nu(
        a,
        Ve,
        Ge,
        yn,
        dn
      ), a.alternate === null && a.return !== null && a.return.alternate !== null && 0.05 < Ge - Ve && (dy(
        a.return.alternate,
        a.return
      ) || wl(
        a,
        Ve,
        Ge,
        "Mount"
      ))), Gn(i), ul(c), dn = s, On = y;
    }
    function Tn(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, Tn(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && lp(t)), e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    function It(e, t, a) {
      for (a = a.child; a !== null; )
        hy(
          e,
          t,
          a
        ), a = a.sibling;
    }
    function hy(e, t, a) {
      if (Ln && typeof Ln.onCommitFiberUnmount == "function")
        try {
          Ln.onCommitFiberUnmount(Lc, a);
        } catch (D) {
          ni || (ni = !0, console.error(
            "React instrumentation encountered an error: %o",
            D
          ));
        }
      var i = tn(), c = xl(), s = il(), y = Hl();
      switch (a.tag) {
        case 26:
          Pn || jl(a, t), It(
            e,
            t,
            a
          ), a.memoizedState ? a.memoizedState.count-- : a.stateNode && (e = a.stateNode, e.parentNode.removeChild(e));
          break;
        case 27:
          Pn || jl(a, t);
          var b = ea, A = Xl;
          Uo(a.type) && (ea = a.stateNode, Xl = !1), It(
            e,
            t,
            a
          ), Ae(
            a,
            Gi,
            a.stateNode
          ), ea = b, Xl = A;
          break;
        case 5:
          Pn || jl(a, t);
        case 6:
          if (b = ea, A = Xl, ea = null, It(
            e,
            t,
            a
          ), ea = b, Xl = A, ea !== null)
            if (Xl)
              try {
                Ae(
                  a,
                  pv,
                  ea,
                  a.stateNode
                );
              } catch (D) {
                nt(
                  a,
                  t,
                  D
                );
              }
            else
              try {
                Ae(
                  a,
                  mv,
                  ea,
                  a.stateNode
                );
              } catch (D) {
                nt(
                  a,
                  t,
                  D
                );
              }
          break;
        case 18:
          ea !== null && (Xl ? (e = ea, zc(
            e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
            a.stateNode
          ), Mc(e)) : zc(ea, a.stateNode));
          break;
        case 4:
          b = ea, A = Xl, ea = a.stateNode.containerInfo, Xl = !0, It(
            e,
            t,
            a
          ), ea = b, Xl = A;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          To(
            Al,
            a,
            t
          ), Pn || Ch(
            a,
            t,
            Ou
          ), It(
            e,
            t,
            a
          );
          break;
        case 1:
          Pn || (jl(a, t), b = a.stateNode, typeof b.componentWillUnmount == "function" && _h(
            a,
            t,
            b
          )), It(
            e,
            t,
            a
          );
          break;
        case 21:
          It(
            e,
            t,
            a
          );
          break;
        case 22:
          Pn = (b = Pn) || a.memoizedState !== null, It(
            e,
            t,
            a
          ), Pn = b;
          break;
        default:
          It(
            e,
            t,
            a
          );
      }
      (a.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
        a,
        Ve,
        Ge,
        yn,
        dn
      ), Gn(i), ul(c), dn = s, On = y;
    }
    function my(e, t) {
      if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
        e = e.dehydrated;
        try {
          Ae(
            t,
            Ih,
            e
          );
        } catch (a) {
          nt(t, t.return, a);
        }
      }
    }
    function py(e, t) {
      if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
        try {
          Ae(
            t,
            Ly,
            e
          );
        } catch (a) {
          nt(t, t.return, a);
        }
    }
    function P0(e) {
      switch (e.tag) {
        case 31:
        case 13:
        case 19:
          var t = e.stateNode;
          return t === null && (t = e.stateNode = new RT()), t;
        case 22:
          return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new RT()), t;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + e.tag + "). This is a bug in React."
          );
      }
    }
    function Oo(e, t) {
      var a = P0(e);
      t.forEach(function(i) {
        if (!a.has(i)) {
          if (a.add(i), ai)
            if (Gm !== null && Xm !== null)
              Xr(Xm, Gm);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          var c = Rc.bind(null, e, i);
          i.then(c, c);
        }
      });
    }
    function za(e, t) {
      var a = t.deletions;
      if (a !== null)
        for (var i = 0; i < a.length; i++) {
          var c = e, s = t, y = a[i], b = tn(), A = s;
          e: for (; A !== null; ) {
            switch (A.tag) {
              case 27:
                if (Uo(A.type)) {
                  ea = A.stateNode, Xl = !1;
                  break e;
                }
                break;
              case 5:
                ea = A.stateNode, Xl = !1;
                break e;
              case 3:
              case 4:
                ea = A.stateNode.containerInfo, Xl = !0;
                break e;
            }
            A = A.return;
          }
          if (ea === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          hy(c, s, y), ea = null, Xl = !1, (y.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && wl(
            y,
            Ve,
            Ge,
            "Unmount"
          ), Gn(b), c = y, s = c.alternate, s !== null && (s.return = null), c.return = null;
        }
      if (t.subtreeFlags & 13886)
        for (t = t.child; t !== null; )
          _f(t, e), t = t.sibling;
    }
    function _f(e, t) {
      var a = tn(), i = xl(), c = il(), s = Hl(), y = e.alternate, b = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          za(t, e), _a(e), b & 4 && (To(
            Al | hi,
            e,
            e.return
          ), Li(Al | hi, e), Ch(
            e,
            e.return,
            Ou | hi
          ));
          break;
        case 1:
          if (za(t, e), _a(e), b & 512 && (Pn || y === null || jl(y, y.return)), b & 64 && $c && (b = e.updateQueue, b !== null && (y = b.callbacks, y !== null))) {
            var A = b.shared.hiddenCallbacks;
            b.shared.hiddenCallbacks = A === null ? y : A.concat(y);
          }
          break;
        case 26:
          if (A = ki, za(t, e), _a(e), b & 512 && (Pn || y === null || jl(y, y.return)), b & 4) {
            var D = y !== null ? y.memoizedState : null;
            if (b = e.memoizedState, y === null)
              if (b === null)
                if (e.stateNode === null) {
                  e: {
                    b = e.type, y = e.memoizedProps, A = A.ownerDocument || A;
                    t: switch (b) {
                      case "title":
                        D = A.getElementsByTagName(
                          "title"
                        )[0], (!D || D[fs] || D[ln] || D.namespaceURI === at || D.hasAttribute("itemprop")) && (D = A.createElement(b), A.head.insertBefore(
                          D,
                          A.querySelector(
                            "head > title"
                          )
                        )), an(D, b, y), D[ln] = e, vn(D), b = D;
                        break e;
                      case "link":
                        var j = Pr(
                          "link",
                          "href",
                          A
                        ).get(b + (y.href || ""));
                        if (j) {
                          for (var V = 0; V < j.length; V++)
                            if (D = j[V], D.getAttribute("href") === (y.href == null || y.href === "" ? null : y.href) && D.getAttribute("rel") === (y.rel == null ? null : y.rel) && D.getAttribute("title") === (y.title == null ? null : y.title) && D.getAttribute("crossorigin") === (y.crossOrigin == null ? null : y.crossOrigin)) {
                              j.splice(V, 1);
                              break t;
                            }
                        }
                        D = A.createElement(b), an(D, b, y), A.head.appendChild(
                          D
                        );
                        break;
                      case "meta":
                        if (j = Pr(
                          "meta",
                          "content",
                          A
                        ).get(b + (y.content || ""))) {
                          for (V = 0; V < j.length; V++)
                            if (D = j[V], He(
                              y.content,
                              "content"
                            ), D.getAttribute("content") === (y.content == null ? null : "" + y.content) && D.getAttribute("name") === (y.name == null ? null : y.name) && D.getAttribute("property") === (y.property == null ? null : y.property) && D.getAttribute("http-equiv") === (y.httpEquiv == null ? null : y.httpEquiv) && D.getAttribute("charset") === (y.charSet == null ? null : y.charSet)) {
                              j.splice(V, 1);
                              break t;
                            }
                        }
                        D = A.createElement(b), an(D, b, y), A.head.appendChild(
                          D
                        );
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + b + '". This is a bug in React.'
                        );
                    }
                    D[ln] = e, vn(D), b = D;
                  }
                  e.stateNode = b;
                } else
                  zv(
                    A,
                    e.type,
                    e.stateNode
                  );
              else
                e.stateNode = tm(
                  A,
                  b,
                  e.memoizedProps
                );
            else
              D !== b ? (D === null ? y.stateNode !== null && (y = y.stateNode, y.parentNode.removeChild(y)) : D.count--, b === null ? zv(
                A,
                e.type,
                e.stateNode
              ) : tm(
                A,
                b,
                e.memoizedProps
              )) : b === null && e.stateNode !== null && Uh(
                e,
                e.memoizedProps,
                y.memoizedProps
              );
          }
          break;
        case 27:
          za(t, e), _a(e), b & 512 && (Pn || y === null || jl(y, y.return)), y !== null && b & 4 && Uh(
            e,
            e.memoizedProps,
            y.memoizedProps
          );
          break;
        case 5:
          if (za(t, e), _a(e), b & 512 && (Pn || y === null || jl(y, y.return)), e.flags & 32) {
            A = e.stateNode;
            try {
              Ae(
                e,
                Wh,
                A
              );
            } catch (Re) {
              nt(e, e.return, Re);
            }
          }
          b & 4 && e.stateNode != null && (A = e.memoizedProps, Uh(
            e,
            A,
            y !== null ? y.memoizedProps : A
          )), b & 1024 && (OS = !0, e.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (za(t, e), _a(e), b & 4) {
            if (e.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            b = e.memoizedProps, y = y !== null ? y.memoizedProps : b, A = e.stateNode;
            try {
              Ae(
                e,
                xb,
                A,
                y,
                b
              );
            } catch (Re) {
              nt(e, e.return, Re);
            }
          }
          break;
        case 3:
          if (A = Hu(), H1 = null, D = ki, ki = Ph(t.containerInfo), za(t, e), ki = D, _a(e), b & 4 && y !== null && y.memoizedState.isDehydrated)
            try {
              Ae(
                e,
                Hy,
                t.containerInfo
              );
            } catch (Re) {
              nt(e, e.return, Re);
            }
          OS && (OS = !1, ev(e)), t.effectDuration += Sr(
            A
          );
          break;
        case 4:
          b = ki, ki = Ph(
            e.stateNode.containerInfo
          ), za(t, e), _a(e), ki = b;
          break;
        case 12:
          b = Hu(), za(t, e), _a(e), e.stateNode.effectDuration += Ta(b);
          break;
        case 31:
          za(t, e), _a(e), b & 4 && (b = e.updateQueue, b !== null && (e.updateQueue = null, Oo(e, b)));
          break;
        case 13:
          za(t, e), _a(e), e.child.flags & 8192 && e.memoizedState !== null != (y !== null && y.memoizedState !== null) && (S1 = kn()), b & 4 && (b = e.updateQueue, b !== null && (e.updateQueue = null, Oo(e, b)));
          break;
        case 22:
          A = e.memoizedState !== null;
          var w = y !== null && y.memoizedState !== null, $ = $c, Ee = Pn;
          if ($c = $ || A, Pn = Ee || w, za(t, e), Pn = Ee, $c = $, w && !A && !$ && !Ee && (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && Kd(
            e,
            Ve,
            Ge
          ), _a(e), b & 8192)
            e: for (t = e.stateNode, t._visibility = A ? t._visibility & ~gg : t._visibility | gg, !A || y === null || w || $c || Pn || (Do(e), (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && wl(
              e,
              Ve,
              Ge,
              "Disconnect"
            )), y = null, t = e; ; ) {
              if (t.tag === 5 || t.tag === 26) {
                if (y === null) {
                  w = y = t;
                  try {
                    D = w.stateNode, A ? Ae(
                      w,
                      gv,
                      D
                    ) : Ae(
                      w,
                      Sv,
                      w.stateNode,
                      w.memoizedProps
                    );
                  } catch (Re) {
                    nt(w, w.return, Re);
                  }
                }
              } else if (t.tag === 6) {
                if (y === null) {
                  w = t;
                  try {
                    j = w.stateNode, A ? Ae(
                      w,
                      vv,
                      j
                    ) : Ae(
                      w,
                      Ev,
                      j,
                      w.memoizedProps
                    );
                  } catch (Re) {
                    nt(w, w.return, Re);
                  }
                }
              } else if (t.tag === 18) {
                if (y === null) {
                  w = t;
                  try {
                    V = w.stateNode, A ? Ae(
                      w,
                      yv,
                      V
                    ) : Ae(
                      w,
                      bv,
                      w.stateNode
                    );
                  } catch (Re) {
                    nt(w, w.return, Re);
                  }
                }
              } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
                t.child.return = t, t = t.child;
                continue;
              }
              if (t === e) break e;
              for (; t.sibling === null; ) {
                if (t.return === null || t.return === e)
                  break e;
                y === t && (y = null), t = t.return;
              }
              y === t && (y = null), t.sibling.return = t.return, t = t.sibling;
            }
          b & 4 && (b = e.updateQueue, b !== null && (y = b.retryQueue, y !== null && (b.retryQueue = null, Oo(e, y))));
          break;
        case 19:
          za(t, e), _a(e), b & 4 && (b = e.updateQueue, b !== null && (e.updateQueue = null, Oo(e, b)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          za(t, e), _a(e);
      }
      (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && ((On || 0.05 < yn) && nu(
        e,
        Ve,
        Ge,
        yn,
        dn
      ), e.alternate === null && e.return !== null && e.return.alternate !== null && 0.05 < Ge - Ve && (dy(
        e.return.alternate,
        e.return
      ) || wl(
        e,
        Ve,
        Ge,
        "Mount"
      ))), Gn(a), ul(i), dn = c, On = s;
    }
    function _a(e) {
      var t = e.flags;
      if (t & 2) {
        try {
          Ae(e, sy, e);
        } catch (a) {
          nt(e, e.return, a);
        }
        e.flags &= -3;
      }
      t & 4096 && (e.flags &= -4097);
    }
    function ev(e) {
      if (e.subtreeFlags & 1024)
        for (e = e.child; e !== null; ) {
          var t = e;
          ev(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
        }
    }
    function hl(e, t) {
      if (t.subtreeFlags & 8772)
        for (t = t.child; t !== null; )
          Mh(e, t.alternate, t), t = t.sibling;
    }
    function Nh(e) {
      var t = tn(), a = xl(), i = il(), c = Hl();
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ch(
            e,
            e.return,
            Ou
          ), Do(e);
          break;
        case 1:
          jl(e, e.return);
          var s = e.stateNode;
          typeof s.componentWillUnmount == "function" && _h(
            e,
            e.return,
            s
          ), Do(e);
          break;
        case 27:
          Ae(
            e,
            Gi,
            e.stateNode
          );
        case 26:
        case 5:
          jl(e, e.return), Do(e);
          break;
        case 22:
          e.memoizedState === null && Do(e);
          break;
        case 30:
          Do(e);
          break;
        default:
          Do(e);
      }
      (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
        e,
        Ve,
        Ge,
        yn,
        dn
      ), Gn(t), ul(a), dn = i, On = c;
    }
    function Do(e) {
      for (e = e.child; e !== null; )
        Nh(e), e = e.sibling;
    }
    function yy(e, t, a, i) {
      var c = tn(), s = xl(), y = il(), b = Hl(), A = a.flags;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          du(
            e,
            a,
            i
          ), $0(a, Ou);
          break;
        case 1:
          if (du(
            e,
            a,
            i
          ), t = a.stateNode, typeof t.componentDidMount == "function" && Ae(
            a,
            fS,
            a,
            t
          ), t = a.updateQueue, t !== null) {
            e = a.stateNode;
            try {
              Ae(
                a,
                Bp,
                t,
                e
              );
            } catch (D) {
              nt(a, a.return, D);
            }
          }
          i && A & 64 && oy(a), Ac(a, a.return);
          break;
        case 27:
          fy(a);
        case 26:
        case 5:
          du(
            e,
            a,
            i
          ), i && t === null && A & 4 && Ao(a), Ac(a, a.return);
          break;
        case 12:
          if (i && A & 4) {
            A = Hu(), du(
              e,
              a,
              i
            ), i = a.stateNode, i.effectDuration += Ta(A);
            try {
              Ae(
                a,
                cy,
                a,
                t,
                bs,
                i.effectDuration
              );
            } catch (D) {
              nt(a, a.return, D);
            }
          } else
            du(
              e,
              a,
              i
            );
          break;
        case 31:
          du(
            e,
            a,
            i
          ), i && A & 4 && my(e, a);
          break;
        case 13:
          du(
            e,
            a,
            i
          ), i && A & 4 && py(e, a);
          break;
        case 22:
          a.memoizedState === null && du(
            e,
            a,
            i
          ), Ac(a, a.return);
          break;
        case 30:
          break;
        default:
          du(
            e,
            a,
            i
          );
      }
      (a.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
        a,
        Ve,
        Ge,
        yn,
        dn
      ), Gn(c), ul(s), dn = y, On = b;
    }
    function du(e, t, a) {
      for (a = a && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; )
        yy(
          e,
          t.alternate,
          t,
          a
        ), t = t.sibling;
    }
    function Uf(e, t) {
      var a = null;
      e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== a && (e != null && ic(e), a != null && tf(a));
    }
    function wf(e, t) {
      e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (ic(t), e != null && tf(e));
    }
    function ml(e, t, a, i, c) {
      if (t.subtreeFlags & 10256 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child))
        for (t = t.child; t !== null; ) {
          var s = t.sibling;
          gy(
            e,
            t,
            a,
            i,
            s !== null ? s.actualStartTime : c
          ), t = s;
        }
    }
    function gy(e, t, a, i, c) {
      var s = tn(), y = xl(), b = il(), A = Hl(), D = ps, j = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          (t.mode & it) !== Qe && 0 < t.actualStartTime && (t.flags & 1) !== 0 && kd(
            t,
            t.actualStartTime,
            c,
            oa,
            a
          ), ml(
            e,
            t,
            a,
            i,
            c
          ), j & 2048 && Rf(t, Ol | hi);
          break;
        case 1:
          (t.mode & it) !== Qe && 0 < t.actualStartTime && ((t.flags & 128) !== 0 ? Ep(
            t,
            t.actualStartTime,
            c,
            []
          ) : (t.flags & 1) !== 0 && kd(
            t,
            t.actualStartTime,
            c,
            oa,
            a
          )), ml(
            e,
            t,
            a,
            i,
            c
          );
          break;
        case 3:
          var V = Hu(), w = oa;
          oa = t.alternate !== null && t.alternate.memoizedState.isDehydrated && (t.flags & 256) === 0, ml(
            e,
            t,
            a,
            i,
            c
          ), oa = w, j & 2048 && (a = null, t.alternate !== null && (a = t.alternate.memoizedState.cache), i = t.memoizedState.cache, i !== a && (ic(i), a != null && tf(a))), e.passiveEffectDuration += Sr(
            V
          );
          break;
        case 12:
          if (j & 2048) {
            j = Hu(), ml(
              e,
              t,
              a,
              i,
              c
            ), e = t.stateNode, e.passiveEffectDuration += Ta(j);
            try {
              Ae(
                t,
                I0,
                t,
                t.alternate,
                bs,
                e.passiveEffectDuration
              );
            } catch ($) {
              nt(t, t.return, $);
            }
          } else
            ml(
              e,
              t,
              a,
              i,
              c
            );
          break;
        case 31:
          j = oa, V = t.alternate !== null ? t.alternate.memoizedState : null, w = t.memoizedState, V !== null && w === null ? (w = t.deletions, w !== null && 0 < w.length && w[0].tag === 18 ? (oa = !1, V = V.hydrationErrors, V !== null && Ep(
            t,
            t.actualStartTime,
            c,
            V
          )) : oa = !0) : oa = !1, ml(
            e,
            t,
            a,
            i,
            c
          ), oa = j;
          break;
        case 13:
          j = oa, V = t.alternate !== null ? t.alternate.memoizedState : null, w = t.memoizedState, V === null || V.dehydrated === null || w !== null && w.dehydrated !== null ? oa = !1 : (w = t.deletions, w !== null && 0 < w.length && w[0].tag === 18 ? (oa = !1, V = V.hydrationErrors, V !== null && Ep(
            t,
            t.actualStartTime,
            c,
            V
          )) : oa = !0), ml(
            e,
            t,
            a,
            i,
            c
          ), oa = j;
          break;
        case 23:
          break;
        case 22:
          w = t.stateNode, V = t.alternate, t.memoizedState !== null ? w._visibility & qc ? ml(
            e,
            t,
            a,
            i,
            c
          ) : Oc(
            e,
            t,
            a,
            i,
            c
          ) : w._visibility & qc ? ml(
            e,
            t,
            a,
            i,
            c
          ) : (w._visibility |= qc, Ro(
            e,
            t,
            a,
            i,
            (t.subtreeFlags & 10256) !== 0 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child),
            c
          ), (t.mode & it) === Qe || oa || (e = t.actualStartTime, 0 <= e && 0.05 < c - e && Kd(t, e, c), 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && Kd(
            t,
            Ve,
            Ge
          ))), j & 2048 && Uf(
            V,
            t
          );
          break;
        case 24:
          ml(
            e,
            t,
            a,
            i,
            c
          ), j & 2048 && wf(t.alternate, t);
          break;
        default:
          ml(
            e,
            t,
            a,
            i,
            c
          );
      }
      (t.mode & it) !== Qe && ((e = !oa && t.alternate === null && t.return !== null && t.return.alternate !== null) && (a = t.actualStartTime, 0 <= a && 0.05 < c - a && wl(
        t,
        a,
        c,
        "Mount"
      )), 0 <= Ve && 0 <= Ge && ((On || 0.05 < yn) && nu(
        t,
        Ve,
        Ge,
        yn,
        dn
      ), e && 0.05 < Ge - Ve && wl(
        t,
        Ve,
        Ge,
        "Mount"
      ))), Gn(s), ul(y), dn = b, On = A, ps = D;
    }
    function Ro(e, t, a, i, c, s) {
      for (c = c && ((t.subtreeFlags & 10256) !== 0 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child)), t = t.child; t !== null; ) {
        var y = t.sibling;
        Mf(
          e,
          t,
          a,
          i,
          c,
          y !== null ? y.actualStartTime : s
        ), t = y;
      }
    }
    function Mf(e, t, a, i, c, s) {
      var y = tn(), b = xl(), A = il(), D = Hl(), j = ps;
      c && (t.mode & it) !== Qe && 0 < t.actualStartTime && (t.flags & 1) !== 0 && kd(
        t,
        t.actualStartTime,
        s,
        oa,
        a
      );
      var V = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          Ro(
            e,
            t,
            a,
            i,
            c,
            s
          ), Rf(t, Ol);
          break;
        case 23:
          break;
        case 22:
          var w = t.stateNode;
          t.memoizedState !== null ? w._visibility & qc ? Ro(
            e,
            t,
            a,
            i,
            c,
            s
          ) : Oc(
            e,
            t,
            a,
            i,
            s
          ) : (w._visibility |= qc, Ro(
            e,
            t,
            a,
            i,
            c,
            s
          )), c && V & 2048 && Uf(
            t.alternate,
            t
          );
          break;
        case 24:
          Ro(
            e,
            t,
            a,
            i,
            c,
            s
          ), c && V & 2048 && wf(t.alternate, t);
          break;
        default:
          Ro(
            e,
            t,
            a,
            i,
            c,
            s
          );
      }
      (t.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
        t,
        Ve,
        Ge,
        yn,
        dn
      ), Gn(y), ul(b), dn = A, On = D, ps = j;
    }
    function Oc(e, t, a, i, c) {
      if (t.subtreeFlags & 10256 || t.actualDuration !== 0 && (t.alternate === null || t.alternate.child !== t.child))
        for (var s = t.child; s !== null; ) {
          t = s.sibling;
          var y = e, b = a, A = i, D = t !== null ? t.actualStartTime : c, j = ps;
          (s.mode & it) !== Qe && 0 < s.actualStartTime && (s.flags & 1) !== 0 && kd(
            s,
            s.actualStartTime,
            D,
            oa,
            b
          );
          var V = s.flags;
          switch (s.tag) {
            case 22:
              Oc(
                y,
                s,
                b,
                A,
                D
              ), V & 2048 && Uf(s.alternate, s);
              break;
            case 24:
              Oc(
                y,
                s,
                b,
                A,
                D
              ), V & 2048 && wf(s.alternate, s);
              break;
            default:
              Oc(
                y,
                s,
                b,
                A,
                D
              );
          }
          ps = j, s = t;
        }
    }
    function Dc(e, t, a) {
      if (e.subtreeFlags & Bg)
        for (e = e.child; e !== null; )
          xh(
            e,
            t,
            a
          ), e = e.sibling;
    }
    function xh(e, t, a) {
      switch (e.tag) {
        case 26:
          Dc(
            e,
            t,
            a
          ), e.flags & Bg && e.memoizedState !== null && Yy(
            a,
            ki,
            e.memoizedState,
            e.memoizedProps
          );
          break;
        case 5:
          Dc(
            e,
            t,
            a
          );
          break;
        case 3:
        case 4:
          var i = ki;
          ki = Ph(
            e.stateNode.containerInfo
          ), Dc(
            e,
            t,
            a
          ), ki = i;
          break;
        case 22:
          e.memoizedState === null && (i = e.alternate, i !== null && i.memoizedState !== null ? (i = Bg, Bg = 16777216, Dc(
            e,
            t,
            a
          ), Bg = i) : Dc(
            e,
            t,
            a
          ));
          break;
        default:
          Dc(
            e,
            t,
            a
          );
      }
    }
    function vy(e) {
      var t = e.alternate;
      if (t !== null && (e = t.child, e !== null)) {
        t.child = null;
        do
          t = e.sibling, e.sibling = null, e = t;
        while (e !== null);
      }
    }
    function pl(e) {
      var t = e.deletions;
      if ((e.flags & 16) !== 0) {
        if (t !== null)
          for (var a = 0; a < t.length; a++) {
            var i = t[a], c = tn();
            pa = i, Ku(
              i,
              e
            ), (i.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && wl(
              i,
              Ve,
              Ge,
              "Unmount"
            ), Gn(c);
          }
        vy(e);
      }
      if (e.subtreeFlags & 10256)
        for (e = e.child; e !== null; )
          Hh(e), e = e.sibling;
    }
    function Hh(e) {
      var t = tn(), a = xl(), i = il(), c = Hl();
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          pl(e), e.flags & 2048 && zh(
            e,
            e.return,
            Ol | hi
          );
          break;
        case 3:
          var s = Hu();
          pl(e), e.stateNode.passiveEffectDuration += Sr(s);
          break;
        case 12:
          s = Hu(), pl(e), e.stateNode.passiveEffectDuration += Ta(s);
          break;
        case 22:
          s = e.stateNode, e.memoizedState !== null && s._visibility & qc && (e.return === null || e.return.tag !== 13) ? (s._visibility &= ~qc, Lh(e), (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && wl(
            e,
            Ve,
            Ge,
            "Disconnect"
          )) : pl(e);
          break;
        default:
          pl(e);
      }
      (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
        e,
        Ve,
        Ge,
        yn,
        dn
      ), Gn(t), ul(a), On = c, dn = i;
    }
    function Lh(e) {
      var t = e.deletions;
      if ((e.flags & 16) !== 0) {
        if (t !== null)
          for (var a = 0; a < t.length; a++) {
            var i = t[a], c = tn();
            pa = i, Ku(
              i,
              e
            ), (i.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && 0.05 < Ge - Ve && wl(
              i,
              Ve,
              Ge,
              "Unmount"
            ), Gn(c);
          }
        vy(e);
      }
      for (e = e.child; e !== null; )
        by(e), e = e.sibling;
    }
    function by(e) {
      var t = tn(), a = xl(), i = il(), c = Hl();
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          zh(
            e,
            e.return,
            Ol
          ), Lh(e);
          break;
        case 22:
          var s = e.stateNode;
          s._visibility & qc && (s._visibility &= ~qc, Lh(e));
          break;
        default:
          Lh(e);
      }
      (e.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
        e,
        Ve,
        Ge,
        yn,
        dn
      ), Gn(t), ul(a), On = c, dn = i;
    }
    function Ku(e, t) {
      for (; pa !== null; ) {
        var a = pa, i = a, c = t, s = tn(), y = xl(), b = il(), A = Hl();
        switch (i.tag) {
          case 0:
          case 11:
          case 15:
            zh(
              i,
              c,
              Ol
            );
            break;
          case 23:
          case 22:
            i.memoizedState !== null && i.memoizedState.cachePool !== null && (c = i.memoizedState.cachePool.pool, c != null && ic(c));
            break;
          case 24:
            tf(i.memoizedState.cache);
        }
        if ((i.mode & it) !== Qe && 0 <= Ve && 0 <= Ge && (On || 0.05 < yn) && nu(
          i,
          Ve,
          Ge,
          yn,
          dn
        ), Gn(s), ul(y), On = A, dn = b, i = a.child, i !== null) i.return = a, pa = i;
        else
          e: for (a = e; pa !== null; ) {
            if (i = pa, s = i.sibling, y = i.return, Tn(i), i === a) {
              pa = null;
              break e;
            }
            if (s !== null) {
              s.return = y, pa = s;
              break e;
            }
            pa = y;
          }
      }
    }
    function Sy() {
      NR.forEach(function(e) {
        return e();
      });
    }
    function Ey() {
      var e = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return e || I.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), e;
    }
    function fa(e) {
      if ((Tt & ca) !== ya && ct !== 0)
        return ct & -ct;
      var t = I.T;
      return t !== null ? (t._updatedFibers || (t._updatedFibers = /* @__PURE__ */ new Set()), t._updatedFibers.add(e), wy()) : v0();
    }
    function jr() {
      if (Zl === 0)
        if ((ct & 536870912) === 0 || pt) {
          var e = td;
          td <<= 1, (td & 3932160) === 0 && (td = 262144), Zl = e;
        } else Zl = 536870912;
      return e = Au.current, e !== null && (e.flags |= 32), Zl;
    }
    function Ze(e, t, a) {
      if (Jm && console.error("useInsertionEffect must not schedule updates."), HS && (O1 = !0), (e === Ft && (Qt === gd || Qt === vd) || e.cancelPendingCommit !== null) && (ku(e, 0), ql(
        e,
        ct,
        Zl,
        !1
      )), Wt(e, a), (Tt & ca) !== ya && e === Ft) {
        if (ti)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              e = st && ae(st) || "Unknown", YT.has(e) || (YT.add(e), t = ae(t) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                t,
                e,
                e
              ));
              break;
            case 1:
              VT || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), VT = !0);
          }
      } else
        ai && Va(e, t, a), Lf(t), e === Ft && ((Tt & ca) === ya && (Cs |= a), gn === Os && ql(
          e,
          ct,
          Zl,
          !1
        )), Qa(e);
    }
    function tv(e, t, a) {
      if ((Tt & (ca | Du)) !== ya)
        throw Error("Should not already be working.");
      if (ct !== 0 && st !== null) {
        var i = st, c = kn();
        switch (N2) {
          case Vg:
          case gd:
            var s = Ag;
            un && ((i = i._debugTask) ? i.run(
              console.timeStamp.bind(
                console,
                "Suspended",
                s,
                c,
                ui,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Suspended",
              s,
              c,
              ui,
              void 0,
              "primary-light"
            ));
            break;
          case vd:
            s = Ag, un && ((i = i._debugTask) ? i.run(
              console.timeStamp.bind(
                console,
                "Action",
                s,
                c,
                ui,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Action",
              s,
              c,
              ui,
              void 0,
              "primary-light"
            ));
            break;
          default:
            un && (i = c - Ag, 3 > i || console.timeStamp(
              "Blocked",
              Ag,
              c,
              ui,
              void 0,
              5 > i ? "primary-light" : 10 > i ? "primary" : 100 > i ? "primary-dark" : "error"
            ));
        }
      }
      s = (a = !a && (t & 127) === 0 && (t & e.expiredLanes) === 0 || _e(e, t)) ? Bi(e, t) : Yr(e, t, !0);
      var y = a;
      do {
        if (s === Fc) {
          Qm && !a && ql(e, t, 0, !1), t = Qt, Ag = Fn(), N2 = t;
          break;
        } else {
          if (i = kn(), c = e.current.alternate, y && !av(c)) {
            tu(t), c = ma, s = i, !un || s <= c || (Un ? Un.run(
              console.timeStamp.bind(
                console,
                "Teared Render",
                c,
                s,
                bt,
                yt,
                "error"
              )
            ) : console.timeStamp(
              "Teared Render",
              c,
              s,
              bt,
              yt,
              "error"
            )), Co(t, i), s = Yr(e, t, !1), y = !1;
            continue;
          }
          if (s === yd) {
            if (y = t, e.errorRecoveryDisabledLanes & y)
              var b = 0;
            else
              b = e.pendingLanes & -536870913, b = b !== 0 ? b : b & 536870912 ? 536870912 : 0;
            if (b !== 0) {
              tu(t), Tp(
                ma,
                i,
                t,
                Un
              ), Co(t, i), t = b;
              e: {
                i = e, s = y, y = Gg;
                var A = i.current.memoizedState.isDehydrated;
                if (A && (ku(i, b).flags |= 256), b = Yr(
                  i,
                  b,
                  !1
                ), b !== yd) {
                  if (CS && !A) {
                    i.errorRecoveryDisabledLanes |= s, Cs |= s, s = Os;
                    break e;
                  }
                  i = Dl, Dl = y, i !== null && (Dl === null ? Dl = i : Dl.push.apply(
                    Dl,
                    i
                  ));
                }
                s = b;
              }
              if (y = !1, s !== yd) continue;
              i = kn();
            }
          }
          if (s === qg) {
            tu(t), Tp(
              ma,
              i,
              t,
              Un
            ), Co(t, i), ku(e, 0), ql(e, t, 0, !0);
            break;
          }
          e: {
            switch (a = e, s) {
              case Fc:
              case qg:
                throw Error("Root did not complete. This is a bug in React.");
              case Os:
                if ((t & 4194048) !== t) break;
              case y1:
                tu(t), w0(
                  ma,
                  i,
                  t,
                  Un
                ), Co(t, i), c = t, (c & 127) !== 0 ? t1 = i : (c & 4194048) !== 0 && (n1 = i), ql(
                  a,
                  t,
                  Zl,
                  !Ds
                );
                break e;
              case yd:
                Dl = null;
                break;
              case p1:
              case CT:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (I.actQueue !== null)
              Kt(
                a,
                c,
                t,
                Dl,
                Xg,
                b1,
                Zl,
                Cs,
                bd,
                s,
                null,
                null,
                ma,
                i
              );
            else {
              if ((t & 62914560) === t && (y = S1 + UT - kn(), 10 < y)) {
                if (ql(
                  a,
                  t,
                  Zl,
                  !Ds
                ), me(a, 0, !0) !== 0) break e;
                $i = t, a.timeoutHandle = $T(
                  nv.bind(
                    null,
                    a,
                    c,
                    Dl,
                    Xg,
                    b1,
                    t,
                    Zl,
                    Cs,
                    bd,
                    Ds,
                    s,
                    "Throttled",
                    ma,
                    i
                  ),
                  y
                );
                break e;
              }
              nv(
                a,
                c,
                Dl,
                Xg,
                b1,
                t,
                Zl,
                Cs,
                bd,
                Ds,
                s,
                null,
                ma,
                i
              );
            }
          }
        }
        break;
      } while (!0);
      Qa(e);
    }
    function nv(e, t, a, i, c, s, y, b, A, D, j, V, w, $) {
      e.timeoutHandle = Od;
      var Ee = t.subtreeFlags, Re = null;
      if ((Ee & 8192 || (Ee & 16785408) === 16785408) && (Re = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Ul
      }, xh(t, s, Re), Ee = (s & 62914560) === s ? S1 - kn() : (s & 4194048) === s ? _T - kn() : 0, Ee = nm(Re, Ee), Ee !== null)) {
        $i = s, e.cancelPendingCommit = Ee(
          Kt.bind(
            null,
            e,
            t,
            s,
            a,
            i,
            c,
            y,
            b,
            A,
            j,
            Re,
            Re.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < Re.count ? 0 < Re.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : Re.imgCount === 1 ? "Suspended on an Image" : 0 < Re.imgCount ? "Suspended on Images" : null,
            w,
            $
          )
        ), ql(
          e,
          s,
          y,
          !D
        );
        return;
      }
      Kt(
        e,
        t,
        s,
        a,
        i,
        c,
        y,
        b,
        A,
        j,
        Re,
        V,
        w,
        $
      );
    }
    function av(e) {
      for (var t = e; ; ) {
        var a = t.tag;
        if ((a === 0 || a === 11 || a === 15) && t.flags & 16384 && (a = t.updateQueue, a !== null && (a = a.stores, a !== null)))
          for (var i = 0; i < a.length; i++) {
            var c = a[i], s = c.getSnapshot;
            c = c.value;
            try {
              if (!El(s(), c)) return !1;
            } catch {
              return !1;
            }
          }
        if (a = t.child, t.subtreeFlags & 16384 && a !== null)
          a.return = t, t = a;
        else {
          if (t === e) break;
          for (; t.sibling === null; ) {
            if (t.return === null || t.return === e) return !0;
            t = t.return;
          }
          t.sibling.return = t.return, t = t.sibling;
        }
      }
      return !0;
    }
    function ql(e, t, a, i) {
      t &= ~zS, t &= ~Cs, e.suspendedLanes |= t, e.pingedLanes &= ~t, i && (e.warmLanes |= t), i = e.expirationTimes;
      for (var c = t; 0 < c; ) {
        var s = 31 - ua(c), y = 1 << s;
        i[s] = -1, c &= ~y;
      }
      a !== 0 && Xo(e, a, t);
    }
    function yl() {
      return (Tt & (ca | Du)) === ya ? (Fu(0), !1) : !0;
    }
    function Bh() {
      if (st !== null) {
        if (Qt === Ql)
          var e = st.return;
        else
          e = st, vr(), fo(e), Hm = null, Mg = 0, e = st;
        for (; e !== null; )
          iy(e.alternate, e), e = e.return;
        st = null;
      }
    }
    function Co(e, t) {
      (e & 127) !== 0 && (od = t), (e & 4194048) !== 0 && (Qc = t), (e & 62914560) !== 0 && (w2 = t), (e & 2080374784) !== 0 && (M2 = t);
    }
    function ku(e, t) {
      un && (console.timeStamp(
        "Blocking Track",
        3e-3,
        3e-3,
        "Blocking",
        yt,
        "primary-light"
      ), console.timeStamp(
        "Transition Track",
        3e-3,
        3e-3,
        "Transition",
        yt,
        "primary-light"
      ), console.timeStamp(
        "Suspense Track",
        3e-3,
        3e-3,
        "Suspense",
        yt,
        "primary-light"
      ), console.timeStamp(
        "Idle Track",
        3e-3,
        3e-3,
        "Idle",
        yt,
        "primary-light"
      ));
      var a = ma;
      if (ma = Fn(), ct !== 0 && 0 < a) {
        if (tu(ct), gn === p1 || gn === Os)
          w0(
            a,
            ma,
            t,
            Un
          );
        else {
          var i = ma, c = Un;
          if (un && !(i <= a)) {
            var s = (t & 738197653) === t ? "tertiary-dark" : "primary-dark", y = (t & 536870912) === t ? "Prewarm" : (t & 201326741) === t ? "Interrupted Hydration" : "Interrupted Render";
            c ? c.run(
              console.timeStamp.bind(
                console,
                y,
                a,
                i,
                bt,
                yt,
                s
              )
            ) : console.timeStamp(
              y,
              a,
              i,
              bt,
              yt,
              s
            );
          }
        }
        Co(ct, ma);
      }
      if (a = Un, Un = null, (t & 127) !== 0) {
        Un = Sg, c = 0 <= jo && jo < od ? od : jo, i = 0 <= cd && cd < od ? od : cd, s = 0 <= i ? i : 0 <= c ? c : ma, 0 <= t1 ? (tu(2), M0(
          t1,
          s,
          t,
          a
        )) : a1 & 127, a = c;
        var b = i, A = Eg, D = 0 < Mm, j = Ss === bg, V = Ss === e1;
        if (c = ma, i = Sg, s = iS, y = oS, un) {
          if (bt = "Blocking", 0 < a ? a > c && (a = c) : a = c, 0 < b ? b > a && (b = a) : b = a, A !== null && a > b) {
            var w = D ? "secondary-light" : "warning";
            i ? i.run(
              console.timeStamp.bind(
                console,
                D ? "Consecutive" : "Event: " + A,
                b,
                a,
                bt,
                yt,
                w
              )
            ) : console.timeStamp(
              D ? "Consecutive" : "Event: " + A,
              b,
              a,
              bt,
              yt,
              w
            );
          }
          c > a && (b = j ? "error" : (t & 738197653) === t ? "tertiary-light" : "primary-light", j = V ? "Promise Resolved" : j ? "Cascading Update" : 5 < c - a ? "Update Blocked" : "Update", V = [], y != null && V.push(["Component name", y]), s != null && V.push(["Method name", s]), a = {
            start: a,
            end: c,
            detail: {
              devtools: {
                properties: V,
                track: bt,
                trackGroup: yt,
                color: b
              }
            }
          }, i ? i.run(
            performance.measure.bind(
              performance,
              j,
              a
            )
          ) : performance.measure(j, a));
        }
        jo = -1.1, Ss = 0, oS = iS = null, t1 = -1.1, Mm = cd, cd = -1.1, od = Fn();
      }
      if ((t & 4194048) !== 0 && (Un = Tg, c = 0 <= Zc && Zc < Qc ? Qc : Zc, a = 0 <= fi && fi < Qc ? Qc : fi, i = 0 <= Es && Es < Qc ? Qc : Es, s = 0 <= i ? i : 0 <= a ? a : ma, 0 <= n1 ? (tu(256), M0(
        n1,
        s,
        t,
        Un
      )) : a1 & 4194048, V = i, b = rd, A = 0 < Ts, D = cS === e1, s = ma, i = Tg, y = _2, j = U2, un && (bt = "Transition", 0 < a ? a > s && (a = s) : a = s, 0 < c ? c > a && (c = a) : c = a, 0 < V ? V > c && (V = c) : V = c, c > V && b !== null && (w = A ? "secondary-light" : "warning", i ? i.run(
        console.timeStamp.bind(
          console,
          A ? "Consecutive" : "Event: " + b,
          V,
          c,
          bt,
          yt,
          w
        )
      ) : console.timeStamp(
        A ? "Consecutive" : "Event: " + b,
        V,
        c,
        bt,
        yt,
        w
      )), a > c && (i ? i.run(
        console.timeStamp.bind(
          console,
          "Action",
          c,
          a,
          bt,
          yt,
          "primary-dark"
        )
      ) : console.timeStamp(
        "Action",
        c,
        a,
        bt,
        yt,
        "primary-dark"
      )), s > a && (c = D ? "Promise Resolved" : 5 < s - a ? "Update Blocked" : "Update", V = [], j != null && V.push(["Component name", j]), y != null && V.push(["Method name", y]), a = {
        start: a,
        end: s,
        detail: {
          devtools: {
            properties: V,
            track: bt,
            trackGroup: yt,
            color: "primary-light"
          }
        }
      }, i ? i.run(
        performance.measure.bind(
          performance,
          c,
          a
        )
      ) : performance.measure(c, a))), fi = Zc = -1.1, cS = 0, n1 = -1.1, Ts = Es, Es = -1.1, Qc = Fn()), (t & 62914560) !== 0 && (a1 & 62914560) !== 0 && (tu(4194304), Ap(w2, ma)), (t & 2080374784) !== 0 && (a1 & 2080374784) !== 0 && (tu(268435456), Ap(M2, ma)), a = e.timeoutHandle, a !== Od && (e.timeoutHandle = Od, JR(a)), a = e.cancelPendingCommit, a !== null && (e.cancelPendingCommit = null, a()), $i = 0, Bh(), Ft = e, st = a = Nu(
        e.current,
        null
      ), ct = t, Qt = Ql, Ru = null, Ds = !1, Qm = _e(e, t), CS = !1, gn = Fc, bd = Zl = zS = Cs = Rs = 0, Dl = Gg = null, b1 = !1, (t & 8) !== 0 && (t |= t & 32), i = e.entangledLanes, i !== 0)
        for (e = e.entanglements, i &= t; 0 < i; )
          c = 31 - ua(i), s = 1 << c, t |= e[c], i &= ~s;
      return Vo = t, $d(), e = A2(), 1e3 < e - T2 && (I.recentlyCreatedOwnerStacks = 0, T2 = e), Ji.discardPendingWarnings(), a;
    }
    function hu(e, t) {
      Ke = null, I.H = Lg, I.getCurrentStack = null, ti = !1, ka = null, t === xm || t === o1 ? (t = rc(), Qt = Vg) : t === dS ? (t = rc(), Qt = zT) : Qt = t === TS ? RS : t !== null && typeof t == "object" && typeof t.then == "function" ? Yg : g1, Ru = t;
      var a = st;
      a === null ? (gn = qg, Ef(
        e,
        Ea(t, e.current)
      )) : a.mode & it && nh(a);
    }
    function Ty() {
      var e = Au.current;
      return e === null ? !0 : (ct & 4194048) === ct ? di === null : (ct & 62914560) === ct || (ct & 536870912) !== 0 ? e === di : !1;
    }
    function jh() {
      var e = I.H;
      return I.H = Lg, e === null ? Lg : e;
    }
    function Ay() {
      var e = I.A;
      return I.A = MR, e;
    }
    function qr(e) {
      Un === null && (Un = e._debugTask == null ? null : e._debugTask);
    }
    function Vr() {
      gn = Os, Ds || (ct & 4194048) !== ct && Au.current !== null || (Qm = !0), (Rs & 134217727) === 0 && (Cs & 134217727) === 0 || Ft === null || ql(
        Ft,
        ct,
        Zl,
        !1
      );
    }
    function Yr(e, t, a) {
      var i = Tt;
      Tt |= ca;
      var c = jh(), s = Ay();
      if (Ft !== e || ct !== t) {
        if (ai) {
          var y = e.memoizedUpdaters;
          0 < y.size && (Xr(e, ct), y.clear()), Si(e, t);
        }
        Xg = null, ku(e, t);
      }
      t = !1, y = gn;
      e: do
        try {
          if (Qt !== Ql && st !== null) {
            var b = st, A = Ru;
            switch (Qt) {
              case RS:
                Bh(), y = y1;
                break e;
              case Vg:
              case gd:
              case vd:
              case Yg:
                Au.current === null && (t = !0);
                var D = Qt;
                if (Qt = Ql, Ru = null, Gr(e, b, A, D), a && Qm) {
                  y = Fc;
                  break e;
                }
                break;
              default:
                D = Qt, Qt = Ql, Ru = null, Gr(e, b, A, D);
            }
          }
          Oy(), y = gn;
          break;
        } catch (j) {
          hu(e, j);
        }
      while (!0);
      return t && e.shellSuspendCounter++, vr(), Tt = i, I.H = c, I.A = s, st === null && (Ft = null, ct = 0, $d()), y;
    }
    function Oy() {
      for (; st !== null; ) qh(st);
    }
    function Bi(e, t) {
      var a = Tt;
      Tt |= ca;
      var i = jh(), c = Ay();
      if (Ft !== e || ct !== t) {
        if (ai) {
          var s = e.memoizedUpdaters;
          0 < s.size && (Xr(e, ct), s.clear()), Si(e, t);
        }
        Xg = null, E1 = kn() + wT, ku(e, t);
      } else
        Qm = _e(
          e,
          t
        );
      e: do
        try {
          if (Qt !== Ql && st !== null)
            t: switch (t = st, s = Ru, Qt) {
              case g1:
                Qt = Ql, Ru = null, Gr(
                  e,
                  t,
                  s,
                  g1
                );
                break;
              case gd:
              case vd:
                if (Hp(s)) {
                  Qt = Ql, Ru = null, Dy(t);
                  break;
                }
                t = function() {
                  Qt !== gd && Qt !== vd || Ft !== e || (Qt = v1), Qa(e);
                }, s.then(t, t);
                break e;
              case Vg:
                Qt = v1;
                break e;
              case zT:
                Qt = DS;
                break e;
              case v1:
                Hp(s) ? (Qt = Ql, Ru = null, Dy(t)) : (Qt = Ql, Ru = null, Gr(
                  e,
                  t,
                  s,
                  v1
                ));
                break;
              case DS:
                var y = null;
                switch (st.tag) {
                  case 26:
                    y = st.memoizedState;
                  case 5:
                  case 27:
                    var b = st;
                    if (y ? dt(y) : b.stateNode.complete) {
                      Qt = Ql, Ru = null;
                      var A = b.sibling;
                      if (A !== null) st = A;
                      else {
                        var D = b.return;
                        D !== null ? (st = D, Nf(D)) : st = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                Qt = Ql, Ru = null, Gr(
                  e,
                  t,
                  s,
                  DS
                );
                break;
              case Yg:
                Qt = Ql, Ru = null, Gr(
                  e,
                  t,
                  s,
                  Yg
                );
                break;
              case RS:
                Bh(), gn = y1;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          I.actQueue !== null ? Oy() : zn();
          break;
        } catch (j) {
          hu(e, j);
        }
      while (!0);
      return vr(), I.H = i, I.A = c, Tt = a, st !== null ? Fc : (Ft = null, ct = 0, $d(), gn);
    }
    function zn() {
      for (; st !== null && !hm(); )
        qh(st);
    }
    function qh(e) {
      var t = e.alternate;
      (e.mode & it) !== Qe ? (Ri(e), t = Ae(
        e,
        Df,
        t,
        e,
        Vo
      ), nh(e)) : t = Ae(
        e,
        Df,
        t,
        e,
        Vo
      ), e.memoizedProps = e.pendingProps, t === null ? Nf(e) : st = t;
    }
    function Dy(e) {
      var t = Ae(e, Kn, e);
      e.memoizedProps = e.pendingProps, t === null ? Nf(e) : st = t;
    }
    function Kn(e) {
      var t = e.alternate, a = (e.mode & it) !== Qe;
      switch (a && Ri(e), e.tag) {
        case 15:
        case 0:
          t = ey(
            t,
            e,
            e.pendingProps,
            e.type,
            void 0,
            ct
          );
          break;
        case 11:
          t = ey(
            t,
            e,
            e.pendingProps,
            e.type.render,
            e.ref,
            ct
          );
          break;
        case 5:
          fo(e);
        default:
          iy(t, e), e = st = Cp(e, Vo), t = Df(t, e, Vo);
      }
      return a && nh(e), t;
    }
    function Gr(e, t, a, i) {
      vr(), fo(t), Hm = null, Mg = 0;
      var c = t.return;
      try {
        if (Kp(
          e,
          c,
          t,
          a,
          ct
        )) {
          gn = qg, Ef(
            e,
            Ea(a, e.current)
          ), st = null;
          return;
        }
      } catch (s) {
        if (c !== null) throw st = c, s;
        gn = qg, Ef(
          e,
          Ea(a, e.current)
        ), st = null;
        return;
      }
      t.flags & 32768 ? (pt || i === g1 ? e = !0 : Qm || (ct & 536870912) !== 0 ? e = !1 : (Ds = e = !0, (i === gd || i === vd || i === Vg || i === Yg) && (i = Au.current, i !== null && i.tag === 13 && (i.flags |= 16384))), Ry(t, e)) : Nf(t);
    }
    function Nf(e) {
      var t = e;
      do {
        if ((t.flags & 32768) !== 0) {
          Ry(
            t,
            Ds
          );
          return;
        }
        var a = t.alternate;
        if (e = t.return, Ri(t), a = Ae(
          t,
          uy,
          a,
          t,
          Vo
        ), (t.mode & it) !== Qe && nf(t), a !== null) {
          st = a;
          return;
        }
        if (t = t.sibling, t !== null) {
          st = t;
          return;
        }
        st = t = e;
      } while (t !== null);
      gn === Fc && (gn = CT);
    }
    function Ry(e, t) {
      do {
        var a = k0(e.alternate, e);
        if (a !== null) {
          a.flags &= 32767, st = a;
          return;
        }
        if ((e.mode & it) !== Qe) {
          nf(e), a = e.actualDuration;
          for (var i = e.child; i !== null; )
            a += i.actualDuration, i = i.sibling;
          e.actualDuration = a;
        }
        if (a = e.return, a !== null && (a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null), !t && (e = e.sibling, e !== null)) {
          st = e;
          return;
        }
        st = e = a;
      } while (e !== null);
      gn = y1, st = null;
    }
    function Kt(e, t, a, i, c, s, y, b, A, D, j, V, w, $) {
      e.cancelPendingCommit = null;
      do
        xf();
      while (ta !== _s);
      if (Ji.flushLegacyContextWarning(), Ji.flushPendingUnsafeLifecycleWarnings(), (Tt & (ca | Du)) !== ya)
        throw Error("Should not already be working.");
      if (tu(a), D === yd ? Tp(
        w,
        $,
        a,
        Un
      ) : i !== null ? _b(
        w,
        $,
        a,
        i,
        t !== null && t.alternate !== null && t.alternate.memoizedState.isDehydrated && (t.flags & 256) !== 0,
        Un
      ) : zb(
        w,
        $,
        a,
        Un
      ), t !== null) {
        if (a === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), t === e.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (s = t.lanes | t.childLanes, s |= tS, tl(
          e,
          a,
          s,
          y,
          b,
          A
        ), e === Ft && (st = Ft = null, ct = 0), Zm = t, Us = e, $i = a, wS = s, NS = c, BT = i, MS = $, jT = V, Fi = T1, qT = null, t.actualDuration !== 0 || (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, Qr(Hc, function() {
          return $g = window.event, Fi === T1 && (Fi = US), Hf(), null;
        })) : (e.callbackNode = null, e.callbackPriority = 0), Xc = null, bs = Fn(), V !== null && Ub(
          $,
          bs,
          V,
          Un
        ), i = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || i) {
          i = I.T, I.T = null, c = _t.p, _t.p = Bn, y = Tt, Tt |= Du;
          try {
            Nb(e, t, a);
          } finally {
            Tt = y, _t.p = c, I.T = i;
          }
        }
        ta = NT, Ua(), $u(), Cy();
      }
    }
    function Ua() {
      if (ta === NT) {
        ta = _s;
        var e = Us, t = Zm, a = $i, i = (t.flags & 13878) !== 0;
        if ((t.subtreeFlags & 13878) !== 0 || i) {
          i = I.T, I.T = null;
          var c = _t.p;
          _t.p = Bn;
          var s = Tt;
          Tt |= Du;
          try {
            Gm = a, Xm = e, oc(), _f(t, e), Xm = Gm = null, a = QS;
            var y = Jd(e.containerInfo), b = a.focusedElem, A = a.selectionRange;
            if (y !== b && b && b.ownerDocument && C0(
              b.ownerDocument.documentElement,
              b
            )) {
              if (A !== null && bp(b)) {
                var D = A.start, j = A.end;
                if (j === void 0 && (j = D), "selectionStart" in b)
                  b.selectionStart = D, b.selectionEnd = Math.min(
                    j,
                    b.value.length
                  );
                else {
                  var V = b.ownerDocument || document, w = V && V.defaultView || window;
                  if (w.getSelection) {
                    var $ = w.getSelection(), Ee = b.textContent.length, Re = Math.min(
                      A.start,
                      Ee
                    ), Pt = A.end === void 0 ? Re : Math.min(A.end, Ee);
                    !$.extend && Re > Pt && (y = Pt, Pt = Re, Re = y);
                    var gt = R0(
                      b,
                      Re
                    ), U = R0(
                      b,
                      Pt
                    );
                    if (gt && U && ($.rangeCount !== 1 || $.anchorNode !== gt.node || $.anchorOffset !== gt.offset || $.focusNode !== U.node || $.focusOffset !== U.offset)) {
                      var M = V.createRange();
                      M.setStart(gt.node, gt.offset), $.removeAllRanges(), Re > Pt ? ($.addRange(M), $.extend(U.node, U.offset)) : (M.setEnd(U.node, U.offset), $.addRange(M));
                    }
                  }
                }
              }
              for (V = [], $ = b; $ = $.parentNode; )
                $.nodeType === 1 && V.push({
                  element: $,
                  left: $.scrollLeft,
                  top: $.scrollTop
                });
              for (typeof b.focus == "function" && b.focus(), b = 0; b < V.length; b++) {
                var B = V[b];
                B.element.scrollLeft = B.left, B.element.scrollTop = B.top;
              }
            }
            j1 = !!XS, QS = XS = null;
          } finally {
            Tt = s, _t.p = c, I.T = i;
          }
        }
        e.current = t, ta = xT;
      }
    }
    function $u() {
      if (ta === xT) {
        ta = _s;
        var e = qT;
        if (e !== null) {
          bs = Fn();
          var t = Gc, a = bs;
          !un || a <= t || console.timeStamp(
            e,
            t,
            a,
            bt,
            yt,
            "secondary-light"
          );
        }
        e = Us, t = Zm, a = $i;
        var i = (t.flags & 8772) !== 0;
        if ((t.subtreeFlags & 8772) !== 0 || i) {
          i = I.T, I.T = null;
          var c = _t.p;
          _t.p = Bn;
          var s = Tt;
          Tt |= Du;
          try {
            Gm = a, Xm = e, oc(), Mh(
              e,
              t.alternate,
              t
            ), Xm = Gm = null;
          } finally {
            Tt = s, _t.p = c, I.T = i;
          }
        }
        e = MS, t = jT, Gc = Fn(), e = t === null ? e : bs, t = Gc, a = Fi === _S, i = Un, Xc !== null ? N0(
          e,
          t,
          Xc,
          !1,
          i
        ) : !un || t <= e || (i ? i.run(
          console.timeStamp.bind(
            console,
            a ? "Commit Interrupted View Transition" : "Commit",
            e,
            t,
            bt,
            yt,
            a ? "error" : "secondary-dark"
          )
        ) : console.timeStamp(
          a ? "Commit Interrupted View Transition" : "Commit",
          e,
          t,
          bt,
          yt,
          a ? "error" : "secondary-dark"
        )), ta = HT;
      }
    }
    function Cy() {
      if (ta === LT || ta === HT) {
        if (ta === LT) {
          var e = Gc;
          Gc = Fn();
          var t = Gc, a = Fi === _S;
          !un || t <= e || console.timeStamp(
            a ? "Interrupted View Transition" : "Starting Animation",
            e,
            t,
            bt,
            yt,
            a ? " error" : "secondary-light"
          ), Fi !== _S && (Fi = MT);
        }
        ta = _s, mm(), e = Us;
        var i = Zm;
        t = $i, a = BT;
        var c = i.actualDuration !== 0 || (i.subtreeFlags & 10256) !== 0 || (i.flags & 10256) !== 0;
        c ? ta = A1 : (ta = _s, Zm = Us = null, zy(
          e,
          e.pendingLanes
        ), Sd = 0, Zg = null);
        var s = e.pendingLanes;
        if (s === 0 && (zs = null), c || Gh(e), s = ba(t), i = i.stateNode, Ln && typeof Ln.onCommitFiberRoot == "function")
          try {
            var y = (i.current.flags & 128) === 128;
            switch (s) {
              case Bn:
                var b = lg;
                break;
              case ia:
                b = pm;
                break;
              case ha:
                b = Hc;
                break;
              case Ho:
                b = ym;
                break;
              default:
                b = Hc;
            }
            Ln.onCommitFiberRoot(
              Lc,
              i,
              b,
              y
            );
          } catch (V) {
            ni || (ni = !0, console.error(
              "React instrumentation encountered an error: %o",
              V
            ));
          }
        if (ai && e.memoizedUpdaters.clear(), Sy(), a !== null) {
          y = I.T, b = _t.p, _t.p = Bn, I.T = null;
          try {
            var A = e.onRecoverableError;
            for (i = 0; i < a.length; i++) {
              var D = a[i], j = lv(D.stack);
              Ae(
                D.source,
                A,
                D.value,
                j
              );
            }
          } finally {
            I.T = y, _t.p = b;
          }
        }
        ($i & 3) !== 0 && xf(), Qa(e), s = e.pendingLanes, (t & 261930) !== 0 && (s & 42) !== 0 ? (u1 = !0, e === xS ? Qg++ : (Qg = 0, xS = e)) : Qg = 0, c || Co(t, Gc), Fu(0);
      }
    }
    function lv(e) {
      return e = { componentStack: e }, Object.defineProperty(e, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), e;
    }
    function zy(e, t) {
      (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, tf(t)));
    }
    function xf() {
      return Ua(), $u(), Cy(), Hf();
    }
    function Hf() {
      if (ta !== A1) return !1;
      var e = Us, t = wS;
      wS = 0;
      var a = ba($i), i = ha > a ? ha : a;
      a = I.T;
      var c = _t.p;
      try {
        _t.p = i, I.T = null;
        var s = NS;
        NS = null, i = Us;
        var y = $i;
        if (ta = _s, Zm = Us = null, $i = 0, (Tt & (ca | Du)) !== ya)
          throw Error("Cannot flush passive effects while already rendering.");
        tu(y), HS = !0, O1 = !1;
        var b = 0;
        if (Xc = null, b = kn(), Fi === MT)
          Ap(
            Gc,
            b,
            DR
          );
        else {
          var A = Gc, D = b, j = Fi === US;
          !un || D <= A || (Un ? Un.run(
            console.timeStamp.bind(
              console,
              j ? "Waiting for Paint" : "Waiting",
              A,
              D,
              bt,
              yt,
              "secondary-light"
            )
          ) : console.timeStamp(
            j ? "Waiting for Paint" : "Waiting",
            A,
            D,
            bt,
            yt,
            "secondary-light"
          ));
        }
        A = Tt, Tt |= Du;
        var V = i.current;
        oc(), Hh(V);
        var w = i.current;
        V = MS, oc(), gy(
          i,
          w,
          y,
          s,
          V
        ), Gh(i), Tt = A;
        var $ = kn();
        if (w = b, V = Un, Xc !== null ? N0(
          w,
          $,
          Xc,
          !0,
          V
        ) : !un || $ <= w || (V ? V.run(
          console.timeStamp.bind(
            console,
            "Remaining Effects",
            w,
            $,
            bt,
            yt,
            "secondary-dark"
          )
        ) : console.timeStamp(
          "Remaining Effects",
          w,
          $,
          bt,
          yt,
          "secondary-dark"
        )), Co(y, $), Fu(0, !1), O1 ? i === Zg ? Sd++ : (Sd = 0, Zg = i) : Sd = 0, O1 = HS = !1, Ln && typeof Ln.onPostCommitFiberRoot == "function")
          try {
            Ln.onPostCommitFiberRoot(Lc, i);
          } catch (Re) {
            ni || (ni = !0, console.error(
              "React instrumentation encountered an error: %o",
              Re
            ));
          }
        var Ee = i.current.stateNode;
        return Ee.effectDuration = 0, Ee.passiveEffectDuration = 0, !0;
      } finally {
        _t.p = c, I.T = a, zy(e, t);
      }
    }
    function wa(e, t, a) {
      t = Ea(a, t), q0(t), t = vh(e.stateNode, t, 2), e = Bu(e, t, 2), e !== null && (Wt(e, 2), Qa(e));
    }
    function nt(e, t, a) {
      if (Jm = !1, e.tag === 3)
        wa(e, e, a);
      else {
        for (; t !== null; ) {
          if (t.tag === 3) {
            wa(
              t,
              e,
              a
            );
            return;
          }
          if (t.tag === 1) {
            var i = t.stateNode;
            if (typeof t.type.getDerivedStateFromError == "function" || typeof i.componentDidCatch == "function" && (zs === null || !zs.has(i))) {
              e = Ea(a, e), q0(e), a = bh(2), i = Bu(t, a, 2), i !== null && (Sh(
                a,
                i,
                t,
                e
              ), Wt(i, 2), Qa(i));
              return;
            }
          }
          t = t.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          a
        );
      }
    }
    function Vh(e, t, a) {
      var i = e.pingCache;
      if (i === null) {
        i = e.pingCache = new xR();
        var c = /* @__PURE__ */ new Set();
        i.set(t, c);
      } else
        c = i.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), i.set(t, c));
      c.has(a) || (CS = !0, c.add(a), i = Xa.bind(null, e, t, a), ai && Xr(e, a), t.then(i, i));
    }
    function Xa(e, t, a) {
      var i = e.pingCache;
      i !== null && i.delete(t), e.pingedLanes |= e.suspendedLanes & a, e.warmLanes &= ~a, (a & 127) !== 0 ? 0 > jo && (od = jo = Fn(), Sg = Pv("Promise Resolved"), Ss = e1) : (a & 4194048) !== 0 && 0 > fi && (Qc = fi = Fn(), Tg = Pv("Promise Resolved"), cS = e1), Ey() && I.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), Ft === e && (ct & a) === a && (gn === Os || gn === p1 && (ct & 62914560) === ct && kn() - S1 < UT ? (Tt & ca) === ya && ku(e, 0) : zS |= a, bd === ct && (bd = 0)), Qa(e);
    }
    function _y(e, t) {
      t === 0 && (t = et()), e = ra(e, t), e !== null && (Wt(e, t), Qa(e));
    }
    function ji(e) {
      var t = e.memoizedState, a = 0;
      t !== null && (a = t.retryLane), _y(e, a);
    }
    function Rc(e, t) {
      var a = 0;
      switch (e.tag) {
        case 31:
        case 13:
          var i = e.stateNode, c = e.memoizedState;
          c !== null && (a = c.retryLane);
          break;
        case 19:
          i = e.stateNode;
          break;
        case 22:
          i = e.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      i !== null && i.delete(t), _y(e, a);
    }
    function mu(e, t, a) {
      if ((t.subtreeFlags & 67117056) !== 0)
        for (t = t.child; t !== null; ) {
          var i = e, c = t, s = c.type === xa;
          s = a || s, c.tag !== 22 ? c.flags & 67108864 ? s && Ae(
            c,
            Yh,
            i,
            c
          ) : mu(
            i,
            c,
            s
          ) : c.memoizedState === null && (s && c.flags & 8192 ? Ae(
            c,
            Yh,
            i,
            c
          ) : c.subtreeFlags & 67108864 && Ae(
            c,
            mu,
            i,
            c,
            s
          )), t = t.sibling;
        }
    }
    function Yh(e, t) {
      Z(!0);
      try {
        Nh(t), by(t), yy(e, t.alternate, t, !1), Mf(e, t, 0, null, !1, 0);
      } finally {
        Z(!1);
      }
    }
    function Gh(e) {
      var t = !0;
      e.current.mode & ($a | Zi) || (t = !1), mu(
        e,
        e.current,
        t
      );
    }
    function Vl(e) {
      if ((Tt & ca) === ya) {
        var t = e.tag;
        if (t === 3 || t === 1 || t === 0 || t === 11 || t === 14 || t === 15) {
          if (t = ae(e) || "ReactComponent", D1 !== null) {
            if (D1.has(t)) return;
            D1.add(t);
          } else D1 = /* @__PURE__ */ new Set([t]);
          Ae(e, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Xr(e, t) {
      ai && e.memoizedUpdaters.forEach(function(a) {
        Va(e, a, t);
      });
    }
    function Qr(e, t) {
      var a = I.actQueue;
      return a !== null ? (a.push(t), BR) : ag(e, t);
    }
    function Lf(e) {
      Ey() && I.actQueue === null && Ae(e, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          ae(e)
        );
      });
    }
    function Qa(e) {
      e !== Km && e.next === null && (Km === null ? R1 = Km = e : Km = Km.next = e), C1 = !0, I.actQueue !== null ? BS || (BS = !0, iv()) : LS || (LS = !0, iv());
    }
    function Fu(e, t) {
      if (!jS && C1) {
        jS = !0;
        do
          for (var a = !1, i = R1; i !== null; ) {
            if (e !== 0) {
              var c = i.pendingLanes;
              if (c === 0) var s = 0;
              else {
                var y = i.suspendedLanes, b = i.pingedLanes;
                s = (1 << 31 - ua(42 | e) + 1) - 1, s &= c & ~(y & ~b), s = s & 201326741 ? s & 201326741 | 1 : s ? s | 2 : 0;
              }
              s !== 0 && (a = !0, Bf(i, s));
            } else
              s = ct, s = me(
                i,
                i === Ft ? s : 0,
                i.cancelPendingCommit !== null || i.timeoutHandle !== Od
              ), (s & 3) === 0 || _e(i, s) || (a = !0, Bf(i, s));
            i = i.next;
          }
        while (a);
        jS = !1;
      }
    }
    function uv() {
      $g = window.event, Xh();
    }
    function Xh() {
      C1 = BS = LS = !1;
      var e = 0;
      ws !== 0 && Ny() && (e = ws);
      for (var t = kn(), a = null, i = R1; i !== null; ) {
        var c = i.next, s = Zr(i, t);
        s === 0 ? (i.next = null, a === null ? R1 = c : a.next = c, c === null && (Km = a)) : (a = i, (e !== 0 || (s & 3) !== 0) && (C1 = !0)), i = c;
      }
      ta !== _s && ta !== A1 || Fu(e), ws !== 0 && (ws = 0);
    }
    function Zr(e, t) {
      for (var a = e.suspendedLanes, i = e.pingedLanes, c = e.expirationTimes, s = e.pendingLanes & -62914561; 0 < s; ) {
        var y = 31 - ua(s), b = 1 << y, A = c[y];
        A === -1 ? ((b & a) === 0 || (b & i) !== 0) && (c[y] = vt(b, t)) : A <= t && (e.expiredLanes |= b), s &= ~b;
      }
      if (t = Ft, a = ct, a = me(
        e,
        e === t ? a : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== Od
      ), i = e.callbackNode, a === 0 || e === t && (Qt === gd || Qt === vd) || e.cancelPendingCommit !== null)
        return i !== null && Qh(i), e.callbackNode = null, e.callbackPriority = 0;
      if ((a & 3) === 0 || _e(e, a)) {
        if (t = a & -a, t !== e.callbackPriority || I.actQueue !== null && i !== qS)
          Qh(i);
        else return t;
        switch (ba(a)) {
          case Bn:
          case ia:
            a = pm;
            break;
          case ha:
            a = Hc;
            break;
          case Ho:
            a = ym;
            break;
          default:
            a = Hc;
        }
        return i = Uy.bind(null, e), I.actQueue !== null ? (I.actQueue.push(i), a = qS) : a = ag(a, i), e.callbackPriority = t, e.callbackNode = a, t;
      }
      return i !== null && Qh(i), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function Uy(e, t) {
      if (u1 = l1 = !1, $g = window.event, ta !== _s && ta !== A1)
        return e.callbackNode = null, e.callbackPriority = 0, null;
      var a = e.callbackNode;
      if (Fi === T1 && (Fi = US), xf() && e.callbackNode !== a)
        return null;
      var i = ct;
      return i = me(
        e,
        e === Ft ? i : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== Od
      ), i === 0 ? null : (tv(
        e,
        i,
        t
      ), Zr(e, kn()), e.callbackNode != null && e.callbackNode === a ? Uy.bind(null, e) : null);
    }
    function Bf(e, t) {
      if (xf()) return null;
      l1 = u1, u1 = !1, tv(e, t, !0);
    }
    function Qh(e) {
      e !== qS && e !== null && dm(e);
    }
    function iv() {
      I.actQueue !== null && I.actQueue.push(function() {
        return Xh(), null;
      }), KR(function() {
        (Tt & (ca | Du)) !== ya ? ag(
          lg,
          uv
        ) : Xh();
      });
    }
    function wy() {
      if (ws === 0) {
        var e = sd;
        e === 0 && (e = rs, rs <<= 1, (rs & 261888) === 0 && (rs = 256)), ws = e;
      }
      return ws;
    }
    function Ot(e) {
      return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : (He(e, "action"), Zs("" + e));
    }
    function Yt(e, t) {
      var a = t.ownerDocument.createElement("input");
      return a.name = t.name, a.value = t.value, e.id && a.setAttribute("form", e.id), t.parentNode.insertBefore(a, t), e = new FormData(e), a.parentNode.removeChild(a), e;
    }
    function mt(e, t, a, i, c) {
      if (t === "submit" && a && a.stateNode === c) {
        var s = Ot(
          (c[Ha] || null).action
        ), y = i.submitter;
        y && (t = (t = y[Ha] || null) ? Ot(t.formAction) : y.getAttribute("formAction"), t !== null && (s = t, y = null));
        var b = new Jv(
          "action",
          "action",
          null,
          i,
          c
        );
        e.push({
          event: b,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (i.defaultPrevented) {
                  if (ws !== 0) {
                    var A = y ? Yt(
                      c,
                      y
                    ) : new FormData(c), D = {
                      pending: !0,
                      data: A,
                      method: c.method,
                      action: s
                    };
                    Object.freeze(D), xi(
                      a,
                      D,
                      null,
                      A
                    );
                  }
                } else
                  typeof s == "function" && (b.preventDefault(), A = y ? Yt(
                    c,
                    y
                  ) : new FormData(c), D = {
                    pending: !0,
                    data: A,
                    method: c.method,
                    action: s
                  }, Object.freeze(D), xi(
                    a,
                    D,
                    s,
                    A
                  ));
              },
              currentTarget: c
            }
          ]
        });
      }
    }
    function rt(e, t, a) {
      e.currentTarget = a;
      try {
        t(e);
      } catch (i) {
        Wb(i);
      }
      e.currentTarget = null;
    }
    function Ht(e, t) {
      t = (t & 4) !== 0;
      for (var a = 0; a < e.length; a++) {
        var i = e[a];
        e: {
          var c = void 0, s = i.event;
          if (i = i.listeners, t)
            for (var y = i.length - 1; 0 <= y; y--) {
              var b = i[y], A = b.instance, D = b.currentTarget;
              if (b = b.listener, A !== c && s.isPropagationStopped())
                break e;
              A !== null ? Ae(
                A,
                rt,
                s,
                b,
                D
              ) : rt(s, b, D), c = A;
            }
          else
            for (y = 0; y < i.length; y++) {
              if (b = i[y], A = b.instance, D = b.currentTarget, b = b.listener, A !== c && s.isPropagationStopped())
                break e;
              A !== null ? Ae(
                A,
                rt,
                s,
                b,
                D
              ) : rt(s, b, D), c = A;
            }
        }
      }
    }
    function Xe(e, t) {
      VS.has(e) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        e
      );
      var a = t[Bc];
      a === void 0 && (a = t[Bc] = /* @__PURE__ */ new Set());
      var i = e + "__bubble";
      a.has(i) || (Zh(t, e, 2, !1), a.add(i));
    }
    function Wu(e, t, a) {
      VS.has(e) && !t && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        e
      );
      var i = 0;
      t && (i |= 4), Zh(
        a,
        e,
        i,
        t
      );
    }
    function zo(e) {
      if (!e[z1]) {
        e[z1] = !0, Yv.forEach(function(a) {
          a !== "selectionchange" && (VS.has(a) || Wu(a, !1, e), Wu(a, !0, e));
        });
        var t = e.nodeType === 9 ? e : e.ownerDocument;
        t === null || t[z1] || (t[z1] = !0, Wu("selectionchange", !1, t));
      }
    }
    function Zh(e, t, a, i) {
      switch (um(t)) {
        case Bn:
          var c = Jy;
          break;
        case ia:
          c = la;
          break;
        default:
          c = Ky;
      }
      a = c.bind(
        null,
        t,
        a,
        e
      ), c = void 0, !Yb || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (c = !0), i ? c !== void 0 ? e.addEventListener(t, a, {
        capture: !0,
        passive: c
      }) : e.addEventListener(t, a, !0) : c !== void 0 ? e.addEventListener(t, a, {
        passive: c
      }) : e.addEventListener(
        t,
        a,
        !1
      );
    }
    function pu(e, t, a, i, c) {
      var s = i;
      if ((t & 1) === 0 && (t & 2) === 0 && i !== null)
        e: for (; ; ) {
          if (i === null) return;
          var y = i.tag;
          if (y === 3 || y === 4) {
            var b = i.stateNode.containerInfo;
            if (b === c) break;
            if (y === 4)
              for (y = i.return; y !== null; ) {
                var A = y.tag;
                if ((A === 3 || A === 4) && y.stateNode.containerInfo === c)
                  return;
                y = y.return;
              }
            for (; b !== null; ) {
              if (y = Ei(b), y === null) return;
              if (A = y.tag, A === 5 || A === 6 || A === 26 || A === 27) {
                i = s = y;
                continue e;
              }
              b = b.parentNode;
            }
          }
          i = i.return;
        }
      Gd(function() {
        var D = s, j = Pl(a), V = [];
        e: {
          var w = E2.get(e);
          if (w !== void 0) {
            var $ = Jv, Ee = e;
            switch (e) {
              case "keypress":
                if (Js(a) === 0) break e;
              case "keydown":
              case "keyup":
                $ = ID;
                break;
              case "focusin":
                Ee = "focus", $ = Zb;
                break;
              case "focusout":
                Ee = "blur", $ = Zb;
                break;
              case "beforeblur":
              case "afterblur":
                $ = Zb;
                break;
              case "click":
                if (a.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                $ = o2;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                $ = VD;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                $ = tR;
                break;
              case g2:
              case v2:
              case b2:
                $ = XD;
                break;
              case S2:
                $ = aR;
                break;
              case "scroll":
              case "scrollend":
                $ = jD;
                break;
              case "wheel":
                $ = uR;
                break;
              case "copy":
              case "cut":
              case "paste":
                $ = ZD;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                $ = r2;
                break;
              case "toggle":
              case "beforetoggle":
                $ = oR;
            }
            var Re = (t & 4) !== 0, Pt = !Re && (e === "scroll" || e === "scrollend"), gt = Re ? w !== null ? w + "Capture" : null : w;
            Re = [];
            for (var U = D, M; U !== null; ) {
              var B = U;
              if (M = B.stateNode, B = B.tag, B !== 5 && B !== 26 && B !== 27 || M === null || gt === null || (B = wu(U, gt), B != null && Re.push(
                kt(
                  U,
                  B,
                  M
                )
              )), Pt) break;
              U = U.return;
            }
            0 < Re.length && (w = new $(
              w,
              Ee,
              null,
              a,
              j
            ), V.push({
              event: w,
              listeners: Re
            }));
          }
        }
        if ((t & 7) === 0) {
          e: {
            if (w = e === "mouseover" || e === "pointerover", $ = e === "mouseout" || e === "pointerout", w && a !== rg && (Ee = a.relatedTarget || a.fromElement) && (Ei(Ee) || Ee[Qi]))
              break e;
            if (($ || w) && (w = j.window === j ? j : (w = j.ownerDocument) ? w.defaultView || w.parentWindow : window, $ ? (Ee = a.relatedTarget || a.toElement, $ = D, Ee = Ee ? Ei(Ee) : null, Ee !== null && (Pt = F(Ee), Re = Ee.tag, Ee !== Pt || Re !== 5 && Re !== 27 && Re !== 6) && (Ee = null)) : ($ = null, Ee = D), $ !== Ee)) {
              if (Re = o2, B = "onMouseLeave", gt = "onMouseEnter", U = "mouse", (e === "pointerout" || e === "pointerover") && (Re = r2, B = "onPointerLeave", gt = "onPointerEnter", U = "pointer"), Pt = $ == null ? w : Pi($), M = Ee == null ? w : Pi(Ee), w = new Re(
                B,
                U + "leave",
                $,
                a,
                j
              ), w.target = Pt, w.relatedTarget = M, B = null, Ei(j) === D && (Re = new Re(
                gt,
                U + "enter",
                Ee,
                a,
                j
              ), Re.target = M, Re.relatedTarget = Pt, B = Re), Pt = B, $ && Ee)
                t: {
                  for (Re = Cc, gt = $, U = Ee, M = 0, B = gt; B; B = Re(B))
                    M++;
                  B = 0;
                  for (var ie = U; ie; ie = Re(ie))
                    B++;
                  for (; 0 < M - B; )
                    gt = Re(gt), M--;
                  for (; 0 < B - M; )
                    U = Re(U), B--;
                  for (; M--; ) {
                    if (gt === U || U !== null && gt === U.alternate) {
                      Re = gt;
                      break t;
                    }
                    gt = Re(gt), U = Re(U);
                  }
                  Re = null;
                }
              else Re = null;
              $ !== null && Jh(
                V,
                w,
                $,
                Re,
                !1
              ), Ee !== null && Pt !== null && Jh(
                V,
                Pt,
                Ee,
                Re,
                !0
              );
            }
          }
          e: {
            if (w = D ? Pi(D) : window, $ = w.nodeName && w.nodeName.toLowerCase(), $ === "select" || $ === "input" && w.type === "file")
              var Oe = ao;
            else if (yp(w))
              if (p2)
                Oe = Fs;
              else {
                Oe = gp;
                var ke = Cb;
              }
            else
              $ = w.nodeName, !$ || $.toLowerCase() !== "input" || w.type !== "checkbox" && w.type !== "radio" ? D && Uu(D.elementType) && (Oe = ao) : Oe = vp;
            if (Oe && (Oe = Oe(e, D))) {
              ks(
                V,
                Oe,
                a,
                j
              );
              break e;
            }
            ke && ke(e, w, D), e === "focusout" && D && w.type === "number" && D.memoizedProps.value != null && op(w, "number", w.value);
          }
          switch (ke = D ? Pi(D) : window, e) {
            case "focusin":
              (yp(ke) || ke.contentEditable === "true") && (Om = ke, Kb = D, yg = null);
              break;
            case "focusout":
              yg = Kb = Om = null;
              break;
            case "mousedown":
              kb = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              kb = !1, z0(
                V,
                a,
                j
              );
              break;
            case "selectionchange":
              if (fR) break;
            case "keydown":
            case "keyup":
              z0(
                V,
                a,
                j
              );
          }
          var qe;
          if (Jb)
            e: {
              switch (e) {
                case "compositionstart":
                  var Le = "onCompositionStart";
                  break e;
                case "compositionend":
                  Le = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  Le = "onCompositionUpdate";
                  break e;
              }
              Le = void 0;
            }
          else
            Am ? hr(e, a) && (Le = "onCompositionEnd") : e === "keydown" && a.keyCode === s2 && (Le = "onCompositionStart");
          Le && (f2 && a.locale !== "ko" && (Am || Le !== "onCompositionStart" ? Le === "onCompositionEnd" && Am && (qe = Wo()) : (ms = j, Gb = "value" in ms ? ms.value : ms.textContent, Am = !0)), ke = yu(
            D,
            Le
          ), 0 < ke.length && (Le = new c2(
            Le,
            e,
            null,
            a,
            j
          ), V.push({
            event: Le,
            listeners: ke
          }), qe ? Le.data = qe : (qe = Oi(a), qe !== null && (Le.data = qe)))), (qe = rR ? pp(e, a) : Xd(e, a)) && (Le = yu(
            D,
            "onBeforeInput"
          ), 0 < Le.length && (ke = new KD(
            "onBeforeInput",
            "beforeinput",
            null,
            a,
            j
          ), V.push({
            event: ke,
            listeners: Le
          }), ke.data = qe)), mt(
            V,
            e,
            D,
            a,
            j
          );
        }
        Ht(V, t);
      });
    }
    function kt(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function yu(e, t) {
      for (var a = t + "Capture", i = []; e !== null; ) {
        var c = e, s = c.stateNode;
        if (c = c.tag, c !== 5 && c !== 26 && c !== 27 || s === null || (c = wu(e, a), c != null && i.unshift(
          kt(e, c, s)
        ), c = wu(e, t), c != null && i.push(
          kt(e, c, s)
        )), e.tag === 3) return i;
        e = e.return;
      }
      return [];
    }
    function Cc(e) {
      if (e === null) return null;
      do
        e = e.return;
      while (e && e.tag !== 5 && e.tag !== 27);
      return e || null;
    }
    function Jh(e, t, a, i, c) {
      for (var s = t._reactName, y = []; a !== null && a !== i; ) {
        var b = a, A = b.alternate, D = b.stateNode;
        if (b = b.tag, A !== null && A === i) break;
        b !== 5 && b !== 26 && b !== 27 || D === null || (A = D, c ? (D = wu(a, s), D != null && y.unshift(
          kt(a, D, A)
        )) : c || (D = wu(a, s), D != null && y.push(
          kt(a, D, A)
        ))), a = a.return;
      }
      y.length !== 0 && e.push({ event: t, listeners: y });
    }
    function Ma(e, t) {
      A0(e, t), e !== "input" && e !== "textarea" && e !== "select" || t == null || t.value !== null || u2 || (u2 = !0, e === "select" && t.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        e
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        e
      ));
      var a = {
        registrationNameDependencies: li,
        possibleRegistrationNames: ds
      };
      Uu(e) || typeof t.is == "string" || Rb(e, t, a), t.contentEditable && !t.suppressContentEditableWarning && t.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function sn(e, t, a, i) {
      t !== a && (a = gu(a), gu(t) !== a && (i[e] = t));
    }
    function jf(e, t, a) {
      t.forEach(function(i) {
        a[qi(i)] = i === "style" ? _o(e) : e.getAttribute(i);
      });
    }
    function fn(e, t) {
      t === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        e,
        e,
        e
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        e,
        typeof t
      );
    }
    function Kh(e, t) {
      return e = e.namespaceURI === Ie || e.namespaceURI === at ? e.ownerDocument.createElementNS(
        e.namespaceURI,
        e.tagName
      ) : e.ownerDocument.createElement(e.tagName), e.innerHTML = t, e.innerHTML;
    }
    function gu(e) {
      return na(e) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        va(e)
      ), $l(e)), (typeof e == "string" ? e : "" + e).replace(jR, `
`).replace(qR, "");
    }
    function My(e, t) {
      return t = gu(t), gu(e) === t;
    }
    function zt(e, t, a, i, c, s) {
      switch (a) {
        case "children":
          typeof i == "string" ? (Qs(i, t, !1), t === "body" || t === "textarea" && i === "" || Fo(e, i)) : (typeof i == "number" || typeof i == "bigint") && (Qs("" + i, t, !1), t !== "body" && Fo(e, "" + i));
          break;
        case "className":
          Ys(e, "class", i);
          break;
        case "tabIndex":
          Ys(e, "tabindex", i);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          Ys(e, a, i);
          break;
        case "style":
          dp(e, i, s);
          break;
        case "data":
          if (t !== "object") {
            Ys(e, "data", i);
            break;
          }
        case "src":
        case "href":
          if (i === "" && (t !== "a" || a !== "href")) {
            console.error(
              a === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              a,
              a
            ), e.removeAttribute(a);
            break;
          }
          if (i == null || typeof i == "function" || typeof i == "symbol" || typeof i == "boolean") {
            e.removeAttribute(a);
            break;
          }
          He(i, a), i = Zs("" + i), e.setAttribute(a, i);
          break;
        case "action":
        case "formAction":
          if (i != null && (t === "form" ? a === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof i == "function" && (c.encType == null && c.method == null || w1 || (w1 = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), c.target == null || U1 || (U1 = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : t === "input" || t === "button" ? a === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : t !== "input" || c.type === "submit" || c.type === "image" || _1 ? t !== "button" || c.type == null || c.type === "submit" || _1 ? typeof i == "function" && (c.name == null || QT || (QT = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), c.formEncType == null && c.formMethod == null || w1 || (w1 = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), c.formTarget == null || U1 || (U1 = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (_1 = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (_1 = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            a === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof i == "function") {
            e.setAttribute(
              a,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof s == "function" && (a === "formAction" ? (t !== "input" && zt(e, t, "name", c.name, c, null), zt(
              e,
              t,
              "formEncType",
              c.formEncType,
              c,
              null
            ), zt(
              e,
              t,
              "formMethod",
              c.formMethod,
              c,
              null
            ), zt(
              e,
              t,
              "formTarget",
              c.formTarget,
              c,
              null
            )) : (zt(
              e,
              t,
              "encType",
              c.encType,
              c,
              null
            ), zt(e, t, "method", c.method, c, null), zt(
              e,
              t,
              "target",
              c.target,
              c,
              null
            )));
          if (i == null || typeof i == "symbol" || typeof i == "boolean") {
            e.removeAttribute(a);
            break;
          }
          He(i, a), i = Zs("" + i), e.setAttribute(a, i);
          break;
        case "onClick":
          i != null && (typeof i != "function" && fn(a, i), e.onclick = Ul);
          break;
        case "onScroll":
          i != null && (typeof i != "function" && fn(a, i), Xe("scroll", e));
          break;
        case "onScrollEnd":
          i != null && (typeof i != "function" && fn(a, i), Xe("scrollend", e));
          break;
        case "dangerouslySetInnerHTML":
          if (i != null) {
            if (typeof i != "object" || !("__html" in i))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (a = i.__html, a != null) {
              if (c.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = a;
            }
          }
          break;
        case "multiple":
          e.multiple = i && typeof i != "function" && typeof i != "symbol";
          break;
        case "muted":
          e.muted = i && typeof i != "function" && typeof i != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (i == null || typeof i == "function" || typeof i == "boolean" || typeof i == "symbol") {
            e.removeAttribute("xlink:href");
            break;
          }
          He(i, a), a = Zs("" + i), e.setAttributeNS(Ed, "xlink:href", a);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          i != null && typeof i != "function" && typeof i != "symbol" ? (He(i, a), e.setAttribute(a, "" + i)) : e.removeAttribute(a);
          break;
        case "inert":
          i !== "" || M1[a] || (M1[a] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            a
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          i && typeof i != "function" && typeof i != "symbol" ? e.setAttribute(a, "") : e.removeAttribute(a);
          break;
        case "capture":
        case "download":
          i === !0 ? e.setAttribute(a, "") : i !== !1 && i != null && typeof i != "function" && typeof i != "symbol" ? (He(i, a), e.setAttribute(a, i)) : e.removeAttribute(a);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          i != null && typeof i != "function" && typeof i != "symbol" && !isNaN(i) && 1 <= i ? (He(i, a), e.setAttribute(a, i)) : e.removeAttribute(a);
          break;
        case "rowSpan":
        case "start":
          i == null || typeof i == "function" || typeof i == "symbol" || isNaN(i) ? e.removeAttribute(a) : (He(i, a), e.setAttribute(a, i));
          break;
        case "popover":
          Xe("beforetoggle", e), Xe("toggle", e), wd(e, "popover", i);
          break;
        case "xlinkActuate":
          Cu(
            e,
            Ed,
            "xlink:actuate",
            i
          );
          break;
        case "xlinkArcrole":
          Cu(
            e,
            Ed,
            "xlink:arcrole",
            i
          );
          break;
        case "xlinkRole":
          Cu(
            e,
            Ed,
            "xlink:role",
            i
          );
          break;
        case "xlinkShow":
          Cu(
            e,
            Ed,
            "xlink:show",
            i
          );
          break;
        case "xlinkTitle":
          Cu(
            e,
            Ed,
            "xlink:title",
            i
          );
          break;
        case "xlinkType":
          Cu(
            e,
            Ed,
            "xlink:type",
            i
          );
          break;
        case "xmlBase":
          Cu(
            e,
            YS,
            "xml:base",
            i
          );
          break;
        case "xmlLang":
          Cu(
            e,
            YS,
            "xml:lang",
            i
          );
          break;
        case "xmlSpace":
          Cu(
            e,
            YS,
            "xml:space",
            i
          );
          break;
        case "is":
          s != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), wd(e, "is", i);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          ZT || i == null || typeof i != "object" || (ZT = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            i
          ));
        default:
          !(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N" ? (a = E0(a), wd(e, a, i)) : li.hasOwnProperty(a) && i != null && typeof i != "function" && fn(a, i);
      }
    }
    function Jr(e, t, a, i, c, s) {
      switch (a) {
        case "style":
          dp(e, i, s);
          break;
        case "dangerouslySetInnerHTML":
          if (i != null) {
            if (typeof i != "object" || !("__html" in i))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (a = i.__html, a != null) {
              if (c.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = a;
            }
          }
          break;
        case "children":
          typeof i == "string" ? Fo(e, i) : (typeof i == "number" || typeof i == "bigint") && Fo(e, "" + i);
          break;
        case "onScroll":
          i != null && (typeof i != "function" && fn(a, i), Xe("scroll", e));
          break;
        case "onScrollEnd":
          i != null && (typeof i != "function" && fn(a, i), Xe("scrollend", e));
          break;
        case "onClick":
          i != null && (typeof i != "function" && fn(a, i), e.onclick = Ul);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (li.hasOwnProperty(a))
            i != null && typeof i != "function" && fn(a, i);
          else
            e: {
              if (a[0] === "o" && a[1] === "n" && (c = a.endsWith("Capture"), t = a.slice(2, c ? a.length - 7 : void 0), s = e[Ha] || null, s = s != null ? s[a] : null, typeof s == "function" && e.removeEventListener(t, s, c), typeof i == "function")) {
                typeof s != "function" && s !== null && (a in e ? e[a] = null : e.hasAttribute(a) && e.removeAttribute(a)), e.addEventListener(t, i, c);
                break e;
              }
              a in e ? e[a] = i : i === !0 ? e.setAttribute(a, "") : wd(e, a, i);
            }
      }
    }
    function an(e, t, a) {
      switch (Ma(t, a), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          Xe("error", e), Xe("load", e);
          var i = !1, c = !1, s;
          for (s in a)
            if (a.hasOwnProperty(s)) {
              var y = a[s];
              if (y != null)
                switch (s) {
                  case "src":
                    i = !0;
                    break;
                  case "srcSet":
                    c = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    zt(e, t, s, y, a, null);
                }
            }
          c && zt(e, t, "srcSet", a.srcSet, a, null), i && zt(e, t, "src", a.src, a, null);
          return;
        case "input":
          Zo("input", a), Xe("invalid", e);
          var b = s = y = c = null, A = null, D = null;
          for (i in a)
            if (a.hasOwnProperty(i)) {
              var j = a[i];
              if (j != null)
                switch (i) {
                  case "name":
                    c = j;
                    break;
                  case "type":
                    y = j;
                    break;
                  case "checked":
                    A = j;
                    break;
                  case "defaultChecked":
                    D = j;
                    break;
                  case "value":
                    s = j;
                    break;
                  case "defaultValue":
                    b = j;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (j != null)
                      throw Error(
                        t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    zt(e, t, i, j, a, null);
                }
            }
          Sa(e, a), xd(
            e,
            s,
            b,
            A,
            D,
            y,
            c,
            !1
          );
          return;
        case "select":
          Zo("select", a), Xe("invalid", e), i = y = s = null;
          for (c in a)
            if (a.hasOwnProperty(c) && (b = a[c], b != null))
              switch (c) {
                case "value":
                  s = b;
                  break;
                case "defaultValue":
                  y = b;
                  break;
                case "multiple":
                  i = b;
                default:
                  zt(
                    e,
                    t,
                    c,
                    b,
                    a,
                    null
                  );
              }
          Hd(e, a), t = s, a = y, e.multiple = !!i, t != null ? zu(e, !!i, t, !1) : a != null && zu(e, !!i, a, !0);
          return;
        case "textarea":
          Zo("textarea", a), Xe("invalid", e), s = c = i = null;
          for (y in a)
            if (a.hasOwnProperty(y) && (b = a[y], b != null))
              switch (y) {
                case "value":
                  i = b;
                  break;
                case "defaultValue":
                  c = b;
                  break;
                case "children":
                  s = b;
                  break;
                case "dangerouslySetInnerHTML":
                  if (b != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  zt(
                    e,
                    t,
                    y,
                    b,
                    a,
                    null
                  );
              }
          Jo(e, a), or(e, i, c, s);
          return;
        case "option":
          S0(e, a);
          for (A in a)
            if (a.hasOwnProperty(A) && (i = a[A], i != null))
              switch (A) {
                case "selected":
                  e.selected = i && typeof i != "function" && typeof i != "symbol";
                  break;
                default:
                  zt(e, t, A, i, a, null);
              }
          return;
        case "dialog":
          Xe("beforetoggle", e), Xe("toggle", e), Xe("cancel", e), Xe("close", e);
          break;
        case "iframe":
        case "object":
          Xe("load", e);
          break;
        case "video":
        case "audio":
          for (i = 0; i < Jg.length; i++)
            Xe(Jg[i], e);
          break;
        case "image":
          Xe("error", e), Xe("load", e);
          break;
        case "details":
          Xe("toggle", e);
          break;
        case "embed":
        case "source":
        case "link":
          Xe("error", e), Xe("load", e);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (D in a)
            if (a.hasOwnProperty(D) && (i = a[D], i != null))
              switch (D) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  zt(e, t, D, i, a, null);
              }
          return;
        default:
          if (Uu(t)) {
            for (j in a)
              a.hasOwnProperty(j) && (i = a[j], i !== void 0 && Jr(
                e,
                t,
                j,
                i,
                a,
                void 0
              ));
            return;
          }
      }
      for (b in a)
        a.hasOwnProperty(b) && (i = a[b], i != null && zt(e, t, b, i, a, null));
    }
    function Hn(e, t, a, i) {
      switch (Ma(t, i), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var c = null, s = null, y = null, b = null, A = null, D = null, j = null;
          for ($ in a) {
            var V = a[$];
            if (a.hasOwnProperty($) && V != null)
              switch ($) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  A = V;
                default:
                  i.hasOwnProperty($) || zt(
                    e,
                    t,
                    $,
                    null,
                    i,
                    V
                  );
              }
          }
          for (var w in i) {
            var $ = i[w];
            if (V = a[w], i.hasOwnProperty(w) && ($ != null || V != null))
              switch (w) {
                case "type":
                  s = $;
                  break;
                case "name":
                  c = $;
                  break;
                case "checked":
                  D = $;
                  break;
                case "defaultChecked":
                  j = $;
                  break;
                case "value":
                  y = $;
                  break;
                case "defaultValue":
                  b = $;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if ($ != null)
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  $ !== V && zt(
                    e,
                    t,
                    w,
                    $,
                    i,
                    V
                  );
              }
          }
          t = a.type === "checkbox" || a.type === "radio" ? a.checked != null : a.value != null, i = i.type === "checkbox" || i.type === "radio" ? i.checked != null : i.value != null, t || !i || XT || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), XT = !0), !t || i || GT || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), GT = !0), eo(
            e,
            y,
            b,
            A,
            D,
            j,
            s,
            c
          );
          return;
        case "select":
          $ = y = b = w = null;
          for (s in a)
            if (A = a[s], a.hasOwnProperty(s) && A != null)
              switch (s) {
                case "value":
                  break;
                case "multiple":
                  $ = A;
                default:
                  i.hasOwnProperty(s) || zt(
                    e,
                    t,
                    s,
                    null,
                    i,
                    A
                  );
              }
          for (c in i)
            if (s = i[c], A = a[c], i.hasOwnProperty(c) && (s != null || A != null))
              switch (c) {
                case "value":
                  w = s;
                  break;
                case "defaultValue":
                  b = s;
                  break;
                case "multiple":
                  y = s;
                default:
                  s !== A && zt(
                    e,
                    t,
                    c,
                    s,
                    i,
                    A
                  );
              }
          i = b, t = y, a = $, w != null ? zu(e, !!t, w, !1) : !!a != !!t && (i != null ? zu(e, !!t, i, !0) : zu(e, !!t, t ? [] : "", !1));
          return;
        case "textarea":
          $ = w = null;
          for (b in a)
            if (c = a[b], a.hasOwnProperty(b) && c != null && !i.hasOwnProperty(b))
              switch (b) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  zt(e, t, b, null, i, c);
              }
          for (y in i)
            if (c = i[y], s = a[y], i.hasOwnProperty(y) && (c != null || s != null))
              switch (y) {
                case "value":
                  w = c;
                  break;
                case "defaultValue":
                  $ = c;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (c != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  c !== s && zt(e, t, y, c, i, s);
              }
          Ko(e, w, $);
          return;
        case "option":
          for (var Ee in a)
            if (w = a[Ee], a.hasOwnProperty(Ee) && w != null && !i.hasOwnProperty(Ee))
              switch (Ee) {
                case "selected":
                  e.selected = !1;
                  break;
                default:
                  zt(
                    e,
                    t,
                    Ee,
                    null,
                    i,
                    w
                  );
              }
          for (A in i)
            if (w = i[A], $ = a[A], i.hasOwnProperty(A) && w !== $ && (w != null || $ != null))
              switch (A) {
                case "selected":
                  e.selected = w && typeof w != "function" && typeof w != "symbol";
                  break;
                default:
                  zt(
                    e,
                    t,
                    A,
                    w,
                    i,
                    $
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var Re in a)
            w = a[Re], a.hasOwnProperty(Re) && w != null && !i.hasOwnProperty(Re) && zt(
              e,
              t,
              Re,
              null,
              i,
              w
            );
          for (D in i)
            if (w = i[D], $ = a[D], i.hasOwnProperty(D) && w !== $ && (w != null || $ != null))
              switch (D) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (w != null)
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  zt(
                    e,
                    t,
                    D,
                    w,
                    i,
                    $
                  );
              }
          return;
        default:
          if (Uu(t)) {
            for (var Pt in a)
              w = a[Pt], a.hasOwnProperty(Pt) && w !== void 0 && !i.hasOwnProperty(Pt) && Jr(
                e,
                t,
                Pt,
                void 0,
                i,
                w
              );
            for (j in i)
              w = i[j], $ = a[j], !i.hasOwnProperty(j) || w === $ || w === void 0 && $ === void 0 || Jr(
                e,
                t,
                j,
                w,
                i,
                $
              );
            return;
          }
      }
      for (var gt in a)
        w = a[gt], a.hasOwnProperty(gt) && w != null && !i.hasOwnProperty(gt) && zt(e, t, gt, null, i, w);
      for (V in i)
        w = i[V], $ = a[V], !i.hasOwnProperty(V) || w === $ || w == null && $ == null || zt(e, t, V, w, i, $);
    }
    function qi(e) {
      switch (e) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return e;
      }
    }
    function _o(e) {
      var t = {};
      e = e.style;
      for (var a = 0; a < e.length; a++) {
        var i = e[a];
        t[i] = e.getPropertyValue(i);
      }
      return t;
    }
    function Iu(e, t, a) {
      if (t != null && typeof t != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var i, c = i = "", s;
        for (s in t)
          if (t.hasOwnProperty(s)) {
            var y = t[s];
            y != null && typeof y != "boolean" && y !== "" && (s.indexOf("--") === 0 ? (wt(y, s), i += c + s + ":" + ("" + y).trim()) : typeof y != "number" || y === 0 || Ne.has(s) ? (wt(y, s), i += c + s.replace(P, "-$1").toLowerCase().replace(Ue, "-ms-") + ":" + ("" + y).trim()) : i += c + s.replace(P, "-$1").toLowerCase().replace(Ue, "-ms-") + ":" + y + "px", c = ";");
          }
        i = i || null, t = e.getAttribute("style"), t !== i && (i = gu(i), gu(t) !== i && (a.style = _o(e)));
      }
    }
    function Za(e, t, a, i, c, s) {
      if (c.delete(a), e = e.getAttribute(a), e === null)
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (i != null)
        switch (typeof i) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (He(i, t), e === "" + i)
              return;
        }
      sn(t, e, i, s);
    }
    function kh(e, t, a, i, c, s) {
      if (c.delete(a), e = e.getAttribute(a), e === null) {
        switch (typeof i) {
          case "function":
          case "symbol":
            return;
        }
        if (!i) return;
      } else
        switch (typeof i) {
          case "function":
          case "symbol":
            break;
          default:
            if (i) return;
        }
      sn(t, e, i, s);
    }
    function $h(e, t, a, i, c, s) {
      if (c.delete(a), e = e.getAttribute(a), e === null)
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (i != null)
        switch (typeof i) {
          case "function":
          case "symbol":
            break;
          default:
            if (He(i, a), e === "" + i)
              return;
        }
      sn(t, e, i, s);
    }
    function Kr(e, t, a, i, c, s) {
      if (c.delete(a), e = e.getAttribute(a), e === null)
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(i)) return;
        }
      else if (i != null)
        switch (typeof i) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(i) && (He(i, t), e === "" + i))
              return;
        }
      sn(t, e, i, s);
    }
    function qf(e, t, a, i, c, s) {
      if (c.delete(a), e = e.getAttribute(a), e === null)
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (i != null)
        switch (typeof i) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (He(i, t), a = Zs("" + i), e === a)
              return;
        }
      sn(t, e, i, s);
    }
    function Ja(e, t, a, i) {
      for (var c = {}, s = /* @__PURE__ */ new Set(), y = e.attributes, b = 0; b < y.length; b++)
        switch (y[b].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            s.add(y[b].name);
        }
      if (Uu(t)) {
        for (var A in a)
          if (a.hasOwnProperty(A)) {
            var D = a[A];
            if (D != null) {
              if (li.hasOwnProperty(A))
                typeof D != "function" && fn(A, D);
              else if (a.suppressHydrationWarning !== !0)
                switch (A) {
                  case "children":
                    typeof D != "string" && typeof D != "number" || sn(
                      "children",
                      e.textContent,
                      D,
                      c
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    y = e.innerHTML, D = D ? D.__html : void 0, D != null && (D = Kh(e, D), sn(
                      A,
                      y,
                      D,
                      c
                    ));
                    continue;
                  case "style":
                    s.delete(A), Iu(e, D, c);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    s.delete(A.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      A
                    );
                    continue;
                  case "className":
                    s.delete("class"), y = ir(
                      e,
                      "class",
                      D
                    ), sn(
                      "className",
                      y,
                      D,
                      c
                    );
                    continue;
                  default:
                    i.context === Wc && t !== "svg" && t !== "math" ? s.delete(A.toLowerCase()) : s.delete(A), y = ir(
                      e,
                      A,
                      D
                    ), sn(
                      A,
                      y,
                      D,
                      c
                    );
                }
            }
          }
      } else
        for (D in a)
          if (a.hasOwnProperty(D) && (A = a[D], A != null)) {
            if (li.hasOwnProperty(D))
              typeof A != "function" && fn(D, A);
            else if (a.suppressHydrationWarning !== !0)
              switch (D) {
                case "children":
                  typeof A != "string" && typeof A != "number" || sn(
                    "children",
                    e.textContent,
                    A,
                    c
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  y = e.innerHTML, A = A ? A.__html : void 0, A != null && (A = Kh(e, A), y !== A && (c[D] = { __html: y }));
                  continue;
                case "className":
                  Za(
                    e,
                    D,
                    "class",
                    A,
                    s,
                    c
                  );
                  continue;
                case "tabIndex":
                  Za(
                    e,
                    D,
                    "tabindex",
                    A,
                    s,
                    c
                  );
                  continue;
                case "style":
                  s.delete(D), Iu(e, A, c);
                  continue;
                case "multiple":
                  s.delete(D), sn(
                    D,
                    e.multiple,
                    A,
                    c
                  );
                  continue;
                case "muted":
                  s.delete(D), sn(
                    D,
                    e.muted,
                    A,
                    c
                  );
                  continue;
                case "autoFocus":
                  s.delete("autofocus"), sn(
                    D,
                    e.autofocus,
                    A,
                    c
                  );
                  continue;
                case "data":
                  if (t !== "object") {
                    s.delete(D), y = e.getAttribute("data"), sn(
                      D,
                      y,
                      A,
                      c
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(A !== "" || t === "a" && D === "href" || t === "object" && D === "data")) {
                    console.error(
                      D === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      D,
                      D
                    );
                    continue;
                  }
                  qf(
                    e,
                    D,
                    D,
                    A,
                    s,
                    c
                  );
                  continue;
                case "action":
                case "formAction":
                  if (y = e.getAttribute(D), typeof A == "function") {
                    s.delete(D.toLowerCase()), D === "formAction" ? (s.delete("name"), s.delete("formenctype"), s.delete("formmethod"), s.delete("formtarget")) : (s.delete("enctype"), s.delete("method"), s.delete("target"));
                    continue;
                  } else if (y === VR) {
                    s.delete(D.toLowerCase()), sn(
                      D,
                      "function",
                      A,
                      c
                    );
                    continue;
                  }
                  qf(
                    e,
                    D,
                    D.toLowerCase(),
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkHref":
                  qf(
                    e,
                    D,
                    "xlink:href",
                    A,
                    s,
                    c
                  );
                  continue;
                case "contentEditable":
                  $h(
                    e,
                    D,
                    "contenteditable",
                    A,
                    s,
                    c
                  );
                  continue;
                case "spellCheck":
                  $h(
                    e,
                    D,
                    "spellcheck",
                    A,
                    s,
                    c
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  $h(
                    e,
                    D,
                    D,
                    A,
                    s,
                    c
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  kh(
                    e,
                    D,
                    D.toLowerCase(),
                    A,
                    s,
                    c
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    b = e;
                    var j = y = D, V = c;
                    if (s.delete(j), b = b.getAttribute(j), b === null)
                      switch (typeof A) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (A === !1) break e;
                      }
                    else if (A != null)
                      switch (typeof A) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (A === !0 && b === "") break e;
                          break;
                        default:
                          if (He(A, y), b === "" + A)
                            break e;
                      }
                    sn(
                      y,
                      b,
                      A,
                      V
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (b = e, j = y = D, V = c, s.delete(j), b = b.getAttribute(j), b === null)
                      switch (typeof A) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(A) || 1 > A) break e;
                      }
                    else if (A != null)
                      switch (typeof A) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(A) || 1 > A) && (He(A, y), b === "" + A))
                            break e;
                      }
                    sn(
                      y,
                      b,
                      A,
                      V
                    );
                  }
                  continue;
                case "rowSpan":
                  Kr(
                    e,
                    D,
                    "rowspan",
                    A,
                    s,
                    c
                  );
                  continue;
                case "start":
                  Kr(
                    e,
                    D,
                    D,
                    A,
                    s,
                    c
                  );
                  continue;
                case "xHeight":
                  Za(
                    e,
                    D,
                    "x-height",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkActuate":
                  Za(
                    e,
                    D,
                    "xlink:actuate",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkArcrole":
                  Za(
                    e,
                    D,
                    "xlink:arcrole",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkRole":
                  Za(
                    e,
                    D,
                    "xlink:role",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkShow":
                  Za(
                    e,
                    D,
                    "xlink:show",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkTitle":
                  Za(
                    e,
                    D,
                    "xlink:title",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xlinkType":
                  Za(
                    e,
                    D,
                    "xlink:type",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xmlBase":
                  Za(
                    e,
                    D,
                    "xml:base",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xmlLang":
                  Za(
                    e,
                    D,
                    "xml:lang",
                    A,
                    s,
                    c
                  );
                  continue;
                case "xmlSpace":
                  Za(
                    e,
                    D,
                    "xml:space",
                    A,
                    s,
                    c
                  );
                  continue;
                case "inert":
                  A !== "" || M1[D] || (M1[D] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    D
                  )), kh(
                    e,
                    D,
                    D,
                    A,
                    s,
                    c
                  );
                  continue;
                default:
                  if (!(2 < D.length) || D[0] !== "o" && D[0] !== "O" || D[1] !== "n" && D[1] !== "N") {
                    b = E0(D), y = !1, i.context === Wc && t !== "svg" && t !== "math" ? s.delete(b.toLowerCase()) : (j = D.toLowerCase(), j = Eu.hasOwnProperty(
                      j
                    ) && Eu[j] || null, j !== null && j !== D && (y = !0, s.delete(j)), s.delete(b));
                    e: if (j = e, V = b, b = A, Vs(V))
                      if (j.hasAttribute(V))
                        j = j.getAttribute(
                          V
                        ), He(
                          b,
                          V
                        ), b = j === "" + b ? b : j;
                      else {
                        switch (typeof b) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (j = V.toLowerCase().slice(0, 5), j !== "data-" && j !== "aria-")
                              break e;
                        }
                        b = b === void 0 ? void 0 : null;
                      }
                    else b = void 0;
                    y || sn(
                      D,
                      b,
                      A,
                      c
                    );
                  }
              }
          }
      return 0 < s.size && a.suppressHydrationWarning !== !0 && jf(e, s, c), Object.keys(c).length === 0 ? null : c;
    }
    function ov(e, t) {
      switch (e.length) {
        case 0:
          return "";
        case 1:
          return e[0];
        case 2:
          return e[0] + " " + t + " " + e[1];
        default:
          return e.slice(0, -1).join(", ") + ", " + t + " " + e[e.length - 1];
      }
    }
    function Na(e) {
      switch (e) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return !0;
        default:
          return !1;
      }
    }
    function cv() {
      if (typeof performance.getEntriesByType == "function") {
        for (var e = 0, t = 0, a = performance.getEntriesByType("resource"), i = 0; i < a.length; i++) {
          var c = a[i], s = c.transferSize, y = c.initiatorType, b = c.duration;
          if (s && b && Na(y)) {
            for (y = 0, b = c.responseEnd, i += 1; i < a.length; i++) {
              var A = a[i], D = A.startTime;
              if (D > b) break;
              var j = A.transferSize, V = A.initiatorType;
              j && Na(V) && (A = A.responseEnd, y += j * (A < b ? 1 : (b - D) / (A - D)));
            }
            if (--i, t += 8 * (s + y) / (c.duration / 1e3), e++, 10 < e) break;
          }
        }
        if (0 < e) return t / e / 1e6;
      }
      return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
    }
    function Vf(e) {
      return e.nodeType === 9 ? e : e.ownerDocument;
    }
    function rv(e) {
      switch (e) {
        case at:
          return $m;
        case Ie:
          return x1;
        default:
          return Wc;
      }
    }
    function Vi(e, t) {
      if (e === Wc)
        switch (t) {
          case "svg":
            return $m;
          case "math":
            return x1;
          default:
            return Wc;
        }
      return e === $m && t === "foreignObject" ? Wc : e;
    }
    function kr(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function Ny() {
      var e = window.event;
      return e && e.type === "popstate" ? e === ZS ? !1 : (ZS = e, !0) : (ZS = null, !1);
    }
    function Pu() {
      var e = window.event;
      return e && e !== $g ? e.type : null;
    }
    function $r() {
      var e = window.event;
      return e && e !== $g ? e.timeStamp : -1.1;
    }
    function sv(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function fv(e, t, a) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          break;
        case "img":
          a.src ? e.src = a.src : a.srcSet && (e.srcset = a.srcSet);
      }
    }
    function dv() {
    }
    function Fh(e, t, a, i) {
      Hn(e, t, a, i), e[Ha] = i;
    }
    function Wh(e) {
      Fo(e, "");
    }
    function xb(e, t, a) {
      e.nodeValue = a;
    }
    function hv(e) {
      if (!e.__reactWarnedAboutChildrenConflict) {
        var t = e[Ha] || null;
        if (t !== null) {
          var a = Fl(e);
          a !== null && (typeof t.children == "string" || typeof t.children == "number" ? (e.__reactWarnedAboutChildrenConflict = !0, Ae(a, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })) : t.dangerouslySetInnerHTML != null && (e.__reactWarnedAboutChildrenConflict = !0, Ae(a, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })));
        }
      }
    }
    function Uo(e) {
      return e === "head";
    }
    function mv(e, t) {
      e.removeChild(t);
    }
    function pv(e, t) {
      (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).removeChild(t);
    }
    function zc(e, t) {
      var a = t, i = 0;
      do {
        var c = a.nextSibling;
        if (e.removeChild(a), c && c.nodeType === 8)
          if (a = c.data, a === kg || a === N1) {
            if (i === 0) {
              e.removeChild(c), Mc(t);
              return;
            }
            i--;
          } else if (a === Kg || a === Ms || a === Ad || a === km || a === Td)
            i++;
          else if (a === GR)
            Gi(
              e.ownerDocument.documentElement
            );
          else if (a === QR) {
            a = e.ownerDocument.head, Gi(a);
            for (var s = a.firstChild; s; ) {
              var y = s.nextSibling, b = s.nodeName;
              s[fs] || b === "SCRIPT" || b === "STYLE" || b === "LINK" && s.rel.toLowerCase() === "stylesheet" || a.removeChild(s), s = y;
            }
          } else
            a === XR && Gi(e.ownerDocument.body);
        a = c;
      } while (a);
      Mc(t);
    }
    function Yf(e, t) {
      var a = e;
      e = 0;
      do {
        var i = a.nextSibling;
        if (a.nodeType === 1 ? t ? (a._stashedDisplay = a.style.display, a.style.display = "none") : (a.style.display = a._stashedDisplay || "", a.getAttribute("style") === "" && a.removeAttribute("style")) : a.nodeType === 3 && (t ? (a._stashedText = a.nodeValue, a.nodeValue = "") : a.nodeValue = a._stashedText || ""), i && i.nodeType === 8)
          if (a = i.data, a === kg) {
            if (e === 0) break;
            e--;
          } else
            a !== Kg && a !== Ms && a !== Ad && a !== km || e++;
        a = i;
      } while (a);
    }
    function yv(e) {
      Yf(e, !0);
    }
    function gv(e) {
      e = e.style, typeof e.setProperty == "function" ? e.setProperty("display", "none", "important") : e.display = "none";
    }
    function vv(e) {
      e.nodeValue = "";
    }
    function bv(e) {
      Yf(e, !1);
    }
    function Sv(e, t) {
      t = t[ZR], t = t != null && t.hasOwnProperty("display") ? t.display : null, e.style.display = t == null || typeof t == "boolean" ? "" : ("" + t).trim();
    }
    function Ev(e, t) {
      e.nodeValue = t;
    }
    function Fr(e) {
      var t = e.firstChild;
      for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
        var a = t;
        switch (t = t.nextSibling, a.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Fr(a), lp(a);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (a.rel.toLowerCase() === "stylesheet") continue;
        }
        e.removeChild(a);
      }
    }
    function Tv(e, t, a, i) {
      for (; e.nodeType === 1; ) {
        var c = a;
        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
          if (!i && (e.nodeName !== "INPUT" || e.type !== "hidden"))
            break;
        } else if (i) {
          if (!e[fs])
            switch (t) {
              case "meta":
                if (!e.hasAttribute("itemprop")) break;
                return e;
              case "link":
                if (s = e.getAttribute("rel"), s === "stylesheet" && e.hasAttribute("data-precedence"))
                  break;
                if (s !== c.rel || e.getAttribute("href") !== (c.href == null || c.href === "" ? null : c.href) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin) || e.getAttribute("title") !== (c.title == null ? null : c.title))
                  break;
                return e;
              case "style":
                if (e.hasAttribute("data-precedence")) break;
                return e;
              case "script":
                if (s = e.getAttribute("src"), (s !== (c.src == null ? null : c.src) || e.getAttribute("type") !== (c.type == null ? null : c.type) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin)) && s && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                  break;
                return e;
              default:
                return e;
            }
        } else if (t === "input" && e.type === "hidden") {
          He(c.name, "name");
          var s = c.name == null ? null : "" + c.name;
          if (c.type === "hidden" && e.getAttribute("name") === s)
            return e;
        } else return e;
        if (e = gl(e.nextSibling), e === null) break;
      }
      return null;
    }
    function Av(e, t, a) {
      if (t === "") return null;
      for (; e.nodeType !== 3; )
        if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !a || (e = gl(e.nextSibling), e === null)) return null;
      return e;
    }
    function Lt(e, t) {
      for (; e.nodeType !== 8; )
        if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = gl(e.nextSibling), e === null)) return null;
      return e;
    }
    function Gf(e) {
      return e.data === Ms || e.data === Ad;
    }
    function xy(e) {
      return e.data === km || e.data === Ms && e.ownerDocument.readyState !== KT;
    }
    function Ov(e, t) {
      var a = e.ownerDocument;
      if (e.data === Ad)
        e._reactRetry = t;
      else if (e.data !== Ms || a.readyState !== KT)
        t();
      else {
        var i = function() {
          t(), a.removeEventListener("DOMContentLoaded", i);
        };
        a.addEventListener("DOMContentLoaded", i), e._reactRetry = i;
      }
    }
    function gl(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === 1 || t === 3) break;
        if (t === 8) {
          if (t = e.data, t === Kg || t === km || t === Ms || t === Ad || t === Td || t === GS || t === JT)
            break;
          if (t === kg || t === N1)
            return null;
        }
      }
      return e;
    }
    function Dv(e) {
      if (e.nodeType === 1) {
        for (var t = e.nodeName.toLowerCase(), a = {}, i = e.attributes, c = 0; c < i.length; c++) {
          var s = i[c];
          a[qi(s.name)] = s.name.toLowerCase() === "style" ? _o(e) : s.value;
        }
        return { type: t, props: a };
      }
      return e.nodeType === 8 ? e.data === Td ? { type: "Activity", props: {} } : { type: "Suspense", props: {} } : e.nodeValue;
    }
    function Rv(e, t, a) {
      return a === null || a[YR] !== !0 ? (e.nodeValue === t ? e = null : (t = gu(t), e = gu(e.nodeValue) === t ? null : e.nodeValue), e) : null;
    }
    function Wr(e) {
      e = e.nextSibling;
      for (var t = 0; e; ) {
        if (e.nodeType === 8) {
          var a = e.data;
          if (a === kg || a === N1) {
            if (t === 0)
              return gl(e.nextSibling);
            t--;
          } else
            a !== Kg && a !== km && a !== Ms && a !== Ad && a !== Td || t++;
        }
        e = e.nextSibling;
      }
      return null;
    }
    function _c(e) {
      e = e.previousSibling;
      for (var t = 0; e; ) {
        if (e.nodeType === 8) {
          var a = e.data;
          if (a === Kg || a === km || a === Ms || a === Ad || a === Td) {
            if (t === 0) return e;
            t--;
          } else
            a !== kg && a !== N1 || t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    function Hy(e) {
      Mc(e);
    }
    function Ih(e) {
      Mc(e);
    }
    function Ly(e) {
      Mc(e);
    }
    function Yi(e, t, a, i, c) {
      switch (c && Xs(e, i.ancestorInfo), t = Vf(a), e) {
        case "html":
          if (e = t.documentElement, !e)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "head":
          if (e = t.head, !e)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "body":
          if (e = t.body, !e)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function ei(e, t, a, i) {
      if (!a[Qi] && Fl(a)) {
        var c = a.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          c,
          c,
          c
        );
      }
      switch (e) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (c = a.attributes; c.length; )
        a.removeAttributeNode(c[0]);
      an(a, e, t), a[ln] = i, a[Ha] = t;
    }
    function Gi(e) {
      for (var t = e.attributes; t.length; )
        e.removeAttributeNode(t[0]);
      lp(e);
    }
    function Ph(e) {
      return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
    }
    function By(e, t, a) {
      var i = Fm;
      if (i && typeof t == "string" && t) {
        var c = qt(t);
        c = 'link[rel="' + e + '"][href="' + c + '"]', typeof a == "string" && (c += '[crossorigin="' + a + '"]'), PT.has(c) || (PT.add(c), e = { rel: e, crossOrigin: a, href: t }, i.querySelector(c) === null && (t = i.createElement("link"), an(t, "link", e), vn(t), i.head.appendChild(t)));
      }
    }
    function jy(e, t, a, i) {
      var c = (c = vl.current) ? Ph(c) : null;
      if (!c)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (e) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof a.precedence == "string" && typeof a.href == "string" ? (a = Uc(a.href), t = _l(c).hoistableStyles, i = t.get(a), i || (i = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, t.set(a, i)), i) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (a.rel === "stylesheet" && typeof a.href == "string" && typeof a.precedence == "string") {
            e = Uc(a.href);
            var s = _l(c).hoistableStyles, y = s.get(e);
            if (!y && (c = c.ownerDocument || c, y = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: Dd, preload: null }
            }, s.set(e, y), (s = c.querySelector(
              Qf(e)
            )) && !s._p && (y.instance = s, y.state.loading = Fg | pi), !yi.has(e))) {
              var b = {
                rel: "preload",
                as: "style",
                href: a.href,
                crossOrigin: a.crossOrigin,
                integrity: a.integrity,
                media: a.media,
                hrefLang: a.hrefLang,
                referrerPolicy: a.referrerPolicy
              };
              yi.set(e, b), s || Cv(
                c,
                e,
                b,
                y.state
              );
            }
            if (t && i === null)
              throw a = `

  - ` + Xf(t) + `
  + ` + Xf(a), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + a
              );
            return y;
          }
          if (t && i !== null)
            throw a = `

  - ` + Xf(t) + `
  + ` + Xf(a), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + a
            );
          return null;
        case "script":
          return t = a.async, a = a.src, typeof a == "string" && t && typeof t != "function" && typeof t != "symbol" ? (a = wc(a), t = _l(c).hoistableScripts, i = t.get(a), i || (i = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, t.set(a, i)), i) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + e + '". this is a bug in React.'
          );
      }
    }
    function Xf(e) {
      var t = 0, a = "<link";
      return typeof e.rel == "string" ? (t++, a += ' rel="' + e.rel + '"') : bl.call(e, "rel") && (t++, a += ' rel="' + (e.rel === null ? "null" : "invalid type " + typeof e.rel) + '"'), typeof e.href == "string" ? (t++, a += ' href="' + e.href + '"') : bl.call(e, "href") && (t++, a += ' href="' + (e.href === null ? "null" : "invalid type " + typeof e.href) + '"'), typeof e.precedence == "string" ? (t++, a += ' precedence="' + e.precedence + '"') : bl.call(e, "precedence") && (t++, a += " precedence={" + (e.precedence === null ? "null" : "invalid type " + typeof e.precedence) + "}"), Object.getOwnPropertyNames(e).length > t && (a += " ..."), a + " />";
    }
    function Uc(e) {
      return 'href="' + qt(e) + '"';
    }
    function Qf(e) {
      return 'link[rel="stylesheet"][' + e + "]";
    }
    function em(e) {
      return ut({}, e, {
        "data-precedence": e.precedence,
        precedence: null
      });
    }
    function Cv(e, t, a, i) {
      e.querySelector(
        'link[rel="preload"][as="style"][' + t + "]"
      ) ? i.loading = Fg : (t = e.createElement("link"), i.preload = t, t.addEventListener("load", function() {
        return i.loading |= Fg;
      }), t.addEventListener("error", function() {
        return i.loading |= WT;
      }), an(t, "link", a), vn(t), e.head.appendChild(t));
    }
    function wc(e) {
      return '[src="' + qt(e) + '"]';
    }
    function Zf(e) {
      return "script[async]" + e;
    }
    function tm(e, t, a) {
      if (t.count++, t.instance === null)
        switch (t.type) {
          case "style":
            var i = e.querySelector(
              'style[data-href~="' + qt(a.href) + '"]'
            );
            if (i)
              return t.instance = i, vn(i), i;
            var c = ut({}, a, {
              "data-href": a.href,
              "data-precedence": a.precedence,
              href: null,
              precedence: null
            });
            return i = (e.ownerDocument || e).createElement("style"), vn(i), an(i, "style", c), Ir(i, a.precedence, e), t.instance = i;
          case "stylesheet":
            c = Uc(a.href);
            var s = e.querySelector(
              Qf(c)
            );
            if (s)
              return t.state.loading |= pi, t.instance = s, vn(s), s;
            i = em(a), (c = yi.get(c)) && qy(i, c), s = (e.ownerDocument || e).createElement("link"), vn(s);
            var y = s;
            return y._p = new Promise(function(b, A) {
              y.onload = b, y.onerror = A;
            }), an(s, "link", i), t.state.loading |= pi, Ir(s, a.precedence, e), t.instance = s;
          case "script":
            return s = wc(a.src), (c = e.querySelector(
              Zf(s)
            )) ? (t.instance = c, vn(c), c) : (i = a, (c = yi.get(s)) && (i = ut({}, a), Vy(i, c)), e = e.ownerDocument || e, c = e.createElement("script"), vn(c), an(c, "link", i), e.head.appendChild(c), t.instance = c);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + t.type + '". this is a bug in React.'
            );
        }
      else
        t.type === "stylesheet" && (t.state.loading & pi) === Dd && (i = t.instance, t.state.loading |= pi, Ir(i, a.precedence, e));
      return t.instance;
    }
    function Ir(e, t, a) {
      for (var i = a.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), c = i.length ? i[i.length - 1] : null, s = c, y = 0; y < i.length; y++) {
        var b = i[y];
        if (b.dataset.precedence === t) s = b;
        else if (s !== c) break;
      }
      s ? s.parentNode.insertBefore(e, s.nextSibling) : (t = a.nodeType === 9 ? a.head : a, t.insertBefore(e, t.firstChild));
    }
    function qy(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
    }
    function Vy(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
    }
    function Pr(e, t, a) {
      if (H1 === null) {
        var i = /* @__PURE__ */ new Map(), c = H1 = /* @__PURE__ */ new Map();
        c.set(a, i);
      } else
        c = H1, i = c.get(a), i || (i = /* @__PURE__ */ new Map(), c.set(a, i));
      if (i.has(e)) return i;
      for (i.set(e, null), a = a.getElementsByTagName(e), c = 0; c < a.length; c++) {
        var s = a[c];
        if (!(s[fs] || s[ln] || e === "link" && s.getAttribute("rel") === "stylesheet") && s.namespaceURI !== at) {
          var y = s.getAttribute(t) || "";
          y = e + y;
          var b = i.get(y);
          b ? b.push(s) : i.set(y, [s]);
        }
      }
      return i;
    }
    function zv(e, t, a) {
      e = e.ownerDocument || e, e.head.insertBefore(
        a,
        t === "title" ? e.querySelector("head > title") : null
      );
    }
    function _v(e, t, a) {
      var i = !a.ancestorInfo.containerTagInScope;
      if (a.context === $m || t.itemProp != null)
        return !i || t.itemProp == null || e !== "meta" && e !== "title" && e !== "style" && e !== "link" && e !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          e,
          e
        ), !1;
      switch (e) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") {
            i && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) {
            if (t.rel === "stylesheet" && typeof t.precedence == "string") {
              e = t.href;
              var c = t.onError, s = t.disabled;
              a = [], t.onLoad && a.push("`onLoad`"), c && a.push("`onError`"), s != null && a.push("`disabled`"), c = ov(a, "and"), c += a.length === 1 ? " prop" : " props", s = a.length === 1 ? "an " + c : "the " + c, a.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                e,
                s,
                c
              );
            }
            i && (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (t.onError || t.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (t.rel) {
            case "stylesheet":
              return e = t.precedence, t = t.disabled, typeof e != "string" && i && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof e == "string" && t == null;
            default:
              return !0;
          }
        case "script":
          if (e = t.async && typeof t.async != "function" && typeof t.async != "symbol", !e || t.onLoad || t.onError || !t.src || typeof t.src != "string") {
            i && (e ? t.onLoad || t.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          i && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            e
          );
      }
      return !1;
    }
    function dt(e) {
      return !(e.type === "stylesheet" && (e.state.loading & IT) === Dd);
    }
    function Yy(e, t, a, i) {
      if (a.type === "stylesheet" && (typeof i.media != "string" || matchMedia(i.media).matches !== !1) && (a.state.loading & pi) === Dd) {
        if (a.instance === null) {
          var c = Uc(i.href), s = t.querySelector(
            Qf(c)
          );
          if (s) {
            t = s._p, t !== null && typeof t == "object" && typeof t.then == "function" && (e.count++, e = es.bind(e), t.then(e, e)), a.state.loading |= pi, a.instance = s, vn(s);
            return;
          }
          s = t.ownerDocument || t, i = em(i), (c = yi.get(c)) && qy(i, c), s = s.createElement("link"), vn(s);
          var y = s;
          y._p = new Promise(function(b, A) {
            y.onload = b, y.onerror = A;
          }), an(s, "link", i), a.instance = s;
        }
        e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(a, t), (t = a.state.preload) && (a.state.loading & IT) === Dd && (e.count++, a = es.bind(e), t.addEventListener("load", a), t.addEventListener("error", a));
      }
    }
    function nm(e, t) {
      return e.stylesheets && e.count === 0 && Jf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(a) {
        var i = setTimeout(function() {
          if (e.stylesheets && Jf(e, e.stylesheets), e.unsuspend) {
            var s = e.unsuspend;
            e.unsuspend = null, s();
          }
        }, kR + t);
        0 < e.imgBytes && KS === 0 && (KS = 125 * cv() * FR);
        var c = setTimeout(
          function() {
            if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Jf(e, e.stylesheets), e.unsuspend)) {
              var s = e.unsuspend;
              e.unsuspend = null, s();
            }
          },
          (e.imgBytes > KS ? 50 : $R) + t
        );
        return e.unsuspend = a, function() {
          e.unsuspend = null, clearTimeout(i), clearTimeout(c);
        };
      } : null;
    }
    function es() {
      if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
        if (this.stylesheets)
          Jf(this, this.stylesheets);
        else if (this.unsuspend) {
          var e = this.unsuspend;
          this.unsuspend = null, e();
        }
      }
    }
    function Jf(e, t) {
      e.stylesheets = null, e.unsuspend !== null && (e.count++, L1 = /* @__PURE__ */ new Map(), t.forEach(Gy, e), L1 = null, es.call(e));
    }
    function Gy(e, t) {
      if (!(t.state.loading & pi)) {
        var a = L1.get(e);
        if (a) var i = a.get(kS);
        else {
          a = /* @__PURE__ */ new Map(), L1.set(e, a);
          for (var c = e.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), s = 0; s < c.length; s++) {
            var y = c[s];
            (y.nodeName === "LINK" || y.getAttribute("media") !== "not all") && (a.set(y.dataset.precedence, y), i = y);
          }
          i && a.set(kS, i);
        }
        c = t.instance, y = c.getAttribute("data-precedence"), s = a.get(y) || i, s === i && a.set(kS, c), a.set(y, c), this.count++, i = es.bind(this), c.addEventListener("load", i), c.addEventListener("error", i), s ? s.parentNode.insertBefore(c, s.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(c, e.firstChild)), t.state.loading |= pi;
      }
    }
    function Kf(e, t, a, i, c, s, y, b, A) {
      for (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = Od, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = St(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = St(0), this.hiddenUpdates = St(null), this.identifierPrefix = i, this.onUncaughtError = c, this.onCaughtError = s, this.onRecoverableError = y, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = A, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), e = this.pendingUpdatersLaneMap = [], t = 0; 31 > t; t++) e.push(/* @__PURE__ */ new Set());
      this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
    }
    function kf(e, t, a, i, c, s, y, b, A, D, j, V) {
      return e = new Kf(
        e,
        t,
        a,
        y,
        A,
        D,
        j,
        V,
        b
      ), t = SR, s === !0 && (t |= $a | Zi), t |= it, s = L(3, null, null, t), e.current = s, s.stateNode = e, t = th(), ic(t), e.pooledCache = t, ic(t), s.memoizedState = {
        element: i,
        isDehydrated: a,
        cache: t
      }, ht(s), e;
    }
    function Uv(e) {
      return e ? (e = gs, e) : gs;
    }
    function am(e, t, a, i, c, s) {
      if (Ln && typeof Ln.onScheduleFiberRoot == "function")
        try {
          Ln.onScheduleFiberRoot(Lc, i, a);
        } catch (y) {
          ni || (ni = !0, console.error(
            "React instrumentation encountered an error: %o",
            y
          ));
        }
      c = Uv(c), i.context === null ? i.context = c : i.pendingContext = c, ti && ka !== null && !aA && (aA = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        ae(ka) || "Unknown"
      )), i = Nn(t), i.payload = { element: a }, s = s === void 0 ? null : s, s !== null && (typeof s != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        s
      ), i.callback = s), a = Bu(e, i, t), a !== null && (xu(t, "root.render()", null), Ze(a, e, t), Bl(a, e, t));
    }
    function wv(e, t) {
      if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
        var a = e.retryLane;
        e.retryLane = a !== 0 && a < t ? a : t;
      }
    }
    function Xy(e, t) {
      wv(e, t), (e = e.alternate) && wv(e, t);
    }
    function Qy(e) {
      if (e.tag === 13 || e.tag === 31) {
        var t = ra(e, 67108864);
        t !== null && Ze(t, e, 67108864), Xy(e, 67108864);
      }
    }
    function Zy(e) {
      if (e.tag === 13 || e.tag === 31) {
        var t = fa(e);
        t = Qo(t);
        var a = ra(e, t);
        a !== null && Ze(a, e, t), Xy(e, t);
      }
    }
    function Gt() {
      return ka;
    }
    function Jy(e, t, a, i) {
      var c = I.T;
      I.T = null;
      var s = _t.p;
      try {
        _t.p = Bn, Ky(e, t, a, i);
      } finally {
        _t.p = s, I.T = c;
      }
    }
    function la(e, t, a, i) {
      var c = I.T;
      I.T = null;
      var s = _t.p;
      try {
        _t.p = ia, Ky(e, t, a, i);
      } finally {
        _t.p = s, I.T = c;
      }
    }
    function Ky(e, t, a, i) {
      if (j1) {
        var c = lm(i);
        if (c === null)
          pu(
            e,
            t,
            i,
            q1,
            a
          ), im(e, i);
        else if (Mv(
          c,
          e,
          t,
          a,
          i
        ))
          i.stopPropagation();
        else if (im(e, i), t & 4 && -1 < IR.indexOf(e)) {
          for (; c !== null; ) {
            var s = Fl(c);
            if (s !== null)
              switch (s.tag) {
                case 3:
                  if (s = s.stateNode, s.current.memoizedState.isDehydrated) {
                    var y = oe(s.pendingLanes);
                    if (y !== 0) {
                      var b = s;
                      for (b.pendingLanes |= 2, b.entangledLanes |= 2; y; ) {
                        var A = 1 << 31 - ua(y);
                        b.entanglements[1] |= A, y &= ~A;
                      }
                      Qa(s), (Tt & (ca | Du)) === ya && (E1 = kn() + wT, Fu(0));
                    }
                  }
                  break;
                case 31:
                case 13:
                  b = ra(s, 2), b !== null && Ze(b, s, 2), yl(), Xy(s, 2);
              }
            if (s = lm(i), s === null && pu(
              e,
              t,
              i,
              q1,
              a
            ), s === c) break;
            c = s;
          }
          c !== null && i.stopPropagation();
        } else
          pu(
            e,
            t,
            i,
            null,
            a
          );
      }
    }
    function lm(e) {
      return e = Pl(e), ky(e);
    }
    function ky(e) {
      if (q1 = null, e = Ei(e), e !== null) {
        var t = F(e);
        if (t === null) e = null;
        else {
          var a = t.tag;
          if (a === 13) {
            if (e = ne(t), e !== null) return e;
            e = null;
          } else if (a === 31) {
            if (e = ye(t), e !== null) return e;
            e = null;
          } else if (a === 3) {
            if (t.stateNode.current.memoizedState.isDehydrated)
              return t.tag === 3 ? t.stateNode.containerInfo : null;
            e = null;
          } else t !== e && (e = null);
        }
      }
      return q1 = e, null;
    }
    function um(e) {
      switch (e) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Bn;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return ia;
        case "message":
          switch (ed()) {
            case lg:
              return Bn;
            case pm:
              return ia;
            case Hc:
            case jv:
              return ha;
            case ym:
              return Ho;
            default:
              return ha;
          }
        default:
          return ha;
      }
    }
    function im(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Ns = null;
          break;
        case "dragenter":
        case "dragleave":
          xs = null;
          break;
        case "mouseover":
        case "mouseout":
          Hs = null;
          break;
        case "pointerover":
        case "pointerout":
          Ig.delete(t.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          Pg.delete(t.pointerId);
      }
    }
    function wo(e, t, a, i, c, s) {
      return e === null || e.nativeEvent !== s ? (e = {
        blockedOn: t,
        domEventName: a,
        eventSystemFlags: i,
        nativeEvent: s,
        targetContainers: [c]
      }, t !== null && (t = Fl(t), t !== null && Qy(t)), e) : (e.eventSystemFlags |= i, t = e.targetContainers, c !== null && t.indexOf(c) === -1 && t.push(c), e);
    }
    function Mv(e, t, a, i, c) {
      switch (t) {
        case "focusin":
          return Ns = wo(
            Ns,
            e,
            t,
            a,
            i,
            c
          ), !0;
        case "dragenter":
          return xs = wo(
            xs,
            e,
            t,
            a,
            i,
            c
          ), !0;
        case "mouseover":
          return Hs = wo(
            Hs,
            e,
            t,
            a,
            i,
            c
          ), !0;
        case "pointerover":
          var s = c.pointerId;
          return Ig.set(
            s,
            wo(
              Ig.get(s) || null,
              e,
              t,
              a,
              i,
              c
            )
          ), !0;
        case "gotpointercapture":
          return s = c.pointerId, Pg.set(
            s,
            wo(
              Pg.get(s) || null,
              e,
              t,
              a,
              i,
              c
            )
          ), !0;
      }
      return !1;
    }
    function $y(e) {
      var t = Ei(e.target);
      if (t !== null) {
        var a = F(t);
        if (a !== null) {
          if (t = a.tag, t === 13) {
            if (t = ne(a), t !== null) {
              e.blockedOn = t, b0(e.priority, function() {
                Zy(a);
              });
              return;
            }
          } else if (t === 31) {
            if (t = ye(a), t !== null) {
              e.blockedOn = t, b0(e.priority, function() {
                Zy(a);
              });
              return;
            }
          } else if (t === 3 && a.stateNode.current.memoizedState.isDehydrated) {
            e.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
            return;
          }
        }
      }
      e.blockedOn = null;
    }
    function ts(e) {
      if (e.blockedOn !== null) return !1;
      for (var t = e.targetContainers; 0 < t.length; ) {
        var a = lm(e.nativeEvent);
        if (a === null) {
          a = e.nativeEvent;
          var i = new a.constructor(
            a.type,
            a
          ), c = i;
          rg !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), rg = c, a.target.dispatchEvent(i), rg === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), rg = null;
        } else
          return t = Fl(a), t !== null && Qy(t), e.blockedOn = a, !1;
        t.shift();
      }
      return !0;
    }
    function om(e, t, a) {
      ts(e) && a.delete(t);
    }
    function Hb() {
      $S = !1, Ns !== null && ts(Ns) && (Ns = null), xs !== null && ts(xs) && (xs = null), Hs !== null && ts(Hs) && (Hs = null), Ig.forEach(om), Pg.forEach(om);
    }
    function $f(e, t) {
      e.blockedOn === t && (e.blockedOn = null, $S || ($S = !0, An.unstable_scheduleCallback(
        An.unstable_NormalPriority,
        Hb
      )));
    }
    function Nv(e) {
      V1 !== e && (V1 = e, An.unstable_scheduleCallback(
        An.unstable_NormalPriority,
        function() {
          V1 === e && (V1 = null);
          for (var t = 0; t < e.length; t += 3) {
            var a = e[t], i = e[t + 1], c = e[t + 2];
            if (typeof i != "function") {
              if (ky(i || a) === null)
                continue;
              break;
            }
            var s = Fl(a);
            s !== null && (e.splice(t, 3), t -= 3, a = {
              pending: !0,
              data: c,
              method: a.method,
              action: i
            }, Object.freeze(a), xi(
              s,
              a,
              i,
              c
            ));
          }
        }
      ));
    }
    function Mc(e) {
      function t(A) {
        return $f(A, e);
      }
      Ns !== null && $f(Ns, e), xs !== null && $f(xs, e), Hs !== null && $f(Hs, e), Ig.forEach(t), Pg.forEach(t);
      for (var a = 0; a < Ls.length; a++) {
        var i = Ls[a];
        i.blockedOn === e && (i.blockedOn = null);
      }
      for (; 0 < Ls.length && (a = Ls[0], a.blockedOn === null); )
        $y(a), a.blockedOn === null && Ls.shift();
      if (a = (e.ownerDocument || e).$$reactFormReplay, a != null)
        for (i = 0; i < a.length; i += 3) {
          var c = a[i], s = a[i + 1], y = c[Ha] || null;
          if (typeof s == "function")
            y || Nv(a);
          else if (y) {
            var b = null;
            if (s && s.hasAttribute("formAction")) {
              if (c = s, y = s[Ha] || null)
                b = y.formAction;
              else if (ky(c) !== null) continue;
            } else b = y.action;
            typeof b == "function" ? a[i + 1] = b : (a.splice(i, 3), i -= 3), Nv(a);
          }
        }
    }
    function xv() {
      function e(s) {
        s.canIntercept && s.info === "react-transition" && s.intercept({
          handler: function() {
            return new Promise(function(y) {
              return c = y;
            });
          },
          focusReset: "manual",
          scroll: "manual"
        });
      }
      function t() {
        c !== null && (c(), c = null), i || setTimeout(a, 20);
      }
      function a() {
        if (!i && !navigation.transition) {
          var s = navigation.currentEntry;
          s && s.url != null && navigation.navigate(s.url, {
            state: s.getState(),
            info: "react-transition",
            history: "replace"
          });
        }
      }
      if (typeof navigation == "object") {
        var i = !1, c = null;
        return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(a, 100), function() {
          i = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener(
            "navigatesuccess",
            t
          ), navigation.removeEventListener(
            "navigateerror",
            t
          ), c !== null && (c(), c = null);
        };
      }
    }
    function Fy(e) {
      this._internalRoot = e;
    }
    function vu(e) {
      this._internalRoot = e;
    }
    function Wy(e) {
      e[Qi] && (e._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var An = UD(), Ff = ar, Lb = xO, ut = Object.assign, Hv = Symbol.for("react.element"), Yl = Symbol.for("react.transitional.element"), Mo = Symbol.for("react.portal"), ns = Symbol.for("react.fragment"), xa = Symbol.for("react.strict_mode"), Wf = Symbol.for("react.profiler"), cm = Symbol.for("react.consumer"), bu = Symbol.for("react.context"), as = Symbol.for("react.forward_ref"), Nc = Symbol.for("react.suspense"), Ka = Symbol.for("react.suspense_list"), If = Symbol.for("react.memo"), da = Symbol.for("react.lazy"), Su = Symbol.for("react.activity"), Bb = Symbol.for("react.memo_cache_sentinel"), Lv = Symbol.iterator, ls = Symbol.for("react.client.reference"), _n = Array.isArray, I = Ff.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, _t = Lb.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, jb = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), Iy = [], Py = [], Xi = -1, No = Me(null), us = Me(null), vl = Me(null), xo = Me(null), is = 0, Bv, xc, os, eg, Pf, rm, sm;
    Be.__reactDisabledLog = !0;
    var cs, tg, fm = !1, ng = new (typeof WeakMap == "function" ? WeakMap : Map)(), ka = null, ti = !1, bl = Object.prototype.hasOwnProperty, ag = An.unstable_scheduleCallback, dm = An.unstable_cancelCallback, hm = An.unstable_shouldYield, mm = An.unstable_requestPaint, kn = An.unstable_now, ed = An.unstable_getCurrentPriorityLevel, lg = An.unstable_ImmediatePriority, pm = An.unstable_UserBlockingPriority, Hc = An.unstable_NormalPriority, jv = An.unstable_LowPriority, ym = An.unstable_IdlePriority, ug = An.log, qv = An.unstable_setDisableYieldValue, Lc = null, Ln = null, ni = !1, ai = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", ua = Math.clz32 ? Math.clz32 : de, ig = Math.log, gm = Math.LN2, rs = 256, td = 262144, ss = 4194304, Bn = 2, ia = 8, ha = 32, Ho = 268435456, Gl = Math.random().toString(36).slice(2), ln = "__reactFiber$" + Gl, Ha = "__reactProps$" + Gl, Qi = "__reactContainer$" + Gl, Bc = "__reactEvents$" + Gl, qb = "__reactListeners$" + Gl, Vv = "__reactHandles$" + Gl, nd = "__reactResources$" + Gl, fs = "__reactMarker$" + Gl, Yv = /* @__PURE__ */ new Set(), li = {}, ds = {}, Gv = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, hs = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), og = {}, vm = {}, bm = /[\n"\\]/g, cg = !1, Xv = !1, ad = !1, n = !1, l = !1, u = !1, o = ["value", "defaultValue"], d = !1, p = /["'&<>\n\t]|^\s|\s$/, T = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), C = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), x = C.concat(["button"]), K = "dd dt li option optgroup p rp rt".split(" "), le = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, re = {}, k = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, P = /([A-Z])/g, Ue = /^ms-/, Ye = /^(?:webkit|moz|o)[A-Z]/, Xt = /^-ms-/, X = /-(.)/g, q = /;\s*$/, J = {}, ce = {}, je = !1, Et = !1, Ne = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), Ie = "http://www.w3.org/1998/Math/MathML", at = "http://www.w3.org/2000/svg", Dt = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Eu = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Qv = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0,
      "aria-braillelabel": 0,
      "aria-brailleroledescription": 0,
      "aria-colindextext": 0,
      "aria-rowindextext": 0
    }, Sm = {}, MD = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), ND = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), u2 = !1, Sl = {}, i2 = /^on./, xD = /^on[^A-Z]/, HD = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), LD = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), BD = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, rg = null, Em = null, Tm = null, Vb = !1, Lo = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Yb = !1;
    if (Lo)
      try {
        var sg = {};
        Object.defineProperty(sg, "passive", {
          get: function() {
            Yb = !0;
          }
        }), window.addEventListener("test", sg, sg), window.removeEventListener("test", sg, sg);
      } catch {
        Yb = !1;
      }
    var ms = null, Gb = null, Zv = null, ld = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Jv = Yn(ld), fg = ut({}, ld, { view: 0, detail: 0 }), jD = Yn(fg), Xb, Qb, dg, Kv = ut({}, fg, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Ks,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (e !== dg && (dg && e.type === "mousemove" ? (Xb = e.screenX - dg.screenX, Qb = e.screenY - dg.screenY) : Qb = Xb = 0, dg = e), Xb);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : Qb;
      }
    }), o2 = Yn(Kv), qD = ut({}, Kv, { dataTransfer: 0 }), VD = Yn(qD), YD = ut({}, fg, { relatedTarget: 0 }), Zb = Yn(YD), GD = ut({}, ld, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), XD = Yn(GD), QD = ut({}, ld, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), ZD = Yn(QD), JD = ut({}, ld, { data: 0 }), c2 = Yn(
      JD
    ), KD = c2, kD = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, $D = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, FD = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, WD = ut({}, fg, {
      key: function(e) {
        if (e.key) {
          var t = kD[e.key] || e.key;
          if (t !== "Unidentified") return t;
        }
        return e.type === "keypress" ? (e = Js(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? $D[e.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Ks,
      charCode: function(e) {
        return e.type === "keypress" ? Js(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Js(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), ID = Yn(WD), PD = ut({}, Kv, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), r2 = Yn(PD), eR = ut({}, fg, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Ks
    }), tR = Yn(eR), nR = ut({}, ld, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), aR = Yn(nR), lR = ut({}, Kv, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), uR = Yn(lR), iR = ut({}, ld, {
      newState: 0,
      oldState: 0
    }), oR = Yn(iR), cR = [9, 13, 27, 32], s2 = 229, Jb = Lo && "CompositionEvent" in window, hg = null;
    Lo && "documentMode" in document && (hg = document.documentMode);
    var rR = Lo && "TextEvent" in window && !hg, f2 = Lo && (!Jb || hg && 8 < hg && 11 >= hg), d2 = 32, h2 = String.fromCharCode(d2), m2 = !1, Am = !1, sR = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, mg = null, pg = null, p2 = !1;
    Lo && (p2 = Qd("input") && (!document.documentMode || 9 < document.documentMode));
    var El = typeof Object.is == "function" ? Object.is : Zd, fR = Lo && "documentMode" in document && 11 >= document.documentMode, Om = null, Kb = null, yg = null, kb = !1, Dm = {
      animationend: Io("Animation", "AnimationEnd"),
      animationiteration: Io("Animation", "AnimationIteration"),
      animationstart: Io("Animation", "AnimationStart"),
      transitionrun: Io("Transition", "TransitionRun"),
      transitionstart: Io("Transition", "TransitionStart"),
      transitioncancel: Io("Transition", "TransitionCancel"),
      transitionend: Io("Transition", "TransitionEnd")
    }, $b = {}, y2 = {};
    Lo && (y2 = document.createElement("div").style, "AnimationEvent" in window || (delete Dm.animationend.animation, delete Dm.animationiteration.animation, delete Dm.animationstart.animation), "TransitionEvent" in window || delete Dm.transitionend.transition);
    var g2 = Po("animationend"), v2 = Po("animationiteration"), b2 = Po("animationstart"), dR = Po("transitionrun"), hR = Po("transitionstart"), mR = Po("transitioncancel"), S2 = Po("transitionend"), E2 = /* @__PURE__ */ new Map(), Fb = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    Fb.push("scrollEnd");
    var T2 = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var pR = performance, A2 = function() {
        return pR.now();
      };
    else {
      var yR = Date;
      A2 = function() {
        return yR.now();
      };
    }
    var Wb = typeof reportError == "function" ? reportError : function(e) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var t = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
          error: e
        });
        if (!window.dispatchEvent(t)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", e);
        return;
      }
      console.error(e);
    }, gR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", kv = 0, Ib = 1, Pb = 2, eS = 3, $v = "– ", Fv = "+ ", O2 = "  ", un = typeof console < "u" && typeof console.timeStamp == "function" && typeof performance < "u" && typeof performance.measure == "function", ui = "Components ⚛", yt = "Scheduler ⚛", bt = "Blocking", ps = !1, jc = {
      color: "primary",
      properties: null,
      tooltipText: "",
      track: ui
    }, ys = {
      start: -0,
      end: -0,
      detail: { devtools: jc }
    }, vR = ["Changed Props", ""], D2 = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", bR = ["Changed Props", D2], gg = 1, qc = 2, ii = [], Rm = 0, tS = 0, gs = {};
    Object.freeze(gs);
    var oi = null, Cm = null, Qe = 0, SR = 1, it = 2, $a = 8, Zi = 16, ER = 32, R2 = !1;
    try {
      var C2 = Object.preventExtensions({});
    } catch {
      R2 = !0;
    }
    var nS = /* @__PURE__ */ new WeakMap(), zm = [], _m = 0, Wv = null, vg = 0, ci = [], ri = 0, ud = null, Vc = 1, Yc = "", La = null, on = null, pt = !1, Bo = !1, Tu = null, vs = null, si = !1, aS = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), lS = Me(null), uS = Me(null), z2 = {}, Iv = null, Um = null, wm = !1, TR = typeof AbortController < "u" ? AbortController : function() {
      var e = [], t = this.signal = {
        aborted: !1,
        addEventListener: function(a, i) {
          e.push(i);
        }
      };
      this.abort = function() {
        t.aborted = !0, e.forEach(function(a) {
          return a();
        });
      };
    }, AR = An.unstable_scheduleCallback, OR = An.unstable_NormalPriority, $n = {
      $$typeof: bu,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, Fn = An.unstable_now, Pv = console.createTask ? console.createTask : function() {
      return null;
    }, bg = 1, e1 = 2, ma = -0, bs = -0, Gc = -0, Xc = null, Tl = -1.1, id = -0, yn = -0, Ve = -1.1, Ge = -1.1, dn = null, On = !1, od = -0, jo = -1.1, Sg = null, Ss = 0, iS = null, oS = null, cd = -1.1, Eg = null, Mm = -1.1, t1 = -1.1, Qc = -0, Zc = -1.1, fi = -1.1, cS = 0, Tg = null, _2 = null, U2 = null, Es = -1.1, rd = null, Ts = -1.1, n1 = -1.1, w2 = -0, M2 = -0, a1 = 0, DR = null, N2 = 0, Ag = -1.1, l1 = !1, u1 = !1, Og = null, rS = 0, sd = 0, Nm = null, x2 = I.S;
    I.S = function(e, t) {
      if (_T = kn(), typeof t == "object" && t !== null && typeof t.then == "function") {
        if (0 > Zc && 0 > fi) {
          Zc = Fn();
          var a = $r(), i = Pu();
          (a !== Ts || i !== rd) && (Ts = -1.1), Es = a, rd = i;
        }
        Ci(e, t);
      }
      x2 !== null && x2(e, t);
    };
    var fd = Me(null), Ji = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, Dg = [], Rg = [], Cg = [], zg = [], _g = [], Ug = [], dd = /* @__PURE__ */ new Set();
    Ji.recordUnsafeLifecycleWarnings = function(e, t) {
      dd.has(e.type) || (typeof t.componentWillMount == "function" && t.componentWillMount.__suppressDeprecationWarning !== !0 && Dg.push(e), e.mode & $a && typeof t.UNSAFE_componentWillMount == "function" && Rg.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Cg.push(e), e.mode & $a && typeof t.UNSAFE_componentWillReceiveProps == "function" && zg.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && _g.push(e), e.mode & $a && typeof t.UNSAFE_componentWillUpdate == "function" && Ug.push(e));
    }, Ji.flushPendingUnsafeLifecycleWarnings = function() {
      var e = /* @__PURE__ */ new Set();
      0 < Dg.length && (Dg.forEach(function(b) {
        e.add(
          ae(b) || "Component"
        ), dd.add(b.type);
      }), Dg = []);
      var t = /* @__PURE__ */ new Set();
      0 < Rg.length && (Rg.forEach(function(b) {
        t.add(
          ae(b) || "Component"
        ), dd.add(b.type);
      }), Rg = []);
      var a = /* @__PURE__ */ new Set();
      0 < Cg.length && (Cg.forEach(function(b) {
        a.add(
          ae(b) || "Component"
        ), dd.add(b.type);
      }), Cg = []);
      var i = /* @__PURE__ */ new Set();
      0 < zg.length && (zg.forEach(
        function(b) {
          i.add(
            ae(b) || "Component"
          ), dd.add(b.type);
        }
      ), zg = []);
      var c = /* @__PURE__ */ new Set();
      0 < _g.length && (_g.forEach(function(b) {
        c.add(
          ae(b) || "Component"
        ), dd.add(b.type);
      }), _g = []);
      var s = /* @__PURE__ */ new Set();
      if (0 < Ug.length && (Ug.forEach(function(b) {
        s.add(
          ae(b) || "Component"
        ), dd.add(b.type);
      }), Ug = []), 0 < t.size) {
        var y = z(
          t
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          y
        );
      }
      0 < i.size && (y = z(
        i
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        y
      )), 0 < s.size && (y = z(
        s
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        y
      )), 0 < e.size && (y = z(e), console.warn(
        `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        y
      )), 0 < a.size && (y = z(
        a
      ), console.warn(
        `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        y
      )), 0 < c.size && (y = z(c), console.warn(
        `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
        y
      ));
    };
    var i1 = /* @__PURE__ */ new Map(), H2 = /* @__PURE__ */ new Set();
    Ji.recordLegacyContextWarning = function(e, t) {
      for (var a = null, i = e; i !== null; )
        i.mode & $a && (a = i), i = i.return;
      a === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !H2.has(e.type) && (i = i1.get(a), e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], i1.set(a, i)), i.push(e));
    }, Ji.flushLegacyContextWarning = function() {
      i1.forEach(function(e) {
        if (e.length !== 0) {
          var t = e[0], a = /* @__PURE__ */ new Set();
          e.forEach(function(c) {
            a.add(ae(c) || "Component"), H2.add(c.type);
          });
          var i = z(a);
          Ae(t, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              i
            );
          });
        }
      });
    }, Ji.discardPendingWarnings = function() {
      Dg = [], Rg = [], Cg = [], zg = [], _g = [], Ug = [], i1 = /* @__PURE__ */ new Map();
    };
    var L2 = {
      react_stack_bottom_frame: function(e, t, a) {
        var i = ti;
        ti = !0;
        try {
          return e(t, a);
        } finally {
          ti = i;
        }
      }
    }, sS = L2.react_stack_bottom_frame.bind(L2), B2 = {
      react_stack_bottom_frame: function(e) {
        var t = ti;
        ti = !0;
        try {
          return e.render();
        } finally {
          ti = t;
        }
      }
    }, j2 = B2.react_stack_bottom_frame.bind(B2), q2 = {
      react_stack_bottom_frame: function(e, t) {
        try {
          t.componentDidMount();
        } catch (a) {
          nt(e, e.return, a);
        }
      }
    }, fS = q2.react_stack_bottom_frame.bind(
      q2
    ), V2 = {
      react_stack_bottom_frame: function(e, t, a, i, c) {
        try {
          t.componentDidUpdate(a, i, c);
        } catch (s) {
          nt(e, e.return, s);
        }
      }
    }, Y2 = V2.react_stack_bottom_frame.bind(
      V2
    ), G2 = {
      react_stack_bottom_frame: function(e, t) {
        var a = t.stack;
        e.componentDidCatch(t.value, {
          componentStack: a !== null ? a : ""
        });
      }
    }, RR = G2.react_stack_bottom_frame.bind(
      G2
    ), X2 = {
      react_stack_bottom_frame: function(e, t, a) {
        try {
          a.componentWillUnmount();
        } catch (i) {
          nt(e, t, i);
        }
      }
    }, Q2 = X2.react_stack_bottom_frame.bind(
      X2
    ), Z2 = {
      react_stack_bottom_frame: function(e) {
        var t = e.create;
        return e = e.inst, t = t(), e.destroy = t;
      }
    }, CR = Z2.react_stack_bottom_frame.bind(Z2), J2 = {
      react_stack_bottom_frame: function(e, t, a) {
        try {
          a();
        } catch (i) {
          nt(e, t, i);
        }
      }
    }, zR = J2.react_stack_bottom_frame.bind(J2), K2 = {
      react_stack_bottom_frame: function(e) {
        var t = e._init;
        return t(e._payload);
      }
    }, _R = K2.react_stack_bottom_frame.bind(K2), xm = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), dS = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), o1 = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), c1 = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, hd = null, wg = !1, Hm = null, Mg = 0, ot = null, hS, k2 = hS = !1, $2 = {}, F2 = {}, W2 = {};
    _ = function(e, t, a) {
      if (a !== null && typeof a == "object" && a._store && (!a._store.validated && a.key == null || a._store.validated === 2)) {
        if (typeof a._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        a._store.validated = 1;
        var i = ae(e), c = i || "null";
        if (!$2[c]) {
          $2[c] = !0, a = a._owner, e = e._debugOwner;
          var s = "";
          e && typeof e.tag == "number" && (c = ae(e)) && (s = `

Check the render method of \`` + c + "`."), s || i && (s = `

Check the top-level render call using <` + i + ">.");
          var y = "";
          a != null && e !== a && (i = null, typeof a.tag == "number" ? i = ae(a) : typeof a.name == "string" && (i = a.name), i && (y = " It was passed a child from " + i + ".")), Ae(t, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              s,
              y
            );
          });
        }
      }
    };
    var md = Xn(!0), I2 = Xn(!1), P2 = 0, eT = 1, tT = 2, mS = 3, As = !1, nT = !1, pS = null, yS = !1, Lm = Me(null), r1 = Me(0), Au = Me(null), di = null, Bm = 1, Ng = 2, jn = Me(0), s1 = 0, hi = 1, Al = 2, Ou = 4, Ol = 8, jm, aT = /* @__PURE__ */ new Set(), lT = /* @__PURE__ */ new Set(), gS = /* @__PURE__ */ new Set(), uT = /* @__PURE__ */ new Set(), Jc = 0, Ke = null, $t = null, Wn = null, f1 = !1, qm = !1, pd = !1, d1 = 0, xg = 0, Kc = null, UR = 0, wR = 25, W = null, mi = null, kc = -1, Hg = !1, Lg = {
      readContext: Ct,
      use: wi,
      useCallback: mn,
      useContext: mn,
      useEffect: mn,
      useImperativeHandle: mn,
      useLayoutEffect: mn,
      useInsertionEffect: mn,
      useMemo: mn,
      useReducer: mn,
      useRef: mn,
      useState: mn,
      useDebugValue: mn,
      useDeferredValue: mn,
      useTransition: mn,
      useSyncExternalStore: mn,
      useId: mn,
      useHostTransitionStatus: mn,
      useFormState: mn,
      useActionState: mn,
      useOptimistic: mn,
      useMemoCache: mn,
      useCacheRefresh: mn
    };
    Lg.useEffectEvent = mn;
    var vS = null, iT = null, bS = null, oT = null, qo = null, Ki = null, h1 = null;
    vS = {
      readContext: function(e) {
        return Ct(e);
      },
      use: wi,
      useCallback: function(e, t) {
        return W = "useCallback", Je(), Ui(t), dh(e, t);
      },
      useContext: function(e) {
        return W = "useContext", Je(), Ct(e);
      },
      useEffect: function(e, t) {
        return W = "useEffect", Je(), Ui(t), yc(e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", Je(), Ui(a), Yu(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        W = "useInsertionEffect", Je(), Ui(t), So(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", Je(), Ui(t), Ra(e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", Je(), Ui(t);
        var a = I.H;
        I.H = qo;
        try {
          return Ca(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", Je();
        var i = I.H;
        I.H = qo;
        try {
          return Dr(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function(e) {
        return W = "useRef", Je(), fh(e);
      },
      useState: function(e) {
        W = "useState", Je();
        var t = I.H;
        I.H = qo;
        try {
          return yo(e);
        } finally {
          I.H = t;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", Je();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", Je(), Ur(e, t);
      },
      useTransition: function() {
        return W = "useTransition", Je(), Eo();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", Je(), Rr(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", Je(), vf();
      },
      useFormState: function(e, t) {
        return W = "useFormState", Je(), of(), fl(e, t);
      },
      useActionState: function(e, t) {
        return W = "useActionState", Je(), fl(e, t);
      },
      useOptimistic: function(e) {
        return W = "useOptimistic", Je(), pc(e);
      },
      useHostTransitionStatus: Hi,
      useMemoCache: rl,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", Je(), hh();
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", Je(), yf(e);
      }
    }, iT = {
      readContext: function(e) {
        return Ct(e);
      },
      use: wi,
      useCallback: function(e, t) {
        return W = "useCallback", se(), dh(e, t);
      },
      useContext: function(e) {
        return W = "useContext", se(), Ct(e);
      },
      useEffect: function(e, t) {
        return W = "useEffect", se(), yc(e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", se(), Yu(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        W = "useInsertionEffect", se(), So(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", se(), Ra(e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", se();
        var a = I.H;
        I.H = qo;
        try {
          return Ca(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", se();
        var i = I.H;
        I.H = qo;
        try {
          return Dr(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function(e) {
        return W = "useRef", se(), fh(e);
      },
      useState: function(e) {
        W = "useState", se();
        var t = I.H;
        I.H = qo;
        try {
          return yo(e);
        } finally {
          I.H = t;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", se();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", se(), Ur(e, t);
      },
      useTransition: function() {
        return W = "useTransition", se(), Eo();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", se(), Rr(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", se(), vf();
      },
      useActionState: function(e, t) {
        return W = "useActionState", se(), fl(e, t);
      },
      useFormState: function(e, t) {
        return W = "useFormState", se(), of(), fl(e, t);
      },
      useOptimistic: function(e) {
        return W = "useOptimistic", se(), pc(e);
      },
      useHostTransitionStatus: Hi,
      useMemoCache: rl,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", se(), hh();
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", se(), yf(e);
      }
    }, bS = {
      readContext: function(e) {
        return Ct(e);
      },
      use: wi,
      useCallback: function(e, t) {
        return W = "useCallback", se(), su(e, t);
      },
      useContext: function(e) {
        return W = "useContext", se(), Ct(e);
      },
      useEffect: function(e, t) {
        W = "useEffect", se(), xn(2048, Ol, e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", se(), _r(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        return W = "useInsertionEffect", se(), xn(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", se(), xn(4, Ou, e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", se();
        var a = I.H;
        I.H = Ki;
        try {
          return nn(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", se();
        var i = I.H;
        I.H = Ki;
        try {
          return dc(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function() {
        return W = "useRef", se(), Nt().memoizedState;
      },
      useState: function() {
        W = "useState", se();
        var e = I.H;
        I.H = Ki;
        try {
          return dc(sl);
        } finally {
          I.H = e;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", se();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", se(), Gu(e, t);
      },
      useTransition: function() {
        return W = "useTransition", se(), G0();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", se(), mc(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", se(), Nt().memoizedState;
      },
      useFormState: function(e) {
        return W = "useFormState", se(), of(), vo(e);
      },
      useActionState: function(e) {
        return W = "useActionState", se(), vo(e);
      },
      useOptimistic: function(e, t) {
        return W = "useOptimistic", se(), hf(e, t);
      },
      useHostTransitionStatus: Hi,
      useMemoCache: rl,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", se(), Nt().memoizedState;
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", se(), zr(e);
      }
    }, oT = {
      readContext: function(e) {
        return Ct(e);
      },
      use: wi,
      useCallback: function(e, t) {
        return W = "useCallback", se(), su(e, t);
      },
      useContext: function(e) {
        return W = "useContext", se(), Ct(e);
      },
      useEffect: function(e, t) {
        W = "useEffect", se(), xn(2048, Ol, e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", se(), _r(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        return W = "useInsertionEffect", se(), xn(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", se(), xn(4, Ou, e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", se();
        var a = I.H;
        I.H = h1;
        try {
          return nn(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", se();
        var i = I.H;
        I.H = h1;
        try {
          return hc(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function() {
        return W = "useRef", se(), Nt().memoizedState;
      },
      useState: function() {
        W = "useState", se();
        var e = I.H;
        I.H = h1;
        try {
          return hc(sl);
        } finally {
          I.H = e;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", se();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", se(), Pe(e, t);
      },
      useTransition: function() {
        return W = "useTransition", se(), rn();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", se(), mc(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", se(), Nt().memoizedState;
      },
      useFormState: function(e) {
        return W = "useFormState", se(), of(), bo(e);
      },
      useActionState: function(e) {
        return W = "useActionState", se(), bo(e);
      },
      useOptimistic: function(e, t) {
        return W = "useOptimistic", se(), mf(e, t);
      },
      useHostTransitionStatus: Hi,
      useMemoCache: rl,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", se(), Nt().memoizedState;
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", se(), zr(e);
      }
    }, qo = {
      readContext: function(e) {
        return O(), Ct(e);
      },
      use: function(e) {
        return E(), wi(e);
      },
      useCallback: function(e, t) {
        return W = "useCallback", E(), Je(), dh(e, t);
      },
      useContext: function(e) {
        return W = "useContext", E(), Je(), Ct(e);
      },
      useEffect: function(e, t) {
        return W = "useEffect", E(), Je(), yc(e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", E(), Je(), Yu(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        W = "useInsertionEffect", E(), Je(), So(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", E(), Je(), Ra(e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", E(), Je();
        var a = I.H;
        I.H = qo;
        try {
          return Ca(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", E(), Je();
        var i = I.H;
        I.H = qo;
        try {
          return Dr(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function(e) {
        return W = "useRef", E(), Je(), fh(e);
      },
      useState: function(e) {
        W = "useState", E(), Je();
        var t = I.H;
        I.H = qo;
        try {
          return yo(e);
        } finally {
          I.H = t;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", E(), Je();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", E(), Je(), Ur(e, t);
      },
      useTransition: function() {
        return W = "useTransition", E(), Je(), Eo();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", E(), Je(), Rr(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", E(), Je(), vf();
      },
      useFormState: function(e, t) {
        return W = "useFormState", E(), Je(), fl(e, t);
      },
      useActionState: function(e, t) {
        return W = "useActionState", E(), Je(), fl(e, t);
      },
      useOptimistic: function(e) {
        return W = "useOptimistic", E(), Je(), pc(e);
      },
      useMemoCache: function(e) {
        return E(), rl(e);
      },
      useHostTransitionStatus: Hi,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", Je(), hh();
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", E(), Je(), yf(e);
      }
    }, Ki = {
      readContext: function(e) {
        return O(), Ct(e);
      },
      use: function(e) {
        return E(), wi(e);
      },
      useCallback: function(e, t) {
        return W = "useCallback", E(), se(), su(e, t);
      },
      useContext: function(e) {
        return W = "useContext", E(), se(), Ct(e);
      },
      useEffect: function(e, t) {
        W = "useEffect", E(), se(), xn(2048, Ol, e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", E(), se(), _r(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        return W = "useInsertionEffect", E(), se(), xn(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", E(), se(), xn(4, Ou, e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", E(), se();
        var a = I.H;
        I.H = Ki;
        try {
          return nn(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", E(), se();
        var i = I.H;
        I.H = Ki;
        try {
          return dc(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function() {
        return W = "useRef", E(), se(), Nt().memoizedState;
      },
      useState: function() {
        W = "useState", E(), se();
        var e = I.H;
        I.H = Ki;
        try {
          return dc(sl);
        } finally {
          I.H = e;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", E(), se();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", E(), se(), Gu(e, t);
      },
      useTransition: function() {
        return W = "useTransition", E(), se(), G0();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", E(), se(), mc(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", E(), se(), Nt().memoizedState;
      },
      useFormState: function(e) {
        return W = "useFormState", E(), se(), vo(e);
      },
      useActionState: function(e) {
        return W = "useActionState", E(), se(), vo(e);
      },
      useOptimistic: function(e, t) {
        return W = "useOptimistic", E(), se(), hf(e, t);
      },
      useMemoCache: function(e) {
        return E(), rl(e);
      },
      useHostTransitionStatus: Hi,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", se(), Nt().memoizedState;
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", E(), se(), zr(e);
      }
    }, h1 = {
      readContext: function(e) {
        return O(), Ct(e);
      },
      use: function(e) {
        return E(), wi(e);
      },
      useCallback: function(e, t) {
        return W = "useCallback", E(), se(), su(e, t);
      },
      useContext: function(e) {
        return W = "useContext", E(), se(), Ct(e);
      },
      useEffect: function(e, t) {
        W = "useEffect", E(), se(), xn(2048, Ol, e, t);
      },
      useImperativeHandle: function(e, t, a) {
        return W = "useImperativeHandle", E(), se(), _r(e, t, a);
      },
      useInsertionEffect: function(e, t) {
        return W = "useInsertionEffect", E(), se(), xn(4, Al, e, t);
      },
      useLayoutEffect: function(e, t) {
        return W = "useLayoutEffect", E(), se(), xn(4, Ou, e, t);
      },
      useMemo: function(e, t) {
        W = "useMemo", E(), se();
        var a = I.H;
        I.H = Ki;
        try {
          return nn(e, t);
        } finally {
          I.H = a;
        }
      },
      useReducer: function(e, t, a) {
        W = "useReducer", E(), se();
        var i = I.H;
        I.H = Ki;
        try {
          return hc(e, t, a);
        } finally {
          I.H = i;
        }
      },
      useRef: function() {
        return W = "useRef", E(), se(), Nt().memoizedState;
      },
      useState: function() {
        W = "useState", E(), se();
        var e = I.H;
        I.H = Ki;
        try {
          return hc(sl);
        } finally {
          I.H = e;
        }
      },
      useDebugValue: function() {
        W = "useDebugValue", E(), se();
      },
      useDeferredValue: function(e, t) {
        return W = "useDeferredValue", E(), se(), Pe(e, t);
      },
      useTransition: function() {
        return W = "useTransition", E(), se(), rn();
      },
      useSyncExternalStore: function(e, t, a) {
        return W = "useSyncExternalStore", E(), se(), mc(
          e,
          t,
          a
        );
      },
      useId: function() {
        return W = "useId", E(), se(), Nt().memoizedState;
      },
      useFormState: function(e) {
        return W = "useFormState", E(), se(), bo(e);
      },
      useActionState: function(e) {
        return W = "useActionState", E(), se(), bo(e);
      },
      useOptimistic: function(e, t) {
        return W = "useOptimistic", E(), se(), mf(e, t);
      },
      useMemoCache: function(e) {
        return E(), rl(e);
      },
      useHostTransitionStatus: Hi,
      useCacheRefresh: function() {
        return W = "useCacheRefresh", se(), Nt().memoizedState;
      },
      useEffectEvent: function(e) {
        return W = "useEffectEvent", E(), se(), zr(e);
      }
    };
    var cT = {}, rT = /* @__PURE__ */ new Set(), sT = /* @__PURE__ */ new Set(), fT = /* @__PURE__ */ new Set(), dT = /* @__PURE__ */ new Set(), hT = /* @__PURE__ */ new Set(), mT = /* @__PURE__ */ new Set(), pT = /* @__PURE__ */ new Set(), yT = /* @__PURE__ */ new Set(), gT = /* @__PURE__ */ new Set(), vT = /* @__PURE__ */ new Set();
    Object.freeze(cT);
    var SS = {
      enqueueSetState: function(e, t, a) {
        e = e._reactInternals;
        var i = fa(e), c = Nn(i);
        c.payload = t, a != null && (Sc(a), c.callback = a), t = Bu(e, c, i), t !== null && (xu(i, "this.setState()", e), Ze(t, e, i), Bl(t, e, i));
      },
      enqueueReplaceState: function(e, t, a) {
        e = e._reactInternals;
        var i = fa(e), c = Nn(i);
        c.tag = eT, c.payload = t, a != null && (Sc(a), c.callback = a), t = Bu(e, c, i), t !== null && (xu(i, "this.replaceState()", e), Ze(t, e, i), Bl(t, e, i));
      },
      enqueueForceUpdate: function(e, t) {
        e = e._reactInternals;
        var a = fa(e), i = Nn(a);
        i.tag = tT, t != null && (Sc(t), i.callback = t), t = Bu(e, i, a), t !== null && (xu(a, "this.forceUpdate()", e), Ze(t, e, a), Bl(t, e, a));
      }
    }, Vm = null, ES = null, TS = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), In = !1, bT = {}, ST = {}, ET = {}, TT = {}, Ym = !1, AT = {}, m1 = {}, AS = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, OT = !1, DT = null;
    DT = /* @__PURE__ */ new Set();
    var $c = !1, Pn = !1, OS = !1, RT = typeof WeakSet == "function" ? WeakSet : Set, pa = null, Gm = null, Xm = null, ea = null, Xl = !1, ki = null, oa = !1, Bg = 8192, MR = {
      getCacheForType: function(e) {
        var t = Ct($n), a = t.data.get(e);
        return a === void 0 && (a = e(), t.data.set(e, a)), a;
      },
      cacheSignal: function() {
        return Ct($n).controller.signal;
      },
      getOwner: function() {
        return ka;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var jg = Symbol.for;
      jg("selector.component"), jg("selector.has_pseudo_class"), jg("selector.role"), jg("selector.test_id"), jg("selector.text");
    }
    var NR = [], xR = typeof WeakMap == "function" ? WeakMap : Map, ya = 0, ca = 2, Du = 4, Fc = 0, qg = 1, yd = 2, p1 = 3, Os = 4, y1 = 6, CT = 5, Tt = ya, Ft = null, st = null, ct = 0, Ql = 0, g1 = 1, gd = 2, Vg = 3, zT = 4, DS = 5, Yg = 6, v1 = 7, RS = 8, vd = 9, Qt = Ql, Ru = null, Ds = !1, Qm = !1, CS = !1, Vo = 0, gn = Fc, Rs = 0, Cs = 0, zS = 0, Zl = 0, bd = 0, Gg = null, Dl = null, b1 = !1, S1 = 0, _T = 0, UT = 300, E1 = 1 / 0, wT = 500, Xg = null, Un = null, zs = null, T1 = 0, _S = 1, US = 2, MT = 3, _s = 0, NT = 1, xT = 2, HT = 3, LT = 4, A1 = 5, ta = 0, Us = null, Zm = null, $i = 0, wS = 0, MS = -0, NS = null, BT = null, jT = null, Fi = T1, qT = null, HR = 50, Qg = 0, xS = null, HS = !1, O1 = !1, LR = 50, Sd = 0, Zg = null, Jm = !1, D1 = null, VT = !1, YT = /* @__PURE__ */ new Set(), BR = {}, R1 = null, Km = null, LS = !1, BS = !1, C1 = !1, jS = !1, ws = 0, qS = {};
    (function() {
      for (var e = 0; e < Fb.length; e++) {
        var t = Fb[e], a = t.toLowerCase();
        t = t[0].toUpperCase() + t.slice(1), eu(a, "on" + t);
      }
      eu(g2, "onAnimationEnd"), eu(v2, "onAnimationIteration"), eu(b2, "onAnimationStart"), eu("dblclick", "onDoubleClick"), eu("focusin", "onFocus"), eu("focusout", "onBlur"), eu(dR, "onTransitionRun"), eu(hR, "onTransitionStart"), eu(mR, "onTransitionCancel"), eu(S2, "onTransitionEnd");
    })(), ur("onMouseEnter", ["mouseout", "mouseover"]), ur("onMouseLeave", ["mouseout", "mouseover"]), ur("onPointerEnter", ["pointerout", "pointerover"]), ur("onPointerLeave", ["pointerout", "pointerover"]), Wl(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), Wl(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), Wl("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), Wl(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), Wl(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), Wl(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var Jg = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), VS = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Jg)
    ), z1 = "_reactListening" + Math.random().toString(36).slice(2), GT = !1, XT = !1, _1 = !1, QT = !1, U1 = !1, w1 = !1, ZT = !1, M1 = {}, jR = /\r\n?/g, qR = /\u0000|\uFFFD/g, Ed = "http://www.w3.org/1999/xlink", YS = "http://www.w3.org/XML/1998/namespace", VR = "javascript:throw new Error('React form unexpectedly submitted.')", YR = "suppressHydrationWarning", Td = "&", N1 = "/&", Kg = "$", kg = "/$", Ms = "$?", Ad = "$~", km = "$!", GR = "html", XR = "body", QR = "head", GS = "F!", JT = "F", KT = "loading", ZR = "style", Wc = 0, $m = 1, x1 = 2, XS = null, QS = null, kT = { dialog: !0, webview: !0 }, ZS = null, $g = void 0, $T = typeof setTimeout == "function" ? setTimeout : void 0, JR = typeof clearTimeout == "function" ? clearTimeout : void 0, Od = -1, FT = typeof Promise == "function" ? Promise : void 0, KR = typeof queueMicrotask == "function" ? queueMicrotask : typeof FT < "u" ? function(e) {
      return FT.resolve(null).then(e).catch(sv);
    } : $T, JS = null, Dd = 0, Fg = 1, WT = 2, IT = 3, pi = 4, yi = /* @__PURE__ */ new Map(), PT = /* @__PURE__ */ new Set(), Ic = _t.d;
    _t.d = {
      f: function() {
        var e = Ic.f(), t = yl();
        return e || t;
      },
      r: function(e) {
        var t = Fl(e);
        t !== null && t.tag === 5 && t.type === "form" ? wr(t) : Ic.r(e);
      },
      D: function(e) {
        Ic.D(e), By("dns-prefetch", e, null);
      },
      C: function(e, t) {
        Ic.C(e, t), By("preconnect", e, t);
      },
      L: function(e, t, a) {
        Ic.L(e, t, a);
        var i = Fm;
        if (i && e && t) {
          var c = 'link[rel="preload"][as="' + qt(t) + '"]';
          t === "image" && a && a.imageSrcSet ? (c += '[imagesrcset="' + qt(
            a.imageSrcSet
          ) + '"]', typeof a.imageSizes == "string" && (c += '[imagesizes="' + qt(
            a.imageSizes
          ) + '"]')) : c += '[href="' + qt(e) + '"]';
          var s = c;
          switch (t) {
            case "style":
              s = Uc(e);
              break;
            case "script":
              s = wc(e);
          }
          yi.has(s) || (e = ut(
            {
              rel: "preload",
              href: t === "image" && a && a.imageSrcSet ? void 0 : e,
              as: t
            },
            a
          ), yi.set(s, e), i.querySelector(c) !== null || t === "style" && i.querySelector(
            Qf(s)
          ) || t === "script" && i.querySelector(Zf(s)) || (t = i.createElement("link"), an(t, "link", e), vn(t), i.head.appendChild(t)));
        }
      },
      m: function(e, t) {
        Ic.m(e, t);
        var a = Fm;
        if (a && e) {
          var i = t && typeof t.as == "string" ? t.as : "script", c = 'link[rel="modulepreload"][as="' + qt(i) + '"][href="' + qt(e) + '"]', s = c;
          switch (i) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              s = wc(e);
          }
          if (!yi.has(s) && (e = ut({ rel: "modulepreload", href: e }, t), yi.set(s, e), a.querySelector(c) === null)) {
            switch (i) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (a.querySelector(Zf(s)))
                  return;
            }
            i = a.createElement("link"), an(i, "link", e), vn(i), a.head.appendChild(i);
          }
        }
      },
      X: function(e, t) {
        Ic.X(e, t);
        var a = Fm;
        if (a && e) {
          var i = _l(a).hoistableScripts, c = wc(e), s = i.get(c);
          s || (s = a.querySelector(
            Zf(c)
          ), s || (e = ut({ src: e, async: !0 }, t), (t = yi.get(c)) && Vy(e, t), s = a.createElement("script"), vn(s), an(s, "link", e), a.head.appendChild(s)), s = {
            type: "script",
            instance: s,
            count: 1,
            state: null
          }, i.set(c, s));
        }
      },
      S: function(e, t, a) {
        Ic.S(e, t, a);
        var i = Fm;
        if (i && e) {
          var c = _l(i).hoistableStyles, s = Uc(e);
          t = t || "default";
          var y = c.get(s);
          if (!y) {
            var b = { loading: Dd, preload: null };
            if (y = i.querySelector(
              Qf(s)
            ))
              b.loading = Fg | pi;
            else {
              e = ut(
                {
                  rel: "stylesheet",
                  href: e,
                  "data-precedence": t
                },
                a
              ), (a = yi.get(s)) && qy(e, a);
              var A = y = i.createElement("link");
              vn(A), an(A, "link", e), A._p = new Promise(function(D, j) {
                A.onload = D, A.onerror = j;
              }), A.addEventListener("load", function() {
                b.loading |= Fg;
              }), A.addEventListener("error", function() {
                b.loading |= WT;
              }), b.loading |= pi, Ir(y, t, i);
            }
            y = {
              type: "stylesheet",
              instance: y,
              count: 1,
              state: b
            }, c.set(s, y);
          }
        }
      },
      M: function(e, t) {
        Ic.M(e, t);
        var a = Fm;
        if (a && e) {
          var i = _l(a).hoistableScripts, c = wc(e), s = i.get(c);
          s || (s = a.querySelector(
            Zf(c)
          ), s || (e = ut({ src: e, async: !0, type: "module" }, t), (t = yi.get(c)) && Vy(e, t), s = a.createElement("script"), vn(s), an(s, "link", e), a.head.appendChild(s)), s = {
            type: "script",
            instance: s,
            count: 1,
            state: null
          }, i.set(c, s));
        }
      }
    };
    var Fm = typeof document > "u" ? null : document, H1 = null, kR = 6e4, $R = 800, FR = 500, KS = 0, kS = null, L1 = null, Rd = jb, Wg = {
      $$typeof: bu,
      Provider: null,
      Consumer: null,
      _currentValue: Rd,
      _currentValue2: Rd,
      _threadCount: 0
    }, eA = "%c%s%c", tA = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", nA = "", B1 = " ", WR = Function.prototype.bind, aA = !1, lA = null, uA = null, iA = null, oA = null, cA = null, rA = null, sA = null, fA = null, dA = null, hA = null;
    lA = function(e, t, a, i) {
      t = r(e, t), t !== null && (a = f(t.memoizedState, a, 0, i), t.memoizedState = a, t.baseState = a, e.memoizedProps = ut({}, e.memoizedProps), a = ra(e, 2), a !== null && Ze(a, e, 2));
    }, uA = function(e, t, a) {
      t = r(e, t), t !== null && (a = v(t.memoizedState, a, 0), t.memoizedState = a, t.baseState = a, e.memoizedProps = ut({}, e.memoizedProps), a = ra(e, 2), a !== null && Ze(a, e, 2));
    }, iA = function(e, t, a, i) {
      t = r(e, t), t !== null && (a = m(t.memoizedState, a, i), t.memoizedState = a, t.baseState = a, e.memoizedProps = ut({}, e.memoizedProps), a = ra(e, 2), a !== null && Ze(a, e, 2));
    }, oA = function(e, t, a) {
      e.pendingProps = f(e.memoizedProps, t, 0, a), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = ra(e, 2), t !== null && Ze(t, e, 2);
    }, cA = function(e, t) {
      e.pendingProps = v(e.memoizedProps, t, 0), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = ra(e, 2), t !== null && Ze(t, e, 2);
    }, rA = function(e, t, a) {
      e.pendingProps = m(
        e.memoizedProps,
        t,
        a
      ), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = ra(e, 2), t !== null && Ze(t, e, 2);
    }, sA = function(e) {
      var t = ra(e, 2);
      t !== null && Ze(t, e, 2);
    }, fA = function(e) {
      var t = et(), a = ra(e, t);
      a !== null && Ze(a, e, t);
    }, dA = function(e) {
      S = e;
    }, hA = function(e) {
      g = e;
    };
    var j1 = !0, q1 = null, $S = !1, Ns = null, xs = null, Hs = null, Ig = /* @__PURE__ */ new Map(), Pg = /* @__PURE__ */ new Map(), Ls = [], IR = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), V1 = null;
    if (vu.prototype.render = Fy.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null) throw Error("Cannot update an unmounted root.");
      var a = arguments;
      typeof a[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : Y(a[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof a[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), a = e;
      var i = t.current, c = fa(i);
      am(i, c, a, t, null, null);
    }, vu.prototype.unmount = Fy.prototype.unmount = function() {
      var e = arguments;
      if (typeof e[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), e = this._internalRoot, e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        (Tt & (ca | Du)) !== ya && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), am(e.current, 2, null, e, null, null), yl(), t[Qi] = null;
      }
    }, vu.prototype.unstable_scheduleHydration = function(e) {
      if (e) {
        var t = v0();
        e = { blockedOn: null, target: e, priority: t };
        for (var a = 0; a < Ls.length && t !== 0 && t < Ls[a].priority; a++) ;
        Ls.splice(a, 0, e), a === 0 && $y(e);
      }
    }, (function() {
      var e = Ff.version;
      if (e !== "19.2.4")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (e + `
  - react-dom:  19.2.4
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    })(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), _t.findDOMNode = function(e) {
      var t = e._reactInternals;
      if (t === void 0)
        throw typeof e.render == "function" ? Error("Unable to find node on an unmounted component.") : (e = Object.keys(e).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + e
        ));
      return e = he(t), e = e !== null ? Te(e) : null, e = e === null ? null : e.stateNode, e;
    }, !(function() {
      var e = {
        bundleType: 1,
        version: "19.2.4",
        rendererPackageName: "react-dom",
        currentDispatcherRef: I,
        reconcilerVersion: "19.2.4"
      };
      return e.overrideHookState = lA, e.overrideHookStateDeletePath = uA, e.overrideHookStateRenamePath = iA, e.overrideProps = oA, e.overridePropsDeletePath = cA, e.overridePropsRenamePath = rA, e.scheduleUpdate = sA, e.scheduleRetry = fA, e.setErrorHandler = dA, e.setSuspenseHandler = hA, e.scheduleRefresh = N, e.scheduleRoot = Q, e.setRefreshHandler = G, e.getCurrentFiber = Gt, Zt(e);
    })() && Lo && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var mA = window.location.protocol;
      /^(https?|file):$/.test(mA) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + (mA === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : ""),
        "font-weight:bold"
      );
    }
    o0.createRoot = function(e, t) {
      if (!Y(e))
        throw Error("Target container is not a DOM element.");
      Wy(e);
      var a = !1, i = "", c = yh, s = gh, y = Zp;
      return t != null && (t.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : typeof t == "object" && t !== null && t.$$typeof === Yl && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (i = t.identifierPrefix), t.onUncaughtError !== void 0 && (c = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (y = t.onRecoverableError)), t = kf(
        e,
        1,
        !1,
        null,
        null,
        a,
        i,
        null,
        c,
        s,
        y,
        xv
      ), e[Qi] = t.current, zo(e), new Fy(t);
    }, o0.hydrateRoot = function(e, t, a) {
      if (!Y(e))
        throw Error("Target container is not a DOM element.");
      Wy(e), t === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var i = !1, c = "", s = yh, y = gh, b = Zp, A = null;
      return a != null && (a.unstable_strictMode === !0 && (i = !0), a.identifierPrefix !== void 0 && (c = a.identifierPrefix), a.onUncaughtError !== void 0 && (s = a.onUncaughtError), a.onCaughtError !== void 0 && (y = a.onCaughtError), a.onRecoverableError !== void 0 && (b = a.onRecoverableError), a.formState !== void 0 && (A = a.formState)), t = kf(
        e,
        1,
        !0,
        t,
        a ?? null,
        i,
        c,
        A,
        s,
        y,
        b,
        xv
      ), t.context = Uv(null), a = t.current, i = fa(a), i = Qo(i), c = Nn(i), c.callback = null, Bu(a, c, i), xu(i, "hydrateRoot()", null), a = i, t.current.lanes = a, Wt(t, a), Qa(t), e[Qi] = t.current, zo(e), new vu(t);
    }, o0.version = "19.2.4", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), o0;
}
var _O;
function xz() {
  if (_O) return nb.exports;
  _O = 1;
  function r() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
      } catch (f) {
        console.error(f);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (r(), nb.exports = Mz()) : nb.exports = Nz(), nb.exports;
}
var Hz = xz();
function V5(r, f = "root") {
  function m() {
    let h = window.document.getElementById(f);
    h || (h = window.document.createElement("div"), h.id = f, window.document.body.append(h)), Hz.createRoot(h).render(
      /* @__PURE__ */ YE.jsx(ar.StrictMode, { children: /* @__PURE__ */ YE.jsx(r, {}) })
    );
  }
  ["complete", "interactive"].includes(document.readyState) ? m() : window.addEventListener("DOMContentLoaded", m);
}
const Y5 = () => {
};
function G5(r, f) {
  const m = { ...r };
  for (const h of f)
    delete m[h];
  return m;
}
const X5 = "pageHostingOverride";
function Q5(r, f = !1) {
  if (!r)
    throw new Error("URL is required to redirect.");
  f ? window.open(r, "_blank", "noopener,noreferrer") : window.location.href = r;
}
function Lz(r, f, m) {
  if (f.length === 0)
    return r;
  const [h, ...v] = f;
  return {
    ...r,
    [h]: v.length === 0 ? m : Lz(
      r[h] || {},
      v,
      m
    )
  };
}
function Z5(r) {
  let f = document.querySelector(
    "head style[data-document-style]"
  );
  f || (f = document.createElement("style"), f.setAttribute("type", "text/css"), f.dataset.documentStyle = "true", document.head.append(f)), f.textContent = r;
}
/*! js-cookie v3.0.5 | MIT */
function lb(r) {
  for (var f = 1; f < arguments.length; f++) {
    var m = arguments[f];
    for (var h in m)
      r[h] = m[h];
  }
  return r;
}
var Bz = {
  read: function(r) {
    return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(r) {
    return encodeURIComponent(r).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function QE(r, f) {
  function m(v, g, S) {
    if (!(typeof document > "u")) {
      S = lb({}, f, S), typeof S.expires == "number" && (S.expires = new Date(Date.now() + S.expires * 864e5)), S.expires && (S.expires = S.expires.toUTCString()), v = encodeURIComponent(v).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var E = "";
      for (var O in S)
        S[O] && (E += "; " + O, S[O] !== !0 && (E += "=" + S[O].split(";")[0]));
      return document.cookie = v + "=" + r.write(g, v) + E;
    }
  }
  function h(v) {
    if (!(typeof document > "u" || arguments.length && !v)) {
      for (var g = document.cookie ? document.cookie.split("; ") : [], S = {}, E = 0; E < g.length; E++) {
        var O = g[E].split("="), R = O.slice(1).join("=");
        try {
          var _ = decodeURIComponent(O[0]);
          if (S[_] = r.read(R, _), v === _)
            break;
        } catch {
        }
      }
      return v ? S[v] : S;
    }
  }
  return Object.create(
    {
      set: m,
      get: h,
      remove: function(v, g) {
        m(
          v,
          "",
          lb({}, g, {
            expires: -1
          })
        );
      },
      withAttributes: function(v) {
        return QE(this.converter, lb({}, this.attributes, v));
      },
      withConverter: function(v) {
        return QE(lb({}, this.converter, v), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(f) },
      converter: { value: Object.freeze(r) }
    }
  );
}
var ub = QE(Bz, { path: "/" });
function J5(r, f = "") {
  const [m, h] = Rl(() => {
    const S = ub.get(r);
    return S === void 0 ? f : S;
  }), v = (S, E) => {
    h(S), ub.set(r, S, E);
  }, g = (S) => {
    h(f), ub.remove(r, S);
  };
  return Cl(() => {
    const S = ub.get(r);
    S !== m && h(S || f);
  }, [r, f, m]), { cookie: m, setCookie: v, removeCookie: g };
}
function K5(r, f = 500) {
  const [m, h] = Rl(r), v = bi(null);
  return Cl(() => (v.current && clearTimeout(v.current), v.current = setTimeout(() => {
    h(r);
  }, f), () => {
    v.current && clearTimeout(v.current);
  }), [r, f]), m;
}
function k5({
  isActiveDealer: r = !0,
  user: f,
  allowLimitedSalespersonAccess: m = !1
}) {
  Cl(() => {
    (!r && f && f.isProxied !== !0 || f?.userRole && !m && D3(f.userRole)) && gb("unauthorizedPage");
  }, [m, r, f, f?.userRole]);
}
function $5(r) {
  const [f, m] = Rl(() => {
    const v = new URLSearchParams(window.location.search ?? ""), g = { ...r };
    for (const S of Object.keys(r)) {
      const E = v.get(S.toString());
      if (E)
        if (Array.isArray(r[S]))
          g[S] = E.split(",").map((O) => O.trim());
        else if (typeof r[S] == "object")
          try {
            g[S] = JSON.parse(E);
          } catch (O) {
            console.warn(
              `Failed to parse URL parameter ${S.toString()} as JSON`,
              O
            );
          }
        else
          g[S] = E;
    }
    return g;
  });
  return [f, (v) => {
    let g;
    try {
      g = new URL(window.location.href, window.location.origin);
    } catch (S) {
      console.warn(
        "Failed to parse URL from href %s and origin %s",
        window.location.href,
        window.location.origin,
        S
      );
      return;
    }
    for (const [S, E] of Object.entries(v))
      if (Array.isArray(E))
        E.length > 0 ? g.searchParams.set(S, E.join(",")) : g.searchParams.delete(S);
      else if (typeof E == "object")
        try {
          g.searchParams.set(S, JSON.stringify(E));
        } catch (O) {
          console.warn(
            `Failed to stringify URL parameter ${S} as JSON`,
            O
          );
        }
      else
        E ? g.searchParams.set(S, E) : g.searchParams.delete(S);
    window.history.replaceState({}, "", g.toString()), m(v);
  }];
}
function F5(r) {
  try {
    WalkMeAPI.startShoutOutById(r);
  } catch (f) {
    console.error(f);
  }
}
const wD = "4a6edbc10b584b078f4b87978759846e", UO = `https://cdn.walkme.com/users/${wD}/`, wO = `walkme_${wD}_https.js`, MO = {
  TEST_ENV: `${UO}test/${wO}`,
  PRODUCTION: `${UO}${wO}`
};
function W5(r = {}) {
  const { user: f } = r, [m, h] = Rl(!1);
  Cl(() => {
    if (!f) {
      h(!1);
      return;
    }
    window.userName = f.userName.toLowerCase(), window.dealerId = f.dealerId, window.roleName = f.userRole, window.dealerType = f.dealerInfo?.dealerType, window.dealerState = f.dealerInfo?.dealerState, window._walkmeConfig = { smartLoad: !0 }, h(!0);
  }, [f]);
  const { loaded: v, error: g } = _D(
    window.environment === "production" ? MO.PRODUCTION : MO.TEST_ENV,
    {
      appendTo: "head",
      enabled: m
    }
  );
  return { loaded: v, error: g };
}
export {
  Y1 as ADOBE_ANALYTICS_SCRIPT_URLS,
  x5 as FULLSTORY_EXCLUDE_DATA_CLASSNAME,
  q5 as HTTP_STATUS_CODE,
  a5 as LAUNCH_DARKLY_CAPS_BACKEND_FLAG_KEYS,
  R3 as LAUNCH_DARKLY_CLIENT_IDS_BY_PROJECT,
  n5 as LAUNCH_DARKLY_DVM_FLAG_KEYS,
  t5 as LAUNCH_DARKLY_FLAGS_CHECK,
  r0 as LAUNCH_DARKLY_FLAG_KEYS,
  yb as LaunchDarklyProject,
  X5 as OVERRIDE_COOKIE,
  B5 as PATH_SEGMENT_REGEX,
  R5 as SWRProvider,
  l3 as adobeEvent,
  CE as capsTestEnvironmentStorageKey,
  Q6 as carLotDescription,
  G6 as carLotsPath,
  _z as checkAuthentication,
  Yz as checkCapsTestEnvironment,
  M5 as createAdobeDataForPageLoad,
  A5 as createAxiosInstance,
  O5 as createConfig,
  Gz as debounce,
  ZE as environmentalizeCAPSURL,
  v3 as environmentalizeCustomerPortalUrl,
  b3 as environmentalizeDealMaxURL,
  g3 as environmentalizeLoginURL,
  S3 as environmentalizePageHostingUrl,
  Xz as formatCurrency,
  $z as formatNumberUS,
  c3 as getAdobeScriptUrl,
  j5 as getBasename,
  H6 as getDealerSpecificPath,
  s0 as getEnvironment,
  _3 as getLocations,
  Qz as getQueryParameter,
  Zz as getStateName,
  XO as getUrlFromFeatureFlag,
  gb as goTo,
  Jz as hasActiveCreditBureau,
  V5 as initializeOnDomReady,
  e5 as isCacUser,
  Kz as isDealerActive,
  kz as isDefined,
  JE as isEmpty,
  YO as isKnownLocation,
  D3 as isLimitedSalesperson,
  qO as isNullish,
  Vz as isProduction,
  D5 as makeRequest,
  Y5 as noOp,
  Iz as normalizeSpacingUpperCase,
  G5 as omitProperties,
  Fz as once,
  Wz as parseNumberInto3Parts,
  Q5 as redirectUser,
  VO as removeEmptyValues,
  GO as replaceUrlPlaceholders,
  N5 as sendCustomDynatraceErrorEvent,
  Lz as setNestedProperty,
  U5 as shouldNavigateToLegacyUi,
  F5 as startWalkMeShoutOutById,
  f0 as toAbsoluteUrl,
  Pz as toSentenceCase,
  Pm as toURL,
  Z5 as updateHeadStyle,
  w5 as useAdobeAnalytics,
  L5 as useAuthentication,
  J5 as useCookie,
  C5 as useDealer,
  K5 as useDebouncedValue,
  H5 as useFullstory,
  zD as useLaunchDarkly,
  z5 as useLaunchDarklyNavigation,
  _5 as useMultiContextCapsBackend,
  k5 as useRedirectUnauthorizedUser,
  $5 as useUrlParameters,
  TD as useUser,
  W5 as useWalkme,
  X6 as userDescription,
  Y6 as userPath,
  e_ as vitePreamble
};
//# sourceMappingURL=index.js.map
